var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key != "symbol" ? key + "" : key, value);
import * as React from "react";
import React__default, { createContext, useContext, useState, useCallback, useEffect, useMemo, useRef } from "react";
const _Subscribable = class _Subscribable {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(listener) {
    const identity2 = {
      listener
    };
    return this.listeners.add(identity2), this.onSubscribe(), () => {
      this.listeners.delete(identity2), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
};
__name(_Subscribable, "Subscribable");
let Subscribable = _Subscribable;
const isServer = typeof window > "u" || "Deno" in window;
function noop$2() {
}
__name(noop$2, "noop$2");
function isValidTimeout(value) {
  return typeof value == "number" && value >= 0 && value !== 1 / 0;
}
__name(isValidTimeout, "isValidTimeout");
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
__name(timeUntilStale, "timeUntilStale");
function parseQueryArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? {
    ...arg2,
    queryKey: arg1
  } : arg1;
}
__name(parseQueryArgs, "parseQueryArgs");
function parseMutationArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? {
    ...arg2,
    mutationKey: arg1
  } : typeof arg1 == "function" ? {
    ...arg2,
    mutationFn: arg1
  } : {
    ...arg1
  };
}
__name(parseMutationArgs, "parseMutationArgs");
function replaceEqualDeep(a2, b2) {
  if (a2 === b2)
    return a2;
  const array = isPlainArray(a2) && isPlainArray(b2);
  if (array || isPlainObject$2(a2) && isPlainObject$2(b2)) {
    const aSize = array ? a2.length : Object.keys(a2).length, bItems = array ? b2 : Object.keys(b2), bSize = bItems.length, copy = array ? [] : {};
    let equalItems = 0;
    for (let i2 = 0; i2 < bSize; i2++) {
      const key = array ? i2 : bItems[i2];
      copy[key] = replaceEqualDeep(a2[key], b2[key]), copy[key] === a2[key] && equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a2 : copy;
  }
  return b2;
}
__name(replaceEqualDeep, "replaceEqualDeep");
function shallowEqualObjects(a2, b2) {
  if (a2 && !b2 || b2 && !a2)
    return !1;
  for (const key in a2)
    if (a2[key] !== b2[key])
      return !1;
  return !0;
}
__name(shallowEqualObjects, "shallowEqualObjects");
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
}
__name(isPlainArray, "isPlainArray");
function isPlainObject$2(o2) {
  if (!hasObjectPrototype(o2))
    return !1;
  const ctor = o2.constructor;
  if (typeof ctor > "u")
    return !0;
  const prot = ctor.prototype;
  return !(!hasObjectPrototype(prot) || !prot.hasOwnProperty("isPrototypeOf"));
}
__name(isPlainObject$2, "isPlainObject$2");
function hasObjectPrototype(o2) {
  return Object.prototype.toString.call(o2) === "[object Object]";
}
__name(hasObjectPrototype, "hasObjectPrototype");
function isQueryKey(value) {
  return Array.isArray(value);
}
__name(isQueryKey, "isQueryKey");
function sleep(timeout) {
  return new Promise((resolve3) => {
    setTimeout(resolve3, timeout);
  });
}
__name(sleep, "sleep");
function scheduleMicrotask(callback) {
  sleep(0).then(callback);
}
__name(scheduleMicrotask, "scheduleMicrotask");
function replaceData(prevData, data, options) {
  return options.isDataEqual != null && options.isDataEqual(prevData, data) ? prevData : typeof options.structuralSharing == "function" ? options.structuralSharing(prevData, data) : options.structuralSharing !== !1 ? replaceEqualDeep(prevData, data) : data;
}
__name(replaceData, "replaceData");
const _FocusManager = class _FocusManager extends Subscribable {
  constructor() {
    super(), this.setup = (onFocus) => {
      if (!isServer && window.addEventListener) {
        const listener = /* @__PURE__ */ __name(() => onFocus(), "listener");
        return window.addEventListener("visibilitychange", listener, !1), window.addEventListener("focus", listener, !1), () => {
          window.removeEventListener("visibilitychange", listener), window.removeEventListener("focus", listener);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;
      (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(setup2) {
    var _this$cleanup2;
    this.setup = setup2, (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this), this.cleanup = setup2((focused) => {
      typeof focused == "boolean" ? this.setFocused(focused) : this.onFocus();
    });
  }
  setFocused(focused) {
    this.focused !== focused && (this.focused = focused, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
};
__name(_FocusManager, "FocusManager");
let FocusManager = _FocusManager;
const focusManager = new FocusManager(), onlineEvents = ["online", "offline"], _OnlineManager = class _OnlineManager extends Subscribable {
  constructor() {
    super(), this.setup = (onOnline) => {
      if (!isServer && window.addEventListener) {
        const listener = /* @__PURE__ */ __name(() => onOnline(), "listener");
        return onlineEvents.forEach((event) => {
          window.addEventListener(event, listener, !1);
        }), () => {
          onlineEvents.forEach((event) => {
            window.removeEventListener(event, listener);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;
      (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(setup2) {
    var _this$cleanup2;
    this.setup = setup2, (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this), this.cleanup = setup2((online) => {
      typeof online == "boolean" ? this.setOnline(online) : this.onOnline();
    });
  }
  setOnline(online) {
    this.online !== online && (this.online = online, this.onOnline());
  }
  onOnline() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
};
__name(_OnlineManager, "OnlineManager");
let OnlineManager = _OnlineManager;
const onlineManager = new OnlineManager();
function canFetch(networkMode) {
  return (networkMode ?? "online") === "online" ? onlineManager.isOnline() : !0;
}
__name(canFetch, "canFetch");
const _CancelledError = class _CancelledError {
  constructor(options) {
    this.revert = options == null ? void 0 : options.revert, this.silent = options == null ? void 0 : options.silent;
  }
};
__name(_CancelledError, "CancelledError");
let CancelledError = _CancelledError;
function isCancelledError(value) {
  return value instanceof CancelledError;
}
__name(isCancelledError, "isCancelledError");
function createNotifyManager() {
  let queue = [], transactions = 0, notifyFn = /* @__PURE__ */ __name((callback) => {
    callback();
  }, "notifyFn"), batchNotifyFn = /* @__PURE__ */ __name((callback) => {
    callback();
  }, "batchNotifyFn");
  const batch = /* @__PURE__ */ __name((callback) => {
    let result2;
    transactions++;
    try {
      result2 = callback();
    } finally {
      transactions--, transactions || flush();
    }
    return result2;
  }, "batch"), schedule = /* @__PURE__ */ __name((callback) => {
    transactions ? queue.push(callback) : scheduleMicrotask(() => {
      notifyFn(callback);
    });
  }, "schedule"), batchCalls = /* @__PURE__ */ __name((callback) => (...args) => {
    schedule(() => {
      callback(...args);
    });
  }, "batchCalls"), flush = /* @__PURE__ */ __name(() => {
    const originalQueue = queue;
    queue = [], originalQueue.length && scheduleMicrotask(() => {
      batchNotifyFn(() => {
        originalQueue.forEach((callback) => {
          notifyFn(callback);
        });
      });
    });
  }, "flush");
  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction: /* @__PURE__ */ __name((fn) => {
      notifyFn = fn;
    }, "setNotifyFunction"),
    setBatchNotifyFunction: /* @__PURE__ */ __name((fn) => {
      batchNotifyFn = fn;
    }, "setBatchNotifyFunction")
  };
}
__name(createNotifyManager, "createNotifyManager");
const notifyManager = createNotifyManager();
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
__name(getDefaultState, "getDefaultState");
const _QueryObserver = class _QueryObserver extends Subscribable {
  constructor(client, options) {
    super(), this.client = client, this.options = options, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(options);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), shouldFetchOnMount(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(options, notifyOptions) {
    const prevOptions = this.options, prevQuery = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(options), process.env.NODE_ENV !== "production" && typeof (options == null ? void 0 : options.isDataEqual) < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), shallowEqualObjects(prevOptions, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = prevOptions.queryKey), this.updateQuery();
    const mounted = this.hasListeners();
    mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions) && this.executeFetch(), this.updateResult(notifyOptions), mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime) && this.updateStaleTimeout();
    const nextRefetchInterval = this.computeRefetchInterval();
    mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval) && this.updateRefetchInterval(nextRefetchInterval);
  }
  getOptimisticResult(options) {
    const query = this.client.getQueryCache().build(this.client, options), result2 = this.createResult(query, options);
    return shouldAssignObserverCurrentProperties(this, result2, options) && (this.currentResult = result2, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), result2;
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(result2) {
    const trackedResult = {};
    return Object.keys(result2).forEach((key) => {
      Object.defineProperty(trackedResult, key, {
        configurable: !1,
        enumerable: !0,
        get: /* @__PURE__ */ __name(() => (this.trackedProps.add(key), result2[key]), "get")
      });
    }), trackedResult;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage,
    ...options
  } = {}) {
    return this.fetch({
      ...options,
      meta: {
        refetchPage
      }
    });
  }
  fetchOptimistic(options) {
    const defaultedOptions = this.client.defaultQueryOptions(options), query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.isFetchingOptimistic = !0, query.fetch().then(() => this.createResult(query, defaultedOptions));
  }
  fetch(fetchOptions) {
    var _fetchOptions$cancelR;
    return this.executeFetch({
      ...fetchOptions,
      cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(fetchOptions) {
    this.updateQuery();
    let promise = this.currentQuery.fetch(this.options, fetchOptions);
    return fetchOptions != null && fetchOptions.throwOnError || (promise = promise.catch(noop$2)), promise;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), isServer || this.currentResult.isStale || !isValidTimeout(this.options.staleTime))
      return;
    const timeout = timeUntilStale(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, timeout);
  }
  computeRefetchInterval() {
    var _this$options$refetch;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : !1;
  }
  updateRefetchInterval(nextInterval) {
    this.clearRefetchInterval(), this.currentRefetchInterval = nextInterval, !(isServer || this.options.enabled === !1 || !isValidTimeout(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || focusManager.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(query, options) {
    const prevQuery = this.currentQuery, prevOptions = this.options, prevResult = this.currentResult, prevResultState = this.currentResultState, prevResultOptions = this.currentResultOptions, queryChange = query !== prevQuery, queryInitialState = queryChange ? query.state : this.currentQueryInitialState, prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult, {
      state
    } = query;
    let {
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      fetchStatus,
      status
    } = state, isPreviousData = !1, isPlaceholderData = !1, data;
    if (options._optimisticResults) {
      const mounted = this.hasListeners(), fetchOnMount = !mounted && shouldFetchOnMount(query, options), fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
      (fetchOnMount || fetchOptionally) && (fetchStatus = canFetch(query.options.networkMode) ? "fetching" : "paused", dataUpdatedAt || (status = "loading")), options._optimisticResults === "isRestoring" && (fetchStatus = "idle");
    }
    if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error")
      data = prevQueryResult.data, dataUpdatedAt = prevQueryResult.dataUpdatedAt, status = prevQueryResult.status, isPreviousData = !0;
    else if (options.select && typeof state.data < "u")
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn)
        data = this.selectResult;
      else
        try {
          this.selectFn = options.select, data = options.select(state.data), data = replaceData(prevResult == null ? void 0 : prevResult.data, data, options), this.selectResult = data, this.selectError = null;
        } catch (selectError) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(selectError), this.selectError = selectError;
        }
    else
      data = state.data;
    if (typeof options.placeholderData < "u" && typeof data > "u" && status === "loading") {
      let placeholderData;
      if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData))
        placeholderData = prevResult.data;
      else if (placeholderData = typeof options.placeholderData == "function" ? options.placeholderData() : options.placeholderData, options.select && typeof placeholderData < "u")
        try {
          placeholderData = options.select(placeholderData), this.selectError = null;
        } catch (selectError) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(selectError), this.selectError = selectError;
        }
      typeof placeholderData < "u" && (status = "success", data = replaceData(prevResult == null ? void 0 : prevResult.data, placeholderData, options), isPlaceholderData = !0);
    }
    this.selectError && (error = this.selectError, data = this.selectResult, errorUpdatedAt = Date.now(), status = "error");
    const isFetching = fetchStatus === "fetching", isLoading = status === "loading", isError = status === "error";
    return {
      status,
      fetchStatus,
      isLoading,
      isSuccess: status === "success",
      isError,
      isInitialLoading: isLoading && isFetching,
      data,
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      failureReason: state.fetchFailureReason,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isLoading,
      isLoadingError: isError && state.dataUpdatedAt === 0,
      isPaused: fetchStatus === "paused",
      isPlaceholderData,
      isPreviousData,
      isRefetchError: isError && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(notifyOptions) {
    const prevResult = this.currentResult, nextResult = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, shallowEqualObjects(nextResult, prevResult))
      return;
    this.currentResult = nextResult;
    const defaultNotifyOptions = {
      cache: !0
    }, shouldNotifyListeners = /* @__PURE__ */ __name(() => {
      if (!prevResult)
        return !0;
      const {
        notifyOnChangeProps
      } = this.options, notifyOnChangePropsValue = typeof notifyOnChangeProps == "function" ? notifyOnChangeProps() : notifyOnChangeProps;
      if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size)
        return !0;
      const includedProps = new Set(notifyOnChangePropsValue ?? this.trackedProps);
      return this.options.useErrorBoundary && includedProps.add("error"), Object.keys(this.currentResult).some((key) => {
        const typedKey = key;
        return this.currentResult[typedKey] !== prevResult[typedKey] && includedProps.has(typedKey);
      });
    }, "shouldNotifyListeners");
    (notifyOptions == null ? void 0 : notifyOptions.listeners) !== !1 && shouldNotifyListeners() && (defaultNotifyOptions.listeners = !0), this.notify({
      ...defaultNotifyOptions,
      ...notifyOptions
    });
  }
  updateQuery() {
    const query = this.client.getQueryCache().build(this.client, this.options);
    if (query === this.currentQuery)
      return;
    const prevQuery = this.currentQuery;
    this.currentQuery = query, this.currentQueryInitialState = query.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (prevQuery == null || prevQuery.removeObserver(this), query.addObserver(this));
  }
  onQueryUpdate(action) {
    const notifyOptions = {};
    action.type === "success" ? notifyOptions.onSuccess = !action.manual : action.type === "error" && !isCancelledError(action.error) && (notifyOptions.onError = !0), this.updateResult(notifyOptions), this.hasListeners() && this.updateTimers();
  }
  notify(notifyOptions) {
    notifyManager.batch(() => {
      if (notifyOptions.onSuccess) {
        var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
        (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data), (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
      } else if (notifyOptions.onError) {
        var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
        (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error), (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, void 0, this.currentResult.error);
      }
      notifyOptions.listeners && this.listeners.forEach(({
        listener
      }) => {
        listener(this.currentResult);
      }), notifyOptions.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
};
__name(_QueryObserver, "QueryObserver");
let QueryObserver = _QueryObserver;
function shouldLoadOnMount(query, options) {
  return options.enabled !== !1 && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === !1);
}
__name(shouldLoadOnMount, "shouldLoadOnMount");
function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
__name(shouldFetchOnMount, "shouldFetchOnMount");
function shouldFetchOn(query, options, field) {
  if (options.enabled !== !1) {
    const value = typeof field == "function" ? field(query) : field;
    return value === "always" || value !== !1 && isStale(query, options);
  }
  return !1;
}
__name(shouldFetchOn, "shouldFetchOn");
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== !1 && (query !== prevQuery || prevOptions.enabled === !1) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
__name(shouldFetchOptionally, "shouldFetchOptionally");
function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
__name(isStale, "isStale");
function shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
  return options.keepPreviousData ? !1 : options.placeholderData !== void 0 ? optimisticResult.isPlaceholderData : !shallowEqualObjects(observer.getCurrentResult(), optimisticResult);
}
__name(shouldAssignObserverCurrentProperties, "shouldAssignObserverCurrentProperties");
const _MutationObserver = class _MutationObserver extends Subscribable {
  constructor(client, options) {
    super(), this.client = client, this.setOptions(options), this.bindMethods(), this.updateResult();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(options) {
    var _this$currentMutation;
    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options), shallowEqualObjects(prevOptions, this.options) || this.client.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.currentMutation,
      observer: this
    }), (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$currentMutation2;
      (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
    }
  }
  onMutationUpdate(action) {
    this.updateResult();
    const notifyOptions = {
      listeners: !0
    };
    action.type === "success" ? notifyOptions.onSuccess = !0 : action.type === "error" && (notifyOptions.onError = !0), this.notify(notifyOptions);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  reset() {
    this.currentMutation = void 0, this.updateResult(), this.notify({
      listeners: !0
    });
  }
  mutate(variables, options) {
    return this.mutateOptions = options, this.currentMutation && this.currentMutation.removeObserver(this), this.currentMutation = this.client.getMutationCache().build(this.client, {
      ...this.options,
      variables: typeof variables < "u" ? variables : this.options.variables
    }), this.currentMutation.addObserver(this), this.currentMutation.execute();
  }
  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : getDefaultState(), result2 = {
      ...state,
      isLoading: state.status === "loading",
      isSuccess: state.status === "success",
      isError: state.status === "error",
      isIdle: state.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result2;
  }
  notify(options) {
    notifyManager.batch(() => {
      if (this.mutateOptions && this.hasListeners()) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context), (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context), (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, void 0, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      }
      options.listeners && this.listeners.forEach(({
        listener
      }) => {
        listener(this.currentResult);
      });
    });
  }
};
__name(_MutationObserver, "MutationObserver");
let MutationObserver = _MutationObserver;
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2.default : x2;
}
__name(getDefaultExportFromCjs, "getDefaultExportFromCjs");
var shim = { exports: {} }, useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min) return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e2 = React__default;
  function h2(a2, b2) {
    return a2 === b2 && (a2 !== 0 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
  }
  __name(h2, "h");
  var k2 = typeof Object.is == "function" ? Object.is : h2, l2 = e2.useState, m2 = e2.useEffect, n2 = e2.useLayoutEffect, p2 = e2.useDebugValue;
  function q2(a2, b2) {
    var d2 = b2(), f2 = l2({ inst: { value: d2, getSnapshot: b2 } }), c2 = f2[0].inst, g2 = f2[1];
    return n2(function() {
      c2.value = d2, c2.getSnapshot = b2, r2(c2) && g2({ inst: c2 });
    }, [a2, d2, b2]), m2(function() {
      return r2(c2) && g2({ inst: c2 }), a2(function() {
        r2(c2) && g2({ inst: c2 });
      });
    }, [a2]), p2(d2), d2;
  }
  __name(q2, "q");
  function r2(a2) {
    var b2 = a2.getSnapshot;
    a2 = a2.value;
    try {
      var d2 = b2();
      return !k2(a2, d2);
    } catch {
      return !0;
    }
  }
  __name(r2, "r");
  function t2(a2, b2) {
    return b2();
  }
  __name(t2, "t");
  var u2 = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? t2 : q2;
  return useSyncExternalStoreShim_production_min.useSyncExternalStore = e2.useSyncExternalStore !== void 0 ? e2.useSyncExternalStore : u2, useSyncExternalStoreShim_production_min;
}
__name(requireUseSyncExternalStoreShim_production_min, "requireUseSyncExternalStoreShim_production_min");
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React2 = React__default, ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format2) {
      {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)
          args[_key2 - 1] = arguments[_key2];
        printWarning("error", format2, args);
      }
    }
    __name(error, "error");
    function printWarning(level, format2, args) {
      {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame, stack = ReactDebugCurrentFrame.getStackAddendum();
        stack !== "" && (format2 += "%s", args = args.concat([stack]));
        var argsWithFormat = args.map(function(item) {
          return String(item);
        });
        argsWithFormat.unshift("Warning: " + format2), Function.prototype.apply.call(console[level], console, argsWithFormat);
      }
    }
    __name(printWarning, "printWarning");
    function is2(x2, y2) {
      return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
    }
    __name(is2, "is");
    var objectIs = typeof Object.is == "function" ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect = React2.useLayoutEffect, useDebugValue = React2.useDebugValue, didWarnOld18Alpha = !1, didWarnUncachedGetSnapshot = !1;
    function useSyncExternalStore2(subscribe, getSnapshot, getServerSnapshot) {
      didWarnOld18Alpha || React2.startTransition !== void 0 && (didWarnOld18Alpha = !0, error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var value = getSnapshot();
      if (!didWarnUncachedGetSnapshot) {
        var cachedValue = getSnapshot();
        objectIs(value, cachedValue) || (error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
      }
      var _useState = useState2({
        inst: {
          value,
          getSnapshot
        }
      }), inst = _useState[0].inst, forceUpdate = _useState[1];
      return useLayoutEffect(function() {
        inst.value = value, inst.getSnapshot = getSnapshot, checkIfSnapshotChanged(inst) && forceUpdate({
          inst
        });
      }, [subscribe, value, getSnapshot]), useEffect2(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
          inst
        });
        var handleStoreChange = /* @__PURE__ */ __name(function() {
          checkIfSnapshotChanged(inst) && forceUpdate({
            inst
          });
        }, "handleStoreChange");
        return subscribe(handleStoreChange);
      }, [subscribe]), useDebugValue(value), value;
    }
    __name(useSyncExternalStore2, "useSyncExternalStore");
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot, prevValue = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(prevValue, nextValue);
      } catch {
        return !0;
      }
    }
    __name(checkIfSnapshotChanged, "checkIfSnapshotChanged");
    function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
      return getSnapshot();
    }
    __name(useSyncExternalStore$1, "useSyncExternalStore$1");
    var canUseDOM = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", isServerEnvironment = !canUseDOM, shim2 = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore2, useSyncExternalStore$2 = React2.useSyncExternalStore !== void 0 ? React2.useSyncExternalStore : shim2;
    useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), useSyncExternalStoreShim_development;
}
__name(requireUseSyncExternalStoreShim_development, "requireUseSyncExternalStoreShim_development");
process.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production_min() : shim.exports = requireUseSyncExternalStoreShim_development();
var shimExports = shim.exports;
const useSyncExternalStore = shimExports.useSyncExternalStore, defaultContext = /* @__PURE__ */ React.createContext(void 0), QueryClientSharingContext = /* @__PURE__ */ React.createContext(!1);
function getQueryClientContext(context, contextSharing) {
  return context || (contextSharing && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = defaultContext), window.ReactQueryClientContext) : defaultContext);
}
__name(getQueryClientContext, "getQueryClientContext");
const useQueryClient = /* @__PURE__ */ __name(({
  context
} = {}) => {
  const queryClient = React.useContext(getQueryClientContext(context, React.useContext(QueryClientSharingContext)));
  if (!queryClient)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return queryClient;
}, "useQueryClient"), QueryClientProvider = /* @__PURE__ */ __name(({
  client,
  children,
  context,
  contextSharing = !1
}) => {
  React.useEffect(() => (client.mount(), () => {
    client.unmount();
  }), [client]), process.env.NODE_ENV !== "production" && contextSharing && client.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const Context = getQueryClientContext(context, contextSharing);
  return /* @__PURE__ */ React.createElement(QueryClientSharingContext.Provider, {
    value: !context && contextSharing
  }, /* @__PURE__ */ React.createElement(Context.Provider, {
    value: client
  }, children));
}, "QueryClientProvider"), IsRestoringContext = /* @__PURE__ */ React.createContext(!1), useIsRestoring = /* @__PURE__ */ __name(() => React.useContext(IsRestoringContext), "useIsRestoring");
IsRestoringContext.Provider;
function createValue() {
  let isReset = !1;
  return {
    clearReset: /* @__PURE__ */ __name(() => {
      isReset = !1;
    }, "clearReset"),
    reset: /* @__PURE__ */ __name(() => {
      isReset = !0;
    }, "reset"),
    isReset: /* @__PURE__ */ __name(() => isReset, "isReset")
  };
}
__name(createValue, "createValue");
const QueryErrorResetBoundaryContext = /* @__PURE__ */ React.createContext(createValue()), useQueryErrorResetBoundary = /* @__PURE__ */ __name(() => React.useContext(QueryErrorResetBoundaryContext), "useQueryErrorResetBoundary");
function shouldThrowError(_useErrorBoundary, params) {
  return typeof _useErrorBoundary == "function" ? _useErrorBoundary(...params) : !!_useErrorBoundary;
}
__name(shouldThrowError, "shouldThrowError");
const ensurePreventErrorBoundaryRetry = /* @__PURE__ */ __name((options, errorResetBoundary) => {
  (options.suspense || options.useErrorBoundary) && (errorResetBoundary.isReset() || (options.retryOnMount = !1));
}, "ensurePreventErrorBoundaryRetry"), useClearResetErrorBoundary = /* @__PURE__ */ __name((errorResetBoundary) => {
  React.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
}, "useClearResetErrorBoundary"), getHasError = /* @__PURE__ */ __name(({
  result: result2,
  errorResetBoundary,
  useErrorBoundary,
  query
}) => result2.isError && !errorResetBoundary.isReset() && !result2.isFetching && shouldThrowError(useErrorBoundary, [result2.error, query]), "getHasError"), ensureStaleTime = /* @__PURE__ */ __name((defaultedOptions) => {
  defaultedOptions.suspense && typeof defaultedOptions.staleTime != "number" && (defaultedOptions.staleTime = 1e3);
}, "ensureStaleTime"), willFetch = /* @__PURE__ */ __name((result2, isRestoring) => result2.isLoading && result2.isFetching && !isRestoring, "willFetch"), shouldSuspend = /* @__PURE__ */ __name((defaultedOptions, result2, isRestoring) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result2, isRestoring), "shouldSuspend"), fetchOptimistic = /* @__PURE__ */ __name((defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).then(({
  data
}) => {
  defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data), defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
}).catch((error) => {
  errorResetBoundary.clearReset(), defaultedOptions.onError == null || defaultedOptions.onError(error), defaultedOptions.onSettled == null || defaultedOptions.onSettled(void 0, error);
}), "fetchOptimistic");
function useBaseQuery(options, Observer) {
  const queryClient = useQueryClient({
    context: options.context
  }), isRestoring = useIsRestoring(), errorResetBoundary = useQueryErrorResetBoundary(), defaultedOptions = queryClient.defaultQueryOptions(options);
  defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic", defaultedOptions.onError && (defaultedOptions.onError = notifyManager.batchCalls(defaultedOptions.onError)), defaultedOptions.onSuccess && (defaultedOptions.onSuccess = notifyManager.batchCalls(defaultedOptions.onSuccess)), defaultedOptions.onSettled && (defaultedOptions.onSettled = notifyManager.batchCalls(defaultedOptions.onSettled)), ensureStaleTime(defaultedOptions), ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary), useClearResetErrorBoundary(errorResetBoundary);
  const [observer] = React.useState(() => new Observer(queryClient, defaultedOptions)), result2 = observer.getOptimisticResult(defaultedOptions);
  if (useSyncExternalStore(React.useCallback((onStoreChange) => {
    const unsubscribe = isRestoring ? () => {
    } : observer.subscribe(notifyManager.batchCalls(onStoreChange));
    return observer.updateResult(), unsubscribe;
  }, [observer, isRestoring]), () => observer.getCurrentResult(), () => observer.getCurrentResult()), React.useEffect(() => {
    observer.setOptions(defaultedOptions, {
      listeners: !1
    });
  }, [defaultedOptions, observer]), shouldSuspend(defaultedOptions, result2, isRestoring))
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  if (getHasError({
    result: result2,
    errorResetBoundary,
    useErrorBoundary: defaultedOptions.useErrorBoundary,
    query: observer.getCurrentQuery()
  }))
    throw result2.error;
  return defaultedOptions.notifyOnChangeProps ? result2 : observer.trackResult(result2);
}
__name(useBaseQuery, "useBaseQuery");
function useQuery(arg1, arg2, arg3) {
  const parsedOptions = parseQueryArgs(arg1, arg2);
  return useBaseQuery(parsedOptions, QueryObserver);
}
__name(useQuery, "useQuery");
function useMutation(arg1, arg2, arg3) {
  const options = parseMutationArgs(arg1, arg2), queryClient = useQueryClient({
    context: options.context
  }), [observer] = React.useState(() => new MutationObserver(queryClient, options));
  React.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result2 = useSyncExternalStore(React.useCallback((onStoreChange) => observer.subscribe(notifyManager.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult()), mutate = React.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop$1);
  }, [observer]);
  if (result2.error && shouldThrowError(observer.options.useErrorBoundary, [result2.error]))
    throw result2.error;
  return {
    ...result2,
    mutate,
    mutateAsync: result2.mutate
  };
}
__name(useMutation, "useMutation");
function noop$1() {
}
__name(noop$1, "noop$1");
const _FileNode = class _FileNode {
  constructor(absolutePath, file) {
    __publicField(this, "_absolutePath");
    __publicField(this, "_dataImportRequestId", null);
    __publicField(this, "_file");
    __publicField(this, "_fileId", null);
    __publicField(this, "_fileImportRequestId", null);
    __publicField(this, "_fileSystemNodeId", null);
    __publicField(this, "_storage", null);
    __publicField(this, "type", "file");
    __publicField(this, "_uploader", null);
    this._absolutePath = absolutePath, this._file = file;
  }
  createUploader(uploaderFactory) {
    return this._uploader = uploaderFactory.create(this), this._uploader;
  }
  get absolutePath() {
    return this._absolutePath;
  }
  get dataImportRequestId() {
    return this._dataImportRequestId;
  }
  get file() {
    return this._file;
  }
  get fileId() {
    return this._fileId;
  }
  get fileImportRequestId() {
    return this._fileImportRequestId;
  }
  get fileSystemNodeId() {
    return this._fileSystemNodeId;
  }
  get storage() {
    return this._storage;
  }
  get uploader() {
    return this._uploader;
  }
  setDataImportRequestId(dataImportRequestId) {
    this._dataImportRequestId = dataImportRequestId;
  }
  setFileId(fileId) {
    this._fileId = fileId;
  }
  setFileImportRequestId(fileImportRequestId) {
    this._fileImportRequestId = fileImportRequestId;
  }
  setFileSystemNodeId(fileSystemNodeId) {
    this._fileSystemNodeId = fileSystemNodeId;
  }
  setStorage(storage) {
    this._storage = storage;
  }
};
__name(_FileNode, "FileNode");
let FileNode = _FileNode;
const _BadStateError = class _BadStateError extends Error {
  constructor(message) {
    super(message);
    __publicField(this, "isRetryable", !1);
    this.name = "BadStateError";
  }
};
__name(_BadStateError, "BadStateError");
let BadStateError = _BadStateError;
const _LimitationError = class _LimitationError extends Error {
  constructor(message) {
    super(message);
    __publicField(this, "isRetryable", !1);
    this.name = "LimitationError";
  }
};
__name(_LimitationError, "LimitationError");
let LimitationError = _LimitationError;
const _AbortionError = class _AbortionError extends Error {
  constructor(message) {
    super(message);
    __publicField(this, "isRetryable", !1);
    this.name = "AbortionError";
  }
};
__name(_AbortionError, "AbortionError");
let AbortionError = _AbortionError;
const _ServerError = class _ServerError extends Error {
  constructor(message) {
    super(message);
    __publicField(this, "isRetryable", !0);
    this.name = "ServerError";
  }
};
__name(_ServerError, "ServerError");
let ServerError = _ServerError;
const _FolderNode = class _FolderNode {
  constructor(absolutePath) {
    __publicField(this, "_absolutePath");
    __publicField(this, "_childFileAbsolutePaths", /* @__PURE__ */ new Set());
    __publicField(this, "_childFolderAbsolutePaths", /* @__PURE__ */ new Set());
    __publicField(this, "_dataImportRequestId", null);
    __publicField(this, "_folderImportRequestId", null);
    __publicField(this, "type", "folder");
    this._absolutePath = absolutePath;
  }
  get absolutePath() {
    return this._absolutePath;
  }
  get childFileAbsolutePaths() {
    return this._childFileAbsolutePaths;
  }
  get childFolderAbsolutePaths() {
    return this._childFolderAbsolutePaths;
  }
  get dataImportRequestId() {
    return this._dataImportRequestId;
  }
  get folderImportRequestId() {
    return this._folderImportRequestId;
  }
  setDataImportRequestId(dataImportRequestId) {
    this._dataImportRequestId = dataImportRequestId;
  }
  setFolderImportRequestId(folderImportRequestId) {
    this._folderImportRequestId = folderImportRequestId;
  }
  addNode(node) {
    if (node.type === "file") this._childFileAbsolutePaths.add(node.absolutePath);
    else if (node.type === "folder") this._childFolderAbsolutePaths.add(node.absolutePath);
    else throw new BadStateError(`file tree node (${node}) has unknown type`);
  }
};
__name(_FolderNode, "FolderNode");
let FolderNode = _FolderNode;
const _FileTree = class _FileTree {
  constructor(nodeMap = /* @__PURE__ */ new Map()) {
    __publicField(this, "_nodeMap");
    __publicField(this, "_numberOfFiles");
    __publicField(this, "_sizeOfFiles");
    this._nodeMap = nodeMap;
    let numberOfFiles = 0, sizeOfFiles = 0;
    this.traverseFileNodes((node) => {
      numberOfFiles += 1, sizeOfFiles += node.file.size;
    }), this._numberOfFiles = numberOfFiles, this._sizeOfFiles = sizeOfFiles;
  }
  addFile(file) {
    const paths = (file.webkitRelativePath || file.path || file.name).split("/").filter((path) => path !== "");
    for (let i2 = 0; i2 < paths.length; i2++) {
      const parentAbsolutePath = i2 === 0 ? "/" : "/" + paths.slice(0, i2).join("/"), childAbsolutePath = "/" + paths.slice(0, i2 + 1).join("/");
      let parentNode = this._nodeMap.get(parentAbsolutePath);
      if (parentNode === void 0 && (parentNode = new FolderNode(parentAbsolutePath), this._nodeMap.set(parentAbsolutePath, parentNode)), assertIsFolderNode(parentNode), i2 === paths.length - 1) {
        const childNode = new FileNode(childAbsolutePath, file);
        parentNode.addNode(childNode), this._nodeMap.set(childAbsolutePath, childNode);
      } else {
        const childNode = new FolderNode(childAbsolutePath);
        parentNode.addNode(childNode);
      }
    }
    this._numberOfFiles += 1, this._sizeOfFiles += file.size;
  }
  addFiles(files) {
    for (const file of files)
      this.addFile(file);
  }
  traverseFromNodeWithDepth(node, callback, depth) {
    if (callback(node, depth), node.type === "folder") {
      for (const childPath of node.childFolderAbsolutePaths.values()) {
        const childNode = this._nodeMap.get(childPath);
        if (!childNode) return;
        this.traverseFromNodeWithDepth(childNode, callback, depth + 1);
      }
      for (const childPath of node.childFileAbsolutePaths.values()) {
        const childNode = this._nodeMap.get(childPath);
        if (!childNode) return;
        this.traverseFromNodeWithDepth(childNode, callback, depth + 1);
      }
    }
  }
  traverse(callback) {
    const root2 = this._nodeMap.get("/");
    root2 && this.traverseFromNodeWithDepth(root2, callback, 0);
  }
  traverseFileNodes(callback) {
    this.traverse((node, depth) => {
      node.type === "file" && callback(node, depth);
    });
  }
  traverseFolderNodes(callback) {
    this.traverse((node, depth) => {
      node.type === "folder" && callback(node, depth);
    });
  }
  map(callback) {
    const results = [];
    return this.traverse((node, depth) => {
      const result2 = callback(node, depth);
      results.push(result2);
    }), results;
  }
  mapFileNodes(callback) {
    const results = [];
    return this.traverseFileNodes((node, depth) => {
      const result2 = callback(node, depth);
      results.push(result2);
    }), results;
  }
  mapFolderNodes(callback) {
    const results = [];
    return this.traverseFolderNodes((node, depth) => {
      const result2 = callback(node, depth);
      results.push(result2);
    }), results;
  }
  getNode(absolutePath) {
    return this._nodeMap.get(absolutePath);
  }
  getRootNode() {
    return this._nodeMap.get("/");
  }
  get numberOfFiles() {
    return this._numberOfFiles;
  }
  get sizeOfFiles() {
    return this._sizeOfFiles;
  }
};
__name(_FileTree, "FileTree");
let FileTree = _FileTree;
const assertNotAborted = /* @__PURE__ */ __name((signal, message) => {
  if (signal != null && signal.aborted) throw new Error(message);
}, "assertNotAborted");
function assertIsString(examinee, message) {
  if (typeof examinee != "string")
    throw new BadStateError(message ?? `examinee (${examinee}) is not a string`);
}
__name(assertIsString, "assertIsString");
function assertIsFileNode(examinee, message) {
  if (!(examinee instanceof FileNode))
    throw new BadStateError(`examinee (${examinee}) is not a FileNode`);
}
__name(assertIsFileNode, "assertIsFileNode");
function assertIsFolderNode(examinee, message) {
  if (!(examinee instanceof FolderNode))
    throw new BadStateError(`examinee (${examinee}) is not a FolderNode`);
}
__name(assertIsFolderNode, "assertIsFolderNode");
function assertIsMap(examinee, message) {
  if (!(examinee instanceof Map)) throw new Error("examinee is not a Map");
}
__name(assertIsMap, "assertIsMap");
function assertIsDefined(examinee, message) {
  if (examinee == null)
    throw new Error(`${examinee} is not defined`);
}
__name(assertIsDefined, "assertIsDefined");
function assertIsEvent(event, expectedEventType, message) {
  if (event.type !== expectedEventType)
    throw new BadStateError(
      `event (${event}) type (${event.type}) is not expected (${expectedEventType})`
    );
}
__name(assertIsEvent, "assertIsEvent");
const DATA_IMPORT_REQUEST_STATUS = {
  CREATED: "CREATED",
  TRACKING_FOLDER_PATHS: "TRACKING_FOLDER_PATHS",
  FOLDER_PATHS_TRACKED: "FOLDER_PATHS_TRACKED",
  TRACKING_FILE_PATHS: "TRACKING_FILE_PATHS",
  FILE_PATHS_TRACKED: "FILE_PATHS_TRACKED",
  IMPORTING_FOLDER_NODES: "IMPORTING_FOLDER_NODES",
  FOLDER_NODES_IMPORTED: "FOLDER_NODES_IMPORTED",
  IMPORTING_FILE_NODES: "IMPORTING_FILE_NODES",
  FILE_NODES_IMPORTED: "FILE_NODES_IMPORTED"
}, NODE_IMPORT_REQUEST_STATUS = {
  CREATED: "CREATED",
  FOLDER_PATH_TRACKED: "FOLDER_PATH_TRACKED",
  FOLDER_NODE_IMPORTED: "FOLDER_NODE_IMPORTED",
  TRACKING_FILE_PATHS: "TRACKING_FILE_PATHS",
  FILE_PATHS_TRACKED: "FILE_PATHS_TRACKED",
  IMPORTING_FILE_NODES: "IMPORTING_FILE_NODES",
  FILE_NODES_IMPORTED: "FILE_NODES_IMPORTED"
}, FILE_KIND = {
  ASSET: "AssetFile",
  IMAGE: "ImageFile",
  IMAGE_THUMBNAIL: "ImageThumbnailFile",
  TILESET_3D: "Tileset3dFile",
  OBJ: "ObjFile",
  ORTHO_2D: "Ortho2dFile"
}, DATA_IMPORT_REQUEST_PRIORITY = {
  IMMEDIATE: "IMMEDIATE",
  HIGH: "HIGH",
  LOW: "LOW"
};
var FileKindInput = /* @__PURE__ */ ((FileKindInput2) => (FileKindInput2.Asset = "ASSET", FileKindInput2.Image = "IMAGE", FileKindInput2.ImageThumbnail = "IMAGE_THUMBNAIL", FileKindInput2.Obj = "OBJ", FileKindInput2.Ortho_2D = "ORTHO_2D", FileKindInput2.Tileset_3D = "TILESET_3D", FileKindInput2))(FileKindInput || {});
const CreateDataImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateDataImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "featureType" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "name" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "persistType" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "rootFolderIdempotencyKeyAndName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FolderIdempotencyKeyAndNameInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "systemFolderNodeId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createDataImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "featureType" }, value: { kind: "Variable", name: { kind: "Name", value: "featureType" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "name" } } }, { kind: "Argument", name: { kind: "Name", value: "persistType" }, value: { kind: "Variable", name: { kind: "Name", value: "persistType" } } }, { kind: "Argument", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }, { kind: "Argument", name: { kind: "Name", value: "rootFolderIdempotencyKeyAndName" }, value: { kind: "Variable", name: { kind: "Name", value: "rootFolderIdempotencyKeyAndName" } } }, { kind: "Argument", name: { kind: "Name", value: "systemFolderNodeId" }, value: { kind: "Variable", name: { kind: "Name", value: "systemFolderNodeId" } } }] }] } }] }, CreateDataImportRequestV2Document = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateDataImportRequestV2" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dependants" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "SystemNodeDependantInput" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "featureType" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "name" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "persistType" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "rootFolderIdempotencyKeyAndName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FolderIdempotencyKeyAndNameInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "systemFolderNodeId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createDataImportRequestV2" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "dependants" }, value: { kind: "Variable", name: { kind: "Name", value: "dependants" } } }, { kind: "Argument", name: { kind: "Name", value: "featureType" }, value: { kind: "Variable", name: { kind: "Name", value: "featureType" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "name" } } }, { kind: "Argument", name: { kind: "Name", value: "persistType" }, value: { kind: "Variable", name: { kind: "Name", value: "persistType" } } }, { kind: "Argument", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }, { kind: "Argument", name: { kind: "Name", value: "rootFolderIdempotencyKeyAndName" }, value: { kind: "Variable", name: { kind: "Name", value: "rootFolderIdempotencyKeyAndName" } } }, { kind: "Argument", name: { kind: "Name", value: "systemFolderNodeId" }, value: { kind: "Variable", name: { kind: "Name", value: "systemFolderNodeId" } } }] }] } }] }, UpdateStatusForDataImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateStatusForDataImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "status" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateStatusForDataImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "status" }, value: { kind: "Variable", name: { kind: "Name", value: "status" } } }, { kind: "Argument", name: { kind: "Name", value: "dataImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }] }] } }] }, CreateFolderImportRequestForDataImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateFolderImportRequestForDataImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "parentFolderNodeIdempotencyKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "childFolderNodeIdempotencyKeyAndNames" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FolderIdempotencyKeyAndNameInput" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createFolderImportRequestForDataImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "dataImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }, { kind: "Argument", name: { kind: "Name", value: "parentFolderNodeIdempotencyKey" }, value: { kind: "Variable", name: { kind: "Name", value: "parentFolderNodeIdempotencyKey" } } }, { kind: "Argument", name: { kind: "Name", value: "childFolderNodeIdempotencyKeyAndNames" }, value: { kind: "Variable", name: { kind: "Name", value: "childFolderNodeIdempotencyKeyAndNames" } } }] }] } }] }, UpdateStatusForFolderImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateStatusForFolderImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateStatusForFolderImportRequestInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateStatusForFolderImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] }, CreateFileNodeForFolderImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateFileNodeForFolderImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "fileIdempotencyKeyStorageAndMetadata" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FileIdempotencyKeyStorageAndMetadataInput" } } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "folderImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createFileNodeForFolderImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "dataImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }, { kind: "Argument", name: { kind: "Name", value: "fileIdempotencyKeyStorageAndMetadata" }, value: { kind: "Variable", name: { kind: "Name", value: "fileIdempotencyKeyStorageAndMetadata" } } }, { kind: "Argument", name: { kind: "Name", value: "folderImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "folderImportRequestId" } } }] }] } }] }, CreateFolderNodeForFolderImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateFolderNodeForFolderImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "childFolderImportRequestIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "parentFolderImportRequestId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createFolderNodeForFolderImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "childFolderImportRequestIds" }, value: { kind: "Variable", name: { kind: "Name", value: "childFolderImportRequestIds" } } }, { kind: "Argument", name: { kind: "Name", value: "dataImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }, { kind: "Argument", name: { kind: "Name", value: "parentFolderImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "parentFolderImportRequestId" } } }] }] } }] }, TrackFilesForFolderImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "TrackFilesForFolderImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "folderImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "files" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FileItemInput" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackFilesForFolderImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "dataImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }, { kind: "Argument", name: { kind: "Name", value: "folderImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "folderImportRequestId" } } }, { kind: "Argument", name: { kind: "Name", value: "files" }, value: { kind: "Variable", name: { kind: "Name", value: "files" } } }] }] } }] }, CreateFileV2Document = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateFileV2" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreateFileInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createFileV2" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "file" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AssetFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObjFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ortho2dFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tileset3dFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, LogInDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "LogIn" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "password" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "password" }, value: { kind: "Variable", name: { kind: "Name", value: "password" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bearerToken" } }] } }] } }] }, CreateFileDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateFile" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "fileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "fileKind" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FileKindInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "name" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "size" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Float" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "type" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createFile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "accountId" }, value: { kind: "Variable", name: { kind: "Name", value: "accountId" } } }, { kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "fileId" }, value: { kind: "Variable", name: { kind: "Name", value: "fileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fileKind" }, value: { kind: "Variable", name: { kind: "Name", value: "fileKind" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "name" } } }, { kind: "Argument", name: { kind: "Name", value: "size" }, value: { kind: "Variable", name: { kind: "Name", value: "size" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "Variable", name: { kind: "Name", value: "type" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AssetFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObjFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ortho2dFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tileset3dFile" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, CreateMultipartUploadDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateMultipartUpload" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "fileName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createMultipartUpload" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "fileName" }, value: { kind: "Variable", name: { kind: "Name", value: "fileName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bucket" } }, { kind: "Field", name: { kind: "Name", value: "fileId" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "uploadId" } }] } }] } }] }, CreatePresignedUploadPartUrlDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreatePresignedUploadPartUrl" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "partNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createPresignedUploadPartUrl" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "partNumber" }, value: { kind: "Variable", name: { kind: "Name", value: "partNumber" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }] }] } }] }, CompleteMultipartUploadDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CompleteMultipartUpload" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "parts" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "MultiPartInput" } } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "completeMultipartUpload" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "parts" }, value: { kind: "Variable", name: { kind: "Name", value: "parts" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }] }] } }] }, AbortMultiPartUploadDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "AbortMultiPartUpload" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "abortMultipartUpload" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }] }] } }] }, CreateImageThumbnailsForPersistedImagesByIdsDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateImageThumbnailsForPersistedImagesByIds" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "fileIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createImageThumbnailsForPersistedImagesByIds" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "fileIds" }, value: { kind: "Variable", name: { kind: "Name", value: "fileIds" } } }] }] } }] }, CreateMultipartUploadForFileImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateMultipartUploadForFileImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "fileImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createMultipartUploadForFileImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "dataImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }, { kind: "Argument", name: { kind: "Name", value: "fileImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "fileImportRequestId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bucket" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "uploadId" } }] } }] } }] }, CreatePresignedPartUrlForFileImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreatePresignedPartUrlForFileImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "partNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createPresignedPartUrlForFileImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "partNumber" }, value: { kind: "Variable", name: { kind: "Name", value: "partNumber" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }] }] } }] }, CompleteMultipartUploadForFileImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CompleteMultipartUploadForFileImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "parts" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "MultiPartInput" } } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "completeMultipartUploadForFileImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "parts" }, value: { kind: "Variable", name: { kind: "Name", value: "parts" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }] }] } }] }, AbortMultipartUploadForFileImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "AbortMultipartUploadForFileImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "abortMultipartUpload" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }] }] } }] }, BucketAndRegionDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "BucketAndRegion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bucketAndRegion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "bucket" } }] } }] } }] }, MultipartUploadIdDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "MultipartUploadId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipartUploadId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }] }] } }] }, AbortMultipartUploadDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "AbortMultipartUpload" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "abortMultipartUpload" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }] }] } }] }, PresignedMultipartUrlDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "PresignedMultipartUrl" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "partNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Float" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presignedMultipartUrl" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "partNumber" }, value: { kind: "Variable", name: { kind: "Name", value: "partNumber" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }] }] } }] }, ListUploadPartsDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "ListUploadParts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "listUploadParts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PartNumber" } }, { kind: "Field", name: { kind: "Name", value: "ETag" } }, { kind: "Field", name: { kind: "Name", value: "Size" } }] } }] } }] }, CompleteMultipartUploadQueryDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "CompleteMultipartUploadQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "parts" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PartInput" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "completeMultipartUpload" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }, { kind: "Argument", name: { kind: "Name", value: "parts" }, value: { kind: "Variable", name: { kind: "Name", value: "parts" } } }] }] } }] }, FindDataImportRequestByDataImportRequestIdDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "FindDataImportRequestByDataImportRequestId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findDataImportRequestByDataImportRequestId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rootFolderImportRequestId" } }] } }] } }] }, AccountByContextDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "AccountByContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountByContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] }, ListPartsForMultipartUploadDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "listPartsForMultipartUpload" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "listPartsForMultipartUpload" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ETag" } }, { kind: "Field", name: { kind: "Name", value: "PartNumber" } }, { kind: "Field", name: { kind: "Name", value: "Size" } }] } }] } }] }, CountFileImportRequestsByDataImportRequestIdDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "CountFileImportRequestsByDataImportRequestId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "fileKind" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countFileImportRequestsByDataImportRequestId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "dataImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }, { kind: "Argument", name: { kind: "Name", value: "fileKind" }, value: { kind: "Variable", name: { kind: "Name", value: "fileKind" } } }] }] } }] }, FindFileImportRequestsByDataImportRequestIdDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "FindFileImportRequestsByDataImportRequestId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "fileKind" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "start" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "size" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findFileImportRequestsByDataImportRequestId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "dataImportRequestId" }, value: { kind: "Variable", name: { kind: "Name", value: "dataImportRequestId" } } }, { kind: "Argument", name: { kind: "Name", value: "fileKind" }, value: { kind: "Variable", name: { kind: "Name", value: "fileKind" } } }, { kind: "Argument", name: { kind: "Name", value: "start" }, value: { kind: "Variable", name: { kind: "Name", value: "start" } } }, { kind: "Argument", name: { kind: "Name", value: "size" }, value: { kind: "Variable", name: { kind: "Name", value: "size" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "fileId" } }] } }] } }] }, ListPartsForMultipartUploadForFileImportRequestDocument = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "listPartsForMultipartUploadForFileImportRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bucket" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "key" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "uploadId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "listPartsForMultipartUploadForFileImportRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "bucket" }, value: { kind: "Variable", name: { kind: "Name", value: "bucket" } } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "Variable", name: { kind: "Name", value: "key" } } }, { kind: "Argument", name: { kind: "Name", value: "uploadId" }, value: { kind: "Variable", name: { kind: "Name", value: "uploadId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ETag" } }, { kind: "Field", name: { kind: "Name", value: "PartNumber" } }, { kind: "Field", name: { kind: "Name", value: "Size" } }] } }] } }] }, getFileKindInput = /* @__PURE__ */ __name((fileType) => fileType.startsWith("image/") ? FileKindInput.Image : FileKindInput.Asset, "getFileKindInput"), getFileKind = /* @__PURE__ */ __name((fileType) => fileType.startsWith("image/") ? FILE_KIND.IMAGE : FILE_KIND.ASSET, "getFileKind"), documents = {
  "\n  mutation CreateDataImportRequest(\n    $featureType: String!\n    $name: String!\n    $persistType: String!\n    $priority: String!\n    $rootFolderIdempotencyKeyAndName: FolderIdempotencyKeyAndNameInput!\n    $systemFolderNodeId: ID\n  ) {\n    createDataImportRequest(\n      featureType: $featureType\n      name: $name\n      persistType: $persistType\n      priority: $priority\n      rootFolderIdempotencyKeyAndName: $rootFolderIdempotencyKeyAndName\n      systemFolderNodeId: $systemFolderNodeId\n    )\n  }\n": CreateDataImportRequestDocument,
  "\n  mutation CreateDataImportRequestV2(\n    $dependants: [SystemNodeDependantInput!]\n    $featureType: String!\n    $name: String!\n    $persistType: String!\n    $priority: String!\n    $rootFolderIdempotencyKeyAndName: FolderIdempotencyKeyAndNameInput!\n    $systemFolderNodeId: ID\n  ) {\n    createDataImportRequestV2(\n      dependants: $dependants\n      featureType: $featureType\n      name: $name\n      persistType: $persistType\n      priority: $priority\n      rootFolderIdempotencyKeyAndName: $rootFolderIdempotencyKeyAndName\n      systemFolderNodeId: $systemFolderNodeId\n    )\n  }\n": CreateDataImportRequestV2Document,
  "\n  mutation UpdateStatusForDataImportRequest($status: String!, $dataImportRequestId: ID!) {\n    updateStatusForDataImportRequest(status: $status, dataImportRequestId: $dataImportRequestId)\n  }\n": UpdateStatusForDataImportRequestDocument,
  "\n  mutation CreateFolderImportRequestForDataImportRequest(\n    $dataImportRequestId: ID!\n    $parentFolderNodeIdempotencyKey: String!\n    $childFolderNodeIdempotencyKeyAndNames: [FolderIdempotencyKeyAndNameInput!]!\n  ) {\n    createFolderImportRequestForDataImportRequest(\n      dataImportRequestId: $dataImportRequestId\n      parentFolderNodeIdempotencyKey: $parentFolderNodeIdempotencyKey\n      childFolderNodeIdempotencyKeyAndNames: $childFolderNodeIdempotencyKeyAndNames\n    )\n  }\n": CreateFolderImportRequestForDataImportRequestDocument,
  "\n  mutation UpdateStatusForFolderImportRequest($input: UpdateStatusForFolderImportRequestInput!) {\n    updateStatusForFolderImportRequest(input: $input)\n  }\n": UpdateStatusForFolderImportRequestDocument,
  "\n  mutation CreateFileNodeForFolderImportRequest(\n    $dataImportRequestId: ID!,\n    $fileIdempotencyKeyStorageAndMetadata: [FileIdempotencyKeyStorageAndMetadataInput!]!\n    $folderImportRequestId: ID!,\n  ) {\n    createFileNodeForFolderImportRequest(\n      dataImportRequestId: $dataImportRequestId\n      fileIdempotencyKeyStorageAndMetadata: $fileIdempotencyKeyStorageAndMetadata\n      folderImportRequestId: $folderImportRequestId\n    )\n  }\n": CreateFileNodeForFolderImportRequestDocument,
  "\n  mutation CreateFolderNodeForFolderImportRequest(\n    $childFolderImportRequestIds: [ID]!\n    $dataImportRequestId: ID!\n    $parentFolderImportRequestId: ID\n  ) {\n    createFolderNodeForFolderImportRequest(\n      childFolderImportRequestIds: $childFolderImportRequestIds\n      dataImportRequestId: $dataImportRequestId\n      parentFolderImportRequestId: $parentFolderImportRequestId\n    )\n  }\n": CreateFolderNodeForFolderImportRequestDocument,
  "\n  mutation TrackFilesForFolderImportRequest(\n    $dataImportRequestId: ID!\n    $folderImportRequestId: ID!\n    $files: [FileItemInput!]!\n  ) {\n    trackFilesForFolderImportRequest(\n      dataImportRequestId: $dataImportRequestId\n      folderImportRequestId: $folderImportRequestId\n      files: $files\n    )\n  }\n": TrackFilesForFolderImportRequestDocument,
  "\n  mutation CreateFileV2($input: CreateFileInput!) {\n    createFileV2(input: $input) {\n      file {\n        __typename\n        ... on AssetFile { id }\n        ... on ImageFile { id }\n        ... on ObjFile { id }\n        ... on Ortho2dFile { id }\n        ... on Tileset3dFile { id }\n      }\n      node {\n        __typename\n        id\n      }\n    }\n  }\n": CreateFileV2Document,
  "\n  mutation LogIn($email: String!, $password: String!) {\n    login(email: $email, password: $password) {\n      bearerToken\n    }\n  }\n": LogInDocument,
  "\n  mutation CreateFile(\n    $accountId: ID!\n    $bucket: String!\n    $fileId: ID!\n    $fileKind: FileKindInput!\n    $key: String!\n    $name: String!\n    $size: Float!\n    $type: String!\n  ) {\n    createFile(\n      accountId: $accountId\n      bucket: $bucket\n      fileId: $fileId\n      fileKind: $fileKind\n      key: $key\n      name: $name\n      size: $size\n      type: $type\n    ) {\n      __typename\n      ... on AssetFile { id }\n      ... on ImageFile { id }\n      ... on ObjFile { id }\n      ... on Ortho2dFile { id }\n      ... on Tileset3dFile { id }\n    }\n  }\n": CreateFileDocument,
  "\n  mutation CreateMultipartUpload($fileName: String!) {\n    createMultipartUpload(fileName: $fileName) {\n      bucket\n      fileId\n      key\n      uploadId\n    }\n  }\n": CreateMultipartUploadDocument,
  "\n  mutation CreatePresignedUploadPartUrl(\n    $bucket: String!\n    $key: String!\n    $partNumber: Int!\n    $uploadId: String!\n  ) {\n    createPresignedUploadPartUrl(\n      bucket: $bucket\n      key: $key\n      partNumber: $partNumber\n      uploadId: $uploadId\n    )\n  }\n": CreatePresignedUploadPartUrlDocument,
  "\n  mutation CompleteMultipartUpload(\n    $bucket: String!\n    $key: String!\n    $parts: [MultiPartInput!]!\n    $uploadId: String!\n  ) {\n    completeMultipartUpload(\n      bucket: $bucket\n      key: $key\n      parts: $parts\n      uploadId: $uploadId\n    )\n  }\n": CompleteMultipartUploadDocument,
  "\n  mutation AbortMultiPartUpload(\n    $bucket: String!\n    $key: String!\n    $uploadId: String!\n  ) {\n    abortMultipartUpload(\n      bucket: $bucket\n      key: $key\n      uploadId: $uploadId\n    )\n  }\n": AbortMultiPartUploadDocument,
  "\nmutation CreateImageThumbnailsForPersistedImagesByIds($fileIds: [ID]!) {\n  createImageThumbnailsForPersistedImagesByIds(fileIds: $fileIds)\n}\n": CreateImageThumbnailsForPersistedImagesByIdsDocument,
  "\n  mutation CreateMultipartUploadForFileImportRequest($dataImportRequestId: ID!, $fileImportRequestId: ID!) {\n    createMultipartUploadForFileImportRequest(dataImportRequestId: $dataImportRequestId, fileImportRequestId: $fileImportRequestId) {\n      bucket\n      key\n      uploadId\n    }\n  }\n": CreateMultipartUploadForFileImportRequestDocument,
  "\n  mutation CreatePresignedPartUrlForFileImportRequest(\n    $bucket: String!\n    $key: String!\n    $partNumber: Int!\n    $uploadId: String!\n  ) {\n    createPresignedPartUrlForFileImportRequest(\n      bucket: $bucket\n      key: $key\n      partNumber: $partNumber\n      uploadId: $uploadId\n    )\n  }\n": CreatePresignedPartUrlForFileImportRequestDocument,
  "\n  mutation CompleteMultipartUploadForFileImportRequest(\n    $bucket: String!\n    $key: String!\n    $parts: [MultiPartInput!]!\n    $uploadId: String!\n  ) {\n    completeMultipartUploadForFileImportRequest(\n      bucket: $bucket\n      key: $key\n      parts: $parts\n      uploadId: $uploadId\n    )\n  }\n": CompleteMultipartUploadForFileImportRequestDocument,
  "\n  mutation AbortMultipartUploadForFileImportRequest(\n    $bucket: String!\n    $key: String!\n    $uploadId: String!\n  ) {\n    abortMultipartUpload(\n      bucket: $bucket\n      key: $key\n      uploadId: $uploadId\n    )\n  }\n": AbortMultipartUploadForFileImportRequestDocument,
  "\n  query BucketAndRegion {\n    bucketAndRegion {\n      region\n      bucket\n    }\n  }\n": BucketAndRegionDocument,
  "\n  query MultipartUploadId($key: String!, $bucket: String!) {\n    multipartUploadId(key: $key, bucket: $bucket)\n  }\n": MultipartUploadIdDocument,
  "\n  query AbortMultipartUpload($key: String!, $bucket: String!, $uploadId: String!) {\n    abortMultipartUpload(key: $key, bucket: $bucket, uploadId: $uploadId)\n  }\n": AbortMultipartUploadDocument,
  "\n  query PresignedMultipartUrl($key: String!, $partNumber: Float!, $uploadId: String!) {\n    presignedMultipartUrl(key: $key, partNumber: $partNumber, uploadId: $uploadId)\n  }\n": PresignedMultipartUrlDocument,
  "\n  query ListUploadParts($key: String!, $bucket: String!, $uploadId: String!) {\n    listUploadParts(key: $key, bucket: $bucket, uploadId: $uploadId) {\n      PartNumber\n      ETag\n      Size\n    }\n  }\n": ListUploadPartsDocument,
  "\n  query CompleteMultipartUploadQuery(\n    $key: String!\n    $bucket: String!\n    $uploadId: String!\n    $parts: [PartInput!]!\n  ) {\n    completeMultipartUpload(bucket: $bucket, key: $key, uploadId: $uploadId, parts: $parts)\n  }\n": CompleteMultipartUploadQueryDocument,
  "\n  query FindDataImportRequestByDataImportRequestId($dataImportRequestId: ID!) {\n    findDataImportRequestByDataImportRequestId(id: $dataImportRequestId) {\n      rootFolderImportRequestId\n    } \n  }\n": FindDataImportRequestByDataImportRequestIdDocument,
  "\n  query AccountByContext {\n    accountByContext {\n      id\n    }\n  }\n": AccountByContextDocument,
  "\n  query listPartsForMultipartUpload(\n    $bucket: String!\n    $key: String!\n    $uploadId: String!\n  ) {\n    listPartsForMultipartUpload(\n      bucket: $bucket\n      key: $key\n      uploadId: $uploadId\n    ) {\n      ETag\n      PartNumber\n      Size\n    }\n  }\n": ListPartsForMultipartUploadDocument,
  "\nquery CountFileImportRequestsByDataImportRequestId($dataImportRequestId: String!, $fileKind: String) {\n  countFileImportRequestsByDataImportRequestId(\n      dataImportRequestId: $dataImportRequestId\n      fileKind: $fileKind\n  )\n}\n": CountFileImportRequestsByDataImportRequestIdDocument,
  "\nquery FindFileImportRequestsByDataImportRequestId($dataImportRequestId: String!, $fileKind: String, $start: Int, $size: Int) {\n  findFileImportRequestsByDataImportRequestId(\n      dataImportRequestId: $dataImportRequestId\n      fileKind: $fileKind\n      start: $start\n      size: $size\n  ) {\n      id\n      kind\n      fileId\n  }\n}\n": FindFileImportRequestsByDataImportRequestIdDocument,
  "\n  query listPartsForMultipartUploadForFileImportRequest(\n    $bucket: String!\n    $key: String!\n    $uploadId: String!\n  ) {\n    listPartsForMultipartUploadForFileImportRequest(\n      bucket: $bucket\n      key: $key\n      uploadId: $uploadId\n    ) {\n      ETag\n      PartNumber\n      Size\n    }\n  }\n": ListPartsForMultipartUploadForFileImportRequestDocument
};
function gql(source) {
  return documents[source] ?? {};
}
__name(gql, "gql");
gql(`
  mutation CreateDataImportRequest(
    $featureType: String!
    $name: String!
    $persistType: String!
    $priority: String!
    $rootFolderIdempotencyKeyAndName: FolderIdempotencyKeyAndNameInput!
    $systemFolderNodeId: ID
  ) {
    createDataImportRequest(
      featureType: $featureType
      name: $name
      persistType: $persistType
      priority: $priority
      rootFolderIdempotencyKeyAndName: $rootFolderIdempotencyKeyAndName
      systemFolderNodeId: $systemFolderNodeId
    )
  }
`);
const CREATE_DATA_IMPORT_REQUEST_V2 = gql(`
  mutation CreateDataImportRequestV2(
    $dependants: [SystemNodeDependantInput!]
    $featureType: String!
    $name: String!
    $persistType: String!
    $priority: String!
    $rootFolderIdempotencyKeyAndName: FolderIdempotencyKeyAndNameInput!
    $systemFolderNodeId: ID
  ) {
    createDataImportRequestV2(
      dependants: $dependants
      featureType: $featureType
      name: $name
      persistType: $persistType
      priority: $priority
      rootFolderIdempotencyKeyAndName: $rootFolderIdempotencyKeyAndName
      systemFolderNodeId: $systemFolderNodeId
    )
  }
`), UPDATE_STATUS_FOR_DATA_IMPORT_REQUEST = gql(`
  mutation UpdateStatusForDataImportRequest($status: String!, $dataImportRequestId: ID!) {
    updateStatusForDataImportRequest(status: $status, dataImportRequestId: $dataImportRequestId)
  }
`), CREATE_FOLDER_IMPORT_REQUEST_FOR_DATA_IMPORT_REQUEST = gql(`
  mutation CreateFolderImportRequestForDataImportRequest(
    $dataImportRequestId: ID!
    $parentFolderNodeIdempotencyKey: String!
    $childFolderNodeIdempotencyKeyAndNames: [FolderIdempotencyKeyAndNameInput!]!
  ) {
    createFolderImportRequestForDataImportRequest(
      dataImportRequestId: $dataImportRequestId
      parentFolderNodeIdempotencyKey: $parentFolderNodeIdempotencyKey
      childFolderNodeIdempotencyKeyAndNames: $childFolderNodeIdempotencyKeyAndNames
    )
  }
`), UPDATE_STATUS_FOR_FOLDER_IMPORT_REQUEST = gql(`
  mutation UpdateStatusForFolderImportRequest($input: UpdateStatusForFolderImportRequestInput!) {
    updateStatusForFolderImportRequest(input: $input)
  }
`), CREATE_FILE_NODE_FOR_FOLDER_IMPORT_REQUEST = gql(`
  mutation CreateFileNodeForFolderImportRequest(
    $dataImportRequestId: ID!,
    $fileIdempotencyKeyStorageAndMetadata: [FileIdempotencyKeyStorageAndMetadataInput!]!
    $folderImportRequestId: ID!,
  ) {
    createFileNodeForFolderImportRequest(
      dataImportRequestId: $dataImportRequestId
      fileIdempotencyKeyStorageAndMetadata: $fileIdempotencyKeyStorageAndMetadata
      folderImportRequestId: $folderImportRequestId
    )
  }
`), CREATE_FOLDER_NODE_FOR_FOLDER_IMPORT_REQUEST = gql(`
  mutation CreateFolderNodeForFolderImportRequest(
    $childFolderImportRequestIds: [ID]!
    $dataImportRequestId: ID!
    $parentFolderImportRequestId: ID
  ) {
    createFolderNodeForFolderImportRequest(
      childFolderImportRequestIds: $childFolderImportRequestIds
      dataImportRequestId: $dataImportRequestId
      parentFolderImportRequestId: $parentFolderImportRequestId
    )
  }
`), TRACK_FILES_FOR_FOLDER_IMPORT_REQUEST = gql(`
  mutation TrackFilesForFolderImportRequest(
    $dataImportRequestId: ID!
    $folderImportRequestId: ID!
    $files: [FileItemInput!]!
  ) {
    trackFilesForFolderImportRequest(
      dataImportRequestId: $dataImportRequestId
      folderImportRequestId: $folderImportRequestId
      files: $files
    )
  }
`);
gql(`
  mutation CreateFileV2($input: CreateFileInput!) {
    createFileV2(input: $input) {
      file {
        __typename
        ... on AssetFile { id }
        ... on ImageFile { id }
        ... on ObjFile { id }
        ... on Ortho2dFile { id }
        ... on Tileset3dFile { id }
      }
      node {
        __typename
        id
      }
    }
  }
`);
gql(`
  mutation LogIn($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      bearerToken
    }
  }
`);
const CREATE_FILE = gql(`
  mutation CreateFile(
    $accountId: ID!
    $bucket: String!
    $fileId: ID!
    $fileKind: FileKindInput!
    $key: String!
    $name: String!
    $size: Float!
    $type: String!
  ) {
    createFile(
      accountId: $accountId
      bucket: $bucket
      fileId: $fileId
      fileKind: $fileKind
      key: $key
      name: $name
      size: $size
      type: $type
    ) {
      __typename
      ... on AssetFile { id }
      ... on ImageFile { id }
      ... on ObjFile { id }
      ... on Ortho2dFile { id }
      ... on Tileset3dFile { id }
    }
  }
`), CREATE_MULTIPART_UPLOAD = gql(`
  mutation CreateMultipartUpload($fileName: String!) {
    createMultipartUpload(fileName: $fileName) {
      bucket
      fileId
      key
      uploadId
    }
  }
`), CREATE_PRESIGNED_UPLOAD_PART_URL = gql(`
  mutation CreatePresignedUploadPartUrl(
    $bucket: String!
    $key: String!
    $partNumber: Int!
    $uploadId: String!
  ) {
    createPresignedUploadPartUrl(
      bucket: $bucket
      key: $key
      partNumber: $partNumber
      uploadId: $uploadId
    )
  }
`), COMPLETE_MULTIPART_UPLOAD = gql(`
  mutation CompleteMultipartUpload(
    $bucket: String!
    $key: String!
    $parts: [MultiPartInput!]!
    $uploadId: String!
  ) {
    completeMultipartUpload(
      bucket: $bucket
      key: $key
      parts: $parts
      uploadId: $uploadId
    )
  }
`), ABORT_MULTIPART_UPLOAD = gql(`
  mutation AbortMultiPartUpload(
    $bucket: String!
    $key: String!
    $uploadId: String!
  ) {
    abortMultipartUpload(
      bucket: $bucket
      key: $key
      uploadId: $uploadId
    )
  }
`), CREATE_IMAGE_THUMBNAILS_FOR_PERSISTED_IMAGES_BY_IDS = gql(`
mutation CreateImageThumbnailsForPersistedImagesByIds($fileIds: [ID]!) {
  createImageThumbnailsForPersistedImagesByIds(fileIds: $fileIds)
}
`), CREATE_MULTIPART_UPLOAD_FOR_FILE_IMPORT_REQUEST = gql(`
  mutation CreateMultipartUploadForFileImportRequest($dataImportRequestId: ID!, $fileImportRequestId: ID!) {
    createMultipartUploadForFileImportRequest(dataImportRequestId: $dataImportRequestId, fileImportRequestId: $fileImportRequestId) {
      bucket
      key
      uploadId
    }
  }
`), CREATE_PRESIGNED_UPLOAD_PART_URL_FOR_FILE_IMPORT_REQUEST = gql(`
  mutation CreatePresignedPartUrlForFileImportRequest(
    $bucket: String!
    $key: String!
    $partNumber: Int!
    $uploadId: String!
  ) {
    createPresignedPartUrlForFileImportRequest(
      bucket: $bucket
      key: $key
      partNumber: $partNumber
      uploadId: $uploadId
    )
  }
`), COMPLETE_MULTIPART_UPLOAD_FOR_FILE_IMPORT_REQUEST = gql(`
  mutation CompleteMultipartUploadForFileImportRequest(
    $bucket: String!
    $key: String!
    $parts: [MultiPartInput!]!
    $uploadId: String!
  ) {
    completeMultipartUploadForFileImportRequest(
      bucket: $bucket
      key: $key
      parts: $parts
      uploadId: $uploadId
    )
  }
`), ABORT_MULTIPART_UPLOAD_FOR_FILE_IMPORT_REQUEST = gql(`
  mutation AbortMultipartUploadForFileImportRequest(
    $bucket: String!
    $key: String!
    $uploadId: String!
  ) {
    abortMultipartUpload(
      bucket: $bucket
      key: $key
      uploadId: $uploadId
    )
  }
`), RequestContext = createContext(
  null
  // request has to be provided all the time
), RequestContextProvider = RequestContext.Provider, useCreateFile = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_FILE, variables), "mutationFn")
  });
}, "useCreateFile"), useUppyEvents = /* @__PURE__ */ __name((uppy) => {
  const eventListeners = useState(() => ({
    addFiles: /* @__PURE__ */ new Set(),
    complete: /* @__PURE__ */ new Set(),
    progress: /* @__PURE__ */ new Set(),
    uploadProgress: /* @__PURE__ */ new Set(),
    uploadSuccess: /* @__PURE__ */ new Set(),
    createSuccess: /* @__PURE__ */ new Set(),
    dirCreating: /* @__PURE__ */ new Set(),
    dirCreated: /* @__PURE__ */ new Set(),
    dirFinding: /* @__PURE__ */ new Set(),
    dirFound: /* @__PURE__ */ new Set(),
    folderTracking: /* @__PURE__ */ new Set(),
    folderTracked: /* @__PURE__ */ new Set(),
    fileTracking: /* @__PURE__ */ new Set(),
    fileTracked: /* @__PURE__ */ new Set(),
    folderImporting: /* @__PURE__ */ new Set(),
    folderImported: /* @__PURE__ */ new Set(),
    fileImporting: /* @__PURE__ */ new Set(),
    fileImported: /* @__PURE__ */ new Set(),
    reset: /* @__PURE__ */ new Set(),
    updateGraph: /* @__PURE__ */ new Set(),
    updateStage: /* @__PURE__ */ new Set(),
    error: /* @__PURE__ */ new Set(),
    uploadError: /* @__PURE__ */ new Set(),
    uppyError: /* @__PURE__ */ new Set()
  }))[0], on = useCallback(
    (eventName, callback) => {
      eventListeners[eventName].add(callback);
    },
    [eventListeners]
  ), off = useCallback(
    (eventName, callback) => {
      eventListeners[eventName].delete(callback);
    },
    [eventListeners]
  ), emit2 = useCallback(
    (eventName, args) => {
      const listeners = eventListeners[eventName];
      for (const listener of listeners)
        listener(args);
    },
    [eventListeners]
  );
  return useEffect(() => {
    const onFilesAdded = /* @__PURE__ */ __name((files) => {
      emit2(
        "addFiles",
        files.map((file) => ({ file: file.data, fileId: file.id }))
      );
    }, "onFilesAdded"), onComplete = /* @__PURE__ */ __name((result2) => {
      const failed = result2.failed.map((file) => ({
        error: file.error,
        file: file.data,
        fileId: file.id
      })), successful = result2.successful.map((file) => ({
        file: file.data,
        fileId: file.id,
        uploadUrl: file.uploadURL
      }));
      emit2("complete", { failed, successful });
    }, "onComplete"), onProgress = /* @__PURE__ */ __name((progress) => {
      emit2("progress", { progress });
    }, "onProgress"), onUploadProgress = /* @__PURE__ */ __name((file, progress) => {
      const ratio = progress.bytesUploaded / progress.bytesTotal;
      emit2("uploadProgress", {
        bytesTotal: progress.bytesTotal,
        bytesUploaded: progress.bytesUploaded,
        file: file.data,
        fileId: file.id,
        progress: ratio
      });
    }, "onUploadProgress"), onUploadSuccess = /* @__PURE__ */ __name((file) => {
      emit2("uploadSuccess", { file: file.data, fileId: file.id });
    }, "onUploadSuccess"), onUploadError = /* @__PURE__ */ __name((file, error) => {
      emit2("uploadError", { file: file.data, fileId: file.id, error });
    }, "onUploadError"), onUppyError = /* @__PURE__ */ __name((error) => {
      emit2("uppyError", { error }), emit2("error", { error });
    }, "onUppyError");
    return uppy.on("complete", onComplete), uppy.on("files-added", onFilesAdded), uppy.on("progress", onProgress), uppy.on("upload-progress", onUploadProgress), uppy.on("upload-success", onUploadSuccess), uppy.on("upload-error", onUploadError), uppy.on("error", onUppyError), () => {
      uppy.off("complete", onComplete), uppy.off("files-added", onFilesAdded), uppy.off("progress", onProgress), uppy.off("upload-progress", onUploadProgress), uppy.off("upload-success", onUploadSuccess), uppy.off("upload-error", onUploadError);
    };
  }, [emit2, eventListeners, uppy]), {
    emit: emit2,
    off,
    on
  };
}, "useUppyEvents");
function has$1(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}
__name(has$1, "has$1");
function _classPrivateFieldLooseBase$u(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$u, "_classPrivateFieldLooseBase$u");
var id$u = 0;
function _classPrivateFieldLooseKey$u(name) {
  return "__private_" + id$u++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$u, "_classPrivateFieldLooseKey$u");
function insertReplacement(source, rx, replacement) {
  const newParts = [];
  return source.forEach((chunk2) => typeof chunk2 != "string" ? newParts.push(chunk2) : rx[Symbol.split](chunk2).forEach((raw, i2, list) => {
    raw !== "" && newParts.push(raw), i2 < list.length - 1 && newParts.push(replacement);
  })), newParts;
}
__name(insertReplacement, "insertReplacement");
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param {string} phrase that needs interpolation, with placeholders
 * @param {object} options with values that will be used to replace placeholders
 * @returns {any[]} interpolated
 */
function interpolate(phrase, options) {
  const dollarRegex = /\$/g, dollarBillsYall = "$$$$";
  let interpolated = [phrase];
  if (options == null) return interpolated;
  for (const arg of Object.keys(options))
    if (arg !== "_") {
      let replacement = options[arg];
      typeof replacement == "string" && (replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall)), interpolated = insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, "g"), replacement);
    }
  return interpolated;
}
__name(interpolate, "interpolate");
var _apply = /* @__PURE__ */ _classPrivateFieldLooseKey$u("apply");
const _Translator = class _Translator {
  /**
   * @param {object|Array<object>} locales - locale or list of locales.
   */
  constructor(locales) {
    Object.defineProperty(this, _apply, {
      value: _apply2
    }), this.locale = {
      strings: {},
      pluralize(n2) {
        return n2 === 1 ? 0 : 1;
      }
    }, Array.isArray(locales) ? locales.forEach(_classPrivateFieldLooseBase$u(this, _apply)[_apply], this) : _classPrivateFieldLooseBase$u(this, _apply)[_apply](locales);
  }
  /**
   * Public translate method
   *
   * @param {string} key
   * @param {object} options with values that will be used later to replace placeholders in string
   * @returns {string} translated (and interpolated)
   */
  translate(key, options) {
    return this.translateArray(key, options).join("");
  }
  /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @param {string} key
   * @param {object} options with values that will be used to replace placeholders
   * @returns {Array} The translated and interpolated parts, in order.
   */
  translateArray(key, options) {
    if (!has$1(this.locale.strings, key))
      throw new Error(`missing string: ${key}`);
    const string = this.locale.strings[key];
    if (typeof string == "object") {
      if (options && typeof options.smart_count < "u") {
        const plural = this.locale.pluralize(options.smart_count);
        return interpolate(string[plural], options);
      }
      throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
    }
    return interpolate(string, options);
  }
};
__name(_Translator, "Translator");
let Translator = _Translator;
function _apply2(locale2) {
  if (!(locale2 != null && locale2.strings))
    return;
  const prevLocale = this.locale;
  this.locale = {
    ...prevLocale,
    strings: {
      ...prevLocale.strings,
      ...locale2.strings
    }
  }, this.locale.pluralize = locale2.pluralize || prevLocale.pluralize;
}
__name(_apply2, "_apply2");
var namespaceEmitter = /* @__PURE__ */ __name(function() {
  var emitter = {}, _fns = emitter._fns = {};
  emitter.emit = /* @__PURE__ */ __name(function(event, arg1, arg2, arg3, arg4, arg5, arg6) {
    var toEmit = getListeners(event);
    toEmit.length && emitAll(event, toEmit, [arg1, arg2, arg3, arg4, arg5, arg6]);
  }, "emit"), emitter.on = /* @__PURE__ */ __name(function(event, fn) {
    _fns[event] || (_fns[event] = []), _fns[event].push(fn);
  }, "on"), emitter.once = /* @__PURE__ */ __name(function(event, fn) {
    function one() {
      fn.apply(this, arguments), emitter.off(event, one);
    }
    __name(one, "one"), this.on(event, one);
  }, "once"), emitter.off = /* @__PURE__ */ __name(function(event, fn) {
    var keep = [];
    if (event && fn) {
      var fns = this._fns[event], i2 = 0, l2 = fns ? fns.length : 0;
      for (i2; i2 < l2; i2++)
        fns[i2] !== fn && keep.push(fns[i2]);
    }
    keep.length ? this._fns[event] = keep : delete this._fns[event];
  }, "off");
  function getListeners(e2) {
    var out = _fns[e2] ? _fns[e2] : [], idx = e2.indexOf(":"), args = idx === -1 ? [e2] : [e2.substring(0, idx), e2.substring(idx + 1)], keys = Object.keys(_fns), i2 = 0, l2 = keys.length;
    for (i2; i2 < l2; i2++) {
      var key = keys[i2];
      if (key === "*" && (out = out.concat(_fns[key])), args.length === 2 && args[0] === key) {
        out = out.concat(_fns[key]);
        break;
      }
    }
    return out;
  }
  __name(getListeners, "getListeners");
  function emitAll(e2, fns, args) {
    var i2 = 0, l2 = fns.length;
    for (i2; i2 < l2 && fns[i2]; i2++)
      fns[i2].event = e2, fns[i2].apply(fns[i2], args);
  }
  return __name(emitAll, "emitAll"), emitter;
}, "createNamespaceEmitter");
const ee$1 = /* @__PURE__ */ getDefaultExportFromCjs(namespaceEmitter);
let urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", nanoid = /* @__PURE__ */ __name((size = 21) => {
  let id2 = "", i2 = size;
  for (; i2--; )
    id2 += urlAlphabet[Math.random() * 64 | 0];
  return id2;
}, "nanoid");
function isObject$6(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
__name(isObject$6, "isObject$6");
var isObject_1 = isObject$6, freeGlobal$2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$2, freeGlobal$1 = _freeGlobal, freeSelf$1 = typeof self == "object" && self && self.Object === Object && self, root$3 = freeGlobal$1 || freeSelf$1 || Function("return this")(), _root = root$3, root$2 = _root, now$1 = /* @__PURE__ */ __name(function() {
  return root$2.Date.now();
}, "now$1"), now_1 = now$1, reWhitespace$1 = /\s/;
function trimmedEndIndex$2(string) {
  for (var index = string.length; index-- && reWhitespace$1.test(string.charAt(index)); )
    ;
  return index;
}
__name(trimmedEndIndex$2, "trimmedEndIndex$2");
var _trimmedEndIndex = trimmedEndIndex$2, trimmedEndIndex$1 = _trimmedEndIndex, reTrimStart$1 = /^\s+/;
function baseTrim$2(string) {
  return string && string.slice(0, trimmedEndIndex$1(string) + 1).replace(reTrimStart$1, "");
}
__name(baseTrim$2, "baseTrim$2");
var _baseTrim = baseTrim$2, root$1 = _root, Symbol$4 = root$1.Symbol, _Symbol = Symbol$4, Symbol$3 = _Symbol, objectProto$3 = Object.prototype, hasOwnProperty$3 = objectProto$3.hasOwnProperty, nativeObjectToString$3 = objectProto$3.toString, symToStringTag$3 = Symbol$3 ? Symbol$3.toStringTag : void 0;
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag$3), tag = value[symToStringTag$3];
  try {
    value[symToStringTag$3] = void 0;
    var unmasked = !0;
  } catch {
  }
  var result2 = nativeObjectToString$3.call(value);
  return unmasked && (isOwn ? value[symToStringTag$3] = tag : delete value[symToStringTag$3]), result2;
}
__name(getRawTag$2, "getRawTag$2");
var _getRawTag = getRawTag$2, objectProto$2 = Object.prototype, nativeObjectToString$2 = objectProto$2.toString;
function objectToString$2(value) {
  return nativeObjectToString$2.call(value);
}
__name(objectToString$2, "objectToString$2");
var _objectToString = objectToString$2, Symbol$2 = _Symbol, getRawTag$1 = _getRawTag, objectToString$1 = _objectToString, nullTag$1 = "[object Null]", undefinedTag$1 = "[object Undefined]", symToStringTag$2 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag$2(value) {
  return value == null ? value === void 0 ? undefinedTag$1 : nullTag$1 : symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$1(value) : objectToString$1(value);
}
__name(baseGetTag$2, "baseGetTag$2");
var _baseGetTag = baseGetTag$2;
function isObjectLike$2(value) {
  return value != null && typeof value == "object";
}
__name(isObjectLike$2, "isObjectLike$2");
var isObjectLike_1 = isObjectLike$2, baseGetTag$1 = _baseGetTag, isObjectLike$1 = isObjectLike_1, symbolTag$1 = "[object Symbol]";
function isSymbol$2(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && baseGetTag$1(value) == symbolTag$1;
}
__name(isSymbol$2, "isSymbol$2");
var isSymbol_1 = isSymbol$2, baseTrim$1 = _baseTrim, isObject$5 = isObject_1, isSymbol$1 = isSymbol_1, NAN$1 = NaN, reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i, reIsBinary$1 = /^0b[01]+$/i, reIsOctal$1 = /^0o[0-7]+$/i, freeParseInt$1 = parseInt;
function toNumber$2(value) {
  if (typeof value == "number")
    return value;
  if (isSymbol$1(value))
    return NAN$1;
  if (isObject$5(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$5(other) ? other + "" : other;
  }
  if (typeof value != "string")
    return value === 0 ? value : +value;
  value = baseTrim$1(value);
  var isBinary = reIsBinary$1.test(value);
  return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}
__name(toNumber$2, "toNumber$2");
var toNumber_1 = toNumber$2, isObject$4 = isObject_1, now = now_1, toNumber$1 = toNumber_1, FUNC_ERROR_TEXT$1 = "Expected a function", nativeMax$1 = Math.max, nativeMin = Math.min;
function debounce$2(func, wait, options) {
  var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = !1, maxing = !1, trailing = !0;
  if (typeof func != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  wait = toNumber$1(wait) || 0, isObject$4(options) && (leading = !!options.leading, maxing = "maxWait" in options, maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait, trailing = "trailing" in options ? !!options.trailing : trailing);
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    return lastArgs = lastThis = void 0, lastInvokeTime = time, result2 = func.apply(thisArg, args), result2;
  }
  __name(invokeFunc, "invokeFunc");
  function leadingEdge(time) {
    return lastInvokeTime = time, timerId = setTimeout(timerExpired, wait), leading ? invokeFunc(time) : result2;
  }
  __name(leadingEdge, "leadingEdge");
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  __name(remainingWait, "remainingWait");
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  __name(shouldInvoke, "shouldInvoke");
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time))
      return trailingEdge(time);
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  __name(timerExpired, "timerExpired");
  function trailingEdge(time) {
    return timerId = void 0, trailing && lastArgs ? invokeFunc(time) : (lastArgs = lastThis = void 0, result2);
  }
  __name(trailingEdge, "trailingEdge");
  function cancel2() {
    timerId !== void 0 && clearTimeout(timerId), lastInvokeTime = 0, lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  __name(cancel2, "cancel");
  function flush() {
    return timerId === void 0 ? result2 : trailingEdge(now());
  }
  __name(flush, "flush");
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    if (lastArgs = arguments, lastThis = this, lastCallTime = time, isInvoking) {
      if (timerId === void 0)
        return leadingEdge(lastCallTime);
      if (maxing)
        return clearTimeout(timerId), timerId = setTimeout(timerExpired, wait), invokeFunc(lastCallTime);
    }
    return timerId === void 0 && (timerId = setTimeout(timerExpired, wait)), result2;
  }
  return __name(debounced, "debounced"), debounced.cancel = cancel2, debounced.flush = flush, debounced;
}
__name(debounce$2, "debounce$2");
var debounce_1 = debounce$2;
const debounce$3 = /* @__PURE__ */ getDefaultExportFromCjs(debounce_1);
var debounce$1 = debounce_1, isObject$3 = isObject_1, FUNC_ERROR_TEXT = "Expected a function";
function throttle$1(func, wait, options) {
  var leading = !0, trailing = !0;
  if (typeof func != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return isObject$3(options) && (leading = "leading" in options ? !!options.leading : leading, trailing = "trailing" in options ? !!options.trailing : trailing), debounce$1(func, wait, {
    leading,
    maxWait: wait,
    trailing
  });
}
__name(throttle$1, "throttle$1");
var throttle_1 = throttle$1;
const throttle$2 = /* @__PURE__ */ getDefaultExportFromCjs(throttle_1);
function _classPrivateFieldLooseBase$t(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$t, "_classPrivateFieldLooseBase$t");
var id$t = 0;
function _classPrivateFieldLooseKey$t(name) {
  return "__private_" + id$t++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$t, "_classPrivateFieldLooseKey$t");
const packageJson$y = {
  version: "3.0.3"
};
var _callbacks = /* @__PURE__ */ _classPrivateFieldLooseKey$t("callbacks"), _publish = /* @__PURE__ */ _classPrivateFieldLooseKey$t("publish");
const _DefaultStore = class _DefaultStore {
  constructor() {
    Object.defineProperty(this, _publish, {
      value: _publish2
    }), Object.defineProperty(this, _callbacks, {
      writable: !0,
      value: /* @__PURE__ */ new Set()
    }), this.state = {};
  }
  getState() {
    return this.state;
  }
  setState(patch) {
    const prevState = {
      ...this.state
    }, nextState = {
      ...this.state,
      ...patch
    };
    this.state = nextState, _classPrivateFieldLooseBase$t(this, _publish)[_publish](prevState, nextState, patch);
  }
  subscribe(listener) {
    return _classPrivateFieldLooseBase$t(this, _callbacks)[_callbacks].add(listener), () => {
      _classPrivateFieldLooseBase$t(this, _callbacks)[_callbacks].delete(listener);
    };
  }
};
__name(_DefaultStore, "DefaultStore");
let DefaultStore = _DefaultStore;
function _publish2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
    args[_key] = arguments[_key];
  _classPrivateFieldLooseBase$t(this, _callbacks)[_callbacks].forEach((listener) => {
    listener(...args);
  });
}
__name(_publish2, "_publish2");
DefaultStore.VERSION = packageJson$y.version;
function getFileNameAndExtension(fullFileName) {
  const lastDot = fullFileName.lastIndexOf(".");
  return lastDot === -1 || lastDot === fullFileName.length - 1 ? {
    name: fullFileName,
    extension: void 0
  } : {
    name: fullFileName.slice(0, lastDot),
    extension: fullFileName.slice(lastDot + 1)
  };
}
__name(getFileNameAndExtension, "getFileNameAndExtension");
const mimeTypes = {
  md: "text/markdown",
  markdown: "text/markdown",
  mp4: "video/mp4",
  mp3: "audio/mp3",
  svg: "image/svg+xml",
  jpg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  gif: "image/gif",
  heic: "image/heic",
  heif: "image/heif",
  yaml: "text/yaml",
  yml: "text/yaml",
  csv: "text/csv",
  tsv: "text/tab-separated-values",
  tab: "text/tab-separated-values",
  avi: "video/x-msvideo",
  mks: "video/x-matroska",
  mkv: "video/x-matroska",
  mov: "video/quicktime",
  dicom: "application/dicom",
  doc: "application/msword",
  docm: "application/vnd.ms-word.document.macroenabled.12",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  dot: "application/msword",
  dotm: "application/vnd.ms-word.template.macroenabled.12",
  dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  xla: "application/vnd.ms-excel",
  xlam: "application/vnd.ms-excel.addin.macroenabled.12",
  xlc: "application/vnd.ms-excel",
  xlf: "application/x-xliff+xml",
  xlm: "application/vnd.ms-excel",
  xls: "application/vnd.ms-excel",
  xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
  xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xlt: "application/vnd.ms-excel",
  xltm: "application/vnd.ms-excel.template.macroenabled.12",
  xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  xlw: "application/vnd.ms-excel",
  txt: "text/plain",
  text: "text/plain",
  conf: "text/plain",
  log: "text/plain",
  pdf: "application/pdf",
  zip: "application/zip",
  "7z": "application/x-7z-compressed",
  rar: "application/x-rar-compressed",
  tar: "application/x-tar",
  gz: "application/gzip",
  dmg: "application/x-apple-diskimage"
};
function getFileType(file) {
  var _getFileNameAndExtens;
  if (file.type) return file.type;
  const fileExtension = file.name ? (_getFileNameAndExtens = getFileNameAndExtension(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
  return fileExtension && fileExtension in mimeTypes ? mimeTypes[fileExtension] : "application/octet-stream";
}
__name(getFileType, "getFileType");
function encodeCharacter(character) {
  return character.charCodeAt(0).toString(32);
}
__name(encodeCharacter, "encodeCharacter");
function encodeFilename(name) {
  let suffix = "";
  return name.replace(/[^A-Z0-9]/ig, (character) => (suffix += `-${encodeCharacter(character)}`, "/")) + suffix;
}
__name(encodeFilename, "encodeFilename");
function generateFileID(file) {
  let id2 = "uppy";
  return typeof file.name == "string" && (id2 += `-${encodeFilename(file.name.toLowerCase())}`), file.type !== void 0 && (id2 += `-${file.type}`), file.meta && typeof file.meta.relativePath == "string" && (id2 += `-${encodeFilename(file.meta.relativePath.toLowerCase())}`), file.data.size !== void 0 && (id2 += `-${file.data.size}`), file.data.lastModified !== void 0 && (id2 += `-${file.data.lastModified}`), id2;
}
__name(generateFileID, "generateFileID");
function hasFileStableId(file) {
  return !file.isRemote || !file.remote ? !1 : (/* @__PURE__ */ new Set(["box", "dropbox", "drive", "facebook", "unsplash"])).has(file.remote.provider);
}
__name(hasFileStableId, "hasFileStableId");
function getSafeFileId(file) {
  if (hasFileStableId(file)) return file.id;
  const fileType = getFileType(file);
  return generateFileID({
    ...file,
    type: fileType
  });
}
__name(getSafeFileId, "getSafeFileId");
function supportsUploadProgress(userAgent) {
  if (userAgent == null && typeof navigator < "u" && (userAgent = navigator.userAgent), !userAgent) return !0;
  const m2 = /Edge\/(\d+\.\d+)/.exec(userAgent);
  if (!m2) return !0;
  const edgeVersion = m2[1];
  let [major, minor] = edgeVersion.split(".");
  return major = parseInt(major, 10), minor = parseInt(minor, 10), major < 15 || major === 15 && minor < 15063 || major > 18 || major === 18 && minor >= 18218;
}
__name(supportsUploadProgress, "supportsUploadProgress");
function getFileName(fileType, fileDescriptor) {
  return fileDescriptor.name ? fileDescriptor.name : fileType.split("/")[0] === "image" ? `${fileType.split("/")[0]}.${fileType.split("/")[1]}` : "noname";
}
__name(getFileName, "getFileName");
function pad(number) {
  return number < 10 ? `0${number}` : number.toString();
}
__name(pad, "pad");
function getTimeStamp() {
  const date = /* @__PURE__ */ new Date(), hours = pad(date.getHours()), minutes = pad(date.getMinutes()), seconds = pad(date.getSeconds());
  return `${hours}:${minutes}:${seconds}`;
}
__name(getTimeStamp, "getTimeStamp");
const justErrorsLogger = {
  debug: /* @__PURE__ */ __name(() => {
  }, "debug"),
  warn: /* @__PURE__ */ __name(() => {
  }, "warn"),
  error: /* @__PURE__ */ __name(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
      args[_key] = arguments[_key];
    return console.error(`[Uppy] [${getTimeStamp()}]`, ...args);
  }, "error")
}, debugLogger = {
  debug: /* @__PURE__ */ __name(function() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)
      args[_key2] = arguments[_key2];
    return console.debug(`[Uppy] [${getTimeStamp()}]`, ...args);
  }, "debug"),
  warn: /* @__PURE__ */ __name(function() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)
      args[_key3] = arguments[_key3];
    return console.warn(`[Uppy] [${getTimeStamp()}]`, ...args);
  }, "warn"),
  error: /* @__PURE__ */ __name(function() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)
      args[_key4] = arguments[_key4];
    return console.error(`[Uppy] [${getTimeStamp()}]`, ...args);
  }, "error")
};
var prettierBytes$2 = /* @__PURE__ */ __name(function(num) {
  if (typeof num != "number" || isNaN(num))
    throw new TypeError(`Expected a number, got ${typeof num}`);
  const neg = num < 0, units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  if (neg && (num = -num), num < 1)
    return `${(neg ? "-" : "") + num} B`;
  const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
  num = Number(num / Math.pow(1024, exponent));
  const unit = units[exponent];
  return num >= 10 || num % 1 === 0 ? `${(neg ? "-" : "") + num.toFixed(0)} ${unit}` : `${(neg ? "-" : "") + num.toFixed(1)} ${unit}`;
}, "prettierBytes");
const prettierBytes$3 = /* @__PURE__ */ getDefaultExportFromCjs(prettierBytes$2);
function WildcardMatcher(text, separator2) {
  this.text = text = text || "", this.hasWild = ~text.indexOf("*"), this.separator = separator2, this.parts = text.split(separator2);
}
__name(WildcardMatcher, "WildcardMatcher");
WildcardMatcher.prototype.match = function(input) {
  var matches2 = !0, parts = this.parts, ii, partsCount = parts.length, testParts;
  if (typeof input == "string" || input instanceof String)
    if (!this.hasWild && this.text != input)
      matches2 = !1;
    else {
      for (testParts = (input || "").split(this.separator), ii = 0; matches2 && ii < partsCount; ii++)
        parts[ii] !== "*" && (ii < testParts.length ? matches2 = parts[ii] === testParts[ii] : matches2 = !1);
      matches2 = matches2 && testParts;
    }
  else if (typeof input.splice == "function")
    for (matches2 = [], ii = input.length; ii--; )
      this.match(input[ii]) && (matches2[matches2.length] = input[ii]);
  else if (typeof input == "object") {
    matches2 = {};
    for (var key in input)
      this.match(key) && (matches2[key] = input[key]);
  }
  return matches2;
};
var wildcard$1 = /* @__PURE__ */ __name(function(text, test, separator2) {
  var matcher = new WildcardMatcher(text, separator2 || /[\/\.]/);
  return typeof test < "u" ? matcher.match(test) : matcher;
}, "wildcard$1"), wildcard = wildcard$1, reMimePartSplit = /[\/\+\.]/, mimeMatch = /* @__PURE__ */ __name(function(target, pattern) {
  function test(pattern2) {
    var result2 = wildcard(pattern2, target, reMimePartSplit);
    return result2 && result2.length >= 2;
  }
  return __name(test, "test"), pattern ? test(pattern.split(";")[0]) : test;
}, "mimeMatch");
const match = /* @__PURE__ */ getDefaultExportFromCjs(mimeMatch), defaultOptions$4 = {
  maxFileSize: null,
  minFileSize: null,
  maxTotalFileSize: null,
  maxNumberOfFiles: null,
  minNumberOfFiles: null,
  allowedFileTypes: null,
  requiredMetaFields: []
}, _RestrictionError = class _RestrictionError extends Error {
  constructor(message, _temp) {
    let {
      isUserFacing = !0,
      file
    } = _temp === void 0 ? {} : _temp;
    super(message), this.isRestriction = !0, this.isUserFacing = isUserFacing, file != null && (this.file = file);
  }
};
__name(_RestrictionError, "RestrictionError");
let RestrictionError = _RestrictionError;
const _Restricter = class _Restricter {
  constructor(getOpts, i18n) {
    this.i18n = i18n, this.getOpts = () => {
      const opts = getOpts();
      if (opts.restrictions.allowedFileTypes != null && !Array.isArray(opts.restrictions.allowedFileTypes))
        throw new TypeError("`restrictions.allowedFileTypes` must be an array");
      return opts;
    };
  }
  // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
  validateAggregateRestrictions(existingFiles, addingFiles) {
    const {
      maxTotalFileSize,
      maxNumberOfFiles
    } = this.getOpts().restrictions;
    if (maxNumberOfFiles && existingFiles.filter((f2) => !f2.isGhost).length + addingFiles.length > maxNumberOfFiles)
      throw new RestrictionError(`${this.i18n("youCanOnlyUploadX", {
        smart_count: maxNumberOfFiles
      })}`);
    if (maxTotalFileSize) {
      let totalFilesSize = existingFiles.reduce((total, f2) => total + f2.size, 0);
      for (const addingFile of addingFiles)
        if (addingFile.size != null && (totalFilesSize += addingFile.size, totalFilesSize > maxTotalFileSize))
          throw new RestrictionError(this.i18n("exceedsSize", {
            size: prettierBytes$3(maxTotalFileSize),
            file: addingFile.name
          }));
    }
  }
  validateSingleFile(file) {
    const {
      maxFileSize,
      minFileSize,
      allowedFileTypes
    } = this.getOpts().restrictions;
    if (allowedFileTypes && !allowedFileTypes.some((type) => type.includes("/") ? file.type ? match(file.type.replace(/;.*?$/, ""), type) : !1 : type[0] === "." && file.extension ? file.extension.toLowerCase() === type.slice(1).toLowerCase() : !1)) {
      const allowedFileTypesString = allowedFileTypes.join(", ");
      throw new RestrictionError(this.i18n("youCanOnlyUploadFileTypes", {
        types: allowedFileTypesString
      }), {
        file
      });
    }
    if (maxFileSize && file.size != null && file.size > maxFileSize)
      throw new RestrictionError(this.i18n("exceedsSize", {
        size: prettierBytes$3(maxFileSize),
        file: file.name
      }), {
        file
      });
    if (minFileSize && file.size != null && file.size < minFileSize)
      throw new RestrictionError(this.i18n("inferiorSize", {
        size: prettierBytes$3(minFileSize)
      }), {
        file
      });
  }
  validate(existingFiles, addingFiles) {
    addingFiles.forEach((addingFile) => {
      this.validateSingleFile(addingFile);
    }), this.validateAggregateRestrictions(existingFiles, addingFiles);
  }
  validateMinNumberOfFiles(files) {
    const {
      minNumberOfFiles
    } = this.getOpts().restrictions;
    if (Object.keys(files).length < minNumberOfFiles)
      throw new RestrictionError(this.i18n("youHaveToAtLeastSelectX", {
        smart_count: minNumberOfFiles
      }));
  }
  getMissingRequiredMetaFields(file) {
    const error = new RestrictionError(this.i18n("missingRequiredMetaFieldOnFile", {
      fileName: file.name
    })), {
      requiredMetaFields
    } = this.getOpts().restrictions, missingFields = [];
    for (const field of requiredMetaFields)
      (!Object.hasOwn(file.meta, field) || file.meta[field] === "") && missingFields.push(field);
    return {
      missingFields,
      error
    };
  }
};
__name(_Restricter, "Restricter");
let Restricter = _Restricter;
const locale$k = {
  strings: {
    addBulkFilesFailed: {
      0: "Failed to add %{smart_count} file due to an internal error",
      1: "Failed to add %{smart_count} files due to internal errors"
    },
    youCanOnlyUploadX: {
      0: "You can only upload %{smart_count} file",
      1: "You can only upload %{smart_count} files"
    },
    youHaveToAtLeastSelectX: {
      0: "You have to select at least %{smart_count} file",
      1: "You have to select at least %{smart_count} files"
    },
    exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
    missingRequiredMetaField: "Missing required meta fields",
    missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
    inferiorSize: "This file is smaller than the allowed size of %{size}",
    youCanOnlyUploadFileTypes: "You can only upload: %{types}",
    noMoreFilesAllowed: "Cannot add more files",
    noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
    companionError: "Connection with Companion failed",
    authAborted: "Authentication aborted",
    companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
    failedToUpload: "Failed to upload %{file}",
    noInternetConnection: "No Internet connection",
    connectedToInternet: "Connected to the Internet",
    // Strings for remote providers
    noFilesFound: "You have no files or folders here",
    noSearchResults: "Unfortunately, there are no results for this search",
    selectX: {
      0: "Select %{smart_count}",
      1: "Select %{smart_count}"
    },
    allFilesFromFolderNamed: "All files from folder %{name}",
    openFolderNamed: "Open folder %{name}",
    cancel: "Cancel",
    logOut: "Log out",
    filter: "Filter",
    resetFilter: "Reset filter",
    loading: "Loading...",
    loadedXFiles: "Loaded %{numFiles} files",
    authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
    authenticateWith: "Connect to %{pluginName}",
    signInWithGoogle: "Sign in with Google",
    searchImages: "Search for images",
    enterTextToSearch: "Enter text to search for images",
    search: "Search",
    resetSearch: "Reset search",
    emptyFolderAdded: "No files were added from empty folder",
    addedNumFiles: "Added %{numFiles} file(s)",
    folderAlreadyAdded: 'The folder "%{folder}" was already added',
    folderAdded: {
      0: "Added %{smart_count} file from %{folder}",
      1: "Added %{smart_count} files from %{folder}"
    },
    additionalRestrictionsFailed: "%{count} additional restrictions were not fulfilled"
  }
};
let _Symbol$for$5, _Symbol$for2$1;
function _classPrivateFieldLooseBase$s(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$s, "_classPrivateFieldLooseBase$s");
var id$s = 0;
function _classPrivateFieldLooseKey$s(name) {
  return "__private_" + id$s++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$s, "_classPrivateFieldLooseKey$s");
const packageJson$x = {
  version: "3.5.0"
};
var _plugins = /* @__PURE__ */ _classPrivateFieldLooseKey$s("plugins"), _restricter = /* @__PURE__ */ _classPrivateFieldLooseKey$s("restricter"), _storeUnsubscribe = /* @__PURE__ */ _classPrivateFieldLooseKey$s("storeUnsubscribe"), _emitter$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$s("emitter"), _preProcessors = /* @__PURE__ */ _classPrivateFieldLooseKey$s("preProcessors"), _uploaders = /* @__PURE__ */ _classPrivateFieldLooseKey$s("uploaders"), _postProcessors = /* @__PURE__ */ _classPrivateFieldLooseKey$s("postProcessors"), _informAndEmit = /* @__PURE__ */ _classPrivateFieldLooseKey$s("informAndEmit"), _checkRequiredMetaFieldsOnFile = /* @__PURE__ */ _classPrivateFieldLooseKey$s("checkRequiredMetaFieldsOnFile"), _checkRequiredMetaFields = /* @__PURE__ */ _classPrivateFieldLooseKey$s("checkRequiredMetaFields"), _assertNewUploadAllowed = /* @__PURE__ */ _classPrivateFieldLooseKey$s("assertNewUploadAllowed"), _transformFile = /* @__PURE__ */ _classPrivateFieldLooseKey$s("transformFile"), _startIfAutoProceed = /* @__PURE__ */ _classPrivateFieldLooseKey$s("startIfAutoProceed"), _checkAndUpdateFileState = /* @__PURE__ */ _classPrivateFieldLooseKey$s("checkAndUpdateFileState"), _addListeners$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$s("addListeners"), _updateOnlineStatus = /* @__PURE__ */ _classPrivateFieldLooseKey$s("updateOnlineStatus"), _createUpload$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$s("createUpload"), _getUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$s("getUpload"), _removeUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$s("removeUpload"), _runUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$s("runUpload");
_Symbol$for$5 = Symbol.for("uppy test: getPlugins");
_Symbol$for2$1 = Symbol.for("uppy test: createUpload");
const _Uppy = class _Uppy {
  /**
   * Instantiate Uppy
   *
   * @param {object} opts — Uppy options
   */
  constructor(_opts) {
    Object.defineProperty(this, _runUpload, {
      value: _runUpload2
    }), Object.defineProperty(this, _removeUpload, {
      value: _removeUpload2
    }), Object.defineProperty(this, _getUpload, {
      value: _getUpload2
    }), Object.defineProperty(this, _createUpload$1, {
      value: _createUpload2$1
    }), Object.defineProperty(this, _addListeners$1, {
      value: _addListeners2$1
    }), Object.defineProperty(this, _checkAndUpdateFileState, {
      value: _checkAndUpdateFileState2
    }), Object.defineProperty(this, _startIfAutoProceed, {
      value: _startIfAutoProceed2
    }), Object.defineProperty(this, _transformFile, {
      value: _transformFile2
    }), Object.defineProperty(this, _assertNewUploadAllowed, {
      value: _assertNewUploadAllowed2
    }), Object.defineProperty(this, _checkRequiredMetaFields, {
      value: _checkRequiredMetaFields2
    }), Object.defineProperty(this, _checkRequiredMetaFieldsOnFile, {
      value: _checkRequiredMetaFieldsOnFile2
    }), Object.defineProperty(this, _informAndEmit, {
      value: _informAndEmit2
    }), Object.defineProperty(this, _plugins, {
      writable: !0,
      value: /* @__PURE__ */ Object.create(null)
    }), Object.defineProperty(this, _restricter, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _storeUnsubscribe, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _emitter$1, {
      writable: !0,
      value: ee$1()
    }), Object.defineProperty(this, _preProcessors, {
      writable: !0,
      value: /* @__PURE__ */ new Set()
    }), Object.defineProperty(this, _uploaders, {
      writable: !0,
      value: /* @__PURE__ */ new Set()
    }), Object.defineProperty(this, _postProcessors, {
      writable: !0,
      value: /* @__PURE__ */ new Set()
    }), this.calculateProgress = throttle$2((file, data) => {
      const fileInState = this.getFile(file == null ? void 0 : file.id);
      if (file == null || !fileInState) {
        this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
        return;
      }
      if (fileInState.progress.percentage === 100) {
        this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
        return;
      }
      const canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
      this.setFileState(file.id, {
        progress: {
          ...fileInState.progress,
          bytesUploaded: data.bytesUploaded,
          bytesTotal: data.bytesTotal,
          percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
        }
      }), this.calculateTotalProgress();
    }, 500, {
      leading: !0,
      trailing: !0
    }), Object.defineProperty(this, _updateOnlineStatus, {
      writable: !0,
      value: this.updateOnlineStatus.bind(this)
    }), this.defaultLocale = locale$k;
    const defaultOptions2 = {
      id: "uppy",
      autoProceed: !1,
      allowMultipleUploadBatches: !0,
      debug: !1,
      restrictions: defaultOptions$4,
      meta: {},
      onBeforeFileAdded: /* @__PURE__ */ __name((file, files) => !Object.hasOwn(files, file.id), "onBeforeFileAdded"),
      onBeforeUpload: /* @__PURE__ */ __name((files) => files, "onBeforeUpload"),
      store: new DefaultStore(),
      logger: justErrorsLogger,
      infoTimeout: 5e3
    };
    this.opts = {
      ...defaultOptions2,
      ..._opts,
      restrictions: {
        ...defaultOptions2.restrictions,
        ..._opts && _opts.restrictions
      }
    }, _opts && _opts.logger && _opts.debug ? this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning") : _opts && _opts.debug && (this.opts.logger = debugLogger), this.log(`Using Core v${this.constructor.VERSION}`), this.i18nInit(), this.store = this.opts.store, this.setState({
      plugins: {},
      files: {},
      currentUploads: {},
      allowNewUpload: !0,
      capabilities: {
        uploadProgress: supportsUploadProgress(),
        individualCancellation: !0,
        resumableUploads: !1
      },
      totalProgress: 0,
      meta: {
        ...this.opts.meta
      },
      info: [],
      recoveredState: null
    }), _classPrivateFieldLooseBase$s(this, _restricter)[_restricter] = new Restricter(() => this.opts, this.i18n), _classPrivateFieldLooseBase$s(this, _storeUnsubscribe)[_storeUnsubscribe] = this.store.subscribe((prevState, nextState, patch) => {
      this.emit("state-update", prevState, nextState, patch), this.updateAll(nextState);
    }), this.opts.debug && typeof window < "u" && (window[this.opts.id] = this), _classPrivateFieldLooseBase$s(this, _addListeners$1)[_addListeners$1]();
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)
      args[_key - 1] = arguments[_key];
    _classPrivateFieldLooseBase$s(this, _emitter$1)[_emitter$1].emit(event, ...args);
  }
  on(event, callback) {
    return _classPrivateFieldLooseBase$s(this, _emitter$1)[_emitter$1].on(event, callback), this;
  }
  once(event, callback) {
    return _classPrivateFieldLooseBase$s(this, _emitter$1)[_emitter$1].once(event, callback), this;
  }
  off(event, callback) {
    return _classPrivateFieldLooseBase$s(this, _emitter$1)[_emitter$1].off(event, callback), this;
  }
  /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */
  updateAll(state) {
    this.iteratePlugins((plugin) => {
      plugin.update(state);
    });
  }
  /**
   * Updates state with a patch
   *
   * @param {object} patch {foo: 'bar'}
   */
  setState(patch) {
    this.store.setState(patch);
  }
  /**
   * Returns current state.
   *
   * @returns {object}
   */
  getState() {
    return this.store.getState();
  }
  patchFilesState(filesWithNewState) {
    const existingFilesState = this.getState().files;
    this.setState({
      files: {
        ...existingFilesState,
        ...Object.fromEntries(Object.entries(filesWithNewState).map((_ref) => {
          let [fileID, newFileState] = _ref;
          return [fileID, {
            ...existingFilesState[fileID],
            ...newFileState
          }];
        }))
      }
    });
  }
  /**
   * Shorthand to set state for a specific file.
   */
  setFileState(fileID, state) {
    if (!this.getState().files[fileID])
      throw new Error(`Can’t set state for ${fileID} (the file could have been removed)`);
    this.patchFilesState({
      [fileID]: state
    });
  }
  i18nInit() {
    const translator = new Translator([this.defaultLocale, this.opts.locale]);
    this.i18n = translator.translate.bind(translator), this.i18nArray = translator.translateArray.bind(translator), this.locale = translator.locale;
  }
  setOptions(newOpts) {
    this.opts = {
      ...this.opts,
      ...newOpts,
      restrictions: {
        ...this.opts.restrictions,
        ...newOpts && newOpts.restrictions
      }
    }, newOpts.meta && this.setMeta(newOpts.meta), this.i18nInit(), newOpts.locale && this.iteratePlugins((plugin) => {
      plugin.setOptions(newOpts);
    }), this.setState();
  }
  resetProgress() {
    const defaultProgress = {
      percentage: 0,
      bytesUploaded: 0,
      uploadComplete: !1,
      uploadStarted: null
    }, files = {
      ...this.getState().files
    }, updatedFiles = {};
    Object.keys(files).forEach((fileID) => {
      updatedFiles[fileID] = {
        ...files[fileID],
        progress: {
          ...files[fileID].progress,
          ...defaultProgress
        }
      };
    }), this.setState({
      files: updatedFiles,
      totalProgress: 0,
      allowNewUpload: !0,
      error: null,
      recoveredState: null
    }), this.emit("reset-progress");
  }
  addPreProcessor(fn) {
    _classPrivateFieldLooseBase$s(this, _preProcessors)[_preProcessors].add(fn);
  }
  removePreProcessor(fn) {
    return _classPrivateFieldLooseBase$s(this, _preProcessors)[_preProcessors].delete(fn);
  }
  addPostProcessor(fn) {
    _classPrivateFieldLooseBase$s(this, _postProcessors)[_postProcessors].add(fn);
  }
  removePostProcessor(fn) {
    return _classPrivateFieldLooseBase$s(this, _postProcessors)[_postProcessors].delete(fn);
  }
  addUploader(fn) {
    _classPrivateFieldLooseBase$s(this, _uploaders)[_uploaders].add(fn);
  }
  removeUploader(fn) {
    return _classPrivateFieldLooseBase$s(this, _uploaders)[_uploaders].delete(fn);
  }
  setMeta(data) {
    const updatedMeta = {
      ...this.getState().meta,
      ...data
    }, updatedFiles = {
      ...this.getState().files
    };
    Object.keys(updatedFiles).forEach((fileID) => {
      updatedFiles[fileID] = {
        ...updatedFiles[fileID],
        meta: {
          ...updatedFiles[fileID].meta,
          ...data
        }
      };
    }), this.log("Adding metadata:"), this.log(data), this.setState({
      meta: updatedMeta,
      files: updatedFiles
    });
  }
  setFileMeta(fileID, data) {
    const updatedFiles = {
      ...this.getState().files
    };
    if (!updatedFiles[fileID]) {
      this.log("Was trying to set metadata for a file that has been removed: ", fileID);
      return;
    }
    const newMeta = {
      ...updatedFiles[fileID].meta,
      ...data
    };
    updatedFiles[fileID] = {
      ...updatedFiles[fileID],
      meta: newMeta
    }, this.setState({
      files: updatedFiles
    });
  }
  /**
   * Get a file object.
   *
   * @param {string} fileID The ID of the file object to return.
   */
  getFile(fileID) {
    return this.getState().files[fileID];
  }
  /**
   * Get all files in an array.
   */
  getFiles() {
    const {
      files
    } = this.getState();
    return Object.values(files);
  }
  getFilesByIds(ids) {
    return ids.map((id2) => this.getFile(id2));
  }
  getObjectOfFilesPerState() {
    const {
      files: filesObject,
      totalProgress,
      error
    } = this.getState(), files = Object.values(filesObject), inProgressFiles = files.filter((_ref2) => {
      let {
        progress
      } = _ref2;
      return !progress.uploadComplete && progress.uploadStarted;
    }), newFiles = files.filter((file) => !file.progress.uploadStarted), startedFiles = files.filter((file) => file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess), uploadStartedFiles = files.filter((file) => file.progress.uploadStarted), pausedFiles = files.filter((file) => file.isPaused), completeFiles = files.filter((file) => file.progress.uploadComplete), erroredFiles = files.filter((file) => file.error), inProgressNotPausedFiles = inProgressFiles.filter((file) => !file.isPaused), processingFiles = files.filter((file) => file.progress.preprocess || file.progress.postprocess);
    return {
      newFiles,
      startedFiles,
      uploadStartedFiles,
      pausedFiles,
      completeFiles,
      erroredFiles,
      inProgressFiles,
      inProgressNotPausedFiles,
      processingFiles,
      isUploadStarted: uploadStartedFiles.length > 0,
      isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
      isAllErrored: !!error && erroredFiles.length === files.length,
      isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
      isUploadInProgress: inProgressFiles.length > 0,
      isSomeGhost: files.some((file) => file.isGhost)
    };
  }
  validateRestrictions(file, files) {
    files === void 0 && (files = this.getFiles());
    try {
      _classPrivateFieldLooseBase$s(this, _restricter)[_restricter].validate(files, [file]);
    } catch (err) {
      return err;
    }
    return null;
  }
  checkIfFileAlreadyExists(fileID) {
    const {
      files
    } = this.getState();
    return !!(files[fileID] && !files[fileID].isGhost);
  }
  /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   *
   * @param {object} file object to add
   * @returns {string} id for the added file
   */
  addFile(file) {
    _classPrivateFieldLooseBase$s(this, _assertNewUploadAllowed)[_assertNewUploadAllowed](file);
    const {
      nextFilesState,
      validFilesToAdd,
      errors
    } = _classPrivateFieldLooseBase$s(this, _checkAndUpdateFileState)[_checkAndUpdateFileState]([file]), restrictionErrors = errors.filter((error) => error.isRestriction);
    if (_classPrivateFieldLooseBase$s(this, _informAndEmit)[_informAndEmit](restrictionErrors), errors.length > 0) throw errors[0];
    this.setState({
      files: nextFilesState
    });
    const [firstValidFileToAdd] = validFilesToAdd;
    return this.emit("file-added", firstValidFileToAdd), this.emit("files-added", validFilesToAdd), this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`), _classPrivateFieldLooseBase$s(this, _startIfAutoProceed)[_startIfAutoProceed](), firstValidFileToAdd.id;
  }
  /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */
  addFiles(fileDescriptors) {
    _classPrivateFieldLooseBase$s(this, _assertNewUploadAllowed)[_assertNewUploadAllowed]();
    const {
      nextFilesState,
      validFilesToAdd,
      errors
    } = _classPrivateFieldLooseBase$s(this, _checkAndUpdateFileState)[_checkAndUpdateFileState](fileDescriptors), restrictionErrors = errors.filter((error) => error.isRestriction);
    _classPrivateFieldLooseBase$s(this, _informAndEmit)[_informAndEmit](restrictionErrors);
    const nonRestrictionErrors = errors.filter((error) => !error.isRestriction);
    if (nonRestrictionErrors.length > 0) {
      let message = `Multiple errors occurred while adding files:
`;
      if (nonRestrictionErrors.forEach((subError) => {
        message += `
 * ${subError.message}`;
      }), this.info({
        message: this.i18n("addBulkFilesFailed", {
          smart_count: nonRestrictionErrors.length
        }),
        details: message
      }, "error", this.opts.infoTimeout), typeof AggregateError == "function")
        throw new AggregateError(nonRestrictionErrors, message);
      {
        const err = new Error(message);
        throw err.errors = nonRestrictionErrors, err;
      }
    }
    this.setState({
      files: nextFilesState
    }), validFilesToAdd.forEach((file) => {
      this.emit("file-added", file);
    }), this.emit("files-added", validFilesToAdd), validFilesToAdd.length > 5 ? this.log(`Added batch of ${validFilesToAdd.length} files`) : Object.values(validFilesToAdd).forEach((file) => {
      this.log(`Added file: ${file.name}
 id: ${file.id}
 type: ${file.type}`);
    }), validFilesToAdd.length > 0 && _classPrivateFieldLooseBase$s(this, _startIfAutoProceed)[_startIfAutoProceed]();
  }
  removeFiles(fileIDs, reason) {
    const {
      files,
      currentUploads
    } = this.getState(), updatedFiles = {
      ...files
    }, updatedUploads = {
      ...currentUploads
    }, removedFiles = /* @__PURE__ */ Object.create(null);
    fileIDs.forEach((fileID) => {
      files[fileID] && (removedFiles[fileID] = files[fileID], delete updatedFiles[fileID]);
    });
    function fileIsNotRemoved(uploadFileID) {
      return removedFiles[uploadFileID] === void 0;
    }
    __name(fileIsNotRemoved, "fileIsNotRemoved"), Object.keys(updatedUploads).forEach((uploadID) => {
      const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
      if (newFileIDs.length === 0) {
        delete updatedUploads[uploadID];
        return;
      }
      const {
        capabilities
      } = this.getState();
      if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation)
        throw new Error("individualCancellation is disabled");
      updatedUploads[uploadID] = {
        ...currentUploads[uploadID],
        fileIDs: newFileIDs
      };
    });
    const stateUpdate = {
      currentUploads: updatedUploads,
      files: updatedFiles
    };
    Object.keys(updatedFiles).length === 0 && (stateUpdate.allowNewUpload = !0, stateUpdate.error = null, stateUpdate.recoveredState = null), this.setState(stateUpdate), this.calculateTotalProgress();
    const removedFileIDs = Object.keys(removedFiles);
    removedFileIDs.forEach((fileID) => {
      this.emit("file-removed", removedFiles[fileID], reason);
    }), removedFileIDs.length > 5 ? this.log(`Removed ${removedFileIDs.length} files`) : this.log(`Removed files: ${removedFileIDs.join(", ")}`);
  }
  removeFile(fileID, reason) {
    reason === void 0 && (reason = null), this.removeFiles([fileID], reason);
  }
  pauseResume(fileID) {
    if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).uploadComplete)
      return;
    const isPaused = !(this.getFile(fileID).isPaused || !1);
    return this.setFileState(fileID, {
      isPaused
    }), this.emit("upload-pause", fileID, isPaused), isPaused;
  }
  pauseAll() {
    const updatedFiles = {
      ...this.getState().files
    };
    Object.keys(updatedFiles).filter((file) => !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted).forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: !0
      };
      updatedFiles[file] = updatedFile;
    }), this.setState({
      files: updatedFiles
    }), this.emit("pause-all");
  }
  resumeAll() {
    const updatedFiles = {
      ...this.getState().files
    };
    Object.keys(updatedFiles).filter((file) => !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted).forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: !1,
        error: null
      };
      updatedFiles[file] = updatedFile;
    }), this.setState({
      files: updatedFiles
    }), this.emit("resume-all");
  }
  retryAll() {
    const updatedFiles = {
      ...this.getState().files
    }, filesToRetry = Object.keys(updatedFiles).filter((file) => updatedFiles[file].error);
    if (filesToRetry.forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: !1,
        error: null
      };
      updatedFiles[file] = updatedFile;
    }), this.setState({
      files: updatedFiles,
      error: null
    }), this.emit("retry-all", filesToRetry), filesToRetry.length === 0)
      return Promise.resolve({
        successful: [],
        failed: []
      });
    const uploadID = _classPrivateFieldLooseBase$s(this, _createUpload$1)[_createUpload$1](filesToRetry, {
      forceAllowNewUpload: !0
      // create new upload even if allowNewUpload: false
    });
    return _classPrivateFieldLooseBase$s(this, _runUpload)[_runUpload](uploadID);
  }
  cancelAll(_temp) {
    let {
      reason = "user"
    } = _temp === void 0 ? {} : _temp;
    if (this.emit("cancel-all", {
      reason
    }), reason === "user") {
      const {
        files
      } = this.getState(), fileIDs = Object.keys(files);
      fileIDs.length && this.removeFiles(fileIDs, "cancel-all"), this.setState({
        totalProgress: 0,
        error: null,
        recoveredState: null
      });
    }
  }
  retryUpload(fileID) {
    this.setFileState(fileID, {
      error: null,
      isPaused: !1
    }), this.emit("upload-retry", fileID);
    const uploadID = _classPrivateFieldLooseBase$s(this, _createUpload$1)[_createUpload$1]([fileID], {
      forceAllowNewUpload: !0
      // create new upload even if allowNewUpload: false
    });
    return _classPrivateFieldLooseBase$s(this, _runUpload)[_runUpload](uploadID);
  }
  logout() {
    this.iteratePlugins((plugin) => {
      plugin.provider && plugin.provider.logout && plugin.provider.logout();
    });
  }
  calculateTotalProgress() {
    const inProgress = this.getFiles().filter((file) => file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess);
    if (inProgress.length === 0) {
      this.emit("progress", 0), this.setState({
        totalProgress: 0
      });
      return;
    }
    const sizedFiles = inProgress.filter((file) => file.progress.bytesTotal != null), unsizedFiles = inProgress.filter((file) => file.progress.bytesTotal == null);
    if (sizedFiles.length === 0) {
      const progressMax = inProgress.length * 100, currentProgress = unsizedFiles.reduce((acc, file) => acc + file.progress.percentage, 0), totalProgress2 = Math.round(currentProgress / progressMax * 100);
      this.setState({
        totalProgress: totalProgress2
      });
      return;
    }
    let totalSize = sizedFiles.reduce((acc, file) => acc + file.progress.bytesTotal, 0);
    const averageSize = totalSize / sizedFiles.length;
    totalSize += averageSize * unsizedFiles.length;
    let uploadedSize = 0;
    sizedFiles.forEach((file) => {
      uploadedSize += file.progress.bytesUploaded;
    }), unsizedFiles.forEach((file) => {
      uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
    });
    let totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100);
    totalProgress > 100 && (totalProgress = 100), this.setState({
      totalProgress
    }), this.emit("progress", totalProgress);
  }
  updateOnlineStatus() {
    (typeof window.navigator.onLine < "u" ? window.navigator.onLine : !0) ? (this.emit("is-online"), this.wasOffline && (this.emit("back-online"), this.info(this.i18n("connectedToInternet"), "success", 3e3), this.wasOffline = !1)) : (this.emit("is-offline"), this.info(this.i18n("noInternetConnection"), "error", 0), this.wasOffline = !0);
  }
  getID() {
    return this.opts.id;
  }
  /**
   * Registers a plugin with Core.
   *
   * @param {object} Plugin object
   * @param {object} [opts] object with options to be passed to Plugin
   * @returns {object} self for chaining
   */
  // eslint-disable-next-line no-shadow
  use(Plugin, opts) {
    if (typeof Plugin != "function") {
      const msg = `Expected a plugin class, but got ${Plugin === null ? "null" : typeof Plugin}. Please verify that the plugin was imported and spelled correctly.`;
      throw new TypeError(msg);
    }
    const plugin = new Plugin(this, opts), pluginId = plugin.id;
    if (!pluginId)
      throw new Error("Your plugin must have an id");
    if (!plugin.type)
      throw new Error("Your plugin must have a type");
    const existsPluginAlready = this.getPlugin(pluginId);
    if (existsPluginAlready) {
      const msg = `Already found a plugin named '${existsPluginAlready.id}'. Tried to use: '${pluginId}'.
Uppy plugins must have unique \`id\` options. See https://uppy.io/docs/plugins/#id.`;
      throw new Error(msg);
    }
    return Plugin.VERSION && this.log(`Using ${pluginId} v${Plugin.VERSION}`), plugin.type in _classPrivateFieldLooseBase$s(this, _plugins)[_plugins] ? _classPrivateFieldLooseBase$s(this, _plugins)[_plugins][plugin.type].push(plugin) : _classPrivateFieldLooseBase$s(this, _plugins)[_plugins][plugin.type] = [plugin], plugin.install(), this;
  }
  /**
   * Find one Plugin by name.
   *
   * @param {string} id plugin id
   * @returns {BasePlugin|undefined}
   */
  getPlugin(id2) {
    for (const plugins of Object.values(_classPrivateFieldLooseBase$s(this, _plugins)[_plugins])) {
      const foundPlugin = plugins.find((plugin) => plugin.id === id2);
      if (foundPlugin != null) return foundPlugin;
    }
  }
  [_Symbol$for$5](type) {
    return _classPrivateFieldLooseBase$s(this, _plugins)[_plugins][type];
  }
  /**
   * Iterate through all `use`d plugins.
   *
   * @param {Function} method that will be run on each plugin
   */
  iteratePlugins(method) {
    Object.values(_classPrivateFieldLooseBase$s(this, _plugins)[_plugins]).flat(1).forEach(method);
  }
  /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */
  removePlugin(instance) {
    this.log(`Removing plugin ${instance.id}`), this.emit("plugin-remove", instance), instance.uninstall && instance.uninstall();
    const list = _classPrivateFieldLooseBase$s(this, _plugins)[_plugins][instance.type], index = list.findIndex((item) => item.id === instance.id);
    index !== -1 && list.splice(index, 1);
    const updatedState = {
      plugins: {
        ...this.getState().plugins,
        [instance.id]: void 0
      }
    };
    this.setState(updatedState);
  }
  /**
   * Uninstall all plugins and close down this Uppy instance.
   */
  close(_temp2) {
    let {
      reason
    } = _temp2 === void 0 ? {} : _temp2;
    this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`), this.cancelAll({
      reason
    }), _classPrivateFieldLooseBase$s(this, _storeUnsubscribe)[_storeUnsubscribe](), this.iteratePlugins((plugin) => {
      this.removePlugin(plugin);
    }), typeof window < "u" && window.removeEventListener && (window.removeEventListener("online", _classPrivateFieldLooseBase$s(this, _updateOnlineStatus)[_updateOnlineStatus]), window.removeEventListener("offline", _classPrivateFieldLooseBase$s(this, _updateOnlineStatus)[_updateOnlineStatus]));
  }
  hideInfo() {
    const {
      info
    } = this.getState();
    this.setState({
      info: info.slice(1)
    }), this.emit("info-hidden");
  }
  /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   *
   * @param {string | object} message Message to be displayed by the informer
   * @param {string} [type]
   * @param {number} [duration]
   */
  info(message, type, duration2) {
    type === void 0 && (type = "info"), duration2 === void 0 && (duration2 = 3e3);
    const isComplexMessage = typeof message == "object";
    this.setState({
      info: [...this.getState().info, {
        type,
        message: isComplexMessage ? message.message : message,
        details: isComplexMessage ? message.details : null
      }]
    }), setTimeout(() => this.hideInfo(), duration2), this.emit("info-visible");
  }
  /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   *
   * @param {string|object} message to log
   * @param {string} [type] optional `error` or `warning`
   */
  log(message, type) {
    const {
      logger
    } = this.opts;
    switch (type) {
      case "error":
        logger.error(message);
        break;
      case "warning":
        logger.warn(message);
        break;
      default:
        logger.debug(message);
        break;
    }
  }
  /**
   * Restore an upload by its ID.
   */
  restore(uploadID) {
    return this.log(`Core: attempting to restore upload "${uploadID}"`), this.getState().currentUploads[uploadID] ? _classPrivateFieldLooseBase$s(this, _runUpload)[_runUpload](uploadID) : (_classPrivateFieldLooseBase$s(this, _removeUpload)[_removeUpload](uploadID), Promise.reject(new Error("Nonexistent upload")));
  }
  [_Symbol$for2$1]() {
    return _classPrivateFieldLooseBase$s(this, _createUpload$1)[_createUpload$1](...arguments);
  }
  /**
   * Add data to an upload's result object.
   *
   * @param {string} uploadID The ID of the upload.
   * @param {object} data Data properties to add to the result object.
   */
  addResultData(uploadID, data) {
    if (!_classPrivateFieldLooseBase$s(this, _getUpload)[_getUpload](uploadID)) {
      this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
      return;
    }
    const {
      currentUploads
    } = this.getState(), currentUpload = {
      ...currentUploads[uploadID],
      result: {
        ...currentUploads[uploadID].result,
        ...data
      }
    };
    this.setState({
      currentUploads: {
        ...currentUploads,
        [uploadID]: currentUpload
      }
    });
  }
  /**
   * Start an upload for all the files that are not currently being uploaded.
   *
   * @returns {Promise}
   */
  upload() {
    var _classPrivateFieldLoo;
    (_classPrivateFieldLoo = _classPrivateFieldLooseBase$s(this, _plugins)[_plugins].uploader) != null && _classPrivateFieldLoo.length || this.log("No uploader type plugins are used", "warning");
    let {
      files
    } = this.getState();
    const onBeforeUploadResult = this.opts.onBeforeUpload(files);
    return onBeforeUploadResult === !1 ? Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false")) : (onBeforeUploadResult && typeof onBeforeUploadResult == "object" && (files = onBeforeUploadResult, this.setState({
      files
    })), Promise.resolve().then(() => _classPrivateFieldLooseBase$s(this, _restricter)[_restricter].validateMinNumberOfFiles(files)).catch((err) => {
      throw _classPrivateFieldLooseBase$s(this, _informAndEmit)[_informAndEmit]([err]), err;
    }).then(() => {
      if (!_classPrivateFieldLooseBase$s(this, _checkRequiredMetaFields)[_checkRequiredMetaFields](files))
        throw new RestrictionError(this.i18n("missingRequiredMetaField"));
    }).catch((err) => {
      throw err;
    }).then(() => {
      const {
        currentUploads
      } = this.getState(), currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr) => curr.fileIDs), waitingFileIDs = [];
      Object.keys(files).forEach((fileID) => {
        const file = this.getFile(fileID);
        !file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1 && waitingFileIDs.push(file.id);
      });
      const uploadID = _classPrivateFieldLooseBase$s(this, _createUpload$1)[_createUpload$1](waitingFileIDs);
      return _classPrivateFieldLooseBase$s(this, _runUpload)[_runUpload](uploadID);
    }).catch((err) => {
      throw this.emit("error", err), this.log(err, "error"), err;
    }));
  }
};
__name(_Uppy, "Uppy");
let Uppy = _Uppy;
function _informAndEmit2(errors) {
  for (const error of errors) {
    const {
      file,
      isRestriction
    } = error;
    isRestriction ? this.emit("restriction-failed", file, error) : this.emit("error", error), this.log(error, "warning");
  }
  const userFacingErrors = errors.filter((error) => error.isUserFacing), maxNumToShow = 4, firstErrors = userFacingErrors.slice(0, maxNumToShow), additionalErrors = userFacingErrors.slice(maxNumToShow);
  firstErrors.forEach((_ref3) => {
    let {
      message,
      details = ""
    } = _ref3;
    this.info({
      message,
      details
    }, "error", this.opts.infoTimeout);
  }), additionalErrors.length > 0 && this.info({
    message: this.i18n("additionalRestrictionsFailed", {
      count: additionalErrors.length
    })
  });
}
__name(_informAndEmit2, "_informAndEmit2");
function _checkRequiredMetaFieldsOnFile2(file) {
  const {
    missingFields,
    error
  } = _classPrivateFieldLooseBase$s(this, _restricter)[_restricter].getMissingRequiredMetaFields(file);
  return missingFields.length > 0 ? (this.setFileState(file.id, {
    missingRequiredMetaFields: missingFields
  }), this.log(error.message), this.emit("restriction-failed", file, error), !1) : !0;
}
__name(_checkRequiredMetaFieldsOnFile2, "_checkRequiredMetaFieldsOnFile2");
function _checkRequiredMetaFields2(files) {
  let success = !0;
  for (const file of Object.values(files))
    _classPrivateFieldLooseBase$s(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file) || (success = !1);
  return success;
}
__name(_checkRequiredMetaFields2, "_checkRequiredMetaFields2");
function _assertNewUploadAllowed2(file) {
  const {
    allowNewUpload
  } = this.getState();
  if (allowNewUpload === !1) {
    const error = new RestrictionError(this.i18n("noMoreFilesAllowed"), {
      file
    });
    throw _classPrivateFieldLooseBase$s(this, _informAndEmit)[_informAndEmit]([error]), error;
  }
}
__name(_assertNewUploadAllowed2, "_assertNewUploadAllowed2");
function _transformFile2(fileDescriptorOrFile) {
  const fileDescriptor = fileDescriptorOrFile instanceof File ? {
    name: fileDescriptorOrFile.name,
    type: fileDescriptorOrFile.type,
    size: fileDescriptorOrFile.size,
    data: fileDescriptorOrFile
  } : fileDescriptorOrFile, fileType = getFileType(fileDescriptor), fileName = getFileName(fileType, fileDescriptor), fileExtension = getFileNameAndExtension(fileName).extension, isRemote = !!fileDescriptor.isRemote, id2 = getSafeFileId(fileDescriptor), meta = fileDescriptor.meta || {};
  meta.name = fileName, meta.type = fileType;
  const size = Number.isFinite(fileDescriptor.data.size) ? fileDescriptor.data.size : null;
  return {
    source: fileDescriptor.source || "",
    id: id2,
    name: fileName,
    extension: fileExtension || "",
    meta: {
      ...this.getState().meta,
      ...meta
    },
    type: fileType,
    data: fileDescriptor.data,
    progress: {
      percentage: 0,
      bytesUploaded: 0,
      bytesTotal: size,
      uploadComplete: !1,
      uploadStarted: null
    },
    size,
    isRemote,
    remote: fileDescriptor.remote || "",
    preview: fileDescriptor.preview
  };
}
__name(_transformFile2, "_transformFile2");
function _startIfAutoProceed2() {
  this.opts.autoProceed && !this.scheduledAutoProceed && (this.scheduledAutoProceed = setTimeout(() => {
    this.scheduledAutoProceed = null, this.upload().catch((err) => {
      err.isRestriction || this.log(err.stack || err.message || err);
    });
  }, 4));
}
__name(_startIfAutoProceed2, "_startIfAutoProceed2");
function _checkAndUpdateFileState2(filesToAdd) {
  const {
    files: existingFiles
  } = this.getState(), nextFilesState = {
    ...existingFiles
  }, validFilesToAdd = [], errors = [];
  for (const fileToAdd of filesToAdd)
    try {
      var _existingFiles$newFil;
      let newFile = _classPrivateFieldLooseBase$s(this, _transformFile)[_transformFile](fileToAdd);
      if ((_existingFiles$newFil = existingFiles[newFile.id]) != null && _existingFiles$newFil.isGhost) {
        const {
          isGhost,
          ...existingFileState
        } = existingFiles[newFile.id];
        newFile = {
          ...existingFileState,
          data: fileToAdd.data
        }, this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
      }
      const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
      if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id))
        throw new RestrictionError(this.i18n("noDuplicates", {
          fileName: newFile.name
        }), {
          file: fileToAdd
        });
      if (onBeforeFileAddedResult === !1)
        throw new RestrictionError("Cannot add the file because onBeforeFileAdded returned false.", {
          isUserFacing: !1,
          file: fileToAdd
        });
      typeof onBeforeFileAddedResult == "object" && onBeforeFileAddedResult !== null && (newFile = onBeforeFileAddedResult), _classPrivateFieldLooseBase$s(this, _restricter)[_restricter].validateSingleFile(newFile), nextFilesState[newFile.id] = newFile, validFilesToAdd.push(newFile);
    } catch (err) {
      errors.push(err);
    }
  try {
    _classPrivateFieldLooseBase$s(this, _restricter)[_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
  } catch (err) {
    return errors.push(err), {
      nextFilesState: existingFiles,
      validFilesToAdd: [],
      errors
    };
  }
  return {
    nextFilesState,
    validFilesToAdd,
    errors
  };
}
__name(_checkAndUpdateFileState2, "_checkAndUpdateFileState2");
function _addListeners2$1() {
  const errorHandler = /* @__PURE__ */ __name((error, file, response) => {
    let errorMsg = error.message || "Unknown error";
    error.details && (errorMsg += ` ${error.details}`), this.setState({
      error: errorMsg
    }), file != null && file.id in this.getState().files && this.setFileState(file.id, {
      error: errorMsg,
      response
    });
  }, "errorHandler");
  this.on("error", errorHandler), this.on("upload-error", (file, error, response) => {
    if (errorHandler(error, file, response), typeof error == "object" && error.message) {
      this.log(error.message, "error");
      const newError = new Error(this.i18n("failedToUpload", {
        file: file == null ? void 0 : file.name
      }));
      newError.isUserFacing = !0, newError.details = error.message, error.details && (newError.details += ` ${error.details}`), _classPrivateFieldLooseBase$s(this, _informAndEmit)[_informAndEmit]([newError]);
    } else
      _classPrivateFieldLooseBase$s(this, _informAndEmit)[_informAndEmit]([error]);
  });
  let uploadStalledWarningRecentlyEmitted;
  this.on("upload-stalled", (error, files) => {
    const {
      message
    } = error, details = files.map((file) => file.meta.name).join(", ");
    uploadStalledWarningRecentlyEmitted || (this.info({
      message,
      details
    }, "warning", this.opts.infoTimeout), uploadStalledWarningRecentlyEmitted = setTimeout(() => {
      uploadStalledWarningRecentlyEmitted = null;
    }, this.opts.infoTimeout)), this.log(`${message} ${details}`.trim(), "warning");
  }), this.on("upload", () => {
    this.setState({
      error: null
    });
  });
  const onUploadStarted = /* @__PURE__ */ __name((files) => {
    const filesFiltered = files.filter((file) => {
      const exists = file != null && this.getFile(file.id);
      return exists || this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`), exists;
    }), filesState = Object.fromEntries(filesFiltered.map((file) => [file.id, {
      progress: {
        uploadStarted: Date.now(),
        uploadComplete: !1,
        percentage: 0,
        bytesUploaded: 0,
        bytesTotal: file.size
      }
    }]));
    this.patchFilesState(filesState);
  }, "onUploadStarted");
  this.on("upload-start", (files) => {
    files.forEach((file) => {
      this.emit("upload-started", file);
    }), onUploadStarted(files);
  }), this.on("upload-progress", this.calculateProgress), this.on("upload-success", (file, uploadResp) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const currentProgress = this.getFile(file.id).progress;
    this.setFileState(file.id, {
      progress: {
        ...currentProgress,
        postprocess: _classPrivateFieldLooseBase$s(this, _postProcessors)[_postProcessors].size > 0 ? {
          mode: "indeterminate"
        } : null,
        uploadComplete: !0,
        percentage: 100,
        bytesUploaded: currentProgress.bytesTotal
      },
      response: uploadResp,
      uploadURL: uploadResp.uploadURL,
      isPaused: !1
    }), file.size == null && this.setFileState(file.id, {
      size: uploadResp.bytesUploaded || currentProgress.bytesTotal
    }), this.calculateTotalProgress();
  }), this.on("preprocess-progress", (file, progress) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    this.setFileState(file.id, {
      progress: {
        ...this.getFile(file.id).progress,
        preprocess: progress
      }
    });
  }), this.on("preprocess-complete", (file) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const files = {
      ...this.getState().files
    };
    files[file.id] = {
      ...files[file.id],
      progress: {
        ...files[file.id].progress
      }
    }, delete files[file.id].progress.preprocess, this.setState({
      files
    });
  }), this.on("postprocess-progress", (file, progress) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    this.setFileState(file.id, {
      progress: {
        ...this.getState().files[file.id].progress,
        postprocess: progress
      }
    });
  }), this.on("postprocess-complete", (file) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const files = {
      ...this.getState().files
    };
    files[file.id] = {
      ...files[file.id],
      progress: {
        ...files[file.id].progress
      }
    }, delete files[file.id].progress.postprocess, this.setState({
      files
    });
  }), this.on("restored", () => {
    this.calculateTotalProgress();
  }), this.on("dashboard:file-edit-complete", (file) => {
    file && _classPrivateFieldLooseBase$s(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file);
  }), typeof window < "u" && window.addEventListener && (window.addEventListener("online", _classPrivateFieldLooseBase$s(this, _updateOnlineStatus)[_updateOnlineStatus]), window.addEventListener("offline", _classPrivateFieldLooseBase$s(this, _updateOnlineStatus)[_updateOnlineStatus]), setTimeout(_classPrivateFieldLooseBase$s(this, _updateOnlineStatus)[_updateOnlineStatus], 3e3));
}
__name(_addListeners2$1, "_addListeners2$1");
function _createUpload2$1(fileIDs, opts) {
  opts === void 0 && (opts = {});
  const {
    forceAllowNewUpload = !1
  } = opts, {
    allowNewUpload,
    currentUploads
  } = this.getState();
  if (!allowNewUpload && !forceAllowNewUpload)
    throw new Error("Cannot create a new upload: already uploading.");
  const uploadID = nanoid();
  return this.emit("upload", {
    id: uploadID,
    fileIDs
  }), this.setState({
    allowNewUpload: this.opts.allowMultipleUploadBatches !== !1 && this.opts.allowMultipleUploads !== !1,
    currentUploads: {
      ...currentUploads,
      [uploadID]: {
        fileIDs,
        step: 0,
        result: {}
      }
    }
  }), uploadID;
}
__name(_createUpload2$1, "_createUpload2$1");
function _getUpload2(uploadID) {
  const {
    currentUploads
  } = this.getState();
  return currentUploads[uploadID];
}
__name(_getUpload2, "_getUpload2");
function _removeUpload2(uploadID) {
  const currentUploads = {
    ...this.getState().currentUploads
  };
  delete currentUploads[uploadID], this.setState({
    currentUploads
  });
}
__name(_removeUpload2, "_removeUpload2");
async function _runUpload2(uploadID) {
  const getCurrentUpload = /* @__PURE__ */ __name(() => {
    const {
      currentUploads
    } = this.getState();
    return currentUploads[uploadID];
  }, "getCurrentUpload");
  let currentUpload = getCurrentUpload();
  const steps = [..._classPrivateFieldLooseBase$s(this, _preProcessors)[_preProcessors], ..._classPrivateFieldLooseBase$s(this, _uploaders)[_uploaders], ..._classPrivateFieldLooseBase$s(this, _postProcessors)[_postProcessors]];
  try {
    for (let step = currentUpload.step || 0; step < steps.length && currentUpload; step++) {
      const fn = steps[step];
      this.setState({
        currentUploads: {
          ...this.getState().currentUploads,
          [uploadID]: {
            ...currentUpload,
            step
          }
        }
      });
      const {
        fileIDs
      } = currentUpload;
      await fn(fileIDs, uploadID), currentUpload = getCurrentUpload();
    }
  } catch (err) {
    throw _classPrivateFieldLooseBase$s(this, _removeUpload)[_removeUpload](uploadID), err;
  }
  if (currentUpload) {
    currentUpload.fileIDs.forEach((fileID) => {
      const file = this.getFile(fileID);
      file && file.progress.postprocess && this.emit("postprocess-complete", file);
    });
    const files = currentUpload.fileIDs.map((fileID) => this.getFile(fileID)), successful = files.filter((file) => !file.error), failed = files.filter((file) => file.error);
    await this.addResultData(uploadID, {
      successful,
      failed,
      uploadID
    }), currentUpload = getCurrentUpload();
  }
  let result2;
  return currentUpload && (result2 = currentUpload.result, this.emit("complete", result2), _classPrivateFieldLooseBase$s(this, _removeUpload)[_removeUpload](uploadID)), result2 == null && this.log(`Not setting result for an upload that has been removed: ${uploadID}`), result2;
}
__name(_runUpload2, "_runUpload2");
Uppy.VERSION = packageJson$x.version;
var n$1, l$2, u$2, i$2, o$2, r$2, f$2, c$2 = {}, s$2 = [], a$2 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, h$2 = Array.isArray;
function v$2(n2, l2) {
  for (var u2 in l2) n2[u2] = l2[u2];
  return n2;
}
__name(v$2, "v$2");
function p$2(n2) {
  var l2 = n2.parentNode;
  l2 && l2.removeChild(n2);
}
__name(p$2, "p$2");
function y$1(l2, u2, t2) {
  var i2, o2, r2, f2 = {};
  for (r2 in u2) r2 == "key" ? i2 = u2[r2] : r2 == "ref" ? o2 = u2[r2] : f2[r2] = u2[r2];
  if (arguments.length > 2 && (f2.children = arguments.length > 3 ? n$1.call(arguments, 2) : t2), typeof l2 == "function" && l2.defaultProps != null) for (r2 in l2.defaultProps) f2[r2] === void 0 && (f2[r2] = l2.defaultProps[r2]);
  return d$2(l2, f2, i2, o2, null);
}
__name(y$1, "y$1");
function d$2(n2, t2, i2, o2, r2) {
  var f2 = { type: n2, props: t2, key: i2, ref: o2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: r2 ?? ++u$2 };
  return r2 == null && l$2.vnode != null && l$2.vnode(f2), f2;
}
__name(d$2, "d$2");
function _$2() {
  return { current: null };
}
__name(_$2, "_$2");
function k$2(n2) {
  return n2.children;
}
__name(k$2, "k$2");
function b$2(n2, l2) {
  this.props = n2, this.context = l2;
}
__name(b$2, "b$2");
function g$2(n2, l2) {
  if (l2 == null) return n2.__ ? g$2(n2.__, n2.__.__k.indexOf(n2) + 1) : null;
  for (var u2; l2 < n2.__k.length; l2++) if ((u2 = n2.__k[l2]) != null && u2.__e != null) return u2.__e;
  return typeof n2.type == "function" ? g$2(n2) : null;
}
__name(g$2, "g$2");
function m$2(n2) {
  var l2, u2;
  if ((n2 = n2.__) != null && n2.__c != null) {
    for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++) if ((u2 = n2.__k[l2]) != null && u2.__e != null) {
      n2.__e = n2.__c.base = u2.__e;
      break;
    }
    return m$2(n2);
  }
}
__name(m$2, "m$2");
function w$2(n2) {
  (!n2.__d && (n2.__d = !0) && i$2.push(n2) && !x.__r++ || o$2 !== l$2.debounceRendering) && ((o$2 = l$2.debounceRendering) || r$2)(x);
}
__name(w$2, "w$2");
function x() {
  var n2, l2, u2, t2, o2, r2, e2, c2, s2;
  for (i$2.sort(f$2); n2 = i$2.shift(); ) n2.__d && (l2 = i$2.length, t2 = void 0, o2 = void 0, r2 = void 0, c2 = (e2 = (u2 = n2).__v).__e, (s2 = u2.__P) && (t2 = [], o2 = [], (r2 = v$2({}, e2)).__v = e2.__v + 1, L$1(s2, e2, r2, u2.__n, s2.ownerSVGElement !== void 0, e2.__h != null ? [c2] : null, t2, c2 ?? g$2(e2), e2.__h, o2), M$1(t2, e2, o2), e2.__e != c2 && m$2(e2)), i$2.length > l2 && i$2.sort(f$2));
  x.__r = 0;
}
__name(x, "x");
function P$1(n2, l2, u2, t2, i2, o2, r2, f2, e2, a2, v2) {
  var p2, y2, _2, b2, m2, w2, x2, P2, C2, H2 = 0, I2 = t2 && t2.__k || s$2, T2 = I2.length, j2 = T2, z2 = l2.length;
  for (u2.__k = [], p2 = 0; p2 < z2; p2++) (b2 = u2.__k[p2] = (b2 = l2[p2]) == null || typeof b2 == "boolean" || typeof b2 == "function" ? null : typeof b2 == "string" || typeof b2 == "number" || typeof b2 == "bigint" ? d$2(null, b2, null, null, b2) : h$2(b2) ? d$2(k$2, { children: b2 }, null, null, null) : b2.__b > 0 ? d$2(b2.type, b2.props, b2.key, b2.ref ? b2.ref : null, b2.__v) : b2) != null ? (b2.__ = u2, b2.__b = u2.__b + 1, (P2 = A$1(b2, I2, x2 = p2 + H2, j2)) === -1 ? _2 = c$2 : (_2 = I2[P2] || c$2, I2[P2] = void 0, j2--), L$1(n2, b2, _2, i2, o2, r2, f2, e2, a2, v2), m2 = b2.__e, (y2 = b2.ref) && _2.ref != y2 && (_2.ref && O$1(_2.ref, null, b2), v2.push(y2, b2.__c || m2, b2)), m2 != null && (w2 == null && (w2 = m2), (C2 = _2 === c$2 || _2.__v === null) ? P2 == -1 && H2-- : P2 !== x2 && (P2 === x2 + 1 ? H2++ : P2 > x2 ? j2 > z2 - x2 ? H2 += P2 - x2 : H2-- : H2 = P2 < x2 && P2 == x2 - 1 ? P2 - x2 : 0), x2 = p2 + H2, typeof b2.type != "function" || P2 === x2 && _2.__k !== b2.__k ? typeof b2.type == "function" || P2 === x2 && !C2 ? b2.__d !== void 0 ? (e2 = b2.__d, b2.__d = void 0) : e2 = m2.nextSibling : e2 = S$1(n2, m2, e2) : e2 = $$1(b2, e2, n2), typeof u2.type == "function" && (u2.__d = e2))) : (_2 = I2[p2]) && _2.key == null && _2.__e && (_2.__e == e2 && (e2 = g$2(_2)), q$1(_2, _2, !1), I2[p2] = null);
  for (u2.__e = w2, p2 = T2; p2--; ) I2[p2] != null && (typeof u2.type == "function" && I2[p2].__e != null && I2[p2].__e == u2.__d && (u2.__d = I2[p2].__e.nextSibling), q$1(I2[p2], I2[p2]));
}
__name(P$1, "P$1");
function $$1(n2, l2, u2) {
  for (var t2, i2 = n2.__k, o2 = 0; i2 && o2 < i2.length; o2++) (t2 = i2[o2]) && (t2.__ = n2, l2 = typeof t2.type == "function" ? $$1(t2, l2, u2) : S$1(u2, t2.__e, l2));
  return l2;
}
__name($$1, "$$1");
function C(n2, l2) {
  return l2 = l2 || [], n2 == null || typeof n2 == "boolean" || (h$2(n2) ? n2.some(function(n3) {
    C(n3, l2);
  }) : l2.push(n2)), l2;
}
__name(C, "C");
function S$1(n2, l2, u2) {
  return u2 == null || u2.parentNode !== n2 ? n2.insertBefore(l2, null) : l2 == u2 && l2.parentNode != null || n2.insertBefore(l2, u2), l2.nextSibling;
}
__name(S$1, "S$1");
function A$1(n2, l2, u2, t2) {
  var i2 = n2.key, o2 = n2.type, r2 = u2 - 1, f2 = u2 + 1, e2 = l2[u2];
  if (e2 === null || e2 && i2 == e2.key && o2 === e2.type) return u2;
  if (t2 > (e2 != null ? 1 : 0)) for (; r2 >= 0 || f2 < l2.length; ) {
    if (r2 >= 0) {
      if ((e2 = l2[r2]) && i2 == e2.key && o2 === e2.type) return r2;
      r2--;
    }
    if (f2 < l2.length) {
      if ((e2 = l2[f2]) && i2 == e2.key && o2 === e2.type) return f2;
      f2++;
    }
  }
  return -1;
}
__name(A$1, "A$1");
function H$1(n2, l2, u2, t2, i2) {
  var o2;
  for (o2 in u2) o2 === "children" || o2 === "key" || o2 in l2 || T$2(n2, o2, null, u2[o2], t2);
  for (o2 in l2) i2 && typeof l2[o2] != "function" || o2 === "children" || o2 === "key" || o2 === "value" || o2 === "checked" || u2[o2] === l2[o2] || T$2(n2, o2, l2[o2], u2[o2], t2);
}
__name(H$1, "H$1");
function I$1(n2, l2, u2) {
  l2[0] === "-" ? n2.setProperty(l2, u2 ?? "") : n2[l2] = u2 == null ? "" : typeof u2 != "number" || a$2.test(l2) ? u2 : u2 + "px";
}
__name(I$1, "I$1");
function T$2(n2, l2, u2, t2, i2) {
  var o2;
  n: if (l2 === "style") if (typeof u2 == "string") n2.style.cssText = u2;
  else {
    if (typeof t2 == "string" && (n2.style.cssText = t2 = ""), t2) for (l2 in t2) u2 && l2 in u2 || I$1(n2.style, l2, "");
    if (u2) for (l2 in u2) t2 && u2[l2] === t2[l2] || I$1(n2.style, l2, u2[l2]);
  }
  else if (l2[0] === "o" && l2[1] === "n") o2 = l2 !== (l2 = l2.replace(/(PointerCapture)$|Capture$/, "$1")), l2 = l2.toLowerCase() in n2 ? l2.toLowerCase().slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + o2] = u2, u2 ? t2 || n2.addEventListener(l2, o2 ? z$2 : j$2, o2) : n2.removeEventListener(l2, o2 ? z$2 : j$2, o2);
  else if (l2 !== "dangerouslySetInnerHTML") {
    if (i2) l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (l2 !== "width" && l2 !== "height" && l2 !== "href" && l2 !== "list" && l2 !== "form" && l2 !== "tabIndex" && l2 !== "download" && l2 !== "rowSpan" && l2 !== "colSpan" && l2 in n2) try {
      n2[l2] = u2 ?? "";
      break n;
    } catch {
    }
    typeof u2 == "function" || (u2 == null || u2 === !1 && l2[4] !== "-" ? n2.removeAttribute(l2) : n2.setAttribute(l2, u2));
  }
}
__name(T$2, "T$2");
function j$2(n2) {
  return this.l[n2.type + !1](l$2.event ? l$2.event(n2) : n2);
}
__name(j$2, "j$2");
function z$2(n2) {
  return this.l[n2.type + !0](l$2.event ? l$2.event(n2) : n2);
}
__name(z$2, "z$2");
function L$1(n2, u2, t2, i2, o2, r2, f2, e2, c2, s2) {
  var a2, p2, y2, d2, _2, g2, m2, w2, x2, $2, C2, S2, A2, H2, I2, T2 = u2.type;
  if (u2.constructor !== void 0) return null;
  t2.__h != null && (c2 = t2.__h, e2 = u2.__e = t2.__e, u2.__h = null, r2 = [e2]), (a2 = l$2.__b) && a2(u2);
  n: if (typeof T2 == "function") try {
    if (w2 = u2.props, x2 = (a2 = T2.contextType) && i2[a2.__c], $2 = a2 ? x2 ? x2.props.value : a2.__ : i2, t2.__c ? m2 = (p2 = u2.__c = t2.__c).__ = p2.__E : ("prototype" in T2 && T2.prototype.render ? u2.__c = p2 = new T2(w2, $2) : (u2.__c = p2 = new b$2(w2, $2), p2.constructor = T2, p2.render = B$2), x2 && x2.sub(p2), p2.props = w2, p2.state || (p2.state = {}), p2.context = $2, p2.__n = i2, y2 = p2.__d = !0, p2.__h = [], p2._sb = []), p2.__s == null && (p2.__s = p2.state), T2.getDerivedStateFromProps != null && (p2.__s == p2.state && (p2.__s = v$2({}, p2.__s)), v$2(p2.__s, T2.getDerivedStateFromProps(w2, p2.__s))), d2 = p2.props, _2 = p2.state, p2.__v = u2, y2) T2.getDerivedStateFromProps == null && p2.componentWillMount != null && p2.componentWillMount(), p2.componentDidMount != null && p2.__h.push(p2.componentDidMount);
    else {
      if (T2.getDerivedStateFromProps == null && w2 !== d2 && p2.componentWillReceiveProps != null && p2.componentWillReceiveProps(w2, $2), !p2.__e && (p2.shouldComponentUpdate != null && p2.shouldComponentUpdate(w2, p2.__s, $2) === !1 || u2.__v === t2.__v)) {
        for (u2.__v !== t2.__v && (p2.props = w2, p2.state = p2.__s, p2.__d = !1), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.forEach(function(n3) {
          n3 && (n3.__ = u2);
        }), C2 = 0; C2 < p2._sb.length; C2++) p2.__h.push(p2._sb[C2]);
        p2._sb = [], p2.__h.length && f2.push(p2);
        break n;
      }
      p2.componentWillUpdate != null && p2.componentWillUpdate(w2, p2.__s, $2), p2.componentDidUpdate != null && p2.__h.push(function() {
        p2.componentDidUpdate(d2, _2, g2);
      });
    }
    if (p2.context = $2, p2.props = w2, p2.__P = n2, p2.__e = !1, S2 = l$2.__r, A2 = 0, "prototype" in T2 && T2.prototype.render) {
      for (p2.state = p2.__s, p2.__d = !1, S2 && S2(u2), a2 = p2.render(p2.props, p2.state, p2.context), H2 = 0; H2 < p2._sb.length; H2++) p2.__h.push(p2._sb[H2]);
      p2._sb = [];
    } else do
      p2.__d = !1, S2 && S2(u2), a2 = p2.render(p2.props, p2.state, p2.context), p2.state = p2.__s;
    while (p2.__d && ++A2 < 25);
    p2.state = p2.__s, p2.getChildContext != null && (i2 = v$2(v$2({}, i2), p2.getChildContext())), y2 || p2.getSnapshotBeforeUpdate == null || (g2 = p2.getSnapshotBeforeUpdate(d2, _2)), P$1(n2, h$2(I2 = a2 != null && a2.type === k$2 && a2.key == null ? a2.props.children : a2) ? I2 : [I2], u2, t2, i2, o2, r2, f2, e2, c2, s2), p2.base = u2.__e, u2.__h = null, p2.__h.length && f2.push(p2), m2 && (p2.__E = p2.__ = null);
  } catch (n3) {
    u2.__v = null, (c2 || r2 != null) && (u2.__e = e2, u2.__h = !!c2, r2[r2.indexOf(e2)] = null), l$2.__e(n3, u2, t2);
  }
  else r2 == null && u2.__v === t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : u2.__e = N$1(t2.__e, u2, t2, i2, o2, r2, f2, c2, s2);
  (a2 = l$2.diffed) && a2(u2);
}
__name(L$1, "L$1");
function M$1(n2, u2, t2) {
  for (var i2 = 0; i2 < t2.length; i2++) O$1(t2[i2], t2[++i2], t2[++i2]);
  l$2.__c && l$2.__c(u2, n2), n2.some(function(u3) {
    try {
      n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
        n3.call(u3);
      });
    } catch (n3) {
      l$2.__e(n3, u3.__v);
    }
  });
}
__name(M$1, "M$1");
function N$1(l2, u2, t2, i2, o2, r2, f2, e2, s2) {
  var a2, v2, y2, d2 = t2.props, _2 = u2.props, k2 = u2.type, b2 = 0;
  if (k2 === "svg" && (o2 = !0), r2 != null) {
    for (; b2 < r2.length; b2++) if ((a2 = r2[b2]) && "setAttribute" in a2 == !!k2 && (k2 ? a2.localName === k2 : a2.nodeType === 3)) {
      l2 = a2, r2[b2] = null;
      break;
    }
  }
  if (l2 == null) {
    if (k2 === null) return document.createTextNode(_2);
    l2 = o2 ? document.createElementNS("http://www.w3.org/2000/svg", k2) : document.createElement(k2, _2.is && _2), r2 = null, e2 = !1;
  }
  if (k2 === null) d2 === _2 || e2 && l2.data === _2 || (l2.data = _2);
  else {
    if (r2 = r2 && n$1.call(l2.childNodes), v2 = (d2 = t2.props || c$2).dangerouslySetInnerHTML, y2 = _2.dangerouslySetInnerHTML, !e2) {
      if (r2 != null) for (d2 = {}, b2 = 0; b2 < l2.attributes.length; b2++) d2[l2.attributes[b2].name] = l2.attributes[b2].value;
      (y2 || v2) && (y2 && (v2 && y2.__html == v2.__html || y2.__html === l2.innerHTML) || (l2.innerHTML = y2 && y2.__html || ""));
    }
    if (H$1(l2, _2, d2, o2, e2), y2) u2.__k = [];
    else if (P$1(l2, h$2(b2 = u2.props.children) ? b2 : [b2], u2, t2, i2, o2 && k2 !== "foreignObject", r2, f2, r2 ? r2[0] : t2.__k && g$2(t2, 0), e2, s2), r2 != null) for (b2 = r2.length; b2--; ) r2[b2] != null && p$2(r2[b2]);
    e2 || ("value" in _2 && (b2 = _2.value) !== void 0 && (b2 !== l2.value || k2 === "progress" && !b2 || k2 === "option" && b2 !== d2.value) && T$2(l2, "value", b2, d2.value, !1), "checked" in _2 && (b2 = _2.checked) !== void 0 && b2 !== l2.checked && T$2(l2, "checked", b2, d2.checked, !1));
  }
  return l2;
}
__name(N$1, "N$1");
function O$1(n2, u2, t2) {
  try {
    typeof n2 == "function" ? n2(u2) : n2.current = u2;
  } catch (n3) {
    l$2.__e(n3, t2);
  }
}
__name(O$1, "O$1");
function q$1(n2, u2, t2) {
  var i2, o2;
  if (l$2.unmount && l$2.unmount(n2), (i2 = n2.ref) && (i2.current && i2.current !== n2.__e || O$1(i2, null, u2)), (i2 = n2.__c) != null) {
    if (i2.componentWillUnmount) try {
      i2.componentWillUnmount();
    } catch (n3) {
      l$2.__e(n3, u2);
    }
    i2.base = i2.__P = null, n2.__c = void 0;
  }
  if (i2 = n2.__k) for (o2 = 0; o2 < i2.length; o2++) i2[o2] && q$1(i2[o2], u2, t2 || typeof n2.type != "function");
  t2 || n2.__e == null || p$2(n2.__e), n2.__ = n2.__e = n2.__d = void 0;
}
__name(q$1, "q$1");
function B$2(n2, l2, u2) {
  return this.constructor(n2, u2);
}
__name(B$2, "B$2");
function D$1(u2, t2, i2) {
  var o2, r2, f2, e2;
  l$2.__ && l$2.__(u2, t2), r2 = (o2 = typeof i2 == "function") ? null : t2.__k, f2 = [], e2 = [], L$1(t2, u2 = (!o2 && i2 || t2).__k = y$1(k$2, null, [u2]), r2 || c$2, c$2, t2.ownerSVGElement !== void 0, !o2 && i2 ? [i2] : r2 ? null : t2.firstChild ? n$1.call(t2.childNodes) : null, f2, !o2 && i2 ? i2 : r2 ? r2.__e : t2.firstChild, o2, e2), M$1(f2, u2, e2);
}
__name(D$1, "D$1");
function F$2(l2, u2, t2) {
  var i2, o2, r2, f2, e2 = v$2({}, l2.props);
  for (r2 in l2.type && l2.type.defaultProps && (f2 = l2.type.defaultProps), u2) r2 == "key" ? i2 = u2[r2] : r2 == "ref" ? o2 = u2[r2] : e2[r2] = u2[r2] === void 0 && f2 !== void 0 ? f2[r2] : u2[r2];
  return arguments.length > 2 && (e2.children = arguments.length > 3 ? n$1.call(arguments, 2) : t2), d$2(l2.type, e2, i2 || l2.key, o2 || l2.ref, null);
}
__name(F$2, "F$2");
n$1 = s$2.slice, l$2 = { __e: /* @__PURE__ */ __name(function(n2, l2, u2, t2) {
  for (var i2, o2, r2; l2 = l2.__; ) if ((i2 = l2.__c) && !i2.__) try {
    if ((o2 = i2.constructor) && o2.getDerivedStateFromError != null && (i2.setState(o2.getDerivedStateFromError(n2)), r2 = i2.__d), i2.componentDidCatch != null && (i2.componentDidCatch(n2, t2 || {}), r2 = i2.__d), r2) return i2.__E = i2;
  } catch (l3) {
    n2 = l3;
  }
  throw n2;
}, "__e") }, u$2 = 0, b$2.prototype.setState = function(n2, l2) {
  var u2;
  u2 = this.__s != null && this.__s !== this.state ? this.__s : this.__s = v$2({}, this.state), typeof n2 == "function" && (n2 = n2(v$2({}, u2), this.props)), n2 && v$2(u2, n2), n2 != null && this.__v && (l2 && this._sb.push(l2), w$2(this));
}, b$2.prototype.forceUpdate = function(n2) {
  this.__v && (this.__e = !0, n2 && this.__h.push(n2), w$2(this));
}, b$2.prototype.render = k$2, i$2 = [], r$2 = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$2 = /* @__PURE__ */ __name(function(n2, l2) {
  return n2.__v.__b - l2.__v.__b;
}, "f$2"), x.__r = 0;
function isDOMElement(obj) {
  return (obj == null ? void 0 : obj.nodeType) === Node.ELEMENT_NODE;
}
__name(isDOMElement, "isDOMElement");
function findDOMElement(element, context) {
  return context === void 0 && (context = document), typeof element == "string" ? context.querySelector(element) : isDOMElement(element) ? element : null;
}
__name(findDOMElement, "findDOMElement");
function getTextDirection(element) {
  for (var _element; element && !element.dir; )
    element = element.parentNode;
  return (_element = element) == null ? void 0 : _element.dir;
}
__name(getTextDirection, "getTextDirection");
const _BasePlugin = class _BasePlugin {
  constructor(uppy, opts) {
    opts === void 0 && (opts = {}), this.uppy = uppy, this.opts = opts;
  }
  getPluginState() {
    const {
      plugins
    } = this.uppy.getState();
    return plugins[this.id] || {};
  }
  setPluginState(update) {
    const {
      plugins
    } = this.uppy.getState();
    this.uppy.setState({
      plugins: {
        ...plugins,
        [this.id]: {
          ...plugins[this.id],
          ...update
        }
      }
    });
  }
  setOptions(newOpts) {
    this.opts = {
      ...this.opts,
      ...newOpts
    }, this.setPluginState(), this.i18nInit();
  }
  i18nInit() {
    const translator = new Translator([this.defaultLocale, this.uppy.locale, this.opts.locale]);
    this.i18n = translator.translate.bind(translator), this.i18nArray = translator.translateArray.bind(translator), this.setPluginState();
  }
  /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */
  // eslint-disable-next-line class-methods-use-this
  addTarget() {
    throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
  }
  // eslint-disable-next-line class-methods-use-this
  install() {
  }
  // eslint-disable-next-line class-methods-use-this
  uninstall() {
  }
  /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */
  render() {
    throw new Error("Extend the render method to add your plugin to a DOM element");
  }
  // eslint-disable-next-line class-methods-use-this
  update() {
  }
  // Called after every state update, after everything's mounted. Debounced.
  // eslint-disable-next-line class-methods-use-this
  afterUpdate() {
  }
};
__name(_BasePlugin, "BasePlugin");
let BasePlugin = _BasePlugin;
function _classPrivateFieldLooseBase$r(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$r, "_classPrivateFieldLooseBase$r");
var id$r = 0;
function _classPrivateFieldLooseKey$r(name) {
  return "__private_" + id$r++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$r, "_classPrivateFieldLooseKey$r");
function debounce(fn) {
  let calling = null, latestArgs = null;
  return function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
      args[_key] = arguments[_key];
    return latestArgs = args, calling || (calling = Promise.resolve().then(() => (calling = null, fn(...latestArgs)))), calling;
  };
}
__name(debounce, "debounce");
var _updateUI = /* @__PURE__ */ _classPrivateFieldLooseKey$r("updateUI");
const _UIPlugin = class _UIPlugin extends BasePlugin {
  constructor() {
    super(...arguments), Object.defineProperty(this, _updateUI, {
      writable: !0,
      value: void 0
    });
  }
  getTargetPlugin(target) {
    let targetPlugin;
    if (typeof target == "object" && target instanceof _UIPlugin)
      targetPlugin = target;
    else if (typeof target == "function") {
      const Target = target;
      this.uppy.iteratePlugins((p2) => {
        p2 instanceof Target && (targetPlugin = p2);
      });
    }
    return targetPlugin;
  }
  /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */
  mount(target, plugin) {
    const callerPluginName = plugin.id, targetElement = findDOMElement(target);
    if (targetElement) {
      this.isTargetDOMEl = !0;
      const uppyRootElement = document.createElement("div");
      return uppyRootElement.classList.add("uppy-Root"), _classPrivateFieldLooseBase$r(this, _updateUI)[_updateUI] = debounce((state) => {
        this.uppy.getPlugin(this.id) && (D$1(this.render(state), uppyRootElement), this.afterUpdate());
      }), this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`), this.opts.replaceTargetContent && (targetElement.innerHTML = ""), D$1(this.render(this.uppy.getState()), uppyRootElement), this.el = uppyRootElement, targetElement.appendChild(uppyRootElement), uppyRootElement.dir = this.opts.direction || getTextDirection(uppyRootElement) || "ltr", this.onMount(), this.el;
    }
    const targetPlugin = this.getTargetPlugin(target);
    if (targetPlugin)
      return this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`), this.parent = targetPlugin, this.el = targetPlugin.addTarget(plugin), this.onMount(), this.el;
    this.uppy.log(`Not installing ${callerPluginName}`);
    let message = `Invalid target option given to ${callerPluginName}.`;
    throw typeof target == "function" ? message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly." : message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.", new Error(message);
  }
  update(state) {
    if (this.el != null) {
      var _classPrivateFieldLoo, _classPrivateFieldLoo2;
      (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase$r(this, _updateUI))[_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
    }
  }
  unmount() {
    if (this.isTargetDOMEl) {
      var _this$el;
      (_this$el = this.el) == null || _this$el.remove();
    }
    this.onUnmount();
  }
  // eslint-disable-next-line class-methods-use-this
  onMount() {
  }
  // eslint-disable-next-line class-methods-use-this
  onUnmount() {
  }
};
__name(_UIPlugin, "UIPlugin");
let UIPlugin = _UIPlugin;
const _NetworkError = class _NetworkError extends Error {
  constructor(error, xhr) {
    xhr === void 0 && (xhr = null), super("This looks like a network error, the endpoint might be blocked by an internet provider or a firewall."), this.cause = error, this.isNetworkError = !0, this.request = xhr;
  }
};
__name(_NetworkError, "NetworkError");
let NetworkError = _NetworkError;
function fetchWithNetworkError() {
  return fetch(...arguments).catch((err) => {
    throw err.name === "AbortError" ? err : new NetworkError(err);
  });
}
__name(fetchWithNetworkError, "fetchWithNetworkError");
const _ErrorWithCause = class _ErrorWithCause extends Error {
  constructor(message, options) {
    options === void 0 && (options = {}), super(message), this.cause = options.cause, this.cause && has$1(this.cause, "isNetworkError") && (this.isNetworkError = this.cause.isNetworkError);
  }
};
__name(_ErrorWithCause, "ErrorWithCause");
let ErrorWithCause = _ErrorWithCause;
function emitSocketProgress(uploader, progressData, file) {
  const {
    progress,
    bytesUploaded,
    bytesTotal
  } = progressData;
  progress && (uploader.uppy.log(`Upload progress: ${progress}`), uploader.uppy.emit("upload-progress", file, {
    uploader,
    bytesUploaded,
    bytesTotal
  }));
}
__name(emitSocketProgress, "emitSocketProgress");
const emitSocketProgress$1 = throttle$2(emitSocketProgress, 300, {
  leading: !0,
  trailing: !0
});
function getSocketHost(url) {
  const host = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i.exec(url)[1];
  return `${/^http:\/\//i.test(url) ? "ws" : "wss"}://${host}`;
}
__name(getSocketHost, "getSocketHost");
function _classPrivateFieldLooseBase$q(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$q, "_classPrivateFieldLooseBase$q");
var id$q = 0;
function _classPrivateFieldLooseKey$q(name) {
  return "__private_" + id$q++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$q, "_classPrivateFieldLooseKey$q");
var _uppy$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$q("uppy"), _events = /* @__PURE__ */ _classPrivateFieldLooseKey$q("events");
const _EventManager = class _EventManager {
  constructor(uppy) {
    Object.defineProperty(this, _uppy$1, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _events, {
      writable: !0,
      value: []
    }), _classPrivateFieldLooseBase$q(this, _uppy$1)[_uppy$1] = uppy;
  }
  on(event, fn) {
    return _classPrivateFieldLooseBase$q(this, _events)[_events].push([event, fn]), _classPrivateFieldLooseBase$q(this, _uppy$1)[_uppy$1].on(event, fn);
  }
  remove() {
    for (const [event, fn] of _classPrivateFieldLooseBase$q(this, _events)[_events].splice(0))
      _classPrivateFieldLooseBase$q(this, _uppy$1)[_uppy$1].off(event, fn);
  }
  onFilePause(fileID, cb) {
    this.on("upload-pause", (targetFileID, isPaused) => {
      fileID === targetFileID && cb(isPaused);
    });
  }
  onFileRemove(fileID, cb) {
    this.on("file-removed", (file) => {
      fileID === file.id && cb(file.id);
    });
  }
  onPause(fileID, cb) {
    this.on("upload-pause", (targetFileID, isPaused) => {
      fileID === targetFileID && cb(isPaused);
    });
  }
  onRetry(fileID, cb) {
    this.on("upload-retry", (targetFileID) => {
      fileID === targetFileID && cb();
    });
  }
  onRetryAll(fileID, cb) {
    this.on("retry-all", () => {
      _classPrivateFieldLooseBase$q(this, _uppy$1)[_uppy$1].getFile(fileID) && cb();
    });
  }
  onPauseAll(fileID, cb) {
    this.on("pause-all", () => {
      _classPrivateFieldLooseBase$q(this, _uppy$1)[_uppy$1].getFile(fileID) && cb();
    });
  }
  onCancelAll(fileID, eventHandler) {
    var _this = this;
    this.on("cancel-all", function() {
      _classPrivateFieldLooseBase$q(_this, _uppy$1)[_uppy$1].getFile(fileID) && eventHandler(...arguments);
    });
  }
  onResumeAll(fileID, cb) {
    this.on("resume-all", () => {
      _classPrivateFieldLooseBase$q(this, _uppy$1)[_uppy$1].getFile(fileID) && cb();
    });
  }
};
__name(_EventManager, "EventManager");
let EventManager = _EventManager;
const _AuthError = class _AuthError extends Error {
  constructor() {
    super("Authorization required"), this.name = "AuthError", this.isAuthError = !0;
  }
};
__name(_AuthError, "AuthError");
let AuthError = _AuthError, _Symbol$for$4, _Symbol$for2;
function _classPrivateFieldLooseBase$p(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$p, "_classPrivateFieldLooseBase$p");
var id$p = 0;
function _classPrivateFieldLooseKey$p(name) {
  return "__private_" + id$p++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$p, "_classPrivateFieldLooseKey$p");
var _queued = /* @__PURE__ */ _classPrivateFieldLooseKey$p("queued"), _emitter = /* @__PURE__ */ _classPrivateFieldLooseKey$p("emitter"), _isOpen = /* @__PURE__ */ _classPrivateFieldLooseKey$p("isOpen"), _socket = /* @__PURE__ */ _classPrivateFieldLooseKey$p("socket"), _handleMessage = /* @__PURE__ */ _classPrivateFieldLooseKey$p("handleMessage");
_Symbol$for$4 = Symbol.for("uppy test: getSocket");
_Symbol$for2 = Symbol.for("uppy test: getQueued");
const _UppySocket = class _UppySocket {
  constructor(opts) {
    Object.defineProperty(this, _queued, {
      writable: !0,
      value: []
    }), Object.defineProperty(this, _emitter, {
      writable: !0,
      value: ee$1()
    }), Object.defineProperty(this, _isOpen, {
      writable: !0,
      value: !1
    }), Object.defineProperty(this, _socket, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _handleMessage, {
      writable: !0,
      value: /* @__PURE__ */ __name((e2) => {
        try {
          const message = JSON.parse(e2.data);
          this.emit(message.action, message.payload);
        } catch (err) {
          console.log(err);
        }
      }, "value")
    }), this.opts = opts, (!opts || opts.autoOpen !== !1) && this.open();
  }
  get isOpen() {
    return _classPrivateFieldLooseBase$p(this, _isOpen)[_isOpen];
  }
  [_Symbol$for$4]() {
    return _classPrivateFieldLooseBase$p(this, _socket)[_socket];
  }
  [_Symbol$for2]() {
    return _classPrivateFieldLooseBase$p(this, _queued)[_queued];
  }
  open() {
    _classPrivateFieldLooseBase$p(this, _socket)[_socket] == null && (_classPrivateFieldLooseBase$p(this, _socket)[_socket] = new WebSocket(this.opts.target), _classPrivateFieldLooseBase$p(this, _socket)[_socket].onopen = () => {
      for (_classPrivateFieldLooseBase$p(this, _isOpen)[_isOpen] = !0; _classPrivateFieldLooseBase$p(this, _queued)[_queued].length > 0 && _classPrivateFieldLooseBase$p(this, _isOpen)[_isOpen]; ) {
        const first = _classPrivateFieldLooseBase$p(this, _queued)[_queued].shift();
        this.send(first.action, first.payload);
      }
    }, _classPrivateFieldLooseBase$p(this, _socket)[_socket].onclose = () => {
      _classPrivateFieldLooseBase$p(this, _isOpen)[_isOpen] = !1, _classPrivateFieldLooseBase$p(this, _socket)[_socket] = null;
    }, _classPrivateFieldLooseBase$p(this, _socket)[_socket].onmessage = _classPrivateFieldLooseBase$p(this, _handleMessage)[_handleMessage]);
  }
  close() {
    var _classPrivateFieldLoo;
    (_classPrivateFieldLoo = _classPrivateFieldLooseBase$p(this, _socket)[_socket]) == null || _classPrivateFieldLoo.close();
  }
  send(action, payload) {
    if (!_classPrivateFieldLooseBase$p(this, _isOpen)[_isOpen]) {
      _classPrivateFieldLooseBase$p(this, _queued)[_queued].push({
        action,
        payload
      });
      return;
    }
    _classPrivateFieldLooseBase$p(this, _socket)[_socket].send(JSON.stringify({
      action,
      payload
    }));
  }
  on(action, handler) {
    _classPrivateFieldLooseBase$p(this, _emitter)[_emitter].on(action, handler);
  }
  emit(action, payload) {
    _classPrivateFieldLooseBase$p(this, _emitter)[_emitter].emit(action, payload);
  }
  once(action, handler) {
    _classPrivateFieldLooseBase$p(this, _emitter)[_emitter].once(action, handler);
  }
};
__name(_UppySocket, "UppySocket");
let UppySocket = _UppySocket, _Symbol$for$3;
function _classPrivateFieldLooseBase$o(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$o, "_classPrivateFieldLooseBase$o");
var id$o = 0;
function _classPrivateFieldLooseKey$o(name) {
  return "__private_" + id$o++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$o, "_classPrivateFieldLooseKey$o");
const packageJson$w = {
  version: "3.4.0"
};
function stripSlash(url) {
  return url.replace(/\/$/, "");
}
__name(stripSlash, "stripSlash");
async function handleJSONResponse(res) {
  if (res.status === 401)
    throw new AuthError();
  const jsonPromise = res.json();
  if (res.ok)
    return jsonPromise;
  let errMsg = `Failed request with status: ${res.status}. ${res.statusText}`;
  try {
    const errData = await jsonPromise;
    errMsg = errData.message ? `${errMsg} message: ${errData.message}` : errMsg, errMsg = errData.requestId ? `${errMsg} request-Id: ${errData.requestId}` : errMsg;
  } catch {
  }
  throw new Error(errMsg);
}
__name(handleJSONResponse, "handleJSONResponse");
const allowedHeadersCache = /* @__PURE__ */ new Map();
var _companionHeaders = /* @__PURE__ */ _classPrivateFieldLooseKey$o("companionHeaders"), _getUrl = /* @__PURE__ */ _classPrivateFieldLooseKey$o("getUrl"), _requestSocketToken = /* @__PURE__ */ _classPrivateFieldLooseKey$o("requestSocketToken");
_Symbol$for$3 = Symbol.for("uppy test: getCompanionHeaders");
const _RequestClient = class _RequestClient {
  constructor(uppy, opts, getQueue) {
    Object.defineProperty(this, _getUrl, {
      value: _getUrl2
    }), Object.defineProperty(this, _companionHeaders, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _requestSocketToken, {
      writable: !0,
      value: /* @__PURE__ */ __name(async (file, postBody) => {
        if (file.remote.url == null)
          throw new Error("Cannot connect to an undefined URL");
        return (await this.post(file.remote.url, {
          ...file.remote.body,
          ...postBody
        })).token;
      }, "value")
    }), this.uppy = uppy, this.opts = opts, this.getQueue = getQueue, this.onReceiveResponse = this.onReceiveResponse.bind(this), _classPrivateFieldLooseBase$o(this, _companionHeaders)[_companionHeaders] = opts == null ? void 0 : opts.companionHeaders;
  }
  setCompanionHeaders(headers) {
    _classPrivateFieldLooseBase$o(this, _companionHeaders)[_companionHeaders] = headers;
  }
  [_Symbol$for$3]() {
    return _classPrivateFieldLooseBase$o(this, _companionHeaders)[_companionHeaders];
  }
  get hostname() {
    const {
      companion
    } = this.uppy.getState(), host = this.opts.companionUrl;
    return stripSlash(companion && companion[host] ? companion[host] : host);
  }
  async headers() {
    return {
      ...{
        Accept: "application/json",
        "Content-Type": "application/json",
        "Uppy-Versions": `@uppy/companion-client=${_RequestClient.VERSION}`
      },
      ..._classPrivateFieldLooseBase$o(this, _companionHeaders)[_companionHeaders]
    };
  }
  onReceiveResponse(_ref) {
    let {
      headers
    } = _ref;
    const companion = this.uppy.getState().companion || {}, host = this.opts.companionUrl;
    headers.has("i-am") && headers.get("i-am") !== companion[host] && this.uppy.setState({
      companion: {
        ...companion,
        [host]: headers.get("i-am")
      }
    });
  }
  /*
    Preflight was added to avoid breaking change between older Companion-client versions and
    newer Companion versions and vice-versa. Usually the break will manifest via CORS errors because a
    version of companion-client could be sending certain headers to a version of Companion server that
    does not support those headers. In which case, the default preflight would lead to CORS.
    So to avoid those errors, we do preflight ourselves, to see what headers the Companion server
    we are communicating with allows. And based on that, companion-client knows what headers to
    send and what headers to not send.
     The preflight only happens once throughout the life-cycle of a certain
    Companion-client <-> Companion-server pair (allowedHeadersCache).
    Subsequent requests use the cached result of the preflight.
    However if there is an error retrieving the allowed headers, we will try again next time
  */
  async preflight(path) {
    const allowedHeadersCached = allowedHeadersCache.get(this.hostname);
    if (allowedHeadersCached != null) return allowedHeadersCached;
    const fallbackAllowedHeaders = ["accept", "content-type", "uppy-auth-token"], promise = (async () => {
      try {
        const header = (await fetch(_classPrivateFieldLooseBase$o(this, _getUrl)[_getUrl](path), {
          method: "OPTIONS"
        })).headers.get("access-control-allow-headers");
        if (header == null || header === "*")
          return allowedHeadersCache.set(this.hostname, fallbackAllowedHeaders), fallbackAllowedHeaders;
        this.uppy.log(`[CompanionClient] adding allowed preflight headers to companion cache: ${this.hostname} ${header}`);
        const allowedHeaders = header.split(",").map((headerName) => headerName.trim().toLowerCase());
        return allowedHeadersCache.set(this.hostname, allowedHeaders), allowedHeaders;
      } catch (err) {
        return this.uppy.log(`[CompanionClient] unable to make preflight request ${err}`, "warning"), allowedHeadersCache.delete(this.hostname), fallbackAllowedHeaders;
      }
    })();
    return allowedHeadersCache.set(this.hostname, promise), promise;
  }
  async preflightAndHeaders(path) {
    const [allowedHeaders, headers] = await Promise.all([this.preflight(path), this.headers()]);
    return Object.fromEntries(Object.entries(headers).filter((_ref2) => {
      let [header] = _ref2;
      return allowedHeaders.includes(header.toLowerCase()) ? !0 : (this.uppy.log(`[CompanionClient] excluding disallowed header ${header}`), !1);
    }));
  }
  /** @protected */
  async request(_ref3) {
    let {
      path,
      method = "GET",
      data,
      skipPostResponse,
      signal
    } = _ref3;
    try {
      const headers = await this.preflightAndHeaders(path), response = await fetchWithNetworkError(_classPrivateFieldLooseBase$o(this, _getUrl)[_getUrl](path), {
        method,
        signal,
        headers,
        credentials: this.opts.companionCookiesRule || "same-origin",
        body: data ? JSON.stringify(data) : null
      });
      return skipPostResponse || this.onReceiveResponse(response), handleJSONResponse(response);
    } catch (err) {
      throw err != null && err.isAuthError ? err : new ErrorWithCause(`Could not ${method} ${_classPrivateFieldLooseBase$o(this, _getUrl)[_getUrl](path)}`, {
        cause: err
      });
    }
  }
  async get(path, options) {
    return options === void 0 && (options = void 0), typeof options == "boolean" && (options = {
      skipPostResponse: options
    }), this.request({
      ...options,
      path
    });
  }
  async post(path, data, options) {
    return options === void 0 && (options = void 0), typeof options == "boolean" && (options = {
      skipPostResponse: options
    }), this.request({
      ...options,
      path,
      method: "POST",
      data
    });
  }
  async delete(path, data, options) {
    return data === void 0 && (data = void 0), typeof options == "boolean" && (options = {
      skipPostResponse: options
    }), this.request({
      ...options,
      path,
      method: "DELETE",
      data
    });
  }
  async uploadRemoteFile(file, reqBody, options) {
    options === void 0 && (options = {});
    try {
      if (file.serverToken)
        return await this.connectToServerSocket(file, this.getQueue());
      const serverToken = await this.getQueue().wrapPromiseFunction(_classPrivateFieldLooseBase$o(this, _requestSocketToken)[_requestSocketToken], {
        priority: -1
      })(file, reqBody).abortOn(options.signal);
      return this.uppy.getState().files[file.id] ? (this.uppy.setFileState(file.id, {
        serverToken
      }), await this.connectToServerSocket(this.uppy.getFile(file.id), this.getQueue())) : void 0;
    } catch (err) {
      var _err$cause;
      if ((err == null || (_err$cause = err.cause) == null ? void 0 : _err$cause.name) === "AbortError")
        return;
      throw this.uppy.setFileState(file.id, {
        serverToken: void 0
      }), this.uppy.emit("upload-error", file, err), err;
    }
  }
  /**
   * @param {UppyFile} file
   */
  async connectToServerSocket(file, queue) {
    return new Promise((resolve3, reject) => {
      const token = file.serverToken, host = getSocketHost(file.remote.companionUrl), socket = new UppySocket({
        target: `${host}/api/${token}`,
        autoOpen: !1
      }), eventManager = new EventManager(this.uppy);
      let queuedRequest;
      eventManager.onFileRemove(file.id, () => {
        socket.send("cancel", {}), queuedRequest.abort(), resolve3(`upload ${file.id} was removed`);
      }), eventManager.onPause(file.id, (isPaused) => {
        isPaused ? (socket.send("pause", {}), queuedRequest.abort()) : (queuedRequest.abort(), queuedRequest = queue.run(() => (socket.open(), socket.send("resume", {}), () => {
        })));
      }), eventManager.onPauseAll(file.id, () => {
        socket.send("pause", {}), queuedRequest.abort();
      }), eventManager.onCancelAll(file.id, function(_temp) {
        let {
          reason
        } = _temp === void 0 ? {} : _temp;
        reason === "user" && (socket.send("cancel", {}), queuedRequest.abort()), resolve3(`upload ${file.id} was canceled`);
      }), eventManager.onResumeAll(file.id, () => {
        queuedRequest.abort(), file.error && socket.send("pause", {}), queuedRequest = queue.run(() => (socket.open(), socket.send("resume", {}), () => {
        }));
      }), eventManager.onRetry(file.id, () => {
        socket.isOpen && (socket.send("pause", {}), socket.send("resume", {}));
      }), eventManager.onRetryAll(file.id, () => {
        socket.isOpen && (socket.send("pause", {}), socket.send("resume", {}));
      }), socket.on("progress", (progressData) => emitSocketProgress$1(this, progressData, file)), socket.on("error", (errData) => {
        const {
          message
        } = errData.error, error = Object.assign(new Error(message), {
          cause: errData.error
        });
        this.opts.useFastRemoteRetry ? socket.close() : this.uppy.setFileState(file.id, {
          serverToken: null
        }), this.uppy.emit("upload-error", file, error), queuedRequest.done(), reject(error);
      }), socket.on("success", (data) => {
        const uploadResp = {
          uploadURL: data.url
        };
        this.uppy.emit("upload-success", file, uploadResp), queuedRequest.done(), socket.close(), resolve3();
      }), queuedRequest = queue.run(() => (file.isPaused ? socket.send("pause", {}) : socket.open(), () => {
      }));
    });
  }
};
__name(_RequestClient, "RequestClient");
let RequestClient = _RequestClient;
function _getUrl2(url) {
  return /^(https?:|)\/\//.test(url) ? url : `${this.hostname}/${url}`;
}
__name(_getUrl2, "_getUrl2");
RequestClient.VERSION = packageJson$w.version;
function setItem(key, value) {
  return new Promise((resolve3) => {
    localStorage.setItem(key, value), resolve3();
  });
}
__name(setItem, "setItem");
function getItem(key) {
  return Promise.resolve(localStorage.getItem(key));
}
__name(getItem, "getItem");
function removeItem(key) {
  return new Promise((resolve3) => {
    localStorage.removeItem(key), resolve3();
  });
}
__name(removeItem, "removeItem");
const tokenStorage = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getItem,
  removeItem,
  setItem
}, Symbol.toStringTag, { value: "Module" }));
function _classPrivateFieldLooseBase$n(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$n, "_classPrivateFieldLooseBase$n");
var id$n = 0;
function _classPrivateFieldLooseKey$n(name) {
  return "__private_" + id$n++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$n, "_classPrivateFieldLooseKey$n");
const getName$1 = /* @__PURE__ */ __name((id2) => id2.split("-").map((s2) => s2.charAt(0).toUpperCase() + s2.slice(1)).join(" "), "getName$1");
function getOrigin() {
  return location.origin;
}
__name(getOrigin, "getOrigin");
function getRegex(value) {
  if (typeof value == "string")
    return new RegExp(`^${value}$`);
  if (value instanceof RegExp)
    return value;
}
__name(getRegex, "getRegex");
function isOriginAllowed(origin2, allowedOrigin) {
  return (Array.isArray(allowedOrigin) ? allowedOrigin.map(getRegex) : [getRegex(allowedOrigin)]).some((pattern) => (pattern == null ? void 0 : pattern.test(origin2)) || (pattern == null ? void 0 : pattern.test(`${origin2}/`)));
}
__name(isOriginAllowed, "isOriginAllowed");
var _refreshingTokenPromise = /* @__PURE__ */ _classPrivateFieldLooseKey$n("refreshingTokenPromise"), _getAuthToken = /* @__PURE__ */ _classPrivateFieldLooseKey$n("getAuthToken"), _removeAuthToken = /* @__PURE__ */ _classPrivateFieldLooseKey$n("removeAuthToken");
const _Provider = class _Provider extends RequestClient {
  constructor(uppy, opts, getQueue) {
    super(uppy, opts, getQueue), Object.defineProperty(this, _removeAuthToken, {
      value: _removeAuthToken2
    }), Object.defineProperty(this, _getAuthToken, {
      value: _getAuthToken2
    }), Object.defineProperty(this, _refreshingTokenPromise, {
      writable: !0,
      value: void 0
    }), this.provider = opts.provider, this.id = this.provider, this.name = this.opts.name || getName$1(this.id), this.pluginId = this.opts.pluginId, this.tokenKey = `companion-${this.pluginId}-auth-token`, this.companionKeysParams = this.opts.companionKeysParams, this.preAuthToken = null;
  }
  async headers() {
    const [headers, token] = await Promise.all([super.headers(), _classPrivateFieldLooseBase$n(this, _getAuthToken)[_getAuthToken]()]), authHeaders = {};
    return token && (authHeaders["uppy-auth-token"] = token), this.companionKeysParams && (authHeaders["uppy-credentials-params"] = btoa(JSON.stringify({
      params: this.companionKeysParams
    }))), {
      ...headers,
      ...authHeaders
    };
  }
  onReceiveResponse(response) {
    super.onReceiveResponse(response);
    const plugin = this.uppy.getPlugin(this.pluginId), authenticated = plugin.getPluginState().authenticated ? response.status !== 401 : response.status < 400;
    return plugin.setPluginState({
      authenticated
    }), response;
  }
  async setAuthToken(token) {
    return this.uppy.getPlugin(this.pluginId).storage.setItem(this.tokenKey, token);
  }
  /**
   * Ensure we have a preauth token if necessary. Attempts to fetch one if we don't,
   * or rejects if loading one fails.
   */
  async ensurePreAuth() {
    if (this.companionKeysParams && !this.preAuthToken && (await this.fetchPreAuthToken(), !this.preAuthToken))
      throw new Error("Could not load authentication data required for third-party login. Please try again later.");
  }
  authUrl(queries) {
    queries === void 0 && (queries = {});
    const params = new URLSearchParams({
      state: btoa(JSON.stringify({
        origin: getOrigin()
      })),
      ...queries
    });
    return this.preAuthToken && params.set("uppyPreAuthToken", this.preAuthToken), `${this.hostname}/${this.id}/connect?${params}`;
  }
  async login(queries) {
    return await this.ensurePreAuth(), new Promise((resolve3, reject) => {
      const link = this.authUrl(queries), authWindow = window.open(link, "_blank"), handleToken = /* @__PURE__ */ __name((e2) => {
        if (e2.source !== authWindow) {
          this.uppy.log.warn("ignoring event from unknown source", e2);
          return;
        }
        const {
          companionAllowedHosts
        } = this.uppy.getPlugin(this.pluginId).opts;
        if (!isOriginAllowed(e2.origin, companionAllowedHosts)) {
          reject(new Error(`rejecting event from ${e2.origin} vs allowed pattern ${companionAllowedHosts}`));
          return;
        }
        const data = typeof e2.data == "string" ? JSON.parse(e2.data) : e2.data;
        if (data.error) {
          const {
            uppy
          } = this, message = uppy.i18n("authAborted");
          uppy.info({
            message
          }, "warning", 5e3), reject(new Error("auth aborted"));
          return;
        }
        if (!data.token) {
          reject(new Error("did not receive token from auth window"));
          return;
        }
        authWindow.close(), window.removeEventListener("message", handleToken), this.setAuthToken(data.token), resolve3();
      }, "handleToken");
      window.addEventListener("message", handleToken);
    });
  }
  refreshTokenUrl() {
    return `${this.hostname}/${this.id}/refresh-token`;
  }
  fileUrl(id2) {
    return `${this.hostname}/${this.id}/get/${id2}`;
  }
  /** @protected */
  async request() {
    await _classPrivateFieldLooseBase$n(this, _refreshingTokenPromise)[_refreshingTokenPromise];
    try {
      return await super.request(...arguments);
    } catch (err) {
      if (!err.isAuthError) throw err;
      return await _classPrivateFieldLooseBase$n(this, _refreshingTokenPromise)[_refreshingTokenPromise], _classPrivateFieldLooseBase$n(this, _refreshingTokenPromise)[_refreshingTokenPromise] = (async () => {
        try {
          const response = await super.request({
            path: this.refreshTokenUrl(),
            method: "POST"
          });
          await this.setAuthToken(response.uppyAuthToken);
        } finally {
          _classPrivateFieldLooseBase$n(this, _refreshingTokenPromise)[_refreshingTokenPromise] = void 0;
        }
      })(), await _classPrivateFieldLooseBase$n(this, _refreshingTokenPromise)[_refreshingTokenPromise], super.request(...arguments);
    }
  }
  async fetchPreAuthToken() {
    if (this.companionKeysParams)
      try {
        const res = await this.post(`${this.id}/preauth/`, {
          params: this.companionKeysParams
        });
        this.preAuthToken = res.token;
      } catch (err) {
        this.uppy.log(`[CompanionClient] unable to fetch preAuthToken ${err}`, "warning");
      }
  }
  list(directory, options) {
    return this.get(`${this.id}/list/${directory || ""}`, options);
  }
  async logout(options) {
    const response = await this.get(`${this.id}/logout`, options);
    return await _classPrivateFieldLooseBase$n(this, _removeAuthToken)[_removeAuthToken](), response;
  }
  static initPlugin(plugin, opts, defaultOpts) {
    if (plugin.type = "acquirer", plugin.files = [], defaultOpts && (plugin.opts = {
      ...defaultOpts,
      ...opts
    }), opts.serverUrl || opts.serverPattern)
      throw new Error("`serverUrl` and `serverPattern` have been renamed to `companionUrl` and `companionAllowedHosts` respectively in the 0.30.5 release. Please consult the docs (for example, https://uppy.io/docs/instagram/ for the Instagram plugin) and use the updated options.`");
    if (opts.companionAllowedHosts) {
      const pattern = opts.companionAllowedHosts;
      if (typeof pattern != "string" && !Array.isArray(pattern) && !(pattern instanceof RegExp))
        throw new TypeError(`${plugin.id}: the option "companionAllowedHosts" must be one of string, Array, RegExp`);
      plugin.opts.companionAllowedHosts = pattern;
    } else /^(?!https?:\/\/).*$/i.test(opts.companionUrl) ? plugin.opts.companionAllowedHosts = `https://${opts.companionUrl.replace(/^\/\//, "")}` : plugin.opts.companionAllowedHosts = new URL(opts.companionUrl).origin;
    plugin.storage = plugin.opts.storage || tokenStorage;
  }
};
__name(_Provider, "Provider");
let Provider = _Provider;
async function _getAuthToken2() {
  return this.uppy.getPlugin(this.pluginId).storage.getItem(this.tokenKey);
}
__name(_getAuthToken2, "_getAuthToken2");
async function _removeAuthToken2() {
  return this.uppy.getPlugin(this.pluginId).storage.removeItem(this.tokenKey);
}
__name(_removeAuthToken2, "_removeAuthToken2");
const getName = /* @__PURE__ */ __name((id2) => id2.split("-").map((s2) => s2.charAt(0).toUpperCase() + s2.slice(1)).join(" "), "getName"), _SearchProvider = class _SearchProvider extends RequestClient {
  constructor(uppy, opts) {
    super(uppy, opts), this.provider = opts.provider, this.id = this.provider, this.name = this.opts.name || getName(this.id), this.pluginId = this.opts.pluginId;
  }
  fileUrl(id2) {
    return `${this.hostname}/search/${this.id}/get/${id2}`;
  }
  search(text, queries) {
    return this.get(`search/${this.id}/list?q=${encodeURIComponent(text)}${queries ? `&${queries}` : ""}`);
  }
};
__name(_SearchProvider, "SearchProvider");
let SearchProvider = _SearchProvider;
var eventemitter3 = { exports: {} };
(function(module) {
  var has2 = Object.prototype.hasOwnProperty, prefix = "~";
  function Events() {
  }
  __name(Events, "Events"), Object.create && (Events.prototype = /* @__PURE__ */ Object.create(null), new Events().__proto__ || (prefix = !1));
  function EE(fn, context, once) {
    this.fn = fn, this.context = context, this.once = once || !1;
  }
  __name(EE, "EE");
  function addListener2(emitter, event, fn, context, once) {
    if (typeof fn != "function")
      throw new TypeError("The listener must be a function");
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    return emitter._events[evt] ? emitter._events[evt].fn ? emitter._events[evt] = [emitter._events[evt], listener] : emitter._events[evt].push(listener) : (emitter._events[evt] = listener, emitter._eventsCount++), emitter;
  }
  __name(addListener2, "addListener");
  function clearEvent(emitter, evt) {
    --emitter._eventsCount === 0 ? emitter._events = new Events() : delete emitter._events[evt];
  }
  __name(clearEvent, "clearEvent");
  function EventEmitter2() {
    this._events = new Events(), this._eventsCount = 0;
  }
  __name(EventEmitter2, "EventEmitter"), EventEmitter2.prototype.eventNames = /* @__PURE__ */ __name(function() {
    var names = [], events2, name;
    if (this._eventsCount === 0) return names;
    for (name in events2 = this._events)
      has2.call(events2, name) && names.push(prefix ? name.slice(1) : name);
    return Object.getOwnPropertySymbols ? names.concat(Object.getOwnPropertySymbols(events2)) : names;
  }, "eventNames"), EventEmitter2.prototype.listeners = /* @__PURE__ */ __name(function(event) {
    var evt = prefix ? prefix + event : event, handlers2 = this._events[evt];
    if (!handlers2) return [];
    if (handlers2.fn) return [handlers2.fn];
    for (var i2 = 0, l2 = handlers2.length, ee2 = new Array(l2); i2 < l2; i2++)
      ee2[i2] = handlers2[i2].fn;
    return ee2;
  }, "listeners"), EventEmitter2.prototype.listenerCount = /* @__PURE__ */ __name(function(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    return listeners ? listeners.fn ? 1 : listeners.length : 0;
  }, "listenerCount"), EventEmitter2.prototype.emit = /* @__PURE__ */ __name(function(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return !1;
    var listeners = this._events[evt], len2 = arguments.length, args, i2;
    if (listeners.fn) {
      switch (listeners.once && this.removeListener(event, listeners.fn, void 0, !0), len2) {
        case 1:
          return listeners.fn.call(listeners.context), !0;
        case 2:
          return listeners.fn.call(listeners.context, a1), !0;
        case 3:
          return listeners.fn.call(listeners.context, a1, a2), !0;
        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), !0;
        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), !0;
        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), !0;
      }
      for (i2 = 1, args = new Array(len2 - 1); i2 < len2; i2++)
        args[i2 - 1] = arguments[i2];
      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length, j2;
      for (i2 = 0; i2 < length; i2++)
        switch (listeners[i2].once && this.removeListener(event, listeners[i2].fn, void 0, !0), len2) {
          case 1:
            listeners[i2].fn.call(listeners[i2].context);
            break;
          case 2:
            listeners[i2].fn.call(listeners[i2].context, a1);
            break;
          case 3:
            listeners[i2].fn.call(listeners[i2].context, a1, a2);
            break;
          case 4:
            listeners[i2].fn.call(listeners[i2].context, a1, a2, a3);
            break;
          default:
            if (!args) for (j2 = 1, args = new Array(len2 - 1); j2 < len2; j2++)
              args[j2 - 1] = arguments[j2];
            listeners[i2].fn.apply(listeners[i2].context, args);
        }
    }
    return !0;
  }, "emit"), EventEmitter2.prototype.on = /* @__PURE__ */ __name(function(event, fn, context) {
    return addListener2(this, event, fn, context, !1);
  }, "on"), EventEmitter2.prototype.once = /* @__PURE__ */ __name(function(event, fn, context) {
    return addListener2(this, event, fn, context, !0);
  }, "once"), EventEmitter2.prototype.removeListener = /* @__PURE__ */ __name(function(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn)
      return clearEvent(this, evt), this;
    var listeners = this._events[evt];
    if (listeners.fn)
      listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context) && clearEvent(this, evt);
    else {
      for (var i2 = 0, events2 = [], length = listeners.length; i2 < length; i2++)
        (listeners[i2].fn !== fn || once && !listeners[i2].once || context && listeners[i2].context !== context) && events2.push(listeners[i2]);
      events2.length ? this._events[evt] = events2.length === 1 ? events2[0] : events2 : clearEvent(this, evt);
    }
    return this;
  }, "removeListener"), EventEmitter2.prototype.removeAllListeners = /* @__PURE__ */ __name(function(event) {
    var evt;
    return event ? (evt = prefix ? prefix + event : event, this._events[evt] && clearEvent(this, evt)) : (this._events = new Events(), this._eventsCount = 0), this;
  }, "removeAllListeners"), EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener, EventEmitter2.prototype.addListener = EventEmitter2.prototype.on, EventEmitter2.prefixed = prefix, EventEmitter2.EventEmitter = EventEmitter2, module.exports = EventEmitter2;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports), _TimeoutError = class _TimeoutError extends Error {
  constructor(message) {
    super(message), this.name = "TimeoutError";
  }
};
__name(_TimeoutError, "TimeoutError");
let TimeoutError = _TimeoutError;
var _a;
let AbortError$1 = (_a = class extends Error {
  constructor(message) {
    super(), this.name = "AbortError", this.message = message;
  }
}, __name(_a, "AbortError"), _a);
const getDOMException = /* @__PURE__ */ __name((errorMessage) => globalThis.DOMException === void 0 ? new AbortError$1(errorMessage) : new DOMException(errorMessage), "getDOMException"), getAbortedReason = /* @__PURE__ */ __name((signal) => {
  const reason = signal.reason === void 0 ? getDOMException("This operation was aborted.") : signal.reason;
  return reason instanceof Error ? reason : getDOMException(reason);
}, "getAbortedReason");
function pTimeout(promise, milliseconds, fallback, options) {
  let timer;
  const cancelablePromise = new Promise((resolve3, reject) => {
    if (typeof milliseconds != "number" || Math.sign(milliseconds) !== 1)
      throw new TypeError(`Expected \`milliseconds\` to be a positive number, got \`${milliseconds}\``);
    if (milliseconds === Number.POSITIVE_INFINITY) {
      resolve3(promise);
      return;
    }
    if (options = {
      customTimers: { setTimeout, clearTimeout },
      ...options
    }, options.signal) {
      const { signal } = options;
      signal.aborted && reject(getAbortedReason(signal)), signal.addEventListener("abort", () => {
        reject(getAbortedReason(signal));
      });
    }
    timer = options.customTimers.setTimeout.call(void 0, () => {
      const message = `Promise timed out after ${milliseconds} milliseconds`, timeoutError = fallback instanceof Error ? fallback : new TimeoutError(message);
      typeof promise.cancel == "function" && promise.cancel(), reject(timeoutError);
    }, milliseconds), (async () => {
      try {
        resolve3(await promise);
      } catch (error) {
        reject(error);
      } finally {
        options.customTimers.clearTimeout.call(void 0, timer);
      }
    })();
  });
  return cancelablePromise.clear = () => {
    clearTimeout(timer), timer = void 0;
  }, cancelablePromise;
}
__name(pTimeout, "pTimeout");
function lowerBound(array, value, comparator) {
  let first = 0, count = array.length;
  for (; count > 0; ) {
    const step = Math.trunc(count / 2);
    let it = first + step;
    comparator(array[it], value) <= 0 ? (first = ++it, count -= step + 1) : count = step;
  }
  return first;
}
__name(lowerBound, "lowerBound");
var __classPrivateFieldGet$1 = function(receiver, state, kind, f2) {
  if (kind === "a" && !f2) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state == "function" ? receiver !== state || !f2 : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f2 : kind === "a" ? f2.call(receiver) : f2 ? f2.value : state.get(receiver);
}, _PriorityQueue_queue;
const _PriorityQueue = class _PriorityQueue {
  constructor() {
    _PriorityQueue_queue.set(this, []);
  }
  enqueue(run, options) {
    options = {
      priority: 0,
      ...options
    };
    const element = {
      priority: options.priority,
      run
    };
    if (this.size && __classPrivateFieldGet$1(this, _PriorityQueue_queue, "f")[this.size - 1].priority >= options.priority) {
      __classPrivateFieldGet$1(this, _PriorityQueue_queue, "f").push(element);
      return;
    }
    const index = lowerBound(__classPrivateFieldGet$1(this, _PriorityQueue_queue, "f"), element, (a2, b2) => b2.priority - a2.priority);
    __classPrivateFieldGet$1(this, _PriorityQueue_queue, "f").splice(index, 0, element);
  }
  dequeue() {
    const item = __classPrivateFieldGet$1(this, _PriorityQueue_queue, "f").shift();
    return item == null ? void 0 : item.run;
  }
  filter(options) {
    return __classPrivateFieldGet$1(this, _PriorityQueue_queue, "f").filter((element) => element.priority === options.priority).map((element) => element.run);
  }
  get size() {
    return __classPrivateFieldGet$1(this, _PriorityQueue_queue, "f").length;
  }
};
__name(_PriorityQueue, "PriorityQueue");
let PriorityQueue = _PriorityQueue;
_PriorityQueue_queue = /* @__PURE__ */ new WeakMap();
var __classPrivateFieldSet = function(receiver, state, value, kind, f2) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f2) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state == "function" ? receiver !== state || !f2 : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f2.call(receiver, value) : f2 ? f2.value = value : state.set(receiver, value), value;
}, __classPrivateFieldGet = function(receiver, state, kind, f2) {
  if (kind === "a" && !f2) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state == "function" ? receiver !== state || !f2 : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f2 : kind === "a" ? f2.call(receiver) : f2 ? f2.value : state.get(receiver);
}, _PQueue_instances, _PQueue_carryoverConcurrencyCount, _PQueue_isIntervalIgnored, _PQueue_intervalCount, _PQueue_intervalCap, _PQueue_interval, _PQueue_intervalEnd, _PQueue_intervalId, _PQueue_timeoutId, _PQueue_queue, _PQueue_queueClass, _PQueue_pending, _PQueue_concurrency, _PQueue_isPaused, _PQueue_throwOnTimeout, _PQueue_doesIntervalAllowAnother_get, _PQueue_doesConcurrentAllowAnother_get, _PQueue_next, _PQueue_onResumeInterval, _PQueue_isIntervalPaused_get, _PQueue_tryToStartAnother, _PQueue_initializeIntervalIfNeeded, _PQueue_onInterval, _PQueue_processQueue, _PQueue_throwOnAbort, _PQueue_onEvent;
const _AbortError = class _AbortError extends Error {
};
__name(_AbortError, "AbortError");
let AbortError = _AbortError;
const _PQueue = class _PQueue extends EventEmitter {
  // TODO: The `throwOnTimeout` option should affect the return types of `add()` and `addAll()`
  constructor(options) {
    var _a6, _b, _c2, _d;
    if (super(), _PQueue_instances.add(this), _PQueue_carryoverConcurrencyCount.set(this, void 0), _PQueue_isIntervalIgnored.set(this, void 0), _PQueue_intervalCount.set(this, 0), _PQueue_intervalCap.set(this, void 0), _PQueue_interval.set(this, void 0), _PQueue_intervalEnd.set(this, 0), _PQueue_intervalId.set(this, void 0), _PQueue_timeoutId.set(this, void 0), _PQueue_queue.set(this, void 0), _PQueue_queueClass.set(this, void 0), _PQueue_pending.set(this, 0), _PQueue_concurrency.set(this, void 0), _PQueue_isPaused.set(this, void 0), _PQueue_throwOnTimeout.set(this, void 0), Object.defineProperty(this, "timeout", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), options = {
      carryoverConcurrencyCount: !1,
      intervalCap: Number.POSITIVE_INFINITY,
      interval: 0,
      concurrency: Number.POSITIVE_INFINITY,
      autoStart: !0,
      queueClass: PriorityQueue,
      ...options
    }, !(typeof options.intervalCap == "number" && options.intervalCap >= 1))
      throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${(_b = (_a6 = options.intervalCap) === null || _a6 === void 0 ? void 0 : _a6.toString()) !== null && _b !== void 0 ? _b : ""}\` (${typeof options.intervalCap})`);
    if (options.interval === void 0 || !(Number.isFinite(options.interval) && options.interval >= 0))
      throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${(_d = (_c2 = options.interval) === null || _c2 === void 0 ? void 0 : _c2.toString()) !== null && _d !== void 0 ? _d : ""}\` (${typeof options.interval})`);
    __classPrivateFieldSet(this, _PQueue_carryoverConcurrencyCount, options.carryoverConcurrencyCount, "f"), __classPrivateFieldSet(this, _PQueue_isIntervalIgnored, options.intervalCap === Number.POSITIVE_INFINITY || options.interval === 0, "f"), __classPrivateFieldSet(this, _PQueue_intervalCap, options.intervalCap, "f"), __classPrivateFieldSet(this, _PQueue_interval, options.interval, "f"), __classPrivateFieldSet(this, _PQueue_queue, new options.queueClass(), "f"), __classPrivateFieldSet(this, _PQueue_queueClass, options.queueClass, "f"), this.concurrency = options.concurrency, this.timeout = options.timeout, __classPrivateFieldSet(this, _PQueue_throwOnTimeout, options.throwOnTimeout === !0, "f"), __classPrivateFieldSet(this, _PQueue_isPaused, options.autoStart === !1, "f");
  }
  get concurrency() {
    return __classPrivateFieldGet(this, _PQueue_concurrency, "f");
  }
  set concurrency(newConcurrency) {
    if (!(typeof newConcurrency == "number" && newConcurrency >= 1))
      throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${newConcurrency}\` (${typeof newConcurrency})`);
    __classPrivateFieldSet(this, _PQueue_concurrency, newConcurrency, "f"), __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_processQueue).call(this);
  }
  async add(function_, options = {}) {
    return options = {
      timeout: this.timeout,
      throwOnTimeout: __classPrivateFieldGet(this, _PQueue_throwOnTimeout, "f"),
      ...options
    }, new Promise((resolve3, reject) => {
      __classPrivateFieldGet(this, _PQueue_queue, "f").enqueue(async () => {
        var _a6, _b, _c2;
        __classPrivateFieldSet(this, _PQueue_pending, (_b = __classPrivateFieldGet(this, _PQueue_pending, "f"), _b++, _b), "f"), __classPrivateFieldSet(this, _PQueue_intervalCount, (_c2 = __classPrivateFieldGet(this, _PQueue_intervalCount, "f"), _c2++, _c2), "f");
        try {
          if (!((_a6 = options.signal) === null || _a6 === void 0) && _a6.aborted)
            throw new AbortError("The task was aborted.");
          let operation = function_({ signal: options.signal });
          options.timeout && (operation = pTimeout(Promise.resolve(operation), options.timeout)), options.signal && (operation = Promise.race([operation, __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_throwOnAbort).call(this, options.signal)]));
          const result2 = await operation;
          resolve3(result2), this.emit("completed", result2);
        } catch (error) {
          if (error instanceof TimeoutError && !options.throwOnTimeout) {
            resolve3();
            return;
          }
          reject(error), this.emit("error", error);
        } finally {
          __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_next).call(this);
        }
      }, options), this.emit("add"), __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this);
    });
  }
  async addAll(functions, options) {
    return Promise.all(functions.map(async (function_) => this.add(function_, options)));
  }
  /**
  Start (or resume) executing enqueued tasks within concurrency limit. No need to call this if queue is not paused (via `options.autoStart = false` or by `.pause()` method.)
  */
  start() {
    return __classPrivateFieldGet(this, _PQueue_isPaused, "f") ? (__classPrivateFieldSet(this, _PQueue_isPaused, !1, "f"), __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_processQueue).call(this), this) : this;
  }
  /**
  Put queue execution on hold.
  */
  pause() {
    __classPrivateFieldSet(this, _PQueue_isPaused, !0, "f");
  }
  /**
  Clear the queue.
  */
  clear() {
    __classPrivateFieldSet(this, _PQueue_queue, new (__classPrivateFieldGet(this, _PQueue_queueClass, "f"))(), "f");
  }
  /**
      Can be called multiple times. Useful if you for example add additional items at a later time.
  
      @returns A promise that settles when the queue becomes empty.
      */
  async onEmpty() {
    __classPrivateFieldGet(this, _PQueue_queue, "f").size !== 0 && await __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "empty");
  }
  /**
      @returns A promise that settles when the queue size is less than the given limit: `queue.size < limit`.
  
      If you want to avoid having the queue grow beyond a certain size you can `await queue.onSizeLessThan()` before adding a new item.
  
      Note that this only limits the number of items waiting to start. There could still be up to `concurrency` jobs already running that this call does not include in its calculation.
      */
  async onSizeLessThan(limit) {
    __classPrivateFieldGet(this, _PQueue_queue, "f").size < limit || await __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "next", () => __classPrivateFieldGet(this, _PQueue_queue, "f").size < limit);
  }
  /**
      The difference with `.onEmpty` is that `.onIdle` guarantees that all work from the queue has finished. `.onEmpty` merely signals that the queue is empty, but it could mean that some promises haven't completed yet.
  
      @returns A promise that settles when the queue becomes empty, and all promises have completed; `queue.size === 0 && queue.pending === 0`.
      */
  async onIdle() {
    __classPrivateFieldGet(this, _PQueue_pending, "f") === 0 && __classPrivateFieldGet(this, _PQueue_queue, "f").size === 0 || await __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "idle");
  }
  /**
  Size of the queue, the number of queued items waiting to run.
  */
  get size() {
    return __classPrivateFieldGet(this, _PQueue_queue, "f").size;
  }
  /**
      Size of the queue, filtered by the given options.
  
      For example, this can be used to find the number of items remaining in the queue with a specific priority level.
      */
  sizeBy(options) {
    return __classPrivateFieldGet(this, _PQueue_queue, "f").filter(options).length;
  }
  /**
  Number of running items (no longer in the queue).
  */
  get pending() {
    return __classPrivateFieldGet(this, _PQueue_pending, "f");
  }
  /**
  Whether the queue is currently paused.
  */
  get isPaused() {
    return __classPrivateFieldGet(this, _PQueue_isPaused, "f");
  }
};
__name(_PQueue, "PQueue");
let PQueue = _PQueue;
_PQueue_carryoverConcurrencyCount = /* @__PURE__ */ new WeakMap(), _PQueue_isIntervalIgnored = /* @__PURE__ */ new WeakMap(), _PQueue_intervalCount = /* @__PURE__ */ new WeakMap(), _PQueue_intervalCap = /* @__PURE__ */ new WeakMap(), _PQueue_interval = /* @__PURE__ */ new WeakMap(), _PQueue_intervalEnd = /* @__PURE__ */ new WeakMap(), _PQueue_intervalId = /* @__PURE__ */ new WeakMap(), _PQueue_timeoutId = /* @__PURE__ */ new WeakMap(), _PQueue_queue = /* @__PURE__ */ new WeakMap(), _PQueue_queueClass = /* @__PURE__ */ new WeakMap(), _PQueue_pending = /* @__PURE__ */ new WeakMap(), _PQueue_concurrency = /* @__PURE__ */ new WeakMap(), _PQueue_isPaused = /* @__PURE__ */ new WeakMap(), _PQueue_throwOnTimeout = /* @__PURE__ */ new WeakMap(), _PQueue_instances = /* @__PURE__ */ new WeakSet(), _PQueue_doesIntervalAllowAnother_get = /* @__PURE__ */ __name(function() {
  return __classPrivateFieldGet(this, _PQueue_isIntervalIgnored, "f") || __classPrivateFieldGet(this, _PQueue_intervalCount, "f") < __classPrivateFieldGet(this, _PQueue_intervalCap, "f");
}, "_PQueue_doesIntervalAllowAnother_get"), _PQueue_doesConcurrentAllowAnother_get = /* @__PURE__ */ __name(function() {
  return __classPrivateFieldGet(this, _PQueue_pending, "f") < __classPrivateFieldGet(this, _PQueue_concurrency, "f");
}, "_PQueue_doesConcurrentAllowAnother_get"), _PQueue_next = /* @__PURE__ */ __name(function() {
  var _a6;
  __classPrivateFieldSet(this, _PQueue_pending, (_a6 = __classPrivateFieldGet(this, _PQueue_pending, "f"), _a6--, _a6), "f"), __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this), this.emit("next");
}, "_PQueue_next"), _PQueue_onResumeInterval = /* @__PURE__ */ __name(function() {
  __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_onInterval).call(this), __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_initializeIntervalIfNeeded).call(this), __classPrivateFieldSet(this, _PQueue_timeoutId, void 0, "f");
}, "_PQueue_onResumeInterval"), _PQueue_isIntervalPaused_get = /* @__PURE__ */ __name(function() {
  const now2 = Date.now();
  if (__classPrivateFieldGet(this, _PQueue_intervalId, "f") === void 0) {
    const delay = __classPrivateFieldGet(this, _PQueue_intervalEnd, "f") - now2;
    if (delay < 0)
      __classPrivateFieldSet(this, _PQueue_intervalCount, __classPrivateFieldGet(this, _PQueue_carryoverConcurrencyCount, "f") ? __classPrivateFieldGet(this, _PQueue_pending, "f") : 0, "f");
    else
      return __classPrivateFieldGet(this, _PQueue_timeoutId, "f") === void 0 && __classPrivateFieldSet(this, _PQueue_timeoutId, setTimeout(() => {
        __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_onResumeInterval).call(this);
      }, delay), "f"), !0;
  }
  return !1;
}, "_PQueue_isIntervalPaused_get"), _PQueue_tryToStartAnother = /* @__PURE__ */ __name(function() {
  if (__classPrivateFieldGet(this, _PQueue_queue, "f").size === 0)
    return __classPrivateFieldGet(this, _PQueue_intervalId, "f") && clearInterval(__classPrivateFieldGet(this, _PQueue_intervalId, "f")), __classPrivateFieldSet(this, _PQueue_intervalId, void 0, "f"), this.emit("empty"), __classPrivateFieldGet(this, _PQueue_pending, "f") === 0 && this.emit("idle"), !1;
  if (!__classPrivateFieldGet(this, _PQueue_isPaused, "f")) {
    const canInitializeInterval = !__classPrivateFieldGet(this, _PQueue_instances, "a", _PQueue_isIntervalPaused_get);
    if (__classPrivateFieldGet(this, _PQueue_instances, "a", _PQueue_doesIntervalAllowAnother_get) && __classPrivateFieldGet(this, _PQueue_instances, "a", _PQueue_doesConcurrentAllowAnother_get)) {
      const job = __classPrivateFieldGet(this, _PQueue_queue, "f").dequeue();
      return job ? (this.emit("active"), job(), canInitializeInterval && __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_initializeIntervalIfNeeded).call(this), !0) : !1;
    }
  }
  return !1;
}, "_PQueue_tryToStartAnother"), _PQueue_initializeIntervalIfNeeded = /* @__PURE__ */ __name(function() {
  __classPrivateFieldGet(this, _PQueue_isIntervalIgnored, "f") || __classPrivateFieldGet(this, _PQueue_intervalId, "f") !== void 0 || (__classPrivateFieldSet(this, _PQueue_intervalId, setInterval(() => {
    __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_onInterval).call(this);
  }, __classPrivateFieldGet(this, _PQueue_interval, "f")), "f"), __classPrivateFieldSet(this, _PQueue_intervalEnd, Date.now() + __classPrivateFieldGet(this, _PQueue_interval, "f"), "f"));
}, "_PQueue_initializeIntervalIfNeeded"), _PQueue_onInterval = /* @__PURE__ */ __name(function() {
  __classPrivateFieldGet(this, _PQueue_intervalCount, "f") === 0 && __classPrivateFieldGet(this, _PQueue_pending, "f") === 0 && __classPrivateFieldGet(this, _PQueue_intervalId, "f") && (clearInterval(__classPrivateFieldGet(this, _PQueue_intervalId, "f")), __classPrivateFieldSet(this, _PQueue_intervalId, void 0, "f")), __classPrivateFieldSet(this, _PQueue_intervalCount, __classPrivateFieldGet(this, _PQueue_carryoverConcurrencyCount, "f") ? __classPrivateFieldGet(this, _PQueue_pending, "f") : 0, "f"), __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_processQueue).call(this);
}, "_PQueue_onInterval"), _PQueue_processQueue = /* @__PURE__ */ __name(function() {
  for (; __classPrivateFieldGet(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this); )
    ;
}, "_PQueue_processQueue"), _PQueue_throwOnAbort = /* @__PURE__ */ __name(async function(signal) {
  return new Promise((_resolve2, reject) => {
    signal.addEventListener("abort", () => {
      reject(new AbortError("The task was aborted."));
    }, { once: !0 });
  });
}, "_PQueue_throwOnAbort"), _PQueue_onEvent = /* @__PURE__ */ __name(async function(event, filter2) {
  return new Promise((resolve3) => {
    const listener = /* @__PURE__ */ __name(() => {
      filter2 && !filter2() || (this.off(event, listener), resolve3());
    }, "listener");
    this.on(event, listener);
  });
}, "_PQueue_onEvent");
function GoogleIcon() {
  return y$1("svg", {
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, y$1("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, y$1("circle", {
    fill: "#FFF",
    cx: "13",
    cy: "13",
    r: "13"
  }), y$1("path", {
    d: "M21.64 13.205c0-.639-.057-1.252-.164-1.841H13v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
    fill: "#4285F4",
    "fill-rule": "nonzero"
  }), y$1("path", {
    d: "M13 22c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.957v2.332A8.997 8.997 0 0013 22z",
    fill: "#34A853",
    "fill-rule": "nonzero"
  }), y$1("path", {
    d: "M7.964 14.71A5.41 5.41 0 017.682 13c0-.593.102-1.17.282-1.71V8.958H4.957A8.996 8.996 0 004 13c0 1.452.348 2.827.957 4.042l3.007-2.332z",
    fill: "#FBBC05",
    "fill-rule": "nonzero"
  }), y$1("path", {
    d: "M13 7.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C17.463 4.891 15.426 4 13 4a8.997 8.997 0 00-8.043 4.958l3.007 2.332C8.672 9.163 10.656 7.58 13 7.58z",
    fill: "#EA4335",
    "fill-rule": "nonzero"
  }), y$1("path", {
    d: "M4 4h18v18H4z"
  })));
}
__name(GoogleIcon, "GoogleIcon");
function AuthView(props) {
  const {
    pluginName,
    pluginIcon,
    i18nArray,
    handleAuth
  } = props, isGoogleDrive = pluginName === "Google Drive", pluginNameComponent = y$1("span", {
    className: "uppy-Provider-authTitleName"
  }, pluginName, y$1("br", null));
  return y$1("div", {
    className: "uppy-Provider-auth"
  }, y$1("div", {
    className: "uppy-Provider-authIcon"
  }, pluginIcon()), y$1("div", {
    className: "uppy-Provider-authTitle"
  }, i18nArray("authenticateWithTitle", {
    pluginName: pluginNameComponent
  })), isGoogleDrive ? y$1("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn uppy-Provider-btn-google",
    onClick: handleAuth,
    "data-uppy-super-focusable": !0
  }, y$1(GoogleIcon, null), i18nArray("signInWithGoogle")) : y$1("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
    onClick: handleAuth,
    "data-uppy-super-focusable": !0
  }, i18nArray("authenticateWith", {
    pluginName
  })));
}
__name(AuthView, "AuthView");
const User = /* @__PURE__ */ __name((_ref) => {
  let {
    i18n,
    logout,
    username
  } = _ref;
  return [y$1("span", {
    className: "uppy-ProviderBrowser-user",
    key: "username"
  }, username), y$1("button", {
    type: "button",
    onClick: logout,
    className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
    key: "logout"
  }, i18n("logOut"))];
}, "User"), Breadcrumb = /* @__PURE__ */ __name((props) => {
  const {
    getFolder,
    title,
    isLast
  } = props;
  return y$1(k$2, null, y$1("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn",
    onClick: getFolder
  }, title), isLast ? "" : " / ");
}, "Breadcrumb"), Breadcrumbs = /* @__PURE__ */ __name((props) => {
  const {
    getFolder,
    title,
    breadcrumbsIcon,
    breadcrumbs
  } = props;
  return y$1("div", {
    className: "uppy-Provider-breadcrumbs"
  }, y$1("div", {
    className: "uppy-Provider-breadcrumbsIcon"
  }, breadcrumbsIcon), breadcrumbs.map((directory, i2) => y$1(Breadcrumb, {
    key: directory.id,
    getFolder: /* @__PURE__ */ __name(() => getFolder(directory.requestPath), "getFolder"),
    title: i2 === 0 ? title : directory.name,
    isLast: i2 + 1 === breadcrumbs.length
  })));
}, "Breadcrumbs"), Header = /* @__PURE__ */ __name((props) => {
  const components = [];
  return props.showBreadcrumbs && components.push(Breadcrumbs({
    getFolder: props.getFolder,
    breadcrumbs: props.breadcrumbs,
    breadcrumbsIcon: props.pluginIcon && props.pluginIcon(),
    title: props.title
  })), components.push(User({
    logout: props.logout,
    username: props.username,
    i18n: props.i18n
  })), components;
}, "Header");
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      for (var classes = [], i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (arg) {
          var argType = typeof arg;
          if (argType === "string" || argType === "number")
            classes.push(arg);
          else if (Array.isArray(arg)) {
            if (arg.length) {
              var inner = classNames2.apply(null, arg);
              inner && classes.push(inner);
            }
          } else if (argType === "object") {
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
              classes.push(arg.toString());
              continue;
            }
            for (var key in arg)
              hasOwn.call(arg, key) && arg[key] && classes.push(key);
          }
        }
      }
      return classes.join(" ");
    }
    __name(classNames2, "classNames"), module.exports ? (classNames2.default = classNames2, module.exports = classNames2) : window.classNames = classNames2;
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
function remoteFileObjToLocal(file) {
  return {
    ...file,
    type: file.mimeType,
    extension: file.name ? getFileNameAndExtension(file.name).extension : null
  };
}
__name(remoteFileObjToLocal, "remoteFileObjToLocal");
var t$1, r$1, u$1, i$1, o$1 = 0, f$1 = [], c$1 = [], e$1 = l$2.__b, a$1 = l$2.__r, v$1 = l$2.diffed, l$1 = l$2.__c, m$1 = l$2.unmount;
function d$1(t2, u2) {
  l$2.__h && l$2.__h(r$1, t2, o$1 || u2), o$1 = 0;
  var i2 = r$1.__H || (r$1.__H = { __: [], __h: [] });
  return t2 >= i2.__.length && i2.__.push({ __V: c$1 }), i2.__[t2];
}
__name(d$1, "d$1");
function h$1(n2) {
  return o$1 = 1, s$1(B$1, n2);
}
__name(h$1, "h$1");
function s$1(n2, u2, i2) {
  var o2 = d$1(t$1++, 2);
  if (o2.t = n2, !o2.__c && (o2.__ = [B$1(void 0, u2), function(n3) {
    var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
    t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
  }], o2.__c = r$1, !r$1.u)) {
    var f2 = /* @__PURE__ */ __name(function(n3, t2, r2) {
      if (!o2.__c.__H) return !0;
      var u3 = o2.__c.__H.__.filter(function(n4) {
        return n4.__c;
      });
      if (u3.every(function(n4) {
        return !n4.__N;
      })) return !c2 || c2.call(this, n3, t2, r2);
      var i3 = !1;
      return u3.forEach(function(n4) {
        if (n4.__N) {
          var t3 = n4.__[0];
          n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = !0);
        }
      }), !(!i3 && o2.__c.props === n3) && (!c2 || c2.call(this, n3, t2, r2));
    }, "f");
    r$1.u = !0;
    var c2 = r$1.shouldComponentUpdate, e2 = r$1.componentWillUpdate;
    r$1.componentWillUpdate = function(n3, t2, r2) {
      if (this.__e) {
        var u3 = c2;
        c2 = void 0, f2(n3, t2, r2), c2 = u3;
      }
      e2 && e2.call(this, n3, t2, r2);
    }, r$1.shouldComponentUpdate = f2;
  }
  return o2.__N || o2.__;
}
__name(s$1, "s$1");
function p$1(u2, i2) {
  var o2 = d$1(t$1++, 3);
  !l$2.__s && z$1(o2.__H, i2) && (o2.__ = u2, o2.i = i2, r$1.__H.__h.push(o2));
}
__name(p$1, "p$1");
function _$1(n2) {
  return o$1 = 5, F$1(function() {
    return { current: n2 };
  }, []);
}
__name(_$1, "_$1");
function F$1(n2, r2) {
  var u2 = d$1(t$1++, 7);
  return z$1(u2.__H, r2) ? (u2.__V = n2(), u2.i = r2, u2.__h = n2, u2.__V) : u2.__;
}
__name(F$1, "F$1");
function T$1(n2, t2) {
  return o$1 = 8, F$1(function() {
    return n2;
  }, t2);
}
__name(T$1, "T$1");
function b$1() {
  for (var t2; t2 = f$1.shift(); ) if (t2.__P && t2.__H) try {
    t2.__H.__h.forEach(k$1), t2.__H.__h.forEach(w$1), t2.__H.__h = [];
  } catch (r2) {
    t2.__H.__h = [], l$2.__e(r2, t2.__v);
  }
}
__name(b$1, "b$1");
l$2.__b = function(n2) {
  r$1 = null, e$1 && e$1(n2);
}, l$2.__r = function(n2) {
  a$1 && a$1(n2), t$1 = 0;
  var i2 = (r$1 = n2.__c).__H;
  i2 && (u$1 === r$1 ? (i2.__h = [], r$1.__h = [], i2.__.forEach(function(n3) {
    n3.__N && (n3.__ = n3.__N), n3.__V = c$1, n3.__N = n3.i = void 0;
  })) : (i2.__h.forEach(k$1), i2.__h.forEach(w$1), i2.__h = [], t$1 = 0)), u$1 = r$1;
}, l$2.diffed = function(t2) {
  v$1 && v$1(t2);
  var o2 = t2.__c;
  o2 && o2.__H && (o2.__H.__h.length && (f$1.push(o2) !== 1 && i$1 === l$2.requestAnimationFrame || ((i$1 = l$2.requestAnimationFrame) || j$1)(b$1)), o2.__H.__.forEach(function(n2) {
    n2.i && (n2.__H = n2.i), n2.__V !== c$1 && (n2.__ = n2.__V), n2.i = void 0, n2.__V = c$1;
  })), u$1 = r$1 = null;
}, l$2.__c = function(t2, r2) {
  r2.some(function(t3) {
    try {
      t3.__h.forEach(k$1), t3.__h = t3.__h.filter(function(n2) {
        return !n2.__ || w$1(n2);
      });
    } catch (u2) {
      r2.some(function(n2) {
        n2.__h && (n2.__h = []);
      }), r2 = [], l$2.__e(u2, t3.__v);
    }
  }), l$1 && l$1(t2, r2);
}, l$2.unmount = function(t2) {
  m$1 && m$1(t2);
  var r2, u2 = t2.__c;
  u2 && u2.__H && (u2.__H.__.forEach(function(n2) {
    try {
      k$1(n2);
    } catch (n3) {
      r2 = n3;
    }
  }), u2.__H = void 0, r2 && l$2.__e(r2, u2.__v));
};
var g$1 = typeof requestAnimationFrame == "function";
function j$1(n2) {
  var t2, r2 = /* @__PURE__ */ __name(function() {
    clearTimeout(u2), g$1 && cancelAnimationFrame(t2), setTimeout(n2);
  }, "r"), u2 = setTimeout(r2, 100);
  g$1 && (t2 = requestAnimationFrame(r2));
}
__name(j$1, "j$1");
function k$1(n2) {
  var t2 = r$1, u2 = n2.__c;
  typeof u2 == "function" && (n2.__c = void 0, u2()), r$1 = t2;
}
__name(k$1, "k$1");
function w$1(n2) {
  var t2 = r$1;
  n2.__c = n2.__(), r$1 = t2;
}
__name(w$1, "w$1");
function z$1(n2, t2) {
  return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
    return t3 !== n2[r2];
  });
}
__name(z$1, "z$1");
function B$1(n2, t2) {
  return typeof t2 == "function" ? t2(n2) : t2;
}
__name(B$1, "B$1");
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$8.apply(this, arguments);
}
__name(_extends$8, "_extends$8");
const STYLE_INNER = {
  position: "relative",
  // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
  // and this additional property would hide things that we want to show.
  //
  // overflow: 'hidden',
  width: "100%",
  minHeight: "100%"
}, STYLE_CONTENT = {
  position: "absolute",
  top: 0,
  left: 0,
  // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
  // stretch far beyond the content. For our use case, the content div actually can get its height from
  // the elements inside it, so we don't need to specify a `height` property at all.
  //
  // height: '100%',
  width: "100%",
  overflow: "visible"
}, _VirtualList = class _VirtualList extends b$2 {
  constructor(props) {
    super(props), this.handleScroll = () => {
      this.setState({
        offset: this.base.scrollTop
      });
    }, this.handleResize = () => {
      this.resize();
    }, this.focusElement = null, this.state = {
      offset: 0,
      height: 0
    };
  }
  componentDidMount() {
    this.resize(), window.addEventListener("resize", this.handleResize);
  }
  // TODO: refactor to stable lifecycle method
  // eslint-disable-next-line
  componentWillUpdate() {
    this.base.contains(document.activeElement) && (this.focusElement = document.activeElement);
  }
  componentDidUpdate() {
    this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement && this.focusElement.focus(), this.focusElement = null, this.resize();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  resize() {
    const {
      height
    } = this.state;
    height !== this.base.offsetHeight && this.setState({
      height: this.base.offsetHeight
    });
  }
  render(_ref) {
    let {
      data,
      rowHeight,
      renderRow,
      overscanCount = 10,
      ...props
    } = _ref;
    const {
      offset,
      height
    } = this.state;
    let start = Math.floor(offset / rowHeight), visibleRowCount = Math.floor(height / rowHeight);
    overscanCount && (start = Math.max(0, start - start % overscanCount), visibleRowCount += overscanCount);
    const end = start + visibleRowCount + 4, selection = data.slice(start, end), styleInner = {
      ...STYLE_INNER,
      height: data.length * rowHeight
    }, styleContent = {
      ...STYLE_CONTENT,
      top: start * rowHeight
    };
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y$1("div", _extends$8({
        onScroll: this.handleScroll
      }, props), y$1("div", {
        role: "presentation",
        style: styleInner
      }, y$1("div", {
        role: "presentation",
        style: styleContent
      }, selection.map(renderRow))))
    );
  }
};
__name(_VirtualList, "VirtualList");
let VirtualList = _VirtualList;
function SearchFilterInput(props) {
  const {
    search,
    searchOnInput,
    searchTerm,
    showButton,
    inputLabel,
    clearSearchLabel,
    buttonLabel,
    clearSearch,
    inputClassName,
    buttonCSSClassName
  } = props, [searchText, setSearchText] = h$1(searchTerm ?? ""), validateAndSearch = T$1((ev) => {
    ev.preventDefault(), search(searchText);
  }, [search, searchText]), handleInput = T$1((ev) => {
    const inputValue = ev.target.value;
    setSearchText(inputValue), searchOnInput && search(inputValue);
  }, [setSearchText, searchOnInput, search]), handleReset = /* @__PURE__ */ __name(() => {
    setSearchText(""), clearSearch && clearSearch();
  }, "handleReset"), [form] = h$1(() => {
    const formEl = document.createElement("form");
    return formEl.setAttribute("tabindex", "-1"), formEl.id = nanoid(), formEl;
  });
  return p$1(() => (document.body.appendChild(form), form.addEventListener("submit", validateAndSearch), () => {
    form.removeEventListener("submit", validateAndSearch), document.body.removeChild(form);
  }), [form, validateAndSearch]), y$1(k$2, null, y$1("input", {
    className: `uppy-u-reset ${inputClassName}`,
    type: "search",
    "aria-label": inputLabel,
    placeholder: inputLabel,
    value: searchText,
    onInput: handleInput,
    form: form.id,
    "data-uppy-super-focusable": !0
  }), !showButton && y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    class: "uppy-c-icon uppy-ProviderBrowser-searchFilterIcon",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, y$1("path", {
    d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z"
  })), !showButton && searchText && y$1("button", {
    className: "uppy-u-reset uppy-ProviderBrowser-searchFilterReset",
    type: "button",
    "aria-label": clearSearchLabel,
    title: clearSearchLabel,
    onClick: handleReset
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    viewBox: "0 0 19 19"
  }, y$1("path", {
    d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"
  }))), showButton && y$1("button", {
    className: `uppy-u-reset uppy-c-btn uppy-c-btn-primary ${buttonCSSClassName}`,
    type: "submit",
    form: form.id
  }, buttonLabel));
}
__name(SearchFilterInput, "SearchFilterInput");
const FooterActions = /* @__PURE__ */ __name((_ref) => {
  let {
    cancel: cancel2,
    done,
    i18n,
    selected
  } = _ref;
  return y$1("div", {
    className: "uppy-ProviderBrowser-footer"
  }, y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary",
    onClick: done,
    type: "button"
  }, i18n("selectX", {
    smart_count: selected
  })), y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
    onClick: cancel2,
    type: "button"
  }, i18n("cancel")));
}, "FooterActions");
function FileIcon() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: 11,
    height: 14.5,
    viewBox: "0 0 44 58"
  }, y$1("path", {
    d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"
  }));
}
__name(FileIcon, "FileIcon");
function FolderIcon() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    style: {
      minWidth: 16,
      marginRight: 3
    },
    viewBox: "0 0 276.157 276.157"
  }, y$1("path", {
    d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z"
  }));
}
__name(FolderIcon, "FolderIcon");
function VideoIcon() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    style: {
      width: 16,
      marginRight: 4
    },
    viewBox: "0 0 58 58"
  }, y$1("path", {
    d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"
  }), y$1("path", {
    d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"
  }));
}
__name(VideoIcon, "VideoIcon");
const ItemIcon = /* @__PURE__ */ __name((props) => {
  const {
    itemIconString
  } = props;
  if (itemIconString !== null)
    switch (itemIconString) {
      case "file":
        return y$1(FileIcon, null);
      case "folder":
        return y$1(FolderIcon, null);
      case "video":
        return y$1(VideoIcon, null);
      default: {
        const {
          alt
        } = props;
        return y$1("img", {
          src: itemIconString,
          alt,
          loading: "lazy",
          width: 16,
          height: 16
        });
      }
    }
}, "ItemIcon");
function GridListItem(props) {
  const {
    className,
    isDisabled,
    restrictionError,
    isChecked,
    title,
    itemIconEl,
    showTitles,
    toggleCheckbox,
    recordShiftKeyPress,
    id: id2,
    children
  } = props, checkBoxClassName = classNames("uppy-u-reset", "uppy-ProviderBrowserItem-checkbox", "uppy-ProviderBrowserItem-checkbox--grid", {
    "uppy-ProviderBrowserItem-checkbox--is-checked": isChecked
  });
  return y$1("li", {
    className,
    title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : null
  }, y$1("input", {
    type: "checkbox",
    className: checkBoxClassName,
    onChange: toggleCheckbox,
    onKeyDown: recordShiftKeyPress,
    onMouseDown: recordShiftKeyPress,
    name: "listitem",
    id: id2,
    checked: isChecked,
    disabled: isDisabled,
    "data-uppy-super-focusable": !0
  }), y$1("label", {
    htmlFor: id2,
    "aria-label": title,
    className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
  }, itemIconEl, showTitles && title, children));
}
__name(GridListItem, "GridListItem");
function ListItem$1(props) {
  const {
    className,
    isDisabled,
    restrictionError,
    isCheckboxDisabled,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    type,
    id: id2,
    itemIconEl,
    title,
    handleFolderClick,
    showTitles,
    i18n
  } = props;
  return y$1("li", {
    className,
    title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : null
  }, isCheckboxDisabled ? null : y$1("input", {
    type: "checkbox",
    className: `uppy-u-reset uppy-ProviderBrowserItem-checkbox ${isChecked ? "uppy-ProviderBrowserItem-checkbox--is-checked" : ""}`,
    onChange: toggleCheckbox,
    onKeyDown: recordShiftKeyPress,
    onMouseDown: recordShiftKeyPress,
    name: "listitem",
    id: id2,
    checked: isChecked,
    "aria-label": type === "file" ? null : i18n("allFilesFromFolderNamed", {
      name: title
    }),
    disabled: isDisabled,
    "data-uppy-super-focusable": !0
  }), type === "file" ? (
    // label for a checkbox
    y$1("label", {
      htmlFor: id2,
      className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, y$1("div", {
      className: "uppy-ProviderBrowserItem-iconWrap"
    }, itemIconEl), showTitles && title)
  ) : (
    // button to open a folder
    y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-inner",
      onClick: handleFolderClick,
      "aria-label": i18n("openFolderNamed", {
        name: title
      })
    }, y$1("div", {
      className: "uppy-ProviderBrowserItem-iconWrap"
    }, itemIconEl), showTitles && y$1("span", null, title))
  ));
}
__name(ListItem$1, "ListItem$1");
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$7.apply(this, arguments);
}
__name(_extends$7, "_extends$7");
const Item = /* @__PURE__ */ __name((props) => {
  const {
    author,
    getItemIcon,
    isChecked,
    isDisabled,
    viewType
  } = props, itemIconString = getItemIcon(), className = classNames("uppy-ProviderBrowserItem", {
    "uppy-ProviderBrowserItem--selected": isChecked
  }, {
    "uppy-ProviderBrowserItem--disabled": isDisabled
  }, {
    "uppy-ProviderBrowserItem--noPreview": itemIconString === "video"
  }), itemIconEl = y$1(ItemIcon, {
    itemIconString
  });
  switch (viewType) {
    case "grid":
      return y$1(
        GridListItem,
        _extends$7({}, props, {
          className,
          itemIconEl
        })
      );
    case "list":
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        y$1(ListItem$1, _extends$7({}, props, {
          className,
          itemIconEl
        }))
      );
    case "unsplash":
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        y$1(GridListItem, _extends$7({}, props, {
          className,
          itemIconEl
        }), y$1("a", {
          href: `${author.url}?utm_source=Companion&utm_medium=referral`,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "uppy-ProviderBrowserItem-author",
          tabIndex: "-1"
        }, author.name))
      );
    default:
      throw new Error(`There is no such type ${viewType}`);
  }
}, "Item"), VIRTUAL_SHARED_DIR = "shared-with-me";
function ListItem(props) {
  const {
    currentSelection,
    uppyFiles,
    viewType,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    showTitles,
    i18n,
    validateRestrictions,
    getNextFolder,
    columns,
    f: f2
  } = props;
  if (f2.isFolder) {
    var _isChecked;
    return Item({
      columns,
      showTitles,
      viewType,
      i18n,
      id: f2.id,
      title: f2.name,
      getItemIcon: /* @__PURE__ */ __name(() => f2.icon, "getItemIcon"),
      isChecked: isChecked(f2),
      toggleCheckbox: /* @__PURE__ */ __name((event) => toggleCheckbox(event, f2), "toggleCheckbox"),
      recordShiftKeyPress,
      type: "folder",
      isDisabled: (_isChecked = isChecked(f2)) == null ? void 0 : _isChecked.loading,
      isCheckboxDisabled: f2.id === VIRTUAL_SHARED_DIR,
      handleFolderClick: /* @__PURE__ */ __name(() => getNextFolder(f2), "handleFolderClick")
    });
  }
  const restrictionError = validateRestrictions(remoteFileObjToLocal(f2), [...uppyFiles, ...currentSelection]);
  return Item({
    id: f2.id,
    title: f2.name,
    author: f2.author,
    getItemIcon: /* @__PURE__ */ __name(() => f2.icon, "getItemIcon"),
    isChecked: isChecked(f2),
    toggleCheckbox: /* @__PURE__ */ __name((event) => toggleCheckbox(event, f2), "toggleCheckbox"),
    recordShiftKeyPress,
    columns,
    showTitles,
    viewType,
    i18n,
    type: "file",
    isDisabled: restrictionError && !isChecked(f2),
    restrictionError
  });
}
__name(ListItem, "ListItem");
function Browser(props) {
  const {
    currentSelection,
    folders,
    files,
    uppyFiles,
    viewType,
    headerComponent,
    showBreadcrumbs,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    handleScroll,
    showTitles,
    i18n,
    validateRestrictions,
    isLoading,
    showSearchFilter,
    search,
    searchTerm,
    clearSearch,
    searchOnInput,
    searchInputLabel,
    clearSearchLabel,
    getNextFolder,
    cancel: cancel2,
    done,
    columns,
    noResultsLabel,
    loadAllFiles
  } = props, selected = currentSelection.length, rows = F$1(() => [...folders, ...files], [folders, files]);
  return y$1("div", {
    className: classNames("uppy-ProviderBrowser", `uppy-ProviderBrowser-viewType--${viewType}`)
  }, headerComponent && y$1("div", {
    className: "uppy-ProviderBrowser-header"
  }, y$1("div", {
    className: classNames("uppy-ProviderBrowser-headerBar", !showBreadcrumbs && "uppy-ProviderBrowser-headerBar--simple")
  }, headerComponent)), showSearchFilter && y$1("div", {
    class: "uppy-ProviderBrowser-searchFilter"
  }, y$1(SearchFilterInput, {
    search,
    searchTerm,
    clearSearch,
    inputLabel: searchInputLabel,
    clearSearchLabel,
    inputClassName: "uppy-ProviderBrowser-searchFilterInput",
    searchOnInput
  })), isLoading ? y$1("div", {
    className: "uppy-Provider-loading"
  }, y$1("span", null, i18n("loading"))) : !folders.length && !files.length ? y$1("div", {
    className: "uppy-Provider-empty"
  }, noResultsLabel) : loadAllFiles ? y$1("div", {
    className: "uppy-ProviderBrowser-body"
  }, y$1("ul", {
    className: "uppy-ProviderBrowser-list"
  }, y$1(VirtualList, {
    data: rows,
    renderRow: /* @__PURE__ */ __name((f2) => y$1(ListItem, {
      currentSelection,
      uppyFiles,
      viewType,
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      showTitles,
      i18n,
      validateRestrictions,
      getNextFolder,
      columns,
      f: f2
    }), "renderRow"),
    rowHeight: 31
  }))) : y$1("div", {
    className: "uppy-ProviderBrowser-body"
  }, y$1("ul", {
    className: "uppy-ProviderBrowser-list",
    onScroll: handleScroll,
    role: "listbox",
    tabIndex: "-1"
  }, rows.map((f2) => y$1(ListItem, {
    currentSelection,
    uppyFiles,
    viewType,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    showTitles,
    i18n,
    validateRestrictions,
    getNextFolder,
    columns,
    f: f2
  })))), selected > 0 && y$1(FooterActions, {
    selected,
    done,
    cancel: cancel2,
    i18n
  }));
}
__name(Browser, "Browser");
const LoaderView = /* @__PURE__ */ __name((_ref) => {
  let {
    i18n,
    loading
  } = _ref;
  return y$1("div", {
    className: "uppy-Provider-loading"
  }, y$1("span", null, i18n("loading")), typeof loading == "string" && // todo improve this, see discussion in https://github.com/transloadit/uppy/pull/4399#discussion_r1162564445
  y$1("span", {
    style: {
      marginTop: ".7em"
    }
  }, loading));
}, "LoaderView"), _CloseWrapper = class _CloseWrapper extends b$2 {
  componentWillUnmount() {
    const {
      onUnmount
    } = this.props;
    onUnmount();
  }
  render() {
    const {
      children
    } = this.props;
    return C(children)[0];
  }
};
__name(_CloseWrapper, "CloseWrapper");
let CloseWrapper = _CloseWrapper;
function isPreviewSupported(fileType) {
  return fileType ? /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType) : !1;
}
__name(isPreviewSupported, "isPreviewSupported");
const _View = class _View {
  constructor(plugin, opts) {
    this.filterItems = (items) => {
      const state = this.plugin.getPluginState();
      return !state.filterInput || state.filterInput === "" ? items : items.filter((folder) => folder.name.toLowerCase().indexOf(state.filterInput.toLowerCase()) !== -1);
    }, this.recordShiftKeyPress = (e2) => {
      this.isShiftKeyPressed = e2.shiftKey;
    }, this.toggleCheckbox = (e2, file) => {
      e2.stopPropagation(), e2.preventDefault(), e2.currentTarget.focus();
      const {
        folders,
        files
      } = this.plugin.getPluginState(), items = this.filterItems(folders.concat(files));
      if (this.lastCheckbox && this.isShiftKeyPressed) {
        const {
          currentSelection: currentSelection2
        } = this.plugin.getPluginState(), prevIndex = items.indexOf(this.lastCheckbox), currentIndex = items.indexOf(file), newSelection = prevIndex < currentIndex ? items.slice(prevIndex, currentIndex + 1) : items.slice(currentIndex, prevIndex + 1), reducedNewSelection = [];
        for (const item of newSelection) {
          const {
            uppy
          } = this.plugin, restrictionError = uppy.validateRestrictions(remoteFileObjToLocal(item), [...uppy.getFiles(), ...reducedNewSelection]);
          restrictionError ? uppy.info({
            message: restrictionError.message
          }, "error", uppy.opts.infoTimeout) : reducedNewSelection.push(item);
        }
        this.plugin.setPluginState({
          currentSelection: [.../* @__PURE__ */ new Set([...currentSelection2, ...reducedNewSelection])]
        });
        return;
      }
      this.lastCheckbox = file;
      const {
        currentSelection
      } = this.plugin.getPluginState();
      this.isChecked(file) ? this.plugin.setPluginState({
        currentSelection: currentSelection.filter((item) => item.id !== file.id)
      }) : this.plugin.setPluginState({
        currentSelection: currentSelection.concat([file])
      });
    }, this.isChecked = (file) => {
      const {
        currentSelection
      } = this.plugin.getPluginState();
      return currentSelection.some((item) => item.id === file.id);
    }, this.plugin = plugin, this.provider = opts.provider, this.isHandlingScroll = !1, this.preFirstRender = this.preFirstRender.bind(this), this.handleError = this.handleError.bind(this), this.clearSelection = this.clearSelection.bind(this), this.cancelPicking = this.cancelPicking.bind(this);
  }
  preFirstRender() {
    this.plugin.setPluginState({
      didFirstRender: !0
    }), this.plugin.onFirstRender();
  }
  // eslint-disable-next-line class-methods-use-this
  shouldHandleScroll(event) {
    const {
      scrollHeight,
      scrollTop,
      offsetHeight
    } = event.target;
    return scrollHeight - (scrollTop + offsetHeight) < 50 && !this.isHandlingScroll;
  }
  clearSelection() {
    this.plugin.setPluginState({
      currentSelection: [],
      filterInput: ""
    });
  }
  cancelPicking() {
    this.clearSelection();
    const dashboard = this.plugin.uppy.getPlugin("Dashboard");
    dashboard && dashboard.hideAllPanels();
  }
  handleError(error) {
    var _error$cause;
    const {
      uppy
    } = this.plugin, message = uppy.i18n("companionError");
    uppy.log(error.toString()), !(error.isAuthError || ((_error$cause = error.cause) == null ? void 0 : _error$cause.name) === "AbortError") && uppy.info({
      message,
      details: error.toString()
    }, "error", 5e3);
  }
  // todo document what is a "tagFile" or get rid of this concept
  getTagFile(file) {
    const tagFile = {
      id: file.id,
      source: this.plugin.id,
      data: file,
      name: file.name || file.id,
      type: file.mimeType,
      isRemote: !0,
      meta: {},
      body: {
        fileId: file.id
      },
      remote: {
        companionUrl: this.plugin.opts.companionUrl,
        url: `${this.provider.fileUrl(file.requestPath)}`,
        body: {
          fileId: file.id
        },
        providerOptions: this.provider.opts,
        providerName: this.provider.name,
        provider: this.provider.provider
      }
    }, fileType = getFileType(tagFile);
    return fileType && isPreviewSupported(fileType) && (tagFile.preview = file.thumbnail), file.author && (file.author.name != null && (tagFile.meta.authorName = String(file.author.name)), file.author.url && (tagFile.meta.authorUrl = file.author.url)), file.relDirPath != null && (tagFile.meta.relativePath = file.relDirPath ? `${file.relDirPath}/${tagFile.name}` : null), file.absDirPath != null && (tagFile.meta.absolutePath = file.absDirPath ? `/${file.absDirPath}/${tagFile.name}` : `/${tagFile.name}`), tagFile;
  }
  setLoading(loading) {
    this.plugin.setPluginState({
      loading
    });
  }
};
__name(_View, "View");
let View = _View;
function _classPrivateFieldLooseBase$m(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$m, "_classPrivateFieldLooseBase$m");
var id$m = 0;
function _classPrivateFieldLooseKey$m(name) {
  return "__private_" + id$m++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$m, "_classPrivateFieldLooseKey$m");
const packageJson$v = {
  version: "3.5.0"
};
function formatBreadcrumbs(breadcrumbs) {
  return breadcrumbs.slice(1).map((directory) => directory.name).join("/");
}
__name(formatBreadcrumbs, "formatBreadcrumbs");
function prependPath(path, component) {
  return path ? `${path}/${component}` : component;
}
__name(prependPath, "prependPath");
function defaultPickerIcon() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30"
  }, y$1("path", {
    d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
  }));
}
__name(defaultPickerIcon, "defaultPickerIcon");
var _abortController$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$m("abortController"), _withAbort = /* @__PURE__ */ _classPrivateFieldLooseKey$m("withAbort"), _list = /* @__PURE__ */ _classPrivateFieldLooseKey$m("list"), _listFilesAndFolders = /* @__PURE__ */ _classPrivateFieldLooseKey$m("listFilesAndFolders"), _recursivelyListAllFiles = /* @__PURE__ */ _classPrivateFieldLooseKey$m("recursivelyListAllFiles");
const _ProviderView = class _ProviderView extends View {
  /**
   * @param {object} plugin instance of the plugin
   * @param {object} opts
   */
  constructor(plugin, opts) {
    super(plugin, opts), Object.defineProperty(this, _recursivelyListAllFiles, {
      value: _recursivelyListAllFiles2
    }), Object.defineProperty(this, _listFilesAndFolders, {
      value: _listFilesAndFolders2
    }), Object.defineProperty(this, _list, {
      value: _list2
    }), Object.defineProperty(this, _withAbort, {
      value: _withAbort2
    }), Object.defineProperty(this, _abortController$1, {
      writable: !0,
      value: void 0
    });
    const defaultOptions2 = {
      viewType: "list",
      showTitles: !0,
      showFilter: !0,
      showBreadcrumbs: !0,
      loadAllFiles: !1
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.filterQuery = this.filterQuery.bind(this), this.clearFilter = this.clearFilter.bind(this), this.getFolder = this.getFolder.bind(this), this.getNextFolder = this.getNextFolder.bind(this), this.logout = this.logout.bind(this), this.handleAuth = this.handleAuth.bind(this), this.handleScroll = this.handleScroll.bind(this), this.donePicking = this.donePicking.bind(this), this.render = this.render.bind(this), this.plugin.setPluginState({
      authenticated: !1,
      files: [],
      folders: [],
      breadcrumbs: [],
      filterInput: "",
      isSearchVisible: !1,
      currentSelection: []
    });
  }
  // eslint-disable-next-line class-methods-use-this
  tearDown() {
  }
  /**
   * Select a folder based on its id: fetches the folder and then updates state with its contents
   * TODO rename to something better like selectFolder or navigateToFolder (breaking change?)
   *
   * @param  {string} requestPath
   * the path we need to use when sending list request to companion (for some providers it's different from ID)
   * @param  {string} name used in the UI and to build the absDirPath
   * @returns {Promise}   Folders/files in folder
   */
  async getFolder(requestPath, name) {
    this.setLoading(!0);
    try {
      await _classPrivateFieldLooseBase$m(this, _withAbort)[_withAbort](async (signal) => {
        this.lastCheckbox = void 0;
        let {
          breadcrumbs
        } = this.plugin.getPluginState();
        const index = breadcrumbs.findIndex((dir) => requestPath === dir.requestPath);
        index !== -1 ? breadcrumbs = breadcrumbs.slice(0, index + 1) : breadcrumbs = [...breadcrumbs, {
          requestPath,
          name
        }], this.nextPagePath = requestPath;
        let files = [], folders = [];
        do {
          const {
            files: newFiles,
            folders: newFolders
          } = await _classPrivateFieldLooseBase$m(this, _listFilesAndFolders)[_listFilesAndFolders]({
            breadcrumbs,
            signal
          });
          files = files.concat(newFiles), folders = folders.concat(newFolders), this.setLoading(this.plugin.uppy.i18n("loadedXFiles", {
            numFiles: files.length + folders.length
          }));
        } while (this.opts.loadAllFiles && this.nextPagePath);
        this.plugin.setPluginState({
          folders,
          files,
          breadcrumbs,
          filterInput: ""
        });
      });
    } catch (err) {
      this.handleError(err);
    } finally {
      this.setLoading(!1);
    }
  }
  /**
   * Fetches new folder
   *
   * @param  {object} folder
   */
  getNextFolder(folder) {
    this.getFolder(folder.requestPath, folder.name), this.lastCheckbox = void 0;
  }
  /**
   * Removes session token on client side.
   */
  async logout() {
    try {
      await _classPrivateFieldLooseBase$m(this, _withAbort)[_withAbort](async (signal) => {
        const res = await this.provider.logout({
          signal
        });
        if (res.ok) {
          if (!res.revoked) {
            const message = this.plugin.uppy.i18n("companionUnauthorizeHint", {
              provider: this.plugin.title,
              url: res.manual_revoke_url
            });
            this.plugin.uppy.info(message, "info", 7e3);
          }
          const newState = {
            authenticated: !1,
            files: [],
            folders: [],
            breadcrumbs: [],
            filterInput: ""
          };
          this.plugin.setPluginState(newState);
        }
      });
    } catch (err) {
      this.handleError(err);
    }
  }
  filterQuery(input) {
    this.plugin.setPluginState({
      filterInput: input
    });
  }
  clearFilter() {
    this.plugin.setPluginState({
      filterInput: ""
    });
  }
  async handleAuth() {
    const clientVersion = `@uppy/provider-views=${_ProviderView.VERSION}`;
    try {
      await this.provider.login({
        uppyVersions: clientVersion
      }), this.plugin.setPluginState({
        authenticated: !0
      }), this.preFirstRender();
    } catch (e2) {
      this.plugin.uppy.log(`login failed: ${e2.message}`);
    }
  }
  async handleScroll(event) {
    if (this.shouldHandleScroll(event) && this.nextPagePath) {
      this.isHandlingScroll = !0;
      try {
        await _classPrivateFieldLooseBase$m(this, _withAbort)[_withAbort](async (signal) => {
          const {
            files,
            folders,
            breadcrumbs
          } = this.plugin.getPluginState(), {
            files: newFiles,
            folders: newFolders
          } = await _classPrivateFieldLooseBase$m(this, _listFilesAndFolders)[_listFilesAndFolders]({
            breadcrumbs,
            signal
          }), combinedFiles = files.concat(newFiles), combinedFolders = folders.concat(newFolders);
          this.plugin.setPluginState({
            folders: combinedFolders,
            files: combinedFiles
          });
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isHandlingScroll = !1;
      }
    }
  }
  async donePicking() {
    this.setLoading(!0);
    try {
      await _classPrivateFieldLooseBase$m(this, _withAbort)[_withAbort](async (signal) => {
        const {
          currentSelection
        } = this.plugin.getPluginState(), messages = [], newFiles = [];
        for (const selectedItem of currentSelection) {
          const {
            requestPath
          } = selectedItem, withRelDirPath = /* @__PURE__ */ __name((newItem) => ({
            ...newItem,
            // calculate the file's path relative to the user's selected item's path
            // see https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
            relDirPath: newItem.absDirPath.replace(selectedItem.absDirPath, "").replace(/^\//, "")
          }), "withRelDirPath");
          if (selectedItem.isFolder) {
            let isEmpty = !0, numNewFiles = 0;
            const queue = new PQueue({
              concurrency: 6
            }), onFiles = /* @__PURE__ */ __name((files) => {
              for (const newFile of files) {
                const tagFile = this.getTagFile(newFile), id2 = getSafeFileId(tagFile);
                this.plugin.uppy.checkIfFileAlreadyExists(id2) || (newFiles.push(withRelDirPath(newFile)), numNewFiles++, this.setLoading(this.plugin.uppy.i18n("addedNumFiles", {
                  numFiles: numNewFiles
                }))), isEmpty = !1;
              }
            }, "onFiles");
            await _classPrivateFieldLooseBase$m(this, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
              requestPath,
              absDirPath: prependPath(selectedItem.absDirPath, selectedItem.name),
              relDirPath: selectedItem.name,
              queue,
              onFiles,
              signal
            }), await queue.onIdle();
            let message;
            isEmpty ? message = this.plugin.uppy.i18n("emptyFolderAdded") : numNewFiles === 0 ? message = this.plugin.uppy.i18n("folderAlreadyAdded", {
              folder: selectedItem.name
            }) : message = this.plugin.uppy.i18n("folderAdded", {
              smart_count: numNewFiles,
              folder: selectedItem.name
            }), messages.push(message);
          } else
            newFiles.push(withRelDirPath(selectedItem));
        }
        this.plugin.uppy.log("Adding remote provider files"), this.plugin.uppy.addFiles(newFiles.map((file) => this.getTagFile(file))), this.plugin.setPluginState({
          filterInput: ""
        }), messages.forEach((message) => this.plugin.uppy.info(message)), this.clearSelection();
      });
    } catch (err) {
      this.handleError(err);
    } finally {
      this.setLoading(!1);
    }
  }
  render(state, viewOptions) {
    var _this = this;
    viewOptions === void 0 && (viewOptions = {});
    const {
      authenticated,
      didFirstRender
    } = this.plugin.getPluginState(), {
      i18n
    } = this.plugin.uppy;
    didFirstRender || this.preFirstRender();
    const targetViewOptions = {
      ...this.opts,
      ...viewOptions
    }, {
      files,
      folders,
      filterInput,
      loading,
      currentSelection
    } = this.plugin.getPluginState(), {
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      filterItems
    } = this, hasInput = filterInput !== "", pluginIcon = this.plugin.icon || defaultPickerIcon, headerProps = {
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      getFolder: this.getFolder,
      breadcrumbs: this.plugin.getPluginState().breadcrumbs,
      pluginIcon,
      title: this.plugin.title,
      logout: this.logout,
      username: this.username,
      i18n
    }, browserProps = {
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      currentSelection,
      files: hasInput ? filterItems(files) : files,
      folders: hasInput ? filterItems(folders) : folders,
      username: this.username,
      getNextFolder: this.getNextFolder,
      getFolder: this.getFolder,
      loadAllFiles: this.opts.loadAllFiles,
      // For SearchFilterInput component
      showSearchFilter: targetViewOptions.showFilter,
      search: this.filterQuery,
      clearSearch: this.clearFilter,
      searchTerm: filterInput,
      searchOnInput: !0,
      searchInputLabel: i18n("filter"),
      clearSearchLabel: i18n("resetFilter"),
      noResultsLabel: i18n("noFilesFound"),
      logout: this.logout,
      handleScroll: this.handleScroll,
      done: this.donePicking,
      cancel: this.cancelPicking,
      headerComponent: Header(headerProps),
      title: this.plugin.title,
      viewType: targetViewOptions.viewType,
      showTitles: targetViewOptions.showTitles,
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      pluginIcon,
      i18n: this.plugin.uppy.i18n,
      uppyFiles: this.plugin.uppy.getFiles(),
      validateRestrictions: /* @__PURE__ */ __name(function() {
        return _this.plugin.uppy.validateRestrictions(...arguments);
      }, "validateRestrictions")
    };
    return loading ? y$1(CloseWrapper, {
      onUnmount: this.clearSelection
    }, y$1(LoaderView, {
      i18n: this.plugin.uppy.i18n,
      loading
    })) : authenticated ? y$1(CloseWrapper, {
      onUnmount: this.clearSelection
    }, y$1(Browser, browserProps)) : y$1(CloseWrapper, {
      onUnmount: this.clearSelection
    }, y$1(AuthView, {
      pluginName: this.plugin.title,
      pluginIcon,
      handleAuth: this.handleAuth,
      i18n: this.plugin.uppy.i18n,
      i18nArray: this.plugin.uppy.i18nArray
    }));
  }
};
__name(_ProviderView, "ProviderView");
let ProviderView = _ProviderView;
async function _withAbort2(op) {
  var _classPrivateFieldLoo;
  (_classPrivateFieldLoo = _classPrivateFieldLooseBase$m(this, _abortController$1)[_abortController$1]) == null || _classPrivateFieldLoo.abort();
  const abortController = new AbortController();
  _classPrivateFieldLooseBase$m(this, _abortController$1)[_abortController$1] = abortController;
  const cancelRequest = /* @__PURE__ */ __name(() => {
    abortController.abort(), this.clearSelection();
  }, "cancelRequest");
  try {
    this.plugin.uppy.on("dashboard:close-panel", cancelRequest), this.plugin.uppy.on("cancel-all", cancelRequest), await op(abortController.signal);
  } finally {
    this.plugin.uppy.off("dashboard:close-panel", cancelRequest), this.plugin.uppy.off("cancel-all", cancelRequest), _classPrivateFieldLooseBase$m(this, _abortController$1)[_abortController$1] = void 0;
  }
}
__name(_withAbort2, "_withAbort2");
async function _list2(_ref) {
  let {
    requestPath,
    absDirPath,
    signal
  } = _ref;
  const {
    username,
    nextPagePath,
    items
  } = await this.provider.list(requestPath, {
    signal
  });
  return this.username = username || this.username, {
    items: items.map((item) => ({
      ...item,
      absDirPath
    })),
    nextPagePath
  };
}
__name(_list2, "_list2");
async function _listFilesAndFolders2(_ref2) {
  let {
    breadcrumbs,
    signal
  } = _ref2;
  const absDirPath = formatBreadcrumbs(breadcrumbs), {
    items,
    nextPagePath
  } = await _classPrivateFieldLooseBase$m(this, _list)[_list]({
    requestPath: this.nextPagePath,
    absDirPath,
    signal
  });
  this.nextPagePath = nextPagePath;
  const files = [], folders = [];
  return items.forEach((item) => {
    item.isFolder ? folders.push(item) : files.push(item);
  }), {
    files,
    folders
  };
}
__name(_listFilesAndFolders2, "_listFilesAndFolders2");
async function _recursivelyListAllFiles2(_ref3) {
  let {
    requestPath,
    absDirPath,
    relDirPath,
    queue,
    onFiles,
    signal
  } = _ref3, curPath = requestPath;
  for (; curPath; ) {
    const res = await _classPrivateFieldLooseBase$m(this, _list)[_list]({
      requestPath: curPath,
      absDirPath,
      signal
    });
    curPath = res.nextPagePath;
    const files = res.items.filter((item) => !item.isFolder), folders = res.items.filter((item) => item.isFolder);
    onFiles(files);
    const promises = folders.map(async (folder) => queue.add(async () => _classPrivateFieldLooseBase$m(this, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
      requestPath: folder.requestPath,
      absDirPath: prependPath(absDirPath, folder.name),
      relDirPath: prependPath(relDirPath, folder.name),
      queue,
      onFiles,
      signal
    })));
    await Promise.all(promises);
  }
}
__name(_recursivelyListAllFiles2, "_recursivelyListAllFiles2");
ProviderView.VERSION = packageJson$v.version;
function _classPrivateFieldLooseBase$l(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$l, "_classPrivateFieldLooseBase$l");
var id$l = 0;
function _classPrivateFieldLooseKey$l(name) {
  return "__private_" + id$l++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$l, "_classPrivateFieldLooseKey$l");
const packageJson$u = {
  version: "3.5.0"
};
var _updateFilesAndInputMode = /* @__PURE__ */ _classPrivateFieldLooseKey$l("updateFilesAndInputMode");
const _SearchProviderView = class _SearchProviderView extends View {
  /**
   * @param {object} plugin instance of the plugin
   * @param {object} opts
   */
  constructor(plugin, opts) {
    super(plugin, opts), Object.defineProperty(this, _updateFilesAndInputMode, {
      value: _updateFilesAndInputMode2
    });
    const defaultOptions2 = {
      viewType: "grid",
      showTitles: !1,
      showFilter: !1,
      showBreadcrumbs: !1
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.search = this.search.bind(this), this.clearSearch = this.clearSearch.bind(this), this.resetPluginState = this.resetPluginState.bind(this), this.handleScroll = this.handleScroll.bind(this), this.donePicking = this.donePicking.bind(this), this.render = this.render.bind(this), this.defaultState = {
      isInputMode: !0,
      files: [],
      folders: [],
      breadcrumbs: [],
      filterInput: "",
      currentSelection: [],
      searchTerm: null
    }, this.plugin.setPluginState(this.defaultState);
  }
  // eslint-disable-next-line class-methods-use-this
  tearDown() {
  }
  resetPluginState() {
    this.plugin.setPluginState(this.defaultState);
  }
  async search(query) {
    const {
      searchTerm
    } = this.plugin.getPluginState();
    if (!(query && query === searchTerm)) {
      this.setLoading(!0);
      try {
        const res = await this.provider.search(query);
        _classPrivateFieldLooseBase$l(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](res, []);
      } catch (err) {
        this.handleError(err);
      } finally {
        this.setLoading(!1);
      }
    }
  }
  clearSearch() {
    this.plugin.setPluginState({
      currentSelection: [],
      files: [],
      searchTerm: null
    });
  }
  async handleScroll(event) {
    const query = this.nextPageQuery || null;
    if (this.shouldHandleScroll(event) && query) {
      this.isHandlingScroll = !0;
      try {
        const {
          files,
          searchTerm
        } = this.plugin.getPluginState(), response = await this.provider.search(searchTerm, query);
        _classPrivateFieldLooseBase$l(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](response, files);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isHandlingScroll = !1;
      }
    }
  }
  donePicking() {
    const {
      currentSelection
    } = this.plugin.getPluginState();
    this.plugin.uppy.log("Adding remote search provider files"), this.plugin.uppy.addFiles(currentSelection.map((file) => this.getTagFile(file))), this.resetPluginState();
  }
  render(state, viewOptions) {
    var _this = this;
    viewOptions === void 0 && (viewOptions = {});
    const {
      didFirstRender,
      isInputMode,
      searchTerm
    } = this.plugin.getPluginState(), {
      i18n
    } = this.plugin.uppy;
    didFirstRender || this.preFirstRender();
    const targetViewOptions = {
      ...this.opts,
      ...viewOptions
    }, {
      files,
      folders,
      filterInput,
      loading,
      currentSelection
    } = this.plugin.getPluginState(), {
      isChecked,
      toggleCheckbox,
      filterItems,
      recordShiftKeyPress
    } = this, hasInput = filterInput !== "", browserProps = {
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      currentSelection,
      files: hasInput ? filterItems(files) : files,
      folders: hasInput ? filterItems(folders) : folders,
      handleScroll: this.handleScroll,
      done: this.donePicking,
      cancel: this.cancelPicking,
      // For SearchFilterInput component
      showSearchFilter: targetViewOptions.showFilter,
      search: this.search,
      clearSearch: this.clearSearch,
      searchTerm,
      searchOnInput: !1,
      searchInputLabel: i18n("search"),
      clearSearchLabel: i18n("resetSearch"),
      noResultsLabel: i18n("noSearchResults"),
      title: this.plugin.title,
      viewType: targetViewOptions.viewType,
      showTitles: targetViewOptions.showTitles,
      showFilter: targetViewOptions.showFilter,
      isLoading: loading,
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      pluginIcon: this.plugin.icon,
      i18n,
      uppyFiles: this.plugin.uppy.getFiles(),
      validateRestrictions: /* @__PURE__ */ __name(function() {
        return _this.plugin.uppy.validateRestrictions(...arguments);
      }, "validateRestrictions")
    };
    return isInputMode ? y$1(CloseWrapper, {
      onUnmount: this.resetPluginState
    }, y$1("div", {
      className: "uppy-SearchProvider"
    }, y$1(SearchFilterInput, {
      search: this.search,
      clearSelection: this.clearSelection,
      inputLabel: i18n("enterTextToSearch"),
      buttonLabel: i18n("searchImages"),
      inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
      buttonCSSClassName: "uppy-SearchProvider-searchButton",
      showButton: !0
    }))) : y$1(CloseWrapper, {
      onUnmount: this.resetPluginState
    }, y$1(Browser, browserProps));
  }
};
__name(_SearchProviderView, "SearchProviderView");
let SearchProviderView = _SearchProviderView;
function _updateFilesAndInputMode2(res, files) {
  this.nextPageQuery = res.nextPageQuery, res.items.forEach((item) => {
    files.push(item);
  }), this.plugin.setPluginState({
    currentSelection: [],
    isInputMode: !1,
    files,
    searchTerm: res.searchedFor
  });
}
__name(_updateFilesAndInputMode2, "_updateFilesAndInputMode2");
SearchProviderView.VERSION = packageJson$u.version;
function emaFilter(newValue, previousSmoothedValue, halfLife, dt) {
  return newValue === previousSmoothedValue ? newValue : dt === 0 ? previousSmoothedValue : newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}
__name(emaFilter, "emaFilter");
const statusBarStates = {
  STATE_ERROR: "error",
  STATE_WAITING: "waiting",
  STATE_PREPROCESSING: "preprocessing",
  STATE_UPLOADING: "uploading",
  STATE_POSTPROCESSING: "postprocessing",
  STATE_COMPLETE: "complete"
};
function calculateProcessingProgress(files) {
  const values = [];
  let mode, message;
  for (const {
    progress
  } of Object.values(files)) {
    const {
      preprocess,
      postprocess
    } = progress;
    message == null && (preprocess || postprocess) && ({
      mode,
      message
    } = preprocess || postprocess), (preprocess == null ? void 0 : preprocess.mode) === "determinate" && values.push(preprocess.value), (postprocess == null ? void 0 : postprocess.mode) === "determinate" && values.push(postprocess.value);
  }
  const value = values.reduce((total, progressValue) => total + progressValue / values.length, 0);
  return {
    mode,
    message,
    value
  };
}
__name(calculateProcessingProgress, "calculateProcessingProgress");
function secondsToTime(rawSeconds) {
  const hours = Math.floor(rawSeconds / 3600) % 24, minutes = Math.floor(rawSeconds / 60) % 60, seconds = Math.floor(rawSeconds % 60);
  return {
    hours,
    minutes,
    seconds
  };
}
__name(secondsToTime, "secondsToTime");
function prettyETA(seconds) {
  const time = secondsToTime(seconds), hoursStr = time.hours === 0 ? "" : `${time.hours}h`, minutesStr = time.minutes === 0 ? "" : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, "0")}`}m`, secondsStr = time.hours !== 0 ? "" : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, "0")}`}s`;
  return `${hoursStr}${minutesStr}${secondsStr}`;
}
__name(prettyETA, "prettyETA");
const DOT = "·", renderDot = /* @__PURE__ */ __name(() => ` ${DOT} `, "renderDot");
function UploadBtn(props) {
  const {
    newFiles,
    isUploadStarted,
    recoveredState,
    i18n,
    uploadState,
    isSomeGhost,
    startUpload
  } = props, uploadBtnClassNames = classNames("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", {
    "uppy-c-btn-primary": uploadState === statusBarStates.STATE_WAITING
  }, {
    "uppy-StatusBar-actionBtn--disabled": isSomeGhost
  }), uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n("uploadXNewFiles", {
    smart_count: newFiles
  }) : i18n("uploadXFiles", {
    smart_count: newFiles
  });
  return y$1("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n("uploadXFiles", {
      smart_count: newFiles
    }),
    onClick: startUpload,
    disabled: isSomeGhost,
    "data-uppy-super-focusable": !0
  }, uploadBtnText);
}
__name(UploadBtn, "UploadBtn");
function RetryBtn(props) {
  const {
    i18n,
    uppy
  } = props;
  return y$1("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
    "aria-label": i18n("retryUpload"),
    onClick: /* @__PURE__ */ __name(() => uppy.retryAll().catch(() => {
    }), "onClick"),
    "data-uppy-super-focusable": !0,
    "data-cy": "retry"
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "8",
    height: "10",
    viewBox: "0 0 8 10"
  }, y$1("path", {
    d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
  })), i18n("retry"));
}
__name(RetryBtn, "RetryBtn");
function CancelBtn(props) {
  const {
    i18n,
    uppy
  } = props;
  return y$1("button", {
    type: "button",
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    title: i18n("cancel"),
    "aria-label": i18n("cancel"),
    onClick: /* @__PURE__ */ __name(() => uppy.cancelAll(), "onClick"),
    "data-cy": "cancel",
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, y$1("g", {
    fill: "none",
    fillRule: "evenodd"
  }, y$1("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), y$1("path", {
    fill: "#FFF",
    d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
  }))));
}
__name(CancelBtn, "CancelBtn");
function PauseResumeButton(props) {
  const {
    isAllPaused,
    i18n,
    isAllComplete,
    resumableUploads,
    uppy
  } = props, title = i18n(isAllPaused ? "resume" : "pause");
  function togglePauseResume() {
    return isAllComplete ? null : resumableUploads ? isAllPaused ? uppy.resumeAll() : uppy.pauseAll() : uppy.cancelAll();
  }
  return __name(togglePauseResume, "togglePauseResume"), y$1("button", {
    title,
    "aria-label": title,
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    type: "button",
    onClick: togglePauseResume,
    "data-cy": "togglePauseResume",
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, y$1("g", {
    fill: "none",
    fillRule: "evenodd"
  }, y$1("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), y$1("path", {
    fill: "#FFF",
    d: isAllPaused ? "M6 4.25L11.5 8 6 11.75z" : "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z"
  }))));
}
__name(PauseResumeButton, "PauseResumeButton");
function DoneBtn(props) {
  const {
    i18n,
    doneButtonHandler
  } = props;
  return y$1("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
    onClick: doneButtonHandler,
    "data-uppy-super-focusable": !0
  }, i18n("done"));
}
__name(DoneBtn, "DoneBtn");
function LoadingSpinner() {
  return y$1("svg", {
    className: "uppy-StatusBar-spinner",
    "aria-hidden": "true",
    focusable: "false",
    width: "14",
    height: "14"
  }, y$1("path", {
    d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
    fillRule: "evenodd"
  }));
}
__name(LoadingSpinner, "LoadingSpinner");
function ProgressBarProcessing(props) {
  const {
    progress
  } = props, {
    value,
    mode,
    message
  } = progress, roundedValue = Math.round(value * 100);
  return y$1("div", {
    className: "uppy-StatusBar-content"
  }, y$1(LoadingSpinner, null), mode === "determinate" ? `${roundedValue}% · ` : "", message);
}
__name(ProgressBarProcessing, "ProgressBarProcessing");
function ProgressDetails(props) {
  const {
    numUploads,
    complete,
    totalUploadedSize,
    totalSize,
    totalETA,
    i18n
  } = props, ifShowFilesUploadedOfTotal = numUploads > 1;
  return y$1("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, ifShowFilesUploadedOfTotal && i18n("filesUploadedOfTotal", {
    complete,
    smart_count: numUploads
  }), y$1("span", {
    className: "uppy-StatusBar-additionalInfo"
  }, ifShowFilesUploadedOfTotal && renderDot(), i18n("dataUploadedOfTotal", {
    complete: prettierBytes$3(totalUploadedSize),
    total: prettierBytes$3(totalSize)
  }), renderDot(), i18n("xTimeLeft", {
    time: prettyETA(totalETA)
  })));
}
__name(ProgressDetails, "ProgressDetails");
function FileUploadCount(props) {
  const {
    i18n,
    complete,
    numUploads
  } = props;
  return y$1("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, i18n("filesUploadedOfTotal", {
    complete,
    smart_count: numUploads
  }));
}
__name(FileUploadCount, "FileUploadCount");
function UploadNewlyAddedFiles(props) {
  const {
    i18n,
    newFiles,
    startUpload
  } = props, uploadBtnClassNames = classNames("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
  return y$1("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, y$1("div", {
    className: "uppy-StatusBar-statusSecondaryHint"
  }, i18n("xMoreFilesAdded", {
    smart_count: newFiles
  })), y$1("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n("uploadXFiles", {
      smart_count: newFiles
    }),
    onClick: startUpload
  }, i18n("upload")));
}
__name(UploadNewlyAddedFiles, "UploadNewlyAddedFiles");
function ProgressBarUploading(props) {
  const {
    i18n,
    supportsUploadProgress: supportsUploadProgress2,
    totalProgress,
    showProgressDetails,
    isUploadStarted,
    isAllComplete,
    isAllPaused,
    newFiles,
    numUploads,
    complete,
    totalUploadedSize,
    totalSize,
    totalETA,
    startUpload
  } = props, showUploadNewlyAddedFiles = newFiles && isUploadStarted;
  if (!isUploadStarted || isAllComplete)
    return null;
  const title = i18n(isAllPaused ? "paused" : "uploading");
  function renderProgressDetails() {
    return !isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails ? supportsUploadProgress2 ? y$1(ProgressDetails, {
      numUploads,
      complete,
      totalUploadedSize,
      totalSize,
      totalETA,
      i18n
    }) : y$1(FileUploadCount, {
      i18n,
      complete,
      numUploads
    }) : null;
  }
  return __name(renderProgressDetails, "renderProgressDetails"), y$1("div", {
    className: "uppy-StatusBar-content",
    "aria-label": title,
    title
  }, isAllPaused ? null : y$1(LoadingSpinner, null), y$1("div", {
    className: "uppy-StatusBar-status"
  }, y$1("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, supportsUploadProgress2 ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? y$1(UploadNewlyAddedFiles, {
    i18n,
    newFiles,
    startUpload
  }) : null));
}
__name(ProgressBarUploading, "ProgressBarUploading");
function ProgressBarComplete(props) {
  const {
    i18n
  } = props;
  return y$1("div", {
    className: "uppy-StatusBar-content",
    role: "status",
    title: i18n("complete")
  }, y$1("div", {
    className: "uppy-StatusBar-status"
  }, y$1("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "15",
    height: "11",
    viewBox: "0 0 15 11"
  }, y$1("path", {
    d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
  })), i18n("complete"))));
}
__name(ProgressBarComplete, "ProgressBarComplete");
function ProgressBarError(props) {
  const {
    error,
    i18n,
    complete,
    numUploads
  } = props;
  function displayErrorAlert() {
    const errorMessage = `${i18n("uploadFailed")} 

 ${error}`;
    alert(errorMessage);
  }
  return __name(displayErrorAlert, "displayErrorAlert"), y$1("div", {
    className: "uppy-StatusBar-content",
    title: i18n("uploadFailed")
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "11",
    height: "11",
    viewBox: "0 0 11 11"
  }, y$1("path", {
    d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
  })), y$1("div", {
    className: "uppy-StatusBar-status"
  }, y$1("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, i18n("uploadFailed"), y$1("button", {
    className: "uppy-u-reset uppy-StatusBar-details",
    "aria-label": i18n("showErrorDetails"),
    "data-microtip-position": "top-right",
    "data-microtip-size": "medium",
    onClick: displayErrorAlert,
    type: "button"
  }, "?")), y$1(FileUploadCount, {
    i18n,
    complete,
    numUploads
  })));
}
__name(ProgressBarError, "ProgressBarError");
const {
  STATE_ERROR,
  STATE_WAITING,
  STATE_PREPROCESSING,
  STATE_UPLOADING,
  STATE_POSTPROCESSING,
  STATE_COMPLETE
} = statusBarStates;
function StatusBar$1(props) {
  const {
    newFiles,
    allowNewUpload,
    isUploadInProgress,
    isAllPaused,
    resumableUploads,
    error,
    hideUploadButton,
    hidePauseResumeButton,
    hideCancelButton,
    hideRetryButton,
    recoveredState,
    uploadState,
    totalProgress,
    files,
    supportsUploadProgress: supportsUploadProgress2,
    hideAfterFinish,
    isSomeGhost,
    doneButtonHandler,
    isUploadStarted,
    i18n,
    startUpload,
    uppy,
    isAllComplete,
    showProgressDetails,
    numUploads,
    complete,
    totalSize,
    totalETA,
    totalUploadedSize
  } = props;
  function getProgressValue() {
    switch (uploadState) {
      case STATE_POSTPROCESSING:
      case STATE_PREPROCESSING: {
        const progress = calculateProcessingProgress(files);
        return progress.mode === "determinate" ? progress.value * 100 : totalProgress;
      }
      case STATE_ERROR:
        return null;
      case STATE_UPLOADING:
        return supportsUploadProgress2 ? totalProgress : null;
      default:
        return totalProgress;
    }
  }
  __name(getProgressValue, "getProgressValue");
  function getIsIndeterminate() {
    switch (uploadState) {
      case STATE_POSTPROCESSING:
      case STATE_PREPROCESSING: {
        const {
          mode
        } = calculateProcessingProgress(files);
        return mode === "indeterminate";
      }
      case STATE_UPLOADING:
        return !supportsUploadProgress2;
      default:
        return !1;
    }
  }
  __name(getIsIndeterminate, "getIsIndeterminate");
  function getIsHidden() {
    if (recoveredState)
      return !1;
    switch (uploadState) {
      case STATE_WAITING:
        return hideUploadButton || newFiles === 0;
      case STATE_COMPLETE:
        return hideAfterFinish;
      default:
        return !1;
    }
  }
  __name(getIsHidden, "getIsHidden");
  const progressValue = getProgressValue(), isHidden = getIsHidden(), width = progressValue ?? 100, showUploadBtn = !error && newFiles && !isUploadInProgress && !isAllPaused && allowNewUpload && !hideUploadButton, showCancelBtn = !hideCancelButton && uploadState !== STATE_WAITING && uploadState !== STATE_COMPLETE, showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === STATE_UPLOADING, showRetryBtn = error && !isAllComplete && !hideRetryButton, showDoneBtn = doneButtonHandler && uploadState === STATE_COMPLETE, progressClassNames = classNames("uppy-StatusBar-progress", {
    "is-indeterminate": getIsIndeterminate()
  }), statusBarClassNames = classNames("uppy-StatusBar", `is-${uploadState}`, {
    "has-ghosts": isSomeGhost
  });
  return y$1("div", {
    className: statusBarClassNames,
    "aria-hidden": isHidden
  }, y$1("div", {
    className: progressClassNames,
    style: {
      width: `${width}%`
    },
    role: "progressbar",
    "aria-label": `${width}%`,
    "aria-valuetext": `${width}%`,
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-valuenow": progressValue
  }), (() => {
    switch (uploadState) {
      case STATE_PREPROCESSING:
      case STATE_POSTPROCESSING:
        return y$1(ProgressBarProcessing, {
          progress: calculateProcessingProgress(files)
        });
      case STATE_COMPLETE:
        return y$1(ProgressBarComplete, {
          i18n
        });
      case STATE_ERROR:
        return y$1(ProgressBarError, {
          error,
          i18n,
          numUploads,
          complete
        });
      case STATE_UPLOADING:
        return y$1(ProgressBarUploading, {
          i18n,
          supportsUploadProgress: supportsUploadProgress2,
          totalProgress,
          showProgressDetails,
          isUploadStarted,
          isAllComplete,
          isAllPaused,
          newFiles,
          numUploads,
          complete,
          totalUploadedSize,
          totalSize,
          totalETA,
          startUpload
        });
      default:
        return null;
    }
  })(), y$1("div", {
    className: "uppy-StatusBar-actions"
  }, recoveredState || showUploadBtn ? y$1(UploadBtn, {
    newFiles,
    isUploadStarted,
    recoveredState,
    i18n,
    isSomeGhost,
    startUpload,
    uploadState
  }) : null, showRetryBtn ? y$1(RetryBtn, {
    i18n,
    uppy
  }) : null, showPauseResumeBtn ? y$1(PauseResumeButton, {
    isAllPaused,
    i18n,
    isAllComplete,
    resumableUploads,
    uppy
  }) : null, showCancelBtn ? y$1(CancelBtn, {
    i18n,
    uppy
  }) : null, showDoneBtn ? y$1(DoneBtn, {
    i18n,
    doneButtonHandler
  }) : null));
}
__name(StatusBar$1, "StatusBar$1");
const locale$j = {
  strings: {
    // Shown in the status bar while files are being uploaded.
    uploading: "Uploading",
    // Shown in the status bar once all files have been uploaded.
    complete: "Complete",
    // Shown in the status bar if an upload failed.
    uploadFailed: "Upload failed",
    // Shown in the status bar while the upload is paused.
    paused: "Paused",
    // Used as the label for the button that retries an upload.
    retry: "Retry",
    // Used as the label for the button that cancels an upload.
    cancel: "Cancel",
    // Used as the label for the button that pauses an upload.
    pause: "Pause",
    // Used as the label for the button that resumes an upload.
    resume: "Resume",
    // Used as the label for the button that resets the upload state after an upload
    done: "Done",
    // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
    filesUploadedOfTotal: {
      0: "%{complete} of %{smart_count} file uploaded",
      1: "%{complete} of %{smart_count} files uploaded"
    },
    // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
    dataUploadedOfTotal: "%{complete} of %{total}",
    // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
    xTimeLeft: "%{time} left",
    // Used as the label for the button that starts an upload.
    uploadXFiles: {
      0: "Upload %{smart_count} file",
      1: "Upload %{smart_count} files"
    },
    // Used as the label for the button that starts an upload, if another upload has been started in the past
    // and new files were added later.
    uploadXNewFiles: {
      0: "Upload +%{smart_count} file",
      1: "Upload +%{smart_count} files"
    },
    upload: "Upload",
    retryUpload: "Retry upload",
    xMoreFilesAdded: {
      0: "%{smart_count} more file added",
      1: "%{smart_count} more files added"
    },
    showErrorDetails: "Show error details"
  }
};
function _classPrivateFieldLooseBase$k(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$k, "_classPrivateFieldLooseBase$k");
var id$k = 0;
function _classPrivateFieldLooseKey$k(name) {
  return "__private_" + id$k++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$k, "_classPrivateFieldLooseKey$k");
const packageJson$t = {
  version: "3.2.4"
}, speedFilterHalfLife = 2e3, ETAFilterHalfLife = 2e3;
function getUploadingState$1(error, isAllComplete, recoveredState, files) {
  if (error)
    return statusBarStates.STATE_ERROR;
  if (isAllComplete)
    return statusBarStates.STATE_COMPLETE;
  if (recoveredState)
    return statusBarStates.STATE_WAITING;
  let state = statusBarStates.STATE_WAITING;
  const fileIDs = Object.keys(files);
  for (let i2 = 0; i2 < fileIDs.length; i2++) {
    const {
      progress
    } = files[fileIDs[i2]];
    if (progress.uploadStarted && !progress.uploadComplete)
      return statusBarStates.STATE_UPLOADING;
    progress.preprocess && state !== statusBarStates.STATE_UPLOADING && (state = statusBarStates.STATE_PREPROCESSING), progress.postprocess && state !== statusBarStates.STATE_UPLOADING && state !== statusBarStates.STATE_PREPROCESSING && (state = statusBarStates.STATE_POSTPROCESSING);
  }
  return state;
}
__name(getUploadingState$1, "getUploadingState$1");
var _lastUpdateTime = /* @__PURE__ */ _classPrivateFieldLooseKey$k("lastUpdateTime"), _previousUploadedBytes = /* @__PURE__ */ _classPrivateFieldLooseKey$k("previousUploadedBytes"), _previousSpeed = /* @__PURE__ */ _classPrivateFieldLooseKey$k("previousSpeed"), _previousETA = /* @__PURE__ */ _classPrivateFieldLooseKey$k("previousETA"), _computeSmoothETA = /* @__PURE__ */ _classPrivateFieldLooseKey$k("computeSmoothETA"), _onUploadStart = /* @__PURE__ */ _classPrivateFieldLooseKey$k("onUploadStart");
const _StatusBar = class _StatusBar extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), Object.defineProperty(this, _computeSmoothETA, {
      value: _computeSmoothETA2
    }), Object.defineProperty(this, _lastUpdateTime, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _previousUploadedBytes, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _previousSpeed, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _previousETA, {
      writable: !0,
      value: void 0
    }), this.startUpload = () => this.uppy.upload().catch(() => {
    }), Object.defineProperty(this, _onUploadStart, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        const {
          recoveredState
        } = this.uppy.getState();
        if (_classPrivateFieldLooseBase$k(this, _previousSpeed)[_previousSpeed] = null, _classPrivateFieldLooseBase$k(this, _previousETA)[_previousETA] = null, recoveredState) {
          _classPrivateFieldLooseBase$k(this, _previousUploadedBytes)[_previousUploadedBytes] = Object.values(recoveredState.files).reduce((pv, _ref) => {
            let {
              progress
            } = _ref;
            return pv + progress.bytesUploaded;
          }, 0), this.uppy.emit("restore-confirmed");
          return;
        }
        _classPrivateFieldLooseBase$k(this, _lastUpdateTime)[_lastUpdateTime] = performance.now(), _classPrivateFieldLooseBase$k(this, _previousUploadedBytes)[_previousUploadedBytes] = 0;
      }, "value")
    }), this.id = this.opts.id || "StatusBar", this.title = "StatusBar", this.type = "progressindicator", this.defaultLocale = locale$j;
    const defaultOptions2 = {
      target: "body",
      hideUploadButton: !1,
      hideRetryButton: !1,
      hidePauseResumeButton: !1,
      hideCancelButton: !1,
      showProgressDetails: !1,
      hideAfterFinish: !0,
      doneButtonHandler: null
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.i18nInit(), this.render = this.render.bind(this), this.install = this.install.bind(this);
  }
  render(state) {
    const {
      capabilities,
      files,
      allowNewUpload,
      totalProgress,
      error,
      recoveredState
    } = state, {
      newFiles,
      startedFiles,
      completeFiles,
      isUploadStarted,
      isAllComplete,
      isAllErrored,
      isAllPaused,
      isUploadInProgress,
      isSomeGhost
    } = this.uppy.getObjectOfFilesPerState(), newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles, resumableUploads = !!capabilities.resumableUploads, supportsUploadProgress2 = capabilities.uploadProgress !== !1;
    let totalSize = 0, totalUploadedSize = 0;
    startedFiles.forEach((file) => {
      totalSize += file.progress.bytesTotal || 0, totalUploadedSize += file.progress.bytesUploaded || 0;
    });
    const totalETA = _classPrivateFieldLooseBase$k(this, _computeSmoothETA)[_computeSmoothETA]({
      uploaded: totalUploadedSize,
      total: totalSize,
      remaining: totalSize - totalUploadedSize
    });
    return StatusBar$1({
      error,
      uploadState: getUploadingState$1(error, isAllComplete, recoveredState, state.files || {}),
      allowNewUpload,
      totalProgress,
      totalSize,
      totalUploadedSize,
      isAllComplete: !1,
      isAllPaused,
      isAllErrored,
      isUploadStarted,
      isUploadInProgress,
      isSomeGhost,
      recoveredState,
      complete: completeFiles.length,
      newFiles: newFilesOrRecovered.length,
      numUploads: startedFiles.length,
      totalETA,
      files,
      i18n: this.i18n,
      uppy: this.uppy,
      startUpload: this.startUpload,
      doneButtonHandler: this.opts.doneButtonHandler,
      resumableUploads,
      supportsUploadProgress: supportsUploadProgress2,
      showProgressDetails: this.opts.showProgressDetails,
      hideUploadButton: this.opts.hideUploadButton,
      hideRetryButton: this.opts.hideRetryButton,
      hidePauseResumeButton: this.opts.hidePauseResumeButton,
      hideCancelButton: this.opts.hideCancelButton,
      hideAfterFinish: this.opts.hideAfterFinish,
      isTargetDOMEl: this.isTargetDOMEl
    });
  }
  onMount() {
    const element = this.el;
    getTextDirection(element) || (element.dir = "ltr");
  }
  install() {
    const {
      target
    } = this.opts;
    target && this.mount(target, this), this.uppy.on("upload", _classPrivateFieldLooseBase$k(this, _onUploadStart)[_onUploadStart]), _classPrivateFieldLooseBase$k(this, _lastUpdateTime)[_lastUpdateTime] = performance.now(), _classPrivateFieldLooseBase$k(this, _previousUploadedBytes)[_previousUploadedBytes] = this.uppy.getFiles().reduce((pv, file) => pv + file.progress.bytesUploaded, 0);
  }
  uninstall() {
    this.unmount(), this.uppy.off("upload", _classPrivateFieldLooseBase$k(this, _onUploadStart)[_onUploadStart]);
  }
};
__name(_StatusBar, "StatusBar");
let StatusBar = _StatusBar;
function _computeSmoothETA2(totalBytes) {
  var _classPrivateFieldLoo, _classPrivateFieldLoo2;
  if (totalBytes.total === 0 || totalBytes.remaining === 0)
    return 0;
  (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = _classPrivateFieldLooseBase$k(this, _lastUpdateTime))[_lastUpdateTime]) != null || (_classPrivateFieldLoo[_lastUpdateTime] = performance.now());
  const dt = performance.now() - _classPrivateFieldLooseBase$k(this, _lastUpdateTime)[_lastUpdateTime];
  if (dt === 0) {
    var _classPrivateFieldLoo3;
    return Math.round(((_classPrivateFieldLoo3 = _classPrivateFieldLooseBase$k(this, _previousETA)[_previousETA]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
  }
  const uploadedBytesSinceLastTick = totalBytes.uploaded - _classPrivateFieldLooseBase$k(this, _previousUploadedBytes)[_previousUploadedBytes];
  if (_classPrivateFieldLooseBase$k(this, _previousUploadedBytes)[_previousUploadedBytes] = totalBytes.uploaded, uploadedBytesSinceLastTick <= 0) {
    var _classPrivateFieldLoo4;
    return Math.round(((_classPrivateFieldLoo4 = _classPrivateFieldLooseBase$k(this, _previousETA)[_previousETA]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
  }
  const currentSpeed = uploadedBytesSinceLastTick / dt, filteredSpeed = _classPrivateFieldLooseBase$k(this, _previousSpeed)[_previousSpeed] == null ? currentSpeed : emaFilter(currentSpeed, _classPrivateFieldLooseBase$k(this, _previousSpeed)[_previousSpeed], speedFilterHalfLife, dt);
  _classPrivateFieldLooseBase$k(this, _previousSpeed)[_previousSpeed] = filteredSpeed;
  const instantETA = totalBytes.remaining / filteredSpeed, updatedPreviousETA = Math.max(_classPrivateFieldLooseBase$k(this, _previousETA)[_previousETA] - dt, 0), filteredETA = _classPrivateFieldLooseBase$k(this, _previousETA)[_previousETA] == null ? instantETA : emaFilter(instantETA, updatedPreviousETA, ETAFilterHalfLife, dt);
  return _classPrivateFieldLooseBase$k(this, _previousETA)[_previousETA] = filteredETA, _classPrivateFieldLooseBase$k(this, _lastUpdateTime)[_lastUpdateTime] = performance.now(), Math.round(filteredETA / 100) / 10;
}
__name(_computeSmoothETA2, "_computeSmoothETA2");
StatusBar.VERSION = packageJson$t.version;
const TRANSITION_MS = 300, _FadeIn = class _FadeIn extends b$2 {
  constructor() {
    super(...arguments), this.ref = _$2();
  }
  componentWillEnter(callback) {
    this.ref.current.style.opacity = "1", this.ref.current.style.transform = "none", setTimeout(callback, TRANSITION_MS);
  }
  componentWillLeave(callback) {
    this.ref.current.style.opacity = "0", this.ref.current.style.transform = "translateY(350%)", setTimeout(callback, TRANSITION_MS);
  }
  render() {
    const {
      children
    } = this.props;
    return y$1("div", {
      className: "uppy-Informer-animated",
      ref: this.ref
    }, children);
  }
};
__name(_FadeIn, "FadeIn");
let FadeIn = _FadeIn;
function assign$2(obj, props) {
  return Object.assign(obj, props);
}
__name(assign$2, "assign$2");
function getKey(vnode, fallback) {
  var _vnode$key;
  return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}
__name(getKey, "getKey");
function linkRef(component, name) {
  const cache2 = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
  return cache2[name] || (cache2[name] = (c2) => {
    component.refs[name] = c2;
  });
}
__name(linkRef, "linkRef");
function getChildMapping(children) {
  const out = {};
  for (let i2 = 0; i2 < children.length; i2++)
    if (children[i2] != null) {
      const key = getKey(children[i2], i2.toString(36));
      out[key] = children[i2];
    }
  return out;
}
__name(getChildMapping, "getChildMapping");
function mergeChildMappings(prev, next) {
  prev = prev || {}, next = next || {};
  const getValueForKey = /* @__PURE__ */ __name((key) => next.hasOwnProperty(key) ? next[key] : prev[key], "getValueForKey"), nextKeysPending = {};
  let pendingKeys = [];
  for (const prevKey in prev)
    next.hasOwnProperty(prevKey) ? pendingKeys.length && (nextKeysPending[prevKey] = pendingKeys, pendingKeys = []) : pendingKeys.push(prevKey);
  const childMapping = {};
  for (const nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey))
      for (let i2 = 0; i2 < nextKeysPending[nextKey].length; i2++) {
        const pendingNextKey = nextKeysPending[nextKey][i2];
        childMapping[nextKeysPending[nextKey][i2]] = getValueForKey(pendingNextKey);
      }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (let i2 = 0; i2 < pendingKeys.length; i2++)
    childMapping[pendingKeys[i2]] = getValueForKey(pendingKeys[i2]);
  return childMapping;
}
__name(mergeChildMappings, "mergeChildMappings");
const identity = /* @__PURE__ */ __name((i2) => i2, "identity"), _TransitionGroup = class _TransitionGroup extends b$2 {
  constructor(props, context) {
    super(props, context), this.refs = {}, this.state = {
      children: getChildMapping(C(C(this.props.children)) || [])
    }, this.performAppear = this.performAppear.bind(this), this.performEnter = this.performEnter.bind(this), this.performLeave = this.performLeave.bind(this);
  }
  componentWillMount() {
    this.currentlyTransitioningKeys = {}, this.keysToAbortLeave = [], this.keysToEnter = [], this.keysToLeave = [];
  }
  componentDidMount() {
    const initialChildMapping = this.state.children;
    for (const key in initialChildMapping)
      initialChildMapping[key] && this.performAppear(key);
  }
  componentWillReceiveProps(nextProps) {
    const nextChildMapping = getChildMapping(C(nextProps.children) || []), prevChildMapping = this.state.children;
    this.setState((prevState) => ({
      children: mergeChildMappings(prevState.children, nextChildMapping)
    }));
    let key;
    for (key in nextChildMapping)
      if (nextChildMapping.hasOwnProperty(key)) {
        const hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
        nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key] ? (this.keysToEnter.push(key), this.keysToAbortLeave.push(key)) : nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key] && this.keysToEnter.push(key);
      }
    for (key in prevChildMapping)
      if (prevChildMapping.hasOwnProperty(key)) {
        const hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
        prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key] && this.keysToLeave.push(key);
      }
  }
  componentDidUpdate() {
    const {
      keysToEnter
    } = this;
    this.keysToEnter = [], keysToEnter.forEach(this.performEnter);
    const {
      keysToLeave
    } = this;
    this.keysToLeave = [], keysToLeave.forEach(this.performLeave);
  }
  _finishAbort(key) {
    const idx = this.keysToAbortLeave.indexOf(key);
    idx !== -1 && this.keysToAbortLeave.splice(idx, 1);
  }
  performAppear(key) {
    this.currentlyTransitioningKeys[key] = !0;
    const component = this.refs[key];
    component != null && component.componentWillAppear ? component.componentWillAppear(this._handleDoneAppearing.bind(this, key)) : this._handleDoneAppearing(key);
  }
  _handleDoneAppearing(key) {
    const component = this.refs[key];
    component != null && component.componentDidAppear && component.componentDidAppear(), delete this.currentlyTransitioningKeys[key], this._finishAbort(key);
    const currentChildMapping = getChildMapping(C(this.props.children) || []);
    (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) && this.performLeave(key);
  }
  performEnter(key) {
    this.currentlyTransitioningKeys[key] = !0;
    const component = this.refs[key];
    component != null && component.componentWillEnter ? component.componentWillEnter(this._handleDoneEntering.bind(this, key)) : this._handleDoneEntering(key);
  }
  _handleDoneEntering(key) {
    const component = this.refs[key];
    component != null && component.componentDidEnter && component.componentDidEnter(), delete this.currentlyTransitioningKeys[key], this._finishAbort(key);
    const currentChildMapping = getChildMapping(C(this.props.children) || []);
    (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) && this.performLeave(key);
  }
  performLeave(key) {
    if (this.keysToAbortLeave.indexOf(key) !== -1)
      return;
    this.currentlyTransitioningKeys[key] = !0;
    const component = this.refs[key];
    component != null && component.componentWillLeave ? component.componentWillLeave(this._handleDoneLeaving.bind(this, key)) : this._handleDoneLeaving(key);
  }
  _handleDoneLeaving(key) {
    if (this.keysToAbortLeave.indexOf(key) !== -1)
      return;
    const component = this.refs[key];
    component != null && component.componentDidLeave && component.componentDidLeave(), delete this.currentlyTransitioningKeys[key];
    const currentChildMapping = getChildMapping(C(this.props.children) || []);
    if (currentChildMapping && currentChildMapping.hasOwnProperty(key))
      this.performEnter(key);
    else {
      const children = assign$2({}, this.state.children);
      delete children[key], this.setState({
        children
      });
    }
  }
  render(_ref, _ref2) {
    let {
      childFactory,
      transitionLeave,
      transitionName: transitionName2,
      transitionAppear,
      transitionEnter,
      transitionLeaveTimeout,
      transitionEnterTimeout,
      transitionAppearTimeout,
      component,
      ...props
    } = _ref, {
      children
    } = _ref2;
    const childrenToRender = Object.entries(children).map((_ref3) => {
      let [key, child] = _ref3;
      if (!child) return;
      const ref = linkRef(this, key);
      return F$2(childFactory(child), {
        ref,
        key
      });
    }).filter(Boolean);
    return y$1(component, props, childrenToRender);
  }
};
__name(_TransitionGroup, "TransitionGroup");
let TransitionGroup = _TransitionGroup;
TransitionGroup.defaultProps = {
  component: "span",
  childFactory: identity
};
const packageJson$s = {
  version: "3.0.3"
}, _Informer = class _Informer extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.render = (state) => y$1("div", {
      className: "uppy uppy-Informer"
    }, y$1(TransitionGroup, null, state.info.map((info) => y$1(FadeIn, {
      key: info.message
    }, y$1("p", {
      role: "alert"
    }, info.message, " ", info.details && y$1("span", {
      "aria-label": info.details,
      "data-microtip-position": "top-left",
      "data-microtip-size": "medium",
      role: "tooltip",
      onClick: /* @__PURE__ */ __name(() => alert(`${info.message} 

 ${info.details}`), "onClick")
    }, "?")))))), this.type = "progressindicator", this.id = this.opts.id || "Informer", this.title = "Informer";
    const defaultOptions2 = {};
    this.opts = {
      ...defaultOptions2,
      ...opts
    };
  }
  install() {
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
};
__name(_Informer, "Informer");
let Informer = _Informer;
Informer.VERSION = packageJson$s.version;
const DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function dataURItoBlob(dataURI, opts, toFile) {
  var _ref, _opts$mimeType;
  const dataURIData = DATA_URL_PATTERN.exec(dataURI), mimeType = (_ref = (_opts$mimeType = opts.mimeType) != null ? _opts$mimeType : dataURIData == null ? void 0 : dataURIData[1]) != null ? _ref : "plain/text";
  let data;
  if (dataURIData[2] != null) {
    const binary = atob(decodeURIComponent(dataURIData[3])), bytes = new Uint8Array(binary.length);
    for (let i2 = 0; i2 < binary.length; i2++)
      bytes[i2] = binary.charCodeAt(i2);
    data = [bytes];
  } else
    data = [decodeURIComponent(dataURIData[3])];
  return new Blob(data, {
    type: mimeType
  });
}
__name(dataURItoBlob, "dataURItoBlob");
function isObjectURL(url) {
  return url.startsWith("blob:");
}
__name(isObjectURL, "isObjectURL");
function e(e2, t2, s2) {
  return t2 in e2 ? Object.defineProperty(e2, t2, { value: s2, enumerable: !0, configurable: !0, writable: !0 }) : e2[t2] = s2, e2;
}
__name(e, "e");
var t = typeof self < "u" ? self : global;
const s = typeof navigator < "u", i = s && typeof HTMLImageElement > "u", n = !(typeof global > "u" || typeof process > "u" || !process.versions || !process.versions.node), r = t.Buffer, a = !!r, h = /* @__PURE__ */ __name((e2) => e2 !== void 0, "h");
function f(e2) {
  return e2 === void 0 || (e2 instanceof Map ? e2.size === 0 : Object.values(e2).filter(h).length === 0);
}
__name(f, "f");
function l(e2) {
  let t2 = new Error(e2);
  throw delete t2.stack, t2;
}
__name(l, "l");
function o(e2) {
  let t2 = function(e3) {
    let t3 = 0;
    return e3.ifd0.enabled && (t3 += 1024), e3.exif.enabled && (t3 += 2048), e3.makerNote && (t3 += 2048), e3.userComment && (t3 += 1024), e3.gps.enabled && (t3 += 512), e3.interop.enabled && (t3 += 100), e3.ifd1.enabled && (t3 += 1024), t3 + 2048;
  }(e2);
  return e2.jfif.enabled && (t2 += 50), e2.xmp.enabled && (t2 += 2e4), e2.iptc.enabled && (t2 += 14e3), e2.icc.enabled && (t2 += 6e3), t2;
}
__name(o, "o");
const u = /* @__PURE__ */ __name((e2) => String.fromCharCode.apply(null, e2), "u"), d = typeof TextDecoder < "u" ? new TextDecoder("utf-8") : void 0, _c = class _c {
  static from(e2, t2) {
    return e2 instanceof this && e2.le === t2 ? e2 : new _c(e2, void 0, void 0, t2);
  }
  constructor(e2, t2 = 0, s2, i2) {
    if (typeof i2 == "boolean" && (this.le = i2), Array.isArray(e2) && (e2 = new Uint8Array(e2)), e2 === 0) this.byteOffset = 0, this.byteLength = 0;
    else if (e2 instanceof ArrayBuffer) {
      s2 === void 0 && (s2 = e2.byteLength - t2);
      let i3 = new DataView(e2, t2, s2);
      this._swapDataView(i3);
    } else if (e2 instanceof Uint8Array || e2 instanceof DataView || e2 instanceof _c) {
      s2 === void 0 && (s2 = e2.byteLength - t2), (t2 += e2.byteOffset) + s2 > e2.byteOffset + e2.byteLength && l("Creating view outside of available memory in ArrayBuffer");
      let i3 = new DataView(e2.buffer, t2, s2);
      this._swapDataView(i3);
    } else if (typeof e2 == "number") {
      let t3 = new DataView(new ArrayBuffer(e2));
      this._swapDataView(t3);
    } else l("Invalid input argument for BufferView: " + e2);
  }
  _swapArrayBuffer(e2) {
    this._swapDataView(new DataView(e2));
  }
  _swapBuffer(e2) {
    this._swapDataView(new DataView(e2.buffer, e2.byteOffset, e2.byteLength));
  }
  _swapDataView(e2) {
    this.dataView = e2, this.buffer = e2.buffer, this.byteOffset = e2.byteOffset, this.byteLength = e2.byteLength;
  }
  _lengthToEnd(e2) {
    return this.byteLength - e2;
  }
  set(e2, t2, s2 = _c) {
    return e2 instanceof DataView || e2 instanceof _c ? e2 = new Uint8Array(e2.buffer, e2.byteOffset, e2.byteLength) : e2 instanceof ArrayBuffer && (e2 = new Uint8Array(e2)), e2 instanceof Uint8Array || l("BufferView.set(): Invalid data argument."), this.toUint8().set(e2, t2), new s2(this, t2, e2.byteLength);
  }
  subarray(e2, t2) {
    return t2 = t2 || this._lengthToEnd(e2), new _c(this, e2, t2);
  }
  toUint8() {
    return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
  }
  getUint8Array(e2, t2) {
    return new Uint8Array(this.buffer, this.byteOffset + e2, t2);
  }
  getString(e2 = 0, t2 = this.byteLength) {
    return i2 = this.getUint8Array(e2, t2), d ? d.decode(i2) : a ? Buffer.from(i2).toString("utf8") : decodeURIComponent(escape(u(i2)));
    var i2;
  }
  getLatin1String(e2 = 0, t2 = this.byteLength) {
    let s2 = this.getUint8Array(e2, t2);
    return u(s2);
  }
  getUnicodeString(e2 = 0, t2 = this.byteLength) {
    const s2 = [];
    for (let i2 = 0; i2 < t2 && e2 + i2 < this.byteLength; i2 += 2) s2.push(this.getUint16(e2 + i2));
    return u(s2);
  }
  getInt8(e2) {
    return this.dataView.getInt8(e2);
  }
  getUint8(e2) {
    return this.dataView.getUint8(e2);
  }
  getInt16(e2, t2 = this.le) {
    return this.dataView.getInt16(e2, t2);
  }
  getInt32(e2, t2 = this.le) {
    return this.dataView.getInt32(e2, t2);
  }
  getUint16(e2, t2 = this.le) {
    return this.dataView.getUint16(e2, t2);
  }
  getUint32(e2, t2 = this.le) {
    return this.dataView.getUint32(e2, t2);
  }
  getFloat32(e2, t2 = this.le) {
    return this.dataView.getFloat32(e2, t2);
  }
  getFloat64(e2, t2 = this.le) {
    return this.dataView.getFloat64(e2, t2);
  }
  getFloat(e2, t2 = this.le) {
    return this.dataView.getFloat32(e2, t2);
  }
  getDouble(e2, t2 = this.le) {
    return this.dataView.getFloat64(e2, t2);
  }
  getUintBytes(e2, t2, s2) {
    switch (t2) {
      case 1:
        return this.getUint8(e2, s2);
      case 2:
        return this.getUint16(e2, s2);
      case 4:
        return this.getUint32(e2, s2);
      case 8:
        return this.getUint64 && this.getUint64(e2, s2);
    }
  }
  getUint(e2, t2, s2) {
    switch (t2) {
      case 8:
        return this.getUint8(e2, s2);
      case 16:
        return this.getUint16(e2, s2);
      case 32:
        return this.getUint32(e2, s2);
      case 64:
        return this.getUint64 && this.getUint64(e2, s2);
    }
  }
  toString(e2) {
    return this.dataView.toString(e2, this.constructor.name);
  }
  ensureChunk() {
  }
};
__name(_c, "c");
let c = _c;
function p(e2, t2) {
  l(`${e2} '${t2}' was not loaded, try using full build of exifr.`);
}
__name(p, "p");
const _g = class _g extends Map {
  constructor(e2) {
    super(), this.kind = e2;
  }
  get(e2, t2) {
    return this.has(e2) || p(this.kind, e2), t2 && (e2 in t2 || function(e3, t3) {
      l(`Unknown ${e3} '${t3}'.`);
    }(this.kind, e2), t2[e2].enabled || p(this.kind, e2)), super.get(e2);
  }
  keyList() {
    return Array.from(this.keys());
  }
};
__name(_g, "g");
let g = _g;
var m = new g("file parser"), y = new g("segment parser"), b = new g("file reader");
let w = t.fetch;
function k(e2, t2) {
  return (i2 = e2).startsWith("data:") || i2.length > 1e4 ? v(e2, t2, "base64") : n && e2.includes("://") ? O(e2, t2, "url", S) : n ? v(e2, t2, "fs") : s ? O(e2, t2, "url", S) : void l("Invalid input argument");
  var i2;
}
__name(k, "k");
async function O(e2, t2, s2, i2) {
  return b.has(s2) ? v(e2, t2, s2) : i2 ? async function(e3, t3) {
    let s3 = await t3(e3);
    return new c(s3);
  }(e2, i2) : void l(`Parser ${s2} is not loaded`);
}
__name(O, "O");
async function v(e2, t2, s2) {
  let i2 = new (b.get(s2))(e2, t2);
  return await i2.read(), i2;
}
__name(v, "v");
const S = /* @__PURE__ */ __name((e2) => w(e2).then((e3) => e3.arrayBuffer()), "S"), A = /* @__PURE__ */ __name((e2) => new Promise((t2, s2) => {
  let i2 = new FileReader();
  i2.onloadend = () => t2(i2.result || new ArrayBuffer()), i2.onerror = s2, i2.readAsArrayBuffer(e2);
}), "A"), B = /* @__PURE__ */ new Map(), V = /* @__PURE__ */ new Map(), I = /* @__PURE__ */ new Map(), L = ["chunked", "firstChunkSize", "firstChunkSizeNode", "firstChunkSizeBrowser", "chunkSize", "chunkLimit"], T = ["jfif", "xmp", "icc", "iptc", "ihdr"], z = ["tiff", ...T], P = ["ifd0", "ifd1", "exif", "gps", "interop"], F = [...z, ...P], j = ["makerNote", "userComment"], E = ["translateKeys", "translateValues", "reviveValues", "multiSegment"], M = [...E, "sanitize", "mergeOutput", "silentErrors"], __ = class __ {
  get translate() {
    return this.translateKeys || this.translateValues || this.reviveValues;
  }
};
__name(__, "_");
let _ = __;
const _D = class _D extends _ {
  get needed() {
    return this.enabled || this.deps.size > 0;
  }
  constructor(t2, s2, i2, n2) {
    if (super(), e(this, "enabled", !1), e(this, "skip", /* @__PURE__ */ new Set()), e(this, "pick", /* @__PURE__ */ new Set()), e(this, "deps", /* @__PURE__ */ new Set()), e(this, "translateKeys", !1), e(this, "translateValues", !1), e(this, "reviveValues", !1), this.key = t2, this.enabled = s2, this.parse = this.enabled, this.applyInheritables(n2), this.canBeFiltered = P.includes(t2), this.canBeFiltered && (this.dict = B.get(t2)), i2 !== void 0) if (Array.isArray(i2)) this.parse = this.enabled = !0, this.canBeFiltered && i2.length > 0 && this.translateTagSet(i2, this.pick);
    else if (typeof i2 == "object") {
      if (this.enabled = !0, this.parse = i2.parse !== !1, this.canBeFiltered) {
        let { pick: e2, skip: t3 } = i2;
        e2 && e2.length > 0 && this.translateTagSet(e2, this.pick), t3 && t3.length > 0 && this.translateTagSet(t3, this.skip);
      }
      this.applyInheritables(i2);
    } else i2 === !0 || i2 === !1 ? this.parse = this.enabled = i2 : l(`Invalid options argument: ${i2}`);
  }
  applyInheritables(e2) {
    let t2, s2;
    for (t2 of E) s2 = e2[t2], s2 !== void 0 && (this[t2] = s2);
  }
  translateTagSet(e2, t2) {
    if (this.dict) {
      let s2, i2, { tagKeys: n2, tagValues: r2 } = this.dict;
      for (s2 of e2) typeof s2 == "string" ? (i2 = r2.indexOf(s2), i2 === -1 && (i2 = n2.indexOf(Number(s2))), i2 !== -1 && t2.add(Number(n2[i2]))) : t2.add(s2);
    } else for (let s2 of e2) t2.add(s2);
  }
  finalizeFilters() {
    !this.enabled && this.deps.size > 0 ? (this.enabled = !0, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
  }
};
__name(_D, "D");
let D = _D;
var N = { jfif: !1, tiff: !0, xmp: !1, icc: !1, iptc: !1, ifd0: !0, ifd1: !1, exif: !0, gps: !0, interop: !1, ihdr: void 0, makerNote: !1, userComment: !1, multiSegment: !1, skip: [], pick: [], translateKeys: !0, translateValues: !0, reviveValues: !0, sanitize: !0, mergeOutput: !0, silentErrors: !0, chunked: !0, firstChunkSize: void 0, firstChunkSizeNode: 512, firstChunkSizeBrowser: 65536, chunkSize: 65536, chunkLimit: 5 }, $ = /* @__PURE__ */ new Map();
const _R = class _R extends _ {
  static useCached(e2) {
    let t2 = $.get(e2);
    return t2 !== void 0 || (t2 = new this(e2), $.set(e2, t2)), t2;
  }
  constructor(e2) {
    super(), e2 === !0 ? this.setupFromTrue() : e2 === void 0 ? this.setupFromUndefined() : Array.isArray(e2) ? this.setupFromArray(e2) : typeof e2 == "object" ? this.setupFromObject(e2) : l(`Invalid options argument ${e2}`), this.firstChunkSize === void 0 && (this.firstChunkSize = s ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
  }
  setupFromUndefined() {
    let e2;
    for (e2 of L) this[e2] = N[e2];
    for (e2 of M) this[e2] = N[e2];
    for (e2 of j) this[e2] = N[e2];
    for (e2 of F) this[e2] = new D(e2, N[e2], void 0, this);
  }
  setupFromTrue() {
    let e2;
    for (e2 of L) this[e2] = N[e2];
    for (e2 of M) this[e2] = N[e2];
    for (e2 of j) this[e2] = !0;
    for (e2 of F) this[e2] = new D(e2, !0, void 0, this);
  }
  setupFromArray(e2) {
    let t2;
    for (t2 of L) this[t2] = N[t2];
    for (t2 of M) this[t2] = N[t2];
    for (t2 of j) this[t2] = N[t2];
    for (t2 of F) this[t2] = new D(t2, !1, void 0, this);
    this.setupGlobalFilters(e2, void 0, P);
  }
  setupFromObject(e2) {
    let t2;
    for (t2 of (P.ifd0 = P.ifd0 || P.image, P.ifd1 = P.ifd1 || P.thumbnail, Object.assign(this, e2), L)) this[t2] = W(e2[t2], N[t2]);
    for (t2 of M) this[t2] = W(e2[t2], N[t2]);
    for (t2 of j) this[t2] = W(e2[t2], N[t2]);
    for (t2 of z) this[t2] = new D(t2, N[t2], e2[t2], this);
    for (t2 of P) this[t2] = new D(t2, N[t2], e2[t2], this.tiff);
    this.setupGlobalFilters(e2.pick, e2.skip, P, F), e2.tiff === !0 ? this.batchEnableWithBool(P, !0) : e2.tiff === !1 ? this.batchEnableWithUserValue(P, e2) : Array.isArray(e2.tiff) ? this.setupGlobalFilters(e2.tiff, void 0, P) : typeof e2.tiff == "object" && this.setupGlobalFilters(e2.tiff.pick, e2.tiff.skip, P);
  }
  batchEnableWithBool(e2, t2) {
    for (let s2 of e2) this[s2].enabled = t2;
  }
  batchEnableWithUserValue(e2, t2) {
    for (let s2 of e2) {
      let e3 = t2[s2];
      this[s2].enabled = e3 !== !1 && e3 !== void 0;
    }
  }
  setupGlobalFilters(e2, t2, s2, i2 = s2) {
    if (e2 && e2.length) {
      for (let e3 of i2) this[e3].enabled = !1;
      let t3 = K(e2, s2);
      for (let [e3, s3] of t3) X(this[e3].pick, s3), this[e3].enabled = !0;
    } else if (t2 && t2.length) {
      let e3 = K(t2, s2);
      for (let [t3, s3] of e3) X(this[t3].skip, s3);
    }
  }
  filterNestedSegmentTags() {
    let { ifd0: e2, exif: t2, xmp: s2, iptc: i2, icc: n2 } = this;
    this.makerNote ? t2.deps.add(37500) : t2.skip.add(37500), this.userComment ? t2.deps.add(37510) : t2.skip.add(37510), s2.enabled || e2.skip.add(700), i2.enabled || e2.skip.add(33723), n2.enabled || e2.skip.add(34675);
  }
  traverseTiffDependencyTree() {
    let { ifd0: e2, exif: t2, gps: s2, interop: i2 } = this;
    i2.needed && (t2.deps.add(40965), e2.deps.add(40965)), t2.needed && e2.deps.add(34665), s2.needed && e2.deps.add(34853), this.tiff.enabled = P.some((e3) => this[e3].enabled === !0) || this.makerNote || this.userComment;
    for (let e3 of P) this[e3].finalizeFilters();
  }
  get onlyTiff() {
    return !T.map((e2) => this[e2].enabled).some((e2) => e2 === !0) && this.tiff.enabled;
  }
  checkLoadedPlugins() {
    for (let e2 of z) this[e2].enabled && !y.has(e2) && p("segment parser", e2);
  }
};
__name(_R, "R");
let R = _R;
function K(e2, t2) {
  let s2, i2, n2, r2, a2 = [];
  for (n2 of t2) {
    for (r2 of (s2 = B.get(n2), i2 = [], s2)) (e2.includes(r2[0]) || e2.includes(r2[1])) && i2.push(r2[0]);
    i2.length && a2.push([n2, i2]);
  }
  return a2;
}
__name(K, "K");
function W(e2, t2) {
  return e2 !== void 0 ? e2 : t2 !== void 0 ? t2 : void 0;
}
__name(W, "W");
function X(e2, t2) {
  for (let s2 of t2) e2.add(s2);
}
__name(X, "X");
e(R, "default", N);
const _H = class _H {
  constructor(t2) {
    e(this, "parsers", {}), e(this, "output", {}), e(this, "errors", []), e(this, "pushToErrors", (e2) => this.errors.push(e2)), this.options = R.useCached(t2);
  }
  async read(e2) {
    this.file = await function(e3, t2) {
      return typeof e3 == "string" ? k(e3, t2) : s && !i && e3 instanceof HTMLImageElement ? k(e3.src, t2) : e3 instanceof Uint8Array || e3 instanceof ArrayBuffer || e3 instanceof DataView ? new c(e3) : s && e3 instanceof Blob ? O(e3, t2, "blob", A) : void l("Invalid input argument");
    }(e2, this.options);
  }
  setup() {
    if (this.fileParser) return;
    let { file: e2 } = this, t2 = e2.getUint16(0);
    for (let [s2, i2] of m) if (i2.canHandle(e2, t2)) return this.fileParser = new i2(this.options, this.file, this.parsers), e2[s2] = !0;
    this.file.close && this.file.close(), l("Unknown file format");
  }
  async parse() {
    let { output: e2, errors: t2 } = this;
    return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t2.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t2.length > 0 && (e2.errors = t2), f(s2 = e2) ? void 0 : s2;
    var s2;
  }
  async executeParsers() {
    let { output: e2 } = this;
    await this.fileParser.parse();
    let t2 = Object.values(this.parsers).map(async (t3) => {
      let s2 = await t3.parse();
      t3.assignToOutput(e2, s2);
    });
    this.options.silentErrors && (t2 = t2.map((e3) => e3.catch(this.pushToErrors))), await Promise.all(t2);
  }
  async extractThumbnail() {
    this.setup();
    let { options: e2, file: t2 } = this, s2 = y.get("tiff", e2);
    var i2;
    if (t2.tiff ? i2 = { start: 0, type: "tiff" } : t2.jpeg && (i2 = await this.fileParser.getOrFindSegment("tiff")), i2 === void 0) return;
    let n2 = await this.fileParser.ensureSegmentChunk(i2), r2 = this.parsers.tiff = new s2(n2, e2, t2), a2 = await r2.extractThumbnail();
    return t2.close && t2.close(), a2;
  }
};
__name(_H, "H");
let H = _H;
const _J = class _J {
  static findPosition(e2, t2) {
    let s2 = e2.getUint16(t2 + 2) + 2, i2 = typeof this.headerLength == "function" ? this.headerLength(e2, t2, s2) : this.headerLength, n2 = t2 + i2, r2 = s2 - i2;
    return { offset: t2, length: s2, headerLength: i2, start: n2, size: r2, end: n2 + r2 };
  }
  static parse(e2, t2 = {}) {
    return new this(e2, new R({ [this.type]: t2 }), e2).parse();
  }
  normalizeInput(e2) {
    return e2 instanceof c ? e2 : new c(e2);
  }
  constructor(t2, s2 = {}, i2) {
    e(this, "errors", []), e(this, "raw", /* @__PURE__ */ new Map()), e(this, "handleError", (e2) => {
      if (!this.options.silentErrors) throw e2;
      this.errors.push(e2.message);
    }), this.chunk = this.normalizeInput(t2), this.file = i2, this.type = this.constructor.type, this.globalOptions = this.options = s2, this.localOptions = s2[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
  }
  translate() {
    this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
  }
  get output() {
    return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
  }
  translateBlock(e2, t2) {
    let s2 = I.get(t2), i2 = V.get(t2), n2 = B.get(t2), r2 = this.options[t2], a2 = r2.reviveValues && !!s2, h2 = r2.translateValues && !!i2, f2 = r2.translateKeys && !!n2, l2 = {};
    for (let [t3, r3] of e2) a2 && s2.has(t3) ? r3 = s2.get(t3)(r3) : h2 && i2.has(t3) && (r3 = this.translateValue(r3, i2.get(t3))), f2 && n2.has(t3) && (t3 = n2.get(t3) || t3), l2[t3] = r3;
    return l2;
  }
  translateValue(e2, t2) {
    return t2[e2] || t2.DEFAULT || e2;
  }
  assignToOutput(e2, t2) {
    this.assignObjectToOutput(e2, this.constructor.type, t2);
  }
  assignObjectToOutput(e2, t2, s2) {
    if (this.globalOptions.mergeOutput) return Object.assign(e2, s2);
    e2[t2] ? Object.assign(e2[t2], s2) : e2[t2] = s2;
  }
};
__name(_J, "J");
let J = _J;
e(J, "headerLength", 4), e(J, "type", void 0), e(J, "multiSegment", !1), e(J, "canHandle", () => !1);
function q(e2) {
  return e2 === 192 || e2 === 194 || e2 === 196 || e2 === 219 || e2 === 221 || e2 === 218 || e2 === 254;
}
__name(q, "q");
function Q(e2) {
  return e2 >= 224 && e2 <= 239;
}
__name(Q, "Q");
function Z(e2, t2, s2) {
  for (let [i2, n2] of y) if (n2.canHandle(e2, t2, s2)) return i2;
}
__name(Z, "Z");
const _ee = class _ee extends class {
  constructor(t2, s2, i2) {
    e(this, "errors", []), e(this, "ensureSegmentChunk", async (e2) => {
      let t3 = e2.start, s3 = e2.size || 65536;
      if (this.file.chunked) if (this.file.available(t3, s3)) e2.chunk = this.file.subarray(t3, s3);
      else try {
        e2.chunk = await this.file.readChunk(t3, s3);
      } catch (t4) {
        l(`Couldn't read segment: ${JSON.stringify(e2)}. ${t4.message}`);
      }
      else this.file.byteLength > t3 + s3 ? e2.chunk = this.file.subarray(t3, s3) : e2.size === void 0 ? e2.chunk = this.file.subarray(t3) : l("Segment unreachable: " + JSON.stringify(e2));
      return e2.chunk;
    }), this.extendOptions && this.extendOptions(t2), this.options = t2, this.file = s2, this.parsers = i2;
  }
  injectSegment(e2, t2) {
    this.options[e2].enabled && this.createParser(e2, t2);
  }
  createParser(e2, t2) {
    let s2 = new (y.get(e2))(t2, this.options, this.file);
    return this.parsers[e2] = s2;
  }
  createParsers(e2) {
    for (let t2 of e2) {
      let { type: e3, chunk: s2 } = t2, i2 = this.options[e3];
      if (i2 && i2.enabled) {
        let t3 = this.parsers[e3];
        t3 && t3.append || t3 || this.createParser(e3, s2);
      }
    }
  }
  async readSegments(e2) {
    let t2 = e2.map(this.ensureSegmentChunk);
    await Promise.all(t2);
  }
} {
  constructor(...t2) {
    super(...t2), e(this, "appSegments", []), e(this, "jpegSegments", []), e(this, "unknownSegments", []);
  }
  static canHandle(e2, t2) {
    return t2 === 65496;
  }
  async parse() {
    await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
  }
  setupSegmentFinderArgs(e2) {
    e2 === !0 ? (this.findAll = !0, this.wanted = new Set(y.keyList())) : (e2 = e2 === void 0 ? y.keyList().filter((e3) => this.options[e3].enabled) : e2.filter((e3) => this.options[e3].enabled && y.has(e3)), this.findAll = !1, this.remaining = new Set(e2), this.wanted = new Set(e2)), this.unfinishedMultiSegment = !1;
  }
  async findAppSegments(e2 = 0, t2) {
    this.setupSegmentFinderArgs(t2);
    let { file: s2, findAll: i2, wanted: n2, remaining: r2 } = this;
    if (!i2 && this.file.chunked && (i2 = Array.from(n2).some((e3) => {
      let t3 = y.get(e3), s3 = this.options[e3];
      return t3.multiSegment && s3.multiSegment;
    }), i2 && await this.file.readWhole()), e2 = this.findAppSegmentsInRange(e2, s2.byteLength), !this.options.onlyTiff && s2.chunked) {
      let t3 = !1;
      for (; r2.size > 0 && !t3 && (s2.canReadNextChunk || this.unfinishedMultiSegment); ) {
        let { nextChunkOffset: i3 } = s2, n3 = this.appSegments.some((e3) => !this.file.available(e3.offset || e3.start, e3.length || e3.size));
        if (t3 = e2 > i3 && !n3 ? !await s2.readNextChunk(e2) : !await s2.readNextChunk(i3), (e2 = this.findAppSegmentsInRange(e2, s2.byteLength)) === void 0) return;
      }
    }
  }
  findAppSegmentsInRange(e2, t2) {
    t2 -= 2;
    let s2, i2, n2, r2, a2, h2, { file: f2, findAll: l2, wanted: o2, remaining: u2, options: d2 } = this;
    for (; e2 < t2; e2++) if (f2.getUint8(e2) === 255) {
      if (s2 = f2.getUint8(e2 + 1), Q(s2)) {
        if (i2 = f2.getUint16(e2 + 2), n2 = Z(f2, e2, i2), n2 && o2.has(n2) && (r2 = y.get(n2), a2 = r2.findPosition(f2, e2), h2 = d2[n2], a2.type = n2, this.appSegments.push(a2), !l2 && (r2.multiSegment && h2.multiSegment ? (this.unfinishedMultiSegment = a2.chunkNumber < a2.chunkCount, this.unfinishedMultiSegment || u2.delete(n2)) : u2.delete(n2), u2.size === 0))) break;
        d2.recordUnknownSegments && (a2 = J.findPosition(f2, e2), a2.marker = s2, this.unknownSegments.push(a2)), e2 += i2 + 1;
      } else if (q(s2)) {
        if (i2 = f2.getUint16(e2 + 2), s2 === 218 && d2.stopAfterSos !== !1) return;
        d2.recordJpegSegments && this.jpegSegments.push({ offset: e2, length: i2, marker: s2 }), e2 += i2 + 1;
      }
    }
    return e2;
  }
  mergeMultiSegments() {
    if (!this.appSegments.some((e3) => e3.multiSegment)) return;
    let e2 = function(e3, t2) {
      let s2, i2, n2, r2 = /* @__PURE__ */ new Map();
      for (let a2 = 0; a2 < e3.length; a2++) s2 = e3[a2], i2 = s2[t2], r2.has(i2) ? n2 = r2.get(i2) : r2.set(i2, n2 = []), n2.push(s2);
      return Array.from(r2);
    }(this.appSegments, "type");
    this.mergedAppSegments = e2.map(([e3, t2]) => {
      let s2 = y.get(e3, this.options);
      return s2.handleMultiSegments ? { type: e3, chunk: s2.handleMultiSegments(t2) } : t2[0];
    });
  }
  getSegment(e2) {
    return this.appSegments.find((t2) => t2.type === e2);
  }
  async getOrFindSegment(e2) {
    let t2 = this.getSegment(e2);
    return t2 === void 0 && (await this.findAppSegments(0, [e2]), t2 = this.getSegment(e2)), t2;
  }
};
__name(_ee, "ee");
let ee = _ee;
e(ee, "type", "jpeg"), m.set("jpeg", ee);
const te = [void 0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8, 4], _se = class _se extends J {
  parseHeader() {
    var e2 = this.chunk.getUint16();
    e2 === 18761 ? this.le = !0 : e2 === 19789 && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
  }
  parseTags(e2, t2, s2 = /* @__PURE__ */ new Map()) {
    let { pick: i2, skip: n2 } = this.options[t2];
    i2 = new Set(i2);
    let r2 = i2.size > 0, a2 = n2.size === 0, h2 = this.chunk.getUint16(e2);
    e2 += 2;
    for (let f2 = 0; f2 < h2; f2++) {
      let h3 = this.chunk.getUint16(e2);
      if (r2) {
        if (i2.has(h3) && (s2.set(h3, this.parseTag(e2, h3, t2)), i2.delete(h3), i2.size === 0)) break;
      } else !a2 && n2.has(h3) || s2.set(h3, this.parseTag(e2, h3, t2));
      e2 += 12;
    }
    return s2;
  }
  parseTag(e2, t2, s2) {
    let { chunk: i2 } = this, n2 = i2.getUint16(e2 + 2), r2 = i2.getUint32(e2 + 4), a2 = te[n2];
    if (a2 * r2 <= 4 ? e2 += 8 : e2 = i2.getUint32(e2 + 8), (n2 < 1 || n2 > 13) && l(`Invalid TIFF value type. block: ${s2.toUpperCase()}, tag: ${t2.toString(16)}, type: ${n2}, offset ${e2}`), e2 > i2.byteLength && l(`Invalid TIFF value offset. block: ${s2.toUpperCase()}, tag: ${t2.toString(16)}, type: ${n2}, offset ${e2} is outside of chunk size ${i2.byteLength}`), n2 === 1) return i2.getUint8Array(e2, r2);
    if (n2 === 2) return (h2 = function(e3) {
      for (; e3.endsWith("\0"); ) e3 = e3.slice(0, -1);
      return e3;
    }(h2 = i2.getString(e2, r2)).trim()) === "" ? void 0 : h2;
    var h2;
    if (n2 === 7) return i2.getUint8Array(e2, r2);
    if (r2 === 1) return this.parseTagValue(n2, e2);
    {
      let t3 = new (function(e3) {
        switch (e3) {
          case 1:
            return Uint8Array;
          case 3:
            return Uint16Array;
          case 4:
            return Uint32Array;
          case 5:
            return Array;
          case 6:
            return Int8Array;
          case 8:
            return Int16Array;
          case 9:
            return Int32Array;
          case 10:
            return Array;
          case 11:
            return Float32Array;
          case 12:
            return Float64Array;
          default:
            return Array;
        }
      }(n2))(r2), s3 = a2;
      for (let i3 = 0; i3 < r2; i3++) t3[i3] = this.parseTagValue(n2, e2), e2 += s3;
      return t3;
    }
  }
  parseTagValue(e2, t2) {
    let { chunk: s2 } = this;
    switch (e2) {
      case 1:
        return s2.getUint8(t2);
      case 3:
        return s2.getUint16(t2);
      case 4:
        return s2.getUint32(t2);
      case 5:
        return s2.getUint32(t2) / s2.getUint32(t2 + 4);
      case 6:
        return s2.getInt8(t2);
      case 8:
        return s2.getInt16(t2);
      case 9:
        return s2.getInt32(t2);
      case 10:
        return s2.getInt32(t2) / s2.getInt32(t2 + 4);
      case 11:
        return s2.getFloat(t2);
      case 12:
        return s2.getDouble(t2);
      case 13:
        return s2.getUint32(t2);
      default:
        l(`Invalid tiff type ${e2}`);
    }
  }
};
__name(_se, "se");
let se = _se;
const _ie = class _ie extends se {
  static canHandle(e2, t2) {
    return e2.getUint8(t2 + 1) === 225 && e2.getUint32(t2 + 4) === 1165519206 && e2.getUint16(t2 + 8) === 0;
  }
  async parse() {
    this.parseHeader();
    let { options: e2 } = this;
    return e2.ifd0.enabled && await this.parseIfd0Block(), e2.exif.enabled && await this.safeParse("parseExifBlock"), e2.gps.enabled && await this.safeParse("parseGpsBlock"), e2.interop.enabled && await this.safeParse("parseInteropBlock"), e2.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
  }
  safeParse(e2) {
    let t2 = this[e2]();
    return t2.catch !== void 0 && (t2 = t2.catch(this.handleError)), t2;
  }
  findIfd0Offset() {
    this.ifd0Offset === void 0 && (this.ifd0Offset = this.chunk.getUint32(4));
  }
  findIfd1Offset() {
    if (this.ifd1Offset === void 0) {
      this.findIfd0Offset();
      let e2 = this.chunk.getUint16(this.ifd0Offset), t2 = this.ifd0Offset + 2 + 12 * e2;
      this.ifd1Offset = this.chunk.getUint32(t2);
    }
  }
  parseBlock(e2, t2) {
    let s2 = /* @__PURE__ */ new Map();
    return this[t2] = s2, this.parseTags(e2, t2, s2), s2;
  }
  async parseIfd0Block() {
    if (this.ifd0) return;
    let { file: e2 } = this;
    this.findIfd0Offset(), this.ifd0Offset < 8 && l("Malformed EXIF data"), !e2.chunked && this.ifd0Offset > e2.byteLength && l(`IFD0 offset points to outside of file.
this.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e2.byteLength}`), e2.tiff && await e2.ensureChunk(this.ifd0Offset, o(this.options));
    let t2 = this.parseBlock(this.ifd0Offset, "ifd0");
    return t2.size !== 0 ? (this.exifOffset = t2.get(34665), this.interopOffset = t2.get(40965), this.gpsOffset = t2.get(34853), this.xmp = t2.get(700), this.iptc = t2.get(33723), this.icc = t2.get(34675), this.options.sanitize && (t2.delete(34665), t2.delete(40965), t2.delete(34853), t2.delete(700), t2.delete(33723), t2.delete(34675)), t2) : void 0;
  }
  async parseExifBlock() {
    if (this.exif || (this.ifd0 || await this.parseIfd0Block(), this.exifOffset === void 0)) return;
    this.file.tiff && await this.file.ensureChunk(this.exifOffset, o(this.options));
    let e2 = this.parseBlock(this.exifOffset, "exif");
    return this.interopOffset || (this.interopOffset = e2.get(40965)), this.makerNote = e2.get(37500), this.userComment = e2.get(37510), this.options.sanitize && (e2.delete(40965), e2.delete(37500), e2.delete(37510)), this.unpack(e2, 41728), this.unpack(e2, 41729), e2;
  }
  unpack(e2, t2) {
    let s2 = e2.get(t2);
    s2 && s2.length === 1 && e2.set(t2, s2[0]);
  }
  async parseGpsBlock() {
    if (this.gps || (this.ifd0 || await this.parseIfd0Block(), this.gpsOffset === void 0)) return;
    let e2 = this.parseBlock(this.gpsOffset, "gps");
    return e2 && e2.has(2) && e2.has(4) && (e2.set("latitude", ne(...e2.get(2), e2.get(1))), e2.set("longitude", ne(...e2.get(4), e2.get(3)))), e2;
  }
  async parseInteropBlock() {
    if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), this.interopOffset !== void 0 || this.exif || await this.parseExifBlock(), this.interopOffset !== void 0)) return this.parseBlock(this.interopOffset, "interop");
  }
  async parseThumbnailBlock(e2 = !1) {
    if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e2)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
  }
  async extractThumbnail() {
    if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), this.ifd1 === void 0) return;
    let e2 = this.ifd1.get(513), t2 = this.ifd1.get(514);
    return this.chunk.getUint8Array(e2, t2);
  }
  get image() {
    return this.ifd0;
  }
  get thumbnail() {
    return this.ifd1;
  }
  createOutput() {
    let e2, t2, s2, i2 = {};
    for (t2 of P) if (e2 = this[t2], !f(e2)) if (s2 = this.canTranslate ? this.translateBlock(e2, t2) : Object.fromEntries(e2), this.options.mergeOutput) {
      if (t2 === "ifd1") continue;
      Object.assign(i2, s2);
    } else i2[t2] = s2;
    return this.makerNote && (i2.makerNote = this.makerNote), this.userComment && (i2.userComment = this.userComment), i2;
  }
  assignToOutput(e2, t2) {
    if (this.globalOptions.mergeOutput) Object.assign(e2, t2);
    else for (let [s2, i2] of Object.entries(t2)) this.assignObjectToOutput(e2, s2, i2);
  }
};
__name(_ie, "ie");
let ie = _ie;
function ne(e2, t2, s2, i2) {
  var n2 = e2 + t2 / 60 + s2 / 3600;
  return i2 !== "S" && i2 !== "W" || (n2 *= -1), n2;
}
__name(ne, "ne");
e(ie, "type", "tiff"), e(ie, "headerLength", 10), y.set("tiff", ie);
const ae = { ifd0: !1, ifd1: !1, exif: !1, gps: !1, interop: !1, sanitize: !1, reviveValues: !0, translateKeys: !1, translateValues: !1, mergeOutput: !1 };
Object.assign({}, ae, { firstChunkSize: 4e4, gps: [1, 2, 3, 4] });
Object.assign({}, ae, { tiff: !1, ifd1: !0, mergeOutput: !1 });
const de = Object.assign({}, ae, { firstChunkSize: 4e4, ifd0: [274] });
async function ce(e2) {
  let t2 = new H(de);
  await t2.read(e2);
  let s2 = await t2.parse();
  if (s2 && s2.ifd0) return s2.ifd0[274];
}
__name(ce, "ce");
const pe = Object.freeze({ 1: { dimensionSwapped: !1, scaleX: 1, scaleY: 1, deg: 0, rad: 0 }, 2: { dimensionSwapped: !1, scaleX: -1, scaleY: 1, deg: 0, rad: 0 }, 3: { dimensionSwapped: !1, scaleX: 1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 4: { dimensionSwapped: !1, scaleX: -1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 5: { dimensionSwapped: !0, scaleX: 1, scaleY: -1, deg: 90, rad: 90 * Math.PI / 180 }, 6: { dimensionSwapped: !0, scaleX: 1, scaleY: 1, deg: 90, rad: 90 * Math.PI / 180 }, 7: { dimensionSwapped: !0, scaleX: 1, scaleY: -1, deg: 270, rad: 270 * Math.PI / 180 }, 8: { dimensionSwapped: !0, scaleX: 1, scaleY: 1, deg: 270, rad: 270 * Math.PI / 180 } });
let ge = !0, me = !0;
if (typeof navigator == "object") {
  let e2 = navigator.userAgent;
  if (e2.includes("iPad") || e2.includes("iPhone")) {
    let t2 = e2.match(/OS (\d+)_(\d+)/);
    if (t2) {
      let [, e3, s2] = t2;
      ge = Number(e3) + 0.1 * Number(s2) < 13.4, me = !1;
    }
  } else if (e2.includes("OS X 10")) {
    let [, t2] = e2.match(/OS X 10[_.](\d+)/);
    ge = me = Number(t2) < 15;
  }
  if (e2.includes("Chrome/")) {
    let [, t2] = e2.match(/Chrome\/(\d+)/);
    ge = me = Number(t2) < 81;
  } else if (e2.includes("Firefox/")) {
    let [, t2] = e2.match(/Firefox\/(\d+)/);
    ge = me = Number(t2) < 77;
  }
}
async function ye(e2) {
  let t2 = await ce(e2);
  return Object.assign({ canvas: ge, css: me }, pe[t2]);
}
__name(ye, "ye");
const _be = class _be extends c {
  constructor(...t2) {
    super(...t2), e(this, "ranges", new we()), this.byteLength !== 0 && this.ranges.add(0, this.byteLength);
  }
  _tryExtend(e2, t2, s2) {
    if (e2 === 0 && this.byteLength === 0 && s2) {
      let e3 = new DataView(s2.buffer || s2, s2.byteOffset, s2.byteLength);
      this._swapDataView(e3);
    } else {
      let s3 = e2 + t2;
      if (s3 > this.byteLength) {
        let { dataView: e3 } = this._extend(s3);
        this._swapDataView(e3);
      }
    }
  }
  _extend(e2) {
    let t2;
    t2 = a ? r.allocUnsafe(e2) : new Uint8Array(e2);
    let s2 = new DataView(t2.buffer, t2.byteOffset, t2.byteLength);
    return t2.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), { uintView: t2, dataView: s2 };
  }
  subarray(e2, t2, s2 = !1) {
    return t2 = t2 || this._lengthToEnd(e2), s2 && this._tryExtend(e2, t2), this.ranges.add(e2, t2), super.subarray(e2, t2);
  }
  set(e2, t2, s2 = !1) {
    s2 && this._tryExtend(t2, e2.byteLength, e2);
    let i2 = super.set(e2, t2);
    return this.ranges.add(t2, i2.byteLength), i2;
  }
  async ensureChunk(e2, t2) {
    this.chunked && (this.ranges.available(e2, t2) || await this.readChunk(e2, t2));
  }
  available(e2, t2) {
    return this.ranges.available(e2, t2);
  }
};
__name(_be, "be");
let be = _be;
const _we = class _we {
  constructor() {
    e(this, "list", []);
  }
  get length() {
    return this.list.length;
  }
  add(e2, t2, s2 = 0) {
    let i2 = e2 + t2, n2 = this.list.filter((t3) => ke(e2, t3.offset, i2) || ke(e2, t3.end, i2));
    if (n2.length > 0) {
      e2 = Math.min(e2, ...n2.map((e3) => e3.offset)), i2 = Math.max(i2, ...n2.map((e3) => e3.end)), t2 = i2 - e2;
      let s3 = n2.shift();
      s3.offset = e2, s3.length = t2, s3.end = i2, this.list = this.list.filter((e3) => !n2.includes(e3));
    } else this.list.push({ offset: e2, length: t2, end: i2 });
  }
  available(e2, t2) {
    let s2 = e2 + t2;
    return this.list.some((t3) => t3.offset <= e2 && s2 <= t3.end);
  }
};
__name(_we, "we");
let we = _we;
function ke(e2, t2, s2) {
  return e2 <= t2 && t2 <= s2;
}
__name(ke, "ke");
const _Oe = class _Oe extends be {
  constructor(t2, s2) {
    super(0), e(this, "chunksRead", 0), this.input = t2, this.options = s2;
  }
  async readWhole() {
    this.chunked = !1, await this.readChunk(this.nextChunkOffset);
  }
  async readChunked() {
    this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
  }
  async readNextChunk(e2 = this.nextChunkOffset) {
    if (this.fullyRead) return this.chunksRead++, !1;
    let t2 = this.options.chunkSize, s2 = await this.readChunk(e2, t2);
    return !!s2 && s2.byteLength === t2;
  }
  async readChunk(e2, t2) {
    if (this.chunksRead++, (t2 = this.safeWrapAddress(e2, t2)) !== 0) return this._readChunk(e2, t2);
  }
  safeWrapAddress(e2, t2) {
    return this.size !== void 0 && e2 + t2 > this.size ? Math.max(0, this.size - e2) : t2;
  }
  get nextChunkOffset() {
    if (this.ranges.list.length !== 0) return this.ranges.list[0].length;
  }
  get canReadNextChunk() {
    return this.chunksRead < this.options.chunkLimit;
  }
  get fullyRead() {
    return this.size !== void 0 && this.nextChunkOffset === this.size;
  }
  read() {
    return this.options.chunked ? this.readChunked() : this.readWhole();
  }
  close() {
  }
};
__name(_Oe, "Oe");
let Oe = _Oe;
b.set("blob", class extends Oe {
  async readWhole() {
    this.chunked = !1;
    let e2 = await A(this.input);
    this._swapArrayBuffer(e2);
  }
  readChunked() {
    return this.chunked = !0, this.size = this.input.size, super.readChunked();
  }
  async _readChunk(e2, t2) {
    let s2 = t2 ? e2 + t2 : void 0, i2 = this.input.slice(e2, s2), n2 = await A(i2);
    return this.set(n2, e2, !0);
  }
});
const locale$i = {
  strings: {
    generatingThumbnails: "Generating thumbnails..."
  }
}, packageJson$r = {
  version: "3.0.4"
};
function canvasToBlob$2(canvas, type, quality) {
  try {
    canvas.getContext("2d").getImageData(0, 0, 1, 1);
  } catch (err) {
    if (err.code === 18)
      return Promise.reject(new Error("cannot read image, probably an svg with external resources"));
  }
  return canvas.toBlob ? new Promise((resolve3) => {
    canvas.toBlob(resolve3, type, quality);
  }).then((blob) => {
    if (blob === null)
      throw new Error("cannot read image, probably an svg with external resources");
    return blob;
  }) : Promise.resolve().then(() => dataURItoBlob(canvas.toDataURL(type, quality), {})).then((blob) => {
    if (blob === null)
      throw new Error("could not extract blob, probably an old browser");
    return blob;
  });
}
__name(canvasToBlob$2, "canvasToBlob$2");
function rotateImage(image, translate) {
  let w2 = image.width, h2 = image.height;
  (translate.deg === 90 || translate.deg === 270) && (w2 = image.height, h2 = image.width);
  const canvas = document.createElement("canvas");
  canvas.width = w2, canvas.height = h2;
  const context = canvas.getContext("2d");
  return context.translate(w2 / 2, h2 / 2), translate.canvas && (context.rotate(translate.rad), context.scale(translate.scaleX, translate.scaleY)), context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height), canvas;
}
__name(rotateImage, "rotateImage");
function protect(image) {
  const ratio = image.width / image.height, maxSquare = 5e6, maxSize = 4096;
  let maxW = Math.floor(Math.sqrt(maxSquare * ratio)), maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
  if (maxW > maxSize && (maxW = maxSize, maxH = Math.round(maxW / ratio)), maxH > maxSize && (maxH = maxSize, maxW = Math.round(ratio * maxH)), image.width > maxW) {
    const canvas = document.createElement("canvas");
    return canvas.width = maxW, canvas.height = maxH, canvas.getContext("2d").drawImage(image, 0, 0, maxW, maxH), canvas;
  }
  return image;
}
__name(protect, "protect");
const _ThumbnailGenerator = class _ThumbnailGenerator extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.onFileAdded = (file) => {
      !file.preview && file.data && isPreviewSupported(file.type) && !file.isRemote && this.addToQueue(file.id);
    }, this.onCancelRequest = (file) => {
      const index = this.queue.indexOf(file.id);
      index !== -1 && this.queue.splice(index, 1);
    }, this.onFileRemoved = (file) => {
      const index = this.queue.indexOf(file.id);
      index !== -1 && this.queue.splice(index, 1), file.preview && isObjectURL(file.preview) && URL.revokeObjectURL(file.preview);
    }, this.onRestored = () => {
      this.uppy.getFiles().filter((file) => file.isRestored).forEach((file) => {
        (!file.preview || isObjectURL(file.preview)) && this.addToQueue(file.id);
      });
    }, this.onAllFilesRemoved = () => {
      this.queue = [];
    }, this.waitUntilAllProcessed = (fileIDs) => {
      fileIDs.forEach((fileID) => {
        const file = this.uppy.getFile(fileID);
        this.uppy.emit("preprocess-progress", file, {
          mode: "indeterminate",
          message: this.i18n("generatingThumbnails")
        });
      });
      const emitPreprocessCompleteForAll = /* @__PURE__ */ __name(() => {
        fileIDs.forEach((fileID) => {
          const file = this.uppy.getFile(fileID);
          this.uppy.emit("preprocess-complete", file);
        });
      }, "emitPreprocessCompleteForAll");
      return new Promise((resolve3) => {
        this.queueProcessing ? this.uppy.once("thumbnail:all-generated", () => {
          emitPreprocessCompleteForAll(), resolve3();
        }) : (emitPreprocessCompleteForAll(), resolve3());
      });
    }, this.type = "modifier", this.id = this.opts.id || "ThumbnailGenerator", this.title = "Thumbnail Generator", this.queue = [], this.queueProcessing = !1, this.defaultThumbnailDimension = 200, this.thumbnailType = this.opts.thumbnailType || "image/jpeg", this.defaultLocale = locale$i;
    const defaultOptions2 = {
      thumbnailWidth: null,
      thumbnailHeight: null,
      waitForThumbnailsBeforeUpload: !1,
      lazy: !1
    };
    if (this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.i18nInit(), this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload)
      throw new Error("ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.");
  }
  /**
   * Create a thumbnail for the given Uppy file object.
   *
   * @param {{data: Blob}} file
   * @param {number} targetWidth
   * @param {number} targetHeight
   * @returns {Promise}
   */
  createThumbnail(file, targetWidth, targetHeight) {
    const originalUrl = URL.createObjectURL(file.data), onload = new Promise((resolve3, reject) => {
      const image = new Image();
      image.src = originalUrl, image.addEventListener("load", () => {
        URL.revokeObjectURL(originalUrl), resolve3(image);
      }), image.addEventListener("error", (event) => {
        URL.revokeObjectURL(originalUrl), reject(event.error || new Error("Could not create thumbnail"));
      });
    }), orientationPromise = ye(file.data).catch(() => 1);
    return Promise.all([onload, orientationPromise]).then((_ref) => {
      let [image, orientation] = _ref;
      const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg), rotatedImage = rotateImage(image, orientation), resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
      return canvasToBlob$2(resizedImage, this.thumbnailType, 80);
    }).then((blob) => URL.createObjectURL(blob));
  }
  /**
   * Get the new calculated dimensions for the given image and a target width
   * or height. If both width and height are given, only width is taken into
   * account. If neither width nor height are given, the default dimension
   * is used.
   */
  getProportionalDimensions(img, width, height, rotation) {
    let aspect = img.width / img.height;
    return (rotation === 90 || rotation === 270) && (aspect = img.height / img.width), width != null ? {
      width,
      height: Math.round(width / aspect)
    } : height != null ? {
      width: Math.round(height * aspect),
      height
    } : {
      width: this.defaultThumbnailDimension,
      height: Math.round(this.defaultThumbnailDimension / aspect)
    };
  }
  /**
   * Resize an image to the target `width` and `height`.
   *
   * Returns a Canvas with the resized image on it.
   */
  // eslint-disable-next-line class-methods-use-this
  resizeImage(image, targetWidth, targetHeight) {
    let img = protect(image), steps = Math.ceil(Math.log2(img.width / targetWidth));
    steps < 1 && (steps = 1);
    let sW = targetWidth * 2 ** (steps - 1), sH = targetHeight * 2 ** (steps - 1);
    const x2 = 2;
    for (; steps--; ) {
      const canvas = document.createElement("canvas");
      canvas.width = sW, canvas.height = sH, canvas.getContext("2d").drawImage(img, 0, 0, sW, sH), img = canvas, sW = Math.round(sW / x2), sH = Math.round(sH / x2);
    }
    return img;
  }
  /**
   * Set the preview URL for a file.
   */
  setPreviewURL(fileID, preview3) {
    this.uppy.setFileState(fileID, {
      preview: preview3
    });
  }
  addToQueue(item) {
    this.queue.push(item), this.queueProcessing === !1 && this.processQueue();
  }
  processQueue() {
    if (this.queueProcessing = !0, this.queue.length > 0) {
      const current = this.uppy.getFile(this.queue.shift());
      return current ? this.requestThumbnail(current).catch(() => {
      }).then(() => this.processQueue()) : (this.uppy.log("[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug", "error"), Promise.resolve());
    }
    return this.queueProcessing = !1, this.uppy.log("[ThumbnailGenerator] Emptied thumbnail queue"), this.uppy.emit("thumbnail:all-generated"), Promise.resolve();
  }
  requestThumbnail(file) {
    return isPreviewSupported(file.type) && !file.isRemote ? this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview3) => {
      this.setPreviewURL(file.id, preview3), this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`), this.uppy.emit("thumbnail:generated", this.uppy.getFile(file.id), preview3);
    }).catch((err) => {
      this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, "warning"), this.uppy.log(err, "warning"), this.uppy.emit("thumbnail:error", this.uppy.getFile(file.id), err);
    }) : Promise.resolve();
  }
  install() {
    this.uppy.on("file-removed", this.onFileRemoved), this.uppy.on("cancel-all", this.onAllFilesRemoved), this.opts.lazy ? (this.uppy.on("thumbnail:request", this.onFileAdded), this.uppy.on("thumbnail:cancel", this.onCancelRequest)) : (this.uppy.on("file-added", this.onFileAdded), this.uppy.on("restored", this.onRestored)), this.opts.waitForThumbnailsBeforeUpload && this.uppy.addPreProcessor(this.waitUntilAllProcessed);
  }
  uninstall() {
    this.uppy.off("file-removed", this.onFileRemoved), this.uppy.off("cancel-all", this.onAllFilesRemoved), this.opts.lazy ? (this.uppy.off("thumbnail:request", this.onFileAdded), this.uppy.off("thumbnail:cancel", this.onCancelRequest)) : (this.uppy.off("file-added", this.onFileAdded), this.uppy.off("restored", this.onRestored)), this.opts.waitForThumbnailsBeforeUpload && this.uppy.removePreProcessor(this.waitUntilAllProcessed);
  }
};
__name(_ThumbnailGenerator, "ThumbnailGenerator");
let ThumbnailGenerator = _ThumbnailGenerator;
ThumbnailGenerator.VERSION = packageJson$r.version;
function findAllDOMElements(element) {
  if (typeof element == "string") {
    const elements = document.querySelectorAll(element);
    return elements.length === 0 ? null : Array.from(elements);
  }
  return typeof element == "object" && isDOMElement(element) ? [element] : null;
}
__name(findAllDOMElements, "findAllDOMElements");
const toArray$3 = Array.from;
function getFilesAndDirectoriesFromDirectory(directoryReader, oldEntries, logDropError, _ref) {
  let {
    onSuccess
  } = _ref;
  directoryReader.readEntries(
    (entries) => {
      const newEntries = [...oldEntries, ...entries];
      entries.length ? queueMicrotask(() => {
        getFilesAndDirectoriesFromDirectory(directoryReader, newEntries, logDropError, {
          onSuccess
        });
      }) : onSuccess(newEntries);
    },
    // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error) => {
      logDropError(error), onSuccess(oldEntries);
    }
  );
}
__name(getFilesAndDirectoriesFromDirectory, "getFilesAndDirectoriesFromDirectory");
function getAsFileSystemHandleFromEntry(entry, logDropError) {
  return entry == null ? entry : {
    // eslint-disable-next-line no-nested-ternary
    kind: entry.isFile ? "file" : entry.isDirectory ? "directory" : void 0,
    name: entry.name,
    getFile() {
      return new Promise((resolve3, reject) => entry.file(resolve3, reject));
    },
    async *values() {
      const directoryReader = entry.createReader();
      yield* await new Promise((resolve3) => {
        getFilesAndDirectoriesFromDirectory(directoryReader, [], logDropError, {
          onSuccess: /* @__PURE__ */ __name((dirEntries) => resolve3(dirEntries.map((file) => getAsFileSystemHandleFromEntry(file, logDropError))), "onSuccess")
        });
      });
    }
  };
}
__name(getAsFileSystemHandleFromEntry, "getAsFileSystemHandleFromEntry");
function createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
  try {
    return lastResortFile === void 0 && (lastResortFile = void 0), async function* () {
      const getNextRelativePath = /* @__PURE__ */ __name(() => `${relativePath}/${entry.name}`, "getNextRelativePath");
      if (entry.kind === "file") {
        const file = await entry.getFile();
        file != null ? (file.relativePath = relativePath ? getNextRelativePath() : null, yield file) : lastResortFile != null && (yield lastResortFile);
      } else if (entry.kind === "directory")
        for await (const handle of entry.values())
          yield* createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
      else lastResortFile != null && (yield lastResortFile);
    }();
  } catch (e2) {
    return Promise.reject(e2);
  }
}
__name(createPromiseToAddFileOrParseDirectory, "createPromiseToAddFileOrParseDirectory");
async function* getFilesFromDataTransfer(dataTransfer, logDropError) {
  const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item) => {
    var _fileSystemHandle;
    let fileSystemHandle;
    const getAsEntry = /* @__PURE__ */ __name(() => typeof item.getAsEntry == "function" ? item.getAsEntry() : item.webkitGetAsEntry(), "getAsEntry");
    return (_fileSystemHandle = fileSystemHandle) != null || (fileSystemHandle = getAsFileSystemHandleFromEntry(getAsEntry(), logDropError)), {
      fileSystemHandle,
      lastResortFile: item.getAsFile()
      // can be used as a fallback in case other methods fail
    };
  }));
  for (const {
    lastResortFile,
    fileSystemHandle
  } of fileSystemHandles)
    if (fileSystemHandle != null)
      try {
        yield* createPromiseToAddFileOrParseDirectory(fileSystemHandle, "", lastResortFile);
      } catch (err) {
        lastResortFile != null ? yield lastResortFile : logDropError(err);
      }
    else lastResortFile != null && (yield lastResortFile);
}
__name(getFilesFromDataTransfer, "getFilesFromDataTransfer");
function fallbackApi(dataTransfer) {
  const files = toArray$3(dataTransfer.files);
  return Promise.resolve(files);
}
__name(fallbackApi, "fallbackApi");
async function getDroppedFiles(dataTransfer, _temp) {
  let {
    logDropError = /* @__PURE__ */ __name(() => {
    }, "logDropError")
  } = _temp === void 0 ? {} : _temp;
  try {
    const accumulator = [];
    for await (const file of getFilesFromDataTransfer(dataTransfer, logDropError))
      accumulator.push(file);
    return accumulator;
  } catch {
    return fallbackApi(dataTransfer);
  }
}
__name(getDroppedFiles, "getDroppedFiles");
var safeIsNaN = Number.isNaN || /* @__PURE__ */ __name(function(value) {
  return typeof value == "number" && value !== value;
}, "ponyfill");
function isEqual(first, second) {
  return !!(first === second || safeIsNaN(first) && safeIsNaN(second));
}
__name(isEqual, "isEqual");
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length)
    return !1;
  for (var i2 = 0; i2 < newInputs.length; i2++)
    if (!isEqual(newInputs[i2], lastInputs[i2]))
      return !1;
  return !0;
}
__name(areInputsEqual, "areInputsEqual");
function memoizeOne(resultFn, isEqual2) {
  isEqual2 === void 0 && (isEqual2 = areInputsEqual);
  var cache2 = null;
  function memoized() {
    for (var newArgs = [], _i = 0; _i < arguments.length; _i++)
      newArgs[_i] = arguments[_i];
    if (cache2 && cache2.lastThis === this && isEqual2(newArgs, cache2.lastArgs))
      return cache2.lastResult;
    var lastResult = resultFn.apply(this, newArgs);
    return cache2 = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    }, lastResult;
  }
  return __name(memoized, "memoized"), memoized.clear = /* @__PURE__ */ __name(function() {
    cache2 = null;
  }, "clear"), memoized;
}
__name(memoizeOne, "memoizeOne");
const FOCUSABLE_ELEMENTS = ['a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', "input:not([disabled]):not([inert]):not([aria-hidden])", "select:not([disabled]):not([inert]):not([aria-hidden])", "textarea:not([disabled]):not([inert]):not([aria-hidden])", "button:not([disabled]):not([inert]):not([aria-hidden])", 'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])', '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'];
function getActiveOverlayEl(dashboardEl, activeOverlayType) {
  if (activeOverlayType) {
    const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`);
    if (overlayEl) return overlayEl;
  }
  return dashboardEl;
}
__name(getActiveOverlayEl, "getActiveOverlayEl");
function focusOnFirstNode(event, nodes) {
  const node = nodes[0];
  node && (node.focus(), event.preventDefault());
}
__name(focusOnFirstNode, "focusOnFirstNode");
function focusOnLastNode(event, nodes) {
  const node = nodes[nodes.length - 1];
  node && (node.focus(), event.preventDefault());
}
__name(focusOnLastNode, "focusOnLastNode");
function isFocusInOverlay(activeOverlayEl) {
  return activeOverlayEl.contains(document.activeElement);
}
__name(isFocusInOverlay, "isFocusInOverlay");
function trapFocus(event, activeOverlayType, dashboardEl) {
  const activeOverlayEl = getActiveOverlayEl(dashboardEl, activeOverlayType), focusableNodes = toArray$3(activeOverlayEl.querySelectorAll(FOCUSABLE_ELEMENTS)), focusedItemIndex = focusableNodes.indexOf(document.activeElement);
  isFocusInOverlay(activeOverlayEl) ? event.shiftKey && focusedItemIndex === 0 ? focusOnLastNode(event, focusableNodes) : !event.shiftKey && focusedItemIndex === focusableNodes.length - 1 && focusOnFirstNode(event, focusableNodes) : focusOnFirstNode(event, focusableNodes);
}
__name(trapFocus, "trapFocus");
function forInline(event, activeOverlayType, dashboardEl) {
  activeOverlayType === null || trapFocus(event, activeOverlayType, dashboardEl);
}
__name(forInline, "forInline");
function createSuperFocus() {
  let lastFocusWasOnSuperFocusableEl = !1;
  return debounce$3(/* @__PURE__ */ __name((dashboardEl, activeOverlayType) => {
    const overlayEl = getActiveOverlayEl(dashboardEl, activeOverlayType), isFocusInOverlay2 = overlayEl.contains(document.activeElement);
    if (isFocusInOverlay2 && lastFocusWasOnSuperFocusableEl) return;
    const superFocusableEl = overlayEl.querySelector("[data-uppy-super-focusable]");
    if (!(isFocusInOverlay2 && !superFocusableEl))
      if (superFocusableEl)
        superFocusableEl.focus({
          preventScroll: !0
        }), lastFocusWasOnSuperFocusableEl = !0;
      else {
        const firstEl = overlayEl.querySelector(FOCUSABLE_ELEMENTS);
        firstEl == null || firstEl.focus({
          preventScroll: !0
        }), lastFocusWasOnSuperFocusableEl = !1;
      }
  }, "superFocus"), 260);
}
__name(createSuperFocus, "createSuperFocus");
function isDragDropSupported() {
  const div = document.body;
  return !(!("draggable" in div) || !("ondragstart" in div && "ondrop" in div) || !("FormData" in window) || !("FileReader" in window));
}
__name(isDragDropSupported, "isDragDropSupported");
var isShallowEqual = /* @__PURE__ */ __name(function(a2, b2) {
  if (a2 === b2) return !0;
  for (var i2 in a2) if (!(i2 in b2)) return !1;
  for (var i2 in b2) if (a2[i2] !== b2[i2]) return !1;
  return !0;
}, "isShallowEqual");
const shallowEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs(isShallowEqual);
function iconImage() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y$1("g", {
    fill: "#686DE0",
    fillRule: "evenodd"
  }, y$1("path", {
    d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
    fillRule: "nonzero"
  }), y$1("path", {
    d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
    fillRule: "nonzero"
  }), y$1("circle", {
    cx: "7.5",
    cy: "9.5",
    r: "1.5"
  })));
}
__name(iconImage, "iconImage");
function iconAudio() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y$1("path", {
    d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
    fill: "#049BCF",
    fillRule: "nonzero"
  }));
}
__name(iconAudio, "iconAudio");
function iconVideo() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y$1("path", {
    d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
    fill: "#19AF67",
    fillRule: "nonzero"
  }));
}
__name(iconVideo, "iconVideo");
function iconPDF() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y$1("path", {
    d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
    fill: "#E2514A",
    fillRule: "nonzero"
  }));
}
__name(iconPDF, "iconPDF");
function iconArchive() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y$1("path", {
    d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
    fill: "#00C469",
    fillRule: "nonzero"
  }));
}
__name(iconArchive, "iconArchive");
function iconFile() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y$1("g", {
    fill: "#A7AFB7",
    fillRule: "nonzero"
  }, y$1("path", {
    d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
  }), y$1("path", {
    d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
  })));
}
__name(iconFile, "iconFile");
function iconText() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y$1("path", {
    d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
    fill: "#5A5E69",
    fillRule: "nonzero"
  }));
}
__name(iconText, "iconText");
function getIconByMime(fileType) {
  const defaultChoice = {
    color: "#838999",
    icon: iconFile()
  };
  if (!fileType) return defaultChoice;
  const fileTypeGeneral = fileType.split("/")[0], fileTypeSpecific = fileType.split("/")[1];
  return fileTypeGeneral === "text" ? {
    color: "#5a5e69",
    icon: iconText()
  } : fileTypeGeneral === "image" ? {
    color: "#686de0",
    icon: iconImage()
  } : fileTypeGeneral === "audio" ? {
    color: "#068dbb",
    icon: iconAudio()
  } : fileTypeGeneral === "video" ? {
    color: "#19af67",
    icon: iconVideo()
  } : fileTypeGeneral === "application" && fileTypeSpecific === "pdf" ? {
    color: "#e25149",
    icon: iconPDF()
  } : fileTypeGeneral === "application" && ["zip", "x-7z-compressed", "x-rar-compressed", "x-tar", "x-gzip", "x-apple-diskimage"].indexOf(fileTypeSpecific) !== -1 ? {
    color: "#00C469",
    icon: iconArchive()
  } : defaultChoice;
}
__name(getIconByMime, "getIconByMime");
function FilePreview(props) {
  const {
    file
  } = props;
  if (file.preview)
    return y$1("img", {
      className: "uppy-Dashboard-Item-previewImg",
      alt: file.name,
      src: file.preview
    });
  const {
    color,
    icon
  } = getIconByMime(file.type);
  return y$1("div", {
    className: "uppy-Dashboard-Item-previewIconWrap"
  }, y$1("span", {
    className: "uppy-Dashboard-Item-previewIcon",
    style: {
      color
    }
  }, icon), y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-Dashboard-Item-previewIconBg",
    width: "58",
    height: "76",
    viewBox: "0 0 58 76"
  }, y$1("rect", {
    fill: "#FFF",
    width: "58",
    height: "76",
    rx: "3",
    fillRule: "evenodd"
  })));
}
__name(FilePreview, "FilePreview");
const metaFieldIdToName = /* @__PURE__ */ __name((metaFieldId, metaFields) => (typeof metaFields == "function" ? metaFields() : metaFields).filter((f2) => f2.id === metaFieldId)[0].name, "metaFieldIdToName");
function renderMissingMetaFieldsError(props) {
  const {
    file,
    toggleFileCard,
    i18n,
    metaFields
  } = props, {
    missingRequiredMetaFields
  } = file;
  if (!(missingRequiredMetaFields != null && missingRequiredMetaFields.length))
    return null;
  const metaFieldsString = missingRequiredMetaFields.map((missingMetaField) => metaFieldIdToName(missingMetaField, metaFields)).join(", ");
  return y$1("div", {
    className: "uppy-Dashboard-Item-errorMessage"
  }, i18n("missingRequiredMetaFields", {
    smart_count: missingRequiredMetaFields.length,
    fields: metaFieldsString
  }), " ", y$1("button", {
    type: "button",
    class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
    onClick: /* @__PURE__ */ __name(() => toggleFileCard(!0, file.id), "onClick")
  }, i18n("editFile")));
}
__name(renderMissingMetaFieldsError, "renderMissingMetaFieldsError");
function FilePreviewAndLink(props) {
  const {
    file,
    i18n,
    toggleFileCard,
    metaFields,
    showLinkToFileUploadResult
  } = props, previewBackgroundColor = file.preview ? "rgba(255, 255, 255, 0.5)" : getIconByMime(props.file.type).color;
  return y$1("div", {
    className: "uppy-Dashboard-Item-previewInnerWrap",
    style: {
      backgroundColor: previewBackgroundColor
    }
  }, showLinkToFileUploadResult && file.uploadURL && y$1("a", {
    className: "uppy-Dashboard-Item-previewLink",
    href: file.uploadURL,
    rel: "noreferrer noopener",
    target: "_blank",
    "aria-label": file.meta.name
  }, y$1("span", {
    hidden: !0
  }, file.meta.name)), y$1(FilePreview, {
    file
  }), y$1(renderMissingMetaFieldsError, {
    file,
    i18n,
    toggleFileCard,
    metaFields
  }));
}
__name(FilePreviewAndLink, "FilePreviewAndLink");
function onPauseResumeCancelRetry(props) {
  if (!props.isUploaded) {
    if (props.error && !props.hideRetryButton) {
      props.uppy.retryUpload(props.file.id);
      return;
    }
    props.resumableUploads && !props.hidePauseResumeButton ? props.uppy.pauseResume(props.file.id) : props.individualCancellation && !props.hideCancelButton && props.uppy.removeFile(props.file.id);
  }
}
__name(onPauseResumeCancelRetry, "onPauseResumeCancelRetry");
function progressIndicatorTitle(props) {
  return props.isUploaded ? props.i18n("uploadComplete") : props.error ? props.i18n("retryUpload") : props.resumableUploads ? props.file.isPaused ? props.i18n("resumeUpload") : props.i18n("pauseUpload") : props.individualCancellation ? props.i18n("cancelUpload") : "";
}
__name(progressIndicatorTitle, "progressIndicatorTitle");
function ProgressIndicatorButton(props) {
  return y$1("div", {
    className: "uppy-Dashboard-Item-progress"
  }, y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-progressIndicator",
    type: "button",
    "aria-label": progressIndicatorTitle(props),
    title: progressIndicatorTitle(props),
    onClick: /* @__PURE__ */ __name(() => onPauseResumeCancelRetry(props), "onClick")
  }, props.children));
}
__name(ProgressIndicatorButton, "ProgressIndicatorButton");
function ProgressCircleContainer(_ref) {
  let {
    children
  } = _ref;
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "70",
    height: "70",
    viewBox: "0 0 36 36",
    className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"
  }, children);
}
__name(ProgressCircleContainer, "ProgressCircleContainer");
function ProgressCircle(_ref2) {
  let {
    progress
  } = _ref2;
  const circleLength = 2 * Math.PI * 15;
  return y$1("g", null, y$1("circle", {
    className: "uppy-Dashboard-Item-progressIcon--bg",
    r: "15",
    cx: "18",
    cy: "18",
    "stroke-width": "2",
    fill: "none"
  }), y$1("circle", {
    className: "uppy-Dashboard-Item-progressIcon--progress",
    r: "15",
    cx: "18",
    cy: "18",
    transform: "rotate(-90, 18, 18)",
    fill: "none",
    "stroke-width": "2",
    "stroke-dasharray": circleLength,
    "stroke-dashoffset": circleLength - circleLength / 100 * progress
  }));
}
__name(ProgressCircle, "ProgressCircle");
function FileProgress(props) {
  if (!props.file.progress.uploadStarted)
    return null;
  if (props.isUploaded)
    return y$1("div", {
      className: "uppy-Dashboard-Item-progress"
    }, y$1("div", {
      className: "uppy-Dashboard-Item-progressIndicator"
    }, y$1(ProgressCircleContainer, null, y$1("circle", {
      r: "15",
      cx: "18",
      cy: "18",
      fill: "#1bb240"
    }), y$1("polygon", {
      className: "uppy-Dashboard-Item-progressIcon--check",
      transform: "translate(2, 3)",
      points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
    }))));
  if (!props.recoveredState)
    return props.error && !props.hideRetryButton ? (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y$1(ProgressIndicatorButton, props, y$1("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
        width: "28",
        height: "31",
        viewBox: "0 0 16 19"
      }, y$1("path", {
        d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
      }), y$1("path", {
        d: "M7.9 3H10v2H7.9z"
      }), y$1("path", {
        d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
      }), y$1("path", {
        d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
      })))
    ) : props.resumableUploads && !props.hidePauseResumeButton ? (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y$1(ProgressIndicatorButton, props, y$1(ProgressCircleContainer, null, y$1(ProgressCircle, {
        progress: props.file.progress.percentage
      }), props.file.isPaused ? y$1("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--play",
        transform: "translate(3, 3)",
        points: "12 20 12 10 20 15"
      }) : y$1("g", {
        className: "uppy-Dashboard-Item-progressIcon--pause",
        transform: "translate(14.5, 13)"
      }, y$1("rect", {
        x: "0",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
      }), y$1("rect", {
        x: "5",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
      }))))
    ) : !props.resumableUploads && props.individualCancellation && !props.hideCancelButton ? (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y$1(ProgressIndicatorButton, props, y$1(ProgressCircleContainer, null, y$1(ProgressCircle, {
        progress: props.file.progress.percentage
      }), y$1("polygon", {
        className: "cancel",
        transform: "translate(2, 2)",
        points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
      })))
    ) : y$1("div", {
      className: "uppy-Dashboard-Item-progress"
    }, y$1("div", {
      className: "uppy-Dashboard-Item-progressIndicator"
    }, y$1(ProgressCircleContainer, null, y$1(ProgressCircle, {
      progress: props.file.progress.percentage
    }))));
}
__name(FileProgress, "FileProgress");
var prettierBytes2 = /* @__PURE__ */ __name(function(num) {
  if (typeof num != "number" || isNaN(num))
    throw new TypeError("Expected a number, got " + typeof num);
  var neg = num < 0, units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  if (neg && (num = -num), num < 1)
    return (neg ? "-" : "") + num + " B";
  var exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
  num = Number(num / Math.pow(1024, exponent));
  var unit = units[exponent];
  return num >= 10 || num % 1 === 0 ? (neg ? "-" : "") + num.toFixed(0) + " " + unit : (neg ? "-" : "") + num.toFixed(1) + " " + unit;
}, "prettierBytes");
const prettierBytes$1 = /* @__PURE__ */ getDefaultExportFromCjs(prettierBytes2), separator = "...";
function truncateString(string, maxLength) {
  if (maxLength === 0) return "";
  if (string.length <= maxLength) return string;
  if (maxLength <= separator.length + 1) return `${string.slice(0, maxLength - 1)}…`;
  const charsToShow = maxLength - separator.length, frontChars = Math.ceil(charsToShow / 2), backChars = Math.floor(charsToShow / 2);
  return string.slice(0, frontChars) + separator + string.slice(-backChars);
}
__name(truncateString, "truncateString");
const renderFileName = /* @__PURE__ */ __name((props) => {
  const {
    author,
    name
  } = props.file.meta;
  function getMaxNameLength() {
    return props.isSingleFile && props.containerHeight >= 350 ? 90 : props.containerWidth <= 352 ? 35 : props.containerWidth <= 576 ? 60 : author ? 20 : 30;
  }
  return __name(getMaxNameLength, "getMaxNameLength"), y$1("div", {
    className: "uppy-Dashboard-Item-name",
    title: name
  }, truncateString(name, getMaxNameLength()));
}, "renderFileName"), renderAuthor = /* @__PURE__ */ __name((props) => {
  const {
    author
  } = props.file.meta, {
    providerName
  } = props.file.remote, dot = "·";
  return author ? y$1("div", {
    className: "uppy-Dashboard-Item-author"
  }, y$1("a", {
    href: `${author.url}?utm_source=Companion&utm_medium=referral`,
    target: "_blank",
    rel: "noopener noreferrer"
  }, truncateString(author.name, 13)), providerName ? y$1(k$2, null, ` ${dot} `, providerName, ` ${dot} `) : null) : null;
}, "renderAuthor"), renderFileSize = /* @__PURE__ */ __name((props) => props.file.size && y$1("div", {
  className: "uppy-Dashboard-Item-statusSize"
}, prettierBytes$1(props.file.size)), "renderFileSize"), ReSelectButton = /* @__PURE__ */ __name((props) => props.file.isGhost && y$1("span", null, " • ", y$1("button", {
  className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
  type: "button",
  onClick: props.toggleAddFilesPanel
}, props.i18n("reSelect"))), "ReSelectButton"), ErrorButton = /* @__PURE__ */ __name((_ref) => {
  let {
    file,
    onClick
  } = _ref;
  return file.error ? y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-errorDetails",
    "aria-label": file.error,
    "data-microtip-position": "bottom",
    "data-microtip-size": "medium",
    onClick,
    type: "button"
  }, "?") : null;
}, "ErrorButton");
function FileInfo(props) {
  const {
    file
  } = props;
  return y$1("div", {
    className: "uppy-Dashboard-Item-fileInfo",
    "data-uppy-file-source": file.source
  }, y$1("div", {
    className: "uppy-Dashboard-Item-fileName"
  }, renderFileName(props), y$1(ErrorButton, {
    file: props.file,
    onClick: /* @__PURE__ */ __name(() => alert(props.file.error), "onClick")
    // TODO: move to a custom alert implementation
  })), y$1("div", {
    className: "uppy-Dashboard-Item-status"
  }, renderAuthor(props), renderFileSize(props), ReSelectButton(props)), y$1(renderMissingMetaFieldsError, {
    file: props.file,
    i18n: props.i18n,
    toggleFileCard: props.toggleFileCard,
    metaFields: props.metaFields
  }));
}
__name(FileInfo, "FileInfo");
function copyToClipboard(textToCopy, fallbackString) {
  return fallbackString === void 0 && (fallbackString = "Copy the URL below"), new Promise((resolve3) => {
    const textArea = document.createElement("textarea");
    textArea.setAttribute("style", {
      position: "fixed",
      top: 0,
      left: 0,
      width: "2em",
      height: "2em",
      padding: 0,
      border: "none",
      outline: "none",
      boxShadow: "none",
      background: "transparent"
    }), textArea.value = textToCopy, document.body.appendChild(textArea), textArea.select();
    const magicCopyFailed = /* @__PURE__ */ __name(() => {
      document.body.removeChild(textArea), window.prompt(fallbackString, textToCopy), resolve3();
    }, "magicCopyFailed");
    try {
      return document.execCommand("copy") ? (document.body.removeChild(textArea), resolve3()) : magicCopyFailed("copy command unavailable");
    } catch {
      return document.body.removeChild(textArea), magicCopyFailed();
    }
  });
}
__name(copyToClipboard, "copyToClipboard");
function EditButton(_ref) {
  let {
    file,
    uploadInProgressOrComplete,
    metaFields,
    canEditFile,
    i18n,
    onClick
  } = _ref;
  return !uploadInProgressOrComplete && metaFields && metaFields.length > 0 || !uploadInProgressOrComplete && canEditFile(file) ? y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
    type: "button",
    "aria-label": i18n("editFileWithFilename", {
      file: file.meta.name
    }),
    title: i18n("editFileWithFilename", {
      file: file.meta.name
    }),
    onClick: /* @__PURE__ */ __name(() => onClick(), "onClick")
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14"
  }, y$1("g", {
    fillRule: "evenodd"
  }, y$1("path", {
    d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
    fillRule: "nonzero"
  }), y$1("rect", {
    x: "1",
    y: "12.293",
    width: "11",
    height: "1",
    rx: ".5"
  }), y$1("path", {
    fillRule: "nonzero",
    d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
  })))) : null;
}
__name(EditButton, "EditButton");
function RemoveButton(_ref2) {
  let {
    i18n,
    onClick,
    file
  } = _ref2;
  return y$1("button", {
    className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
    type: "button",
    "aria-label": i18n("removeFile", {
      file: file.meta.name
    }),
    title: i18n("removeFile", {
      file: file.meta.name
    }),
    onClick: /* @__PURE__ */ __name(() => onClick(), "onClick")
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, y$1("path", {
    d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
  }), y$1("path", {
    fill: "#FFF",
    d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
  })));
}
__name(RemoveButton, "RemoveButton");
const copyLinkToClipboard = /* @__PURE__ */ __name((event, props) => {
  copyToClipboard(props.file.uploadURL, props.i18n("copyLinkToClipboardFallback")).then(() => {
    props.uppy.log("Link copied to clipboard."), props.uppy.info(props.i18n("copyLinkToClipboardSuccess"), "info", 3e3);
  }).catch(props.uppy.log).then(() => event.target.focus({
    preventScroll: !0
  }));
}, "copyLinkToClipboard");
function CopyLinkButton(props) {
  const {
    i18n
  } = props;
  return y$1("button", {
    className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
    type: "button",
    "aria-label": i18n("copyLink"),
    title: i18n("copyLink"),
    onClick: /* @__PURE__ */ __name((event) => copyLinkToClipboard(event, props), "onClick")
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "14",
    height: "14",
    viewBox: "0 0 14 12"
  }, y$1("path", {
    d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
  })));
}
__name(CopyLinkButton, "CopyLinkButton");
function Buttons(props) {
  const {
    uppy,
    file,
    uploadInProgressOrComplete,
    canEditFile,
    metaFields,
    showLinkToFileUploadResult,
    showRemoveButton,
    i18n,
    toggleFileCard,
    openFileEditor
  } = props;
  return y$1("div", {
    className: "uppy-Dashboard-Item-actionWrapper"
  }, y$1(EditButton, {
    i18n,
    file,
    uploadInProgressOrComplete,
    canEditFile,
    metaFields,
    onClick: /* @__PURE__ */ __name(() => {
      metaFields && metaFields.length > 0 ? toggleFileCard(!0, file.id) : openFileEditor(file);
    }, "editAction")
  }), showLinkToFileUploadResult && file.uploadURL ? y$1(CopyLinkButton, {
    file,
    uppy,
    i18n
  }) : null, showRemoveButton ? y$1(RemoveButton, {
    i18n,
    file,
    uppy,
    onClick: /* @__PURE__ */ __name(() => props.uppy.removeFile(file.id, "removed-by-user"), "onClick")
  }) : null);
}
__name(Buttons, "Buttons");
const _FileItem = class _FileItem extends b$2 {
  componentDidMount() {
    const {
      file
    } = this.props;
    file.preview || this.props.handleRequestThumbnail(file);
  }
  shouldComponentUpdate(nextProps) {
    return !shallowEqual$1(this.props, nextProps);
  }
  // VirtualList mounts FileItems again and they emit `thumbnail:request`
  // Otherwise thumbnails are broken or missing after Golden Retriever restores files
  componentDidUpdate() {
    const {
      file
    } = this.props;
    file.preview || this.props.handleRequestThumbnail(file);
  }
  componentWillUnmount() {
    const {
      file
    } = this.props;
    file.preview || this.props.handleCancelThumbnail(file);
  }
  render() {
    const {
      file
    } = this.props, isProcessing = file.progress.preprocess || file.progress.postprocess, isUploaded = file.progress.uploadComplete && !isProcessing && !file.error, uploadInProgressOrComplete = file.progress.uploadStarted || isProcessing, uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing, error = file.error || !1, {
      isGhost
    } = file;
    let showRemoveButton = (this.props.individualCancellation || !uploadInProgress) && !isUploaded;
    isUploaded && this.props.showRemoveButtonAfterComplete && (showRemoveButton = !0);
    const dashboardItemClass = classNames({
      "uppy-Dashboard-Item": !0,
      "is-inprogress": uploadInProgress && !this.props.recoveredState,
      "is-processing": isProcessing,
      "is-complete": isUploaded,
      "is-error": !!error,
      "is-resumable": this.props.resumableUploads,
      "is-noIndividualCancellation": !this.props.individualCancellation,
      "is-ghost": isGhost
    });
    return y$1("div", {
      className: dashboardItemClass,
      id: `uppy_${file.id}`,
      role: this.props.role
    }, y$1("div", {
      className: "uppy-Dashboard-Item-preview"
    }, y$1(FilePreviewAndLink, {
      file,
      showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
      i18n: this.props.i18n,
      toggleFileCard: this.props.toggleFileCard,
      metaFields: this.props.metaFields
    }), y$1(FileProgress, {
      uppy: this.props.uppy,
      file,
      error,
      isUploaded,
      hideRetryButton: this.props.hideRetryButton,
      hideCancelButton: this.props.hideCancelButton,
      hidePauseResumeButton: this.props.hidePauseResumeButton,
      recoveredState: this.props.recoveredState,
      showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete,
      resumableUploads: this.props.resumableUploads,
      individualCancellation: this.props.individualCancellation,
      i18n: this.props.i18n
    })), y$1("div", {
      className: "uppy-Dashboard-Item-fileInfoAndButtons"
    }, y$1(FileInfo, {
      file,
      id: this.props.id,
      acquirers: this.props.acquirers,
      containerWidth: this.props.containerWidth,
      containerHeight: this.props.containerHeight,
      i18n: this.props.i18n,
      toggleAddFilesPanel: this.props.toggleAddFilesPanel,
      toggleFileCard: this.props.toggleFileCard,
      metaFields: this.props.metaFields,
      isSingleFile: this.props.isSingleFile
    }), y$1(Buttons, {
      file,
      metaFields: this.props.metaFields,
      showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
      showRemoveButton,
      canEditFile: this.props.canEditFile,
      uploadInProgressOrComplete,
      toggleFileCard: this.props.toggleFileCard,
      openFileEditor: this.props.openFileEditor,
      uppy: this.props.uppy,
      i18n: this.props.i18n
    })));
  }
};
__name(_FileItem, "FileItem");
let FileItem = _FileItem;
function chunks(list, size) {
  const chunked = [];
  let currentChunk = [];
  return list.forEach((item) => {
    currentChunk.length < size ? currentChunk.push(item) : (chunked.push(currentChunk), currentChunk = [item]);
  }), currentChunk.length && chunked.push(currentChunk), chunked;
}
__name(chunks, "chunks");
const FileList = /* @__PURE__ */ __name((_ref) => {
  let {
    id: id2,
    error,
    i18n,
    uppy,
    files,
    acquirers,
    resumableUploads,
    hideRetryButton,
    hidePauseResumeButton,
    hideCancelButton,
    showLinkToFileUploadResult,
    showRemoveButtonAfterComplete,
    isWide,
    metaFields,
    isSingleFile,
    toggleFileCard,
    handleRequestThumbnail,
    handleCancelThumbnail,
    recoveredState,
    individualCancellation,
    itemsPerRow,
    openFileEditor,
    canEditFile,
    toggleAddFilesPanel,
    containerWidth,
    containerHeight
  } = _ref;
  const rowHeight = itemsPerRow === 1 ? 71 : 200, rows = F$1(() => {
    const sortByGhostComesFirst = /* @__PURE__ */ __name((file1, file2) => files[file2].isGhost - files[file1].isGhost, "sortByGhostComesFirst"), fileIds = Object.keys(files);
    return recoveredState && fileIds.sort(sortByGhostComesFirst), chunks(fileIds, itemsPerRow);
  }, [files, itemsPerRow, recoveredState]), renderRow = /* @__PURE__ */ __name((row) => (
    // The `role="presentation` attribute ensures that the list items are properly
    // associated with the `VirtualList` element.
    // We use the first file ID as the key—this should not change across scroll rerenders
    y$1("div", {
      class: "uppy-Dashboard-filesInner",
      role: "presentation",
      key: row[0]
    }, row.map((fileID) => y$1(FileItem, {
      key: fileID,
      uppy,
      id: id2,
      error,
      i18n,
      acquirers,
      resumableUploads,
      individualCancellation,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showLinkToFileUploadResult,
      showRemoveButtonAfterComplete,
      isWide,
      metaFields,
      recoveredState,
      isSingleFile,
      containerWidth,
      containerHeight,
      toggleFileCard,
      handleRequestThumbnail,
      handleCancelThumbnail,
      role: "listitem",
      openFileEditor,
      canEditFile,
      toggleAddFilesPanel,
      file: files[fileID]
    })))
  ), "renderRow");
  return isSingleFile ? y$1("div", {
    class: "uppy-Dashboard-files"
  }, renderRow(rows[0])) : y$1(VirtualList, {
    class: "uppy-Dashboard-files",
    role: "list",
    data: rows,
    renderRow,
    rowHeight
  });
}, "FileList");
let _Symbol$for$2;
_Symbol$for$2 = Symbol.for("uppy test: disable unused locale key warning");
const _AddFiles = class _AddFiles extends b$2 {
  constructor() {
    super(...arguments), this.triggerFileInputClick = () => {
      this.fileInput.click();
    }, this.triggerFolderInputClick = () => {
      this.folderInput.click();
    }, this.triggerVideoCameraInputClick = () => {
      this.mobileVideoFileInput.click();
    }, this.triggerPhotoCameraInputClick = () => {
      this.mobilePhotoFileInput.click();
    }, this.onFileInputChange = (event) => {
      this.props.handleInputChange(event), event.target.value = null;
    }, this.renderHiddenInput = (isFolder, refCallback) => y$1("input", {
      className: "uppy-Dashboard-input",
      hidden: !0,
      "aria-hidden": "true",
      tabIndex: -1,
      webkitdirectory: isFolder,
      type: "file",
      name: "files[]",
      multiple: this.props.maxNumberOfFiles !== 1,
      onChange: this.onFileInputChange,
      accept: this.props.allowedFileTypes,
      ref: refCallback
    }), this.renderHiddenCameraInput = (type, nativeCameraFacingMode, refCallback) => {
      const accept = {
        photo: "image/*",
        video: "video/*"
      }[type];
      return y$1("input", {
        className: "uppy-Dashboard-input",
        hidden: !0,
        "aria-hidden": "true",
        tabIndex: -1,
        type: "file",
        name: `camera-${type}`,
        onChange: this.onFileInputChange,
        capture: nativeCameraFacingMode,
        accept,
        ref: refCallback
      });
    }, this.renderMyDeviceAcquirer = () => y$1("div", {
      className: "uppy-DashboardTab",
      role: "presentation",
      "data-uppy-acquirer-id": "MyDevice"
    }, y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
      role: "tab",
      tabIndex: 0,
      "data-uppy-super-focusable": !0,
      onClick: this.triggerFileInputClick
    }, y$1("div", {
      className: "uppy-DashboardTab-inner"
    }, y$1("svg", {
      className: "uppy-DashboardTab-iconMyDevice",
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("path", {
      d: "M8.45 22.087l-1.305-6.674h17.678l-1.572 6.674H8.45zm4.975-12.412l1.083 1.765a.823.823 0 00.715.386h7.951V13.5H8.587V9.675h4.838zM26.043 13.5h-1.195v-2.598c0-.463-.336-.75-.798-.75h-8.356l-1.082-1.766A.823.823 0 0013.897 8H7.728c-.462 0-.815.256-.815.718V13.5h-.956a.97.97 0 00-.746.37.972.972 0 00-.19.81l1.724 8.565c.095.44.484.755.933.755H24c.44 0 .824-.3.929-.727l2.043-8.568a.972.972 0 00-.176-.825.967.967 0 00-.753-.38z",
      fill: "currentcolor",
      "fill-rule": "evenodd"
    }))), y$1("div", {
      className: "uppy-DashboardTab-name"
    }, this.props.i18n("myDevice")))), this.renderPhotoCamera = () => y$1("div", {
      className: "uppy-DashboardTab",
      role: "presentation",
      "data-uppy-acquirer-id": "MobilePhotoCamera"
    }, y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
      role: "tab",
      tabIndex: 0,
      "data-uppy-super-focusable": !0,
      onClick: this.triggerPhotoCameraInputClick
    }, y$1("div", {
      className: "uppy-DashboardTab-inner"
    }, y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("path", {
      d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
      fill: "#02B383",
      "fill-rule": "nonzero"
    }))), y$1("div", {
      className: "uppy-DashboardTab-name"
    }, this.props.i18n("takePictureBtn")))), this.renderVideoCamera = () => y$1("div", {
      className: "uppy-DashboardTab",
      role: "presentation",
      "data-uppy-acquirer-id": "MobileVideoCamera"
    }, y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
      role: "tab",
      tabIndex: 0,
      "data-uppy-super-focusable": !0,
      onClick: this.triggerVideoCameraInputClick
    }, y$1("div", {
      className: "uppy-DashboardTab-inner"
    }, y$1("svg", {
      "aria-hidden": "true",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("path", {
      fill: "#FF675E",
      fillRule: "nonzero",
      d: "m21.254 14.277 2.941-2.588c.797-.313 1.243.818 1.09 1.554-.01 2.094.02 4.189-.017 6.282-.126.915-1.145 1.08-1.58.34l-2.434-2.142c-.192.287-.504 1.305-.738.468-.104-1.293-.028-2.596-.05-3.894.047-.312.381.823.426 1.069.063-.384.206-.744.362-1.09zm-12.939-3.73c3.858.013 7.717-.025 11.574.02.912.129 1.492 1.237 1.351 2.217-.019 2.412.04 4.83-.03 7.239-.17 1.025-1.166 1.59-2.029 1.429-3.705-.012-7.41.025-11.114-.019-.913-.129-1.492-1.237-1.352-2.217.018-2.404-.036-4.813.029-7.214.136-.82.83-1.473 1.571-1.454z "
    }))), y$1("div", {
      className: "uppy-DashboardTab-name"
    }, this.props.i18n("recordVideoBtn")))), this.renderBrowseButton = (text, onClickFn) => {
      const numberOfAcquirers = this.props.acquirers.length;
      return y$1("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-browse",
        onClick: onClickFn,
        "data-uppy-super-focusable": numberOfAcquirers === 0
      }, text);
    }, this.renderDropPasteBrowseTagline = (numberOfAcquirers) => {
      const browseFiles = this.renderBrowseButton(this.props.i18n("browseFiles"), this.triggerFileInputClick), browseFolders = this.renderBrowseButton(this.props.i18n("browseFolders"), this.triggerFolderInputClick), lowerFMSelectionType = this.props.fileManagerSelectionType, camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
      return y$1(
        "div",
        {
          class: "uppy-Dashboard-AddFiles-title"
        },
        // eslint-disable-next-line no-nested-ternary
        this.props.disableLocalFiles ? this.props.i18n("importFiles") : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
          browseFiles,
          browseFolders,
          browse: browseFiles
        }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
          browseFiles,
          browseFolders,
          browse: browseFiles
        })
      );
    }, this.renderAcquirer = (acquirer) => y$1("div", {
      className: "uppy-DashboardTab",
      role: "presentation",
      "data-uppy-acquirer-id": acquirer.id
    }, y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
      role: "tab",
      tabIndex: 0,
      "data-cy": acquirer.id,
      "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
      "aria-selected": this.props.activePickerPanel.id === acquirer.id,
      "data-uppy-super-focusable": !0,
      onClick: /* @__PURE__ */ __name(() => this.props.showPanel(acquirer.id), "onClick")
    }, y$1("div", {
      className: "uppy-DashboardTab-inner"
    }, acquirer.icon()), y$1("div", {
      className: "uppy-DashboardTab-name"
    }, acquirer.name))), this.renderAcquirers = (acquirers) => {
      const acquirersWithoutLastTwo = [...acquirers], lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
      return y$1(k$2, null, acquirersWithoutLastTwo.map((acquirer) => this.renderAcquirer(acquirer)), y$1("span", {
        role: "presentation",
        style: {
          "white-space": "nowrap"
        }
      }, lastTwoAcquirers.map((acquirer) => this.renderAcquirer(acquirer))));
    }, this.renderSourcesList = (acquirers, disableLocalFiles) => {
      const {
        showNativePhotoCameraButton,
        showNativeVideoCameraButton
      } = this.props;
      let list = [];
      const myDeviceKey = "myDevice";
      disableLocalFiles || (list.push({
        key: myDeviceKey,
        elements: this.renderMyDeviceAcquirer()
      }), showNativePhotoCameraButton && list.push({
        key: "nativePhotoCameraButton",
        elements: this.renderPhotoCamera()
      }), showNativeVideoCameraButton && list.push({
        key: "nativePhotoCameraButton",
        elements: this.renderVideoCamera()
      })), list.push(...acquirers.map((acquirer) => ({
        key: acquirer.id,
        elements: this.renderAcquirer(acquirer)
      }))), list.length === 1 && list[0].key === myDeviceKey && (list = []);
      const listWithoutLastTwo = [...list], lastTwo = listWithoutLastTwo.splice(list.length - 2, list.length), renderList = /* @__PURE__ */ __name((l2) => l2.map((_ref) => {
        let {
          key,
          elements
        } = _ref;
        return y$1(k$2, {
          key
        }, elements);
      }), "renderList");
      return y$1(k$2, null, this.renderDropPasteBrowseTagline(list.length), y$1("div", {
        className: "uppy-Dashboard-AddFiles-list",
        role: "tablist"
      }, renderList(listWithoutLastTwo), y$1("span", {
        role: "presentation",
        style: {
          "white-space": "nowrap"
        }
      }, renderList(lastTwo))));
    };
  }
  [_Symbol$for$2]() {
    this.props.i18nArray("dropPasteBoth"), this.props.i18nArray("dropPasteFiles"), this.props.i18nArray("dropPasteFolders"), this.props.i18nArray("dropPasteImportBoth"), this.props.i18nArray("dropPasteImportFiles"), this.props.i18nArray("dropPasteImportFolders");
  }
  renderPoweredByUppy() {
    const {
      i18nArray
    } = this.props, uppyBranding = y$1("span", null, y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
      width: "11",
      height: "11",
      viewBox: "0 0 11 11"
    }, y$1("path", {
      d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
      fillRule: "evenodd"
    })), y$1("span", {
      className: "uppy-Dashboard-poweredByUppy"
    }, "Uppy")), linkText = i18nArray("poweredBy", {
      uppy: uppyBranding
    });
    return y$1("a", {
      tabIndex: "-1",
      href: "https://uppy.io",
      rel: "noreferrer noopener",
      target: "_blank",
      className: "uppy-Dashboard-poweredBy"
    }, linkText);
  }
  render() {
    const {
      showNativePhotoCameraButton,
      showNativeVideoCameraButton,
      nativeCameraFacingMode
    } = this.props;
    return y$1("div", {
      className: "uppy-Dashboard-AddFiles"
    }, this.renderHiddenInput(!1, (ref) => {
      this.fileInput = ref;
    }), this.renderHiddenInput(!0, (ref) => {
      this.folderInput = ref;
    }), showNativePhotoCameraButton && this.renderHiddenCameraInput("photo", nativeCameraFacingMode, (ref) => {
      this.mobilePhotoFileInput = ref;
    }), showNativeVideoCameraButton && this.renderHiddenCameraInput("video", nativeCameraFacingMode, (ref) => {
      this.mobileVideoFileInput = ref;
    }), this.renderSourcesList(this.props.acquirers, this.props.disableLocalFiles), y$1("div", {
      className: "uppy-Dashboard-AddFiles-info"
    }, this.props.note && y$1("div", {
      className: "uppy-Dashboard-note"
    }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy(this.props)));
  }
};
__name(_AddFiles, "AddFiles");
let AddFiles = _AddFiles;
const AddFilesPanel = /* @__PURE__ */ __name((props) => y$1("div", {
  className: classNames("uppy-Dashboard-AddFilesPanel", props.className),
  "data-uppy-panelType": "AddFiles",
  "aria-hidden": !props.showAddFilesPanel
}, y$1("div", {
  className: "uppy-DashboardContent-bar"
}, y$1("div", {
  className: "uppy-DashboardContent-title",
  role: "heading",
  "aria-level": "1"
}, props.i18n("addingMoreFiles")), y$1("button", {
  className: "uppy-DashboardContent-back",
  type: "button",
  onClick: /* @__PURE__ */ __name(() => props.toggleAddFilesPanel(!1), "onClick")
}, props.i18n("back"))), y$1(AddFiles, props)), "AddFilesPanel");
function ignoreEvent(ev) {
  const {
    tagName
  } = ev.target;
  if (tagName === "INPUT" || tagName === "TEXTAREA") {
    ev.stopPropagation();
    return;
  }
  ev.preventDefault(), ev.stopPropagation();
}
__name(ignoreEvent, "ignoreEvent");
function PickerPanelContent(_ref) {
  let {
    activePickerPanel,
    className,
    hideAllPanels,
    i18n,
    state,
    uppy
  } = _ref;
  return y$1("div", {
    className: classNames("uppy-DashboardContent-panel", className),
    role: "tabpanel",
    "data-uppy-panelType": "PickerPanel",
    id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
    onDragOver: ignoreEvent,
    onDragLeave: ignoreEvent,
    onDrop: ignoreEvent,
    onPaste: ignoreEvent
  }, y$1("div", {
    className: "uppy-DashboardContent-bar"
  }, y$1("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18n("importFrom", {
    name: activePickerPanel.name
  })), y$1("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: hideAllPanels
  }, i18n("cancel"))), y$1("div", {
    className: "uppy-DashboardContent-panelBody"
  }, uppy.getPlugin(activePickerPanel.id).render(state)));
}
__name(PickerPanelContent, "PickerPanelContent");
function EditorPanel(props) {
  const file = props.files[props.fileCardFor], handleCancel = /* @__PURE__ */ __name(() => {
    props.uppy.emit("file-editor:cancel", file), props.hideAllPanels();
  }, "handleCancel");
  return y$1("div", {
    className: classNames("uppy-DashboardContent-panel", props.className),
    role: "tabpanel",
    "data-uppy-panelType": "FileEditor",
    id: "uppy-DashboardContent-panel--editor"
  }, y$1("div", {
    className: "uppy-DashboardContent-bar"
  }, y$1("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, props.i18nArray("editing", {
    file: y$1("span", {
      className: "uppy-DashboardContent-titleFile"
    }, file.meta ? file.meta.name : file.name)
  })), y$1("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: handleCancel
  }, props.i18n("cancel")), y$1("button", {
    className: "uppy-DashboardContent-save",
    type: "button",
    onClick: props.saveFileEditor
  }, props.i18n("save"))), y$1("div", {
    className: "uppy-DashboardContent-panelBody"
  }, props.editors.map((target) => props.uppy.getPlugin(target.id).render(props.state))));
}
__name(EditorPanel, "EditorPanel");
const uploadStates = {
  STATE_ERROR: "error",
  STATE_WAITING: "waiting",
  STATE_PREPROCESSING: "preprocessing",
  STATE_UPLOADING: "uploading",
  STATE_POSTPROCESSING: "postprocessing",
  STATE_COMPLETE: "complete",
  STATE_PAUSED: "paused"
};
function getUploadingState(isAllErrored, isAllComplete, isAllPaused, files) {
  if (files === void 0 && (files = {}), isAllErrored)
    return uploadStates.STATE_ERROR;
  if (isAllComplete)
    return uploadStates.STATE_COMPLETE;
  if (isAllPaused)
    return uploadStates.STATE_PAUSED;
  let state = uploadStates.STATE_WAITING;
  const fileIDs = Object.keys(files);
  for (let i2 = 0; i2 < fileIDs.length; i2++) {
    const {
      progress
    } = files[fileIDs[i2]];
    if (progress.uploadStarted && !progress.uploadComplete)
      return uploadStates.STATE_UPLOADING;
    progress.preprocess && state !== uploadStates.STATE_UPLOADING && (state = uploadStates.STATE_PREPROCESSING), progress.postprocess && state !== uploadStates.STATE_UPLOADING && state !== uploadStates.STATE_PREPROCESSING && (state = uploadStates.STATE_POSTPROCESSING);
  }
  return state;
}
__name(getUploadingState, "getUploadingState");
function UploadStatus(_ref) {
  let {
    files,
    i18n,
    isAllComplete,
    isAllErrored,
    isAllPaused,
    inProgressNotPausedFiles,
    newFiles,
    processingFiles
  } = _ref;
  switch (getUploadingState(isAllErrored, isAllComplete, isAllPaused, files)) {
    case "uploading":
      return i18n("uploadingXFiles", {
        smart_count: inProgressNotPausedFiles.length
      });
    case "preprocessing":
    case "postprocessing":
      return i18n("processingXFiles", {
        smart_count: processingFiles.length
      });
    case "paused":
      return i18n("uploadPaused");
    case "waiting":
      return i18n("xFilesSelected", {
        smart_count: newFiles.length
      });
    case "complete":
      return i18n("uploadComplete");
    case "error":
      return i18n("error");
  }
}
__name(UploadStatus, "UploadStatus");
function PanelTopBar(props) {
  const {
    i18n,
    isAllComplete,
    hideCancelButton,
    maxNumberOfFiles,
    toggleAddFilesPanel,
    uppy
  } = props;
  let {
    allowNewUpload
  } = props;
  return allowNewUpload && maxNumberOfFiles && (allowNewUpload = props.totalFileCount < props.maxNumberOfFiles), y$1("div", {
    className: "uppy-DashboardContent-bar"
  }, !isAllComplete && !hideCancelButton ? y$1("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: /* @__PURE__ */ __name(() => uppy.cancelAll(), "onClick")
  }, i18n("cancel")) : y$1("div", null), y$1("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, y$1(UploadStatus, props)), allowNewUpload ? y$1("button", {
    className: "uppy-DashboardContent-addMore",
    type: "button",
    "aria-label": i18n("addMoreFiles"),
    title: i18n("addMoreFiles"),
    onClick: /* @__PURE__ */ __name(() => toggleAddFilesPanel(!0), "onClick")
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15"
  }, y$1("path", {
    d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
  })), y$1("span", {
    className: "uppy-DashboardContent-addMoreCaption"
  }, i18n("addMore"))) : y$1("div", null));
}
__name(PanelTopBar, "PanelTopBar");
function RenderMetaFields(props) {
  const {
    computedMetaFields,
    requiredMetaFields,
    updateMeta,
    form,
    formState
  } = props, fieldCSSClasses = {
    text: "uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input"
  };
  return computedMetaFields.map((field) => {
    const id2 = `uppy-Dashboard-FileCard-input-${field.id}`, required3 = requiredMetaFields.includes(field.id);
    return y$1("fieldset", {
      key: field.id,
      className: "uppy-Dashboard-FileCard-fieldset"
    }, y$1("label", {
      className: "uppy-Dashboard-FileCard-label",
      htmlFor: id2
    }, field.name), field.render !== void 0 ? field.render({
      value: formState[field.id],
      onChange: /* @__PURE__ */ __name((newVal) => updateMeta(newVal, field.id), "onChange"),
      fieldCSSClasses,
      required: required3,
      form: form.id
    }, y$1) : y$1("input", {
      className: fieldCSSClasses.text,
      id: id2,
      form: form.id,
      type: field.type || "text",
      required: required3,
      value: formState[field.id],
      placeholder: field.placeholder,
      onInput: /* @__PURE__ */ __name((ev) => updateMeta(ev.target.value, field.id), "onInput"),
      "data-uppy-super-focusable": !0
    }));
  });
}
__name(RenderMetaFields, "RenderMetaFields");
function FileCard(props) {
  var _getMetaFields;
  const {
    files,
    fileCardFor,
    toggleFileCard,
    saveFileCard,
    metaFields,
    requiredMetaFields,
    openFileEditor,
    i18n,
    i18nArray,
    className,
    canEditFile
  } = props, getMetaFields = /* @__PURE__ */ __name(() => typeof metaFields == "function" ? metaFields(files[fileCardFor]) : metaFields, "getMetaFields"), file = files[fileCardFor], computedMetaFields = (_getMetaFields = getMetaFields()) != null ? _getMetaFields : [], showEditButton = canEditFile(file), storedMetaData = {};
  computedMetaFields.forEach((field) => {
    var _file$meta$field$id;
    storedMetaData[field.id] = (_file$meta$field$id = file.meta[field.id]) != null ? _file$meta$field$id : "";
  });
  const [formState, setFormState] = h$1(storedMetaData), handleSave = T$1((ev) => {
    ev.preventDefault(), saveFileCard(formState, fileCardFor);
  }, [saveFileCard, formState, fileCardFor]), updateMeta = /* @__PURE__ */ __name((newVal, name) => {
    setFormState({
      ...formState,
      [name]: newVal
    });
  }, "updateMeta"), handleCancel = /* @__PURE__ */ __name(() => {
    toggleFileCard(!1);
  }, "handleCancel"), [form] = h$1(() => {
    const formEl = document.createElement("form");
    return formEl.setAttribute("tabindex", "-1"), formEl.id = nanoid(), formEl;
  });
  return p$1(() => (document.body.appendChild(form), form.addEventListener("submit", handleSave), () => {
    form.removeEventListener("submit", handleSave), document.body.removeChild(form);
  }), [form, handleSave]), y$1("div", {
    className: classNames("uppy-Dashboard-FileCard", className),
    "data-uppy-panelType": "FileCard",
    onDragOver: ignoreEvent,
    onDragLeave: ignoreEvent,
    onDrop: ignoreEvent,
    onPaste: ignoreEvent
  }, y$1("div", {
    className: "uppy-DashboardContent-bar"
  }, y$1("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18nArray("editing", {
    file: y$1("span", {
      className: "uppy-DashboardContent-titleFile"
    }, file.meta ? file.meta.name : file.name)
  })), y$1("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    form: form.id,
    title: i18n("finishEditingFile"),
    onClick: handleCancel
  }, i18n("cancel"))), y$1("div", {
    className: "uppy-Dashboard-FileCard-inner"
  }, y$1("div", {
    className: "uppy-Dashboard-FileCard-preview",
    style: {
      backgroundColor: getIconByMime(file.type).color
    }
  }, y$1(FilePreview, {
    file
  }), showEditButton && y$1("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
    onClick: /* @__PURE__ */ __name((event) => {
      handleSave(event), openFileEditor(file);
    }, "onClick")
  }, i18n("editFile"))), y$1("div", {
    className: "uppy-Dashboard-FileCard-info"
  }, y$1(RenderMetaFields, {
    computedMetaFields,
    requiredMetaFields,
    updateMeta,
    form,
    formState
  })), y$1("div", {
    className: "uppy-Dashboard-FileCard-actions"
  }, y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn",
    type: "submit",
    form: form.id
  }, i18n("saveChanges")), y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
    type: "button",
    onClick: handleCancel,
    form: form.id
  }, i18n("cancel")))));
}
__name(FileCard, "FileCard");
const transitionName = "uppy-transition-slideDownUp", duration = 250, _Slide = class _Slide extends b$2 {
  constructor(props) {
    super(props), this.state = {
      cachedChildren: null,
      className: ""
    };
  }
  // TODO: refactor to stable lifecycle method
  // eslint-disable-next-line
  componentWillUpdate(nextProps) {
    const {
      cachedChildren
    } = this.state, child = C(nextProps.children)[0];
    if (cachedChildren === child) return null;
    const patch = {
      cachedChildren: child
    };
    child && !cachedChildren && (patch.className = `${transitionName}-enter`, cancelAnimationFrame(this.animationFrame), clearTimeout(this.leaveTimeout), this.leaveTimeout = void 0, this.animationFrame = requestAnimationFrame(() => {
      this.setState({
        className: `${transitionName}-enter ${transitionName}-enter-active`
      }), this.enterTimeout = setTimeout(() => {
        this.setState({
          className: ""
        });
      }, duration);
    })), cachedChildren && !child && this.leaveTimeout === void 0 && (patch.cachedChildren = cachedChildren, patch.className = `${transitionName}-leave`, cancelAnimationFrame(this.animationFrame), clearTimeout(this.enterTimeout), this.enterTimeout = void 0, this.animationFrame = requestAnimationFrame(() => {
      this.setState({
        className: `${transitionName}-leave ${transitionName}-leave-active`
      }), this.leaveTimeout = setTimeout(() => {
        this.setState({
          cachedChildren: null,
          className: ""
        });
      }, duration);
    })), this.setState(patch);
  }
  render() {
    const {
      cachedChildren,
      className
    } = this.state;
    return cachedChildren ? F$2(cachedChildren, {
      className: classNames(className, cachedChildren.props.className)
    }) : null;
  }
};
__name(_Slide, "Slide");
let Slide = _Slide;
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$6.apply(this, arguments);
}
__name(_extends$6, "_extends$6");
const WIDTH_XL = 900, WIDTH_LG = 700, WIDTH_MD = 576, HEIGHT_MD = 330;
function Dashboard$1(props) {
  const isNoFiles = props.totalFileCount === 0, isSingleFile = props.totalFileCount === 1, isSizeMD = props.containerWidth > WIDTH_MD, isSizeHeightMD = props.containerHeight > HEIGHT_MD, dashboardClassName = classNames({
    "uppy-Dashboard": !0,
    "uppy-Dashboard--isDisabled": props.disabled,
    "uppy-Dashboard--animateOpenClose": props.animateOpenClose,
    "uppy-Dashboard--isClosing": props.isClosing,
    "uppy-Dashboard--isDraggingOver": props.isDraggingOver,
    "uppy-Dashboard--modal": !props.inline,
    "uppy-size--md": props.containerWidth > WIDTH_MD,
    "uppy-size--lg": props.containerWidth > WIDTH_LG,
    "uppy-size--xl": props.containerWidth > WIDTH_XL,
    "uppy-size--height-md": props.containerHeight > HEIGHT_MD,
    // We might want to enable this in the future
    // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
    // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
    "uppy-Dashboard--isAddFilesPanelVisible": props.showAddFilesPanel,
    "uppy-Dashboard--isInnerWrapVisible": props.areInsidesReadyToBeVisible,
    // Only enable “centered single file” mode when Dashboard is tall enough
    "uppy-Dashboard--singleFile": props.singleFileFullScreen && isSingleFile && isSizeHeightMD
  });
  let itemsPerRow = 1;
  props.containerWidth > WIDTH_XL ? itemsPerRow = 5 : props.containerWidth > WIDTH_LG ? itemsPerRow = 4 : props.containerWidth > WIDTH_MD && (itemsPerRow = 3);
  const showFileList = props.showSelectedFiles && !isNoFiles, numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null, numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID) => props.files[fileID].isGhost).length : null, renderRestoredText = /* @__PURE__ */ __name(() => numberOfGhosts > 0 ? props.i18n("recoveredXFiles", {
    smart_count: numberOfGhosts
  }) : props.i18n("recoveredAllFiles"), "renderRestoredText");
  return y$1("div", {
    className: dashboardClassName,
    "data-uppy-theme": props.theme,
    "data-uppy-num-acquirers": props.acquirers.length,
    "data-uppy-drag-drop-supported": !props.disableLocalFiles && isDragDropSupported(),
    "aria-hidden": props.inline ? "false" : props.isHidden,
    "aria-disabled": props.disabled,
    "aria-label": props.inline ? props.i18n("dashboardTitle") : props.i18n("dashboardWindowTitle"),
    onPaste: props.handlePaste,
    onDragOver: props.handleDragOver,
    onDragLeave: props.handleDragLeave,
    onDrop: props.handleDrop
  }, y$1("div", {
    "aria-hidden": "true",
    className: "uppy-Dashboard-overlay",
    tabIndex: -1,
    onClick: props.handleClickOutside
  }), y$1("div", {
    className: "uppy-Dashboard-inner",
    "aria-modal": !props.inline && "true",
    role: !props.inline && "dialog",
    style: {
      width: props.inline && props.width ? props.width : "",
      height: props.inline && props.height ? props.height : ""
    }
  }, props.inline ? null : y$1("button", {
    className: "uppy-u-reset uppy-Dashboard-close",
    type: "button",
    "aria-label": props.i18n("closeModal"),
    title: props.i18n("closeModal"),
    onClick: props.closeModal
  }, y$1("span", {
    "aria-hidden": "true"
  }, "×")), y$1("div", {
    className: "uppy-Dashboard-innerWrap"
  }, y$1("div", {
    className: "uppy-Dashboard-dropFilesHereHint"
  }, props.i18n("dropHint")), showFileList && y$1(PanelTopBar, props), numberOfFilesForRecovery && y$1("div", {
    className: "uppy-Dashboard-serviceMsg"
  }, y$1("svg", {
    className: "uppy-Dashboard-serviceMsg-icon",
    "aria-hidden": "true",
    focusable: "false",
    width: "21",
    height: "16",
    viewBox: "0 0 24 19"
  }, y$1("g", {
    transform: "translate(0 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, y$1("path", {
    d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
    fill: "#FFD300"
  }), y$1("path", {
    fill: "#000",
    d: "M11 6h2l-.3 8h-1.4z"
  }), y$1("circle", {
    fill: "#000",
    cx: "12",
    cy: "17",
    r: "1"
  }))), y$1("strong", {
    className: "uppy-Dashboard-serviceMsg-title"
  }, props.i18n("sessionRestored")), y$1("div", {
    className: "uppy-Dashboard-serviceMsg-text"
  }, renderRestoredText())), showFileList ? y$1(FileList, {
    id: props.id,
    error: props.error,
    i18n: props.i18n,
    uppy: props.uppy,
    files: props.files,
    acquirers: props.acquirers,
    resumableUploads: props.resumableUploads,
    hideRetryButton: props.hideRetryButton,
    hidePauseResumeButton: props.hidePauseResumeButton,
    hideCancelButton: props.hideCancelButton,
    showLinkToFileUploadResult: props.showLinkToFileUploadResult,
    showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
    isWide: props.isWide,
    metaFields: props.metaFields,
    toggleFileCard: props.toggleFileCard,
    handleRequestThumbnail: props.handleRequestThumbnail,
    handleCancelThumbnail: props.handleCancelThumbnail,
    recoveredState: props.recoveredState,
    individualCancellation: props.individualCancellation,
    openFileEditor: props.openFileEditor,
    canEditFile: props.canEditFile,
    toggleAddFilesPanel: props.toggleAddFilesPanel,
    isSingleFile,
    itemsPerRow
  }) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    y$1(AddFiles, _extends$6({}, props, {
      isSizeMD
    }))
  ), y$1(Slide, null, props.showAddFilesPanel ? y$1(AddFilesPanel, _extends$6({
    key: "AddFiles"
  }, props, {
    isSizeMD
  })) : null), y$1(Slide, null, props.fileCardFor ? y$1(FileCard, _extends$6({
    key: "FileCard"
  }, props)) : null), y$1(Slide, null, props.activePickerPanel ? y$1(PickerPanelContent, _extends$6({
    key: "Picker"
  }, props)) : null), y$1(Slide, null, props.showFileEditor ? y$1(EditorPanel, _extends$6({
    key: "Editor"
  }, props)) : null), y$1("div", {
    className: "uppy-Dashboard-progressindicators"
  }, props.progressindicators.map((target) => props.uppy.getPlugin(target.id).render(props.state))))));
}
__name(Dashboard$1, "Dashboard$1");
const locale$h = {
  strings: {
    // When `inline: false`, used as the screen reader label for the button that closes the modal.
    closeModal: "Close Modal",
    // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
    addMoreFiles: "Add more files",
    addingMoreFiles: "Adding more files",
    // Used as the header for import panels, e.g., “Import from Google Drive”.
    importFrom: "Import from %{name}",
    // When `inline: false`, used as the screen reader label for the dashboard modal.
    dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
    // When `inline: true`, used as the screen reader label for the dashboard area.
    dashboardTitle: "Uppy Dashboard",
    // Shown in the Informer when a link to a file was copied to the clipboard.
    copyLinkToClipboardSuccess: "Link copied to clipboard.",
    // Used when a link cannot be copied automatically — the user has to select the text from the
    // input element below this string.
    copyLinkToClipboardFallback: "Copy the URL below",
    // Used as the hover title and screen reader label for buttons that copy a file link.
    copyLink: "Copy link",
    back: "Back",
    // Used as the screen reader label for buttons that remove a file.
    removeFile: "Remove file",
    // Used as the screen reader label for buttons that open the metadata editor panel for a file.
    editFile: "Edit file",
    // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
    editing: "Editing %{file}",
    // Shown on the main upload screen when an upload error occurs
    error: "Error",
    // Used as the screen reader label for the button that saves metadata edits and returns to the
    // file list view.
    finishEditingFile: "Finish editing file",
    saveChanges: "Save changes",
    // Used as the label for the tab button that opens the system file selection dialog.
    myDevice: "My Device",
    dropHint: "Drop your files here",
    // Used as the hover text and screen reader label for file progress indicators when
    // they have been fully uploaded.
    uploadComplete: "Upload complete",
    uploadPaused: "Upload paused",
    // Used as the hover text and screen reader label for the buttons to resume paused uploads.
    resumeUpload: "Resume upload",
    // Used as the hover text and screen reader label for the buttons to pause uploads.
    pauseUpload: "Pause upload",
    // Used as the hover text and screen reader label for the buttons to retry failed uploads.
    retryUpload: "Retry upload",
    // Used as the hover text and screen reader label for the buttons to cancel uploads.
    cancelUpload: "Cancel upload",
    // Used in a title, how many files are currently selected
    xFilesSelected: {
      0: "%{smart_count} file selected",
      1: "%{smart_count} files selected"
    },
    uploadingXFiles: {
      0: "Uploading %{smart_count} file",
      1: "Uploading %{smart_count} files"
    },
    processingXFiles: {
      0: "Processing %{smart_count} file",
      1: "Processing %{smart_count} files"
    },
    // The "powered by Uppy" link at the bottom of the Dashboard.
    poweredBy: "Powered by %{uppy}",
    addMore: "Add more",
    editFileWithFilename: "Edit file %{file}",
    save: "Save",
    cancel: "Cancel",
    dropPasteFiles: "Drop files here or %{browseFiles}",
    dropPasteFolders: "Drop files here or %{browseFolders}",
    dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
    dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
    dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
    dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
    importFiles: "Import files from:",
    browseFiles: "browse files",
    browseFolders: "browse folders",
    recoveredXFiles: {
      0: "We could not fully recover 1 file. Please re-select it and resume the upload.",
      1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
    },
    recoveredAllFiles: "We restored all files. You can now resume the upload.",
    sessionRestored: "Session restored",
    reSelect: "Re-select",
    missingRequiredMetaFields: {
      0: "Missing required meta field: %{fields}.",
      1: "Missing required meta fields: %{fields}."
    },
    // Used for native device camera buttons on mobile
    takePictureBtn: "Take Picture",
    recordVideoBtn: "Record Video"
  }
};
function _classPrivateFieldLooseBase$j(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$j, "_classPrivateFieldLooseBase$j");
var id$j = 0;
function _classPrivateFieldLooseKey$j(name) {
  return "__private_" + id$j++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$j, "_classPrivateFieldLooseKey$j");
const packageJson$q = {
  version: "3.5.3"
}, memoize = memoizeOne.default || memoizeOne, TAB_KEY = 9, ESC_KEY = 27;
function createPromise() {
  const o2 = {};
  return o2.promise = new Promise((resolve3, reject) => {
    o2.resolve = resolve3, o2.reject = reject;
  }), o2;
}
__name(createPromise, "createPromise");
var _disabledNodes = /* @__PURE__ */ _classPrivateFieldLooseKey$j("disabledNodes"), _generateLargeThumbnailIfSingleFile = /* @__PURE__ */ _classPrivateFieldLooseKey$j("generateLargeThumbnailIfSingleFile"), _openFileEditorWhenFilesAdded = /* @__PURE__ */ _classPrivateFieldLooseKey$j("openFileEditorWhenFilesAdded"), _attachRenderFunctionToTarget = /* @__PURE__ */ _classPrivateFieldLooseKey$j("attachRenderFunctionToTarget"), _isTargetSupported = /* @__PURE__ */ _classPrivateFieldLooseKey$j("isTargetSupported"), _getAcquirers = /* @__PURE__ */ _classPrivateFieldLooseKey$j("getAcquirers"), _getProgressIndicators = /* @__PURE__ */ _classPrivateFieldLooseKey$j("getProgressIndicators"), _getEditors = /* @__PURE__ */ _classPrivateFieldLooseKey$j("getEditors");
const _Dashboard = class _Dashboard extends UIPlugin {
  constructor(uppy, _opts) {
    var _this;
    super(uppy, _opts), _this = this, Object.defineProperty(this, _disabledNodes, {
      writable: !0,
      value: null
    }), this.removeTarget = (plugin) => {
      const newTargets = this.getPluginState().targets.filter((target) => target.id !== plugin.id);
      this.setPluginState({
        targets: newTargets
      });
    }, this.addTarget = (plugin) => {
      const callerPluginId = plugin.id || plugin.constructor.name, callerPluginName = plugin.title || callerPluginId, callerPluginType = plugin.type;
      if (callerPluginType !== "acquirer" && callerPluginType !== "progressindicator" && callerPluginType !== "editor") {
        this.uppy.log("Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor", "error");
        return;
      }
      const target = {
        id: callerPluginId,
        name: callerPluginName,
        type: callerPluginType
      }, newTargets = this.getPluginState().targets.slice();
      return newTargets.push(target), this.setPluginState({
        targets: newTargets
      }), this.el;
    }, this.hideAllPanels = () => {
      const state = this.getPluginState(), update = {
        activePickerPanel: !1,
        showAddFilesPanel: !1,
        activeOverlayType: null,
        fileCardFor: null,
        showFileEditor: !1
      };
      state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType || (this.setPluginState(update), this.uppy.emit("dashboard:close-panel", state.activePickerPanel.id));
    }, this.showPanel = (id2) => {
      const {
        targets
      } = this.getPluginState(), activePickerPanel = targets.filter((target) => target.type === "acquirer" && target.id === id2)[0];
      this.setPluginState({
        activePickerPanel,
        activeOverlayType: "PickerPanel"
      }), this.uppy.emit("dashboard:show-panel", id2);
    }, this.canEditFile = (file) => {
      const {
        targets
      } = this.getPluginState();
      return _classPrivateFieldLooseBase$j(this, _getEditors)[_getEditors](targets).some((target) => this.uppy.getPlugin(target.id).canEditFile(file));
    }, this.openFileEditor = (file) => {
      const {
        targets
      } = this.getPluginState(), editors = _classPrivateFieldLooseBase$j(this, _getEditors)[_getEditors](targets);
      this.setPluginState({
        showFileEditor: !0,
        fileCardFor: file.id || null,
        activeOverlayType: "FileEditor"
      }), editors.forEach((editor) => {
        this.uppy.getPlugin(editor.id).selectFile(file);
      });
    }, this.saveFileEditor = () => {
      const {
        targets
      } = this.getPluginState();
      _classPrivateFieldLooseBase$j(this, _getEditors)[_getEditors](targets).forEach((editor) => {
        this.uppy.getPlugin(editor.id).save();
      }), this.hideAllPanels();
    }, this.openModal = () => {
      const {
        promise,
        resolve: resolve3
      } = createPromise();
      if (this.savedScrollPosition = window.pageYOffset, this.savedActiveElement = document.activeElement, this.opts.disablePageScrollWhenModalOpen && document.body.classList.add("uppy-Dashboard-isFixed"), this.opts.animateOpenClose && this.getPluginState().isClosing) {
        const handler = /* @__PURE__ */ __name(() => {
          this.setPluginState({
            isHidden: !1
          }), this.el.removeEventListener("animationend", handler, !1), resolve3();
        }, "handler");
        this.el.addEventListener("animationend", handler, !1);
      } else
        this.setPluginState({
          isHidden: !1
        }), resolve3();
      return this.opts.browserBackButtonClose && this.updateBrowserHistory(), document.addEventListener("keydown", this.handleKeyDownInModal), this.uppy.emit("dashboard:modal-open"), promise;
    }, this.closeModal = function(opts) {
      opts === void 0 && (opts = {});
      const {
        // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
        manualClose = !0
      } = opts, {
        isHidden,
        isClosing
      } = _this.getPluginState();
      if (isHidden || isClosing)
        return;
      const {
        promise,
        resolve: resolve3
      } = createPromise();
      if (_this.opts.disablePageScrollWhenModalOpen && document.body.classList.remove("uppy-Dashboard-isFixed"), _this.opts.animateOpenClose) {
        _this.setPluginState({
          isClosing: !0
        });
        const handler = /* @__PURE__ */ __name(() => {
          _this.setPluginState({
            isHidden: !0,
            isClosing: !1
          }), _this.superFocus.cancel(), _this.savedActiveElement.focus(), _this.el.removeEventListener("animationend", handler, !1), resolve3();
        }, "handler");
        _this.el.addEventListener("animationend", handler, !1);
      } else
        _this.setPluginState({
          isHidden: !0
        }), _this.superFocus.cancel(), _this.savedActiveElement.focus(), resolve3();
      if (document.removeEventListener("keydown", _this.handleKeyDownInModal), manualClose && _this.opts.browserBackButtonClose) {
        var _history$state;
        (_history$state = history.state) != null && _history$state[_this.modalName] && history.back();
      }
      return _this.uppy.emit("dashboard:modal-closed"), promise;
    }, this.isModalOpen = () => !this.getPluginState().isHidden || !1, this.requestCloseModal = () => this.opts.onRequestCloseModal ? this.opts.onRequestCloseModal() : this.closeModal(), this.setDarkModeCapability = (isDarkModeOn) => {
      const {
        capabilities
      } = this.uppy.getState();
      this.uppy.setState({
        capabilities: {
          ...capabilities,
          darkMode: isDarkModeOn
        }
      });
    }, this.handleSystemDarkModeChange = (event) => {
      const isDarkModeOnNow = event.matches;
      this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? "on" : "off"}`), this.setDarkModeCapability(isDarkModeOnNow);
    }, this.toggleFileCard = (show, fileID) => {
      const file = this.uppy.getFile(fileID);
      show ? this.uppy.emit("dashboard:file-edit-start", file) : this.uppy.emit("dashboard:file-edit-complete", file), this.setPluginState({
        fileCardFor: show ? fileID : null,
        activeOverlayType: show ? "FileCard" : null
      });
    }, this.toggleAddFilesPanel = (show) => {
      this.setPluginState({
        showAddFilesPanel: show,
        activeOverlayType: show ? "AddFiles" : null
      });
    }, this.addFiles = (files) => {
      const descriptors2 = files.map((file) => ({
        source: this.id,
        name: file.name,
        type: file.type,
        data: file,
        meta: {
          // path of the file relative to the ancestor directory the user selected.
          // e.g. 'docs/Old Prague/airbnb.pdf'
          relativePath: file.relativePath || file.webkitRelativePath || null
        }
      }));
      try {
        this.uppy.addFiles(descriptors2);
      } catch (err) {
        this.uppy.log(err);
      }
    }, this.startListeningToResize = () => {
      this.resizeObserver = new ResizeObserver((entries) => {
        const uppyDashboardInnerEl = entries[0], {
          width,
          height
        } = uppyDashboardInnerEl.contentRect;
        this.setPluginState({
          containerWidth: width,
          containerHeight: height,
          areInsidesReadyToBeVisible: !0
        });
      }), this.resizeObserver.observe(this.el.querySelector(".uppy-Dashboard-inner")), this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(() => {
        const pluginState = this.getPluginState(), isModalAndClosed = !this.opts.inline && pluginState.isHidden;
        // We might want to enable this in the future
        // if ResizeObserver hasn't yet fired,
        !pluginState.areInsidesReadyToBeVisible && !isModalAndClosed && (this.uppy.log("[Dashboard] resize event didn’t fire on time: defaulted to mobile layout", "warning"), this.setPluginState({
          areInsidesReadyToBeVisible: !0
        }));
      }, 1e3);
    }, this.stopListeningToResize = () => {
      this.resizeObserver.disconnect(), clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
    }, this.recordIfFocusedOnUppyRecently = (event) => {
      this.el.contains(event.target) ? this.ifFocusedOnUppyRecently = !0 : (this.ifFocusedOnUppyRecently = !1, this.superFocus.cancel());
    }, this.disableInteractiveElements = (disable2) => {
      var _classPrivateFieldLoo;
      const NODES_TO_DISABLE = ["a[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", '[role="button"]:not([disabled])'], nodesToDisable = (_classPrivateFieldLoo = _classPrivateFieldLooseBase$j(this, _disabledNodes)[_disabledNodes]) != null ? _classPrivateFieldLoo : toArray$3(this.el.querySelectorAll(NODES_TO_DISABLE)).filter((node) => !node.classList.contains("uppy-Dashboard-close"));
      for (const node of nodesToDisable)
        node.tagName === "A" ? node.setAttribute("aria-disabled", disable2) : node.disabled = disable2;
      disable2 ? _classPrivateFieldLooseBase$j(this, _disabledNodes)[_disabledNodes] = nodesToDisable : _classPrivateFieldLooseBase$j(this, _disabledNodes)[_disabledNodes] = null, this.dashboardIsDisabled = disable2;
    }, this.updateBrowserHistory = () => {
      var _history$state2;
      (_history$state2 = history.state) != null && _history$state2[this.modalName] || history.pushState({
        // eslint-disable-next-line no-restricted-globals
        ...history.state,
        [this.modalName]: !0
      }, ""), window.addEventListener("popstate", this.handlePopState, !1);
    }, this.handlePopState = (event) => {
      var _event$state;
      this.isModalOpen() && (!event.state || !event.state[this.modalName]) && this.closeModal({
        manualClose: !1
      }), !this.isModalOpen() && (_event$state = event.state) != null && _event$state[this.modalName] && history.back();
    }, this.handleKeyDownInModal = (event) => {
      event.keyCode === ESC_KEY && this.requestCloseModal(event), event.keyCode === TAB_KEY && trapFocus(event, this.getPluginState().activeOverlayType, this.el);
    }, this.handleClickOutside = () => {
      this.opts.closeModalOnClickOutside && this.requestCloseModal();
    }, this.handlePaste = (event) => {
      this.uppy.iteratePlugins((plugin) => {
        plugin.type === "acquirer" && (plugin.handleRootPaste == null || plugin.handleRootPaste(event));
      });
      const files = toArray$3(event.clipboardData.files);
      files.length > 0 && (this.uppy.log("[Dashboard] Files pasted"), this.addFiles(files));
    }, this.handleInputChange = (event) => {
      event.preventDefault();
      const files = toArray$3(event.target.files);
      files.length > 0 && (this.uppy.log("[Dashboard] Files selected through input"), this.addFiles(files));
    }, this.handleDragOver = (event) => {
      var _this$opts$onDragOver, _this$opts;
      event.preventDefault(), event.stopPropagation();
      const canSomePluginHandleRootDrop = /* @__PURE__ */ __name(() => {
        let somePluginCanHandleRootDrop2 = !0;
        return this.uppy.iteratePlugins((plugin) => {
          plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event) && (somePluginCanHandleRootDrop2 = !0);
        }), somePluginCanHandleRootDrop2;
      }, "canSomePluginHandleRootDrop"), doesEventHaveFiles = /* @__PURE__ */ __name(() => {
        const {
          types
        } = event.dataTransfer;
        return types.some((type) => type === "Files");
      }, "doesEventHaveFiles"), somePluginCanHandleRootDrop = canSomePluginHandleRootDrop(), hasFiles = doesEventHaveFiles();
      if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled || this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
        event.dataTransfer.dropEffect = "none", clearTimeout(this.removeDragOverClassTimeout);
        return;
      }
      event.dataTransfer.dropEffect = "copy", clearTimeout(this.removeDragOverClassTimeout), this.setPluginState({
        isDraggingOver: !0
      }), (_this$opts$onDragOver = (_this$opts = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
    }, this.handleDragLeave = (event) => {
      var _this$opts$onDragLeav, _this$opts2;
      event.preventDefault(), event.stopPropagation(), clearTimeout(this.removeDragOverClassTimeout), this.removeDragOverClassTimeout = setTimeout(() => {
        this.setPluginState({
          isDraggingOver: !1
        });
      }, 50), (_this$opts$onDragLeav = (_this$opts2 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
    }, this.handleDrop = async (event) => {
      var _this$opts$onDrop, _this$opts3;
      event.preventDefault(), event.stopPropagation(), clearTimeout(this.removeDragOverClassTimeout), this.setPluginState({
        isDraggingOver: !1
      }), this.uppy.iteratePlugins((plugin) => {
        plugin.type === "acquirer" && (plugin.handleRootDrop == null || plugin.handleRootDrop(event));
      });
      let executedDropErrorOnce = !1;
      const logDropError = /* @__PURE__ */ __name((error) => {
        this.uppy.log(error, "error"), executedDropErrorOnce || (this.uppy.info(error.message, "error"), executedDropErrorOnce = !0);
      }, "logDropError");
      this.uppy.log("[Dashboard] Processing dropped files");
      const files = await getDroppedFiles(event.dataTransfer, {
        logDropError
      });
      files.length > 0 && (this.uppy.log("[Dashboard] Files dropped"), this.addFiles(files)), (_this$opts$onDrop = (_this$opts3 = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
    }, this.handleRequestThumbnail = (file) => {
      this.opts.waitForThumbnailsBeforeUpload || this.uppy.emit("thumbnail:request", file);
    }, this.handleCancelThumbnail = (file) => {
      this.opts.waitForThumbnailsBeforeUpload || this.uppy.emit("thumbnail:cancel", file);
    }, this.handleKeyDownInInline = (event) => {
      event.keyCode === TAB_KEY && forInline(event, this.getPluginState().activeOverlayType, this.el);
    }, this.handlePasteOnBody = (event) => {
      this.el.contains(document.activeElement) && this.handlePaste(event);
    }, this.handleComplete = (_ref) => {
      let {
        failed
      } = _ref;
      this.opts.closeAfterFinish && failed.length === 0 && this.requestCloseModal();
    }, this.handleCancelRestore = () => {
      this.uppy.emit("restore-canceled");
    }, Object.defineProperty(this, _generateLargeThumbnailIfSingleFile, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        if (this.opts.disableThumbnailGenerator)
          return;
        const LARGE_THUMBNAIL = 600, files = this.uppy.getFiles();
        if (files.length === 1) {
          const thumbnailGenerator = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
          thumbnailGenerator == null || thumbnailGenerator.setOptions({
            thumbnailWidth: LARGE_THUMBNAIL
          });
          const fileForThumbnail = {
            ...files[0],
            preview: void 0
          };
          thumbnailGenerator.requestThumbnail(fileForThumbnail).then(() => {
            thumbnailGenerator == null || thumbnailGenerator.setOptions({
              thumbnailWidth: this.opts.thumbnailWidth
            });
          });
        }
      }, "value")
    }), Object.defineProperty(this, _openFileEditorWhenFilesAdded, {
      writable: !0,
      value: /* @__PURE__ */ __name((files) => {
        const firstFile = files[0];
        this.canEditFile(firstFile) && this.openFileEditor(firstFile);
      }, "value")
    }), this.initEvents = () => {
      if (this.opts.trigger && !this.opts.inline) {
        const showModalTrigger = findAllDOMElements(this.opts.trigger);
        showModalTrigger ? showModalTrigger.forEach((trigger) => trigger.addEventListener("click", this.openModal)) : this.uppy.log("Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself", "warning");
      }
      this.startListeningToResize(), document.addEventListener("paste", this.handlePasteOnBody), this.uppy.on("plugin-remove", this.removeTarget), this.uppy.on("file-added", this.hideAllPanels), this.uppy.on("dashboard:modal-closed", this.hideAllPanels), this.uppy.on("file-editor:complete", this.hideAllPanels), this.uppy.on("complete", this.handleComplete), this.uppy.on("files-added", _classPrivateFieldLooseBase$j(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]), this.uppy.on("file-removed", _classPrivateFieldLooseBase$j(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]), document.addEventListener("focus", this.recordIfFocusedOnUppyRecently, !0), document.addEventListener("click", this.recordIfFocusedOnUppyRecently, !0), this.opts.inline && this.el.addEventListener("keydown", this.handleKeyDownInInline), this.opts.autoOpenFileEditor && this.uppy.on("files-added", _classPrivateFieldLooseBase$j(this, _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
    }, this.removeEvents = () => {
      const showModalTrigger = findAllDOMElements(this.opts.trigger);
      !this.opts.inline && showModalTrigger && showModalTrigger.forEach((trigger) => trigger.removeEventListener("click", this.openModal)), this.stopListeningToResize(), document.removeEventListener("paste", this.handlePasteOnBody), window.removeEventListener("popstate", this.handlePopState, !1), this.uppy.off("plugin-remove", this.removeTarget), this.uppy.off("file-added", this.hideAllPanels), this.uppy.off("dashboard:modal-closed", this.hideAllPanels), this.uppy.off("file-editor:complete", this.hideAllPanels), this.uppy.off("complete", this.handleComplete), this.uppy.off("files-added", _classPrivateFieldLooseBase$j(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]), this.uppy.off("file-removed", _classPrivateFieldLooseBase$j(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]), document.removeEventListener("focus", this.recordIfFocusedOnUppyRecently), document.removeEventListener("click", this.recordIfFocusedOnUppyRecently), this.opts.inline && this.el.removeEventListener("keydown", this.handleKeyDownInInline), this.opts.autoOpenFileEditor && this.uppy.off("files-added", _classPrivateFieldLooseBase$j(this, _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
    }, this.superFocusOnEachUpdate = () => {
      const isFocusInUppy = this.el.contains(document.activeElement), isFocusNowhere = document.activeElement === document.body || document.activeElement === null, isInformerHidden = this.uppy.getState().info.length === 0, isModal = !this.opts.inline;
      // If update is connected to showing the Informer - let the screen reader calmly read it.
      isInformerHidden && // If we are in a modal - always superfocus without concern for other elements
      // on the page (user is unlikely to want to interact with the rest of the page)
      (isModal || isFocusInUppy || isFocusNowhere && this.ifFocusedOnUppyRecently) ? this.superFocus(this.el, this.getPluginState().activeOverlayType) : this.superFocus.cancel();
    }, this.afterUpdate = () => {
      if (this.opts.disabled && !this.dashboardIsDisabled) {
        this.disableInteractiveElements(!0);
        return;
      }
      !this.opts.disabled && this.dashboardIsDisabled && this.disableInteractiveElements(!1), this.superFocusOnEachUpdate();
    }, this.saveFileCard = (meta, fileID) => {
      this.uppy.setFileMeta(fileID, meta), this.toggleFileCard(!1, fileID);
    }, Object.defineProperty(this, _attachRenderFunctionToTarget, {
      writable: !0,
      value: /* @__PURE__ */ __name((target) => {
        const plugin = this.uppy.getPlugin(target.id);
        return {
          ...target,
          icon: plugin.icon || this.opts.defaultPickerIcon,
          render: plugin.render
        };
      }, "value")
    }), Object.defineProperty(this, _isTargetSupported, {
      writable: !0,
      value: /* @__PURE__ */ __name((target) => {
        const plugin = this.uppy.getPlugin(target.id);
        return typeof plugin.isSupported != "function" ? !0 : plugin.isSupported();
      }, "value")
    }), Object.defineProperty(this, _getAcquirers, {
      writable: !0,
      value: memoize((targets) => targets.filter((target) => target.type === "acquirer" && _classPrivateFieldLooseBase$j(this, _isTargetSupported)[_isTargetSupported](target)).map(_classPrivateFieldLooseBase$j(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]))
    }), Object.defineProperty(this, _getProgressIndicators, {
      writable: !0,
      value: memoize((targets) => targets.filter((target) => target.type === "progressindicator").map(_classPrivateFieldLooseBase$j(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]))
    }), Object.defineProperty(this, _getEditors, {
      writable: !0,
      value: memoize((targets) => targets.filter((target) => target.type === "editor").map(_classPrivateFieldLooseBase$j(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]))
    }), this.render = (state) => {
      const pluginState = this.getPluginState(), {
        files,
        capabilities,
        allowNewUpload
      } = state, {
        newFiles,
        uploadStartedFiles,
        completeFiles,
        erroredFiles,
        inProgressFiles,
        inProgressNotPausedFiles,
        processingFiles,
        isUploadStarted,
        isAllComplete,
        isAllErrored,
        isAllPaused
      } = this.uppy.getObjectOfFilesPerState(), acquirers = _classPrivateFieldLooseBase$j(this, _getAcquirers)[_getAcquirers](pluginState.targets), progressindicators = _classPrivateFieldLooseBase$j(this, _getProgressIndicators)[_getProgressIndicators](pluginState.targets), editors = _classPrivateFieldLooseBase$j(this, _getEditors)[_getEditors](pluginState.targets);
      let theme;
      return this.opts.theme === "auto" ? theme = capabilities.darkMode ? "dark" : "light" : theme = this.opts.theme, ["files", "folders", "both"].indexOf(this.opts.fileManagerSelectionType) < 0 && (this.opts.fileManagerSelectionType = "files", console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`)), Dashboard$1({
        state,
        isHidden: pluginState.isHidden,
        files,
        newFiles,
        uploadStartedFiles,
        completeFiles,
        erroredFiles,
        inProgressFiles,
        inProgressNotPausedFiles,
        processingFiles,
        isUploadStarted,
        isAllComplete,
        isAllErrored,
        isAllPaused,
        totalFileCount: Object.keys(files).length,
        totalProgress: state.totalProgress,
        allowNewUpload,
        acquirers,
        theme,
        disabled: this.opts.disabled,
        disableLocalFiles: this.opts.disableLocalFiles,
        direction: this.opts.direction,
        activePickerPanel: pluginState.activePickerPanel,
        showFileEditor: pluginState.showFileEditor,
        saveFileEditor: this.saveFileEditor,
        disableInteractiveElements: this.disableInteractiveElements,
        animateOpenClose: this.opts.animateOpenClose,
        isClosing: pluginState.isClosing,
        progressindicators,
        editors,
        autoProceed: this.uppy.opts.autoProceed,
        id: this.id,
        closeModal: this.requestCloseModal,
        handleClickOutside: this.handleClickOutside,
        handleInputChange: this.handleInputChange,
        handlePaste: this.handlePaste,
        inline: this.opts.inline,
        showPanel: this.showPanel,
        hideAllPanels: this.hideAllPanels,
        i18n: this.i18n,
        i18nArray: this.i18nArray,
        uppy: this.uppy,
        note: this.opts.note,
        recoveredState: state.recoveredState,
        metaFields: pluginState.metaFields,
        resumableUploads: capabilities.resumableUploads || !1,
        individualCancellation: capabilities.individualCancellation,
        isMobileDevice: capabilities.isMobileDevice,
        fileCardFor: pluginState.fileCardFor,
        toggleFileCard: this.toggleFileCard,
        toggleAddFilesPanel: this.toggleAddFilesPanel,
        showAddFilesPanel: pluginState.showAddFilesPanel,
        saveFileCard: this.saveFileCard,
        openFileEditor: this.openFileEditor,
        canEditFile: this.canEditFile,
        width: this.opts.width,
        height: this.opts.height,
        showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
        fileManagerSelectionType: this.opts.fileManagerSelectionType,
        proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
        hideCancelButton: this.opts.hideCancelButton,
        hideRetryButton: this.opts.hideRetryButton,
        hidePauseResumeButton: this.opts.hidePauseResumeButton,
        showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
        containerWidth: pluginState.containerWidth,
        containerHeight: pluginState.containerHeight,
        areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
        isTargetDOMEl: this.isTargetDOMEl,
        parentElement: this.el,
        allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
        maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
        requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
        showSelectedFiles: this.opts.showSelectedFiles,
        showNativePhotoCameraButton: this.opts.showNativePhotoCameraButton,
        showNativeVideoCameraButton: this.opts.showNativeVideoCameraButton,
        nativeCameraFacingMode: this.opts.nativeCameraFacingMode,
        singleFileFullScreen: this.opts.singleFileFullScreen,
        handleCancelRestore: this.handleCancelRestore,
        handleRequestThumbnail: this.handleRequestThumbnail,
        handleCancelThumbnail: this.handleCancelThumbnail,
        // drag props
        isDraggingOver: pluginState.isDraggingOver,
        handleDragOver: this.handleDragOver,
        handleDragLeave: this.handleDragLeave,
        handleDrop: this.handleDrop
      });
    }, this.discoverProviderPlugins = () => {
      this.uppy.iteratePlugins((plugin) => {
        plugin && !plugin.target && plugin.opts && plugin.opts.target === this.constructor && this.addTarget(plugin);
      });
    }, this.install = () => {
      this.setPluginState({
        isHidden: !0,
        fileCardFor: null,
        activeOverlayType: null,
        showAddFilesPanel: !1,
        activePickerPanel: !1,
        showFileEditor: !1,
        metaFields: this.opts.metaFields,
        targets: [],
        // We'll make them visible once .containerWidth is determined
        areInsidesReadyToBeVisible: !1,
        isDraggingOver: !1
      });
      const {
        inline,
        closeAfterFinish
      } = this.opts;
      if (inline && closeAfterFinish)
        throw new Error("[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.");
      const {
        allowMultipleUploads,
        allowMultipleUploadBatches
      } = this.uppy.opts;
      (allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish && this.uppy.log("[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true", "warning");
      const {
        target
      } = this.opts;
      target && this.mount(target, this), (this.opts.plugins || []).forEach((pluginID) => {
        const plugin = this.uppy.getPlugin(pluginID);
        plugin && plugin.mount(this, plugin);
      }), this.opts.disableStatusBar || this.uppy.use(StatusBar, {
        id: `${this.id}:StatusBar`,
        target: this,
        hideUploadButton: this.opts.hideUploadButton,
        hideRetryButton: this.opts.hideRetryButton,
        hidePauseResumeButton: this.opts.hidePauseResumeButton,
        hideCancelButton: this.opts.hideCancelButton,
        showProgressDetails: this.opts.showProgressDetails,
        hideAfterFinish: this.opts.hideProgressAfterFinish,
        locale: this.opts.locale,
        doneButtonHandler: this.opts.doneButtonHandler
      }), this.opts.disableInformer || this.uppy.use(Informer, {
        id: `${this.id}:Informer`,
        target: this
      }), this.opts.disableThumbnailGenerator || this.uppy.use(ThumbnailGenerator, {
        id: `${this.id}:ThumbnailGenerator`,
        thumbnailWidth: this.opts.thumbnailWidth,
        thumbnailHeight: this.opts.thumbnailHeight,
        thumbnailType: this.opts.thumbnailType,
        waitForThumbnailsBeforeUpload: this.opts.waitForThumbnailsBeforeUpload,
        // If we don't block on thumbnails, we can lazily generate them
        lazy: !this.opts.waitForThumbnailsBeforeUpload
      }), this.darkModeMediaQuery = typeof window < "u" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
      const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : !1;
      this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? "on" : "off"}`), this.setDarkModeCapability(isDarkModeOnFromTheStart), this.opts.theme === "auto" && this.darkModeMediaQuery.addListener(this.handleSystemDarkModeChange), this.discoverProviderPlugins(), this.initEvents();
    }, this.uninstall = () => {
      if (!this.opts.disableInformer) {
        const informer = this.uppy.getPlugin(`${this.id}:Informer`);
        informer && this.uppy.removePlugin(informer);
      }
      if (!this.opts.disableStatusBar) {
        const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
        statusBar && this.uppy.removePlugin(statusBar);
      }
      if (!this.opts.disableThumbnailGenerator) {
        const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
        thumbnail && this.uppy.removePlugin(thumbnail);
      }
      (this.opts.plugins || []).forEach((pluginID) => {
        const plugin = this.uppy.getPlugin(pluginID);
        plugin && plugin.unmount();
      }), this.opts.theme === "auto" && this.darkModeMediaQuery.removeListener(this.handleSystemDarkModeChange), this.unmount(), this.removeEvents();
    }, this.id = this.opts.id || "Dashboard", this.title = "Dashboard", this.type = "orchestrator", this.modalName = `uppy-Dashboard-${nanoid()}`, this.defaultLocale = locale$h;
    const defaultOptions2 = {
      target: "body",
      metaFields: [],
      trigger: null,
      inline: !1,
      width: 750,
      height: 550,
      thumbnailWidth: 280,
      thumbnailType: "image/jpeg",
      waitForThumbnailsBeforeUpload: !1,
      defaultPickerIcon,
      showLinkToFileUploadResult: !1,
      showProgressDetails: !1,
      hideUploadButton: !1,
      hideCancelButton: !1,
      hideRetryButton: !1,
      hidePauseResumeButton: !1,
      hideProgressAfterFinish: !1,
      doneButtonHandler: /* @__PURE__ */ __name(() => {
        this.uppy.cancelAll(), this.requestCloseModal();
      }, "doneButtonHandler"),
      note: null,
      closeModalOnClickOutside: !1,
      closeAfterFinish: !1,
      singleFileFullScreen: !0,
      disableStatusBar: !1,
      disableInformer: !1,
      disableThumbnailGenerator: !1,
      disablePageScrollWhenModalOpen: !0,
      animateOpenClose: !0,
      fileManagerSelectionType: "files",
      proudlyDisplayPoweredByUppy: !0,
      onRequestCloseModal: /* @__PURE__ */ __name(() => this.closeModal(), "onRequestCloseModal"),
      showSelectedFiles: !0,
      showRemoveButtonAfterComplete: !1,
      browserBackButtonClose: !1,
      showNativePhotoCameraButton: !1,
      showNativeVideoCameraButton: !1,
      theme: "light",
      autoOpenFileEditor: !1,
      disabled: !1,
      disableLocalFiles: !1
    };
    this.opts = {
      ...defaultOptions2,
      ..._opts
    }, this.i18nInit(), this.superFocus = createSuperFocus(), this.ifFocusedOnUppyRecently = !1, this.makeDashboardInsidesVisibleAnywayTimeout = null, this.removeDragOverClassTimeout = null;
  }
};
__name(_Dashboard, "Dashboard");
let Dashboard = _Dashboard;
Dashboard.VERSION = packageJson$q.version;
const locale$g = {
  strings: {
    // Text to show on the droppable area.
    // `%{browse}` is replaced with a link that opens the system file selection dialog.
    dropHereOr: "Drop here or %{browse}",
    // Used as the label for the link that opens the system file selection dialog.
    browse: "browse"
  }
}, packageJson$p = {
  version: "3.0.3"
}, _DragDrop = class _DragDrop extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.handleDrop = async (event) => {
      var _this$opts$onDrop, _this$opts;
      event.preventDefault(), event.stopPropagation(), clearTimeout(this.removeDragOverClassTimeout), this.setPluginState({
        isDraggingOver: !1
      });
      const logDropError = /* @__PURE__ */ __name((error) => {
        this.uppy.log(error, "error");
      }, "logDropError"), files = await getDroppedFiles(event.dataTransfer, {
        logDropError
      });
      files.length > 0 && (this.uppy.log("[DragDrop] Files dropped"), this.addFiles(files)), (_this$opts$onDrop = (_this$opts = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts, event);
    }, this.type = "acquirer", this.id = this.opts.id || "DragDrop", this.title = "Drag & Drop", this.defaultLocale = locale$g;
    const defaultOpts = {
      target: null,
      inputName: "files[]",
      width: "100%",
      height: "100%",
      note: null
    };
    this.opts = {
      ...defaultOpts,
      ...opts
    }, this.i18nInit(), this.isDragDropSupported = isDragDropSupported(), this.removeDragOverClassTimeout = null, this.onInputChange = this.onInputChange.bind(this), this.handleDragOver = this.handleDragOver.bind(this), this.handleDragLeave = this.handleDragLeave.bind(this), this.handleDrop = this.handleDrop.bind(this), this.addFiles = this.addFiles.bind(this), this.render = this.render.bind(this);
  }
  addFiles(files) {
    const descriptors2 = files.map((file) => ({
      source: this.id,
      name: file.name,
      type: file.type,
      data: file,
      meta: {
        // path of the file relative to the ancestor directory the user selected.
        // e.g. 'docs/Old Prague/airbnb.pdf'
        relativePath: file.relativePath || null
      }
    }));
    try {
      this.uppy.addFiles(descriptors2);
    } catch (err) {
      this.uppy.log(err);
    }
  }
  onInputChange(event) {
    const files = toArray$3(event.target.files);
    files.length > 0 && (this.uppy.log("[DragDrop] Files selected through input"), this.addFiles(files)), event.target.value = null;
  }
  handleDragOver(event) {
    var _this$opts$onDragOver, _this$opts2;
    event.preventDefault(), event.stopPropagation();
    const {
      types
    } = event.dataTransfer, hasFiles = types.some((type) => type === "Files"), {
      allowNewUpload
    } = this.uppy.getState();
    if (!hasFiles || !allowNewUpload) {
      event.dataTransfer.dropEffect = "none", clearTimeout(this.removeDragOverClassTimeout);
      return;
    }
    event.dataTransfer.dropEffect = "copy", clearTimeout(this.removeDragOverClassTimeout), this.setPluginState({
      isDraggingOver: !0
    }), (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts2, event);
  }
  handleDragLeave(event) {
    var _this$opts$onDragLeav, _this$opts3;
    event.preventDefault(), event.stopPropagation(), clearTimeout(this.removeDragOverClassTimeout), this.removeDragOverClassTimeout = setTimeout(() => {
      this.setPluginState({
        isDraggingOver: !1
      });
    }, 50), (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts3, event);
  }
  renderHiddenFileInput() {
    const {
      restrictions
    } = this.uppy.opts;
    return y$1("input", {
      className: "uppy-DragDrop-input",
      type: "file",
      hidden: !0,
      ref: /* @__PURE__ */ __name((ref) => {
        this.fileInputRef = ref;
      }, "ref"),
      name: this.opts.inputName,
      multiple: restrictions.maxNumberOfFiles !== 1,
      accept: restrictions.allowedFileTypes,
      onChange: this.onInputChange
    });
  }
  static renderArrowSvg() {
    return y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon uppy-DragDrop-arrow",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16"
    }, y$1("path", {
      d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0",
      fillRule: "evenodd"
    }));
  }
  renderLabel() {
    return y$1("div", {
      className: "uppy-DragDrop-label"
    }, this.i18nArray("dropHereOr", {
      browse: y$1("span", {
        className: "uppy-DragDrop-browse"
      }, this.i18n("browse"))
    }));
  }
  renderNote() {
    return y$1("span", {
      className: "uppy-DragDrop-note"
    }, this.opts.note);
  }
  render() {
    const dragDropClass = `uppy-u-reset
      uppy-DragDrop-container
      ${this.isDragDropSupported ? "uppy-DragDrop--isDragDropSupported" : ""}
      ${this.getPluginState().isDraggingOver ? "uppy-DragDrop--isDraggingOver" : ""}
    `, dragDropStyle = {
      width: this.opts.width,
      height: this.opts.height
    };
    return y$1("button", {
      type: "button",
      className: dragDropClass,
      style: dragDropStyle,
      onClick: /* @__PURE__ */ __name(() => this.fileInputRef.click(), "onClick"),
      onDragOver: this.handleDragOver,
      onDragLeave: this.handleDragLeave,
      onDrop: this.handleDrop
    }, this.renderHiddenFileInput(), y$1("div", {
      className: "uppy-DragDrop-inner"
    }, _DragDrop.renderArrowSvg(), this.renderLabel(), this.renderNote()));
  }
  install() {
    const {
      target
    } = this.opts;
    this.setPluginState({
      isDraggingOver: !1
    }), target && this.mount(target, this);
  }
  uninstall() {
    this.unmount();
  }
};
__name(_DragDrop, "DragDrop");
let DragDrop = _DragDrop;
DragDrop.VERSION = packageJson$p.version;
const packageJson$o = {
  version: "2.0.1"
};
function isFileTransfer(event) {
  var _event$dataTransfer$t, _event$dataTransfer$t2;
  return (_event$dataTransfer$t = (_event$dataTransfer$t2 = event.dataTransfer.types) == null ? void 0 : _event$dataTransfer$t2.some((type) => type === "Files")) != null ? _event$dataTransfer$t : !1;
}
__name(isFileTransfer, "isFileTransfer");
const _DropTarget = class _DropTarget extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.addFiles = (files) => {
      const descriptors2 = files.map((file) => ({
        source: this.id,
        name: file.name,
        type: file.type,
        data: file,
        meta: {
          // path of the file relative to the ancestor directory the user selected.
          // e.g. 'docs/Old Prague/airbnb.pdf'
          relativePath: file.relativePath || null
        }
      }));
      try {
        this.uppy.addFiles(descriptors2);
      } catch (err) {
        this.uppy.log(err);
      }
    }, this.handleDrop = async (event) => {
      var _this$opts$onDrop, _this$opts;
      if (!isFileTransfer(event))
        return;
      event.preventDefault(), event.stopPropagation(), clearTimeout(this.removeDragOverClassTimeout), event.currentTarget.classList.remove("uppy-is-drag-over"), this.setPluginState({
        isDraggingOver: !1
      }), this.uppy.iteratePlugins((plugin) => {
        plugin.type === "acquirer" && (plugin.handleRootDrop == null || plugin.handleRootDrop(event));
      });
      let executedDropErrorOnce = !1;
      const logDropError = /* @__PURE__ */ __name((error) => {
        this.uppy.log(error, "error"), executedDropErrorOnce || (this.uppy.info(error.message, "error"), executedDropErrorOnce = !0);
      }, "logDropError"), files = await getDroppedFiles(event.dataTransfer, {
        logDropError
      });
      files.length > 0 && (this.uppy.log("[DropTarget] Files were dropped"), this.addFiles(files)), (_this$opts$onDrop = (_this$opts = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts, event);
    }, this.handleDragOver = (event) => {
      var _this$opts$onDragOver, _this$opts2;
      isFileTransfer(event) && (event.preventDefault(), event.stopPropagation(), event.dataTransfer.dropEffect = "copy", clearTimeout(this.removeDragOverClassTimeout), event.currentTarget.classList.add("uppy-is-drag-over"), this.setPluginState({
        isDraggingOver: !0
      }), (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts2, event));
    }, this.handleDragLeave = (event) => {
      var _this$opts$onDragLeav, _this$opts3;
      if (!isFileTransfer(event))
        return;
      event.preventDefault(), event.stopPropagation();
      const {
        currentTarget
      } = event;
      clearTimeout(this.removeDragOverClassTimeout), this.removeDragOverClassTimeout = setTimeout(() => {
        currentTarget.classList.remove("uppy-is-drag-over"), this.setPluginState({
          isDraggingOver: !1
        });
      }, 50), (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts3, event);
    }, this.addListeners = () => {
      const {
        target
      } = this.opts;
      if (target instanceof Element ? this.nodes = [target] : typeof target == "string" && (this.nodes = toArray$3(document.querySelectorAll(target))), !this.nodes && !this.nodes.length > 0)
        throw new Error(`"${target}" does not match any HTML elements`);
      this.nodes.forEach((node) => {
        node.addEventListener("dragover", this.handleDragOver, !1), node.addEventListener("dragleave", this.handleDragLeave, !1), node.addEventListener("drop", this.handleDrop, !1);
      });
    }, this.removeListeners = () => {
      this.nodes && this.nodes.forEach((node) => {
        node.removeEventListener("dragover", this.handleDragOver, !1), node.removeEventListener("dragleave", this.handleDragLeave, !1), node.removeEventListener("drop", this.handleDrop, !1);
      });
    }, this.type = "acquirer", this.id = this.opts.id || "DropTarget", this.title = "Drop Target";
    const defaultOpts = {
      target: null
    };
    this.opts = {
      ...defaultOpts,
      ...opts
    }, this.removeDragOverClassTimeout = null;
  }
  install() {
    this.setPluginState({
      isDraggingOver: !1
    }), this.addListeners();
  }
  uninstall() {
    this.removeListeners();
  }
};
__name(_DropTarget, "DropTarget");
let DropTarget = _DropTarget;
DropTarget.VERSION = packageJson$o.version;
const locale$f = {
  strings: {
    chooseFiles: "Choose files"
  }
}, packageJson$n = {
  version: "3.0.3"
}, _FileInput = class _FileInput extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "FileInput", this.title = "File Input", this.type = "acquirer", this.defaultLocale = locale$f;
    const defaultOptions2 = {
      target: null,
      pretty: !0,
      inputName: "files[]"
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.i18nInit(), this.render = this.render.bind(this), this.handleInputChange = this.handleInputChange.bind(this), this.handleClick = this.handleClick.bind(this);
  }
  addFiles(files) {
    const descriptors2 = files.map((file) => ({
      source: this.id,
      name: file.name,
      type: file.type,
      data: file
    }));
    try {
      this.uppy.addFiles(descriptors2);
    } catch (err) {
      this.uppy.log(err);
    }
  }
  handleInputChange(event) {
    this.uppy.log("[FileInput] Something selected through input...");
    const files = toArray$3(event.target.files);
    this.addFiles(files), event.target.value = null;
  }
  handleClick() {
    this.input.click();
  }
  render() {
    const hiddenInputStyle = {
      width: "0.1px",
      height: "0.1px",
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      zIndex: -1
    }, {
      restrictions
    } = this.uppy.opts, accept = restrictions.allowedFileTypes ? restrictions.allowedFileTypes.join(",") : null;
    return y$1("div", {
      className: "uppy-FileInput-container"
    }, y$1("input", {
      className: "uppy-FileInput-input",
      style: this.opts.pretty && hiddenInputStyle,
      type: "file",
      name: this.opts.inputName,
      onChange: this.handleInputChange,
      multiple: restrictions.maxNumberOfFiles !== 1,
      accept,
      ref: /* @__PURE__ */ __name((input) => {
        this.input = input;
      }, "ref")
    }), this.opts.pretty && y$1("button", {
      className: "uppy-FileInput-btn",
      type: "button",
      onClick: this.handleClick
    }, this.i18n("chooseFiles")));
  }
  install() {
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.unmount();
  }
};
__name(_FileInput, "FileInput");
let FileInput = _FileInput;
FileInput.VERSION = packageJson$n.version;
/*!
 * Cropper.js v1.5.7
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2020-05-23T05:23:00.081Z
 */
function _typeof$9(obj) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$9 = /* @__PURE__ */ __name(function(obj2) {
    return typeof obj2;
  }, "_typeof$9") : _typeof$9 = /* @__PURE__ */ __name(function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, "_typeof$9"), _typeof$9(obj);
}
__name(_typeof$9, "_typeof$9");
function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$9, "_classCallCheck$9");
function _defineProperties$8(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$8, "_defineProperties$8");
function _createClass$9(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$8(Constructor.prototype, protoProps), staticProps && _defineProperties$8(Constructor, staticProps), Constructor;
}
__name(_createClass$9, "_createClass$9");
function _defineProperty$2(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}
__name(_defineProperty$2, "_defineProperty$2");
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
__name(ownKeys$2, "ownKeys$2");
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread2, "_objectSpread2");
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _iterableToArray(iter) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
__name(_iterableToArray, "_iterableToArray");
function _unsupportedIterableToArray$1(o2, minLen) {
  if (o2) {
    if (typeof o2 == "string") return _arrayLikeToArray$1(o2, minLen);
    var n2 = Object.prototype.toString.call(o2).slice(8, -1);
    if (n2 === "Object" && o2.constructor && (n2 = o2.constructor.name), n2 === "Map" || n2 === "Set") return Array.from(o2);
    if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o2, minLen);
  }
}
__name(_unsupportedIterableToArray$1, "_unsupportedIterableToArray$1");
function _arrayLikeToArray$1(arr, len2) {
  (len2 == null || len2 > arr.length) && (len2 = arr.length);
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++) arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$1, "_arrayLikeToArray$1");
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread, "_nonIterableSpread");
var IS_BROWSER = typeof window < "u" && typeof window.document < "u", WINDOW = IS_BROWSER ? window : {}, IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? "ontouchstart" in WINDOW.document.documentElement : !1, HAS_POINTER_EVENT = IS_BROWSER ? "PointerEvent" in WINDOW : !1, NAMESPACE = "cropper", ACTION_ALL = "all", ACTION_CROP = "crop", ACTION_MOVE = "move", ACTION_ZOOM = "zoom", ACTION_EAST = "e", ACTION_WEST = "w", ACTION_SOUTH = "s", ACTION_NORTH = "n", ACTION_NORTH_EAST = "ne", ACTION_NORTH_WEST = "nw", ACTION_SOUTH_EAST = "se", ACTION_SOUTH_WEST = "sw", CLASS_CROP = "".concat(NAMESPACE, "-crop"), CLASS_DISABLED = "".concat(NAMESPACE, "-disabled"), CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden"), CLASS_HIDE = "".concat(NAMESPACE, "-hide"), CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible"), CLASS_MODAL = "".concat(NAMESPACE, "-modal"), CLASS_MOVE = "".concat(NAMESPACE, "-move"), DATA_ACTION = "".concat(NAMESPACE, "Action"), DATA_PREVIEW = "".concat(NAMESPACE, "Preview"), DRAG_MODE_CROP = "crop", DRAG_MODE_MOVE = "move", DRAG_MODE_NONE = "none", EVENT_CROP = "crop", EVENT_CROP_END = "cropend", EVENT_CROP_MOVE = "cropmove", EVENT_CROP_START = "cropstart", EVENT_DBLCLICK = "dblclick", EVENT_TOUCH_START = IS_TOUCH_DEVICE ? "touchstart" : "mousedown", EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? "touchmove" : "mousemove", EVENT_TOUCH_END = IS_TOUCH_DEVICE ? "touchend touchcancel" : "mouseup", EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? "pointerdown" : EVENT_TOUCH_START, EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? "pointermove" : EVENT_TOUCH_MOVE, EVENT_POINTER_UP = HAS_POINTER_EVENT ? "pointerup pointercancel" : EVENT_TOUCH_END, EVENT_READY = "ready", EVENT_RESIZE = "resize", EVENT_WHEEL = "wheel", EVENT_ZOOM = "zoom", MIME_TYPE_JPEG = "image/jpeg", REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, REGEXP_DATA_URL = /^data:/, REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/, REGEXP_TAG_NAME = /^img|canvas$/i, DEFAULTS = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: DRAG_MODE_CROP,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: 200,
  minContainerHeight: 100,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, TEMPLATE = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', isNaN$1 = Number.isNaN || WINDOW.isNaN;
function isNumber$1(value) {
  return typeof value == "number" && !isNaN$1(value);
}
__name(isNumber$1, "isNumber$1");
var isPositiveNumber = /* @__PURE__ */ __name(function(value) {
  return value > 0 && value < 1 / 0;
}, "isPositiveNumber");
function isUndefined$1(value) {
  return typeof value > "u";
}
__name(isUndefined$1, "isUndefined$1");
function isObject$2(value) {
  return _typeof$9(value) === "object" && value !== null;
}
__name(isObject$2, "isObject$2");
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function isPlainObject$1(value) {
  if (!isObject$2(value))
    return !1;
  try {
    var _constructor = value.constructor, prototype2 = _constructor.prototype;
    return _constructor && prototype2 && hasOwnProperty$2.call(prototype2, "isPrototypeOf");
  } catch {
    return !1;
  }
}
__name(isPlainObject$1, "isPlainObject$1");
function isFunction$2(value) {
  return typeof value == "function";
}
__name(isFunction$2, "isFunction$2");
var slice$1 = Array.prototype.slice;
function toArray$2(value) {
  return Array.from ? Array.from(value) : slice$1.call(value);
}
__name(toArray$2, "toArray$2");
function forEach$1(data, callback) {
  return data && isFunction$2(callback) && (Array.isArray(data) || isNumber$1(data.length) ? toArray$2(data).forEach(function(value, key) {
    callback.call(data, value, key, data);
  }) : isObject$2(data) && Object.keys(data).forEach(function(key) {
    callback.call(data, data[key], key, data);
  })), data;
}
__name(forEach$1, "forEach$1");
var assign$1 = Object.assign || /* @__PURE__ */ __name(function(target) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)
    args[_key - 1] = arguments[_key];
  return isObject$2(target) && args.length > 0 && args.forEach(function(arg) {
    isObject$2(arg) && Object.keys(arg).forEach(function(key) {
      target[key] = arg[key];
    });
  }), target;
}, "assign"), REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
function normalizeDecimalNumber(value) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
}
__name(normalizeDecimalNumber, "normalizeDecimalNumber");
var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
function setStyle(element, styles) {
  var style = element.style;
  forEach$1(styles, function(value, property) {
    REGEXP_SUFFIX.test(property) && isNumber$1(value) && (value = "".concat(value, "px")), style[property] = value;
  });
}
__name(setStyle, "setStyle");
function hasClass(element, value) {
  return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
}
__name(hasClass, "hasClass");
function addClass(element, value) {
  if (value) {
    if (isNumber$1(element.length)) {
      forEach$1(element, function(elem) {
        addClass(elem, value);
      });
      return;
    }
    if (element.classList) {
      element.classList.add(value);
      return;
    }
    var className = element.className.trim();
    className ? className.indexOf(value) < 0 && (element.className = "".concat(className, " ").concat(value)) : element.className = value;
  }
}
__name(addClass, "addClass");
function removeClass(element, value) {
  if (value) {
    if (isNumber$1(element.length)) {
      forEach$1(element, function(elem) {
        removeClass(elem, value);
      });
      return;
    }
    if (element.classList) {
      element.classList.remove(value);
      return;
    }
    element.className.indexOf(value) >= 0 && (element.className = element.className.replace(value, ""));
  }
}
__name(removeClass, "removeClass");
function toggleClass(element, value, added) {
  if (value) {
    if (isNumber$1(element.length)) {
      forEach$1(element, function(elem) {
        toggleClass(elem, value, added);
      });
      return;
    }
    added ? addClass(element, value) : removeClass(element, value);
  }
}
__name(toggleClass, "toggleClass");
var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
function toParamCase(value) {
  return value.replace(REGEXP_CAMEL_CASE, "$1-$2").toLowerCase();
}
__name(toParamCase, "toParamCase");
function getData(element, name) {
  return isObject$2(element[name]) ? element[name] : element.dataset ? element.dataset[name] : element.getAttribute("data-".concat(toParamCase(name)));
}
__name(getData, "getData");
function setData(element, name, data) {
  isObject$2(data) ? element[name] = data : element.dataset ? element.dataset[name] = data : element.setAttribute("data-".concat(toParamCase(name)), data);
}
__name(setData, "setData");
function removeData(element, name) {
  if (isObject$2(element[name]))
    try {
      delete element[name];
    } catch {
      element[name] = void 0;
    }
  else if (element.dataset)
    try {
      delete element.dataset[name];
    } catch {
      element.dataset[name] = void 0;
    }
  else
    element.removeAttribute("data-".concat(toParamCase(name)));
}
__name(removeData, "removeData");
var REGEXP_SPACES = /\s\s*/, onceSupported = function() {
  var supported = !1;
  if (IS_BROWSER) {
    var once = !1, listener = /* @__PURE__ */ __name(function() {
    }, "listener"), options = Object.defineProperty({}, "once", {
      get: /* @__PURE__ */ __name(function() {
        return supported = !0, once;
      }, "get"),
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: /* @__PURE__ */ __name(function(value) {
        once = value;
      }, "set")
    });
    WINDOW.addEventListener("test", listener, options), WINDOW.removeEventListener("test", listener, options);
  }
  return supported;
}();
function removeListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function(event) {
    if (!onceSupported) {
      var listeners = element.listeners;
      listeners && listeners[event] && listeners[event][listener] && (handler = listeners[event][listener], delete listeners[event][listener], Object.keys(listeners[event]).length === 0 && delete listeners[event], Object.keys(listeners).length === 0 && delete element.listeners);
    }
    element.removeEventListener(event, handler, options);
  });
}
__name(removeListener, "removeListener");
function addListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function(event) {
    if (options.once && !onceSupported) {
      var _element$listeners = element.listeners, listeners = _element$listeners === void 0 ? {} : _element$listeners;
      _handler = /* @__PURE__ */ __name(function() {
        delete listeners[event][listener], element.removeEventListener(event, _handler, options);
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)
          args[_key2] = arguments[_key2];
        listener.apply(element, args);
      }, "handler"), listeners[event] || (listeners[event] = {}), listeners[event][listener] && element.removeEventListener(event, listeners[event][listener], options), listeners[event][listener] = _handler, element.listeners = listeners;
    }
    element.addEventListener(event, _handler, options);
  });
}
__name(addListener, "addListener");
function dispatchEvent(element, type, data) {
  var event;
  return isFunction$2(Event) && isFunction$2(CustomEvent) ? event = new CustomEvent(type, {
    detail: data,
    bubbles: !0,
    cancelable: !0
  }) : (event = document.createEvent("CustomEvent"), event.initCustomEvent(type, !0, !0, data)), element.dispatchEvent(event);
}
__name(dispatchEvent, "dispatchEvent");
function getOffset(element) {
  var box = element.getBoundingClientRect();
  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
__name(getOffset, "getOffset");
var location$1 = WINDOW.location, REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function isCrossOriginURL(url) {
  var parts = url.match(REGEXP_ORIGINS);
  return parts !== null && (parts[1] !== location$1.protocol || parts[2] !== location$1.hostname || parts[3] !== location$1.port);
}
__name(isCrossOriginURL, "isCrossOriginURL");
function addTimestamp(url) {
  var timestamp = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return url + (url.indexOf("?") === -1 ? "?" : "&") + timestamp;
}
__name(addTimestamp, "addTimestamp");
function getTransforms(_ref) {
  var rotate2 = _ref.rotate, scaleX2 = _ref.scaleX, scaleY2 = _ref.scaleY, translateX = _ref.translateX, translateY = _ref.translateY, values = [];
  isNumber$1(translateX) && translateX !== 0 && values.push("translateX(".concat(translateX, "px)")), isNumber$1(translateY) && translateY !== 0 && values.push("translateY(".concat(translateY, "px)")), isNumber$1(rotate2) && rotate2 !== 0 && values.push("rotate(".concat(rotate2, "deg)")), isNumber$1(scaleX2) && scaleX2 !== 1 && values.push("scaleX(".concat(scaleX2, ")")), isNumber$1(scaleY2) && scaleY2 !== 1 && values.push("scaleY(".concat(scaleY2, ")"));
  var transform = values.length ? values.join(" ") : "none";
  return {
    WebkitTransform: transform,
    msTransform: transform,
    transform
  };
}
__name(getTransforms, "getTransforms");
function getMaxZoomRatio(pointers) {
  var pointers2 = _objectSpread2({}, pointers), ratios = [];
  return forEach$1(pointers, function(pointer, pointerId) {
    delete pointers2[pointerId], forEach$1(pointers2, function(pointer2) {
      var x1 = Math.abs(pointer.startX - pointer2.startX), y1 = Math.abs(pointer.startY - pointer2.startY), x2 = Math.abs(pointer.endX - pointer2.endX), y2 = Math.abs(pointer.endY - pointer2.endY), z1 = Math.sqrt(x1 * x1 + y1 * y1), z2 = Math.sqrt(x2 * x2 + y2 * y2), ratio = (z2 - z1) / z1;
      ratios.push(ratio);
    });
  }), ratios.sort(function(a2, b2) {
    return Math.abs(a2) < Math.abs(b2);
  }), ratios[0];
}
__name(getMaxZoomRatio, "getMaxZoomRatio");
function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX, pageY = _ref2.pageY, end = {
    endX: pageX,
    endY: pageY
  };
  return endOnly ? end : _objectSpread2({
    startX: pageX,
    startY: pageY
  }, end);
}
__name(getPointer, "getPointer");
function getPointersCenter(pointers) {
  var pageX = 0, pageY = 0, count = 0;
  return forEach$1(pointers, function(_ref3) {
    var startX = _ref3.startX, startY = _ref3.startY;
    pageX += startX, pageY += startY, count += 1;
  }), pageX /= count, pageY /= count, {
    pageX,
    pageY
  };
}
__name(getPointersCenter, "getPointersCenter");
function getAdjustedSizes(_ref4) {
  var aspectRatio = _ref4.aspectRatio, height = _ref4.height, width = _ref4.width, type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", isValidWidth = isPositiveNumber(width), isValidHeight = isPositiveNumber(height);
  if (isValidWidth && isValidHeight) {
    var adjustedWidth = height * aspectRatio;
    type === "contain" && adjustedWidth > width || type === "cover" && adjustedWidth < width ? height = width / aspectRatio : width = height * aspectRatio;
  } else isValidWidth ? height = width / aspectRatio : isValidHeight && (width = height * aspectRatio);
  return {
    width,
    height
  };
}
__name(getAdjustedSizes, "getAdjustedSizes");
function getRotatedSizes(_ref5) {
  var width = _ref5.width, height = _ref5.height, degree = _ref5.degree;
  if (degree = Math.abs(degree) % 180, degree === 90)
    return {
      width: height,
      height: width
    };
  var arc = degree % 90 * Math.PI / 180, sinArc = Math.sin(arc), cosArc = Math.cos(arc), newWidth = width * cosArc + height * sinArc, newHeight = width * sinArc + height * cosArc;
  return degree > 90 ? {
    width: newHeight,
    height: newWidth
  } : {
    width: newWidth,
    height: newHeight
  };
}
__name(getRotatedSizes, "getRotatedSizes");
function getSourceCanvas(image, _ref6, _ref7, _ref8) {
  var imageAspectRatio = _ref6.aspectRatio, imageNaturalWidth = _ref6.naturalWidth, imageNaturalHeight = _ref6.naturalHeight, _ref6$rotate = _ref6.rotate, rotate2 = _ref6$rotate === void 0 ? 0 : _ref6$rotate, _ref6$scaleX = _ref6.scaleX, scaleX2 = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX, _ref6$scaleY = _ref6.scaleY, scaleY2 = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY, aspectRatio = _ref7.aspectRatio, naturalWidth = _ref7.naturalWidth, naturalHeight = _ref7.naturalHeight, _ref8$fillColor = _ref8.fillColor, fillColor = _ref8$fillColor === void 0 ? "transparent" : _ref8$fillColor, _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled, imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? !0 : _ref8$imageSmoothingE, _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality, imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? "low" : _ref8$imageSmoothingQ, _ref8$maxWidth = _ref8.maxWidth, maxWidth = _ref8$maxWidth === void 0 ? 1 / 0 : _ref8$maxWidth, _ref8$maxHeight = _ref8.maxHeight, maxHeight = _ref8$maxHeight === void 0 ? 1 / 0 : _ref8$maxHeight, _ref8$minWidth = _ref8.minWidth, minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth, _ref8$minHeight = _ref8.minHeight, minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight, canvas = document.createElement("canvas"), context = canvas.getContext("2d"), maxSizes = getAdjustedSizes({
    aspectRatio,
    width: maxWidth,
    height: maxHeight
  }), minSizes = getAdjustedSizes({
    aspectRatio,
    width: minWidth,
    height: minHeight
  }, "cover"), width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth)), height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)), destMaxSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: maxWidth,
    height: maxHeight
  }), destMinSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: minWidth,
    height: minHeight
  }, "cover"), destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth)), destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight)), params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
  return canvas.width = normalizeDecimalNumber(width), canvas.height = normalizeDecimalNumber(height), context.fillStyle = fillColor, context.fillRect(0, 0, width, height), context.save(), context.translate(width / 2, height / 2), context.rotate(rotate2 * Math.PI / 180), context.scale(scaleX2, scaleY2), context.imageSmoothingEnabled = imageSmoothingEnabled, context.imageSmoothingQuality = imageSmoothingQuality, context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function(param) {
    return Math.floor(normalizeDecimalNumber(param));
  })))), context.restore(), canvas;
}
__name(getSourceCanvas, "getSourceCanvas");
var fromCharCode = String.fromCharCode;
function getStringFromCharCode(dataView, start, length) {
  var str = "";
  length += start;
  for (var i2 = start; i2 < length; i2 += 1)
    str += fromCharCode(dataView.getUint8(i2));
  return str;
}
__name(getStringFromCharCode, "getStringFromCharCode");
var REGEXP_DATA_URL_HEAD = /^data:.*,/;
function dataURLToArrayBuffer(dataURL) {
  var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, ""), binary = atob(base64), arrayBuffer = new ArrayBuffer(binary.length), uint8 = new Uint8Array(arrayBuffer);
  return forEach$1(uint8, function(value, i2) {
    uint8[i2] = binary.charCodeAt(i2);
  }), arrayBuffer;
}
__name(dataURLToArrayBuffer, "dataURLToArrayBuffer");
function arrayBufferToDataURL(arrayBuffer, mimeType) {
  for (var chunks2 = [], chunkSize = 8192, uint8 = new Uint8Array(arrayBuffer); uint8.length > 0; )
    chunks2.push(fromCharCode.apply(null, toArray$2(uint8.subarray(0, chunkSize)))), uint8 = uint8.subarray(chunkSize);
  return "data:".concat(mimeType, ";base64,").concat(btoa(chunks2.join("")));
}
__name(arrayBufferToDataURL, "arrayBufferToDataURL");
function resetAndGetOrientation(arrayBuffer) {
  var dataView = new DataView(arrayBuffer), orientation;
  try {
    var littleEndian, app1Start, ifdStart;
    if (dataView.getUint8(0) === 255 && dataView.getUint8(1) === 216)
      for (var length = dataView.byteLength, offset = 2; offset + 1 < length; ) {
        if (dataView.getUint8(offset) === 255 && dataView.getUint8(offset + 1) === 225) {
          app1Start = offset;
          break;
        }
        offset += 1;
      }
    if (app1Start) {
      var exifIDCode = app1Start + 4, tiffOffset = app1Start + 10;
      if (getStringFromCharCode(dataView, exifIDCode, 4) === "Exif") {
        var endianness = dataView.getUint16(tiffOffset);
        if (littleEndian = endianness === 18761, (littleEndian || endianness === 19789) && dataView.getUint16(tiffOffset + 2, littleEndian) === 42) {
          var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
          firstIFDOffset >= 8 && (ifdStart = tiffOffset + firstIFDOffset);
        }
      }
    }
    if (ifdStart) {
      var _length = dataView.getUint16(ifdStart, littleEndian), _offset, i2;
      for (i2 = 0; i2 < _length; i2 += 1)
        if (_offset = ifdStart + i2 * 12 + 2, dataView.getUint16(_offset, littleEndian) === 274) {
          _offset += 8, orientation = dataView.getUint16(_offset, littleEndian), dataView.setUint16(_offset, 1, littleEndian);
          break;
        }
    }
  } catch {
    orientation = 1;
  }
  return orientation;
}
__name(resetAndGetOrientation, "resetAndGetOrientation");
function parseOrientation(orientation) {
  var rotate2 = 0, scaleX2 = 1, scaleY2 = 1;
  switch (orientation) {
    case 2:
      scaleX2 = -1;
      break;
    case 3:
      rotate2 = -180;
      break;
    case 4:
      scaleY2 = -1;
      break;
    case 5:
      rotate2 = 90, scaleY2 = -1;
      break;
    case 6:
      rotate2 = 90;
      break;
    case 7:
      rotate2 = 90, scaleX2 = -1;
      break;
    case 8:
      rotate2 = -90;
      break;
  }
  return {
    rotate: rotate2,
    scaleX: scaleX2,
    scaleY: scaleY2
  };
}
__name(parseOrientation, "parseOrientation");
var render = {
  render: /* @__PURE__ */ __name(function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  }, "render"),
  initContainer: /* @__PURE__ */ __name(function() {
    var element = this.element, options = this.options, container = this.container, cropper = this.cropper;
    addClass(cropper, CLASS_HIDDEN), removeClass(element, CLASS_HIDDEN);
    var containerData = {
      width: Math.max(container.offsetWidth, Number(options.minContainerWidth) || 200),
      height: Math.max(container.offsetHeight, Number(options.minContainerHeight) || 100)
    };
    this.containerData = containerData, setStyle(cropper, {
      width: containerData.width,
      height: containerData.height
    }), addClass(element, CLASS_HIDDEN), removeClass(cropper, CLASS_HIDDEN);
  }, "initContainer"),
  // Canvas (image wrapper)
  initCanvas: /* @__PURE__ */ __name(function() {
    var containerData = this.containerData, imageData = this.imageData, viewMode = this.options.viewMode, rotated = Math.abs(imageData.rotate) % 180 === 90, naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth, naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight, aspectRatio = naturalWidth / naturalHeight, canvasWidth = containerData.width, canvasHeight = containerData.height;
    containerData.height * aspectRatio > containerData.width ? viewMode === 3 ? canvasWidth = containerData.height * aspectRatio : canvasHeight = containerData.width / aspectRatio : viewMode === 3 ? canvasHeight = containerData.width / aspectRatio : canvasWidth = containerData.height * aspectRatio;
    var canvasData = {
      aspectRatio,
      naturalWidth,
      naturalHeight,
      width: canvasWidth,
      height: canvasHeight
    };
    canvasData.left = (containerData.width - canvasWidth) / 2, canvasData.top = (containerData.height - canvasHeight) / 2, canvasData.oldLeft = canvasData.left, canvasData.oldTop = canvasData.top, this.canvasData = canvasData, this.limited = viewMode === 1 || viewMode === 2, this.limitCanvas(!0, !0), this.initialImageData = assign$1({}, imageData), this.initialCanvasData = assign$1({}, canvasData);
  }, "initCanvas"),
  limitCanvas: /* @__PURE__ */ __name(function(sizeLimited, positionLimited) {
    var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, viewMode = options.viewMode, aspectRatio = canvasData.aspectRatio, cropped = this.cropped && cropBoxData;
    if (sizeLimited) {
      var minCanvasWidth = Number(options.minCanvasWidth) || 0, minCanvasHeight = Number(options.minCanvasHeight) || 0;
      viewMode > 1 ? (minCanvasWidth = Math.max(minCanvasWidth, containerData.width), minCanvasHeight = Math.max(minCanvasHeight, containerData.height), viewMode === 3 && (minCanvasHeight * aspectRatio > minCanvasWidth ? minCanvasWidth = minCanvasHeight * aspectRatio : minCanvasHeight = minCanvasWidth / aspectRatio)) : viewMode > 0 && (minCanvasWidth ? minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0) : minCanvasHeight ? minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0) : cropped && (minCanvasWidth = cropBoxData.width, minCanvasHeight = cropBoxData.height, minCanvasHeight * aspectRatio > minCanvasWidth ? minCanvasWidth = minCanvasHeight * aspectRatio : minCanvasHeight = minCanvasWidth / aspectRatio));
      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio,
        width: minCanvasWidth,
        height: minCanvasHeight
      });
      minCanvasWidth = _getAdjustedSizes.width, minCanvasHeight = _getAdjustedSizes.height, canvasData.minWidth = minCanvasWidth, canvasData.minHeight = minCanvasHeight, canvasData.maxWidth = 1 / 0, canvasData.maxHeight = 1 / 0;
    }
    if (positionLimited)
      if (viewMode > (cropped ? 0 : 1)) {
        var newCanvasLeft = containerData.width - canvasData.width, newCanvasTop = containerData.height - canvasData.height;
        canvasData.minLeft = Math.min(0, newCanvasLeft), canvasData.minTop = Math.min(0, newCanvasTop), canvasData.maxLeft = Math.max(0, newCanvasLeft), canvasData.maxTop = Math.max(0, newCanvasTop), cropped && this.limited && (canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width)), canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height)), canvasData.maxLeft = cropBoxData.left, canvasData.maxTop = cropBoxData.top, viewMode === 2 && (canvasData.width >= containerData.width && (canvasData.minLeft = Math.min(0, newCanvasLeft), canvasData.maxLeft = Math.max(0, newCanvasLeft)), canvasData.height >= containerData.height && (canvasData.minTop = Math.min(0, newCanvasTop), canvasData.maxTop = Math.max(0, newCanvasTop))));
      } else
        canvasData.minLeft = -canvasData.width, canvasData.minTop = -canvasData.height, canvasData.maxLeft = containerData.width, canvasData.maxTop = containerData.height;
  }, "limitCanvas"),
  renderCanvas: /* @__PURE__ */ __name(function(changed, transformed) {
    var canvasData = this.canvasData, imageData = this.imageData;
    if (transformed) {
      var _getRotatedSizes = getRotatedSizes({
        width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
        height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
        degree: imageData.rotate || 0
      }), naturalWidth = _getRotatedSizes.width, naturalHeight = _getRotatedSizes.height, width = canvasData.width * (naturalWidth / canvasData.naturalWidth), height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
      canvasData.left -= (width - canvasData.width) / 2, canvasData.top -= (height - canvasData.height) / 2, canvasData.width = width, canvasData.height = height, canvasData.aspectRatio = naturalWidth / naturalHeight, canvasData.naturalWidth = naturalWidth, canvasData.naturalHeight = naturalHeight, this.limitCanvas(!0, !1);
    }
    (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) && (canvasData.left = canvasData.oldLeft), (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) && (canvasData.top = canvasData.oldTop), canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth), canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight), this.limitCanvas(!1, !0), canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft), canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop), canvasData.oldLeft = canvasData.left, canvasData.oldTop = canvasData.top, setStyle(this.canvas, assign$1({
      width: canvasData.width,
      height: canvasData.height
    }, getTransforms({
      translateX: canvasData.left,
      translateY: canvasData.top
    }))), this.renderImage(changed), this.cropped && this.limited && this.limitCropBox(!0, !0);
  }, "renderCanvas"),
  renderImage: /* @__PURE__ */ __name(function(changed) {
    var canvasData = this.canvasData, imageData = this.imageData, width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth), height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
    assign$1(imageData, {
      width,
      height,
      left: (canvasData.width - width) / 2,
      top: (canvasData.height - height) / 2
    }), setStyle(this.image, assign$1({
      width: imageData.width,
      height: imageData.height
    }, getTransforms(assign$1({
      translateX: imageData.left,
      translateY: imageData.top
    }, imageData)))), changed && this.output();
  }, "renderImage"),
  initCropBox: /* @__PURE__ */ __name(function() {
    var options = this.options, canvasData = this.canvasData, aspectRatio = options.aspectRatio || options.initialAspectRatio, autoCropArea = Number(options.autoCropArea) || 0.8, cropBoxData = {
      width: canvasData.width,
      height: canvasData.height
    };
    aspectRatio && (canvasData.height * aspectRatio > canvasData.width ? cropBoxData.height = cropBoxData.width / aspectRatio : cropBoxData.width = cropBoxData.height * aspectRatio), this.cropBoxData = cropBoxData, this.limitCropBox(!0, !0), cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth), cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight), cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea), cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea), cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2, cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2, cropBoxData.oldLeft = cropBoxData.left, cropBoxData.oldTop = cropBoxData.top, this.initialCropBoxData = assign$1({}, cropBoxData);
  }, "initCropBox"),
  limitCropBox: /* @__PURE__ */ __name(function(sizeLimited, positionLimited) {
    var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, limited = this.limited, aspectRatio = options.aspectRatio;
    if (sizeLimited) {
      var minCropBoxWidth = Number(options.minCropBoxWidth) || 0, minCropBoxHeight = Number(options.minCropBoxHeight) || 0, maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width, maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height;
      minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width), minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height), aspectRatio && (minCropBoxWidth && minCropBoxHeight ? minCropBoxHeight * aspectRatio > minCropBoxWidth ? minCropBoxHeight = minCropBoxWidth / aspectRatio : minCropBoxWidth = minCropBoxHeight * aspectRatio : minCropBoxWidth ? minCropBoxHeight = minCropBoxWidth / aspectRatio : minCropBoxHeight && (minCropBoxWidth = minCropBoxHeight * aspectRatio), maxCropBoxHeight * aspectRatio > maxCropBoxWidth ? maxCropBoxHeight = maxCropBoxWidth / aspectRatio : maxCropBoxWidth = maxCropBoxHeight * aspectRatio), cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth), cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight), cropBoxData.maxWidth = maxCropBoxWidth, cropBoxData.maxHeight = maxCropBoxHeight;
    }
    positionLimited && (limited ? (cropBoxData.minLeft = Math.max(0, canvasData.left), cropBoxData.minTop = Math.max(0, canvasData.top), cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width, cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height) : (cropBoxData.minLeft = 0, cropBoxData.minTop = 0, cropBoxData.maxLeft = containerData.width - cropBoxData.width, cropBoxData.maxTop = containerData.height - cropBoxData.height));
  }, "limitCropBox"),
  renderCropBox: /* @__PURE__ */ __name(function() {
    var options = this.options, containerData = this.containerData, cropBoxData = this.cropBoxData;
    (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) && (cropBoxData.left = cropBoxData.oldLeft), (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) && (cropBoxData.top = cropBoxData.oldTop), cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth), cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight), this.limitCropBox(!1, !0), cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft), cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop), cropBoxData.oldLeft = cropBoxData.left, cropBoxData.oldTop = cropBoxData.top, options.movable && options.cropBoxMovable && setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL), setStyle(this.cropBox, assign$1({
      width: cropBoxData.width,
      height: cropBoxData.height
    }, getTransforms({
      translateX: cropBoxData.left,
      translateY: cropBoxData.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  }, "renderCropBox"),
  output: /* @__PURE__ */ __name(function() {
    this.preview(), dispatchEvent(this.element, EVENT_CROP, this.getData());
  }, "output")
}, preview = {
  initPreview: /* @__PURE__ */ __name(function() {
    var element = this.element, crossOrigin = this.crossOrigin, preview3 = this.options.preview, url = crossOrigin ? this.crossOriginUrl : this.url, alt = element.alt || "The image to preview", image = document.createElement("img");
    if (crossOrigin && (image.crossOrigin = crossOrigin), image.src = url, image.alt = alt, this.viewBox.appendChild(image), this.viewBoxImage = image, !!preview3) {
      var previews = preview3;
      typeof preview3 == "string" ? previews = element.ownerDocument.querySelectorAll(preview3) : preview3.querySelector && (previews = [preview3]), this.previews = previews, forEach$1(previews, function(el) {
        var img = document.createElement("img");
        setData(el, DATA_PREVIEW, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          html: el.innerHTML
        }), crossOrigin && (img.crossOrigin = crossOrigin), img.src = url, img.alt = alt, img.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', el.innerHTML = "", el.appendChild(img);
      });
    }
  }, "initPreview"),
  resetPreview: /* @__PURE__ */ __name(function() {
    forEach$1(this.previews, function(element) {
      var data = getData(element, DATA_PREVIEW);
      setStyle(element, {
        width: data.width,
        height: data.height
      }), element.innerHTML = data.html, removeData(element, DATA_PREVIEW);
    });
  }, "resetPreview"),
  preview: /* @__PURE__ */ __name(function() {
    var imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, cropBoxWidth = cropBoxData.width, cropBoxHeight = cropBoxData.height, width = imageData.width, height = imageData.height, left = cropBoxData.left - canvasData.left - imageData.left, top = cropBoxData.top - canvasData.top - imageData.top;
    !this.cropped || this.disabled || (setStyle(this.viewBoxImage, assign$1({
      width,
      height
    }, getTransforms(assign$1({
      translateX: -left,
      translateY: -top
    }, imageData)))), forEach$1(this.previews, function(element) {
      var data = getData(element, DATA_PREVIEW), originalWidth = data.width, originalHeight = data.height, newWidth = originalWidth, newHeight = originalHeight, ratio = 1;
      cropBoxWidth && (ratio = originalWidth / cropBoxWidth, newHeight = cropBoxHeight * ratio), cropBoxHeight && newHeight > originalHeight && (ratio = originalHeight / cropBoxHeight, newWidth = cropBoxWidth * ratio, newHeight = originalHeight), setStyle(element, {
        width: newWidth,
        height: newHeight
      }), setStyle(element.getElementsByTagName("img")[0], assign$1({
        width: width * ratio,
        height: height * ratio
      }, getTransforms(assign$1({
        translateX: -left * ratio,
        translateY: -top * ratio
      }, imageData))));
    }));
  }, "preview")
}, events = {
  bind: /* @__PURE__ */ __name(function() {
    var element = this.element, options = this.options, cropper = this.cropper;
    isFunction$2(options.cropstart) && addListener(element, EVENT_CROP_START, options.cropstart), isFunction$2(options.cropmove) && addListener(element, EVENT_CROP_MOVE, options.cropmove), isFunction$2(options.cropend) && addListener(element, EVENT_CROP_END, options.cropend), isFunction$2(options.crop) && addListener(element, EVENT_CROP, options.crop), isFunction$2(options.zoom) && addListener(element, EVENT_ZOOM, options.zoom), addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this)), options.zoomable && options.zoomOnWheel && addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), options.toggleDragModeOnDblclick && addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this)), addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this)), addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this)), options.responsive && addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
  }, "bind"),
  unbind: /* @__PURE__ */ __name(function() {
    var element = this.element, options = this.options, cropper = this.cropper;
    isFunction$2(options.cropstart) && removeListener(element, EVENT_CROP_START, options.cropstart), isFunction$2(options.cropmove) && removeListener(element, EVENT_CROP_MOVE, options.cropmove), isFunction$2(options.cropend) && removeListener(element, EVENT_CROP_END, options.cropend), isFunction$2(options.crop) && removeListener(element, EVENT_CROP, options.crop), isFunction$2(options.zoom) && removeListener(element, EVENT_ZOOM, options.zoom), removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart), options.zoomable && options.zoomOnWheel && removeListener(cropper, EVENT_WHEEL, this.onWheel, {
      passive: !1,
      capture: !0
    }), options.toggleDragModeOnDblclick && removeListener(cropper, EVENT_DBLCLICK, this.onDblclick), removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove), removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd), options.responsive && removeListener(window, EVENT_RESIZE, this.onResize);
  }, "unbind")
}, handlers = {
  resize: /* @__PURE__ */ __name(function() {
    if (!this.disabled) {
      var options = this.options, container = this.container, containerData = this.containerData, ratio = container.offsetWidth / containerData.width;
      if (ratio !== 1 || container.offsetHeight !== containerData.height) {
        var canvasData, cropBoxData;
        options.restore && (canvasData = this.getCanvasData(), cropBoxData = this.getCropBoxData()), this.render(), options.restore && (this.setCanvasData(forEach$1(canvasData, function(n2, i2) {
          canvasData[i2] = n2 * ratio;
        })), this.setCropBoxData(forEach$1(cropBoxData, function(n2, i2) {
          cropBoxData[i2] = n2 * ratio;
        })));
      }
    }
  }, "resize"),
  dblclick: /* @__PURE__ */ __name(function() {
    this.disabled || this.options.dragMode === DRAG_MODE_NONE || this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
  }, "dblclick"),
  wheel: /* @__PURE__ */ __name(function(event) {
    var _this = this, ratio = Number(this.options.wheelZoomRatio) || 0.1, delta = 1;
    this.disabled || (event.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      _this.wheeling = !1;
    }, 50), event.deltaY ? delta = event.deltaY > 0 ? 1 : -1 : event.wheelDelta ? delta = -event.wheelDelta / 120 : event.detail && (delta = event.detail > 0 ? 1 : -1), this.zoom(-delta * ratio, event)));
  }, "wheel"),
  cropStart: /* @__PURE__ */ __name(function(event) {
    var buttons = event.buttons, button = event.button;
    if (!(this.disabled || (event.type === "mousedown" || event.type === "pointerdown" && event.pointerType === "mouse") && // No primary button (Usually the left button)
    (isNumber$1(buttons) && buttons !== 1 || isNumber$1(button) && button !== 0 || event.ctrlKey))) {
      var options = this.options, pointers = this.pointers, action;
      event.changedTouches ? forEach$1(event.changedTouches, function(touch) {
        pointers[touch.identifier] = getPointer(touch);
      }) : pointers[event.pointerId || 0] = getPointer(event), Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch ? action = ACTION_ZOOM : action = getData(event.target, DATA_ACTION), REGEXP_ACTIONS.test(action) && dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action
      }) !== !1 && (event.preventDefault(), this.action = action, this.cropping = !1, action === ACTION_CROP && (this.cropping = !0, addClass(this.dragBox, CLASS_MODAL)));
    }
  }, "cropStart"),
  cropMove: /* @__PURE__ */ __name(function(event) {
    var action = this.action;
    if (!(this.disabled || !action)) {
      var pointers = this.pointers;
      event.preventDefault(), dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action
      }) !== !1 && (event.changedTouches ? forEach$1(event.changedTouches, function(touch) {
        assign$1(pointers[touch.identifier] || {}, getPointer(touch, !0));
      }) : assign$1(pointers[event.pointerId || 0] || {}, getPointer(event, !0)), this.change(event));
    }
  }, "cropMove"),
  cropEnd: /* @__PURE__ */ __name(function(event) {
    if (!this.disabled) {
      var action = this.action, pointers = this.pointers;
      event.changedTouches ? forEach$1(event.changedTouches, function(touch) {
        delete pointers[touch.identifier];
      }) : delete pointers[event.pointerId || 0], action && (event.preventDefault(), Object.keys(pointers).length || (this.action = ""), this.cropping && (this.cropping = !1, toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal)), dispatchEvent(this.element, EVENT_CROP_END, {
        originalEvent: event,
        action
      }));
    }
  }, "cropEnd")
}, change = {
  change: /* @__PURE__ */ __name(function(event) {
    var options = this.options, canvasData = this.canvasData, containerData = this.containerData, cropBoxData = this.cropBoxData, pointers = this.pointers, action = this.action, aspectRatio = options.aspectRatio, left = cropBoxData.left, top = cropBoxData.top, width = cropBoxData.width, height = cropBoxData.height, right = left + width, bottom = top + height, minLeft = 0, minTop = 0, maxWidth = containerData.width, maxHeight = containerData.height, renderable = !0, offset;
    !aspectRatio && event.shiftKey && (aspectRatio = width && height ? width / height : 1), this.limited && (minLeft = cropBoxData.minLeft, minTop = cropBoxData.minTop, maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width), maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height));
    var pointer = pointers[Object.keys(pointers)[0]], range = {
      x: pointer.endX - pointer.startX,
      y: pointer.endY - pointer.startY
    }, check = /* @__PURE__ */ __name(function(side) {
      switch (side) {
        case ACTION_EAST:
          right + range.x > maxWidth && (range.x = maxWidth - right);
          break;
        case ACTION_WEST:
          left + range.x < minLeft && (range.x = minLeft - left);
          break;
        case ACTION_NORTH:
          top + range.y < minTop && (range.y = minTop - top);
          break;
        case ACTION_SOUTH:
          bottom + range.y > maxHeight && (range.y = maxHeight - bottom);
          break;
      }
    }, "check");
    switch (action) {
      case ACTION_ALL:
        left += range.x, top += range.y;
        break;
      case ACTION_EAST:
        if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = !1;
          break;
        }
        check(ACTION_EAST), width += range.x, width < 0 && (action = ACTION_WEST, width = -width, left -= width), aspectRatio && (height = width / aspectRatio, top += (cropBoxData.height - height) / 2);
        break;
      case ACTION_NORTH:
        if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = !1;
          break;
        }
        check(ACTION_NORTH), height -= range.y, top += range.y, height < 0 && (action = ACTION_SOUTH, height = -height, top -= height), aspectRatio && (width = height * aspectRatio, left += (cropBoxData.width - width) / 2);
        break;
      case ACTION_WEST:
        if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = !1;
          break;
        }
        check(ACTION_WEST), width -= range.x, left += range.x, width < 0 && (action = ACTION_EAST, width = -width, left -= width), aspectRatio && (height = width / aspectRatio, top += (cropBoxData.height - height) / 2);
        break;
      case ACTION_SOUTH:
        if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = !1;
          break;
        }
        check(ACTION_SOUTH), height += range.y, height < 0 && (action = ACTION_NORTH, height = -height, top -= height), aspectRatio && (width = height * aspectRatio, left += (cropBoxData.width - width) / 2);
        break;
      case ACTION_NORTH_EAST:
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
            renderable = !1;
            break;
          }
          check(ACTION_NORTH), height -= range.y, top += range.y, width = height * aspectRatio;
        } else
          check(ACTION_NORTH), check(ACTION_EAST), range.x >= 0 ? right < maxWidth ? width += range.x : range.y <= 0 && top <= minTop && (renderable = !1) : width += range.x, range.y <= 0 ? top > minTop && (height -= range.y, top += range.y) : (height -= range.y, top += range.y);
        width < 0 && height < 0 ? (action = ACTION_SOUTH_WEST, height = -height, width = -width, top -= height, left -= width) : width < 0 ? (action = ACTION_NORTH_WEST, width = -width, left -= width) : height < 0 && (action = ACTION_SOUTH_EAST, height = -height, top -= height);
        break;
      case ACTION_NORTH_WEST:
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
            renderable = !1;
            break;
          }
          check(ACTION_NORTH), height -= range.y, top += range.y, width = height * aspectRatio, left += cropBoxData.width - width;
        } else
          check(ACTION_NORTH), check(ACTION_WEST), range.x <= 0 ? left > minLeft ? (width -= range.x, left += range.x) : range.y <= 0 && top <= minTop && (renderable = !1) : (width -= range.x, left += range.x), range.y <= 0 ? top > minTop && (height -= range.y, top += range.y) : (height -= range.y, top += range.y);
        width < 0 && height < 0 ? (action = ACTION_SOUTH_EAST, height = -height, width = -width, top -= height, left -= width) : width < 0 ? (action = ACTION_NORTH_EAST, width = -width, left -= width) : height < 0 && (action = ACTION_SOUTH_WEST, height = -height, top -= height);
        break;
      case ACTION_SOUTH_WEST:
        if (aspectRatio) {
          if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
            renderable = !1;
            break;
          }
          check(ACTION_WEST), width -= range.x, left += range.x, height = width / aspectRatio;
        } else
          check(ACTION_SOUTH), check(ACTION_WEST), range.x <= 0 ? left > minLeft ? (width -= range.x, left += range.x) : range.y >= 0 && bottom >= maxHeight && (renderable = !1) : (width -= range.x, left += range.x), range.y >= 0 ? bottom < maxHeight && (height += range.y) : height += range.y;
        width < 0 && height < 0 ? (action = ACTION_NORTH_EAST, height = -height, width = -width, top -= height, left -= width) : width < 0 ? (action = ACTION_SOUTH_EAST, width = -width, left -= width) : height < 0 && (action = ACTION_NORTH_WEST, height = -height, top -= height);
        break;
      case ACTION_SOUTH_EAST:
        if (aspectRatio) {
          if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
            renderable = !1;
            break;
          }
          check(ACTION_EAST), width += range.x, height = width / aspectRatio;
        } else
          check(ACTION_SOUTH), check(ACTION_EAST), range.x >= 0 ? right < maxWidth ? width += range.x : range.y >= 0 && bottom >= maxHeight && (renderable = !1) : width += range.x, range.y >= 0 ? bottom < maxHeight && (height += range.y) : height += range.y;
        width < 0 && height < 0 ? (action = ACTION_NORTH_WEST, height = -height, width = -width, top -= height, left -= width) : width < 0 ? (action = ACTION_SOUTH_WEST, width = -width, left -= width) : height < 0 && (action = ACTION_NORTH_EAST, height = -height, top -= height);
        break;
      case ACTION_MOVE:
        this.move(range.x, range.y), renderable = !1;
        break;
      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), event), renderable = !1;
        break;
      case ACTION_CROP:
        if (!range.x || !range.y) {
          renderable = !1;
          break;
        }
        offset = getOffset(this.cropper), left = pointer.startX - offset.left, top = pointer.startY - offset.top, width = cropBoxData.minWidth, height = cropBoxData.minHeight, range.x > 0 ? action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST : range.x < 0 && (left -= width, action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST), range.y < 0 && (top -= height), this.cropped || (removeClass(this.cropBox, CLASS_HIDDEN), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    renderable && (cropBoxData.width = width, cropBoxData.height = height, cropBoxData.left = left, cropBoxData.top = top, this.action = action, this.renderCropBox()), forEach$1(pointers, function(p2) {
      p2.startX = p2.endX, p2.startY = p2.endY;
    });
  }, "change")
}, methods = {
  // Show the crop box manually
  crop: /* @__PURE__ */ __name(function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && addClass(this.dragBox, CLASS_MODAL), removeClass(this.cropBox, CLASS_HIDDEN), this.setCropBoxData(this.initialCropBoxData)), this;
  }, "crop"),
  // Reset the image and crop box to their initial states
  reset: /* @__PURE__ */ __name(function() {
    return this.ready && !this.disabled && (this.imageData = assign$1({}, this.initialImageData), this.canvasData = assign$1({}, this.initialCanvasData), this.cropBoxData = assign$1({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  }, "reset"),
  // Clear the crop box
  clear: /* @__PURE__ */ __name(function() {
    return this.cropped && !this.disabled && (assign$1(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), removeClass(this.dragBox, CLASS_MODAL), addClass(this.cropBox, CLASS_HIDDEN)), this;
  }, "clear"),
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: /* @__PURE__ */ __name(function(url) {
    var hasSameSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && url && (this.isImg && (this.element.src = url), hasSameSize ? (this.url = url, this.image.src = url, this.ready && (this.viewBoxImage.src = url, forEach$1(this.previews, function(element) {
      element.getElementsByTagName("img")[0].src = url;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(url))), this;
  }, "replace"),
  // Enable (unfreeze) the cropper
  enable: /* @__PURE__ */ __name(function() {
    return this.ready && this.disabled && (this.disabled = !1, removeClass(this.cropper, CLASS_DISABLED)), this;
  }, "enable"),
  // Disable (freeze) the cropper
  disable: /* @__PURE__ */ __name(function() {
    return this.ready && !this.disabled && (this.disabled = !0, addClass(this.cropper, CLASS_DISABLED)), this;
  }, "disable"),
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: /* @__PURE__ */ __name(function() {
    var element = this.element;
    return element[NAMESPACE] ? (element[NAMESPACE] = void 0, this.isImg && this.replaced && (element.src = this.originalUrl), this.uncreate(), this) : this;
  }, "destroy"),
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: /* @__PURE__ */ __name(function(offsetX) {
    var offsetY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : offsetX, _this$canvasData = this.canvasData, left = _this$canvasData.left, top = _this$canvasData.top;
    return this.moveTo(isUndefined$1(offsetX) ? offsetX : left + Number(offsetX), isUndefined$1(offsetY) ? offsetY : top + Number(offsetY));
  }, "move"),
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: /* @__PURE__ */ __name(function(x2) {
    var y2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x2, canvasData = this.canvasData, changed = !1;
    return x2 = Number(x2), y2 = Number(y2), this.ready && !this.disabled && this.options.movable && (isNumber$1(x2) && (canvasData.left = x2, changed = !0), isNumber$1(y2) && (canvasData.top = y2, changed = !0), changed && this.renderCanvas(!0)), this;
  }, "moveTo"),
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: /* @__PURE__ */ __name(function(ratio, _originalEvent) {
    var canvasData = this.canvasData;
    return ratio = Number(ratio), ratio < 0 ? ratio = 1 / (1 - ratio) : ratio = 1 + ratio, this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
  }, "zoom"),
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: /* @__PURE__ */ __name(function(ratio, pivot, _originalEvent) {
    var options = this.options, canvasData = this.canvasData, width = canvasData.width, height = canvasData.height, naturalWidth = canvasData.naturalWidth, naturalHeight = canvasData.naturalHeight;
    if (ratio = Number(ratio), ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
      var newWidth = naturalWidth * ratio, newHeight = naturalHeight * ratio;
      if (dispatchEvent(this.element, EVENT_ZOOM, {
        ratio,
        oldRatio: width / naturalWidth,
        originalEvent: _originalEvent
      }) === !1)
        return this;
      if (_originalEvent) {
        var pointers = this.pointers, offset = getOffset(this.cropper), center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        };
        canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width), canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
      } else isPlainObject$1(pivot) && isNumber$1(pivot.x) && isNumber$1(pivot.y) ? (canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width), canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height)) : (canvasData.left -= (newWidth - width) / 2, canvasData.top -= (newHeight - height) / 2);
      canvasData.width = newWidth, canvasData.height = newHeight, this.renderCanvas(!0);
    }
    return this;
  }, "zoomTo"),
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: /* @__PURE__ */ __name(function(degree) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
  }, "rotate"),
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: /* @__PURE__ */ __name(function(degree) {
    return degree = Number(degree), isNumber$1(degree) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = degree % 360, this.renderCanvas(!0, !0)), this;
  }, "rotateTo"),
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: /* @__PURE__ */ __name(function(_scaleX) {
    var scaleY2 = this.imageData.scaleY;
    return this.scale(_scaleX, isNumber$1(scaleY2) ? scaleY2 : 1);
  }, "scaleX"),
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: /* @__PURE__ */ __name(function(_scaleY) {
    var scaleX2 = this.imageData.scaleX;
    return this.scale(isNumber$1(scaleX2) ? scaleX2 : 1, _scaleY);
  }, "scaleY"),
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: /* @__PURE__ */ __name(function(scaleX2) {
    var scaleY2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scaleX2, imageData = this.imageData, transformed = !1;
    return scaleX2 = Number(scaleX2), scaleY2 = Number(scaleY2), this.ready && !this.disabled && this.options.scalable && (isNumber$1(scaleX2) && (imageData.scaleX = scaleX2, transformed = !0), isNumber$1(scaleY2) && (imageData.scaleY = scaleY2, transformed = !0), transformed && this.renderCanvas(!0, !0)), this;
  }, "scale"),
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: /* @__PURE__ */ __name(function() {
    var rounded = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, options = this.options, imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, data;
    if (this.ready && this.cropped) {
      data = {
        x: cropBoxData.left - canvasData.left,
        y: cropBoxData.top - canvasData.top,
        width: cropBoxData.width,
        height: cropBoxData.height
      };
      var ratio = imageData.width / imageData.naturalWidth;
      if (forEach$1(data, function(n2, i2) {
        data[i2] = n2 / ratio;
      }), rounded) {
        var bottom = Math.round(data.y + data.height), right = Math.round(data.x + data.width);
        data.x = Math.round(data.x), data.y = Math.round(data.y), data.width = right - data.x, data.height = bottom - data.y;
      }
    } else
      data = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return options.rotatable && (data.rotate = imageData.rotate || 0), options.scalable && (data.scaleX = imageData.scaleX || 1, data.scaleY = imageData.scaleY || 1), data;
  }, "getData"),
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: /* @__PURE__ */ __name(function(data) {
    var options = this.options, imageData = this.imageData, canvasData = this.canvasData, cropBoxData = {};
    if (this.ready && !this.disabled && isPlainObject$1(data)) {
      var transformed = !1;
      options.rotatable && isNumber$1(data.rotate) && data.rotate !== imageData.rotate && (imageData.rotate = data.rotate, transformed = !0), options.scalable && (isNumber$1(data.scaleX) && data.scaleX !== imageData.scaleX && (imageData.scaleX = data.scaleX, transformed = !0), isNumber$1(data.scaleY) && data.scaleY !== imageData.scaleY && (imageData.scaleY = data.scaleY, transformed = !0)), transformed && this.renderCanvas(!0, !0);
      var ratio = imageData.width / imageData.naturalWidth;
      isNumber$1(data.x) && (cropBoxData.left = data.x * ratio + canvasData.left), isNumber$1(data.y) && (cropBoxData.top = data.y * ratio + canvasData.top), isNumber$1(data.width) && (cropBoxData.width = data.width * ratio), isNumber$1(data.height) && (cropBoxData.height = data.height * ratio), this.setCropBoxData(cropBoxData);
    }
    return this;
  }, "setData"),
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: /* @__PURE__ */ __name(function() {
    return this.ready ? assign$1({}, this.containerData) : {};
  }, "getContainerData"),
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: /* @__PURE__ */ __name(function() {
    return this.sized ? assign$1({}, this.imageData) : {};
  }, "getImageData"),
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: /* @__PURE__ */ __name(function() {
    var canvasData = this.canvasData, data = {};
    return this.ready && forEach$1(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n2) {
      data[n2] = canvasData[n2];
    }), data;
  }, "getCanvasData"),
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: /* @__PURE__ */ __name(function(data) {
    var canvasData = this.canvasData, aspectRatio = canvasData.aspectRatio;
    return this.ready && !this.disabled && isPlainObject$1(data) && (isNumber$1(data.left) && (canvasData.left = data.left), isNumber$1(data.top) && (canvasData.top = data.top), isNumber$1(data.width) ? (canvasData.width = data.width, canvasData.height = data.width / aspectRatio) : isNumber$1(data.height) && (canvasData.height = data.height, canvasData.width = data.height * aspectRatio), this.renderCanvas(!0)), this;
  }, "setCanvasData"),
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: /* @__PURE__ */ __name(function() {
    var cropBoxData = this.cropBoxData, data;
    return this.ready && this.cropped && (data = {
      left: cropBoxData.left,
      top: cropBoxData.top,
      width: cropBoxData.width,
      height: cropBoxData.height
    }), data || {};
  }, "getCropBoxData"),
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: /* @__PURE__ */ __name(function(data) {
    var cropBoxData = this.cropBoxData, aspectRatio = this.options.aspectRatio, widthChanged, heightChanged;
    return this.ready && this.cropped && !this.disabled && isPlainObject$1(data) && (isNumber$1(data.left) && (cropBoxData.left = data.left), isNumber$1(data.top) && (cropBoxData.top = data.top), isNumber$1(data.width) && data.width !== cropBoxData.width && (widthChanged = !0, cropBoxData.width = data.width), isNumber$1(data.height) && data.height !== cropBoxData.height && (heightChanged = !0, cropBoxData.height = data.height), aspectRatio && (widthChanged ? cropBoxData.height = cropBoxData.width / aspectRatio : heightChanged && (cropBoxData.width = cropBoxData.height * aspectRatio)), this.renderCropBox()), this;
  }, "setCropBoxData"),
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: /* @__PURE__ */ __name(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var canvasData = this.canvasData, source = getSourceCanvas(this.image, this.imageData, canvasData, options);
    if (!this.cropped)
      return source;
    var _this$getData = this.getData(), initialX = _this$getData.x, initialY = _this$getData.y, initialWidth = _this$getData.width, initialHeight = _this$getData.height, ratio = source.width / Math.floor(canvasData.naturalWidth);
    ratio !== 1 && (initialX *= ratio, initialY *= ratio, initialWidth *= ratio, initialHeight *= ratio);
    var aspectRatio = initialWidth / initialHeight, maxSizes = getAdjustedSizes({
      aspectRatio,
      width: options.maxWidth || 1 / 0,
      height: options.maxHeight || 1 / 0
    }), minSizes = getAdjustedSizes({
      aspectRatio,
      width: options.minWidth || 0,
      height: options.minHeight || 0
    }, "cover"), _getAdjustedSizes = getAdjustedSizes({
      aspectRatio,
      width: options.width || (ratio !== 1 ? source.width : initialWidth),
      height: options.height || (ratio !== 1 ? source.height : initialHeight)
    }), width = _getAdjustedSizes.width, height = _getAdjustedSizes.height;
    width = Math.min(maxSizes.width, Math.max(minSizes.width, width)), height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
    var canvas = document.createElement("canvas"), context = canvas.getContext("2d");
    canvas.width = normalizeDecimalNumber(width), canvas.height = normalizeDecimalNumber(height), context.fillStyle = options.fillColor || "transparent", context.fillRect(0, 0, width, height);
    var _options$imageSmoothi = options.imageSmoothingEnabled, imageSmoothingEnabled = _options$imageSmoothi === void 0 ? !0 : _options$imageSmoothi, imageSmoothingQuality = options.imageSmoothingQuality;
    context.imageSmoothingEnabled = imageSmoothingEnabled, imageSmoothingQuality && (context.imageSmoothingQuality = imageSmoothingQuality);
    var sourceWidth = source.width, sourceHeight = source.height, srcX = initialX, srcY = initialY, srcWidth, srcHeight, dstX, dstY, dstWidth, dstHeight;
    srcX <= -initialWidth || srcX > sourceWidth ? (srcX = 0, srcWidth = 0, dstX = 0, dstWidth = 0) : srcX <= 0 ? (dstX = -srcX, srcX = 0, srcWidth = Math.min(sourceWidth, initialWidth + srcX), dstWidth = srcWidth) : srcX <= sourceWidth && (dstX = 0, srcWidth = Math.min(initialWidth, sourceWidth - srcX), dstWidth = srcWidth), srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight ? (srcY = 0, srcHeight = 0, dstY = 0, dstHeight = 0) : srcY <= 0 ? (dstY = -srcY, srcY = 0, srcHeight = Math.min(sourceHeight, initialHeight + srcY), dstHeight = srcHeight) : srcY <= sourceHeight && (dstY = 0, srcHeight = Math.min(initialHeight, sourceHeight - srcY), dstHeight = srcHeight);
    var params = [srcX, srcY, srcWidth, srcHeight];
    if (dstWidth > 0 && dstHeight > 0) {
      var scale2 = width / initialWidth;
      params.push(dstX * scale2, dstY * scale2, dstWidth * scale2, dstHeight * scale2);
    }
    return context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function(param) {
      return Math.floor(normalizeDecimalNumber(param));
    })))), canvas;
  }, "getCroppedCanvas"),
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: /* @__PURE__ */ __name(function(aspectRatio) {
    var options = this.options;
    return !this.disabled && !isUndefined$1(aspectRatio) && (options.aspectRatio = Math.max(0, aspectRatio) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  }, "setAspectRatio"),
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: /* @__PURE__ */ __name(function(mode) {
    var options = this.options, dragBox = this.dragBox, face = this.face;
    if (this.ready && !this.disabled) {
      var croppable = mode === DRAG_MODE_CROP, movable = options.movable && mode === DRAG_MODE_MOVE;
      mode = croppable || movable ? mode : DRAG_MODE_NONE, options.dragMode = mode, setData(dragBox, DATA_ACTION, mode), toggleClass(dragBox, CLASS_CROP, croppable), toggleClass(dragBox, CLASS_MOVE, movable), options.cropBoxMovable || (setData(face, DATA_ACTION, mode), toggleClass(face, CLASS_CROP, croppable), toggleClass(face, CLASS_MOVE, movable));
    }
    return this;
  }, "setDragMode")
}, AnotherCropper = WINDOW.Cropper, Cropper = /* @__PURE__ */ function() {
  function Cropper2(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (_classCallCheck$9(this, Cropper2), !element || !REGEXP_TAG_NAME.test(element.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = element, this.options = assign$1({}, DEFAULTS, isPlainObject$1(options) && options), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return __name(Cropper2, "Cropper"), _createClass$9(Cropper2, [{
    key: "init",
    value: /* @__PURE__ */ __name(function() {
      var element = this.element, tagName = element.tagName.toLowerCase(), url;
      if (!element[NAMESPACE]) {
        if (element[NAMESPACE] = this, tagName === "img") {
          if (this.isImg = !0, url = element.getAttribute("src") || "", this.originalUrl = url, !url)
            return;
          url = element.src;
        } else tagName === "canvas" && window.HTMLCanvasElement && (url = element.toDataURL());
        this.load(url);
      }
    }, "init")
  }, {
    key: "load",
    value: /* @__PURE__ */ __name(function(url) {
      var _this = this;
      if (url) {
        this.url = url, this.imageData = {};
        var element = this.element, options = this.options;
        if (!options.rotatable && !options.scalable && (options.checkOrientation = !1), !options.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (REGEXP_DATA_URL.test(url)) {
          REGEXP_DATA_URL_JPEG.test(url) ? this.read(dataURLToArrayBuffer(url)) : this.clone();
          return;
        }
        var xhr = new XMLHttpRequest(), clone = this.clone.bind(this);
        this.reloading = !0, this.xhr = xhr, xhr.onabort = clone, xhr.onerror = clone, xhr.ontimeout = clone, xhr.onprogress = function() {
          xhr.getResponseHeader("content-type") !== MIME_TYPE_JPEG && xhr.abort();
        }, xhr.onload = function() {
          _this.read(xhr.response);
        }, xhr.onloadend = function() {
          _this.reloading = !1, _this.xhr = null;
        }, options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin && (url = addTimestamp(url)), xhr.open("GET", url), xhr.responseType = "arraybuffer", xhr.withCredentials = element.crossOrigin === "use-credentials", xhr.send();
      }
    }, "load")
  }, {
    key: "read",
    value: /* @__PURE__ */ __name(function(arrayBuffer) {
      var options = this.options, imageData = this.imageData, orientation = resetAndGetOrientation(arrayBuffer), rotate2 = 0, scaleX2 = 1, scaleY2 = 1;
      if (orientation > 1) {
        this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
        var _parseOrientation = parseOrientation(orientation);
        rotate2 = _parseOrientation.rotate, scaleX2 = _parseOrientation.scaleX, scaleY2 = _parseOrientation.scaleY;
      }
      options.rotatable && (imageData.rotate = rotate2), options.scalable && (imageData.scaleX = scaleX2, imageData.scaleY = scaleY2), this.clone();
    }, "read")
  }, {
    key: "clone",
    value: /* @__PURE__ */ __name(function() {
      var element = this.element, url = this.url, crossOrigin = element.crossOrigin, crossOriginUrl = url;
      this.options.checkCrossOrigin && isCrossOriginURL(url) && (crossOrigin || (crossOrigin = "anonymous"), crossOriginUrl = addTimestamp(url)), this.crossOrigin = crossOrigin, this.crossOriginUrl = crossOriginUrl;
      var image = document.createElement("img");
      crossOrigin && (image.crossOrigin = crossOrigin), image.src = crossOriginUrl || url, image.alt = element.alt || "The image to crop", this.image = image, image.onload = this.start.bind(this), image.onerror = this.stop.bind(this), addClass(image, CLASS_HIDE), element.parentNode.insertBefore(image, element.nextSibling);
    }, "clone")
  }, {
    key: "start",
    value: /* @__PURE__ */ __name(function() {
      var _this2 = this, image = this.image;
      image.onload = null, image.onerror = null, this.sizing = !0;
      var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent), done = /* @__PURE__ */ __name(function(naturalWidth, naturalHeight) {
        assign$1(_this2.imageData, {
          naturalWidth,
          naturalHeight,
          aspectRatio: naturalWidth / naturalHeight
        }), _this2.sizing = !1, _this2.sized = !0, _this2.build();
      }, "done");
      if (image.naturalWidth && !isIOSWebKit) {
        done(image.naturalWidth, image.naturalHeight);
        return;
      }
      var sizingImage = document.createElement("img"), body = document.body || document.documentElement;
      this.sizingImage = sizingImage, sizingImage.onload = function() {
        done(sizingImage.width, sizingImage.height), isIOSWebKit || body.removeChild(sizingImage);
      }, sizingImage.src = image.src, isIOSWebKit || (sizingImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", body.appendChild(sizingImage));
    }, "start")
  }, {
    key: "stop",
    value: /* @__PURE__ */ __name(function() {
      var image = this.image;
      image.onload = null, image.onerror = null, image.parentNode.removeChild(image), this.image = null;
    }, "stop")
  }, {
    key: "build",
    value: /* @__PURE__ */ __name(function() {
      if (!(!this.sized || this.ready)) {
        var element = this.element, options = this.options, image = this.image, container = element.parentNode, template = document.createElement("div");
        template.innerHTML = TEMPLATE;
        var cropper = template.querySelector(".".concat(NAMESPACE, "-container")), canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas")), dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box")), cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box")), face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
        this.container = container, this.cropper = cropper, this.canvas = canvas, this.dragBox = dragBox, this.cropBox = cropBox, this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box")), this.face = face, canvas.appendChild(image), addClass(element, CLASS_HIDDEN), container.insertBefore(cropper, element.nextSibling), this.isImg || removeClass(image, CLASS_HIDE), this.initPreview(), this.bind(), options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN, options.aspectRatio = Math.max(0, options.aspectRatio) || NaN, options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0, addClass(cropBox, CLASS_HIDDEN), options.guides || addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN), options.center || addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN), options.background && addClass(cropper, "".concat(NAMESPACE, "-bg")), options.highlight || addClass(face, CLASS_INVISIBLE), options.cropBoxMovable && (addClass(face, CLASS_MOVE), setData(face, DATA_ACTION, ACTION_ALL)), options.cropBoxResizable || (addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN), addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN)), this.render(), this.ready = !0, this.setDragMode(options.dragMode), options.autoCrop && this.crop(), this.setData(options.data), isFunction$2(options.ready) && addListener(element, EVENT_READY, options.ready, {
          once: !0
        }), dispatchEvent(element, EVENT_READY);
      }
    }, "build")
  }, {
    key: "unbuild",
    value: /* @__PURE__ */ __name(function() {
      this.ready && (this.ready = !1, this.unbind(), this.resetPreview(), this.cropper.parentNode.removeChild(this.cropper), removeClass(this.element, CLASS_HIDDEN));
    }, "unbuild")
  }, {
    key: "uncreate",
    value: /* @__PURE__ */ __name(function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }, "uncreate")
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: /* @__PURE__ */ __name(function() {
      return window.Cropper = AnotherCropper, Cropper2;
    }, "noConflict")
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: /* @__PURE__ */ __name(function(options) {
      assign$1(DEFAULTS, isPlainObject$1(options) && options);
    }, "setDefaults")
  }]), Cropper2;
}();
assign$1(Cropper.prototype, render, preview, events, handlers, change, methods);
function getCanvasDataThatFitsPerfectlyIntoContainer(containerData, canvasData) {
  const widthRatio = containerData.width / canvasData.width, heightRatio = containerData.height / canvasData.height, scaleFactor = Math.min(widthRatio, heightRatio), newWidth = canvasData.width * scaleFactor, newHeight = canvasData.height * scaleFactor, newLeft = (containerData.width - newWidth) / 2, newTop = (containerData.height - newHeight) / 2;
  return {
    width: newWidth,
    height: newHeight,
    left: newLeft,
    top: newTop
  };
}
__name(getCanvasDataThatFitsPerfectlyIntoContainer, "getCanvasDataThatFitsPerfectlyIntoContainer");
function toRadians(angle) {
  return angle * (Math.PI / 180);
}
__name(toRadians, "toRadians");
function getScaleFactorThatRemovesDarkCorners(cropboxData, granularAngle) {
  const α = Math.abs(toRadians(granularAngle)), w2 = cropboxData.width, h2 = cropboxData.height;
  return Math.max((Math.sin(α) * w2 + Math.cos(α) * h2) / h2, (Math.sin(α) * h2 + Math.cos(α) * w2) / w2);
}
__name(getScaleFactorThatRemovesDarkCorners, "getScaleFactorThatRemovesDarkCorners");
const _Editor = class _Editor extends b$2 {
  constructor(props) {
    super(props), this.onRotate90Deg = () => {
      const {
        angle90Deg
      } = this.state, newAngle = angle90Deg - 90;
      this.setState({
        angle90Deg: newAngle,
        angleGranular: 0
      }), this.cropper.scale(1), this.cropper.rotateTo(newAngle);
      const canvasData = this.cropper.getCanvasData(), containerData = this.cropper.getContainerData(), newCanvasData = getCanvasDataThatFitsPerfectlyIntoContainer(containerData, canvasData);
      this.cropper.setCanvasData(newCanvasData), this.cropper.setCropBoxData(newCanvasData);
    }, this.onRotateGranular = (ev) => {
      const newGranularAngle = Number(ev.target.value);
      this.setState({
        angleGranular: newGranularAngle
      });
      const {
        angle90Deg
      } = this.state, newAngle = angle90Deg + newGranularAngle;
      this.cropper.rotateTo(newAngle);
      const cropboxData = this.cropper.getCropBoxData(), scaleFactor = getScaleFactorThatRemovesDarkCorners(cropboxData, newGranularAngle), scaleFactorX = this.cropper.getImageData().scaleX < 0 ? -scaleFactor : scaleFactor;
      this.cropper.scale(scaleFactorX, scaleFactor);
    }, this.state = {
      angle90Deg: 0,
      angleGranular: 0
    };
  }
  componentDidMount() {
    const {
      opts,
      storeCropperInstance
    } = this.props;
    this.cropper = new Cropper(this.imgElement, opts.cropperOptions), storeCropperInstance(this.cropper);
  }
  componentWillUnmount() {
    this.cropper.destroy();
  }
  renderGranularRotate() {
    const {
      i18n
    } = this.props, {
      angleGranular
    } = this.state;
    return (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      y$1("label", {
        "data-microtip-position": "top",
        role: "tooltip",
        "aria-label": `${angleGranular}º`,
        className: "uppy-ImageCropper-rangeWrapper uppy-u-reset"
      }, y$1("input", {
        className: "uppy-ImageCropper-range uppy-u-reset",
        type: "range",
        onInput: this.onRotateGranular,
        onChange: this.onRotateGranular,
        value: angleGranular,
        min: "-45",
        max: "44",
        "aria-label": i18n("rotate")
      }))
    );
  }
  renderRevert() {
    const {
      i18n
    } = this.props;
    return y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn",
      "aria-label": i18n("revert"),
      "data-microtip-position": "top",
      onClick: /* @__PURE__ */ __name(() => {
        this.cropper.reset(), this.cropper.setAspectRatio(0), this.setState({
          angle90Deg: 0,
          angleGranular: 0
        });
      }, "onClick")
    }, y$1("svg", {
      "aria-hidden": "true",
      className: "uppy-c-icon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, y$1("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), y$1("path", {
      d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
    })));
  }
  renderRotate() {
    const {
      i18n
    } = this.props;
    return y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn",
      onClick: this.onRotate90Deg,
      "aria-label": i18n("rotate"),
      "data-microtip-position": "top"
    }, y$1("svg", {
      "aria-hidden": "true",
      className: "uppy-c-icon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, y$1("path", {
      d: "M0 0h24v24H0V0zm0 0h24v24H0V0z",
      fill: "none"
    }), y$1("path", {
      d: "M14 10a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2v-7a2 2 0 012-2h8zm0 1.75H6a.25.25 0 00-.243.193L5.75 12v7a.25.25 0 00.193.243L6 19.25h8a.25.25 0 00.243-.193L14.25 19v-7a.25.25 0 00-.193-.243L14 11.75zM12 .76V4c2.3 0 4.61.88 6.36 2.64a8.95 8.95 0 012.634 6.025L21 13a1 1 0 01-1.993.117L19 13h-.003a6.979 6.979 0 00-2.047-4.95 6.97 6.97 0 00-4.652-2.044L12 6v3.24L7.76 5 12 .76z"
    })));
  }
  renderFlip() {
    const {
      i18n
    } = this.props;
    return y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn",
      "aria-label": i18n("flipHorizontal"),
      "data-microtip-position": "top",
      onClick: /* @__PURE__ */ __name(() => this.cropper.scaleX(-this.cropper.getData().scaleX || -1), "onClick")
    }, y$1("svg", {
      "aria-hidden": "true",
      className: "uppy-c-icon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, y$1("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), y$1("path", {
      d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
    })));
  }
  renderZoomIn() {
    const {
      i18n
    } = this.props;
    return y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn",
      "aria-label": i18n("zoomIn"),
      "data-microtip-position": "top",
      onClick: /* @__PURE__ */ __name(() => this.cropper.zoom(0.1), "onClick")
    }, y$1("svg", {
      "aria-hidden": "true",
      className: "uppy-c-icon",
      height: "24",
      viewBox: "0 0 24 24",
      width: "24"
    }, y$1("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }), y$1("path", {
      d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }), y$1("path", {
      d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
    })));
  }
  renderZoomOut() {
    const {
      i18n
    } = this.props;
    return y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn",
      "aria-label": i18n("zoomOut"),
      "data-microtip-position": "top",
      onClick: /* @__PURE__ */ __name(() => this.cropper.zoom(-0.1), "onClick")
    }, y$1("svg", {
      "aria-hidden": "true",
      className: "uppy-c-icon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, y$1("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }), y$1("path", {
      d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
    })));
  }
  renderCropSquare() {
    const {
      i18n
    } = this.props;
    return y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn",
      "aria-label": i18n("aspectRatioSquare"),
      "data-microtip-position": "top",
      onClick: /* @__PURE__ */ __name(() => this.cropper.setAspectRatio(1), "onClick")
    }, y$1("svg", {
      "aria-hidden": "true",
      className: "uppy-c-icon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, y$1("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), y$1("path", {
      d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    })));
  }
  renderCropWidescreen() {
    const {
      i18n
    } = this.props;
    return y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn",
      "aria-label": i18n("aspectRatioLandscape"),
      "data-microtip-position": "top",
      onClick: /* @__PURE__ */ __name(() => this.cropper.setAspectRatio(16 / 9), "onClick")
    }, y$1("svg", {
      "aria-hidden": "true",
      className: "uppy-c-icon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, y$1("path", {
      d: "M 19,4.9999992 V 17.000001 H 4.9999998 V 6.9999992 H 19 m 0,-2 H 4.9999998 c -1.0999999,0 -1.9999999,0.9000001 -1.9999999,2 V 17.000001 c 0,1.1 0.9,2 1.9999999,2 H 19 c 1.1,0 2,-0.9 2,-2 V 6.9999992 c 0,-1.0999999 -0.9,-2 -2,-2 z"
    }), y$1("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    })));
  }
  renderCropWidescreenVertical() {
    const {
      i18n
    } = this.props;
    return y$1("button", {
      type: "button",
      className: "uppy-u-reset uppy-c-btn",
      "aria-label": i18n("aspectRatioPortrait"),
      "data-microtip-position": "top",
      onClick: /* @__PURE__ */ __name(() => this.cropper.setAspectRatio(9 / 16), "onClick")
    }, y$1("svg", {
      "aria-hidden": "true",
      className: "uppy-c-icon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, y$1("path", {
      d: "M 19.000001,19 H 6.999999 V 5 h 10.000002 v 14 m 2,0 V 5 c 0,-1.0999999 -0.9,-1.9999999 -2,-1.9999999 H 6.999999 c -1.1,0 -2,0.9 -2,1.9999999 v 14 c 0,1.1 0.9,2 2,2 h 10.000002 c 1.1,0 2,-0.9 2,-2 z"
    }), y$1("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })));
  }
  render() {
    const {
      currentImage,
      opts
    } = this.props, {
      actions
    } = opts, imageURL = URL.createObjectURL(currentImage.data);
    return y$1("div", {
      className: "uppy-ImageCropper"
    }, y$1("div", {
      className: "uppy-ImageCropper-container"
    }, y$1("img", {
      className: "uppy-ImageCropper-image",
      alt: currentImage.name,
      src: imageURL,
      ref: /* @__PURE__ */ __name((ref) => {
        this.imgElement = ref;
      }, "ref")
    })), y$1("div", {
      className: "uppy-ImageCropper-controls"
    }, actions.revert && this.renderRevert(), actions.rotate && this.renderRotate(), actions.granularRotate && this.renderGranularRotate(), actions.flip && this.renderFlip(), actions.zoomIn && this.renderZoomIn(), actions.zoomOut && this.renderZoomOut(), actions.cropSquare && this.renderCropSquare(), actions.cropWidescreen && this.renderCropWidescreen(), actions.cropWidescreenVertical && this.renderCropWidescreenVertical()));
  }
};
__name(_Editor, "Editor");
let Editor = _Editor;
const locale$e = {
  strings: {
    revert: "Revert",
    rotate: "Rotate",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    flipHorizontal: "Flip horizontal",
    aspectRatioSquare: "Crop square",
    aspectRatioLandscape: "Crop landscape (16:9)",
    aspectRatioPortrait: "Crop portrait (9:16)"
  }
}, packageJson$m = {
  version: "2.2.0"
}, _ImageEditor = class _ImageEditor extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.save = () => {
      const saveBlobCallback = /* @__PURE__ */ __name((blob) => {
        const {
          currentImage: currentImage2
        } = this.getPluginState();
        this.uppy.setFileState(currentImage2.id, {
          data: blob,
          size: blob.size,
          preview: null
        });
        const updatedFile = this.uppy.getFile(currentImage2.id);
        this.uppy.emit("thumbnail:request", updatedFile), this.setPluginState({
          currentImage: updatedFile
        }), this.uppy.emit("file-editor:complete", updatedFile);
      }, "saveBlobCallback"), {
        currentImage
      } = this.getPluginState();
      this.cropper.getCroppedCanvas(this.opts.cropperOptions.croppedCanvasOptions).toBlob(saveBlobCallback, currentImage.type, this.opts.quality);
    }, this.storeCropperInstance = (cropper) => {
      this.cropper = cropper;
    }, this.selectFile = (file) => {
      this.uppy.emit("file-editor:start", file), this.setPluginState({
        currentImage: file
      });
    }, this.id = this.opts.id || "ImageEditor", this.title = "Image Editor", this.type = "editor", this.defaultLocale = locale$e;
    const defaultCropperOptions = {
      viewMode: 0,
      background: !1,
      autoCropArea: 1,
      responsive: !0,
      croppedCanvasOptions: {}
    }, defaultActions = {
      revert: !0,
      rotate: !0,
      granularRotate: !0,
      flip: !0,
      zoomIn: !0,
      zoomOut: !0,
      cropSquare: !0,
      cropWidescreen: !0,
      cropWidescreenVertical: !0
    }, defaultOptions2 = {
      quality: 0.8
    };
    this.opts = {
      ...defaultOptions2,
      ...opts,
      actions: {
        ...defaultActions,
        ...opts.actions
      },
      cropperOptions: {
        ...defaultCropperOptions,
        ...opts.cropperOptions
      }
    }, this.i18nInit();
  }
  // eslint-disable-next-line class-methods-use-this
  canEditFile(file) {
    if (!file.type || file.isRemote)
      return !1;
    const fileTypeSpecific = file.type.split("/")[1];
    return !!/^(jpe?g|gif|png|bmp|webp)$/.test(fileTypeSpecific);
  }
  install() {
    this.setPluginState({
      currentImage: null
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    const {
      currentImage
    } = this.getPluginState();
    if (currentImage) {
      const file = this.uppy.getFile(currentImage.id);
      this.uppy.emit("file-editor:cancel", file);
    }
    this.unmount();
  }
  render() {
    const {
      currentImage
    } = this.getPluginState();
    return currentImage === null || currentImage.isRemote ? null : y$1(Editor, {
      currentImage,
      storeCropperInstance: this.storeCropperInstance,
      save: this.save,
      opts: this.opts,
      i18n: this.i18n
    });
  }
};
__name(_ImageEditor, "ImageEditor");
let ImageEditor = _ImageEditor;
ImageEditor.VERSION = packageJson$m.version;
const packageJson$l = {
  version: "3.0.3"
}, _ProgressBar = class _ProgressBar extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "ProgressBar", this.title = "Progress Bar", this.type = "progressindicator";
    const defaultOptions2 = {
      target: "body",
      fixed: !1,
      hideAfterFinish: !0
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.render = this.render.bind(this);
  }
  render(state) {
    const progress = state.totalProgress || 0, isHidden = (progress === 0 || progress === 100) && this.opts.hideAfterFinish;
    return y$1("div", {
      className: "uppy uppy-ProgressBar",
      style: {
        position: this.opts.fixed ? "fixed" : "initial"
      },
      "aria-hidden": isHidden
    }, y$1("div", {
      className: "uppy-ProgressBar-inner",
      style: {
        width: `${progress}%`
      }
    }), y$1("div", {
      className: "uppy-ProgressBar-percentage"
    }, progress));
  }
  install() {
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.unmount();
  }
};
__name(_ProgressBar, "ProgressBar");
let ProgressBar = _ProgressBar;
ProgressBar.VERSION = packageJson$l.version;
const mimeToExtensions = {
  "audio/mp3": "mp3",
  "audio/mp4": "mp4",
  "audio/ogg": "ogg",
  "audio/webm": "webm",
  "image/gif": "gif",
  "image/heic": "heic",
  "image/heif": "heif",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/svg+xml": "svg",
  "video/mp4": "mp4",
  "video/ogg": "ogv",
  "video/quicktime": "mov",
  "video/webm": "webm",
  "video/x-matroska": "mkv",
  "video/x-msvideo": "avi"
};
function getFileTypeExtension(mimeType) {
  return [mimeType] = mimeType.split(";", 1), mimeToExtensions[mimeType] || null;
}
__name(getFileTypeExtension, "getFileTypeExtension");
function supportsMediaRecorder$1() {
  var _MediaRecorder$protot;
  return typeof MediaRecorder == "function" && typeof ((_MediaRecorder$protot = MediaRecorder.prototype) == null ? void 0 : _MediaRecorder$protot.start) == "function";
}
__name(supportsMediaRecorder$1, "supportsMediaRecorder$1");
function RecordButton$2(_ref) {
  let {
    recording,
    onStartRecording,
    onStopRecording,
    i18n
  } = _ref;
  return recording ? y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Audio-button",
    type: "button",
    title: i18n("stopAudioRecording"),
    "aria-label": i18n("stopAudioRecording"),
    onClick: onStopRecording,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "100",
    height: "100",
    viewBox: "0 0 100 100"
  }, y$1("rect", {
    x: "15",
    y: "15",
    width: "70",
    height: "70"
  }))) : y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Audio-button",
    type: "button",
    title: i18n("startAudioRecording"),
    "aria-label": i18n("startAudioRecording"),
    onClick: onStartRecording,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "14px",
    height: "20px",
    viewBox: "0 0 14 20"
  }, y$1("path", {
    d: "M7 14c2.21 0 4-1.71 4-3.818V3.818C11 1.71 9.21 0 7 0S3 1.71 3 3.818v6.364C3 12.29 4.79 14 7 14zm6.364-7h-.637a.643.643 0 0 0-.636.65V9.6c0 3.039-2.565 5.477-5.6 5.175-2.645-.264-4.582-2.692-4.582-5.407V7.65c0-.36-.285-.65-.636-.65H.636A.643.643 0 0 0 0 7.65v1.631c0 3.642 2.544 6.888 6.045 7.382v1.387H3.818a.643.643 0 0 0-.636.65v.65c0 .36.285.65.636.65h6.364c.351 0 .636-.29.636-.65v-.65c0-.36-.285-.65-.636-.65H7.955v-1.372C11.363 16.2 14 13.212 14 9.6V7.65c0-.36-.285-.65-.636-.65z",
    fill: "#FFF",
    "fill-rule": "nonzero"
  })));
}
__name(RecordButton$2, "RecordButton$2");
function formatSeconds$1(seconds) {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, 0)}`;
}
__name(formatSeconds$1, "formatSeconds$1");
function RecordingLength$1(_ref) {
  let {
    recordingLengthSeconds,
    i18n
  } = _ref;
  const formattedRecordingLengthSeconds = formatSeconds$1(recordingLengthSeconds);
  return y$1("span", {
    "aria-label": i18n("recordingLength", {
      recording_length: formattedRecordingLengthSeconds
    })
  }, formattedRecordingLengthSeconds);
}
__name(RecordingLength$1, "RecordingLength$1");
const AudioSourceSelect = /* @__PURE__ */ __name((_ref) => {
  let {
    currentDeviceId,
    audioSources,
    onChangeSource
  } = _ref;
  return y$1("div", {
    className: "uppy-Audio-videoSource"
  }, y$1("select", {
    className: "uppy-u-reset uppy-Audio-audioSource-select",
    onChange: /* @__PURE__ */ __name((event) => {
      onChangeSource(event.target.value);
    }, "onChange")
  }, audioSources.map((audioSource) => y$1("option", {
    key: audioSource.deviceId,
    value: audioSource.deviceId,
    selected: audioSource.deviceId === currentDeviceId
  }, audioSource.label))));
}, "AudioSourceSelect");
function _classPrivateFieldLooseBase$i(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$i, "_classPrivateFieldLooseBase$i");
var id$i = 0;
function _classPrivateFieldLooseKey$i(name) {
  return "__private_" + id$i++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$i, "_classPrivateFieldLooseKey$i");
function isFunction$1(v2) {
  return typeof v2 == "function";
}
__name(isFunction$1, "isFunction$1");
function result(v2) {
  return isFunction$1(v2) ? v2() : v2;
}
__name(result, "result");
var _draw = /* @__PURE__ */ _classPrivateFieldLooseKey$i("draw");
const _AudioOscilloscope = class _AudioOscilloscope {
  constructor(canvas, options) {
    options === void 0 && (options = {}), Object.defineProperty(this, _draw, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => this.draw(), "value")
    });
    const canvasOptions = options.canvas || {}, canvasContextOptions = options.canvasContext || {};
    this.analyser = null, this.bufferLength = 0, this.dataArray = [], this.canvas = canvas, this.width = result(canvasOptions.width) || this.canvas.width, this.height = result(canvasOptions.height) || this.canvas.height, this.canvas.width = this.width, this.canvas.height = this.height, this.canvasContext = this.canvas.getContext("2d"), this.canvasContext.fillStyle = result(canvasContextOptions.fillStyle) || "rgb(255, 255, 255)", this.canvasContext.strokeStyle = result(canvasContextOptions.strokeStyle) || "rgb(0, 0, 0)", this.canvasContext.lineWidth = result(canvasContextOptions.lineWidth) || 1, this.onDrawFrame = isFunction$1(options.onDrawFrame) ? options.onDrawFrame : () => {
    };
  }
  addSource(streamSource) {
    this.streamSource = streamSource, this.audioContext = this.streamSource.context, this.analyser = this.audioContext.createAnalyser(), this.analyser.fftSize = 2048, this.bufferLength = this.analyser.frequencyBinCount, this.source = this.audioContext.createBufferSource(), this.dataArray = new Uint8Array(this.bufferLength), this.analyser.getByteTimeDomainData(this.dataArray), this.streamSource.connect(this.analyser);
  }
  draw() {
    const {
      analyser,
      dataArray,
      bufferLength
    } = this, ctx = this.canvasContext, w2 = this.width, h2 = this.height;
    analyser && analyser.getByteTimeDomainData(dataArray), ctx.fillRect(0, 0, w2, h2), ctx.beginPath();
    const sliceWidth = w2 * 1 / bufferLength;
    let x2 = 0;
    bufferLength || ctx.moveTo(0, this.height / 2);
    for (let i2 = 0; i2 < bufferLength; i2++) {
      const y2 = dataArray[i2] / 128 * (h2 / 2);
      i2 === 0 ? ctx.moveTo(x2, y2) : ctx.lineTo(x2, y2), x2 += sliceWidth;
    }
    ctx.lineTo(w2, h2 / 2), ctx.stroke(), this.onDrawFrame(this), requestAnimationFrame(_classPrivateFieldLooseBase$i(this, _draw)[_draw]);
  }
};
__name(_AudioOscilloscope, "AudioOscilloscope");
let AudioOscilloscope = _AudioOscilloscope;
function SubmitButton$2(_ref) {
  let {
    onSubmit,
    i18n
  } = _ref;
  return y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Audio-button uppy-Audio-button--submit",
    type: "button",
    title: i18n("submitRecordedFile"),
    "aria-label": i18n("submitRecordedFile"),
    onClick: onSubmit,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    width: "12",
    height: "9",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon"
  }, y$1("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M10.66 0L12 1.31 4.136 9 0 4.956l1.34-1.31L4.136 6.38z"
  })));
}
__name(SubmitButton$2, "SubmitButton$2");
function DiscardButton$1(_ref) {
  let {
    onDiscard,
    i18n
  } = _ref;
  return y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Audio-button",
    type: "button",
    title: i18n("discardRecordedFile"),
    "aria-label": i18n("discardRecordedFile"),
    onClick: onDiscard,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "uppy-c-icon"
  }, y$1("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, y$1("path", {
    d: "M.496 11.367L11.103.76l1.414 1.414L1.911 12.781z"
  }), y$1("path", {
    d: "M11.104 12.782L.497 2.175 1.911.76l10.607 10.606z"
  }))));
}
__name(DiscardButton$1, "DiscardButton$1");
function RecordingScreen(props) {
  const {
    stream,
    recordedAudio,
    onStop,
    recording,
    supportsRecording,
    audioSources,
    showAudioSourceDropdown,
    onSubmit,
    i18n,
    onStartRecording,
    onStopRecording,
    onDiscardRecordedAudio,
    recordingLengthSeconds
  } = props, canvasEl = _$1(null), oscilloscope = _$1(null);
  p$1(() => () => {
    oscilloscope.current = null, onStop();
  }, [onStop]), p$1(() => {
    if (!recordedAudio && (oscilloscope.current = new AudioOscilloscope(canvasEl.current, {
      canvas: {
        width: 600,
        height: 600
      },
      canvasContext: {
        lineWidth: 2,
        fillStyle: "rgb(0,0,0)",
        strokeStyle: "green"
      }
    }), oscilloscope.current.draw(), stream)) {
      const source = new AudioContext().createMediaStreamSource(stream);
      oscilloscope.current.addSource(source);
    }
  }, [recordedAudio, stream]);
  const hasRecordedAudio = recordedAudio != null, shouldShowRecordButton = !hasRecordedAudio && supportsRecording, shouldShowAudioSourceDropdown = showAudioSourceDropdown && !hasRecordedAudio && audioSources && audioSources.length > 1;
  return y$1("div", {
    className: "uppy-Audio-container"
  }, y$1("div", {
    className: "uppy-Audio-audioContainer"
  }, hasRecordedAudio ? y$1("audio", {
    className: "uppy-Audio-player",
    controls: !0,
    src: recordedAudio
  }) : y$1("canvas", {
    ref: canvasEl,
    className: "uppy-Audio-canvas"
  })), y$1("div", {
    className: "uppy-Audio-footer"
  }, y$1("div", {
    className: "uppy-Audio-audioSourceContainer"
  }, shouldShowAudioSourceDropdown ? AudioSourceSelect(props) : null), y$1("div", {
    className: "uppy-Audio-buttonContainer"
  }, shouldShowRecordButton && y$1(RecordButton$2, {
    recording,
    onStartRecording,
    onStopRecording,
    i18n
  }), hasRecordedAudio && y$1(SubmitButton$2, {
    onSubmit,
    i18n
  }), hasRecordedAudio && y$1(DiscardButton$1, {
    onDiscard: onDiscardRecordedAudio,
    i18n
  })), y$1("div", {
    className: "uppy-Audio-recordingLength"
  }, !hasRecordedAudio && y$1(RecordingLength$1, {
    recordingLengthSeconds,
    i18n
  }))));
}
__name(RecordingScreen, "RecordingScreen");
const PermissionsScreen$1 = /* @__PURE__ */ __name((props) => {
  const {
    icon,
    hasAudio,
    i18n
  } = props;
  return y$1("div", {
    className: "uppy-Audio-permissons"
  }, y$1("div", {
    className: "uppy-Audio-permissonsIcon"
  }, icon()), y$1("h1", {
    className: "uppy-Audio-title"
  }, i18n(hasAudio ? "allowAudioAccessTitle" : "noAudioTitle")), y$1("p", null, i18n(hasAudio ? "allowAudioAccessDescription" : "noAudioDescription")));
}, "PermissionsScreen$1"), locale$d = {
  strings: {
    pluginNameAudio: "Audio",
    // Used as the label for the button that starts an audio recording.
    // This is not visibly rendered but is picked up by screen readers.
    startAudioRecording: "Begin audio recording",
    // Used as the label for the button that stops an audio recording.
    // This is not visibly rendered but is picked up by screen readers.
    stopAudioRecording: "Stop audio recording",
    // Title on the “allow access” screen
    allowAudioAccessTitle: "Please allow access to your microphone",
    // Description on the “allow access” screen
    allowAudioAccessDescription: "In order to record audio, please allow microphone access for this site.",
    // Title on the “device not available” screen
    noAudioTitle: "Microphone Not Available",
    // Description on the “device not available” screen
    noAudioDescription: "In order to record audio, please connect a microphone or another audio input device",
    // Message about file size will be shown in an Informer bubble
    recordingStoppedMaxSize: "Recording stopped because the file size is about to exceed the limit",
    // Used as the label for the counter that shows recording length (`1:25`).
    // This is not visibly rendered but is picked up by screen readers.
    recordingLength: "Recording length %{recording_length}",
    // Used as the label for the submit checkmark button.
    // This is not visibly rendered but is picked up by screen readers.
    submitRecordedFile: "Submit recorded file",
    // Used as the label for the discard cross button.
    // This is not visibly rendered but is picked up by screen readers.
    discardRecordedFile: "Discard recorded file"
  }
};
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$5.apply(this, arguments);
}
__name(_extends$5, "_extends$5");
function _classPrivateFieldLooseBase$h(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$h, "_classPrivateFieldLooseBase$h");
var id$h = 0;
function _classPrivateFieldLooseKey$h(name) {
  return "__private_" + id$h++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$h, "_classPrivateFieldLooseKey$h");
const packageJson$k = {
  version: "1.1.2"
};
var _stream = /* @__PURE__ */ _classPrivateFieldLooseKey$h("stream"), _audioActive = /* @__PURE__ */ _classPrivateFieldLooseKey$h("audioActive"), _recordingChunks = /* @__PURE__ */ _classPrivateFieldLooseKey$h("recordingChunks"), _recorder = /* @__PURE__ */ _classPrivateFieldLooseKey$h("recorder"), _capturedMediaFile = /* @__PURE__ */ _classPrivateFieldLooseKey$h("capturedMediaFile"), _mediaDevices = /* @__PURE__ */ _classPrivateFieldLooseKey$h("mediaDevices"), _supportsUserMedia = /* @__PURE__ */ _classPrivateFieldLooseKey$h("supportsUserMedia"), _hasAudioCheck = /* @__PURE__ */ _classPrivateFieldLooseKey$h("hasAudioCheck"), _start = /* @__PURE__ */ _classPrivateFieldLooseKey$h("start"), _startRecording = /* @__PURE__ */ _classPrivateFieldLooseKey$h("startRecording"), _stopRecording = /* @__PURE__ */ _classPrivateFieldLooseKey$h("stopRecording"), _discardRecordedAudio = /* @__PURE__ */ _classPrivateFieldLooseKey$h("discardRecordedAudio"), _submit = /* @__PURE__ */ _classPrivateFieldLooseKey$h("submit"), _stop = /* @__PURE__ */ _classPrivateFieldLooseKey$h("stop"), _getAudio = /* @__PURE__ */ _classPrivateFieldLooseKey$h("getAudio"), _changeSource = /* @__PURE__ */ _classPrivateFieldLooseKey$h("changeSource"), _updateSources = /* @__PURE__ */ _classPrivateFieldLooseKey$h("updateSources");
const _Audio = class _Audio extends UIPlugin {
  constructor(uppy, opts) {
    var _this;
    super(uppy, opts), _this = this, Object.defineProperty(this, _getAudio, {
      value: _getAudio2
    }), Object.defineProperty(this, _hasAudioCheck, {
      value: _hasAudioCheck2
    }), Object.defineProperty(this, _stream, {
      writable: !0,
      value: null
    }), Object.defineProperty(this, _audioActive, {
      writable: !0,
      value: !1
    }), Object.defineProperty(this, _recordingChunks, {
      writable: !0,
      value: null
    }), Object.defineProperty(this, _recorder, {
      writable: !0,
      value: null
    }), Object.defineProperty(this, _capturedMediaFile, {
      writable: !0,
      value: null
    }), Object.defineProperty(this, _mediaDevices, {
      writable: !0,
      value: null
    }), Object.defineProperty(this, _supportsUserMedia, {
      writable: !0,
      value: null
    }), Object.defineProperty(this, _start, {
      writable: !0,
      value: /* @__PURE__ */ __name(function(options) {
        if (options === void 0 && (options = null), !_classPrivateFieldLooseBase$h(_this, _supportsUserMedia)[_supportsUserMedia])
          return Promise.reject(new Error("Microphone access not supported"));
        _classPrivateFieldLooseBase$h(_this, _audioActive)[_audioActive] = !0, _classPrivateFieldLooseBase$h(_this, _hasAudioCheck)[_hasAudioCheck]().then((hasAudio) => (_this.setPluginState({
          hasAudio
        }), _classPrivateFieldLooseBase$h(_this, _mediaDevices)[_mediaDevices].getUserMedia({
          audio: !0
        }).then((stream) => {
          _classPrivateFieldLooseBase$h(_this, _stream)[_stream] = stream;
          let currentDeviceId = null;
          const tracks = stream.getAudioTracks();
          !options || !options.deviceId ? currentDeviceId = tracks[0].getSettings().deviceId : tracks.forEach((track) => {
            track.getSettings().deviceId === options.deviceId && (currentDeviceId = track.getSettings().deviceId);
          }), _classPrivateFieldLooseBase$h(_this, _updateSources)[_updateSources](), _this.setPluginState({
            currentDeviceId,
            audioReady: !0
          });
        }).catch((err) => {
          _this.setPluginState({
            audioReady: !1,
            cameraError: err
          }), _this.uppy.info(err.message, "error");
        })));
      }, "value")
    }), Object.defineProperty(this, _startRecording, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        _classPrivateFieldLooseBase$h(this, _recorder)[_recorder] = new MediaRecorder(_classPrivateFieldLooseBase$h(this, _stream)[_stream]), _classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks] = [];
        let stoppingBecauseOfMaxSize = !1;
        _classPrivateFieldLooseBase$h(this, _recorder)[_recorder].addEventListener("dataavailable", (event) => {
          _classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks].push(event.data);
          const {
            restrictions
          } = this.uppy.opts;
          if (_classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks].length > 1 && restrictions.maxFileSize != null && !stoppingBecauseOfMaxSize) {
            const totalSize = _classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks].reduce((acc, chunk2) => acc + chunk2.size, 0), expectedEndChunkSize = (totalSize - _classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks][0].size) / (_classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks].length - 1) * 3, maxSize = Math.max(0, restrictions.maxFileSize - expectedEndChunkSize);
            totalSize > maxSize && (stoppingBecauseOfMaxSize = !0, this.uppy.info(this.i18n("recordingStoppedMaxSize"), "warning", 4e3), _classPrivateFieldLooseBase$h(this, _stopRecording)[_stopRecording]());
          }
        }), _classPrivateFieldLooseBase$h(this, _recorder)[_recorder].start(500), this.recordingLengthTimer = setInterval(() => {
          const currentRecordingLength = this.getPluginState().recordingLengthSeconds;
          this.setPluginState({
            recordingLengthSeconds: currentRecordingLength + 1
          });
        }, 1e3), this.setPluginState({
          isRecording: !0
        });
      }, "value")
    }), Object.defineProperty(this, _stopRecording, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => new Promise((resolve3) => {
        _classPrivateFieldLooseBase$h(this, _recorder)[_recorder].addEventListener("stop", () => {
          resolve3();
        }), _classPrivateFieldLooseBase$h(this, _recorder)[_recorder].stop(), clearInterval(this.recordingLengthTimer), this.setPluginState({
          recordingLengthSeconds: 0
        });
      }).then(() => (this.setPluginState({
        isRecording: !1
      }), _classPrivateFieldLooseBase$h(this, _getAudio)[_getAudio]())).then((file) => {
        try {
          _classPrivateFieldLooseBase$h(this, _capturedMediaFile)[_capturedMediaFile] = file, this.setPluginState({
            recordedAudio: URL.createObjectURL(file.data)
          });
        } catch (err) {
          err.isRestriction || this.uppy.log(err);
        }
      }).then(() => {
        _classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks] = null, _classPrivateFieldLooseBase$h(this, _recorder)[_recorder] = null;
      }, (error) => {
        throw _classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks] = null, _classPrivateFieldLooseBase$h(this, _recorder)[_recorder] = null, error;
      }), "value")
    }), Object.defineProperty(this, _discardRecordedAudio, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        this.setPluginState({
          recordedAudio: null
        }), _classPrivateFieldLooseBase$h(this, _capturedMediaFile)[_capturedMediaFile] = null;
      }, "value")
    }), Object.defineProperty(this, _submit, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        try {
          _classPrivateFieldLooseBase$h(this, _capturedMediaFile)[_capturedMediaFile] && this.uppy.addFile(_classPrivateFieldLooseBase$h(this, _capturedMediaFile)[_capturedMediaFile]);
        } catch (err) {
          err.isRestriction || this.uppy.log(err, "warning");
        }
      }, "value")
    }), Object.defineProperty(this, _stop, {
      writable: !0,
      value: /* @__PURE__ */ __name(async () => {
        _classPrivateFieldLooseBase$h(this, _stream)[_stream] && _classPrivateFieldLooseBase$h(this, _stream)[_stream].getAudioTracks().forEach((track) => track.stop()), _classPrivateFieldLooseBase$h(this, _recorder)[_recorder] && await new Promise((resolve3) => {
          _classPrivateFieldLooseBase$h(this, _recorder)[_recorder].addEventListener("stop", resolve3, {
            once: !0
          }), _classPrivateFieldLooseBase$h(this, _recorder)[_recorder].stop(), clearInterval(this.recordingLengthTimer);
        }), _classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks] = null, _classPrivateFieldLooseBase$h(this, _recorder)[_recorder] = null, _classPrivateFieldLooseBase$h(this, _audioActive)[_audioActive] = !1, _classPrivateFieldLooseBase$h(this, _stream)[_stream] = null, this.setPluginState({
          recordedAudio: null,
          isRecording: !1,
          recordingLengthSeconds: 0
        });
      }, "value")
    }), Object.defineProperty(this, _changeSource, {
      writable: !0,
      value: /* @__PURE__ */ __name((deviceId) => {
        _classPrivateFieldLooseBase$h(this, _stop)[_stop](), _classPrivateFieldLooseBase$h(this, _start)[_start]({
          deviceId
        });
      }, "value")
    }), Object.defineProperty(this, _updateSources, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        _classPrivateFieldLooseBase$h(this, _mediaDevices)[_mediaDevices].enumerateDevices().then((devices) => {
          this.setPluginState({
            audioSources: devices.filter((device) => device.kind === "audioinput")
          });
        });
      }, "value")
    }), _classPrivateFieldLooseBase$h(this, _mediaDevices)[_mediaDevices] = navigator.mediaDevices, _classPrivateFieldLooseBase$h(this, _supportsUserMedia)[_supportsUserMedia] = _classPrivateFieldLooseBase$h(this, _mediaDevices)[_mediaDevices] != null, this.id = this.opts.id || "Audio", this.type = "acquirer", this.icon = () => y$1("svg", {
      className: "uppy-DashboardTab-iconAudio",
      "aria-hidden": "true",
      focusable: "false",
      width: "32px",
      height: "32px",
      viewBox: "0 0 32 32"
    }, y$1("path", {
      d: "M21.143 12.297c.473 0 .857.383.857.857v2.572c0 3.016-2.24 5.513-5.143 5.931v2.64h2.572a.857.857 0 110 1.714H12.57a.857.857 0 110-1.714h2.572v-2.64C12.24 21.24 10 18.742 10 15.726v-2.572a.857.857 0 111.714 0v2.572A4.29 4.29 0 0016 20.01a4.29 4.29 0 004.286-4.285v-2.572c0-.474.384-.857.857-.857zM16 6.5a3 3 0 013 3v6a3 3 0 01-6 0v-6a3 3 0 013-3z",
      fill: "currentcolor",
      "fill-rule": "nonzero"
    })), this.defaultLocale = locale$d, this.opts = {
      ...opts
    }, this.i18nInit(), this.title = this.i18n("pluginNameAudio"), this.setPluginState({
      hasAudio: !1,
      audioReady: !1,
      cameraError: null,
      recordingLengthSeconds: 0,
      audioSources: [],
      currentDeviceId: null
    });
  }
  render() {
    _classPrivateFieldLooseBase$h(this, _audioActive)[_audioActive] || _classPrivateFieldLooseBase$h(this, _start)[_start]();
    const audioState = this.getPluginState();
    return !audioState.audioReady || !audioState.hasAudio ? y$1(PermissionsScreen$1, {
      icon: this.icon,
      i18n: this.i18n,
      hasAudio: audioState.hasAudio
    }) : y$1(
      RecordingScreen,
      _extends$5({}, audioState, {
        audioActive: _classPrivateFieldLooseBase$h(this, _audioActive)[_audioActive],
        onChangeSource: _classPrivateFieldLooseBase$h(this, _changeSource)[_changeSource],
        onStartRecording: _classPrivateFieldLooseBase$h(this, _startRecording)[_startRecording],
        onStopRecording: _classPrivateFieldLooseBase$h(this, _stopRecording)[_stopRecording],
        onDiscardRecordedAudio: _classPrivateFieldLooseBase$h(this, _discardRecordedAudio)[_discardRecordedAudio],
        onSubmit: _classPrivateFieldLooseBase$h(this, _submit)[_submit],
        onStop: _classPrivateFieldLooseBase$h(this, _stop)[_stop],
        i18n: this.i18n,
        showAudioSourceDropdown: this.opts.showAudioSourceDropdown,
        supportsRecording: supportsMediaRecorder$1(),
        recording: audioState.isRecording,
        stream: _classPrivateFieldLooseBase$h(this, _stream)[_stream]
      })
    );
  }
  install() {
    this.setPluginState({
      audioReady: !1,
      recordingLengthSeconds: 0
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this), _classPrivateFieldLooseBase$h(this, _mediaDevices)[_mediaDevices] && (_classPrivateFieldLooseBase$h(this, _updateSources)[_updateSources](), _classPrivateFieldLooseBase$h(this, _mediaDevices)[_mediaDevices].ondevicechange = () => {
      if (_classPrivateFieldLooseBase$h(this, _updateSources)[_updateSources](), _classPrivateFieldLooseBase$h(this, _stream)[_stream]) {
        let restartStream = !0;
        const {
          audioSources,
          currentDeviceId
        } = this.getPluginState();
        audioSources.forEach((audioSource) => {
          currentDeviceId === audioSource.deviceId && (restartStream = !1);
        }), restartStream && (_classPrivateFieldLooseBase$h(this, _stop)[_stop](), _classPrivateFieldLooseBase$h(this, _start)[_start]());
      }
    });
  }
  uninstall() {
    _classPrivateFieldLooseBase$h(this, _stream)[_stream] && _classPrivateFieldLooseBase$h(this, _stop)[_stop](), this.unmount();
  }
};
__name(_Audio, "Audio");
let Audio = _Audio;
function _hasAudioCheck2() {
  return _classPrivateFieldLooseBase$h(this, _mediaDevices)[_mediaDevices] ? _classPrivateFieldLooseBase$h(this, _mediaDevices)[_mediaDevices].enumerateDevices().then((devices) => devices.some((device) => device.kind === "audioinput")) : Promise.resolve(!1);
}
__name(_hasAudioCheck2, "_hasAudioCheck2");
function _getAudio2() {
  const mimeType = _classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks].find((blob2) => {
    var _blob$type;
    return ((_blob$type = blob2.type) == null ? void 0 : _blob$type.length) > 0;
  }).type, fileExtension = getFileTypeExtension(mimeType);
  if (!fileExtension)
    return Promise.reject(new Error(`Could not retrieve recording: Unsupported media type "${mimeType}"`));
  const name = `audio-${Date.now()}.${fileExtension}`, blob = new Blob(_classPrivateFieldLooseBase$h(this, _recordingChunks)[_recordingChunks], {
    type: mimeType
  }), file = {
    source: this.id,
    name,
    data: new Blob([blob], {
      type: mimeType
    }),
    type: mimeType
  };
  return Promise.resolve(file);
}
__name(_getAudio2, "_getAudio2");
Audio.VERSION = packageJson$k.version;
const locale$c = {
  strings: {
    pluginNameBox: "Box"
  }
}, packageJson$j = {
  version: "2.1.3"
}, _Box = class _Box extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "Box", Provider.initPlugin(this, opts), this.title = this.opts.title || "Box", this.icon = () => y$1("svg", {
      className: "uppy-DashboardTab-iconBox",
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("g", {
      fill: "currentcolor",
      fillRule: "nonzero"
    }, y$1("path", {
      d: "m16.4 13.5c-1.6 0-3 0.9-3.7 2.2-0.7-1.3-2.1-2.2-3.7-2.2-1 0-1.8 0.3-2.5 0.8v-3.6c-0.1-0.3-0.5-0.7-1-0.7s-0.8 0.4-0.8 0.8v7c0 2.3 1.9 4.2 4.2 4.2 1.6 0 3-0.9 3.7-2.2 0.7 1.3 2.1 2.2 3.7 2.2 2.3 0 4.2-1.9 4.2-4.2 0.1-2.4-1.8-4.3-4.1-4.3m-7.5 6.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5m7.5 0c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5"
    }), y$1("path", {
      d: "m27.2 20.6l-2.3-2.8 2.3-2.8c0.3-0.4 0.2-0.9-0.2-1.2s-1-0.2-1.3 0.2l-2 2.4-2-2.4c-0.3-0.4-0.9-0.4-1.3-0.2-0.4 0.3-0.5 0.8-0.2 1.2l2.3 2.8-2.3 2.8c-0.3 0.4-0.2 0.9 0.2 1.2s1 0.2 1.3-0.2l2-2.4 2 2.4c0.3 0.4 0.9 0.4 1.3 0.2 0.4-0.3 0.4-0.8 0.2-1.2"
    }))), this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: "box",
      pluginId: this.id
    }), this.defaultLocale = locale$c, this.i18nInit(), this.title = this.i18n("pluginNameBox"), this.onFirstRender = this.onFirstRender.bind(this), this.render = this.render.bind(this);
  }
  install() {
    this.view = new ProviderView(this, {
      provider: this.provider,
      loadAllFiles: !0
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.view.tearDown(), this.unmount();
  }
  onFirstRender() {
    return this.view.getFolder();
  }
  render(state) {
    return this.view.render(state);
  }
};
__name(_Box, "Box");
let Box = _Box;
Box.VERSION = packageJson$j.version;
const locale$b = {
  strings: {
    pluginNameDropbox: "Dropbox"
  }
}, packageJson$i = {
  version: "3.1.3"
}, _Dropbox = class _Dropbox extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "Dropbox", Provider.initPlugin(this, opts), this.title = this.opts.title || "Dropbox", this.icon = () => y$1("svg", {
      className: "uppy-DashboardTab-iconDropbox",
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("path", {
      d: "M10.5 7.5L5 10.955l5.5 3.454 5.5-3.454 5.5 3.454 5.5-3.454L21.5 7.5 16 10.955zM10.5 21.319L5 17.864l5.5-3.455 5.5 3.455zM16 17.864l5.5-3.455 5.5 3.455-5.5 3.455zM16 25.925l-5.5-3.455 5.5-3.454 5.5 3.454z",
      fill: "currentcolor",
      fillRule: "nonzero"
    })), this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: "dropbox",
      pluginId: this.id
    }), this.defaultLocale = locale$b, this.i18nInit(), this.title = this.i18n("pluginNameDropbox"), this.onFirstRender = this.onFirstRender.bind(this), this.render = this.render.bind(this);
  }
  install() {
    this.view = new ProviderView(this, {
      provider: this.provider,
      loadAllFiles: !0
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.view.tearDown(), this.unmount();
  }
  onFirstRender() {
    return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder()]);
  }
  render(state) {
    return this.view.render(state);
  }
};
__name(_Dropbox, "Dropbox");
let Dropbox = _Dropbox;
Dropbox.VERSION = packageJson$i.version;
const locale$a = {
  strings: {
    pluginNameFacebook: "Facebook"
  }
}, packageJson$h = {
  version: "3.1.2"
}, _Facebook = class _Facebook extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "Facebook", Provider.initPlugin(this, opts), this.title = this.opts.title || "Facebook", this.icon = () => y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("g", {
      fill: "none",
      fillRule: "evenodd"
    }, y$1("path", {
      d: "M27 16c0-6.075-4.925-11-11-11S5 9.925 5 16c0 5.49 4.023 10.041 9.281 10.866V19.18h-2.793V16h2.793v-2.423c0-2.757 1.642-4.28 4.155-4.28 1.204 0 2.462.215 2.462.215v2.707h-1.387c-1.366 0-1.792.848-1.792 1.718V16h3.05l-.487 3.18h-2.563v7.686C22.977 26.041 27 21.49 27 16",
      fill: "#1777F2"
    }), y$1("path", {
      d: "M20.282 19.18L20.77 16h-3.051v-2.063c0-.87.426-1.718 1.792-1.718h1.387V9.512s-1.258-.215-2.462-.215c-2.513 0-4.155 1.523-4.155 4.28V16h-2.793v3.18h2.793v7.686a11.082 11.082 0 003.438 0V19.18h2.563",
      fill: "#FFFFFE"
    }))), this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: "facebook",
      pluginId: this.id
    }), this.defaultLocale = locale$a, this.i18nInit(), this.title = this.i18n("pluginNameFacebook"), this.onFirstRender = this.onFirstRender.bind(this), this.render = this.render.bind(this);
  }
  install() {
    this.view = new ProviderView(this, {
      provider: this.provider
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.view.tearDown(), this.unmount();
  }
  onFirstRender() {
    return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder()]);
  }
  render(state) {
    const viewOptions = {};
    return this.getPluginState().files.length && !this.getPluginState().folders.length && (viewOptions.viewType = "grid", viewOptions.showFilter = !1, viewOptions.showTitles = !1), this.view.render(state, viewOptions);
  }
};
__name(_Facebook, "Facebook");
let Facebook = _Facebook;
Facebook.VERSION = packageJson$h.version;
const _DriveProviderViews = class _DriveProviderViews extends ProviderView {
  toggleCheckbox(e2, file) {
    e2.stopPropagation(), e2.preventDefault(), file.custom.isSharedDrive || super.toggleCheckbox(e2, file);
  }
};
__name(_DriveProviderViews, "DriveProviderViews");
let DriveProviderViews = _DriveProviderViews;
const locale$9 = {
  strings: {
    pluginNameGoogleDrive: "Google Drive"
  }
}, packageJson$g = {
  version: "3.2.1"
}, _GoogleDrive = class _GoogleDrive extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "GoogleDrive", this.title = this.opts.title || "Google Drive", Provider.initPlugin(this, opts), this.title = this.opts.title || "Google Drive", this.icon = () => y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("g", {
      fillRule: "nonzero",
      fill: "none"
    }, y$1("path", {
      d: "M6.663 22.284l.97 1.62c.202.34.492.609.832.804l3.465-5.798H5c0 .378.1.755.302 1.096l1.361 2.278z",
      fill: "#0066DA"
    }), y$1("path", {
      d: "M16 12.09l-3.465-5.798c-.34.195-.63.463-.832.804l-6.4 10.718A2.15 2.15 0 005 18.91h6.93L16 12.09z",
      fill: "#00AC47"
    }), y$1("path", {
      d: "M23.535 24.708c.34-.195.63-.463.832-.804l.403-.67 1.928-3.228c.201-.34.302-.718.302-1.096h-6.93l1.474 2.802 1.991 2.996z",
      fill: "#EA4335"
    }), y$1("path", {
      d: "M16 12.09l3.465-5.798A2.274 2.274 0 0018.331 6h-4.662c-.403 0-.794.11-1.134.292L16 12.09z",
      fill: "#00832D"
    }), y$1("path", {
      d: "M20.07 18.91h-8.14l-3.465 5.798c.34.195.73.292 1.134.292h12.802c.403 0 .794-.11 1.134-.292L20.07 18.91z",
      fill: "#2684FC"
    }), y$1("path", {
      d: "M23.497 12.455l-3.2-5.359a2.252 2.252 0 00-.832-.804L16 12.09l4.07 6.82h6.917c0-.377-.1-.755-.302-1.096l-3.188-5.359z",
      fill: "#FFBA00"
    }))), this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: "drive",
      pluginId: this.id
    }), this.defaultLocale = locale$9, this.i18nInit(), this.title = this.i18n("pluginNameGoogleDrive"), this.onFirstRender = this.onFirstRender.bind(this), this.render = this.render.bind(this);
  }
  install() {
    this.view = new DriveProviderViews(this, {
      provider: this.provider,
      loadAllFiles: !0
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.view.tearDown(), this.unmount();
  }
  onFirstRender() {
    return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder("root")]);
  }
  render(state) {
    return this.view.render(state);
  }
};
__name(_GoogleDrive, "GoogleDrive");
let GoogleDrive = _GoogleDrive;
GoogleDrive.VERSION = packageJson$g.version;
const locale$8 = {
  strings: {
    pluginNameInstagram: "Instagram"
  }
}, packageJson$f = {
  version: "3.1.2"
}, _Instagram = class _Instagram extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "Instagram", Provider.initPlugin(this, opts), this.icon = () => y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("defs", null, y$1("path", {
      d: "M16.825 5l.483-.001.799.002c1.168.005 1.598.021 2.407.057 1.17.05 1.97.235 2.67.506.725.28 1.34.655 1.951 1.265.613.61.99 1.223 1.273 1.946.273.7.46 1.498.516 2.67l.025.552.008.205c.029.748.037 1.51.042 3.777l.001.846v.703l-.001.398a50.82 50.82 0 01-.058 2.588c-.05 1.17-.235 1.97-.506 2.67a5.394 5.394 0 01-1.265 1.951c-.61.613-1.222.99-1.946 1.273-.699.273-1.498.46-2.668.516-.243.012-.451.022-.656.03l-.204.007c-.719.026-1.512.034-3.676.038l-.847.001h-1.1a50.279 50.279 0 01-2.587-.059c-1.171-.05-1.971-.235-2.671-.506a5.394 5.394 0 01-1.951-1.265 5.385 5.385 0 01-1.272-1.946c-.274-.699-.46-1.498-.517-2.668a88.15 88.15 0 01-.03-.656l-.007-.205c-.026-.718-.034-1.512-.038-3.674v-2.129c.006-1.168.022-1.597.058-2.406.051-1.171.235-1.971.506-2.672a5.39 5.39 0 011.265-1.95 5.381 5.381 0 011.946-1.272c.699-.274 1.498-.462 2.669-.517l.656-.03.204-.007c.718-.026 1.511-.034 3.674-.038zm.678 1.981h-1.226l-.295.001c-2.307.005-3.016.013-3.777.043l-.21.009-.457.02c-1.072.052-1.654.232-2.042.383-.513.2-.879.44-1.263.825a3.413 3.413 0 00-.82 1.267c-.15.388-.33.97-.375 2.043a48.89 48.89 0 00-.056 2.482v.398 1.565c.006 2.937.018 3.285.073 4.444.05 1.073.231 1.654.382 2.043.2.512.44.878.825 1.263.386.383.753.621 1.267.82.388.15.97.328 2.043.374.207.01.388.017.563.024l.208.007a63.28 63.28 0 002.109.026h1.564c2.938-.006 3.286-.019 4.446-.073 1.071-.051 1.654-.232 2.04-.383.514-.2.88-.44 1.264-.825.384-.386.622-.753.82-1.266.15-.389.328-.971.375-2.044.039-.88.054-1.292.057-2.723v-1.15-.572c-.006-2.936-.019-3.284-.074-4.445-.05-1.071-.23-1.654-.382-2.04-.2-.515-.44-.88-.825-1.264a3.405 3.405 0 00-1.267-.82c-.388-.15-.97-.328-2.042-.375a48.987 48.987 0 00-2.535-.056zm-1.515 3.37a5.65 5.65 0 11.021 11.299 5.65 5.65 0 01-.02-11.3zm.004 1.982a3.667 3.667 0 10.015 7.334 3.667 3.667 0 00-.015-7.334zm5.865-3.536a1.32 1.32 0 11.005 2.64 1.32 1.32 0 01-.005-2.64z",
      id: "a"
    })), y$1("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, y$1("mask", {
      id: "b",
      fill: "#fff"
    }, y$1("use", {
      xlinkHref: "#a"
    })), y$1("image", {
      mask: "url(#b)",
      x: "4",
      y: "4",
      width: "24",
      height: "24",
      xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAALKADAAQAAAABAAAALAAAAAD8buejAAALZklEQVRYCVWZC2LbNhAFCRKykvP0bD1506SxRKIzbwHJoU3jv5h9WICU3P7+6zlG2zZvr8s/rW1tN7U0rMll8aDYufdzbLfc1JHmpv3jpPy8tsO+3O2s/O6YMSjTl/qdCds4mIIG60m8vdq2Z+phm2V4vAb9+o7BbZeuoM0NyYazvTvbvlN1MGjHUAesZ/IWWOsCeF0BOwAK4ITR0WYd/QKHEPv2DEymmorZtiubjOHEMYEzXmC9GMxu+95Kz+kuwxjDBKb8iUoCAdqZoAeyALreW6ZNx9Y4Jz8cLwjTZOEoR+HU05k2RzgP2iafGgfZiEdZbEr94zpX/xkPtDtGAxF+LRcgTsp9CAZg0rnEnXmPqFshY5vLnVWxLXO/bah2sZQgBZppGSe8NbjNPN5kc/WbIYEn8U+jXCOezT4zfgS1eoVEhceVeK74Fe4N6CoYEoLWykzHsd+GMAUqdTTVvvqT1uWqB3lVCLb12/ORAe8/5Zu9mp7lqoEFUCAFDIxqz7i1bq2AY1U9jqq2QK/7DYl+1AeZlAFcEc+U/jkRUqsvCHQ/nyGvjrOl6EuZWRWVGCKUMCkntQ5o+u2AZ3OxakbTcoBZnY0xhgGCUM4Kp1xtBTnBnXM5ASRms/Fs7d9OpX8bXN45pibQY/ML1MmA5G9CINBuCpdftexr6i2c5qd9J441LNJm3zk1GVusJ7v6mPJ7HPxJR0Li/vg9O1XHTEgvsQoSgExU0NnlLF0paK+6d06aOMKE2nCKV0ofNw4WsWmLsWrv6lPLnhGpr9E137QkHOMB/jh/T8MOqOadXarR44zPBW5NvDccnBxVmdK81+7RQ5p6qnQoRDZPh9+xWj0N2XpqxX1HzMty9UlFnKya/h3gulziAsyxwkSmpTIPB8vagKLyktRdDuBEHNGZMm4oCFWgjq31WPHpaC93gGNqpOpP4Ez4spa+nMNvhTWcuPKAJ79fqIxVoUvdjEG9qSy2WhpQlz61yG/gnKEA25IrIOYK6DIsQs2EE9LR/sTKq38Nd1y/X//FXG0QDHkEqSz3EYVV2dhb00rgLPSDcqmrScs55NNOD2zVqKmYnYTFnkACp520dkW5vBxK99BVzr792/iZ+VVo92UkKU2oG5WFTb6mNiA1H2C8KC0E44qaQleR3EQvQNwLrECOVAiSwM5gpF7nvDND0lZvYuQ9JbZfqdTrqCgwMcVrRS0z9QkLu9NWmkgEHb8p2zDRylj9VWA3lXD2vObEdWpT3w5MiFqQ1W/lteG4eipastxv2w+TeTBP0ypK84HiOW9fUzLcjRDwCW2b2VxmnGSKTX6uRSwMnC9YX4l05Mh2uwI+QVWdWUOSTWd5Xjjf7/tPYk2stSh053XTGN5RJMCMSajMcS8Trn3j/E1ajthlxCkmJXVi47PSUsyyq+jyexsayQNuv5GVYJaszprNsQD3RkgYiy49kFl2JlJJxlf8Uu/lpkq7+aWqzEzjr5cTVpFaJvSVr8AKRtiTlVPFk5t1nO30W+o6jrbAk76kxFa/tX+dom4C1wDPk03gqCw8HTBSxx4FHxIA+mh2pM3rKu5SNqBAuOSZnHzsB9JwW7DV/ge8dlVsOh375PvH8YO8EALU1HuecIC6qQgXifNuSx9XAoLaoGIYDjkWFrawX1U1XrknuMFw7QBSPtg79XovmBvwqnDICrhClEO6wgKFj9vPqJWlthUvdgH1DOA8+wFMexzQc5BUS1d1IsdBSjEv4Fe1LgBO1CpFPTpV1JuPSFNt4y/trzbtaUfwBWwM3/6JsrL6MSQYwLKXAm9YJBxsM8992MblZ63Gami0+rnwOMyPykVpQsyl9eYNOfVC6kRBkwaop//LgcAKWivkHF791g0JK5kMmCgKPas2QRkUFQsuTvm6R1946Wg95k764ZRLW59yO5UVGsawwELupCfAbdCuAwvcz5Xk18rIVEdgSRBRgO77R206QdXHuA2goaGiCQ0GmUfN1JlmFayjv0IcKGkfYt4HAj0yuQBRGDjzuS/rTmAf29Gov1S+FF7QBayNcpoBOEsMt3vFcIUC7VxOnE+pxmkgqEzduzwsPykrjBszCusgdarsRIAL6CM/KqsqcAf1vj8P1TXFyN6e5G8ao48fjKfDQJYizIdIfb+Xwp6Z2fE2C7mUfUEzMKqSBp4VUV1A49Sz1M2LzVzahEfyHUAcQNltR0nADYkBvHXDZQo8H9dQvHF7qhjPtSolBJ0A/vaLwdRz5YFFGoWBy8E/4aKcjqimaUBXXnjBpzOZnMlIVXsTVEBBUa+dD0BR0xVopgAD70psY0KjMHpmHB2kApea9o23NS83mpsref5OZet4U/0CMhSEDpwnxB9lVKSfk5djllXRFPizQmKcqMpnyZ3ycPntf96Ym9ChzU8vCQnhgWZ2UuySArw+cVBG4gqNCS6YoSEEziRWVStKUpe4FfCd91V0XA/qgOJuF7FpGjjyQgsFoNDtibp8cm+cyXxbB6zh4pMUO4H06yzsv4E/A6rg/uRJRnMRmrhMDIhyOjABX9CMDFhBFxx19KujjqWeim5PwVFU6IBiewfyk7IPETcg52kjXN7nsbaoEykKf/cjUgVxpTZZVtnqFMgv4FHa8oSOisawinMLHfUBzJcK1j8BeqquedKDtgcgnA4bym4P6gBWYVM3W/pn41ku5L4RElFWtlk5SXHEThhOWDiIyVROlQNM+wyHimlgATI/PPIm4BB8qfqwHnhgL89gzs+Ww1xQb4821SZ/4IwOJiRqH/X9u7Hj08JLSZfawOQcpRzwgk1oBNzzcgLn1FBNHspMENik9OG4awIDaUjw9rKNT1KXPl9neua6sSbkgqfs/CNfBdNfDDhQuL4AKXEXeOgZID91eOiRUnEFOIA5rnTkBU0/IT05gByoq5KBJF4Hym4Pxh3UcxZ7HjdhEhKWURbhavNR9rjLBwk3ryDcrGzfvk9I69b1yhMGWQ4bqMwv/RMSplQkjjVKXzZX8wESVcuB7QG0YUCMjk/aOmWgc/vC4oMCVYfghIGP6MT1zpeUhM1rQzOnGxmFKwTCir1Xaj5vN7T7nDZvnbDGHbCKnwji2zofNsOvbold3zlUtKGosBun3PbJSrrReHEaCQVCIDEMaCCBs+P+AbybkbIhmbNecGwF+E5/L2ECuPKCWsUESQkKnyyJ93TGACk7OrAY9P8XG//fGCoM7DAEUGnj5Mw7aQfelySWOm9iPuFyvrL8rKQR6mM6qdCUDQsfNPVu4yv/HaPOT1e/yDaviMKmTkg/I/F7MUG9OlrmDrBLRVd3c8KBJlPEKoVRcIJuhoQAmZDUkPC00W5OI1dOpQ1F61kFNqr9SmFcaHdBheOaDHF6QZMOP6QyiZ804oj98wLiAMIgcWw4UDYkDAWfR+4d5s0zP2GgUZX04i+NeSgYGokvbDhIZYUWHgd9K8zZzir264NxZUFbsfM1jdqpV2naA48tx6hsvBSabE4IMtlcOGgq8PqCjoly2rw2soqy4RJWQtPZl6PUCU14ZUWENuZV2Honn3f+k6R6wrkqgTStyQ0bFY+XAaafMRFgUlVeXxXFUcpLEYfZz3FrVUzZrOOJK+4B/wnIZ8TGRvb9OB8EUM0w8uNYj/oa9iK9AMoy6gA72o02srMxpAPUD+EDnVEF7P5xw896VyAbFk8MgnpVpR3gfLnt/wECq3rYFvYLcKCpqvcI+/hVl8AumXDeApklDRRKJSS+KOaq1Rgg4igOYtiQK1hJy46TBtDjznDp3iqJff5j0/LfSZbYVdauqXccJ9W+czupp0sU9gMlqkQ52lU1E6tUwoDUukAD6YRpAwqDrAErzA8QCRvXm98KEep0xIdY1CN1ye27IP0IHvvYIW18qGz8S7VWUZuMkUOb3P8DHTl67ur/i1UAAAAASUVORK5CYII="
    }))), this.defaultLocale = locale$8, this.i18nInit(), this.title = this.i18n("pluginNameInstagram"), this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: "instagram",
      pluginId: this.id
    }), this.onFirstRender = this.onFirstRender.bind(this), this.render = this.render.bind(this);
  }
  install() {
    this.view = new ProviderView(this, {
      provider: this.provider,
      viewType: "grid",
      showTitles: !1,
      showFilter: !1,
      showBreadcrumbs: !1
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.view.tearDown(), this.unmount();
  }
  onFirstRender() {
    return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder("recent")]);
  }
  render(state) {
    return this.view.render(state);
  }
};
__name(_Instagram, "Instagram");
let Instagram = _Instagram;
Instagram.VERSION = packageJson$f.version;
const locale$7 = {
  strings: {
    pluginNameOneDrive: "OneDrive"
  }
}, packageJson$e = {
  version: "3.1.3"
}, _OneDrive = class _OneDrive extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "OneDrive", Provider.initPlugin(this, opts), this.title = this.opts.title || "OneDrive", this.icon = () => y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("g", {
      fill: "none",
      fillRule: "nonzero"
    }, y$1("path", {
      d: "M13.39 12.888l4.618 2.747 2.752-1.15a4.478 4.478 0 012.073-.352 6.858 6.858 0 00-5.527-5.04 6.895 6.895 0 00-6.876 2.982l.07-.002a5.5 5.5 0 012.89.815z",
      fill: "#0364B8"
    }), y$1("path", {
      d: "M13.39 12.887v.001a5.5 5.5 0 00-2.89-.815l-.07.002a5.502 5.502 0 00-4.822 2.964 5.43 5.43 0 00.38 5.62l4.073-1.702 1.81-.757 4.032-1.685 2.105-.88-4.619-2.748z",
      fill: "#0078D4"
    }), y$1("path", {
      d: "M22.833 14.133a4.479 4.479 0 00-2.073.352l-2.752 1.15.798.475 2.616 1.556 1.141.68 3.902 2.321a4.413 4.413 0 00-.022-4.25 4.471 4.471 0 00-3.61-2.284z",
      fill: "#1490DF"
    }), y$1("path", {
      d: "M22.563 18.346l-1.141-.68-2.616-1.556-.798-.475-2.105.88L11.87 18.2l-1.81.757-4.073 1.702A5.503 5.503 0 0010.5 23h12.031a4.472 4.472 0 003.934-2.333l-3.902-2.321z",
      fill: "#28A8EA"
    }))), this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: "onedrive",
      pluginId: this.id
    }), this.defaultLocale = locale$7, this.i18nInit(), this.title = this.i18n("pluginNameOneDrive"), this.onFirstRender = this.onFirstRender.bind(this), this.render = this.render.bind(this);
  }
  install() {
    this.view = new ProviderView(this, {
      provider: this.provider,
      loadAllFiles: !0
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.view.tearDown(), this.unmount();
  }
  onFirstRender() {
    return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder()]);
  }
  render(state) {
    return this.view.render(state);
  }
};
__name(_OneDrive, "OneDrive");
let OneDrive = _OneDrive;
OneDrive.VERSION = packageJson$e.version;
const packageJson$d = {
  version: "3.2.2"
}, _Unsplash = class _Unsplash extends UIPlugin {
  constructor(uppy, opts) {
    if (super(uppy, opts), this.id = this.opts.id || "Unsplash", this.title = this.opts.title || "Unsplash", Provider.initPlugin(this, opts, {}), this.icon = () => y$1("svg", {
      className: "uppy-DashboardTab-iconUnsplash",
      viewBox: "0 0 32 32",
      height: "32",
      width: "32",
      "aria-hidden": "true"
    }, y$1("g", {
      fill: "currentcolor"
    }, y$1("path", {
      d: "M46.575 10.883v-9h12v9zm12 5h10v18h-32v-18h10v9h12z"
    }), y$1("path", {
      d: "M13 12.5V8h6v4.5zm6 2.5h5v9H8v-9h5v4.5h6z"
    }))), !this.opts.companionUrl)
      throw new Error("Companion hostname is required, please consult https://uppy.io/docs/companion");
    this.hostname = this.opts.companionUrl, this.provider = new SearchProvider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: "unsplash",
      pluginId: this.id
    });
  }
  install() {
    this.view = new SearchProviderView(this, {
      provider: this.provider,
      viewType: "unsplash",
      showFilter: !0
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  // eslint-disable-next-line class-methods-use-this
  onFirstRender() {
  }
  render(state) {
    return this.view.render(state);
  }
  uninstall() {
    this.unmount();
  }
};
__name(_Unsplash, "Unsplash");
let Unsplash = _Unsplash;
Unsplash.VERSION = packageJson$d.version;
function _classPrivateFieldLooseBase$g(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$g, "_classPrivateFieldLooseBase$g");
var id$g = 0;
function _classPrivateFieldLooseKey$g(name) {
  return "__private_" + id$g++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$g, "_classPrivateFieldLooseKey$g");
var _handleSubmit = /* @__PURE__ */ _classPrivateFieldLooseKey$g("handleSubmit");
const _UrlUI = class _UrlUI extends b$2 {
  constructor(props) {
    super(props), this.form = document.createElement("form"), Object.defineProperty(this, _handleSubmit, {
      writable: !0,
      value: /* @__PURE__ */ __name((ev) => {
        ev.preventDefault();
        const {
          addFile
        } = this.props, preparedValue = this.input.value.trim();
        addFile(preparedValue);
      }, "value")
    }), this.form.id = nanoid();
  }
  componentDidMount() {
    this.input.value = "", this.form.addEventListener("submit", _classPrivateFieldLooseBase$g(this, _handleSubmit)[_handleSubmit]), document.body.appendChild(this.form);
  }
  componentWillUnmount() {
    this.form.removeEventListener("submit", _classPrivateFieldLooseBase$g(this, _handleSubmit)[_handleSubmit]), document.body.removeChild(this.form);
  }
  render() {
    const {
      i18n
    } = this.props;
    return y$1("div", {
      className: "uppy-Url"
    }, y$1("input", {
      className: "uppy-u-reset uppy-c-textInput uppy-Url-input",
      type: "text",
      "aria-label": i18n("enterUrlToImport"),
      placeholder: i18n("enterUrlToImport"),
      ref: /* @__PURE__ */ __name((input) => {
        this.input = input;
      }, "ref"),
      "data-uppy-super-focusable": !0,
      form: this.form.id
    }), y$1("button", {
      className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Url-importButton",
      type: "submit",
      form: this.form.id
    }, i18n("import")));
  }
};
__name(_UrlUI, "UrlUI");
let UrlUI = _UrlUI;
function forEachDroppedOrPastedUrl(dataTransfer, isDropOrPaste, callback) {
  const items = toArray$3(dataTransfer.items);
  let urlItems;
  switch (isDropOrPaste) {
    case "paste": {
      if (items.some((item) => item.kind === "file"))
        return;
      urlItems = items.filter((item) => item.kind === "string" && item.type === "text/plain");
      break;
    }
    case "drop": {
      urlItems = items.filter((item) => item.kind === "string" && item.type === "text/uri-list");
      break;
    }
    default:
      throw new Error(`isDropOrPaste must be either 'drop' or 'paste', but it's ${isDropOrPaste}`);
  }
  urlItems.forEach((item) => {
    item.getAsString((urlString) => callback(urlString));
  });
}
__name(forEachDroppedOrPastedUrl, "forEachDroppedOrPastedUrl");
const locale$6 = {
  strings: {
    // Label for the "Import" button.
    import: "Import",
    // Placeholder text for the URL input.
    enterUrlToImport: "Enter URL to import a file",
    // Error message shown if Companion could not load a URL.
    failedToFetch: "Companion failed to fetch this URL, please make sure it’s correct",
    // Error message shown if the input does not look like a URL.
    enterCorrectUrl: "Incorrect URL: Please make sure you are entering a direct link to a file"
  }
}, packageJson$c = {
  version: "3.3.3"
};
function UrlIcon() {
  return y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, y$1("path", {
    d: "M23.637 15.312l-2.474 2.464a3.582 3.582 0 01-.577.491c-.907.657-1.897.986-2.968.986a4.925 4.925 0 01-3.959-1.971c-.248-.329-.164-.902.165-1.149.33-.247.907-.164 1.155.164 1.072 1.478 3.133 1.724 4.618.656a.642.642 0 00.33-.328l2.473-2.463c1.238-1.313 1.238-3.366-.082-4.597a3.348 3.348 0 00-4.618 0l-1.402 1.395a.799.799 0 01-1.154 0 .79.79 0 010-1.15l1.402-1.394a4.843 4.843 0 016.843 0c2.062 1.805 2.144 5.007.248 6.896zm-8.081 5.664l-1.402 1.395a3.348 3.348 0 01-4.618 0c-1.319-1.23-1.319-3.365-.082-4.596l2.475-2.464.328-.328c.743-.492 1.567-.739 2.475-.657.906.165 1.648.574 2.143 1.314.248.329.825.411 1.155.165.33-.248.412-.822.165-1.15-.825-1.068-1.98-1.724-3.216-1.888-1.238-.247-2.556.082-3.628.902l-.495.493-2.474 2.464c-1.897 1.969-1.814 5.09.083 6.977.99.904 2.226 1.396 3.463 1.396s2.473-.492 3.463-1.395l1.402-1.396a.79.79 0 000-1.15c-.33-.328-.908-.41-1.237-.082z",
    fill: "#FF753E",
    "fill-rule": "nonzero"
  }));
}
__name(UrlIcon, "UrlIcon");
function addProtocolToURL(url) {
  const protocolRegex = /^[a-z0-9]+:\/\//, defaultProtocol = "http://";
  return protocolRegex.test(url) ? url : defaultProtocol + url;
}
__name(addProtocolToURL, "addProtocolToURL");
function canHandleRootDrop(e2) {
  return toArray$3(e2.dataTransfer.items).filter((item) => item.kind === "string" && item.type === "text/uri-list").length > 0;
}
__name(canHandleRootDrop, "canHandleRootDrop");
function checkIfCorrectURL(url) {
  if (!url) return !1;
  const protocol = url.match(/^([a-z0-9]+):\/\//)[1];
  return !(protocol !== "http" && protocol !== "https");
}
__name(checkIfCorrectURL, "checkIfCorrectURL");
function getFileNameFromUrl(url) {
  const {
    pathname
  } = new URL(url);
  return pathname.substring(pathname.lastIndexOf("/") + 1);
}
__name(getFileNameFromUrl, "getFileNameFromUrl");
var _a2;
let Url$1 = (_a2 = class extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "Url", this.title = this.opts.title || "Link", this.type = "acquirer", this.icon = () => y$1(UrlIcon, null), this.defaultLocale = locale$6;
    const defaultOptions2 = {};
    if (this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.i18nInit(), this.hostname = this.opts.companionUrl, !this.hostname)
      throw new Error("Companion hostname is required, please consult https://uppy.io/docs/companion");
    this.getMeta = this.getMeta.bind(this), this.addFile = this.addFile.bind(this), this.handleRootDrop = this.handleRootDrop.bind(this), this.handleRootPaste = this.handleRootPaste.bind(this), this.client = new RequestClient(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionCookiesRule: this.opts.companionCookiesRule
    });
  }
  getMeta(url) {
    return this.client.post("url/meta", {
      url
    }).then((res) => {
      if (res.error)
        throw this.uppy.log("[URL] Error:"), this.uppy.log(res.error), new Error("Failed to fetch the file");
      return res;
    });
  }
  async addFile(protocollessUrl, optionalMeta) {
    optionalMeta === void 0 && (optionalMeta = void 0);
    const url = addProtocolToURL(protocollessUrl);
    if (!checkIfCorrectURL(url)) {
      this.uppy.log(`[URL] Incorrect URL entered: ${url}`), this.uppy.info(this.i18n("enterCorrectUrl"), "error", 4e3);
      return;
    }
    try {
      const meta = await this.getMeta(url), tagFile = {
        meta: optionalMeta,
        source: this.id,
        name: meta.name || getFileNameFromUrl(url),
        type: meta.type,
        data: {
          size: meta.size
        },
        isRemote: !0,
        body: {
          url
        },
        remote: {
          companionUrl: this.opts.companionUrl,
          url: `${this.hostname}/url/get`,
          body: {
            fileId: url,
            url
          },
          providerOptions: this.client.opts
        }
      };
      this.uppy.log("[Url] Adding remote file");
      try {
        return this.uppy.addFile(tagFile);
      } catch (err) {
        return err.isRestriction || this.uppy.log(err), err;
      }
    } catch (err) {
      return this.uppy.log(err), this.uppy.info({
        message: this.i18n("failedToFetch"),
        details: err
      }, "error", 4e3), err;
    }
  }
  handleRootDrop(e2) {
    forEachDroppedOrPastedUrl(e2.dataTransfer, "drop", (url) => {
      this.uppy.log(`[URL] Adding file from dropped url: ${url}`), this.addFile(url);
    });
  }
  handleRootPaste(e2) {
    forEachDroppedOrPastedUrl(e2.clipboardData, "paste", (url) => {
      this.uppy.log(`[URL] Adding file from pasted url: ${url}`), this.addFile(url);
    });
  }
  render() {
    return y$1(UrlUI, {
      i18n: this.i18n,
      addFile: this.addFile
    });
  }
  install() {
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.unmount();
  }
}, __name(_a2, "Url"), _a2);
Url$1.VERSION = packageJson$c.version;
Url$1.prototype.canHandleRootDrop = canHandleRootDrop;
const locale$5 = {
  strings: {
    pluginNameZoom: "Zoom"
  }
}, packageJson$b = {
  version: "2.1.2"
}, _Zoom = class _Zoom extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.id = this.opts.id || "Zoom", Provider.initPlugin(this, opts), this.title = this.opts.title || "Zoom", this.icon = () => y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("path", {
      d: "M24.5 11.125l-2.75 2.063c-.473.353-.75.91-.75 1.5v3.124c0 .59.277 1.147.75 1.5l2.75 2.063a.938.938 0 001.5-.75v-8.75a.938.938 0 00-1.5-.75zm-4.75 9.5c0 1.035-.84 1.875-1.875 1.875H9.75A3.75 3.75 0 016 18.75v-6.875C6 10.84 6.84 10 7.875 10H16a3.75 3.75 0 013.75 3.75v6.875z",
      fill: "#2E8CFF",
      "fill-rule": "evenodd"
    })), this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: "zoom",
      pluginId: this.id
    }), this.defaultLocale = locale$5, this.i18nInit(), this.title = this.i18n("pluginNameZoom"), this.onFirstRender = this.onFirstRender.bind(this), this.render = this.render.bind(this);
  }
  install() {
    this.view = new ProviderView(this, {
      provider: this.provider
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.view.tearDown(), this.unmount();
  }
  onFirstRender() {
    return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder()]);
  }
  render(state) {
    return this.view.render(state);
  }
};
__name(_Zoom, "Zoom");
let Zoom = _Zoom;
Zoom.VERSION = packageJson$b.version;
function _classPrivateFieldLooseBase$f(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$f, "_classPrivateFieldLooseBase$f");
var id$f = 0;
function _classPrivateFieldLooseKey$f(name) {
  return "__private_" + id$f++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$f, "_classPrivateFieldLooseKey$f");
const packageJson$a = {
  version: "1.0.3"
}, availablePlugins = {
  // Using a null-prototype object to avoid prototype pollution.
  __proto__: null,
  Box,
  Dropbox,
  Facebook,
  GoogleDrive,
  Instagram,
  OneDrive,
  Unsplash,
  Url: Url$1,
  Zoom
};
var _installedPlugins = /* @__PURE__ */ _classPrivateFieldLooseKey$f("installedPlugins");
const _RemoteSources = class _RemoteSources extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts), Object.defineProperty(this, _installedPlugins, {
      writable: !0,
      value: /* @__PURE__ */ new Set()
    }), this.id = this.opts.id || "RemoteSources", this.type = "acquirer";
    const defaultOptions2 = {
      sources: Object.keys(availablePlugins),
      target: Dashboard
    };
    if (this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.opts.companionUrl == null)
      throw new Error("Please specify companionUrl for RemoteSources to work, see https://uppy.io/docs/remote-sources#companionUrl");
  }
  setOptions(newOpts) {
    this.uninstall(), super.setOptions(newOpts), this.install();
  }
  install() {
    this.opts.sources.forEach((pluginId) => {
      const optsForRemoteSourcePlugin = {
        ...this.opts,
        sources: void 0
      }, plugin = availablePlugins[pluginId];
      if (plugin == null) {
        const pluginNames = Object.keys(availablePlugins), formatter = new Intl.ListFormat("en", {
          style: "long",
          type: "disjunction"
        });
        throw new Error(`Invalid plugin: "${pluginId}" is not one of: ${formatter.format(pluginNames)}.`);
      }
      this.uppy.use(plugin, optsForRemoteSourcePlugin), _classPrivateFieldLooseBase$f(this, _installedPlugins)[_installedPlugins].add(this.uppy.getPlugin(pluginId));
    });
  }
  uninstall() {
    for (const plugin of _classPrivateFieldLooseBase$f(this, _installedPlugins)[_installedPlugins])
      this.uppy.removePlugin(plugin);
    _classPrivateFieldLooseBase$f(this, _installedPlugins)[_installedPlugins].clear();
  }
};
__name(_RemoteSources, "RemoteSources");
let RemoteSources = _RemoteSources;
RemoteSources.VERSION = packageJson$a.version;
const ScreenRecIcon = /* @__PURE__ */ __name(() => y$1("svg", {
  className: "uppy-DashboardTab-iconScreenRec",
  "aria-hidden": "true",
  focusable: "false",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, y$1("g", {
  fill: "currentcolor",
  fillRule: "evenodd"
}, y$1("path", {
  d: "M24.182 9H7.818C6.81 9 6 9.742 6 10.667v10c0 .916.81 1.666 1.818 1.666h4.546V24h7.272v-1.667h4.546c1 0 1.809-.75 1.809-1.666l.009-10C26 9.742 25.182 9 24.182 9zM24 21H8V11h16v10z"
}), y$1("circle", {
  cx: "16",
  cy: "16",
  r: "2"
}))), "ScreenRecIcon");
function RecordButton$1(_ref) {
  let {
    recording,
    onStartRecording,
    onStopRecording,
    i18n
  } = _ref;
  return recording ? y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-ScreenCapture-button uppy-ScreenCapture-button--video uppy-ScreenCapture-button--stop-rec",
    type: "button",
    title: i18n("stopCapturing"),
    "aria-label": i18n("stopCapturing"),
    onClick: onStopRecording,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "100",
    height: "100",
    viewBox: "0 0 100 100"
  }, y$1("rect", {
    x: "15",
    y: "15",
    width: "70",
    height: "70"
  }))) : y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-ScreenCapture-button uppy-ScreenCapture-button--video",
    type: "button",
    title: i18n("startCapturing"),
    "aria-label": i18n("startCapturing"),
    onClick: onStartRecording,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "100",
    height: "100",
    viewBox: "0 0 100 100"
  }, y$1("circle", {
    cx: "50",
    cy: "50",
    r: "40"
  })));
}
__name(RecordButton$1, "RecordButton$1");
function SubmitButton$1(_ref) {
  let {
    recording,
    recordedVideo,
    onSubmit,
    i18n
  } = _ref;
  return recordedVideo && !recording ? y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-ScreenCapture-button uppy-ScreenCapture-button--submit",
    type: "button",
    title: i18n("submitRecordedFile"),
    "aria-label": i18n("submitRecordedFile"),
    onClick: onSubmit,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    width: "12",
    height: "9",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon"
  }, y$1("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M10.66 0L12 1.31 4.136 9 0 4.956l1.34-1.31L4.136 6.38z"
  }))) : null;
}
__name(SubmitButton$1, "SubmitButton$1");
const _StopWatch = class _StopWatch extends b$2 {
  constructor(props) {
    super(props), this.state = {
      elapsedTime: 0
    }, this.wrapperStyle = {
      width: "100%",
      height: "100%",
      display: "flex"
    }, this.overlayStyle = {
      position: "absolute",
      width: "100%",
      height: "100%",
      background: "black",
      opacity: 0.7
    }, this.infoContainerStyle = {
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "auto",
      marginBottom: "auto",
      zIndex: 1,
      color: "white"
    }, this.infotextStyle = {
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "1rem",
      fontSize: "1.5rem"
    }, this.timeStyle = {
      display: "block",
      fontWeight: "bold",
      marginLeft: "auto",
      marginRight: "auto",
      fontSize: "3rem",
      fontFamily: "Courier New"
    };
  }
  startTimer() {
    this.timerTick(), this.timerRunning = !0;
  }
  resetTimer() {
    clearTimeout(this.timer), this.setState({
      elapsedTime: 0
    }), this.timerRunning = !1;
  }
  timerTick() {
    this.timer = setTimeout(() => {
      this.setState((state) => ({
        elapsedTime: state.elapsedTime + 1
      })), this.timerTick();
    }, 1e3);
  }
  // eslint-disable-next-line class-methods-use-this
  fmtMSS(s2) {
    return (s2 - (s2 %= 60)) / 60 + (s2 > 9 ? ":" : ":0") + s2;
  }
  render() {
    const {
      recording,
      i18n
    } = {
      ...this.props
    }, {
      elapsedTime
    } = this.state, minAndSec = this.fmtMSS(elapsedTime);
    return recording && !this.timerRunning && this.startTimer(), !recording && this.timerRunning && this.resetTimer(), recording ? y$1("div", {
      style: this.wrapperStyle
    }, y$1("div", {
      style: this.overlayStyle
    }), y$1("div", {
      style: this.infoContainerStyle
    }, y$1("div", {
      style: this.infotextStyle
    }, i18n("recording")), y$1("div", {
      style: this.timeStyle
    }, minAndSec))) : null;
  }
};
__name(_StopWatch, "StopWatch");
let StopWatch = _StopWatch;
const StreamStatus = /* @__PURE__ */ __name((_ref) => {
  let {
    streamActive,
    i18n
  } = _ref;
  return streamActive ? y$1("div", {
    title: i18n("streamActive"),
    "aria-label": i18n("streamActive"),
    className: "uppy-ScreenCapture-icon--stream uppy-ScreenCapture-icon--streamActive"
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, y$1("path", {
    d: "M0 0h24v24H0z",
    opacity: ".1",
    fill: "none"
  }), y$1("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), y$1("path", {
    d: "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }))) : y$1("div", {
    title: i18n("streamPassive"),
    "aria-label": i18n("streamPassive"),
    className: "uppy-ScreenCapture-icon--stream"
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, y$1("path", {
    d: "M0 0h24v24H0z",
    opacity: ".1",
    fill: "none"
  }), y$1("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), y$1("path", {
    d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"
  })));
}, "StreamStatus");
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$4.apply(this, arguments);
}
__name(_extends$4, "_extends$4");
const _RecorderScreen = class _RecorderScreen extends b$2 {
  componentWillUnmount() {
    const {
      onStop
    } = this.props;
    onStop();
  }
  render() {
    const {
      recording,
      stream: videoStream,
      recordedVideo
    } = this.props, videoProps = {
      playsinline: !0
    };
    return (recording || !recordedVideo && !recording) && (videoProps.muted = !0, videoProps.autoplay = !0, videoProps.srcObject = videoStream), recordedVideo && !recording && (videoProps.muted = !1, videoProps.controls = !0, videoProps.src = recordedVideo, this.videoElement && (this.videoElement.srcObject = void 0)), y$1("div", {
      className: "uppy uppy-ScreenCapture-container"
    }, y$1("div", {
      className: "uppy-ScreenCapture-videoContainer"
    }, y$1(StreamStatus, this.props), y$1("video", _extends$4({
      ref: /* @__PURE__ */ __name((videoElement) => {
        this.videoElement = videoElement;
      }, "ref"),
      className: "uppy-ScreenCapture-video"
    }, videoProps)), y$1(StopWatch, this.props)), y$1("div", {
      className: "uppy-ScreenCapture-buttonContainer"
    }, y$1(RecordButton$1, this.props), y$1(SubmitButton$1, this.props)));
  }
};
__name(_RecorderScreen, "RecorderScreen");
let RecorderScreen = _RecorderScreen;
const locale$4 = {
  strings: {
    startCapturing: "Begin screen capturing",
    stopCapturing: "Stop screen capturing",
    submitRecordedFile: "Submit recorded file",
    streamActive: "Stream active",
    streamPassive: "Stream passive",
    micDisabled: "Microphone access denied by user",
    recording: "Recording"
  }
};
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$3.apply(this, arguments);
}
__name(_extends$3, "_extends$3");
const packageJson$9 = {
  version: "3.1.2"
};
function isScreenRecordingSupported() {
  var _navigator$mediaDevic;
  return window.MediaRecorder && ((_navigator$mediaDevic = navigator.mediaDevices) == null ? void 0 : _navigator$mediaDevic.getDisplayMedia);
}
__name(isScreenRecordingSupported, "isScreenRecordingSupported");
function getMediaDevices$1() {
  return window.MediaRecorder && navigator.mediaDevices;
}
__name(getMediaDevices$1, "getMediaDevices$1");
const _ScreenCapture = class _ScreenCapture extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.mediaDevices = getMediaDevices$1(), this.protocol = location.protocol === "https:" ? "https" : "http", this.id = this.opts.id || "ScreenCapture", this.title = this.opts.title || "Screencast", this.type = "acquirer", this.icon = ScreenRecIcon, this.defaultLocale = locale$4;
    const defaultOptions2 = {
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints#Properties_of_shared_screen_tracks
      displayMediaConstraints: {
        video: {
          width: 1280,
          height: 720,
          frameRate: {
            ideal: 3,
            max: 5
          },
          cursor: "motion",
          displaySurface: "monitor"
        }
      },
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamConstraints/audio
      userMediaConstraints: {
        audio: !0
      },
      preferredVideoMimeType: "video/webm"
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.i18nInit(), this.install = this.install.bind(this), this.setPluginState = this.setPluginState.bind(this), this.render = this.render.bind(this), this.start = this.start.bind(this), this.stop = this.stop.bind(this), this.startRecording = this.startRecording.bind(this), this.stopRecording = this.stopRecording.bind(this), this.submit = this.submit.bind(this), this.streamInterrupted = this.streamInactivated.bind(this), this.captureActive = !1, this.capturedMediaFile = null;
  }
  install() {
    if (!isScreenRecordingSupported())
      return this.uppy.log("Screen recorder access is not supported", "warning"), null;
    this.setPluginState({
      streamActive: !1,
      audioStreamActive: !1
    });
    const {
      target
    } = this.opts;
    target && this.mount(target, this);
  }
  uninstall() {
    this.videoStream && this.stop(), this.unmount();
  }
  start() {
    return this.mediaDevices ? (this.captureActive = !0, this.selectAudioStreamSource(), this.selectVideoStreamSource().then((res) => {
      res === !1 && this.parent && this.parent.hideAllPanels && (this.parent.hideAllPanels(), this.captureActive = !1);
    })) : Promise.reject(new Error("Screen recorder access not supported"));
  }
  selectVideoStreamSource() {
    return this.videoStream ? new Promise((resolve3) => resolve3(this.videoStream)) : this.mediaDevices.getDisplayMedia(this.opts.displayMediaConstraints).then((videoStream) => (this.videoStream = videoStream, this.videoStream.addEventListener("inactive", () => {
      this.streamInactivated();
    }), this.setPluginState({
      streamActive: !0
    }), videoStream)).catch((err) => (this.setPluginState({
      screenRecError: err
    }), this.userDenied = !0, setTimeout(() => {
      this.userDenied = !1;
    }, 1e3), !1));
  }
  selectAudioStreamSource() {
    return this.audioStream ? new Promise((resolve3) => resolve3(this.audioStream)) : this.mediaDevices.getUserMedia(this.opts.userMediaConstraints).then((audioStream) => (this.audioStream = audioStream, this.setPluginState({
      audioStreamActive: !0
    }), audioStream)).catch((err) => (err.name === "NotAllowedError" && (this.uppy.info(this.i18n("micDisabled"), "error", 5e3), this.uppy.log(this.i18n("micDisabled"), "warning")), !1));
  }
  startRecording() {
    const options = {};
    this.capturedMediaFile = null, this.recordingChunks = [];
    const {
      preferredVideoMimeType
    } = this.opts;
    this.selectVideoStreamSource().then((videoStream) => {
      preferredVideoMimeType && MediaRecorder.isTypeSupported(preferredVideoMimeType) && getFileTypeExtension(preferredVideoMimeType) && (options.mimeType = preferredVideoMimeType);
      const tracks = [videoStream.getVideoTracks()[0]];
      this.audioStream && tracks.push(this.audioStream.getAudioTracks()[0]), this.outputStream = new MediaStream(tracks), this.recorder = new MediaRecorder(this.outputStream, options), this.recorder.addEventListener("dataavailable", (event) => {
        this.recordingChunks.push(event.data);
      }), this.recorder.start(), this.setPluginState({
        recording: !0
      });
    }).catch((err) => {
      this.uppy.log(err, "error");
    });
  }
  streamInactivated() {
    const {
      recordedVideo,
      recording
    } = {
      ...this.getPluginState()
    };
    !recordedVideo && !recording ? this.parent && this.parent.hideAllPanels && this.parent.hideAllPanels() : recording && (this.uppy.log("Capture stream inactive — stop recording"), this.stopRecording()), this.videoStream = null, this.audioStream = null, this.setPluginState({
      streamActive: !1,
      audioStreamActive: !1
    });
  }
  stopRecording() {
    return new Promise((resolve3) => {
      this.recorder.addEventListener("stop", () => {
        resolve3();
      }), this.recorder.stop();
    }).then(() => (this.setPluginState({
      recording: !1
    }), this.getVideo())).then((file) => {
      this.capturedMediaFile = file, this.setPluginState({
        // eslint-disable-next-line compat/compat
        recordedVideo: URL.createObjectURL(file.data)
      });
    }).then(() => {
      this.recordingChunks = null, this.recorder = null;
    }, (error) => {
      throw this.recordingChunks = null, this.recorder = null, error;
    });
  }
  submit() {
    try {
      this.capturedMediaFile && this.uppy.addFile(this.capturedMediaFile);
    } catch (err) {
      err.isRestriction || this.uppy.log(err, "warning");
    }
  }
  stop() {
    this.videoStream && (this.videoStream.getVideoTracks().forEach((track) => {
      track.stop();
    }), this.videoStream.getAudioTracks().forEach((track) => {
      track.stop();
    }), this.videoStream = null), this.audioStream && (this.audioStream.getAudioTracks().forEach((track) => {
      track.stop();
    }), this.audioStream.getVideoTracks().forEach((track) => {
      track.stop();
    }), this.audioStream = null), this.outputStream && (this.outputStream.getAudioTracks().forEach((track) => {
      track.stop();
    }), this.outputStream.getVideoTracks().forEach((track) => {
      track.stop();
    }), this.outputStream = null), this.setPluginState({
      recordedVideo: null
    }), this.captureActive = !1;
  }
  getVideo() {
    const mimeType = this.recordingChunks[0].type, fileExtension = getFileTypeExtension(mimeType);
    if (!fileExtension)
      return Promise.reject(new Error(`Could not retrieve recording: Unsupported media type "${mimeType}"`));
    const name = `screencap-${Date.now()}.${fileExtension}`, blob = new Blob(this.recordingChunks, {
      type: mimeType
    }), file = {
      source: this.id,
      name,
      data: new Blob([blob], {
        type: mimeType
      }),
      type: mimeType
    };
    return Promise.resolve(file);
  }
  render() {
    const recorderState = this.getPluginState();
    return !recorderState.streamActive && !this.captureActive && !this.userDenied && this.start(), y$1(RecorderScreen, _extends$3({}, recorderState, {
      // eslint-disable-line react/jsx-props-no-spreading
      onStartRecording: this.startRecording,
      onStopRecording: this.stopRecording,
      onStop: this.stop,
      onSubmit: this.submit,
      i18n: this.i18n,
      stream: this.videoStream
    }));
  }
};
__name(_ScreenCapture, "ScreenCapture");
let ScreenCapture = _ScreenCapture;
ScreenCapture.VERSION = packageJson$9.version;
var isMobile$2 = { exports: {} };
isMobile$2.exports = isMobile;
isMobile$2.exports.isMobile = isMobile;
isMobile$2.exports.default = isMobile;
const mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, notMobileRE = /CrOS/, tabletRE = /android|ipad|playbook|silk/i;
function isMobile(opts) {
  opts || (opts = {});
  let ua = opts.ua;
  if (!ua && typeof navigator < "u" && (ua = navigator.userAgent), ua && ua.headers && typeof ua.headers["user-agent"] == "string" && (ua = ua.headers["user-agent"]), typeof ua != "string") return !1;
  let result2 = mobileRE.test(ua) && !notMobileRE.test(ua) || !!opts.tablet && tabletRE.test(ua);
  return !result2 && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1 && (result2 = !0), result2;
}
__name(isMobile, "isMobile");
var isMobileExports = isMobile$2.exports;
const isMobile$1 = /* @__PURE__ */ getDefaultExportFromCjs(isMobileExports);
function canvasToBlob$1(canvas, type, quality) {
  return new Promise((resolve3) => {
    canvas.toBlob(resolve3, type, quality);
  });
}
__name(canvasToBlob$1, "canvasToBlob$1");
function supportsMediaRecorder() {
  return typeof MediaRecorder == "function" && !!MediaRecorder.prototype && typeof MediaRecorder.prototype.start == "function";
}
__name(supportsMediaRecorder, "supportsMediaRecorder");
const CameraIcon = /* @__PURE__ */ __name(() => y$1("svg", {
  "aria-hidden": "true",
  focusable: "false",
  fill: "#0097DC",
  width: "66",
  height: "55",
  viewBox: "0 0 66 55"
}, y$1("path", {
  d: "M57.3 8.433c4.59 0 8.1 3.51 8.1 8.1v29.7c0 4.59-3.51 8.1-8.1 8.1H8.7c-4.59 0-8.1-3.51-8.1-8.1v-29.7c0-4.59 3.51-8.1 8.1-8.1h9.45l4.59-7.02c.54-.54 1.35-1.08 2.16-1.08h16.2c.81 0 1.62.54 2.16 1.08l4.59 7.02h9.45zM33 14.64c-8.62 0-15.393 6.773-15.393 15.393 0 8.62 6.773 15.393 15.393 15.393 8.62 0 15.393-6.773 15.393-15.393 0-8.62-6.773-15.393-15.393-15.393zM33 40c-5.648 0-9.966-4.319-9.966-9.967 0-5.647 4.318-9.966 9.966-9.966s9.966 4.319 9.966 9.966C42.966 35.681 38.648 40 33 40z",
  fillRule: "evenodd"
})), "CameraIcon"), SnapshotButton = /* @__PURE__ */ __name((_ref) => {
  let {
    onSnapshot,
    i18n
  } = _ref;
  return y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--picture",
    type: "button",
    title: i18n("takePicture"),
    "aria-label": i18n("takePicture"),
    onClick: onSnapshot,
    "data-uppy-super-focusable": !0
  }, CameraIcon());
}, "SnapshotButton");
function RecordButton(_ref) {
  let {
    recording,
    onStartRecording,
    onStopRecording,
    i18n
  } = _ref;
  return recording ? y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Webcam-button",
    type: "button",
    title: i18n("stopRecording"),
    "aria-label": i18n("stopRecording"),
    onClick: onStopRecording,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "100",
    height: "100",
    viewBox: "0 0 100 100"
  }, y$1("rect", {
    x: "15",
    y: "15",
    width: "70",
    height: "70"
  }))) : y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Webcam-button",
    type: "button",
    title: i18n("startRecording"),
    "aria-label": i18n("startRecording"),
    onClick: onStartRecording,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "100",
    height: "100",
    viewBox: "0 0 100 100"
  }, y$1("circle", {
    cx: "50",
    cy: "50",
    r: "40"
  })));
}
__name(RecordButton, "RecordButton");
function formatSeconds(seconds) {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, 0)}`;
}
__name(formatSeconds, "formatSeconds");
function RecordingLength(_ref) {
  let {
    recordingLengthSeconds,
    i18n
  } = _ref;
  const formattedRecordingLengthSeconds = formatSeconds(recordingLengthSeconds);
  return y$1("span", {
    "aria-label": i18n("recordingLength", {
      recording_length: formattedRecordingLengthSeconds
    })
  }, formattedRecordingLengthSeconds);
}
__name(RecordingLength, "RecordingLength");
const VideoSourceSelect = /* @__PURE__ */ __name((_ref) => {
  let {
    currentDeviceId,
    videoSources,
    onChangeVideoSource
  } = _ref;
  return y$1("div", {
    className: "uppy-Webcam-videoSource"
  }, y$1("select", {
    className: "uppy-u-reset uppy-Webcam-videoSource-select",
    onChange: /* @__PURE__ */ __name((event) => {
      onChangeVideoSource(event.target.value);
    }, "onChange")
  }, videoSources.map((videoSource) => y$1("option", {
    key: videoSource.deviceId,
    value: videoSource.deviceId,
    selected: videoSource.deviceId === currentDeviceId
  }, videoSource.label))));
}, "VideoSourceSelect");
function SubmitButton(_ref) {
  let {
    onSubmit,
    i18n
  } = _ref;
  return y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--submit",
    type: "button",
    title: i18n("submitRecordedFile"),
    "aria-label": i18n("submitRecordedFile"),
    onClick: onSubmit,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    width: "12",
    height: "9",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon"
  }, y$1("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M10.66 0L12 1.31 4.136 9 0 4.956l1.34-1.31L4.136 6.38z"
  })));
}
__name(SubmitButton, "SubmitButton");
function DiscardButton(_ref) {
  let {
    onDiscard,
    i18n
  } = _ref;
  return y$1("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--discard",
    type: "button",
    title: i18n("discardRecordedFile"),
    "aria-label": i18n("discardRecordedFile"),
    onClick: onDiscard,
    "data-uppy-super-focusable": !0
  }, y$1("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon"
  }, y$1("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, y$1("path", {
    d: "M.496 11.367L11.103.76l1.414 1.414L1.911 12.781z"
  }), y$1("path", {
    d: "M11.104 12.782L.497 2.175 1.911.76l10.607 10.606z"
  }))));
}
__name(DiscardButton, "DiscardButton");
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$2.apply(this, arguments);
}
__name(_extends$2, "_extends$2");
function isModeAvailable$1(modes, mode) {
  return modes.includes(mode);
}
__name(isModeAvailable$1, "isModeAvailable$1");
const _CameraScreen = class _CameraScreen extends b$2 {
  componentDidMount() {
    const {
      onFocus
    } = this.props;
    onFocus();
  }
  componentWillUnmount() {
    const {
      onStop
    } = this.props;
    onStop();
  }
  render() {
    const {
      src,
      recordedVideo,
      recording,
      modes,
      supportsRecording,
      videoSources,
      showVideoSourceDropdown,
      showRecordingLength,
      onSubmit,
      i18n,
      mirror,
      onSnapshot,
      onStartRecording,
      onStopRecording,
      onDiscardRecordedVideo,
      recordingLengthSeconds
    } = this.props, hasRecordedVideo = !!recordedVideo, shouldShowRecordButton = !hasRecordedVideo && supportsRecording && (isModeAvailable$1(modes, "video-only") || isModeAvailable$1(modes, "audio-only") || isModeAvailable$1(modes, "video-audio")), shouldShowSnapshotButton = !hasRecordedVideo && isModeAvailable$1(modes, "picture"), shouldShowRecordingLength = supportsRecording && showRecordingLength && !hasRecordedVideo, shouldShowVideoSourceDropdown = showVideoSourceDropdown && videoSources && videoSources.length > 1, videoProps = {
      playsinline: !0
    };
    return recordedVideo ? (videoProps.muted = !1, videoProps.controls = !0, videoProps.src = recordedVideo, this.videoElement && (this.videoElement.srcObject = void 0)) : (videoProps.muted = !0, videoProps.autoplay = !0, videoProps.srcObject = src), y$1("div", {
      className: "uppy uppy-Webcam-container"
    }, y$1("div", {
      className: "uppy-Webcam-videoContainer"
    }, y$1("video", _extends$2({
      /* eslint-disable-next-line no-return-assign */
      ref: /* @__PURE__ */ __name((videoElement) => this.videoElement = videoElement, "ref"),
      className: `uppy-Webcam-video  ${mirror ? "uppy-Webcam-video--mirrored" : ""}`
      /* eslint-disable-next-line react/jsx-props-no-spreading */
    }, videoProps))), y$1("div", {
      className: "uppy-Webcam-footer"
    }, y$1("div", {
      className: "uppy-Webcam-videoSourceContainer"
    }, shouldShowVideoSourceDropdown ? VideoSourceSelect(this.props) : null), y$1("div", {
      className: "uppy-Webcam-buttonContainer"
    }, shouldShowSnapshotButton && y$1(SnapshotButton, {
      onSnapshot,
      i18n
    }), shouldShowRecordButton && y$1(RecordButton, {
      recording,
      onStartRecording,
      onStopRecording,
      i18n
    }), hasRecordedVideo && y$1(SubmitButton, {
      onSubmit,
      i18n
    }), hasRecordedVideo && y$1(DiscardButton, {
      onDiscard: onDiscardRecordedVideo,
      i18n
    })), y$1("div", {
      className: "uppy-Webcam-recordingLength"
    }, shouldShowRecordingLength && y$1(RecordingLength, {
      recordingLengthSeconds,
      i18n
    }))));
  }
};
__name(_CameraScreen, "CameraScreen");
let CameraScreen = _CameraScreen;
const PermissionsScreen = /* @__PURE__ */ __name((_ref) => {
  let {
    icon,
    i18n,
    hasCamera
  } = _ref;
  return y$1("div", {
    className: "uppy-Webcam-permissons"
  }, y$1("div", {
    className: "uppy-Webcam-permissonsIcon"
  }, icon()), y$1("h1", {
    className: "uppy-Webcam-title"
  }, i18n(hasCamera ? "allowAccessTitle" : "noCameraTitle")), y$1("p", null, i18n(hasCamera ? "allowAccessDescription" : "noCameraDescription")));
}, "PermissionsScreen"), locale$3 = {
  strings: {
    pluginNameCamera: "Camera",
    noCameraTitle: "Camera Not Available",
    noCameraDescription: "In order to take pictures or record video, please connect a camera device",
    recordingStoppedMaxSize: "Recording stopped because the file size is about to exceed the limit",
    submitRecordedFile: "Submit recorded file",
    discardRecordedFile: "Discard recorded file",
    // Shown before a picture is taken when the `countdown` option is set.
    smile: "Smile!",
    // Used as the label for the button that takes a picture.
    // This is not visibly rendered but is picked up by screen readers.
    takePicture: "Take a picture",
    // Used as the label for the button that starts a video recording.
    // This is not visibly rendered but is picked up by screen readers.
    startRecording: "Begin video recording",
    // Used as the label for the button that stops a video recording.
    // This is not visibly rendered but is picked up by screen readers.
    stopRecording: "Stop video recording",
    // Used as the label for the recording length counter. See the showRecordingLength option.
    // This is not visibly rendered but is picked up by screen readers.
    recordingLength: "Recording length %{recording_length}",
    // Title on the “allow access” screen
    allowAccessTitle: "Please allow access to your camera",
    // Description on the “allow access” screen
    allowAccessDescription: "In order to take pictures or record video with your camera, please allow camera access for this site."
  }
};
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$1.apply(this, arguments);
}
__name(_extends$1, "_extends$1");
function _classPrivateFieldLooseBase$e(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$e, "_classPrivateFieldLooseBase$e");
var id$e = 0;
function _classPrivateFieldLooseKey$e(name) {
  return "__private_" + id$e++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$e, "_classPrivateFieldLooseKey$e");
const packageJson$8 = {
  version: "3.3.2"
};
function toMimeType(fileType) {
  return fileType[0] === "." ? mimeTypes[fileType.slice(1)] : fileType;
}
__name(toMimeType, "toMimeType");
function isVideoMimeType(mimeType) {
  return /^video\/[^*]+$/.test(mimeType);
}
__name(isVideoMimeType, "isVideoMimeType");
function isImageMimeType(mimeType) {
  return /^image\/[^*]+$/.test(mimeType);
}
__name(isImageMimeType, "isImageMimeType");
function getMediaDevices() {
  return navigator.mediaDevices;
}
__name(getMediaDevices, "getMediaDevices");
function isModeAvailable(modes, mode) {
  return modes.includes(mode);
}
__name(isModeAvailable, "isModeAvailable");
var _enableMirror = /* @__PURE__ */ _classPrivateFieldLooseKey$e("enableMirror");
const _Webcam = class _Webcam extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), Object.defineProperty(this, _enableMirror, {
      writable: !0,
      value: void 0
    }), this.mediaDevices = getMediaDevices(), this.supportsUserMedia = !!this.mediaDevices, this.protocol = location.protocol.match(/https/i) ? "https" : "http", this.id = this.opts.id || "Webcam", this.type = "acquirer", this.capturedMediaFile = null, this.icon = () => y$1("svg", {
      "aria-hidden": "true",
      focusable: "false",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32"
    }, y$1("path", {
      d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
      fill: "#02B383",
      fillRule: "nonzero"
    })), this.defaultLocale = locale$3;
    const defaultOptions2 = {
      onBeforeSnapshot: /* @__PURE__ */ __name(() => Promise.resolve(), "onBeforeSnapshot"),
      countdown: !1,
      modes: ["video-audio", "video-only", "audio-only", "picture"],
      mirror: !0,
      showVideoSourceDropdown: !1,
      facingMode: "user",
      // @TODO: remove in the next major
      videoConstraints: void 0,
      preferredImageMimeType: null,
      preferredVideoMimeType: null,
      showRecordingLength: !1,
      mobileNativeCamera: isMobile$1({
        tablet: !0
      })
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.i18nInit(), this.title = this.i18n("pluginNameCamera"), _classPrivateFieldLooseBase$e(this, _enableMirror)[_enableMirror] = this.opts.mirror, this.install = this.install.bind(this), this.setPluginState = this.setPluginState.bind(this), this.render = this.render.bind(this), this.start = this.start.bind(this), this.stop = this.stop.bind(this), this.takeSnapshot = this.takeSnapshot.bind(this), this.startRecording = this.startRecording.bind(this), this.stopRecording = this.stopRecording.bind(this), this.discardRecordedVideo = this.discardRecordedVideo.bind(this), this.submit = this.submit.bind(this), this.oneTwoThreeSmile = this.oneTwoThreeSmile.bind(this), this.focus = this.focus.bind(this), this.changeVideoSource = this.changeVideoSource.bind(this), this.webcamActive = !1, this.opts.countdown && (this.opts.onBeforeSnapshot = this.oneTwoThreeSmile), this.setPluginState({
      hasCamera: !1,
      cameraReady: !1,
      cameraError: null,
      recordingLengthSeconds: 0,
      videoSources: [],
      currentDeviceId: null
    });
  }
  setOptions(newOpts) {
    super.setOptions({
      ...newOpts,
      videoConstraints: {
        // May be undefined but ... handles that
        ...this.opts.videoConstraints,
        ...newOpts == null ? void 0 : newOpts.videoConstraints
      }
    });
  }
  hasCameraCheck() {
    return this.mediaDevices ? this.mediaDevices.enumerateDevices().then((devices) => devices.some((device) => device.kind === "videoinput")) : Promise.resolve(!1);
  }
  isAudioOnly() {
    return this.opts.modes.length === 1 && this.opts.modes[0] === "audio-only";
  }
  getConstraints(deviceId) {
    deviceId === void 0 && (deviceId = null);
    const acceptsAudio = this.opts.modes.indexOf("video-audio") !== -1 || this.opts.modes.indexOf("audio-only") !== -1, acceptsVideo = !this.isAudioOnly() && (this.opts.modes.indexOf("video-audio") !== -1 || this.opts.modes.indexOf("video-only") !== -1 || this.opts.modes.indexOf("picture") !== -1), videoConstraints = {
      ...this.opts.videoConstraints || {
        facingMode: this.opts.facingMode
      },
      // facingMode takes precedence over deviceId, and not needed
      // when specific device is selected
      ...deviceId ? {
        deviceId,
        facingMode: null
      } : {}
    };
    return {
      audio: acceptsAudio,
      video: acceptsVideo ? videoConstraints : !1
    };
  }
  // eslint-disable-next-line consistent-return
  start(options) {
    if (options === void 0 && (options = null), !this.supportsUserMedia)
      return Promise.reject(new Error("Webcam access not supported"));
    this.webcamActive = !0, this.opts.mirror && (_classPrivateFieldLooseBase$e(this, _enableMirror)[_enableMirror] = !0);
    const constraints = this.getConstraints(options && options.deviceId ? options.deviceId : null);
    this.hasCameraCheck().then((hasCamera) => (this.setPluginState({
      hasCamera
    }), this.mediaDevices.getUserMedia(constraints).then((stream) => {
      this.stream = stream;
      let currentDeviceId = null;
      const tracks = this.isAudioOnly() ? stream.getAudioTracks() : stream.getVideoTracks();
      !options || !options.deviceId ? currentDeviceId = tracks[0].getSettings().deviceId : tracks.forEach((track) => {
        track.getSettings().deviceId === options.deviceId && (currentDeviceId = track.getSettings().deviceId);
      }), this.updateVideoSources(), this.setPluginState({
        currentDeviceId,
        cameraReady: !0
      });
    }).catch((err) => {
      this.setPluginState({
        cameraReady: !1,
        cameraError: err
      }), this.uppy.info(err.message, "error");
    })));
  }
  /**
   * @returns {object}
   */
  getMediaRecorderOptions() {
    const options = {};
    if (MediaRecorder.isTypeSupported) {
      const {
        restrictions
      } = this.uppy.opts;
      let preferredVideoMimeTypes = [];
      this.opts.preferredVideoMimeType ? preferredVideoMimeTypes = [this.opts.preferredVideoMimeType] : restrictions.allowedFileTypes && (preferredVideoMimeTypes = restrictions.allowedFileTypes.map(toMimeType).filter(isVideoMimeType));
      const filterSupportedTypes = /* @__PURE__ */ __name((candidateType) => MediaRecorder.isTypeSupported(candidateType) && getFileTypeExtension(candidateType), "filterSupportedTypes"), acceptableMimeTypes = preferredVideoMimeTypes.filter(filterSupportedTypes);
      acceptableMimeTypes.length > 0 && (options.mimeType = acceptableMimeTypes[0]);
    }
    return options;
  }
  startRecording() {
    this.recorder = new MediaRecorder(this.stream, this.getMediaRecorderOptions()), this.recordingChunks = [];
    let stoppingBecauseOfMaxSize = !1;
    this.recorder.addEventListener("dataavailable", (event) => {
      this.recordingChunks.push(event.data);
      const {
        restrictions
      } = this.uppy.opts;
      if (this.recordingChunks.length > 1 && restrictions.maxFileSize != null && !stoppingBecauseOfMaxSize) {
        const totalSize = this.recordingChunks.reduce((acc, chunk2) => acc + chunk2.size, 0), expectedEndChunkSize = (totalSize - this.recordingChunks[0].size) / (this.recordingChunks.length - 1) * 3, maxSize = Math.max(0, restrictions.maxFileSize - expectedEndChunkSize);
        totalSize > maxSize && (stoppingBecauseOfMaxSize = !0, this.uppy.info(this.i18n("recordingStoppedMaxSize"), "warning", 4e3), this.stopRecording());
      }
    }), this.recorder.start(500), this.opts.showRecordingLength && (this.recordingLengthTimer = setInterval(() => {
      const currentRecordingLength = this.getPluginState().recordingLengthSeconds;
      this.setPluginState({
        recordingLengthSeconds: currentRecordingLength + 1
      });
    }, 1e3)), this.setPluginState({
      isRecording: !0
    });
  }
  stopRecording() {
    return new Promise((resolve3) => {
      this.recorder.addEventListener("stop", () => {
        resolve3();
      }), this.recorder.stop(), this.opts.showRecordingLength && (clearInterval(this.recordingLengthTimer), this.setPluginState({
        recordingLengthSeconds: 0
      }));
    }).then(() => (this.setPluginState({
      isRecording: !1
    }), this.getVideo())).then((file) => {
      try {
        this.capturedMediaFile = file, this.setPluginState({
          // eslint-disable-next-line compat/compat
          recordedVideo: URL.createObjectURL(file.data)
        }), _classPrivateFieldLooseBase$e(this, _enableMirror)[_enableMirror] = !1;
      } catch (err) {
        err.isRestriction || this.uppy.log(err);
      }
    }).then(() => {
      this.recordingChunks = null, this.recorder = null;
    }, (error) => {
      throw this.recordingChunks = null, this.recorder = null, error;
    });
  }
  discardRecordedVideo() {
    this.setPluginState({
      recordedVideo: null
    }), this.opts.mirror && (_classPrivateFieldLooseBase$e(this, _enableMirror)[_enableMirror] = !0), this.capturedMediaFile = null;
  }
  submit() {
    try {
      this.capturedMediaFile && this.uppy.addFile(this.capturedMediaFile);
    } catch (err) {
      err.isRestriction || this.uppy.log(err, "error");
    }
  }
  async stop() {
    if (this.stream) {
      const audioTracks = this.stream.getAudioTracks(), videoTracks = this.stream.getVideoTracks();
      audioTracks.concat(videoTracks).forEach((track) => track.stop());
    }
    this.recorder && await new Promise((resolve3) => {
      this.recorder.addEventListener("stop", resolve3, {
        once: !0
      }), this.recorder.stop(), this.opts.showRecordingLength && clearInterval(this.recordingLengthTimer);
    }), this.recordingChunks = null, this.recorder = null, this.webcamActive = !1, this.stream = null, this.setPluginState({
      recordedVideo: null,
      isRecording: !1,
      recordingLengthSeconds: 0
    });
  }
  getVideoElement() {
    return this.el.querySelector(".uppy-Webcam-video");
  }
  oneTwoThreeSmile() {
    return new Promise((resolve3, reject) => {
      let count = this.opts.countdown;
      const countDown = setInterval(() => {
        if (!this.webcamActive)
          return clearInterval(countDown), this.captureInProgress = !1, reject(new Error("Webcam is not active"));
        count > 0 ? (this.uppy.info(`${count}...`, "warning", 800), count--) : (clearInterval(countDown), this.uppy.info(this.i18n("smile"), "success", 1500), setTimeout(() => resolve3(), 1500));
      }, 1e3);
    });
  }
  takeSnapshot() {
    this.captureInProgress || (this.captureInProgress = !0, this.opts.onBeforeSnapshot().catch((err) => {
      const message = typeof err == "object" ? err.message : err;
      return this.uppy.info(message, "error", 5e3), Promise.reject(new Error(`onBeforeSnapshot: ${message}`));
    }).then(() => this.getImage()).then((tagFile) => {
      this.captureInProgress = !1;
      try {
        this.uppy.addFile(tagFile);
      } catch (err) {
        err.isRestriction || this.uppy.log(err);
      }
    }, (error) => {
      throw this.captureInProgress = !1, error;
    }));
  }
  getImage() {
    const video = this.getVideoElement();
    if (!video)
      return Promise.reject(new Error("No video element found, likely due to the Webcam tab being closed."));
    const width = video.videoWidth, height = video.videoHeight, canvas = document.createElement("canvas");
    canvas.width = width, canvas.height = height, canvas.getContext("2d").drawImage(video, 0, 0);
    const {
      restrictions
    } = this.uppy.opts;
    let preferredImageMimeTypes = [];
    this.opts.preferredImageMimeType ? preferredImageMimeTypes = [this.opts.preferredImageMimeType] : restrictions.allowedFileTypes && (preferredImageMimeTypes = restrictions.allowedFileTypes.map(toMimeType).filter(isImageMimeType));
    const mimeType = preferredImageMimeTypes[0] || "image/jpeg", ext = getFileTypeExtension(mimeType) || "jpg", name = `cam-${Date.now()}.${ext}`;
    return canvasToBlob$1(canvas, mimeType).then((blob) => ({
      source: this.id,
      name,
      data: new Blob([blob], {
        type: mimeType
      }),
      type: mimeType
    }));
  }
  getVideo() {
    const mimeType = this.recordingChunks.find((blob2) => {
      var _blob$type;
      return ((_blob$type = blob2.type) == null ? void 0 : _blob$type.length) > 0;
    }).type, fileExtension = getFileTypeExtension(mimeType);
    if (!fileExtension)
      return Promise.reject(new Error(`Could not retrieve recording: Unsupported media type "${mimeType}"`));
    const name = `webcam-${Date.now()}.${fileExtension}`, blob = new Blob(this.recordingChunks, {
      type: mimeType
    }), file = {
      source: this.id,
      name,
      data: new Blob([blob], {
        type: mimeType
      }),
      type: mimeType
    };
    return Promise.resolve(file);
  }
  focus() {
    this.opts.countdown && setTimeout(() => {
      this.uppy.info(this.i18n("smile"), "success", 1500);
    }, 1e3);
  }
  changeVideoSource(deviceId) {
    this.stop(), this.start({
      deviceId
    });
  }
  updateVideoSources() {
    this.mediaDevices.enumerateDevices().then((devices) => {
      this.setPluginState({
        videoSources: devices.filter((device) => device.kind === "videoinput")
      });
    });
  }
  render() {
    this.webcamActive || this.start();
    const webcamState = this.getPluginState();
    return !webcamState.cameraReady || !webcamState.hasCamera ? y$1(PermissionsScreen, {
      icon: CameraIcon,
      i18n: this.i18n,
      hasCamera: webcamState.hasCamera
    }) : y$1(
      CameraScreen,
      _extends$1({}, webcamState, {
        onChangeVideoSource: this.changeVideoSource,
        onSnapshot: this.takeSnapshot,
        onStartRecording: this.startRecording,
        onStopRecording: this.stopRecording,
        onDiscardRecordedVideo: this.discardRecordedVideo,
        onSubmit: this.submit,
        onFocus: this.focus,
        onStop: this.stop,
        i18n: this.i18n,
        modes: this.opts.modes,
        showRecordingLength: this.opts.showRecordingLength,
        showVideoSourceDropdown: this.opts.showVideoSourceDropdown,
        supportsRecording: supportsMediaRecorder(),
        recording: webcamState.isRecording,
        mirror: _classPrivateFieldLooseBase$e(this, _enableMirror)[_enableMirror],
        src: this.stream
      })
    );
  }
  install() {
    const {
      mobileNativeCamera,
      modes,
      facingMode,
      videoConstraints
    } = this.opts, {
      target
    } = this.opts;
    if (mobileNativeCamera && target) {
      var _this$getTargetPlugin;
      (_this$getTargetPlugin = this.getTargetPlugin(target)) == null || _this$getTargetPlugin.setOptions({
        showNativeVideoCameraButton: isModeAvailable(modes, "video-only") || isModeAvailable(modes, "video-audio"),
        showNativePhotoCameraButton: isModeAvailable(modes, "picture"),
        nativeCameraFacingMode: (videoConstraints == null ? void 0 : videoConstraints.facingMode) || facingMode
      });
      return;
    }
    this.setPluginState({
      cameraReady: !1,
      recordingLengthSeconds: 0
    }), target && this.mount(target, this), this.mediaDevices && (this.updateVideoSources(), this.mediaDevices.ondevicechange = () => {
      if (this.updateVideoSources(), this.stream) {
        let restartStream = !0;
        const {
          videoSources,
          currentDeviceId
        } = this.getPluginState();
        videoSources.forEach((videoSource) => {
          currentDeviceId === videoSource.deviceId && (restartStream = !1);
        }), restartStream && (this.stop(), this.start());
      }
    });
  }
  uninstall() {
    this.stop(), this.unmount();
  }
  onUnmount() {
    this.stop();
  }
};
__name(_Webcam, "Webcam");
let Webcam = _Webcam;
Webcam.VERSION = packageJson$8.version;
function _classPrivateFieldLooseBase$d(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$d, "_classPrivateFieldLooseBase$d");
var id$d = 0;
function _classPrivateFieldLooseKey$d(name) {
  return "__private_" + id$d++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$d, "_classPrivateFieldLooseKey$d");
function createCancelError(cause) {
  return new Error("Cancelled", {
    cause
  });
}
__name(createCancelError, "createCancelError");
function abortOn(signal) {
  if (signal != null) {
    var _this$then;
    const abortPromise = /* @__PURE__ */ __name(() => this.abort(signal.reason), "abortPromise");
    signal.addEventListener("abort", abortPromise, {
      once: !0
    });
    const removeAbortListener = /* @__PURE__ */ __name(() => {
      signal.removeEventListener("abort", abortPromise);
    }, "removeAbortListener");
    (_this$then = this.then) == null || _this$then.call(this, removeAbortListener, removeAbortListener);
  }
  return this;
}
__name(abortOn, "abortOn");
var _activeRequests = /* @__PURE__ */ _classPrivateFieldLooseKey$d("activeRequests"), _queuedHandlers = /* @__PURE__ */ _classPrivateFieldLooseKey$d("queuedHandlers"), _paused = /* @__PURE__ */ _classPrivateFieldLooseKey$d("paused"), _pauseTimer = /* @__PURE__ */ _classPrivateFieldLooseKey$d("pauseTimer"), _downLimit = /* @__PURE__ */ _classPrivateFieldLooseKey$d("downLimit"), _upperLimit = /* @__PURE__ */ _classPrivateFieldLooseKey$d("upperLimit"), _rateLimitingTimer = /* @__PURE__ */ _classPrivateFieldLooseKey$d("rateLimitingTimer"), _call = /* @__PURE__ */ _classPrivateFieldLooseKey$d("call"), _queueNext = /* @__PURE__ */ _classPrivateFieldLooseKey$d("queueNext"), _next = /* @__PURE__ */ _classPrivateFieldLooseKey$d("next"), _queue = /* @__PURE__ */ _classPrivateFieldLooseKey$d("queue"), _dequeue = /* @__PURE__ */ _classPrivateFieldLooseKey$d("dequeue"), _resume = /* @__PURE__ */ _classPrivateFieldLooseKey$d("resume"), _increaseLimit = /* @__PURE__ */ _classPrivateFieldLooseKey$d("increaseLimit");
const _RateLimitedQueue = class _RateLimitedQueue {
  constructor(limit) {
    Object.defineProperty(this, _dequeue, {
      value: _dequeue2
    }), Object.defineProperty(this, _queue, {
      value: _queue2
    }), Object.defineProperty(this, _next, {
      value: _next2
    }), Object.defineProperty(this, _queueNext, {
      value: _queueNext2
    }), Object.defineProperty(this, _call, {
      value: _call2
    }), Object.defineProperty(this, _activeRequests, {
      writable: !0,
      value: 0
    }), Object.defineProperty(this, _queuedHandlers, {
      writable: !0,
      value: []
    }), Object.defineProperty(this, _paused, {
      writable: !0,
      value: !1
    }), Object.defineProperty(this, _pauseTimer, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _downLimit, {
      writable: !0,
      value: 1
    }), Object.defineProperty(this, _upperLimit, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _rateLimitingTimer, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _resume, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => this.resume(), "value")
    }), Object.defineProperty(this, _increaseLimit, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        if (_classPrivateFieldLooseBase$d(this, _paused)[_paused]) {
          _classPrivateFieldLooseBase$d(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase$d(this, _increaseLimit)[_increaseLimit], 0);
          return;
        }
        _classPrivateFieldLooseBase$d(this, _downLimit)[_downLimit] = this.limit, this.limit = Math.ceil((_classPrivateFieldLooseBase$d(this, _upperLimit)[_upperLimit] + _classPrivateFieldLooseBase$d(this, _downLimit)[_downLimit]) / 2);
        for (let i2 = _classPrivateFieldLooseBase$d(this, _downLimit)[_downLimit]; i2 <= this.limit; i2++)
          _classPrivateFieldLooseBase$d(this, _queueNext)[_queueNext]();
        _classPrivateFieldLooseBase$d(this, _upperLimit)[_upperLimit] - _classPrivateFieldLooseBase$d(this, _downLimit)[_downLimit] > 3 ? _classPrivateFieldLooseBase$d(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase$d(this, _increaseLimit)[_increaseLimit], 2e3) : _classPrivateFieldLooseBase$d(this, _downLimit)[_downLimit] = Math.floor(_classPrivateFieldLooseBase$d(this, _downLimit)[_downLimit] / 2);
      }, "value")
    }), typeof limit != "number" || limit === 0 ? this.limit = 1 / 0 : this.limit = limit;
  }
  run(fn, queueOptions) {
    return !_classPrivateFieldLooseBase$d(this, _paused)[_paused] && _classPrivateFieldLooseBase$d(this, _activeRequests)[_activeRequests] < this.limit ? _classPrivateFieldLooseBase$d(this, _call)[_call](fn) : _classPrivateFieldLooseBase$d(this, _queue)[_queue](fn, queueOptions);
  }
  wrapSyncFunction(fn, queueOptions) {
    var _this = this;
    return function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
        args[_key] = arguments[_key];
      const queuedRequest = _this.run(() => (fn(...args), queueMicrotask(() => queuedRequest.done()), () => {
      }), queueOptions);
      return {
        abortOn,
        abort() {
          queuedRequest.abort();
        }
      };
    };
  }
  wrapPromiseFunction(fn, queueOptions) {
    var _this2 = this;
    return function() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)
        args[_key2] = arguments[_key2];
      let queuedRequest;
      const outerPromise = new Promise((resolve3, reject) => {
        queuedRequest = _this2.run(() => {
          let cancelError, innerPromise;
          try {
            innerPromise = Promise.resolve(fn(...args));
          } catch (err) {
            innerPromise = Promise.reject(err);
          }
          return innerPromise.then((result2) => {
            cancelError ? reject(cancelError) : (queuedRequest.done(), resolve3(result2));
          }, (err) => {
            cancelError ? reject(cancelError) : (queuedRequest.done(), reject(err));
          }), (cause) => {
            cancelError = createCancelError(cause);
          };
        }, queueOptions);
      });
      return outerPromise.abort = (cause) => {
        queuedRequest.abort(cause);
      }, outerPromise.abortOn = abortOn, outerPromise;
    };
  }
  resume() {
    _classPrivateFieldLooseBase$d(this, _paused)[_paused] = !1, clearTimeout(_classPrivateFieldLooseBase$d(this, _pauseTimer)[_pauseTimer]);
    for (let i2 = 0; i2 < this.limit; i2++)
      _classPrivateFieldLooseBase$d(this, _queueNext)[_queueNext]();
  }
  /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */
  pause(duration2) {
    duration2 === void 0 && (duration2 = null), _classPrivateFieldLooseBase$d(this, _paused)[_paused] = !0, clearTimeout(_classPrivateFieldLooseBase$d(this, _pauseTimer)[_pauseTimer]), duration2 != null && (_classPrivateFieldLooseBase$d(this, _pauseTimer)[_pauseTimer] = setTimeout(_classPrivateFieldLooseBase$d(this, _resume)[_resume], duration2));
  }
  /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */
  rateLimit(duration2) {
    clearTimeout(_classPrivateFieldLooseBase$d(this, _rateLimitingTimer)[_rateLimitingTimer]), this.pause(duration2), this.limit > 1 && Number.isFinite(this.limit) && (_classPrivateFieldLooseBase$d(this, _upperLimit)[_upperLimit] = this.limit - 1, this.limit = _classPrivateFieldLooseBase$d(this, _downLimit)[_downLimit], _classPrivateFieldLooseBase$d(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase$d(this, _increaseLimit)[_increaseLimit], duration2));
  }
  get isPaused() {
    return _classPrivateFieldLooseBase$d(this, _paused)[_paused];
  }
};
__name(_RateLimitedQueue, "RateLimitedQueue");
let RateLimitedQueue = _RateLimitedQueue;
function _call2(fn) {
  _classPrivateFieldLooseBase$d(this, _activeRequests)[_activeRequests] += 1;
  let done = !1, cancelActive;
  try {
    cancelActive = fn();
  } catch (err) {
    throw _classPrivateFieldLooseBase$d(this, _activeRequests)[_activeRequests] -= 1, err;
  }
  return {
    abort: /* @__PURE__ */ __name((cause) => {
      done || (done = !0, _classPrivateFieldLooseBase$d(this, _activeRequests)[_activeRequests] -= 1, cancelActive(cause), _classPrivateFieldLooseBase$d(this, _queueNext)[_queueNext]());
    }, "abort"),
    done: /* @__PURE__ */ __name(() => {
      done || (done = !0, _classPrivateFieldLooseBase$d(this, _activeRequests)[_activeRequests] -= 1, _classPrivateFieldLooseBase$d(this, _queueNext)[_queueNext]());
    }, "done")
  };
}
__name(_call2, "_call2");
function _queueNext2() {
  queueMicrotask(() => _classPrivateFieldLooseBase$d(this, _next)[_next]());
}
__name(_queueNext2, "_queueNext2");
function _next2() {
  if (_classPrivateFieldLooseBase$d(this, _paused)[_paused] || _classPrivateFieldLooseBase$d(this, _activeRequests)[_activeRequests] >= this.limit || _classPrivateFieldLooseBase$d(this, _queuedHandlers)[_queuedHandlers].length === 0)
    return;
  const next = _classPrivateFieldLooseBase$d(this, _queuedHandlers)[_queuedHandlers].shift(), handler = _classPrivateFieldLooseBase$d(this, _call)[_call](next.fn);
  next.abort = handler.abort, next.done = handler.done;
}
__name(_next2, "_next2");
function _queue2(fn, options) {
  options === void 0 && (options = {});
  const handler = {
    fn,
    priority: options.priority || 0,
    abort: /* @__PURE__ */ __name(() => {
      _classPrivateFieldLooseBase$d(this, _dequeue)[_dequeue](handler);
    }, "abort"),
    done: /* @__PURE__ */ __name(() => {
      throw new Error("Cannot mark a queued request as done: this indicates a bug");
    }, "done")
  }, index = _classPrivateFieldLooseBase$d(this, _queuedHandlers)[_queuedHandlers].findIndex((other) => handler.priority > other.priority);
  return index === -1 ? _classPrivateFieldLooseBase$d(this, _queuedHandlers)[_queuedHandlers].push(handler) : _classPrivateFieldLooseBase$d(this, _queuedHandlers)[_queuedHandlers].splice(index, 0, handler), handler;
}
__name(_queue2, "_queue2");
function _dequeue2(handler) {
  const index = _classPrivateFieldLooseBase$d(this, _queuedHandlers)[_queuedHandlers].indexOf(handler);
  index !== -1 && _classPrivateFieldLooseBase$d(this, _queuedHandlers)[_queuedHandlers].splice(index, 1);
}
__name(_dequeue2, "_dequeue2");
const internalRateLimitedQueue = Symbol("__queue");
function filterNonFailedFiles(files) {
  const hasError = /* @__PURE__ */ __name((file) => "error" in file && file.error, "hasError");
  return files.filter((file) => !hasError(file));
}
__name(filterNonFailedFiles, "filterNonFailedFiles");
function filterFilesToEmitUploadStarted(files) {
  return files.filter((file) => !file.progress.uploadStarted || !file.isRestored);
}
__name(filterFilesToEmitUploadStarted, "filterFilesToEmitUploadStarted");
const {
  AbortController: AbortController$1
} = globalThis, createAbortError = /* @__PURE__ */ __name(function(message, options) {
  message === void 0 && (message = "Aborted");
  const err = new DOMException(message, "AbortError");
  return options != null && has$1(options, "cause") && Object.defineProperty(err, "cause", {
    __proto__: null,
    configurable: !0,
    writable: !0,
    value: options.cause
  }), err;
}, "createAbortError");
function _classPrivateFieldLooseBase$c(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$c, "_classPrivateFieldLooseBase$c");
var id$c = 0;
function _classPrivateFieldLooseKey$c(name) {
  return "__private_" + id$c++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$c, "_classPrivateFieldLooseKey$c");
const MB$1 = 1024 * 1024, defaultOptions$3 = {
  getChunkSize(file) {
    return Math.ceil(file.size / 1e4);
  },
  onProgress() {
  },
  onPartComplete() {
  },
  onSuccess() {
  },
  onError(err) {
    throw err;
  }
};
function ensureInt(value) {
  if (typeof value == "string")
    return parseInt(value, 10);
  if (typeof value == "number")
    return value;
  throw new TypeError("Expected a number");
}
__name(ensureInt, "ensureInt");
const pausingUploadReason = Symbol("pausing upload, not an actual error");
var _abortController = /* @__PURE__ */ _classPrivateFieldLooseKey$c("abortController"), _chunks = /* @__PURE__ */ _classPrivateFieldLooseKey$c("chunks"), _chunkState = /* @__PURE__ */ _classPrivateFieldLooseKey$c("chunkState"), _data = /* @__PURE__ */ _classPrivateFieldLooseKey$c("data"), _file = /* @__PURE__ */ _classPrivateFieldLooseKey$c("file"), _uploadHasStarted = /* @__PURE__ */ _classPrivateFieldLooseKey$c("uploadHasStarted"), _onError$2 = /* @__PURE__ */ _classPrivateFieldLooseKey$c("onError"), _onSuccess = /* @__PURE__ */ _classPrivateFieldLooseKey$c("onSuccess"), _shouldUseMultipart = /* @__PURE__ */ _classPrivateFieldLooseKey$c("shouldUseMultipart"), _isRestoring = /* @__PURE__ */ _classPrivateFieldLooseKey$c("isRestoring"), _onReject = /* @__PURE__ */ _classPrivateFieldLooseKey$c("onReject"), _maxMultipartParts = /* @__PURE__ */ _classPrivateFieldLooseKey$c("maxMultipartParts"), _minPartSize = /* @__PURE__ */ _classPrivateFieldLooseKey$c("minPartSize"), _initChunks = /* @__PURE__ */ _classPrivateFieldLooseKey$c("initChunks"), _createUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$c("createUpload"), _resumeUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$c("resumeUpload"), _onPartProgress = /* @__PURE__ */ _classPrivateFieldLooseKey$c("onPartProgress"), _onPartComplete = /* @__PURE__ */ _classPrivateFieldLooseKey$c("onPartComplete"), _abortUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$c("abortUpload");
const _MultipartUploader = class _MultipartUploader {
  constructor(data, options) {
    var _this$options, _this$options$getChun;
    Object.defineProperty(this, _abortUpload, {
      value: _abortUpload2
    }), Object.defineProperty(this, _resumeUpload, {
      value: _resumeUpload2
    }), Object.defineProperty(this, _createUpload, {
      value: _createUpload2
    }), Object.defineProperty(this, _initChunks, {
      value: _initChunks2
    }), Object.defineProperty(this, _abortController, {
      writable: !0,
      value: new AbortController$1()
    }), Object.defineProperty(this, _chunks, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _chunkState, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _data, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _file, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _uploadHasStarted, {
      writable: !0,
      value: !1
    }), Object.defineProperty(this, _onError$2, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _onSuccess, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _shouldUseMultipart, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _isRestoring, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _onReject, {
      writable: !0,
      value: /* @__PURE__ */ __name((err) => (err == null ? void 0 : err.cause) === pausingUploadReason ? null : _classPrivateFieldLooseBase$c(this, _onError$2)[_onError$2](err), "value")
    }), Object.defineProperty(this, _maxMultipartParts, {
      writable: !0,
      value: 1e4
    }), Object.defineProperty(this, _minPartSize, {
      writable: !0,
      value: 5 * MB$1
    }), Object.defineProperty(this, _onPartProgress, {
      writable: !0,
      value: /* @__PURE__ */ __name((index) => (ev) => {
        if (!ev.lengthComputable) return;
        _classPrivateFieldLooseBase$c(this, _chunkState)[_chunkState][index].uploaded = ensureInt(ev.loaded);
        const totalUploaded = _classPrivateFieldLooseBase$c(this, _chunkState)[_chunkState].reduce((n2, c2) => n2 + c2.uploaded, 0);
        this.options.onProgress(totalUploaded, _classPrivateFieldLooseBase$c(this, _data)[_data].size);
      }, "value")
    }), Object.defineProperty(this, _onPartComplete, {
      writable: !0,
      value: /* @__PURE__ */ __name((index) => (etag) => {
        _classPrivateFieldLooseBase$c(this, _chunks)[_chunks][index] = null, _classPrivateFieldLooseBase$c(this, _chunkState)[_chunkState][index].etag = etag, _classPrivateFieldLooseBase$c(this, _chunkState)[_chunkState][index].done = !0;
        const part = {
          PartNumber: index + 1,
          ETag: etag
        };
        this.options.onPartComplete(part);
      }, "value")
    }), this.options = {
      ...defaultOptions$3,
      ...options
    }, (_this$options$getChun = (_this$options = this.options).getChunkSize) != null || (_this$options.getChunkSize = defaultOptions$3.getChunkSize), _classPrivateFieldLooseBase$c(this, _data)[_data] = data, _classPrivateFieldLooseBase$c(this, _file)[_file] = options.file, _classPrivateFieldLooseBase$c(this, _onSuccess)[_onSuccess] = this.options.onSuccess, _classPrivateFieldLooseBase$c(this, _onError$2)[_onError$2] = this.options.onError, _classPrivateFieldLooseBase$c(this, _shouldUseMultipart)[_shouldUseMultipart] = this.options.shouldUseMultipart, _classPrivateFieldLooseBase$c(this, _isRestoring)[_isRestoring] = options.uploadId && options.key, _classPrivateFieldLooseBase$c(this, _initChunks)[_initChunks]();
  }
  start() {
    _classPrivateFieldLooseBase$c(this, _uploadHasStarted)[_uploadHasStarted] ? (_classPrivateFieldLooseBase$c(this, _abortController)[_abortController].signal.aborted || _classPrivateFieldLooseBase$c(this, _abortController)[_abortController].abort(pausingUploadReason), _classPrivateFieldLooseBase$c(this, _abortController)[_abortController] = new AbortController$1(), _classPrivateFieldLooseBase$c(this, _resumeUpload)[_resumeUpload]()) : _classPrivateFieldLooseBase$c(this, _isRestoring)[_isRestoring] ? (this.options.companionComm.restoreUploadFile(_classPrivateFieldLooseBase$c(this, _file)[_file], {
      uploadId: this.options.uploadId,
      key: this.options.key
    }), _classPrivateFieldLooseBase$c(this, _resumeUpload)[_resumeUpload]()) : _classPrivateFieldLooseBase$c(this, _createUpload)[_createUpload]();
  }
  pause() {
    _classPrivateFieldLooseBase$c(this, _abortController)[_abortController].abort(pausingUploadReason), _classPrivateFieldLooseBase$c(this, _abortController)[_abortController] = new AbortController$1();
  }
  abort(opts) {
    var _opts;
    opts === void 0 && (opts = void 0), (_opts = opts) != null && _opts.really ? _classPrivateFieldLooseBase$c(this, _abortUpload)[_abortUpload]() : this.pause();
  }
  // TODO: remove this in the next major
  get chunkState() {
    return _classPrivateFieldLooseBase$c(this, _chunkState)[_chunkState];
  }
};
__name(_MultipartUploader, "MultipartUploader");
let MultipartUploader = _MultipartUploader;
function _initChunks2() {
  const fileSize = _classPrivateFieldLooseBase$c(this, _data)[_data].size, shouldUseMultipart = typeof _classPrivateFieldLooseBase$c(this, _shouldUseMultipart)[_shouldUseMultipart] == "function" ? _classPrivateFieldLooseBase$c(this, _shouldUseMultipart)[_shouldUseMultipart](_classPrivateFieldLooseBase$c(this, _file)[_file]) : !!_classPrivateFieldLooseBase$c(this, _shouldUseMultipart)[_shouldUseMultipart];
  if (shouldUseMultipart && fileSize > _classPrivateFieldLooseBase$c(this, _minPartSize)[_minPartSize]) {
    let chunkSize = Math.max(this.options.getChunkSize(_classPrivateFieldLooseBase$c(this, _data)[_data]), _classPrivateFieldLooseBase$c(this, _minPartSize)[_minPartSize]), arraySize = Math.floor(fileSize / chunkSize);
    arraySize > _classPrivateFieldLooseBase$c(this, _maxMultipartParts)[_maxMultipartParts] && (arraySize = _classPrivateFieldLooseBase$c(this, _maxMultipartParts)[_maxMultipartParts], chunkSize = fileSize / _classPrivateFieldLooseBase$c(this, _maxMultipartParts)[_maxMultipartParts]), _classPrivateFieldLooseBase$c(this, _chunks)[_chunks] = Array(arraySize);
    for (let offset = 0, j2 = 0; offset < fileSize; offset += chunkSize, j2++) {
      const end = Math.min(fileSize, offset + chunkSize), getData3 = /* @__PURE__ */ __name(() => {
        const i2 = offset;
        return _classPrivateFieldLooseBase$c(this, _data)[_data].slice(i2, end);
      }, "getData");
      if (_classPrivateFieldLooseBase$c(this, _chunks)[_chunks][j2] = {
        getData: getData3,
        onProgress: _classPrivateFieldLooseBase$c(this, _onPartProgress)[_onPartProgress](j2),
        onComplete: _classPrivateFieldLooseBase$c(this, _onPartComplete)[_onPartComplete](j2),
        shouldUseMultipart
      }, _classPrivateFieldLooseBase$c(this, _isRestoring)[_isRestoring]) {
        const size = offset + chunkSize > fileSize ? fileSize - offset : chunkSize;
        _classPrivateFieldLooseBase$c(this, _chunks)[_chunks][j2].setAsUploaded = () => {
          _classPrivateFieldLooseBase$c(this, _chunks)[_chunks][j2] = null, _classPrivateFieldLooseBase$c(this, _chunkState)[_chunkState][j2].uploaded = size;
        };
      }
    }
  } else
    _classPrivateFieldLooseBase$c(this, _chunks)[_chunks] = [{
      getData: /* @__PURE__ */ __name(() => _classPrivateFieldLooseBase$c(this, _data)[_data], "getData"),
      onProgress: _classPrivateFieldLooseBase$c(this, _onPartProgress)[_onPartProgress](0),
      onComplete: _classPrivateFieldLooseBase$c(this, _onPartComplete)[_onPartComplete](0),
      shouldUseMultipart
    }];
  _classPrivateFieldLooseBase$c(this, _chunkState)[_chunkState] = _classPrivateFieldLooseBase$c(this, _chunks)[_chunks].map(() => ({
    uploaded: 0
  }));
}
__name(_initChunks2, "_initChunks2");
function _createUpload2() {
  this.options.companionComm.uploadFile(_classPrivateFieldLooseBase$c(this, _file)[_file], _classPrivateFieldLooseBase$c(this, _chunks)[_chunks], _classPrivateFieldLooseBase$c(this, _abortController)[_abortController].signal).then(_classPrivateFieldLooseBase$c(this, _onSuccess)[_onSuccess], _classPrivateFieldLooseBase$c(this, _onReject)[_onReject]), _classPrivateFieldLooseBase$c(this, _uploadHasStarted)[_uploadHasStarted] = !0;
}
__name(_createUpload2, "_createUpload2");
function _resumeUpload2() {
  this.options.companionComm.resumeUploadFile(_classPrivateFieldLooseBase$c(this, _file)[_file], _classPrivateFieldLooseBase$c(this, _chunks)[_chunks], _classPrivateFieldLooseBase$c(this, _abortController)[_abortController].signal).then(_classPrivateFieldLooseBase$c(this, _onSuccess)[_onSuccess], _classPrivateFieldLooseBase$c(this, _onReject)[_onReject]);
}
__name(_resumeUpload2, "_resumeUpload2");
function _abortUpload2() {
  _classPrivateFieldLooseBase$c(this, _abortController)[_abortController].abort(), this.options.companionComm.abortFileUpload(_classPrivateFieldLooseBase$c(this, _file)[_file]).catch((err) => this.options.log(err));
}
__name(_abortUpload2, "_abortUpload2");
function createCanonicalRequest(_ref) {
  let {
    method = "PUT",
    CanonicalUri = "/",
    CanonicalQueryString = "",
    SignedHeaders,
    HashedPayload
  } = _ref;
  const headerKeys = Object.keys(SignedHeaders).map((k2) => k2.toLowerCase()).sort();
  return [method, CanonicalUri, CanonicalQueryString, ...headerKeys.map((k2) => `${k2}:${SignedHeaders[k2]}`), "", headerKeys.join(";"), HashedPayload].join(`
`);
}
__name(createCanonicalRequest, "createCanonicalRequest");
const ec = new TextEncoder(), algorithm = {
  name: "HMAC",
  hash: "SHA-256"
};
async function digest(data) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.digest(algorithm.hash, ec.encode(data));
}
__name(digest, "digest");
async function generateHmacKey(secret) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.importKey("raw", typeof secret == "string" ? ec.encode(secret) : secret, algorithm, !1, ["sign"]);
}
__name(generateHmacKey, "generateHmacKey");
function arrayBufferToHexString(arrayBuffer) {
  const byteArray = new Uint8Array(arrayBuffer);
  let hexString = "";
  for (let i2 = 0; i2 < byteArray.length; i2++)
    hexString += byteArray[i2].toString(16).padStart(2, "0");
  return hexString;
}
__name(arrayBufferToHexString, "arrayBufferToHexString");
async function hash(key, data) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.sign(algorithm, await generateHmacKey(key), ec.encode(data));
}
__name(hash, "hash");
async function createSignedURL(_ref2) {
  let {
    accountKey,
    accountSecret,
    sessionToken,
    bucketName,
    Key,
    Region,
    expires,
    uploadId,
    partNumber
  } = _ref2;
  const Service = "s3", host = `${bucketName}.${Service}.${Region}.amazonaws.com`, CanonicalUri = `/${encodeURI(Key)}`, payload = "UNSIGNED-PAYLOAD", requestDateTime = (/* @__PURE__ */ new Date()).toISOString().replace(/[-:]|\.\d+/g, ""), date = requestDateTime.slice(0, 8), scope = `${date}/${Region}/${Service}/aws4_request`, url = new URL(`https://${host}${CanonicalUri}`);
  url.searchParams.set("X-Amz-Algorithm", "AWS4-HMAC-SHA256"), url.searchParams.set("X-Amz-Content-Sha256", payload), url.searchParams.set("X-Amz-Credential", `${accountKey}/${scope}`), url.searchParams.set("X-Amz-Date", requestDateTime), url.searchParams.set("X-Amz-Expires", expires), url.searchParams.set("X-Amz-Security-Token", sessionToken), url.searchParams.set("X-Amz-SignedHeaders", "host"), partNumber && url.searchParams.set("partNumber", partNumber), uploadId && url.searchParams.set("uploadId", uploadId), url.searchParams.set("x-id", partNumber && uploadId ? "UploadPart" : "PutObject");
  const canonical = createCanonicalRequest({
    CanonicalUri,
    CanonicalQueryString: url.search.slice(1),
    SignedHeaders: {
      host
    },
    HashedPayload: payload
  }), hashedCanonical = arrayBufferToHexString(await digest(canonical)), stringToSign = [
    "AWS4-HMAC-SHA256",
    // The algorithm used to create the hash of the canonical request.
    requestDateTime,
    // The date and time used in the credential scope.
    scope,
    // The credential scope. This restricts the resulting signature to the specified Region and service.
    hashedCanonical
    // The hash of the canonical request.
  ].join(`
`), kDate = await hash(`AWS4${accountSecret}`, date), kRegion = await hash(kDate, Region), kService = await hash(kRegion, Service), kSigning = await hash(kService, "aws4_request"), signature = arrayBufferToHexString(await hash(kSigning, stringToSign));
  return url.searchParams.set("X-Amz-Signature", signature), url;
}
__name(createSignedURL, "createSignedURL");
let _Symbol$for$1;
function _classPrivateFieldLooseBase$b(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$b, "_classPrivateFieldLooseBase$b");
var id$b = 0;
function _classPrivateFieldLooseKey$b(name) {
  return "__private_" + id$b++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$b, "_classPrivateFieldLooseKey$b");
const packageJson$7 = {
  version: "3.6.0"
};
function assertServerError$1(res) {
  if (res && res.error) {
    const error = new Error(res.message);
    throw Object.assign(error, res.error), error;
  }
  return res;
}
__name(assertServerError$1, "assertServerError$1");
function getExpiry(credentials) {
  const expirationDate = credentials.Expiration;
  if (expirationDate) {
    const timeUntilExpiry = Math.floor((new Date(expirationDate) - Date.now()) / 1e3);
    if (timeUntilExpiry > 9)
      return timeUntilExpiry;
  }
}
__name(getExpiry, "getExpiry");
function getAllowedMetadata(_ref) {
  let {
    meta,
    allowedMetaFields,
    querify = !1
  } = _ref;
  const metaFields = allowedMetaFields ?? Object.keys(meta);
  return meta ? Object.fromEntries(metaFields.filter((key) => meta[key] != null).map((key) => {
    const realKey = querify ? `metadata[${key}]` : key, value = String(meta[key]);
    return [realKey, value];
  })) : {};
}
__name(getAllowedMetadata, "getAllowedMetadata");
function throwIfAborted(signal) {
  if (signal != null && signal.aborted)
    throw createAbortError("The operation was aborted", {
      cause: signal.reason
    });
}
__name(throwIfAborted, "throwIfAborted");
var _abortMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$b("abortMultipartUpload"), _cache = /* @__PURE__ */ _classPrivateFieldLooseKey$b("cache"), _createMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$b("createMultipartUpload"), _fetchSignature = /* @__PURE__ */ _classPrivateFieldLooseKey$b("fetchSignature"), _getUploadParameters = /* @__PURE__ */ _classPrivateFieldLooseKey$b("getUploadParameters"), _listParts = /* @__PURE__ */ _classPrivateFieldLooseKey$b("listParts"), _previousRetryDelay = /* @__PURE__ */ _classPrivateFieldLooseKey$b("previousRetryDelay"), _requests$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$b("requests"), _retryDelayIterator$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$b("retryDelayIterator"), _sendCompletionRequest = /* @__PURE__ */ _classPrivateFieldLooseKey$b("sendCompletionRequest"), _setS3MultipartState = /* @__PURE__ */ _classPrivateFieldLooseKey$b("setS3MultipartState"), _uploadPartBytes = /* @__PURE__ */ _classPrivateFieldLooseKey$b("uploadPartBytes"), _getFile = /* @__PURE__ */ _classPrivateFieldLooseKey$b("getFile"), _shouldRetry = /* @__PURE__ */ _classPrivateFieldLooseKey$b("shouldRetry"), _nonMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$b("nonMultipartUpload");
const _HTTPCommunicationQueue = class _HTTPCommunicationQueue {
  constructor(_requests2, options, setS3MultipartState, getFile) {
    Object.defineProperty(this, _nonMultipartUpload, {
      value: _nonMultipartUpload2
    }), Object.defineProperty(this, _shouldRetry, {
      value: _shouldRetry2
    }), Object.defineProperty(this, _abortMultipartUpload, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _cache, {
      writable: !0,
      value: /* @__PURE__ */ new WeakMap()
    }), Object.defineProperty(this, _createMultipartUpload, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _fetchSignature, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _getUploadParameters, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _listParts, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _previousRetryDelay, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _requests$1, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _retryDelayIterator$1, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _sendCompletionRequest, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _setS3MultipartState, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _uploadPartBytes, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _getFile, {
      writable: !0,
      value: void 0
    }), _classPrivateFieldLooseBase$b(this, _requests$1)[_requests$1] = _requests2, _classPrivateFieldLooseBase$b(this, _setS3MultipartState)[_setS3MultipartState] = setS3MultipartState, _classPrivateFieldLooseBase$b(this, _getFile)[_getFile] = getFile, this.setOptions(options);
  }
  setOptions(options) {
    const requests = _classPrivateFieldLooseBase$b(this, _requests$1)[_requests$1];
    if ("abortMultipartUpload" in options && (_classPrivateFieldLooseBase$b(this, _abortMultipartUpload)[_abortMultipartUpload] = requests.wrapPromiseFunction(options.abortMultipartUpload, {
      priority: 1
    })), "createMultipartUpload" in options && (_classPrivateFieldLooseBase$b(this, _createMultipartUpload)[_createMultipartUpload] = requests.wrapPromiseFunction(options.createMultipartUpload, {
      priority: -1
    })), "signPart" in options && (_classPrivateFieldLooseBase$b(this, _fetchSignature)[_fetchSignature] = requests.wrapPromiseFunction(options.signPart)), "listParts" in options && (_classPrivateFieldLooseBase$b(this, _listParts)[_listParts] = requests.wrapPromiseFunction(options.listParts)), "completeMultipartUpload" in options && (_classPrivateFieldLooseBase$b(this, _sendCompletionRequest)[_sendCompletionRequest] = requests.wrapPromiseFunction(options.completeMultipartUpload, {
      priority: 1
    })), "retryDelays" in options) {
      var _options$retryDelays;
      _classPrivateFieldLooseBase$b(this, _retryDelayIterator$1)[_retryDelayIterator$1] = (_options$retryDelays = options.retryDelays) == null ? void 0 : _options$retryDelays.values();
    }
    "uploadPartBytes" in options && (_classPrivateFieldLooseBase$b(this, _uploadPartBytes)[_uploadPartBytes] = requests.wrapPromiseFunction(options.uploadPartBytes, {
      priority: 1 / 0
    })), "getUploadParameters" in options && (_classPrivateFieldLooseBase$b(this, _getUploadParameters)[_getUploadParameters] = requests.wrapPromiseFunction(options.getUploadParameters));
  }
  async getUploadId(file, signal) {
    let cachedResult;
    for (; (cachedResult = _classPrivateFieldLooseBase$b(this, _cache)[_cache].get(file.data)) != null; )
      try {
        return await cachedResult;
      } catch {
      }
    const promise = _classPrivateFieldLooseBase$b(this, _createMultipartUpload)[_createMultipartUpload](_classPrivateFieldLooseBase$b(this, _getFile)[_getFile](file), signal), abortPromise = /* @__PURE__ */ __name(() => {
      promise.abort(signal.reason), _classPrivateFieldLooseBase$b(this, _cache)[_cache].delete(file.data);
    }, "abortPromise");
    return signal.addEventListener("abort", abortPromise, {
      once: !0
    }), _classPrivateFieldLooseBase$b(this, _cache)[_cache].set(file.data, promise), promise.then(async (result2) => {
      signal.removeEventListener("abort", abortPromise), _classPrivateFieldLooseBase$b(this, _setS3MultipartState)[_setS3MultipartState](file, result2), _classPrivateFieldLooseBase$b(this, _cache)[_cache].set(file.data, result2);
    }, () => {
      signal.removeEventListener("abort", abortPromise), _classPrivateFieldLooseBase$b(this, _cache)[_cache].delete(file.data);
    }), promise;
  }
  async abortFileUpload(file) {
    const result2 = _classPrivateFieldLooseBase$b(this, _cache)[_cache].get(file.data);
    if (result2 == null)
      return;
    _classPrivateFieldLooseBase$b(this, _cache)[_cache].delete(file.data), _classPrivateFieldLooseBase$b(this, _setS3MultipartState)[_setS3MultipartState](file, /* @__PURE__ */ Object.create(null));
    let awaitedResult;
    try {
      awaitedResult = await result2;
    } catch {
      return;
    }
    await _classPrivateFieldLooseBase$b(this, _abortMultipartUpload)[_abortMultipartUpload](_classPrivateFieldLooseBase$b(this, _getFile)[_getFile](file), awaitedResult);
  }
  /**
   * @param {import("@uppy/core").UppyFile} file
   * @param {import("../types/chunk").Chunk[]} chunks
   * @param {AbortSignal} signal
   * @returns {Promise<void>}
   */
  async uploadFile(file, chunks2, signal) {
    if (throwIfAborted(signal), chunks2.length === 1 && !chunks2[0].shouldUseMultipart)
      return _classPrivateFieldLooseBase$b(this, _nonMultipartUpload)[_nonMultipartUpload](file, chunks2[0], signal);
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    throwIfAborted(signal);
    try {
      const parts = await Promise.all(chunks2.map((chunk2, i2) => this.uploadChunk(file, i2 + 1, chunk2, signal)));
      return throwIfAborted(signal), await _classPrivateFieldLooseBase$b(this, _sendCompletionRequest)[_sendCompletionRequest](_classPrivateFieldLooseBase$b(this, _getFile)[_getFile](file), {
        key,
        uploadId,
        parts,
        signal
      }).abortOn(signal);
    } catch (err) {
      throw (err == null ? void 0 : err.cause) !== pausingUploadReason && (err == null ? void 0 : err.name) !== "AbortError" && this.abortFileUpload(file), err;
    }
  }
  restoreUploadFile(file, uploadIdAndKey) {
    _classPrivateFieldLooseBase$b(this, _cache)[_cache].set(file.data, uploadIdAndKey);
  }
  async resumeUploadFile(file, chunks2, signal) {
    if (throwIfAborted(signal), chunks2.length === 1 && !chunks2[0].shouldUseMultipart)
      return _classPrivateFieldLooseBase$b(this, _nonMultipartUpload)[_nonMultipartUpload](file, chunks2[0], signal);
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    throwIfAborted(signal);
    const alreadyUploadedParts = await _classPrivateFieldLooseBase$b(this, _listParts)[_listParts](_classPrivateFieldLooseBase$b(this, _getFile)[_getFile](file), {
      uploadId,
      key,
      signal
    }).abortOn(signal);
    throwIfAborted(signal);
    const parts = await Promise.all(chunks2.map((chunk2, i2) => {
      const partNumber = i2 + 1, alreadyUploadedInfo = alreadyUploadedParts.find((_ref2) => {
        let {
          PartNumber
        } = _ref2;
        return PartNumber === partNumber;
      });
      return alreadyUploadedInfo == null ? this.uploadChunk(file, partNumber, chunk2, signal) : (chunk2 == null || chunk2.setAsUploaded == null || chunk2.setAsUploaded(), {
        PartNumber: partNumber,
        ETag: alreadyUploadedInfo.ETag
      });
    }));
    return throwIfAborted(signal), _classPrivateFieldLooseBase$b(this, _sendCompletionRequest)[_sendCompletionRequest](_classPrivateFieldLooseBase$b(this, _getFile)[_getFile](file), {
      key,
      uploadId,
      parts,
      signal
    }).abortOn(signal);
  }
  /**
   *
   * @param {import("@uppy/core").UppyFile} file
   * @param {number} partNumber
   * @param {import("../types/chunk").Chunk} chunk
   * @param {AbortSignal} signal
   * @returns {Promise<object>}
   */
  async uploadChunk(file, partNumber, chunk2, signal) {
    throwIfAborted(signal);
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    for (throwIfAborted(signal); ; ) {
      const chunkData = chunk2.getData(), {
        onProgress,
        onComplete
      } = chunk2, signature = await _classPrivateFieldLooseBase$b(this, _fetchSignature)[_fetchSignature](_classPrivateFieldLooseBase$b(this, _getFile)[_getFile](file), {
        uploadId,
        key,
        partNumber,
        body: chunkData,
        signal
      }).abortOn(signal);
      throwIfAborted(signal);
      try {
        return {
          PartNumber: partNumber,
          ...await _classPrivateFieldLooseBase$b(this, _uploadPartBytes)[_uploadPartBytes]({
            signature,
            body: chunkData,
            size: chunkData.size,
            onProgress,
            onComplete,
            signal
          }).abortOn(signal)
        };
      } catch (err) {
        if (!await _classPrivateFieldLooseBase$b(this, _shouldRetry)[_shouldRetry](err)) throw err;
      }
    }
  }
};
__name(_HTTPCommunicationQueue, "HTTPCommunicationQueue");
let HTTPCommunicationQueue = _HTTPCommunicationQueue;
async function _shouldRetry2(err) {
  var _err$source;
  const requests = _classPrivateFieldLooseBase$b(this, _requests$1)[_requests$1], status = err == null || (_err$source = err.source) == null ? void 0 : _err$source.status;
  if (status == null)
    return !1;
  if (status === 403 && err.message === "Request has expired") {
    if (!requests.isPaused) {
      if (requests.limit === 1 || _classPrivateFieldLooseBase$b(this, _previousRetryDelay)[_previousRetryDelay] == null) {
        var _classPrivateFieldLoo;
        const next = (_classPrivateFieldLoo = _classPrivateFieldLooseBase$b(this, _retryDelayIterator$1)[_retryDelayIterator$1]) == null ? void 0 : _classPrivateFieldLoo.next();
        if (next == null || next.done)
          return !1;
        _classPrivateFieldLooseBase$b(this, _previousRetryDelay)[_previousRetryDelay] = next.value;
      }
      requests.rateLimit(0), await new Promise((resolve3) => setTimeout(resolve3, _classPrivateFieldLooseBase$b(this, _previousRetryDelay)[_previousRetryDelay]));
    }
  } else if (status === 429) {
    if (!requests.isPaused) {
      var _classPrivateFieldLoo2;
      const next = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase$b(this, _retryDelayIterator$1)[_retryDelayIterator$1]) == null ? void 0 : _classPrivateFieldLoo2.next();
      if (next == null || next.done)
        return !1;
      requests.rateLimit(next.value);
    }
  } else {
    if (status > 400 && status < 500 && status !== 409)
      return !1;
    if (typeof navigator < "u" && navigator.onLine === !1)
      requests.isPaused || (requests.pause(), window.addEventListener("online", () => {
        requests.resume();
      }, {
        once: !0
      }));
    else {
      var _classPrivateFieldLoo3;
      const next = (_classPrivateFieldLoo3 = _classPrivateFieldLooseBase$b(this, _retryDelayIterator$1)[_retryDelayIterator$1]) == null ? void 0 : _classPrivateFieldLoo3.next();
      if (next == null || next.done)
        return !1;
      await new Promise((resolve3) => setTimeout(resolve3, next.value));
    }
  }
  return !0;
}
__name(_shouldRetry2, "_shouldRetry2");
async function _nonMultipartUpload2(file, chunk2, signal) {
  const {
    method = "POST",
    url,
    fields,
    headers
  } = await _classPrivateFieldLooseBase$b(this, _getUploadParameters)[_getUploadParameters](_classPrivateFieldLooseBase$b(this, _getFile)[_getFile](file), {
    signal
  }).abortOn(signal);
  let body;
  const data = chunk2.getData();
  if (method.toUpperCase() === "POST") {
    const formData = new FormData();
    Object.entries(fields).forEach((_ref10) => {
      let [key, value] = _ref10;
      return formData.set(key, value);
    }), formData.set("file", data), body = formData;
  } else
    body = data;
  const {
    onProgress,
    onComplete
  } = chunk2;
  return _classPrivateFieldLooseBase$b(this, _uploadPartBytes)[_uploadPartBytes]({
    signature: {
      url,
      headers,
      method
    },
    body,
    size: data.size,
    onProgress,
    onComplete,
    signal
  }).abortOn(signal);
}
__name(_nonMultipartUpload2, "_nonMultipartUpload2");
var _companionCommunicationQueue = /* @__PURE__ */ _classPrivateFieldLooseKey$b("companionCommunicationQueue"), _client$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$b("client"), _cachedTemporaryCredentials = /* @__PURE__ */ _classPrivateFieldLooseKey$b("cachedTemporaryCredentials"), _getTemporarySecurityCredentials = /* @__PURE__ */ _classPrivateFieldLooseKey$b("getTemporarySecurityCredentials"), _setS3MultipartState2 = /* @__PURE__ */ _classPrivateFieldLooseKey$b("setS3MultipartState"), _getFile2 = /* @__PURE__ */ _classPrivateFieldLooseKey$b("getFile"), _uploadLocalFile$2 = /* @__PURE__ */ _classPrivateFieldLooseKey$b("uploadLocalFile"), _getCompanionClientArgs$3 = /* @__PURE__ */ _classPrivateFieldLooseKey$b("getCompanionClientArgs"), _upload = /* @__PURE__ */ _classPrivateFieldLooseKey$b("upload"), _setCompanionHeaders$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$b("setCompanionHeaders"), _setResumableUploadsCapability = /* @__PURE__ */ _classPrivateFieldLooseKey$b("setResumableUploadsCapability"), _resetResumableCapability = /* @__PURE__ */ _classPrivateFieldLooseKey$b("resetResumableCapability");
_Symbol$for$1 = Symbol.for("uppy test: getClient");
const _AwsS3Multipart = class _AwsS3Multipart extends BasePlugin {
  constructor(uppy, opts) {
    var _this$opts$rateLimite;
    super(uppy, opts), Object.defineProperty(this, _getCompanionClientArgs$3, {
      value: _getCompanionClientArgs2$2
    }), Object.defineProperty(this, _uploadLocalFile$2, {
      value: _uploadLocalFile2$2
    }), Object.defineProperty(this, _getTemporarySecurityCredentials, {
      value: _getTemporarySecurityCredentials2
    }), Object.defineProperty(this, _companionCommunicationQueue, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _client$1, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _cachedTemporaryCredentials, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _setS3MultipartState2, {
      writable: !0,
      value: /* @__PURE__ */ __name((file, _ref3) => {
        let {
          key,
          uploadId
        } = _ref3;
        const cFile = this.uppy.getFile(file.id);
        cFile != null && this.uppy.setFileState(file.id, {
          s3Multipart: {
            ...cFile.s3Multipart,
            key,
            uploadId
          }
        });
      }, "value")
    }), Object.defineProperty(this, _getFile2, {
      writable: !0,
      value: /* @__PURE__ */ __name((file) => this.uppy.getFile(file.id) || file, "value")
    }), Object.defineProperty(this, _upload, {
      writable: !0,
      value: /* @__PURE__ */ __name(async (fileIDs) => {
        if (fileIDs.length === 0) return;
        const files = this.uppy.getFilesByIds(fileIDs), filesFiltered = filterNonFailedFiles(files), filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
        this.uppy.emit("upload-start", filesToEmit);
        const promises = filesFiltered.map((file) => {
          if (file.isRemote) {
            const Client2 = file.remote.providerOptions.provider ? Provider : RequestClient, getQueue = /* @__PURE__ */ __name(() => this.requests, "getQueue"), client = new Client2(this.uppy, file.remote.providerOptions, getQueue);
            _classPrivateFieldLooseBase$b(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](!1);
            const controller = new AbortController(), removedHandler = /* @__PURE__ */ __name((removedFile) => {
              removedFile.id === file.id && controller.abort();
            }, "removedHandler");
            this.uppy.on("file-removed", removedHandler);
            const uploadPromise = client.uploadRemoteFile(file, _classPrivateFieldLooseBase$b(this, _getCompanionClientArgs$3)[_getCompanionClientArgs$3](file), {
              signal: controller.signal
            });
            return this.requests.wrapSyncFunction(() => {
              this.uppy.off("file-removed", removedHandler);
            }, {
              priority: -1
            })(), uploadPromise;
          }
          return _classPrivateFieldLooseBase$b(this, _uploadLocalFile$2)[_uploadLocalFile$2](file);
        }), upload = await Promise.all(promises);
        return _classPrivateFieldLooseBase$b(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](!0), upload;
      }, "value")
    }), Object.defineProperty(this, _setCompanionHeaders$1, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        _classPrivateFieldLooseBase$b(this, _client$1)[_client$1].setCompanionHeaders(this.opts.companionHeaders);
      }, "value")
    }), Object.defineProperty(this, _setResumableUploadsCapability, {
      writable: !0,
      value: /* @__PURE__ */ __name((boolean) => {
        const {
          capabilities
        } = this.uppy.getState();
        this.uppy.setState({
          capabilities: {
            ...capabilities,
            resumableUploads: boolean
          }
        });
      }, "value")
    }), Object.defineProperty(this, _resetResumableCapability, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => {
        _classPrivateFieldLooseBase$b(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](!0);
      }, "value")
    }), this.type = "uploader", this.id = this.opts.id || "AwsS3Multipart", this.title = "AWS S3 Multipart", _classPrivateFieldLooseBase$b(this, _client$1)[_client$1] = new RequestClient(uppy, opts);
    const defaultOptions2 = {
      // TODO: null here means “include all”, [] means include none.
      // This is inconsistent with @uppy/aws-s3 and @uppy/transloadit
      allowedMetaFields: null,
      limit: 6,
      shouldUseMultipart: /* @__PURE__ */ __name((file) => file.size !== 0, "shouldUseMultipart"),
      // TODO: Switch default to:
      // eslint-disable-next-line no-bitwise
      // shouldUseMultipart: (file) => file.size >> 10 >> 10 > 100,
      retryDelays: [0, 1e3, 3e3, 5e3],
      createMultipartUpload: this.createMultipartUpload.bind(this),
      listParts: this.listParts.bind(this),
      abortMultipartUpload: this.abortMultipartUpload.bind(this),
      completeMultipartUpload: this.completeMultipartUpload.bind(this),
      getTemporarySecurityCredentials: !1,
      signPart: opts != null && opts.getTemporarySecurityCredentials ? this.createSignedURL.bind(this) : this.signPart.bind(this),
      uploadPartBytes: _AwsS3Multipart.uploadPartBytes,
      getUploadParameters: opts != null && opts.getTemporarySecurityCredentials ? this.createSignedURL.bind(this) : this.getUploadParameters.bind(this),
      companionHeaders: {}
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, (opts == null ? void 0 : opts.prepareUploadParts) != null && opts.signPart == null && (this.opts.signPart = async (file, _ref4) => {
      let {
        uploadId,
        key,
        partNumber,
        body,
        signal
      } = _ref4;
      const {
        presignedUrls,
        headers
      } = await opts.prepareUploadParts(file, {
        uploadId,
        key,
        parts: [{
          number: partNumber,
          chunk: body
        }],
        signal
      });
      return {
        url: presignedUrls == null ? void 0 : presignedUrls[partNumber],
        headers: headers == null ? void 0 : headers[partNumber]
      };
    }), this.requests = (_this$opts$rateLimite = this.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new RateLimitedQueue(this.opts.limit), _classPrivateFieldLooseBase$b(this, _companionCommunicationQueue)[_companionCommunicationQueue] = new HTTPCommunicationQueue(this.requests, this.opts, _classPrivateFieldLooseBase$b(this, _setS3MultipartState2)[_setS3MultipartState2], _classPrivateFieldLooseBase$b(this, _getFile2)[_getFile2]), this.uploaders = /* @__PURE__ */ Object.create(null), this.uploaderEvents = /* @__PURE__ */ Object.create(null), this.uploaderSockets = /* @__PURE__ */ Object.create(null);
  }
  [_Symbol$for$1]() {
    return _classPrivateFieldLooseBase$b(this, _client$1)[_client$1];
  }
  setOptions(newOptions) {
    return _classPrivateFieldLooseBase$b(this, _companionCommunicationQueue)[_companionCommunicationQueue].setOptions(newOptions), super.setOptions(newOptions);
  }
  /**
   * Clean up all references for a file's upload: the MultipartUploader instance,
   * any events related to the file, and the Companion WebSocket connection.
   *
   * Set `opts.abort` to tell S3 that the multipart upload is cancelled and must be removed.
   * This should be done when the user cancels the upload, not when the upload is completed or errored.
   */
  resetUploaderReferences(fileID, opts) {
    opts === void 0 && (opts = {}), this.uploaders[fileID] && (this.uploaders[fileID].abort({
      really: opts.abort || !1
    }), this.uploaders[fileID] = null), this.uploaderEvents[fileID] && (this.uploaderEvents[fileID].remove(), this.uploaderEvents[fileID] = null), this.uploaderSockets[fileID] && (this.uploaderSockets[fileID].close(), this.uploaderSockets[fileID] = null);
  }
  // TODO: make this a private method in the next major
  assertHost(method) {
    if (!this.opts.companionUrl)
      throw new Error(`Expected a \`companionUrl\` option containing a Companion address, or if you are not using Companion, a custom \`${method}\` implementation.`);
  }
  createMultipartUpload(file, signal) {
    this.assertHost("createMultipartUpload"), throwIfAborted(signal);
    const metadata = getAllowedMetadata({
      meta: file.meta,
      allowedMetaFields: this.opts.allowedMetaFields
    });
    return _classPrivateFieldLooseBase$b(this, _client$1)[_client$1].post("s3/multipart", {
      filename: file.name,
      type: file.type,
      metadata
    }, {
      signal
    }).then(assertServerError$1);
  }
  listParts(file, _ref5, signal) {
    let {
      key,
      uploadId
    } = _ref5;
    this.assertHost("listParts"), throwIfAborted(signal);
    const filename = encodeURIComponent(key);
    return _classPrivateFieldLooseBase$b(this, _client$1)[_client$1].get(`s3/multipart/${uploadId}?key=${filename}`, {
      signal
    }).then(assertServerError$1);
  }
  completeMultipartUpload(file, _ref6, signal) {
    let {
      key,
      uploadId,
      parts
    } = _ref6;
    this.assertHost("completeMultipartUpload"), throwIfAborted(signal);
    const filename = encodeURIComponent(key), uploadIdEnc = encodeURIComponent(uploadId);
    return _classPrivateFieldLooseBase$b(this, _client$1)[_client$1].post(`s3/multipart/${uploadIdEnc}/complete?key=${filename}`, {
      parts
    }, {
      signal
    }).then(assertServerError$1);
  }
  async createSignedURL(file, options) {
    const data = await _classPrivateFieldLooseBase$b(this, _getTemporarySecurityCredentials)[_getTemporarySecurityCredentials](options), expires = getExpiry(data.credentials) || 604800, {
      uploadId,
      key,
      partNumber,
      signal
    } = options;
    return {
      method: "PUT",
      expires,
      fields: {},
      url: `${await createSignedURL({
        accountKey: data.credentials.AccessKeyId,
        accountSecret: data.credentials.SecretAccessKey,
        sessionToken: data.credentials.SessionToken,
        expires,
        bucketName: data.bucket,
        Region: data.region,
        Key: key ?? `${crypto.randomUUID()}-${file.name}`,
        uploadId,
        partNumber,
        signal
      })}`,
      // Provide content type header required by S3
      headers: {
        "Content-Type": file.type
      }
    };
  }
  signPart(file, _ref7) {
    let {
      uploadId,
      key,
      partNumber,
      signal
    } = _ref7;
    if (this.assertHost("signPart"), throwIfAborted(signal), uploadId == null || key == null || partNumber == null)
      throw new Error("Cannot sign without a key, an uploadId, and a partNumber");
    const filename = encodeURIComponent(key);
    return _classPrivateFieldLooseBase$b(this, _client$1)[_client$1].get(`s3/multipart/${uploadId}/${partNumber}?key=${filename}`, {
      signal
    }).then(assertServerError$1);
  }
  abortMultipartUpload(file, _ref8, signal) {
    let {
      key,
      uploadId
    } = _ref8;
    this.assertHost("abortMultipartUpload");
    const filename = encodeURIComponent(key), uploadIdEnc = encodeURIComponent(uploadId);
    return _classPrivateFieldLooseBase$b(this, _client$1)[_client$1].delete(`s3/multipart/${uploadIdEnc}?key=${filename}`, void 0, {
      signal
    }).then(assertServerError$1);
  }
  getUploadParameters(file, options) {
    const {
      meta
    } = file, {
      type,
      name: filename
    } = meta, metadata = getAllowedMetadata({
      meta,
      allowedMetaFields: this.opts.allowedMetaFields,
      querify: !0
    }), query = new URLSearchParams({
      filename,
      type,
      ...metadata
    });
    return _classPrivateFieldLooseBase$b(this, _client$1)[_client$1].get(`s3/params?${query}`, options);
  }
  static async uploadPartBytes(_ref9) {
    let {
      signature: {
        url,
        expires,
        headers,
        method = "PUT"
      },
      body,
      size = body.size,
      onProgress,
      onComplete,
      signal
    } = _ref9;
    if (throwIfAborted(signal), url == null)
      throw new Error("Cannot upload to an undefined URL");
    return new Promise((resolve3, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url, !0), headers && Object.keys(headers).forEach((key) => {
        xhr.setRequestHeader(key, headers[key]);
      }), xhr.responseType = "text", typeof expires == "number" && (xhr.timeout = expires * 1e3);
      function onabort() {
        xhr.abort();
      }
      __name(onabort, "onabort");
      function cleanup() {
        signal.removeEventListener("abort", onabort);
      }
      __name(cleanup, "cleanup"), signal.addEventListener("abort", onabort), xhr.upload.addEventListener("progress", (ev) => {
        onProgress(ev);
      }), xhr.addEventListener("abort", () => {
        cleanup(), reject(createAbortError());
      }), xhr.addEventListener("timeout", () => {
        cleanup();
        const error = new Error("Request has expired");
        error.source = {
          status: 403
        }, reject(error);
      }), xhr.addEventListener("load", (ev) => {
        if (cleanup(), ev.target.status === 403 && ev.target.responseText.includes("<Message>Request has expired</Message>")) {
          const error = new Error("Request has expired");
          error.source = ev.target, reject(error);
          return;
        }
        if (ev.target.status < 200 || ev.target.status >= 300) {
          const error = new Error("Non 2xx");
          error.source = ev.target, reject(error);
          return;
        }
        onProgress == null || onProgress({
          loaded: size,
          lengthComputable: !0
        });
        const etag = ev.target.getResponseHeader("ETag"), location2 = ev.target.getResponseHeader("Location");
        if (method.toUpperCase() === "POST" && location2 === null && console.warn("AwsS3/Multipart: Could not read the Location header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions."), etag === null) {
          reject(new Error("AwsS3/Multipart: Could not read the ETag header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions."));
          return;
        }
        onComplete == null || onComplete(etag), resolve3({
          ETag: etag,
          ...location2 ? {
            location: location2
          } : void 0
        });
      }), xhr.addEventListener("error", (ev) => {
        cleanup();
        const error = new Error("Unknown error");
        error.source = ev.target, reject(error);
      }), xhr.send(body);
    });
  }
  install() {
    _classPrivateFieldLooseBase$b(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](!0), this.uppy.addPreProcessor(_classPrivateFieldLooseBase$b(this, _setCompanionHeaders$1)[_setCompanionHeaders$1]), this.uppy.addUploader(_classPrivateFieldLooseBase$b(this, _upload)[_upload]), this.uppy.on("cancel-all", _classPrivateFieldLooseBase$b(this, _resetResumableCapability)[_resetResumableCapability]);
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase$b(this, _setCompanionHeaders$1)[_setCompanionHeaders$1]), this.uppy.removeUploader(_classPrivateFieldLooseBase$b(this, _upload)[_upload]), this.uppy.off("cancel-all", _classPrivateFieldLooseBase$b(this, _resetResumableCapability)[_resetResumableCapability]);
  }
};
__name(_AwsS3Multipart, "AwsS3Multipart");
let AwsS3Multipart = _AwsS3Multipart;
async function _getTemporarySecurityCredentials2(options) {
  return throwIfAborted(options == null ? void 0 : options.signal), _classPrivateFieldLooseBase$b(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] == null && (this.opts.getTemporarySecurityCredentials === !0 ? (this.assertHost("getTemporarySecurityCredentials"), _classPrivateFieldLooseBase$b(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = _classPrivateFieldLooseBase$b(this, _client$1)[_client$1].get("s3/sts", null, options).then(assertServerError$1)) : _classPrivateFieldLooseBase$b(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = this.opts.getTemporarySecurityCredentials(options), _classPrivateFieldLooseBase$b(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = await _classPrivateFieldLooseBase$b(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials], setTimeout(() => {
    _classPrivateFieldLooseBase$b(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = null;
  }, (getExpiry(_classPrivateFieldLooseBase$b(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials].credentials) || 0) * 500)), _classPrivateFieldLooseBase$b(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials];
}
__name(_getTemporarySecurityCredentials2, "_getTemporarySecurityCredentials2");
function _uploadLocalFile2$2(file) {
  var _this = this;
  return new Promise((resolve3, reject) => {
    const onProgress = /* @__PURE__ */ __name((bytesUploaded, bytesTotal) => {
      this.uppy.emit("upload-progress", file, {
        uploader: this,
        bytesUploaded,
        bytesTotal
      });
    }, "onProgress"), onError = /* @__PURE__ */ __name((err) => {
      this.uppy.log(err), this.uppy.emit("upload-error", file, err), this.resetUploaderReferences(file.id), reject(err);
    }, "onError"), onSuccess = /* @__PURE__ */ __name((result2) => {
      const uploadResp = {
        body: {
          ...result2
        },
        uploadURL: result2.location
      };
      this.resetUploaderReferences(file.id), this.uppy.emit("upload-success", _classPrivateFieldLooseBase$b(this, _getFile2)[_getFile2](file), uploadResp), result2.location && this.uppy.log(`Download ${file.name} from ${result2.location}`), resolve3();
    }, "onSuccess"), onPartComplete = /* @__PURE__ */ __name((part) => {
      this.uppy.emit("s3-multipart:part-uploaded", _classPrivateFieldLooseBase$b(this, _getFile2)[_getFile2](file), part);
    }, "onPartComplete"), upload = new MultipartUploader(file.data, {
      // .bind to pass the file object to each handler.
      companionComm: _classPrivateFieldLooseBase$b(this, _companionCommunicationQueue)[_companionCommunicationQueue],
      log: /* @__PURE__ */ __name(function() {
        return _this.uppy.log(...arguments);
      }, "log"),
      getChunkSize: this.opts.getChunkSize ? this.opts.getChunkSize.bind(this) : null,
      onProgress,
      onError,
      onSuccess,
      onPartComplete,
      file,
      shouldUseMultipart: this.opts.shouldUseMultipart,
      ...file.s3Multipart
    });
    this.uploaders[file.id] = upload;
    const eventManager = new EventManager(this.uppy);
    this.uploaderEvents[file.id] = eventManager, eventManager.onFileRemove(file.id, (removed) => {
      upload.abort(), this.resetUploaderReferences(file.id, {
        abort: !0
      }), resolve3(`upload ${removed.id} was removed`);
    }), eventManager.onCancelAll(file.id, function(_temp) {
      let {
        reason
      } = _temp === void 0 ? {} : _temp;
      reason === "user" && (upload.abort(), _this.resetUploaderReferences(file.id, {
        abort: !0
      })), resolve3(`upload ${file.id} was canceled`);
    }), eventManager.onFilePause(file.id, (isPaused) => {
      isPaused ? upload.pause() : upload.start();
    }), eventManager.onPauseAll(file.id, () => {
      upload.pause();
    }), eventManager.onResumeAll(file.id, () => {
      upload.start();
    }), upload.start();
  });
}
__name(_uploadLocalFile2$2, "_uploadLocalFile2$2");
function _getCompanionClientArgs2$2(file) {
  return {
    ...file.remote.body,
    protocol: "s3-multipart",
    size: file.data.size,
    metadata: file.meta
  };
}
__name(_getCompanionClientArgs2$2, "_getCompanionClientArgs2$2");
AwsS3Multipart.VERSION = packageJson$7.version;
function _classPrivateFieldLooseBase$a(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$a, "_classPrivateFieldLooseBase$a");
var id$a = 0;
function _classPrivateFieldLooseKey$a(name) {
  return "__private_" + id$a++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$a, "_classPrivateFieldLooseKey$a");
var _aliveTimer = /* @__PURE__ */ _classPrivateFieldLooseKey$a("aliveTimer"), _isDone = /* @__PURE__ */ _classPrivateFieldLooseKey$a("isDone"), _onTimedOut = /* @__PURE__ */ _classPrivateFieldLooseKey$a("onTimedOut"), _timeout = /* @__PURE__ */ _classPrivateFieldLooseKey$a("timeout");
const _ProgressTimeout = class _ProgressTimeout {
  constructor(timeout, timeoutHandler) {
    Object.defineProperty(this, _aliveTimer, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _isDone, {
      writable: !0,
      value: !1
    }), Object.defineProperty(this, _onTimedOut, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _timeout, {
      writable: !0,
      value: void 0
    }), _classPrivateFieldLooseBase$a(this, _timeout)[_timeout] = timeout, _classPrivateFieldLooseBase$a(this, _onTimedOut)[_onTimedOut] = timeoutHandler;
  }
  progress() {
    _classPrivateFieldLooseBase$a(this, _isDone)[_isDone] || _classPrivateFieldLooseBase$a(this, _timeout)[_timeout] > 0 && (clearTimeout(_classPrivateFieldLooseBase$a(this, _aliveTimer)[_aliveTimer]), _classPrivateFieldLooseBase$a(this, _aliveTimer)[_aliveTimer] = setTimeout(_classPrivateFieldLooseBase$a(this, _onTimedOut)[_onTimedOut], _classPrivateFieldLooseBase$a(this, _timeout)[_timeout]));
  }
  done() {
    _classPrivateFieldLooseBase$a(this, _isDone)[_isDone] || (clearTimeout(_classPrivateFieldLooseBase$a(this, _aliveTimer)[_aliveTimer]), _classPrivateFieldLooseBase$a(this, _aliveTimer)[_aliveTimer] = null, _classPrivateFieldLooseBase$a(this, _isDone)[_isDone] = !0);
  }
};
__name(_ProgressTimeout, "ProgressTimeout");
let ProgressTimeout = _ProgressTimeout;
function isNetworkError(xhr) {
  return xhr ? xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0 : !1;
}
__name(isNetworkError, "isNetworkError");
function _classPrivateFieldLooseBase$9(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$9, "_classPrivateFieldLooseBase$9");
var id$9 = 0;
function _classPrivateFieldLooseKey$9(name) {
  return "__private_" + id$9++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$9, "_classPrivateFieldLooseKey$9");
function buildResponseError$1(xhr, error) {
  if (isNetworkError(xhr)) return new NetworkError(error, xhr);
  const err = new ErrorWithCause("Upload error", {
    cause: error
  });
  return err.request = xhr, err;
}
__name(buildResponseError$1, "buildResponseError$1");
function setTypeInBlob$1(file) {
  return file.data.slice(0, file.data.size, file.meta.type);
}
__name(setTypeInBlob$1, "setTypeInBlob$1");
function addMetadata(formData, meta, opts) {
  (Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta)).forEach((item) => {
    formData.append(item, meta[item]);
  });
}
__name(addMetadata, "addMetadata");
function createFormDataUpload(file, opts) {
  const formPost = new FormData();
  addMetadata(formPost, file.meta, opts);
  const dataWithUpdatedType = setTypeInBlob$1(file);
  return file.name ? formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name) : formPost.append(opts.fieldName, dataWithUpdatedType), formPost;
}
__name(createFormDataUpload, "createFormDataUpload");
const createBareUpload = /* @__PURE__ */ __name((file) => file.data, "createBareUpload");
var _addEventHandlerForFile = /* @__PURE__ */ _classPrivateFieldLooseKey$9("addEventHandlerForFile"), _addEventHandlerIfFileStillExists = /* @__PURE__ */ _classPrivateFieldLooseKey$9("addEventHandlerIfFileStillExists");
const _MiniXHRUpload = class _MiniXHRUpload {
  constructor(uppy, opts) {
    Object.defineProperty(this, _addEventHandlerIfFileStillExists, {
      value: _addEventHandlerIfFileStillExists2
    }), Object.defineProperty(this, _addEventHandlerForFile, {
      value: _addEventHandlerForFile2
    }), this.uppy = uppy, this.opts = {
      validateStatus(status) {
        return status >= 200 && status < 300;
      },
      ...opts
    }, this.requests = opts[internalRateLimitedQueue], this.uploaderEvents = /* @__PURE__ */ Object.create(null), this.i18n = opts.i18n;
  }
  getOptions(file) {
    var _file$xhrUpload;
    const {
      uppy
    } = this, overrides = uppy.getState().xhrUpload;
    return {
      ...this.opts,
      ...overrides || {},
      ...file.xhrUpload || {},
      headers: {
        ...this.opts.headers,
        ...overrides == null ? void 0 : overrides.headers,
        ...(_file$xhrUpload = file.xhrUpload) == null ? void 0 : _file$xhrUpload.headers
      }
    };
  }
  uploadLocalFile(file) {
    const opts = this.getOptions(file);
    return new Promise((resolve3, reject) => {
      const data = opts.formData ? createFormDataUpload(file, opts) : createBareUpload(file), xhr = new XMLHttpRequest();
      this.uploaderEvents[file.id] = new EventManager(this.uppy);
      const timer = new ProgressTimeout(opts.timeout, () => {
        xhr.abort(), queuedRequest.done();
        const error = new Error(this.i18n("timedOut", {
          seconds: Math.ceil(opts.timeout / 1e3)
        }));
        this.uppy.emit("upload-error", file, error), reject(error);
      }), id2 = nanoid();
      xhr.upload.addEventListener("loadstart", () => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id2} started`);
      }), xhr.upload.addEventListener("progress", (ev) => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id2} progress: ${ev.loaded} / ${ev.total}`), timer.progress(), ev.lengthComputable && this.uppy.emit("upload-progress", file, {
          uploader: this,
          bytesUploaded: ev.loaded,
          bytesTotal: ev.total
        });
      }), xhr.addEventListener("load", (ev) => {
        if (this.uppy.log(`[AwsS3/XHRUpload] ${id2} finished`), timer.done(), queuedRequest.done(), this.uploaderEvents[file.id] && (this.uploaderEvents[file.id].remove(), this.uploaderEvents[file.id] = null), opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
          const body2 = opts.getResponseData(xhr.responseText, xhr), uploadURL = body2[opts.responseUrlFieldName], uploadResp = {
            status: ev.target.status,
            body: body2,
            uploadURL
          };
          return this.uppy.emit("upload-success", file, uploadResp), uploadURL && this.uppy.log(`Download ${file.name} from ${uploadURL}`), resolve3(file);
        }
        const body = opts.getResponseData(xhr.responseText, xhr), error = buildResponseError$1(xhr, opts.getResponseError(xhr.responseText, xhr)), response = {
          status: ev.target.status,
          body
        };
        return this.uppy.emit("upload-error", file, error, response), reject(error);
      }), xhr.addEventListener("error", () => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id2} errored`), timer.done(), queuedRequest.done(), this.uploaderEvents[file.id] && (this.uploaderEvents[file.id].remove(), this.uploaderEvents[file.id] = null);
        const error = buildResponseError$1(xhr, opts.getResponseError(xhr.responseText, xhr));
        return this.uppy.emit("upload-error", file, error), reject(error);
      }), xhr.open(opts.method.toUpperCase(), opts.endpoint, !0), xhr.withCredentials = !!opts.withCredentials, opts.responseType !== "" && (xhr.responseType = opts.responseType), Object.keys(opts.headers).forEach((header) => {
        xhr.setRequestHeader(header, opts.headers[header]);
      });
      const queuedRequest = this.requests.run(() => (xhr.send(data), () => {
        timer.done(), xhr.abort();
      }), {
        priority: 1
      });
      _classPrivateFieldLooseBase$9(this, _addEventHandlerForFile)[_addEventHandlerForFile]("file-removed", file.id, () => {
        queuedRequest.abort(), reject(new Error("File removed"));
      }), _classPrivateFieldLooseBase$9(this, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]("cancel-all", file.id, function(_temp) {
        let {
          reason
        } = _temp === void 0 ? {} : _temp;
        reason === "user" && queuedRequest.abort(), reject(new Error("Upload cancelled"));
      });
    });
  }
};
__name(_MiniXHRUpload, "MiniXHRUpload");
let MiniXHRUpload = _MiniXHRUpload;
function _addEventHandlerForFile2(eventName, fileID, eventHandler) {
  this.uploaderEvents[fileID].on(eventName, (fileOrID) => {
    var _fileOrID$id;
    const id2 = (_fileOrID$id = fileOrID == null ? void 0 : fileOrID.id) != null ? _fileOrID$id : fileOrID;
    fileID === id2 && eventHandler();
  });
}
__name(_addEventHandlerForFile2, "_addEventHandlerForFile2");
function _addEventHandlerIfFileStillExists2(eventName, fileID, eventHandler) {
  var _this = this;
  this.uploaderEvents[fileID].on(eventName, function() {
    _this.uppy.getFile(fileID) && eventHandler(...arguments);
  });
}
__name(_addEventHandlerIfFileStillExists2, "_addEventHandlerIfFileStillExists2");
function removeMimeParameters(mimeType) {
  return mimeType.replace(/;.*$/, "");
}
__name(removeMimeParameters, "removeMimeParameters");
function isXml(content, xhr) {
  const rawContentType = xhr.headers ? xhr.headers["content-type"] : xhr.getResponseHeader("Content-Type");
  if (typeof rawContentType == "string") {
    const contentType = removeMimeParameters(rawContentType).toLowerCase();
    if (contentType === "application/xml" || contentType === "text/xml" || contentType === "text/html" && /^<\?xml /.test(content))
      return !0;
  }
  return !1;
}
__name(isXml, "isXml");
const locale$2 = {
  strings: {
    timedOut: "Upload stalled for %{seconds} seconds, aborting."
  }
};
let _Symbol$for;
function _classPrivateFieldLooseBase$8(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$8, "_classPrivateFieldLooseBase$8");
var id$8 = 0;
function _classPrivateFieldLooseKey$8(name) {
  return "__private_" + id$8++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$8, "_classPrivateFieldLooseKey$8");
const packageJson$6 = {
  version: "3.3.0"
};
function resolveUrl$1(origin2, link) {
  return !origin2 && !link.startsWith("https://") && !link.startsWith("http://") && (link = `https://${link}`), new URL(link, origin2 || void 0).toString();
}
__name(resolveUrl$1, "resolveUrl$1");
function getXmlValue(source, tagName) {
  const start = source.indexOf(`<${tagName}>`), end = source.indexOf(`</${tagName}>`, start);
  return start !== -1 && end !== -1 ? source.slice(start + tagName.length + 2, end) : "";
}
__name(getXmlValue, "getXmlValue");
function assertServerError(res) {
  if (res && res.error) {
    const error = new Error(res.message);
    throw Object.assign(error, res.error), error;
  }
  return res;
}
__name(assertServerError, "assertServerError");
function validateParameters(file, params) {
  if (!(params != null && typeof params.url == "string" && (typeof params.fields == "object" || params.fields == null)))
    throw new TypeError(`AwsS3: got incorrect result from 'getUploadParameters()' for file '${file.name}', expected an object '{ url, method, fields, headers }' but got '${JSON.stringify(params)}' instead.
See https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.`);
  if (!(params.method == null || /^p(u|os)t$/i.test(params.method)))
    throw new TypeError(`AwsS3: got incorrect method from 'getUploadParameters()' for file '${file.name}', expected  'PUT' or 'POST' but got '${params.method}' instead.
See https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.`);
}
__name(validateParameters, "validateParameters");
function defaultGetResponseError(content, xhr) {
  if (!isXml(content, xhr))
    return;
  const error = getXmlValue(content, "Message");
  return new Error(error);
}
__name(defaultGetResponseError, "defaultGetResponseError");
let warnedSuccessActionStatus = !1;
var _client = /* @__PURE__ */ _classPrivateFieldLooseKey$8("client"), _requests = /* @__PURE__ */ _classPrivateFieldLooseKey$8("requests"), _uploader = /* @__PURE__ */ _classPrivateFieldLooseKey$8("uploader"), _handleUpload$2 = /* @__PURE__ */ _classPrivateFieldLooseKey$8("handleUpload"), _setCompanionHeaders = /* @__PURE__ */ _classPrivateFieldLooseKey$8("setCompanionHeaders"), _getCompanionClientArgs$2 = /* @__PURE__ */ _classPrivateFieldLooseKey$8("getCompanionClientArgs");
_Symbol$for = Symbol.for("uppy test: getClient");
const _AwsS3 = class _AwsS3 extends BasePlugin {
  constructor(uppy, _opts) {
    if ((_opts == null ? void 0 : _opts.shouldUseMultipart) != null)
      return new AwsS3Multipart(uppy, _opts);
    super(uppy, _opts), Object.defineProperty(this, _client, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _requests, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _uploader, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _handleUpload$2, {
      writable: !0,
      value: /* @__PURE__ */ __name(async (fileIDs) => {
        const paramsPromises = /* @__PURE__ */ Object.create(null);
        function onremove(file) {
          var _paramsPromises$id;
          const {
            id: id2
          } = file;
          (_paramsPromises$id = paramsPromises[id2]) == null || _paramsPromises$id.abort();
        }
        __name(onremove, "onremove"), this.uppy.on("file-removed", onremove);
        const files = this.uppy.getFilesByIds(fileIDs), filesFiltered = filterNonFailedFiles(files), filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
        this.uppy.emit("upload-start", filesToEmit);
        const getUploadParameters = _classPrivateFieldLooseBase$8(this, _requests)[_requests].wrapPromiseFunction((file) => this.opts.getUploadParameters(file)), numberOfFiles = fileIDs.length;
        return Promise.allSettled(fileIDs.map((id2, index) => (paramsPromises[id2] = getUploadParameters(this.uppy.getFile(id2)), paramsPromises[id2].then((params) => {
          delete paramsPromises[id2];
          const file = this.uppy.getFile(id2);
          validateParameters(file, params);
          const {
            method = "POST",
            url,
            fields,
            headers
          } = params, xhrOpts = {
            method,
            formData: method.toUpperCase() === "POST",
            endpoint: url,
            allowedMetaFields: fields ? Object.keys(fields) : []
          };
          return headers && (xhrOpts.headers = headers), this.uppy.setFileState(file.id, {
            meta: {
              ...file.meta,
              ...fields
            },
            xhrUpload: xhrOpts
          }), this.uploadFile(file.id, index, numberOfFiles);
        }).catch((error) => {
          delete paramsPromises[id2];
          const file = this.uppy.getFile(id2);
          return this.uppy.emit("upload-error", file, error), Promise.reject(error);
        })))).finally(() => {
          this.uppy.off("file-removed", onremove);
        });
      }, "value")
    }), Object.defineProperty(this, _setCompanionHeaders, {
      writable: !0,
      value: /* @__PURE__ */ __name(() => (_classPrivateFieldLooseBase$8(this, _client)[_client].setCompanionHeaders(this.opts.companionHeaders), Promise.resolve()), "value")
    }), Object.defineProperty(this, _getCompanionClientArgs$2, {
      writable: !0,
      value: /* @__PURE__ */ __name((file) => {
        const opts = _classPrivateFieldLooseBase$8(this, _uploader)[_uploader].getOptions(file), allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(file.meta);
        return {
          ...file.remote.body,
          protocol: "multipart",
          endpoint: opts.endpoint,
          size: file.data.size,
          fieldname: opts.fieldName,
          metadata: Object.fromEntries(allowedMetaFields.map((name) => [name, file.meta[name]])),
          httpMethod: opts.method,
          useFormData: opts.formData,
          headers: typeof opts.headers == "function" ? opts.headers(file) : opts.headers
        };
      }, "value")
    }), this.type = "uploader", this.id = this.opts.id || "AwsS3", this.title = "AWS S3", this.defaultLocale = locale$2;
    const defaultOptions2 = {
      timeout: 30 * 1e3,
      limit: 0,
      allowedMetaFields: [],
      // have to opt in
      getUploadParameters: this.getUploadParameters.bind(this),
      shouldUseMultipart: !1,
      companionHeaders: {}
    };
    if (this.opts = {
      ...defaultOptions2,
      ..._opts
    }, (_opts == null ? void 0 : _opts.allowedMetaFields) === void 0 && "metaFields" in this.opts)
      throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
    this.i18nInit(), _classPrivateFieldLooseBase$8(this, _client)[_client] = new RequestClient(uppy, _opts), _classPrivateFieldLooseBase$8(this, _requests)[_requests] = new RateLimitedQueue(this.opts.limit);
  }
  [_Symbol$for]() {
    return _classPrivateFieldLooseBase$8(this, _client)[_client];
  }
  // TODO: remove getter and setter for #client on the next major release
  get client() {
    return _classPrivateFieldLooseBase$8(this, _client)[_client];
  }
  set client(client) {
    _classPrivateFieldLooseBase$8(this, _client)[_client] = client;
  }
  getUploadParameters(file) {
    if (!this.opts.companionUrl)
      throw new Error("Expected a `companionUrl` option containing a Companion address.");
    const filename = file.meta.name, {
      type
    } = file.meta, metadata = Object.fromEntries(this.opts.allowedMetaFields.filter((key) => file.meta[key] != null).map((key) => [`metadata[${key}]`, file.meta[key].toString()])), query = new URLSearchParams({
      filename,
      type,
      ...metadata
    });
    return _classPrivateFieldLooseBase$8(this, _client)[_client].get(`s3/params?${query}`).then(assertServerError);
  }
  uploadFile(id2, current, total) {
    const file = this.uppy.getFile(id2);
    if (this.uppy.log(`uploading ${current} of ${total}`), file.error) throw new Error(file.error);
    if (file.isRemote) {
      const Client2 = file.remote.providerOptions.provider ? Provider : RequestClient, getQueue = /* @__PURE__ */ __name(() => _classPrivateFieldLooseBase$8(this, _requests)[_requests], "getQueue"), client = new Client2(this.uppy, file.remote.providerOptions, getQueue), controller = new AbortController(), removedHandler = /* @__PURE__ */ __name((removedFile) => {
        removedFile.id === file.id && controller.abort();
      }, "removedHandler");
      this.uppy.on("file-removed", removedHandler);
      const uploadPromise = client.uploadRemoteFile(file, _classPrivateFieldLooseBase$8(this, _getCompanionClientArgs$2)[_getCompanionClientArgs$2](file), {
        signal: controller.signal
      });
      return _classPrivateFieldLooseBase$8(this, _requests)[_requests].wrapSyncFunction(() => {
        this.uppy.off("file-removed", removedHandler);
      }, {
        priority: -1
      })(), uploadPromise;
    }
    return _classPrivateFieldLooseBase$8(this, _uploader)[_uploader].uploadLocalFile(file, current, total);
  }
  install() {
    const {
      uppy
    } = this;
    uppy.addPreProcessor(_classPrivateFieldLooseBase$8(this, _setCompanionHeaders)[_setCompanionHeaders]), uppy.addUploader(_classPrivateFieldLooseBase$8(this, _handleUpload$2)[_handleUpload$2]);
    function defaultGetResponseData(content, xhr) {
      const opts = this;
      return isXml(content, xhr) ? {
        // Some S3 alternatives do not reply with an absolute URL.
        // Eg DigitalOcean Spaces uses /$bucketName/xyz
        location: resolveUrl$1(xhr.responseURL, getXmlValue(content, "Location")),
        bucket: getXmlValue(content, "Bucket"),
        key: getXmlValue(content, "Key"),
        etag: getXmlValue(content, "ETag")
      } : opts.method.toUpperCase() === "POST" ? (warnedSuccessActionStatus || (uppy.log("[AwsS3] No response data found, make sure to set the success_action_status AWS SDK option to 201. See https://uppy.io/docs/aws-s3/#POST-Uploads", "warning"), warnedSuccessActionStatus = !0), {
        location: null
      }) : xhr.responseURL ? {
        location: xhr.responseURL.replace(/\?.*$/, "")
      } : {
        location: null
      };
    }
    __name(defaultGetResponseData, "defaultGetResponseData");
    const xhrOptions = {
      fieldName: "file",
      responseUrlFieldName: "location",
      timeout: this.opts.timeout,
      // Share the rate limiting queue with XHRUpload.
      [internalRateLimitedQueue]: _classPrivateFieldLooseBase$8(this, _requests)[_requests],
      responseType: "text",
      getResponseData: this.opts.getResponseData || defaultGetResponseData,
      getResponseError: defaultGetResponseError
    };
    xhrOptions.i18n = this.i18n, _classPrivateFieldLooseBase$8(this, _uploader)[_uploader] = new MiniXHRUpload(uppy, xhrOptions);
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase$8(this, _setCompanionHeaders)[_setCompanionHeaders]), this.uppy.removeUploader(_classPrivateFieldLooseBase$8(this, _handleUpload$2)[_handleUpload$2]);
  }
};
__name(_AwsS3, "AwsS3");
let AwsS3 = _AwsS3;
AwsS3.VERSION = packageJson$6.version;
const version = "3.7.5", VERSION$2 = version, _hasatob = typeof atob == "function", _hasbtoa = typeof btoa == "function", _hasBuffer = typeof Buffer == "function", _TD = typeof TextDecoder == "function" ? new TextDecoder() : void 0, _TE = typeof TextEncoder == "function" ? new TextEncoder() : void 0, b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", b64chs = Array.prototype.slice.call(b64ch), b64tab = ((a2) => {
  let tab = {};
  return a2.forEach((c2, i2) => tab[c2] = i2), tab;
})(b64chs), b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, _fromCC = String.fromCharCode.bind(String), _U8Afrom = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (it) => new Uint8Array(Array.prototype.slice.call(it, 0)), _mkUriSafe = /* @__PURE__ */ __name((src) => src.replace(/=/g, "").replace(/[+\/]/g, (m0) => m0 == "+" ? "-" : "_"), "_mkUriSafe"), _tidyB64 = /* @__PURE__ */ __name((s2) => s2.replace(/[^A-Za-z0-9\+\/]/g, ""), "_tidyB64"), btoaPolyfill = /* @__PURE__ */ __name((bin) => {
  let u32, c0, c1, c2, asc = "";
  const pad2 = bin.length % 3;
  for (let i2 = 0; i2 < bin.length; ) {
    if ((c0 = bin.charCodeAt(i2++)) > 255 || (c1 = bin.charCodeAt(i2++)) > 255 || (c2 = bin.charCodeAt(i2++)) > 255)
      throw new TypeError("invalid character found");
    u32 = c0 << 16 | c1 << 8 | c2, asc += b64chs[u32 >> 18 & 63] + b64chs[u32 >> 12 & 63] + b64chs[u32 >> 6 & 63] + b64chs[u32 & 63];
  }
  return pad2 ? asc.slice(0, pad2 - 3) + "===".substring(pad2) : asc;
}, "btoaPolyfill"), _btoa = _hasbtoa ? (bin) => btoa(bin) : _hasBuffer ? (bin) => Buffer.from(bin, "binary").toString("base64") : btoaPolyfill, _fromUint8Array = _hasBuffer ? (u8a) => Buffer.from(u8a).toString("base64") : (u8a) => {
  let strs = [];
  for (let i2 = 0, l2 = u8a.length; i2 < l2; i2 += 4096)
    strs.push(_fromCC.apply(null, u8a.subarray(i2, i2 + 4096)));
  return _btoa(strs.join(""));
}, fromUint8Array = /* @__PURE__ */ __name((u8a, urlsafe = !1) => urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a), "fromUint8Array"), cb_utob = /* @__PURE__ */ __name((c2) => {
  if (c2.length < 2) {
    var cc = c2.charCodeAt(0);
    return cc < 128 ? c2 : cc < 2048 ? _fromCC(192 | cc >>> 6) + _fromCC(128 | cc & 63) : _fromCC(224 | cc >>> 12 & 15) + _fromCC(128 | cc >>> 6 & 63) + _fromCC(128 | cc & 63);
  } else {
    var cc = 65536 + (c2.charCodeAt(0) - 55296) * 1024 + (c2.charCodeAt(1) - 56320);
    return _fromCC(240 | cc >>> 18 & 7) + _fromCC(128 | cc >>> 12 & 63) + _fromCC(128 | cc >>> 6 & 63) + _fromCC(128 | cc & 63);
  }
}, "cb_utob"), re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, utob = /* @__PURE__ */ __name((u2) => u2.replace(re_utob, cb_utob), "utob"), _encode = _hasBuffer ? (s2) => Buffer.from(s2, "utf8").toString("base64") : _TE ? (s2) => _fromUint8Array(_TE.encode(s2)) : (s2) => _btoa(utob(s2)), encode$3 = /* @__PURE__ */ __name((src, urlsafe = !1) => urlsafe ? _mkUriSafe(_encode(src)) : _encode(src), "encode$3"), encodeURI$1 = /* @__PURE__ */ __name((src) => encode$3(src, !0), "encodeURI$1"), re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, cb_btou = /* @__PURE__ */ __name((cccc) => {
  switch (cccc.length) {
    case 4:
      var cp = (7 & cccc.charCodeAt(0)) << 18 | (63 & cccc.charCodeAt(1)) << 12 | (63 & cccc.charCodeAt(2)) << 6 | 63 & cccc.charCodeAt(3), offset = cp - 65536;
      return _fromCC((offset >>> 10) + 55296) + _fromCC((offset & 1023) + 56320);
    case 3:
      return _fromCC((15 & cccc.charCodeAt(0)) << 12 | (63 & cccc.charCodeAt(1)) << 6 | 63 & cccc.charCodeAt(2));
    default:
      return _fromCC((31 & cccc.charCodeAt(0)) << 6 | 63 & cccc.charCodeAt(1));
  }
}, "cb_btou"), btou = /* @__PURE__ */ __name((b2) => b2.replace(re_btou, cb_btou), "btou"), atobPolyfill = /* @__PURE__ */ __name((asc) => {
  if (asc = asc.replace(/\s+/g, ""), !b64re.test(asc))
    throw new TypeError("malformed base64.");
  asc += "==".slice(2 - (asc.length & 3));
  let u24, bin = "", r1, r2;
  for (let i2 = 0; i2 < asc.length; )
    u24 = b64tab[asc.charAt(i2++)] << 18 | b64tab[asc.charAt(i2++)] << 12 | (r1 = b64tab[asc.charAt(i2++)]) << 6 | (r2 = b64tab[asc.charAt(i2++)]), bin += r1 === 64 ? _fromCC(u24 >> 16 & 255) : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
  return bin;
}, "atobPolyfill"), _atob = _hasatob ? (asc) => atob(_tidyB64(asc)) : _hasBuffer ? (asc) => Buffer.from(asc, "base64").toString("binary") : atobPolyfill, _toUint8Array = _hasBuffer ? (a2) => _U8Afrom(Buffer.from(a2, "base64")) : (a2) => _U8Afrom(_atob(a2).split("").map((c2) => c2.charCodeAt(0))), toUint8Array = /* @__PURE__ */ __name((a2) => _toUint8Array(_unURI(a2)), "toUint8Array"), _decode = _hasBuffer ? (a2) => Buffer.from(a2, "base64").toString("utf8") : _TD ? (a2) => _TD.decode(_toUint8Array(a2)) : (a2) => btou(_atob(a2)), _unURI = /* @__PURE__ */ __name((a2) => _tidyB64(a2.replace(/[-_]/g, (m0) => m0 == "-" ? "+" : "/")), "_unURI"), decode$1 = /* @__PURE__ */ __name((src) => _decode(_unURI(src)), "decode$1"), isValid = /* @__PURE__ */ __name((src) => {
  if (typeof src != "string")
    return !1;
  const s2 = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(s2) || !/[^\s0-9a-zA-Z\-_]/.test(s2);
}, "isValid"), _noEnum = /* @__PURE__ */ __name((v2) => ({
  value: v2,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), "_noEnum"), extendString = /* @__PURE__ */ __name(function() {
  const _add = /* @__PURE__ */ __name((name, body) => Object.defineProperty(String.prototype, name, _noEnum(body)), "_add");
  _add("fromBase64", function() {
    return decode$1(this);
  }), _add("toBase64", function(urlsafe) {
    return encode$3(this, urlsafe);
  }), _add("toBase64URI", function() {
    return encode$3(this, !0);
  }), _add("toBase64URL", function() {
    return encode$3(this, !0);
  }), _add("toUint8Array", function() {
    return toUint8Array(this);
  });
}, "extendString"), extendUint8Array = /* @__PURE__ */ __name(function() {
  const _add = /* @__PURE__ */ __name((name, body) => Object.defineProperty(Uint8Array.prototype, name, _noEnum(body)), "_add");
  _add("toBase64", function(urlsafe) {
    return fromUint8Array(this, urlsafe);
  }), _add("toBase64URI", function() {
    return fromUint8Array(this, !0);
  }), _add("toBase64URL", function() {
    return fromUint8Array(this, !0);
  });
}, "extendUint8Array"), extendBuiltins = /* @__PURE__ */ __name(() => {
  extendString(), extendUint8Array();
}, "extendBuiltins"), gBase64 = {
  version,
  VERSION: VERSION$2,
  atob: _atob,
  atobPolyfill,
  btoa: _btoa,
  btoaPolyfill,
  fromBase64: decode$1,
  toBase64: encode$3,
  encode: encode$3,
  encodeURI: encodeURI$1,
  encodeURL: encodeURI$1,
  utob,
  btou,
  decode: decode$1,
  isValid,
  fromUint8Array,
  toUint8Array,
  extendString,
  extendUint8Array,
  extendBuiltins
};
var requiresPort = /* @__PURE__ */ __name(function(port2, protocol) {
  if (protocol = protocol.split(":")[0], port2 = +port2, !port2) return !1;
  switch (protocol) {
    case "http":
    case "ws":
      return port2 !== 80;
    case "https":
    case "wss":
      return port2 !== 443;
    case "ftp":
      return port2 !== 21;
    case "gopher":
      return port2 !== 70;
    case "file":
      return !1;
  }
  return port2 !== 0;
}, "required"), querystringify$1 = {}, has = Object.prototype.hasOwnProperty, undef;
function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, " "));
  } catch {
    return null;
  }
}
__name(decode, "decode");
function encode$2(input) {
  try {
    return encodeURIComponent(input);
  } catch {
    return null;
  }
}
__name(encode$2, "encode$2");
function querystring(query) {
  for (var parser = /([^=?#&]+)=?([^&]*)/g, result2 = {}, part; part = parser.exec(query); ) {
    var key = decode(part[1]), value = decode(part[2]);
    key === null || value === null || key in result2 || (result2[key] = value);
  }
  return result2;
}
__name(querystring, "querystring");
function querystringify(obj, prefix) {
  prefix = prefix || "";
  var pairs = [], value, key;
  typeof prefix != "string" && (prefix = "?");
  for (key in obj)
    if (has.call(obj, key)) {
      if (value = obj[key], !value && (value === null || value === undef || isNaN(value)) && (value = ""), key = encode$2(key), value = encode$2(value), key === null || value === null) continue;
      pairs.push(key + "=" + value);
    }
  return pairs.length ? prefix + pairs.join("&") : "";
}
__name(querystringify, "querystringify");
querystringify$1.stringify = querystringify;
querystringify$1.parse = querystring;
var required2 = requiresPort, qs = querystringify$1, controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, CRHTLF = /[\n\r\t]/g, slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, port = /:\d+$/, protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, windowsDriveLetter = /^[a-zA-Z]:/;
function trimLeft(str) {
  return (str || "").toString().replace(controlOrWhitespace, "");
}
__name(trimLeft, "trimLeft");
var rules = [
  ["#", "hash"],
  // Extract from the back.
  ["?", "query"],
  // Extract from the back.
  /* @__PURE__ */ __name(function(address, url) {
    return isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
  }, "sanitize"),
  ["/", "pathname"],
  // Extract from the back.
  ["@", "auth", 1],
  // Extract from the front.
  [NaN, "host", void 0, 1, 1],
  // Set left over value.
  [/:(\d*)$/, "port", void 0, 1],
  // RegExp the back.
  [NaN, "hostname", void 0, 1, 1]
  // Set left over.
], ignore = { hash: 1, query: 1 };
function lolcation(loc) {
  var globalVar;
  typeof window < "u" ? globalVar = window : typeof commonjsGlobal < "u" ? globalVar = commonjsGlobal : typeof self < "u" ? globalVar = self : globalVar = {};
  var location2 = globalVar.location || {};
  loc = loc || location2;
  var finaldestination = {}, type = typeof loc, key;
  if (loc.protocol === "blob:")
    finaldestination = new Url(unescape(loc.pathname), {});
  else if (type === "string") {
    finaldestination = new Url(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if (type === "object") {
    for (key in loc)
      key in ignore || (finaldestination[key] = loc[key]);
    finaldestination.slashes === void 0 && (finaldestination.slashes = slashes.test(loc.href));
  }
  return finaldestination;
}
__name(lolcation, "lolcation");
function isSpecial(scheme) {
  return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
__name(isSpecial, "isSpecial");
function extractProtocol(address, location2) {
  address = trimLeft(address), address = address.replace(CRHTLF, ""), location2 = location2 || {};
  var match2 = protocolre.exec(address), protocol = match2[1] ? match2[1].toLowerCase() : "", forwardSlashes = !!match2[2], otherSlashes = !!match2[3], slashesCount = 0, rest;
  return forwardSlashes ? otherSlashes ? (rest = match2[2] + match2[3] + match2[4], slashesCount = match2[2].length + match2[3].length) : (rest = match2[2] + match2[4], slashesCount = match2[2].length) : otherSlashes ? (rest = match2[3] + match2[4], slashesCount = match2[3].length) : rest = match2[4], protocol === "file:" ? slashesCount >= 2 && (rest = rest.slice(2)) : isSpecial(protocol) ? rest = match2[4] : protocol ? forwardSlashes && (rest = rest.slice(2)) : slashesCount >= 2 && isSpecial(location2.protocol) && (rest = match2[4]), {
    protocol,
    slashes: forwardSlashes || isSpecial(protocol),
    slashesCount,
    rest
  };
}
__name(extractProtocol, "extractProtocol");
function resolve(relative2, base) {
  if (relative2 === "") return base;
  for (var path = (base || "/").split("/").slice(0, -1).concat(relative2.split("/")), i2 = path.length, last = path[i2 - 1], unshift = !1, up = 0; i2--; )
    path[i2] === "." ? path.splice(i2, 1) : path[i2] === ".." ? (path.splice(i2, 1), up++) : up && (i2 === 0 && (unshift = !0), path.splice(i2, 1), up--);
  return unshift && path.unshift(""), (last === "." || last === "..") && path.push(""), path.join("/");
}
__name(resolve, "resolve");
function Url(address, location2, parser) {
  if (address = trimLeft(address), address = address.replace(CRHTLF, ""), !(this instanceof Url))
    return new Url(address, location2, parser);
  var relative2, extracted, parse2, instruction, index, key, instructions = rules.slice(), type = typeof location2, url = this, i2 = 0;
  for (type !== "object" && type !== "string" && (parser = location2, location2 = null), parser && typeof parser != "function" && (parser = qs.parse), location2 = lolcation(location2), extracted = extractProtocol(address || "", location2), relative2 = !extracted.protocol && !extracted.slashes, url.slashes = extracted.slashes || relative2 && location2.slashes, url.protocol = extracted.protocol || location2.protocol || "", address = extracted.rest, (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !isSpecial(url.protocol))) && (instructions[3] = [/(.*)/, "pathname"]); i2 < instructions.length; i2++) {
    if (instruction = instructions[i2], typeof instruction == "function") {
      address = instruction(address, url);
      continue;
    }
    parse2 = instruction[0], key = instruction[1], parse2 !== parse2 ? url[key] = address : typeof parse2 == "string" ? (index = parse2 === "@" ? address.lastIndexOf(parse2) : address.indexOf(parse2), ~index && (typeof instruction[2] == "number" ? (url[key] = address.slice(0, index), address = address.slice(index + instruction[2])) : (url[key] = address.slice(index), address = address.slice(0, index)))) : (index = parse2.exec(address)) && (url[key] = index[1], address = address.slice(0, index.index)), url[key] = url[key] || relative2 && instruction[3] && location2[key] || "", instruction[4] && (url[key] = url[key].toLowerCase());
  }
  parser && (url.query = parser(url.query)), relative2 && location2.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location2.pathname !== "") && (url.pathname = resolve(url.pathname, location2.pathname)), url.pathname.charAt(0) !== "/" && isSpecial(url.protocol) && (url.pathname = "/" + url.pathname), required2(url.port, url.protocol) || (url.host = url.hostname, url.port = ""), url.username = url.password = "", url.auth && (index = url.auth.indexOf(":"), ~index ? (url.username = url.auth.slice(0, index), url.username = encodeURIComponent(decodeURIComponent(url.username)), url.password = url.auth.slice(index + 1), url.password = encodeURIComponent(decodeURIComponent(url.password))) : url.username = encodeURIComponent(decodeURIComponent(url.auth)), url.auth = url.password ? url.username + ":" + url.password : url.username), url.origin = url.protocol !== "file:" && isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null", url.href = url.toString();
}
__name(Url, "Url");
function set(part, value, fn) {
  var url = this;
  switch (part) {
    case "query":
      typeof value == "string" && value.length && (value = (fn || qs.parse)(value)), url[part] = value;
      break;
    case "port":
      url[part] = value, required2(value, url.protocol) ? value && (url.host = url.hostname + ":" + value) : (url.host = url.hostname, url[part] = "");
      break;
    case "hostname":
      url[part] = value, url.port && (value += ":" + url.port), url.host = value;
      break;
    case "host":
      url[part] = value, port.test(value) ? (value = value.split(":"), url.port = value.pop(), url.hostname = value.join(":")) : (url.hostname = value, url.port = "");
      break;
    case "protocol":
      url.protocol = value.toLowerCase(), url.slashes = !fn;
      break;
    case "pathname":
    case "hash":
      if (value) {
        var char = part === "pathname" ? "/" : "#";
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else
        url[part] = value;
      break;
    case "username":
    case "password":
      url[part] = encodeURIComponent(value);
      break;
    case "auth":
      var index = value.indexOf(":");
      ~index ? (url.username = value.slice(0, index), url.username = encodeURIComponent(decodeURIComponent(url.username)), url.password = value.slice(index + 1), url.password = encodeURIComponent(decodeURIComponent(url.password))) : url.username = encodeURIComponent(decodeURIComponent(value));
  }
  for (var i2 = 0; i2 < rules.length; i2++) {
    var ins = rules[i2];
    ins[4] && (url[ins[1]] = url[ins[1]].toLowerCase());
  }
  return url.auth = url.password ? url.username + ":" + url.password : url.username, url.origin = url.protocol !== "file:" && isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null", url.href = url.toString(), url;
}
__name(set, "set");
function toString$2(stringify) {
  (!stringify || typeof stringify != "function") && (stringify = qs.stringify);
  var query, url = this, host = url.host, protocol = url.protocol;
  protocol && protocol.charAt(protocol.length - 1) !== ":" && (protocol += ":");
  var result2 = protocol + (url.protocol && url.slashes || isSpecial(url.protocol) ? "//" : "");
  return url.username ? (result2 += url.username, url.password && (result2 += ":" + url.password), result2 += "@") : url.password ? (result2 += ":" + url.password, result2 += "@") : url.protocol !== "file:" && isSpecial(url.protocol) && !host && url.pathname !== "/" && (result2 += "@"), (host[host.length - 1] === ":" || port.test(url.hostname) && !url.port) && (host += ":"), result2 += host + url.pathname, query = typeof url.query == "object" ? stringify(url.query) : url.query, query && (result2 += query.charAt(0) !== "?" ? "?" + query : query), url.hash && (result2 += url.hash), result2;
}
__name(toString$2, "toString$2");
Url.prototype = { set, toString: toString$2 };
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = qs;
var urlParse = Url;
const URL$1 = /* @__PURE__ */ getDefaultExportFromCjs(urlParse);
function _typeof$8(obj) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$8(obj);
}
__name(_typeof$8, "_typeof$8");
function _createClass$8(Constructor, protoProps, staticProps) {
  return Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$8, "_createClass$8");
function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$8, "_classCallCheck$8");
function _inherits$1(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$1(subClass, superClass);
}
__name(_inherits$1, "_inherits$1");
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return /* @__PURE__ */ __name(function() {
    var Super = _getPrototypeOf$1(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else
      result2 = Super.apply(this, arguments);
    return _possibleConstructorReturn$1(this, result2);
  }, "_createSuperInternal");
}
__name(_createSuper$1, "_createSuper$1");
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof$8(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(self2);
}
__name(_possibleConstructorReturn$1, "_possibleConstructorReturn$1");
function _assertThisInitialized$1(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$1, "_assertThisInitialized$1");
function _wrapNativeSuper(Class) {
  var _cache2 = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = /* @__PURE__ */ __name(function(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
    if (typeof Class2 != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof _cache2 < "u") {
      if (_cache2.has(Class2)) return _cache2.get(Class2);
      _cache2.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf$1(this).constructor);
    }
    return __name(Wrapper, "Wrapper"), Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf$1(Wrapper, Class2);
  }, "_wrapNativeSuper"), _wrapNativeSuper(Class);
}
__name(_wrapNativeSuper, "_wrapNativeSuper");
function _construct(Parent, args, Class) {
  return _isNativeReflectConstruct$1() ? _construct = Reflect.construct.bind() : _construct = /* @__PURE__ */ __name(function(Parent2, args2, Class2) {
    var a2 = [null];
    a2.push.apply(a2, args2);
    var Constructor = Function.bind.apply(Parent2, a2), instance = new Constructor();
    return Class2 && _setPrototypeOf$1(instance, Class2.prototype), instance;
  }, "_construct"), _construct.apply(null, arguments);
}
__name(_construct, "_construct");
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
__name(_isNativeReflectConstruct$1, "_isNativeReflectConstruct$1");
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
__name(_isNativeFunction, "_isNativeFunction");
function _setPrototypeOf$1(o2, p2) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o3, p3) {
    return o3.__proto__ = p3, o3;
  }, "_setPrototypeOf"), _setPrototypeOf$1(o2, p2);
}
__name(_setPrototypeOf$1, "_setPrototypeOf$1");
function _getPrototypeOf$1(o2) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  }, "_getPrototypeOf"), _getPrototypeOf$1(o2);
}
__name(_getPrototypeOf$1, "_getPrototypeOf$1");
var DetailedError = /* @__PURE__ */ function(_Error) {
  _inherits$1(DetailedError2, _Error);
  var _super = _createSuper$1(DetailedError2);
  function DetailedError2(message) {
    var _this, causingErr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, req = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, res = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (_classCallCheck$8(this, DetailedError2), _this = _super.call(this, message), _this.originalRequest = req, _this.originalResponse = res, _this.causingError = causingErr, causingErr != null && (message += ", caused by ".concat(causingErr.toString())), req != null) {
      var requestId = req.getHeader("X-Request-ID") || "n/a", method = req.getMethod(), url = req.getURL(), status = res ? res.getStatus() : "n/a", body = res ? res.getBody() || "" : "n/a";
      message += ", originated from request (method: ".concat(method, ", url: ").concat(url, ", response code: ").concat(status, ", response text: ").concat(body, ", request id: ").concat(requestId, ")");
    }
    return _this.message = message, _this;
  }
  return __name(DetailedError2, "DetailedError"), _createClass$8(DetailedError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c2) {
    var r2 = Math.random() * 16 | 0, v2 = c2 === "x" ? r2 : r2 & 3 | 8;
    return v2.toString(16);
  });
}
__name(uuid, "uuid");
function _regeneratorRuntime$1() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime$1 = /* @__PURE__ */ __name(function() {
    return exports;
  }, "_regeneratorRuntime");
  var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
    obj[key] = desc.value;
  }, $Symbol = typeof Symbol == "function" ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 }), obj[key];
  }
  __name(define, "define");
  try {
    define({}, "");
  } catch {
    define = /* @__PURE__ */ __name(function(obj, key, value) {
      return obj[key] = value;
    }, "define");
  }
  function wrap(innerFn, outerFn, self2, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self2, context) }), generator;
  }
  __name(wrap, "wrap");
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }
  __name(tryCatch, "tryCatch"), exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {
  }
  __name(Generator, "Generator");
  function GeneratorFunction() {
  }
  __name(GeneratorFunction, "GeneratorFunction");
  function GeneratorFunctionPrototype() {
  }
  __name(GeneratorFunctionPrototype, "GeneratorFunctionPrototype");
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function() {
    return this;
  });
  var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype2) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype2, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }
  __name(defineIteratorMethods, "defineIteratorMethods");
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve3, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type !== "throw") {
        var result2 = record.arg, value = result2.value;
        return value && _typeof$7(value) == "object" && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value2) {
          invoke("next", value2, resolve3, reject);
        }, function(err) {
          invoke("throw", err, resolve3, reject);
        }) : PromiseImpl.resolve(value).then(function(unwrapped) {
          result2.value = unwrapped, resolve3(result2);
        }, function(error) {
          return invoke("throw", error, resolve3, reject);
        });
      }
      reject(record.arg);
    }
    __name(invoke, "invoke");
    var previousPromise;
    defineProperty(this, "_invoke", { value: /* @__PURE__ */ __name(function(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve3, reject) {
          invoke(method, arg, resolve3, reject);
        });
      }
      return __name(callInvokeWithMethodAndArg, "callInvokeWithMethodAndArg"), previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }, "value") });
  }
  __name(AsyncIterator, "AsyncIterator");
  function makeInvokeMethod(innerFn, self2, context) {
    var state = "suspendedStart";
    return function(method, arg) {
      if (state === "executing") throw new Error("Generator is already running");
      if (state === "completed") {
        if (method === "throw") throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg; ; ) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") context.sent = context._sent = context.arg;
        else if (context.method === "throw") {
          if (state === "suspendedStart") throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else context.method === "return" && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self2, context);
        if (record.type === "normal") {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return { value: record.arg, done: context.done };
        }
        record.type === "throw" && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  __name(makeInvokeMethod, "makeInvokeMethod");
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method, method = delegate.iterator[methodName];
    if (method === void 0) return context.delegate = null, methodName === "throw" && delegate.iterator.return && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), context.method === "throw") || methodName !== "return" && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, context.method !== "return" && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  __name(maybeInvokeDelegate, "maybeInvokeDelegate");
  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  __name(pushTryEntry, "pushTryEntry");
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  __name(resetTryEntry, "resetTryEntry");
  function Context(tryLocsList) {
    this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  __name(Context, "Context");
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if (typeof iterable.next == "function") return iterable;
      if (!isNaN(iterable.length)) {
        var i2 = -1, next = /* @__PURE__ */ __name(function next2() {
          for (; ++i2 < iterable.length; ) if (hasOwn.call(iterable, i2)) return next2.value = iterable[i2], next2.done = !1, next2;
          return next2.value = void 0, next2.done = !0, next2;
        }, "next");
        return next.next = next;
      }
    }
    return { next: doneResult };
  }
  __name(values, "values");
  function doneResult() {
    return { value: void 0, done: !0 };
  }
  return __name(doneResult, "doneResult"), GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun == "function" && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction");
  }, exports.mark = function(genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function(arg) {
    return { __await: arg };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
    PromiseImpl === void 0 && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result2) {
      return result2.done ? result2.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
    return this;
  }), define(Gp, "toString", function() {
    return "[object Generator]";
  }), exports.keys = function(val) {
    var object = Object(val), keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), /* @__PURE__ */ __name(function next() {
      for (; keys.length; ) {
        var key2 = keys.pop();
        if (key2 in object) return next.value = key2, next.done = !1, next;
      }
      return next.done = !0, next;
    }, "next");
  }, exports.values = values, Context.prototype = { constructor: Context, reset: /* @__PURE__ */ __name(function(skipTempReset) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
  }, "reset"), stop: /* @__PURE__ */ __name(function() {
    this.done = !0;
    var rootRecord = this.tryEntries[0].completion;
    if (rootRecord.type === "throw") throw rootRecord.arg;
    return this.rval;
  }, "stop"), dispatchException: /* @__PURE__ */ __name(function(exception) {
    if (this.done) throw exception;
    var context = this;
    function handle(loc, caught) {
      return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
    }
    __name(handle, "handle");
    for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
      var entry = this.tryEntries[i2], record = entry.completion;
      if (entry.tryLoc === "root") return handle("end");
      if (entry.tryLoc <= this.prev) {
        var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
        if (hasCatch && hasFinally) {
          if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
        } else if (hasCatch) {
          if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
        } else {
          if (!hasFinally) throw new Error("try statement without catch or finally");
          if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
        }
      }
    }
  }, "dispatchException"), abrupt: /* @__PURE__ */ __name(function(type, arg) {
    for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
      var entry = this.tryEntries[i2];
      if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
        var finallyEntry = entry;
        break;
      }
    }
    finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
    var record = finallyEntry ? finallyEntry.completion : {};
    return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
  }, "abrupt"), complete: /* @__PURE__ */ __name(function(record, afterLoc) {
    if (record.type === "throw") throw record.arg;
    return record.type === "break" || record.type === "continue" ? this.next = record.arg : record.type === "return" ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : record.type === "normal" && afterLoc && (this.next = afterLoc), ContinueSentinel;
  }, "complete"), finish: /* @__PURE__ */ __name(function(finallyLoc) {
    for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
      var entry = this.tryEntries[i2];
      if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
    }
  }, "finish"), catch: /* @__PURE__ */ __name(function(tryLoc) {
    for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
      var entry = this.tryEntries[i2];
      if (entry.tryLoc === tryLoc) {
        var record = entry.completion;
        if (record.type === "throw") {
          var thrown = record.arg;
          resetTryEntry(entry);
        }
        return thrown;
      }
    }
    throw new Error("illegal catch attempt");
  }, "_catch"), delegateYield: /* @__PURE__ */ __name(function(iterable, resultName, nextLoc) {
    return this.delegate = { iterator: values(iterable), resultName, nextLoc }, this.method === "next" && (this.arg = void 0), ContinueSentinel;
  }, "delegateYield") }, exports;
}
__name(_regeneratorRuntime$1, "_regeneratorRuntime$1");
function asyncGeneratorStep$1(gen, resolve3, reject, _next3, _throw, key, arg) {
  try {
    var info = gen[key](arg), value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  info.done ? resolve3(value) : Promise.resolve(value).then(_next3, _throw);
}
__name(asyncGeneratorStep$1, "asyncGeneratorStep$1");
function _asyncToGenerator$1(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve3, reject) {
      var gen = fn.apply(self2, args);
      function _next3(value) {
        asyncGeneratorStep$1(gen, resolve3, reject, _next3, _throw, "next", value);
      }
      __name(_next3, "_next");
      function _throw(err) {
        asyncGeneratorStep$1(gen, resolve3, reject, _next3, _throw, "throw", err);
      }
      __name(_throw, "_throw"), _next3(void 0);
    });
  };
}
__name(_asyncToGenerator$1, "_asyncToGenerator$1");
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(o2, minLen) {
  if (o2) {
    if (typeof o2 == "string") return _arrayLikeToArray(o2, minLen);
    var n2 = Object.prototype.toString.call(o2).slice(8, -1);
    if (n2 === "Object" && o2.constructor && (n2 = o2.constructor.name), n2 === "Map" || n2 === "Set") return Array.from(o2);
    if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(arr, len2) {
  (len2 == null || len2 > arr.length) && (len2 = arr.length);
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++) arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(arr, i2) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, i2 !== 0) for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i2); _n = !0) ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && _i.return != null && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
__name(_arrayWithHoles, "_arrayWithHoles");
function _typeof$7(obj) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$7(obj);
}
__name(_typeof$7, "_typeof$7");
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
__name(ownKeys$1, "ownKeys$1");
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$1, "_objectSpread$1");
function _defineProperty$1(obj, key, value) {
  return key = _toPropertyKey$7(key), key in obj ? Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj[key] = value, obj;
}
__name(_defineProperty$1, "_defineProperty$1");
function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$7, "_classCallCheck$7");
function _defineProperties$7(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$7(descriptor.key), descriptor);
  }
}
__name(_defineProperties$7, "_defineProperties$7");
function _createClass$7(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$7(Constructor.prototype, protoProps), staticProps && _defineProperties$7(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$7, "_createClass$7");
function _toPropertyKey$7(arg) {
  var key = _toPrimitive$7(arg, "string");
  return _typeof$7(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$7, "_toPropertyKey$7");
function _toPrimitive$7(input, hint) {
  if (_typeof$7(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$7(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
__name(_toPrimitive$7, "_toPrimitive$7");
var defaultOptions$2 = {
  endpoint: null,
  uploadUrl: null,
  metadata: {},
  fingerprint: null,
  uploadSize: null,
  onProgress: null,
  onChunkComplete: null,
  onSuccess: null,
  onError: null,
  onUploadUrlAvailable: null,
  overridePatchMethod: !1,
  headers: {},
  addRequestId: !1,
  onBeforeRequest: null,
  onAfterResponse: null,
  onShouldRetry: null,
  chunkSize: 1 / 0,
  retryDelays: [0, 1e3, 3e3, 5e3],
  parallelUploads: 1,
  parallelUploadBoundaries: null,
  storeFingerprintForResuming: !0,
  removeFingerprintOnSuccess: !1,
  uploadLengthDeferred: !1,
  uploadDataDuringCreation: !1,
  urlStorage: null,
  fileReader: null,
  httpStack: null
}, BaseUpload = /* @__PURE__ */ function() {
  function BaseUpload2(file, options) {
    _classCallCheck$7(this, BaseUpload2), "resume" in options && console.log("tus: The `resume` option has been removed in tus-js-client v2. Please use the URL storage API instead."), this.options = options, this.options.chunkSize = Number(this.options.chunkSize), this._urlStorage = this.options.urlStorage, this.file = file, this.url = null, this._req = null, this._fingerprint = null, this._urlStorageKey = null, this._offset = null, this._aborted = !1, this._size = null, this._source = null, this._retryAttempt = 0, this._retryTimeout = null, this._offsetBeforeRetry = 0, this._parallelUploads = null, this._parallelUploadUrls = null;
  }
  return __name(BaseUpload2, "BaseUpload"), _createClass$7(BaseUpload2, [{
    key: "findPreviousUploads",
    value: /* @__PURE__ */ __name(function() {
      var _this = this;
      return this.options.fingerprint(this.file, this.options).then(function(fingerprint2) {
        return _this._urlStorage.findUploadsByFingerprint(fingerprint2);
      });
    }, "findPreviousUploads")
  }, {
    key: "resumeFromPreviousUpload",
    value: /* @__PURE__ */ __name(function(previousUpload) {
      this.url = previousUpload.uploadUrl || null, this._parallelUploadUrls = previousUpload.parallelUploadUrls || null, this._urlStorageKey = previousUpload.urlStorageKey;
    }, "resumeFromPreviousUpload")
  }, {
    key: "start",
    value: /* @__PURE__ */ __name(function() {
      var _this2 = this, file = this.file;
      if (!file) {
        this._emitError(new Error("tus: no file or stream to upload provided"));
        return;
      }
      if (!this.options.endpoint && !this.options.uploadUrl && !this.url) {
        this._emitError(new Error("tus: neither an endpoint or an upload URL is provided"));
        return;
      }
      var retryDelays = this.options.retryDelays;
      if (retryDelays != null && Object.prototype.toString.call(retryDelays) !== "[object Array]") {
        this._emitError(new Error("tus: the `retryDelays` option must either be an array or null"));
        return;
      }
      if (this.options.parallelUploads > 1)
        for (var _i = 0, _arr = ["uploadUrl", "uploadSize", "uploadLengthDeferred"]; _i < _arr.length; _i++) {
          var optionName = _arr[_i];
          if (this.options[optionName]) {
            this._emitError(new Error("tus: cannot use the ".concat(optionName, " option when parallelUploads is enabled")));
            return;
          }
        }
      if (this.options.parallelUploadBoundaries) {
        if (this.options.parallelUploads <= 1) {
          this._emitError(new Error("tus: cannot use the `parallelUploadBoundaries` option when `parallelUploads` is disabled"));
          return;
        }
        if (this.options.parallelUploads !== this.options.parallelUploadBoundaries.length) {
          this._emitError(new Error("tus: the `parallelUploadBoundaries` must have the same length as the value of `parallelUploads`"));
          return;
        }
      }
      this.options.fingerprint(file, this.options).then(function(fingerprint2) {
        return _this2._fingerprint = fingerprint2, _this2._source ? _this2._source : _this2.options.fileReader.openFile(file, _this2.options.chunkSize);
      }).then(function(source) {
        if (_this2._source = source, _this2.options.uploadLengthDeferred)
          _this2._size = null;
        else if (_this2.options.uploadSize != null) {
          if (_this2._size = Number(_this2.options.uploadSize), Number.isNaN(_this2._size)) {
            _this2._emitError(new Error("tus: cannot convert `uploadSize` option into a number"));
            return;
          }
        } else if (_this2._size = _this2._source.size, _this2._size == null) {
          _this2._emitError(new Error("tus: cannot automatically derive upload's size from input. Specify it manually using the `uploadSize` option or use the `uploadLengthDeferred` option"));
          return;
        }
        _this2.options.parallelUploads > 1 || _this2._parallelUploadUrls != null ? _this2._startParallelUpload() : _this2._startSingleUpload();
      }).catch(function(err) {
        _this2._emitError(err);
      });
    }, "start")
    /**
     * Initiate the uploading procedure for a parallelized upload, where one file is split into
     * multiple request which are run in parallel.
     *
     * @api private
     */
  }, {
    key: "_startParallelUpload",
    value: /* @__PURE__ */ __name(function() {
      var _this$options$paralle, _this3 = this, totalSize = this._size, totalProgress = 0;
      this._parallelUploads = [];
      var partCount = this._parallelUploadUrls != null ? this._parallelUploadUrls.length : this.options.parallelUploads, parts = (_this$options$paralle = this.options.parallelUploadBoundaries) !== null && _this$options$paralle !== void 0 ? _this$options$paralle : splitSizeIntoParts(this._source.size, partCount);
      this._parallelUploadUrls && parts.forEach(function(part, index) {
        part.uploadUrl = _this3._parallelUploadUrls[index] || null;
      }), this._parallelUploadUrls = new Array(parts.length);
      var uploads = parts.map(function(part, index) {
        var lastPartProgress = 0;
        return _this3._source.slice(part.start, part.end).then(function(_ref) {
          var value = _ref.value;
          return new Promise(function(resolve3, reject) {
            var options = _objectSpread$1(_objectSpread$1({}, _this3.options), {}, {
              // If available, the partial upload should be resumed from a previous URL.
              uploadUrl: part.uploadUrl || null,
              // We take manually care of resuming for partial uploads, so they should
              // not be stored in the URL storage.
              storeFingerprintForResuming: !1,
              removeFingerprintOnSuccess: !1,
              // Reset the parallelUploads option to not cause recursion.
              parallelUploads: 1,
              // Reset this option as we are not doing a parallel upload.
              parallelUploadBoundaries: null,
              metadata: {},
              // Add the header to indicate the this is a partial upload.
              headers: _objectSpread$1(_objectSpread$1({}, _this3.options.headers), {}, {
                "Upload-Concat": "partial"
              }),
              // Reject or resolve the promise if the upload errors or completes.
              onSuccess: resolve3,
              onError: reject,
              // Based in the progress for this partial upload, calculate the progress
              // for the entire final upload.
              onProgress: /* @__PURE__ */ __name(function(newPartProgress) {
                totalProgress = totalProgress - lastPartProgress + newPartProgress, lastPartProgress = newPartProgress, _this3._emitProgress(totalProgress, totalSize);
              }, "onProgress"),
              // Wait until every partial upload has an upload URL, so we can add
              // them to the URL storage.
              onUploadUrlAvailable: /* @__PURE__ */ __name(function() {
                _this3._parallelUploadUrls[index] = upload.url, _this3._parallelUploadUrls.filter(function(u2) {
                  return !!u2;
                }).length === parts.length && _this3._saveUploadInUrlStorage();
              }, "onUploadUrlAvailable")
            }), upload = new BaseUpload2(value, options);
            upload.start(), _this3._parallelUploads.push(upload);
          });
        });
      }), req;
      Promise.all(uploads).then(function() {
        req = _this3._openRequest("POST", _this3.options.endpoint), req.setHeader("Upload-Concat", "final;".concat(_this3._parallelUploadUrls.join(" ")));
        var metadata = encodeMetadata(_this3.options.metadata);
        return metadata !== "" && req.setHeader("Upload-Metadata", metadata), _this3._sendRequest(req, null);
      }).then(function(res) {
        if (!inStatusCategory(res.getStatus(), 200)) {
          _this3._emitHttpError(req, res, "tus: unexpected response while creating upload");
          return;
        }
        var location2 = res.getHeader("Location");
        if (location2 == null) {
          _this3._emitHttpError(req, res, "tus: invalid or missing Location header");
          return;
        }
        _this3.url = resolveUrl(_this3.options.endpoint, location2), "Created upload at ".concat(_this3.url), _this3._emitSuccess();
      }).catch(function(err) {
        _this3._emitError(err);
      });
    }, "_startParallelUpload")
    /**
     * Initiate the uploading procedure for a non-parallel upload. Here the entire file is
     * uploaded in a sequential matter.
     *
     * @api private
     */
  }, {
    key: "_startSingleUpload",
    value: /* @__PURE__ */ __name(function() {
      if (this._aborted = !1, this.url != null) {
        "Resuming upload from previous URL: ".concat(this.url), this._resumeUpload();
        return;
      }
      if (this.options.uploadUrl != null) {
        "Resuming upload from provided URL: ".concat(this.options.uploadUrl), this.url = this.options.uploadUrl, this._resumeUpload();
        return;
      }
      this._createUpload();
    }, "_startSingleUpload")
    /**
     * Abort any running request and stop the current upload. After abort is called, no event
     * handler will be invoked anymore. You can use the `start` method to resume the upload
     * again.
     * If `shouldTerminate` is true, the `terminate` function will be called to remove the
     * current upload from the server.
     *
     * @param {boolean} shouldTerminate True if the upload should be deleted from the server.
     * @return {Promise} The Promise will be resolved/rejected when the requests finish.
     */
  }, {
    key: "abort",
    value: /* @__PURE__ */ __name(function(shouldTerminate) {
      var _this4 = this;
      return this._parallelUploads != null && this._parallelUploads.forEach(function(upload) {
        upload.abort(shouldTerminate);
      }), this._req !== null && this._req.abort(), this._aborted = !0, this._retryTimeout != null && (clearTimeout(this._retryTimeout), this._retryTimeout = null), !shouldTerminate || this.url == null ? Promise.resolve() : BaseUpload2.terminate(this.url, this.options).then(function() {
        return _this4._removeFromUrlStorage();
      });
    }, "abort")
  }, {
    key: "_emitHttpError",
    value: /* @__PURE__ */ __name(function(req, res, message, causingErr) {
      this._emitError(new DetailedError(message, causingErr, req, res));
    }, "_emitHttpError")
  }, {
    key: "_emitError",
    value: /* @__PURE__ */ __name(function(err) {
      var _this5 = this;
      if (!this._aborted) {
        if (this.options.retryDelays != null) {
          var shouldResetDelays = this._offset != null && this._offset > this._offsetBeforeRetry;
          if (shouldResetDelays && (this._retryAttempt = 0), shouldRetry(err, this._retryAttempt, this.options)) {
            var delay = this.options.retryDelays[this._retryAttempt++];
            this._offsetBeforeRetry = this._offset, this._retryTimeout = setTimeout(function() {
              _this5.start();
            }, delay);
            return;
          }
        }
        if (typeof this.options.onError == "function")
          this.options.onError(err);
        else
          throw err;
      }
    }, "_emitError")
    /**
     * Publishes notification if the upload has been successfully completed.
     *
     * @api private
     */
  }, {
    key: "_emitSuccess",
    value: /* @__PURE__ */ __name(function() {
      this.options.removeFingerprintOnSuccess && this._removeFromUrlStorage(), typeof this.options.onSuccess == "function" && this.options.onSuccess();
    }, "_emitSuccess")
    /**
     * Publishes notification when data has been sent to the server. This
     * data may not have been accepted by the server yet.
     *
     * @param {number} bytesSent  Number of bytes sent to the server.
     * @param {number} bytesTotal Total number of bytes to be sent to the server.
     * @api private
     */
  }, {
    key: "_emitProgress",
    value: /* @__PURE__ */ __name(function(bytesSent, bytesTotal) {
      typeof this.options.onProgress == "function" && this.options.onProgress(bytesSent, bytesTotal);
    }, "_emitProgress")
    /**
     * Publishes notification when a chunk of data has been sent to the server
     * and accepted by the server.
     * @param {number} chunkSize  Size of the chunk that was accepted by the server.
     * @param {number} bytesAccepted Total number of bytes that have been
     *                                accepted by the server.
     * @param {number} bytesTotal Total number of bytes to be sent to the server.
     * @api private
     */
  }, {
    key: "_emitChunkComplete",
    value: /* @__PURE__ */ __name(function(chunkSize, bytesAccepted, bytesTotal) {
      typeof this.options.onChunkComplete == "function" && this.options.onChunkComplete(chunkSize, bytesAccepted, bytesTotal);
    }, "_emitChunkComplete")
    /**
     * Create a new upload using the creation extension by sending a POST
     * request to the endpoint. After successful creation the file will be
     * uploaded
     *
     * @api private
     */
  }, {
    key: "_createUpload",
    value: /* @__PURE__ */ __name(function() {
      var _this6 = this;
      if (!this.options.endpoint) {
        this._emitError(new Error("tus: unable to create upload because no endpoint is provided"));
        return;
      }
      var req = this._openRequest("POST", this.options.endpoint);
      this.options.uploadLengthDeferred ? req.setHeader("Upload-Defer-Length", 1) : req.setHeader("Upload-Length", this._size);
      var metadata = encodeMetadata(this.options.metadata);
      metadata !== "" && req.setHeader("Upload-Metadata", metadata);
      var promise;
      this.options.uploadDataDuringCreation && !this.options.uploadLengthDeferred ? (this._offset = 0, promise = this._addChunkToRequest(req)) : promise = this._sendRequest(req, null), promise.then(function(res) {
        if (!inStatusCategory(res.getStatus(), 200)) {
          _this6._emitHttpError(req, res, "tus: unexpected response while creating upload");
          return;
        }
        var location2 = res.getHeader("Location");
        if (location2 == null) {
          _this6._emitHttpError(req, res, "tus: invalid or missing Location header");
          return;
        }
        if (_this6.url = resolveUrl(_this6.options.endpoint, location2), "Created upload at ".concat(_this6.url), typeof _this6.options.onUploadUrlAvailable == "function" && _this6.options.onUploadUrlAvailable(), _this6._size === 0) {
          _this6._emitSuccess(), _this6._source.close();
          return;
        }
        _this6._saveUploadInUrlStorage().then(function() {
          _this6.options.uploadDataDuringCreation ? _this6._handleUploadResponse(req, res) : (_this6._offset = 0, _this6._performUpload());
        });
      }).catch(function(err) {
        _this6._emitHttpError(req, null, "tus: failed to create upload", err);
      });
    }, "_createUpload")
    /*
     * Try to resume an existing upload. First a HEAD request will be sent
     * to retrieve the offset. If the request fails a new upload will be
     * created. In the case of a successful response the file will be uploaded.
     *
     * @api private
     */
  }, {
    key: "_resumeUpload",
    value: /* @__PURE__ */ __name(function() {
      var _this7 = this, req = this._openRequest("HEAD", this.url), promise = this._sendRequest(req, null);
      promise.then(function(res) {
        var status = res.getStatus();
        if (!inStatusCategory(status, 200)) {
          if (status === 423) {
            _this7._emitHttpError(req, res, "tus: upload is currently locked; retry later");
            return;
          }
          if (inStatusCategory(status, 400) && _this7._removeFromUrlStorage(), !_this7.options.endpoint) {
            _this7._emitHttpError(req, res, "tus: unable to resume upload (new upload cannot be created without an endpoint)");
            return;
          }
          _this7.url = null, _this7._createUpload();
          return;
        }
        var offset = parseInt(res.getHeader("Upload-Offset"), 10);
        if (Number.isNaN(offset)) {
          _this7._emitHttpError(req, res, "tus: invalid or missing offset value");
          return;
        }
        var length = parseInt(res.getHeader("Upload-Length"), 10);
        if (Number.isNaN(length) && !_this7.options.uploadLengthDeferred) {
          _this7._emitHttpError(req, res, "tus: invalid or missing length value");
          return;
        }
        typeof _this7.options.onUploadUrlAvailable == "function" && _this7.options.onUploadUrlAvailable(), _this7._saveUploadInUrlStorage().then(function() {
          if (offset === length) {
            _this7._emitProgress(length, length), _this7._emitSuccess();
            return;
          }
          _this7._offset = offset, _this7._performUpload();
        });
      }).catch(function(err) {
        _this7._emitHttpError(req, null, "tus: failed to resume upload", err);
      });
    }, "_resumeUpload")
    /**
     * Start uploading the file using PATCH requests. The file will be divided
     * into chunks as specified in the chunkSize option. During the upload
     * the onProgress event handler may be invoked multiple times.
     *
     * @api private
     */
  }, {
    key: "_performUpload",
    value: /* @__PURE__ */ __name(function() {
      var _this8 = this;
      if (!this._aborted) {
        var req;
        this.options.overridePatchMethod ? (req = this._openRequest("POST", this.url), req.setHeader("X-HTTP-Method-Override", "PATCH")) : req = this._openRequest("PATCH", this.url), req.setHeader("Upload-Offset", this._offset);
        var promise = this._addChunkToRequest(req);
        promise.then(function(res) {
          if (!inStatusCategory(res.getStatus(), 200)) {
            _this8._emitHttpError(req, res, "tus: unexpected response while uploading chunk");
            return;
          }
          _this8._handleUploadResponse(req, res);
        }).catch(function(err) {
          _this8._aborted || _this8._emitHttpError(req, null, "tus: failed to upload chunk at offset ".concat(_this8._offset), err);
        });
      }
    }, "_performUpload")
    /**
     * _addChunktoRequest reads a chunk from the source and sends it using the
     * supplied request object. It will not handle the response.
     *
     * @api private
     */
  }, {
    key: "_addChunkToRequest",
    value: /* @__PURE__ */ __name(function(req) {
      var _this9 = this, start = this._offset, end = this._offset + this.options.chunkSize;
      return req.setProgressHandler(function(bytesSent) {
        _this9._emitProgress(start + bytesSent, _this9._size);
      }), req.setHeader("Content-Type", "application/offset+octet-stream"), (end === 1 / 0 || end > this._size) && !this.options.uploadLengthDeferred && (end = this._size), this._source.slice(start, end).then(function(_ref2) {
        var value = _ref2.value, done = _ref2.done, valueSize = value && value.size ? value.size : 0;
        _this9.options.uploadLengthDeferred && done && (_this9._size = _this9._offset + valueSize, req.setHeader("Upload-Length", _this9._size));
        var newSize = _this9._offset + valueSize;
        return !_this9.options.uploadLengthDeferred && done && newSize !== _this9._size ? Promise.reject(new Error("upload was configured with a size of ".concat(_this9._size, " bytes, but the source is done after ").concat(newSize, " bytes"))) : value === null ? _this9._sendRequest(req) : (_this9._emitProgress(_this9._offset, _this9._size), _this9._sendRequest(req, value));
      });
    }, "_addChunkToRequest")
    /**
     * _handleUploadResponse is used by requests that haven been sent using _addChunkToRequest
     * and already have received a response.
     *
     * @api private
     */
  }, {
    key: "_handleUploadResponse",
    value: /* @__PURE__ */ __name(function(req, res) {
      var offset = parseInt(res.getHeader("Upload-Offset"), 10);
      if (Number.isNaN(offset)) {
        this._emitHttpError(req, res, "tus: invalid or missing offset value");
        return;
      }
      if (this._emitProgress(offset, this._size), this._emitChunkComplete(offset - this._offset, offset, this._size), this._offset = offset, offset === this._size) {
        this._emitSuccess(), this._source.close();
        return;
      }
      this._performUpload();
    }, "_handleUploadResponse")
    /**
     * Create a new HTTP request object with the given method and URL.
     *
     * @api private
     */
  }, {
    key: "_openRequest",
    value: /* @__PURE__ */ __name(function(method, url) {
      var req = openRequest(method, url, this.options);
      return this._req = req, req;
    }, "_openRequest")
    /**
     * Remove the entry in the URL storage, if it has been saved before.
     *
     * @api private
     */
  }, {
    key: "_removeFromUrlStorage",
    value: /* @__PURE__ */ __name(function() {
      var _this10 = this;
      this._urlStorageKey && (this._urlStorage.removeUpload(this._urlStorageKey).catch(function(err) {
        _this10._emitError(err);
      }), this._urlStorageKey = null);
    }, "_removeFromUrlStorage")
    /**
     * Add the upload URL to the URL storage, if possible.
     *
     * @api private
     */
  }, {
    key: "_saveUploadInUrlStorage",
    value: /* @__PURE__ */ __name(function() {
      var _this11 = this;
      if (!this.options.storeFingerprintForResuming || !this._fingerprint || this._urlStorageKey !== null)
        return Promise.resolve();
      var storedUpload = {
        size: this._size,
        metadata: this.options.metadata,
        creationTime: (/* @__PURE__ */ new Date()).toString()
      };
      return this._parallelUploads ? storedUpload.parallelUploadUrls = this._parallelUploadUrls : storedUpload.uploadUrl = this.url, this._urlStorage.addUpload(this._fingerprint, storedUpload).then(function(urlStorageKey) {
        _this11._urlStorageKey = urlStorageKey;
      });
    }, "_saveUploadInUrlStorage")
    /**
     * Send a request with the provided body.
     *
     * @api private
     */
  }, {
    key: "_sendRequest",
    value: /* @__PURE__ */ __name(function(req) {
      var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      return sendRequest(req, body, this.options);
    }, "_sendRequest")
  }], [{
    key: "terminate",
    value: /* @__PURE__ */ __name(function(url) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, req = openRequest("DELETE", url, options);
      return sendRequest(req, null, options).then(function(res) {
        if (res.getStatus() !== 204)
          throw new DetailedError("tus: unexpected response while terminating upload", null, req, res);
      }).catch(function(err) {
        if (err instanceof DetailedError || (err = new DetailedError("tus: failed to terminate upload", err, req, null)), !shouldRetry(err, 0, options))
          throw err;
        var delay = options.retryDelays[0], remainingDelays = options.retryDelays.slice(1), newOptions = _objectSpread$1(_objectSpread$1({}, options), {}, {
          retryDelays: remainingDelays
        });
        return new Promise(function(resolve3) {
          return setTimeout(resolve3, delay);
        }).then(function() {
          return BaseUpload2.terminate(url, newOptions);
        });
      });
    }, "terminate")
  }]), BaseUpload2;
}();
function encodeMetadata(metadata) {
  return Object.entries(metadata).map(function(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
    return "".concat(key, " ").concat(gBase64.encode(String(value)));
  }).join(",");
}
__name(encodeMetadata, "encodeMetadata");
function inStatusCategory(status, category) {
  return status >= category && status < category + 100;
}
__name(inStatusCategory, "inStatusCategory");
function openRequest(method, url, options) {
  var req = options.httpStack.createRequest(method, url);
  req.setHeader("Tus-Resumable", "1.0.0");
  var headers = options.headers || {};
  if (Object.entries(headers).forEach(function(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2), name = _ref6[0], value = _ref6[1];
    req.setHeader(name, value);
  }), options.addRequestId) {
    var requestId = uuid();
    req.setHeader("X-Request-ID", requestId);
  }
  return req;
}
__name(openRequest, "openRequest");
function sendRequest(_x2, _x3, _x4) {
  return _sendRequest2.apply(this, arguments);
}
__name(sendRequest, "sendRequest");
function _sendRequest2() {
  return _sendRequest2 = _asyncToGenerator$1(/* @__PURE__ */ _regeneratorRuntime$1().mark(/* @__PURE__ */ __name(function _callee(req, body, options) {
    var res;
    return _regeneratorRuntime$1().wrap(/* @__PURE__ */ __name(function(_context) {
      for (; ; ) switch (_context.prev = _context.next) {
        case 0:
          if (typeof options.onBeforeRequest != "function") {
            _context.next = 3;
            break;
          }
          return _context.next = 3, options.onBeforeRequest(req);
        case 3:
          return _context.next = 5, req.send(body);
        case 5:
          if (res = _context.sent, typeof options.onAfterResponse != "function") {
            _context.next = 9;
            break;
          }
          return _context.next = 9, options.onAfterResponse(req, res);
        case 9:
          return _context.abrupt("return", res);
        case 10:
        case "end":
          return _context.stop();
      }
    }, "_callee$"), _callee);
  }, "_callee"))), _sendRequest2.apply(this, arguments);
}
__name(_sendRequest2, "_sendRequest2");
function isOnline() {
  var online = !0;
  return typeof window < "u" && // eslint-disable-next-line no-undef
  "navigator" in window && // eslint-disable-next-line no-undef
  window.navigator.onLine === !1 && (online = !1), online;
}
__name(isOnline, "isOnline");
function shouldRetry(err, retryAttempt, options) {
  if (options.retryDelays == null || retryAttempt >= options.retryDelays.length || err.originalRequest == null)
    return !1;
  if (options && typeof options.onShouldRetry == "function")
    return options.onShouldRetry(err, retryAttempt, options);
  var status = err.originalResponse ? err.originalResponse.getStatus() : 0;
  return (!inStatusCategory(status, 400) || status === 409 || status === 423) && isOnline();
}
__name(shouldRetry, "shouldRetry");
function resolveUrl(origin2, link) {
  return new URL$1(link, origin2).toString();
}
__name(resolveUrl, "resolveUrl");
function splitSizeIntoParts(totalSize, partCount) {
  for (var partSize = Math.floor(totalSize / partCount), parts = [], i2 = 0; i2 < partCount; i2++)
    parts.push({
      start: partSize * i2,
      end: partSize * (i2 + 1)
    });
  return parts[partCount - 1].end = totalSize, parts;
}
__name(splitSizeIntoParts, "splitSizeIntoParts");
BaseUpload.defaultOptions = defaultOptions$2;
function _typeof$6(obj) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$6(obj);
}
__name(_typeof$6, "_typeof$6");
function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$6, "_classCallCheck$6");
function _defineProperties$6(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$6(descriptor.key), descriptor);
  }
}
__name(_defineProperties$6, "_defineProperties$6");
function _createClass$6(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$6(Constructor.prototype, protoProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$6, "_createClass$6");
function _toPropertyKey$6(arg) {
  var key = _toPrimitive$6(arg, "string");
  return _typeof$6(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$6, "_toPropertyKey$6");
function _toPrimitive$6(input, hint) {
  if (_typeof$6(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$6(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(input);
}
__name(_toPrimitive$6, "_toPrimitive$6");
var NoopUrlStorage = /* @__PURE__ */ function() {
  function NoopUrlStorage2() {
    _classCallCheck$6(this, NoopUrlStorage2);
  }
  return __name(NoopUrlStorage2, "NoopUrlStorage"), _createClass$6(NoopUrlStorage2, [{
    key: "listAllUploads",
    value: /* @__PURE__ */ __name(function() {
      return Promise.resolve([]);
    }, "listAllUploads")
  }, {
    key: "findUploadsByFingerprint",
    value: /* @__PURE__ */ __name(function(fingerprint2) {
      return Promise.resolve([]);
    }, "findUploadsByFingerprint")
  }, {
    key: "removeUpload",
    value: /* @__PURE__ */ __name(function(urlStorageKey) {
      return Promise.resolve();
    }, "removeUpload")
  }, {
    key: "addUpload",
    value: /* @__PURE__ */ __name(function(fingerprint2, upload) {
      return Promise.resolve(null);
    }, "addUpload")
  }]), NoopUrlStorage2;
}();
function _typeof$5(obj) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$5(obj);
}
__name(_typeof$5, "_typeof$5");
function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$5, "_classCallCheck$5");
function _defineProperties$5(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$5(descriptor.key), descriptor);
  }
}
__name(_defineProperties$5, "_defineProperties$5");
function _createClass$5(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$5(Constructor.prototype, protoProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$5, "_createClass$5");
function _toPropertyKey$5(arg) {
  var key = _toPrimitive$5(arg, "string");
  return _typeof$5(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$5, "_toPropertyKey$5");
function _toPrimitive$5(input, hint) {
  if (_typeof$5(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$5(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(input);
}
__name(_toPrimitive$5, "_toPrimitive$5");
var hasStorage = !1;
try {
  hasStorage = "localStorage" in window;
  var key = "tusSupport", originalValue = localStorage.getItem(key);
  localStorage.setItem(key, originalValue), originalValue === null && localStorage.removeItem(key);
} catch (e2) {
  if (e2.code === e2.SECURITY_ERR || e2.code === e2.QUOTA_EXCEEDED_ERR)
    hasStorage = !1;
  else
    throw e2;
}
var canStoreURLs = hasStorage, WebStorageUrlStorage = /* @__PURE__ */ function() {
  function WebStorageUrlStorage2() {
    _classCallCheck$5(this, WebStorageUrlStorage2);
  }
  return __name(WebStorageUrlStorage2, "WebStorageUrlStorage"), _createClass$5(WebStorageUrlStorage2, [{
    key: "findAllUploads",
    value: /* @__PURE__ */ __name(function() {
      var results = this._findEntries("tus::");
      return Promise.resolve(results);
    }, "findAllUploads")
  }, {
    key: "findUploadsByFingerprint",
    value: /* @__PURE__ */ __name(function(fingerprint2) {
      var results = this._findEntries("tus::".concat(fingerprint2, "::"));
      return Promise.resolve(results);
    }, "findUploadsByFingerprint")
  }, {
    key: "removeUpload",
    value: /* @__PURE__ */ __name(function(urlStorageKey) {
      return localStorage.removeItem(urlStorageKey), Promise.resolve();
    }, "removeUpload")
  }, {
    key: "addUpload",
    value: /* @__PURE__ */ __name(function(fingerprint2, upload) {
      var id2 = Math.round(Math.random() * 1e12), key = "tus::".concat(fingerprint2, "::").concat(id2);
      return localStorage.setItem(key, JSON.stringify(upload)), Promise.resolve(key);
    }, "addUpload")
  }, {
    key: "_findEntries",
    value: /* @__PURE__ */ __name(function(prefix) {
      for (var results = [], i2 = 0; i2 < localStorage.length; i2++) {
        var _key = localStorage.key(i2);
        if (_key.indexOf(prefix) === 0)
          try {
            var upload = JSON.parse(localStorage.getItem(_key));
            upload.urlStorageKey = _key, results.push(upload);
          } catch {
          }
      }
      return results;
    }, "_findEntries")
  }]), WebStorageUrlStorage2;
}();
function _typeof$4(obj) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$4(obj);
}
__name(_typeof$4, "_typeof$4");
function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$4, "_classCallCheck$4");
function _defineProperties$4(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$4(descriptor.key), descriptor);
  }
}
__name(_defineProperties$4, "_defineProperties$4");
function _createClass$4(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$4(Constructor.prototype, protoProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$4, "_createClass$4");
function _toPropertyKey$4(arg) {
  var key = _toPrimitive$4(arg, "string");
  return _typeof$4(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$4, "_toPropertyKey$4");
function _toPrimitive$4(input, hint) {
  if (_typeof$4(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$4(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(input);
}
__name(_toPrimitive$4, "_toPrimitive$4");
var XHRHttpStack = /* @__PURE__ */ function() {
  function XHRHttpStack2() {
    _classCallCheck$4(this, XHRHttpStack2);
  }
  return __name(XHRHttpStack2, "XHRHttpStack"), _createClass$4(XHRHttpStack2, [{
    key: "createRequest",
    value: /* @__PURE__ */ __name(function(method, url) {
      return new Request$1(method, url);
    }, "createRequest")
  }, {
    key: "getName",
    value: /* @__PURE__ */ __name(function() {
      return "XHRHttpStack";
    }, "getName")
  }]), XHRHttpStack2;
}(), Request$1 = /* @__PURE__ */ function() {
  function Request2(method, url) {
    _classCallCheck$4(this, Request2), this._xhr = new XMLHttpRequest(), this._xhr.open(method, url, !0), this._method = method, this._url = url, this._headers = {};
  }
  return __name(Request2, "Request"), _createClass$4(Request2, [{
    key: "getMethod",
    value: /* @__PURE__ */ __name(function() {
      return this._method;
    }, "getMethod")
  }, {
    key: "getURL",
    value: /* @__PURE__ */ __name(function() {
      return this._url;
    }, "getURL")
  }, {
    key: "setHeader",
    value: /* @__PURE__ */ __name(function(header, value) {
      this._xhr.setRequestHeader(header, value), this._headers[header] = value;
    }, "setHeader")
  }, {
    key: "getHeader",
    value: /* @__PURE__ */ __name(function(header) {
      return this._headers[header];
    }, "getHeader")
  }, {
    key: "setProgressHandler",
    value: /* @__PURE__ */ __name(function(progressHandler) {
      "upload" in this._xhr && (this._xhr.upload.onprogress = function(e2) {
        e2.lengthComputable && progressHandler(e2.loaded);
      });
    }, "setProgressHandler")
  }, {
    key: "send",
    value: /* @__PURE__ */ __name(function() {
      var _this = this, body = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      return new Promise(function(resolve3, reject) {
        _this._xhr.onload = function() {
          resolve3(new Response$1(_this._xhr));
        }, _this._xhr.onerror = function(err) {
          reject(err);
        }, _this._xhr.send(body);
      });
    }, "send")
  }, {
    key: "abort",
    value: /* @__PURE__ */ __name(function() {
      return this._xhr.abort(), Promise.resolve();
    }, "abort")
  }, {
    key: "getUnderlyingObject",
    value: /* @__PURE__ */ __name(function() {
      return this._xhr;
    }, "getUnderlyingObject")
  }]), Request2;
}(), Response$1 = /* @__PURE__ */ function() {
  function Response2(xhr) {
    _classCallCheck$4(this, Response2), this._xhr = xhr;
  }
  return __name(Response2, "Response"), _createClass$4(Response2, [{
    key: "getStatus",
    value: /* @__PURE__ */ __name(function() {
      return this._xhr.status;
    }, "getStatus")
  }, {
    key: "getHeader",
    value: /* @__PURE__ */ __name(function(header) {
      return this._xhr.getResponseHeader(header);
    }, "getHeader")
  }, {
    key: "getBody",
    value: /* @__PURE__ */ __name(function() {
      return this._xhr.responseText;
    }, "getBody")
  }, {
    key: "getUnderlyingObject",
    value: /* @__PURE__ */ __name(function() {
      return this._xhr;
    }, "getUnderlyingObject")
  }]), Response2;
}(), isReactNative$1 = /* @__PURE__ */ __name(function() {
  return typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
}, "isReactNative");
function uriToBlob(uri) {
  return new Promise(function(resolve3, reject) {
    var xhr = new XMLHttpRequest();
    xhr.responseType = "blob", xhr.onload = function() {
      var blob = xhr.response;
      resolve3(blob);
    }, xhr.onerror = function(err) {
      reject(err);
    }, xhr.open("GET", uri), xhr.send();
  });
}
__name(uriToBlob, "uriToBlob");
var isCordova$1 = /* @__PURE__ */ __name(function() {
  return typeof window < "u" && (typeof window.PhoneGap < "u" || typeof window.Cordova < "u" || typeof window.cordova < "u");
}, "isCordova");
function readAsByteArray(chunk2) {
  return new Promise(function(resolve3, reject) {
    var reader = new FileReader();
    reader.onload = function() {
      var value = new Uint8Array(reader.result);
      resolve3({
        value
      });
    }, reader.onerror = function(err) {
      reject(err);
    }, reader.readAsArrayBuffer(chunk2);
  });
}
__name(readAsByteArray, "readAsByteArray");
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$3(obj);
}
__name(_typeof$3, "_typeof$3");
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$3, "_classCallCheck$3");
function _defineProperties$3(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor);
  }
}
__name(_defineProperties$3, "_defineProperties$3");
function _createClass$3(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$3(Constructor.prototype, protoProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$3, "_createClass$3");
function _toPropertyKey$3(arg) {
  var key = _toPrimitive$3(arg, "string");
  return _typeof$3(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$3, "_toPropertyKey$3");
function _toPrimitive$3(input, hint) {
  if (_typeof$3(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$3(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(input);
}
__name(_toPrimitive$3, "_toPrimitive$3");
var FileSource = /* @__PURE__ */ function() {
  function FileSource2(file) {
    _classCallCheck$3(this, FileSource2), this._file = file, this.size = file.size;
  }
  return __name(FileSource2, "FileSource"), _createClass$3(FileSource2, [{
    key: "slice",
    value: /* @__PURE__ */ __name(function(start, end) {
      if (isCordova$1())
        return readAsByteArray(this._file.slice(start, end));
      var value = this._file.slice(start, end), done = end >= this.size;
      return Promise.resolve({
        value,
        done
      });
    }, "slice")
  }, {
    key: "close",
    value: /* @__PURE__ */ __name(function() {
    }, "close")
  }]), FileSource2;
}();
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
__name(_typeof$2, "_typeof$2");
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$2, "_classCallCheck$2");
function _defineProperties$2(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
  }
}
__name(_defineProperties$2, "_defineProperties$2");
function _createClass$2(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$2(Constructor.prototype, protoProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$2, "_createClass$2");
function _toPropertyKey$2(arg) {
  var key = _toPrimitive$2(arg, "string");
  return _typeof$2(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$2, "_toPropertyKey$2");
function _toPrimitive$2(input, hint) {
  if (_typeof$2(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$2(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(input);
}
__name(_toPrimitive$2, "_toPrimitive$2");
function len(blobOrArray) {
  return blobOrArray === void 0 ? 0 : blobOrArray.size !== void 0 ? blobOrArray.size : blobOrArray.length;
}
__name(len, "len");
function concat(a2, b2) {
  if (a2.concat)
    return a2.concat(b2);
  if (a2 instanceof Blob)
    return new Blob([a2, b2], {
      type: a2.type
    });
  if (a2.set) {
    var c2 = new a2.constructor(a2.length + b2.length);
    return c2.set(a2), c2.set(b2, a2.length), c2;
  }
  throw new Error("Unknown data type");
}
__name(concat, "concat");
var StreamSource = /* @__PURE__ */ function() {
  function StreamSource2(reader) {
    _classCallCheck$2(this, StreamSource2), this._buffer = void 0, this._bufferOffset = 0, this._reader = reader, this._done = !1;
  }
  return __name(StreamSource2, "StreamSource"), _createClass$2(StreamSource2, [{
    key: "slice",
    value: /* @__PURE__ */ __name(function(start, end) {
      return start < this._bufferOffset ? Promise.reject(new Error("Requested data is before the reader's current offset")) : this._readUntilEnoughDataOrDone(start, end);
    }, "slice")
  }, {
    key: "_readUntilEnoughDataOrDone",
    value: /* @__PURE__ */ __name(function(start, end) {
      var _this = this, hasEnoughData = end <= this._bufferOffset + len(this._buffer);
      if (this._done || hasEnoughData) {
        var value = this._getDataFromBuffer(start, end), done = value == null ? this._done : !1;
        return Promise.resolve({
          value,
          done
        });
      }
      return this._reader.read().then(function(_ref) {
        var value2 = _ref.value, done2 = _ref.done;
        return done2 ? _this._done = !0 : _this._buffer === void 0 ? _this._buffer = value2 : _this._buffer = concat(_this._buffer, value2), _this._readUntilEnoughDataOrDone(start, end);
      });
    }, "_readUntilEnoughDataOrDone")
  }, {
    key: "_getDataFromBuffer",
    value: /* @__PURE__ */ __name(function(start, end) {
      start > this._bufferOffset && (this._buffer = this._buffer.slice(start - this._bufferOffset), this._bufferOffset = start);
      var hasAllDataBeenRead = len(this._buffer) === 0;
      return this._done && hasAllDataBeenRead ? null : this._buffer.slice(0, end - start);
    }, "_getDataFromBuffer")
  }, {
    key: "close",
    value: /* @__PURE__ */ __name(function() {
      this._reader.cancel && this._reader.cancel();
    }, "close")
  }]), StreamSource2;
}();
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
__name(_typeof$1, "_typeof$1");
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = /* @__PURE__ */ __name(function() {
    return exports;
  }, "_regeneratorRuntime");
  var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
    obj[key] = desc.value;
  }, $Symbol = typeof Symbol == "function" ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 }), obj[key];
  }
  __name(define, "define");
  try {
    define({}, "");
  } catch {
    define = /* @__PURE__ */ __name(function(obj, key, value) {
      return obj[key] = value;
    }, "define");
  }
  function wrap(innerFn, outerFn, self2, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self2, context) }), generator;
  }
  __name(wrap, "wrap");
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }
  __name(tryCatch, "tryCatch"), exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {
  }
  __name(Generator, "Generator");
  function GeneratorFunction() {
  }
  __name(GeneratorFunction, "GeneratorFunction");
  function GeneratorFunctionPrototype() {
  }
  __name(GeneratorFunctionPrototype, "GeneratorFunctionPrototype");
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function() {
    return this;
  });
  var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype2) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype2, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }
  __name(defineIteratorMethods, "defineIteratorMethods");
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve3, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type !== "throw") {
        var result2 = record.arg, value = result2.value;
        return value && _typeof$1(value) == "object" && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value2) {
          invoke("next", value2, resolve3, reject);
        }, function(err) {
          invoke("throw", err, resolve3, reject);
        }) : PromiseImpl.resolve(value).then(function(unwrapped) {
          result2.value = unwrapped, resolve3(result2);
        }, function(error) {
          return invoke("throw", error, resolve3, reject);
        });
      }
      reject(record.arg);
    }
    __name(invoke, "invoke");
    var previousPromise;
    defineProperty(this, "_invoke", { value: /* @__PURE__ */ __name(function(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve3, reject) {
          invoke(method, arg, resolve3, reject);
        });
      }
      return __name(callInvokeWithMethodAndArg, "callInvokeWithMethodAndArg"), previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }, "value") });
  }
  __name(AsyncIterator, "AsyncIterator");
  function makeInvokeMethod(innerFn, self2, context) {
    var state = "suspendedStart";
    return function(method, arg) {
      if (state === "executing") throw new Error("Generator is already running");
      if (state === "completed") {
        if (method === "throw") throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg; ; ) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") context.sent = context._sent = context.arg;
        else if (context.method === "throw") {
          if (state === "suspendedStart") throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else context.method === "return" && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self2, context);
        if (record.type === "normal") {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return { value: record.arg, done: context.done };
        }
        record.type === "throw" && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  __name(makeInvokeMethod, "makeInvokeMethod");
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method, method = delegate.iterator[methodName];
    if (method === void 0) return context.delegate = null, methodName === "throw" && delegate.iterator.return && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), context.method === "throw") || methodName !== "return" && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, context.method !== "return" && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  __name(maybeInvokeDelegate, "maybeInvokeDelegate");
  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  __name(pushTryEntry, "pushTryEntry");
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  __name(resetTryEntry, "resetTryEntry");
  function Context(tryLocsList) {
    this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  __name(Context, "Context");
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if (typeof iterable.next == "function") return iterable;
      if (!isNaN(iterable.length)) {
        var i2 = -1, next = /* @__PURE__ */ __name(function next2() {
          for (; ++i2 < iterable.length; ) if (hasOwn.call(iterable, i2)) return next2.value = iterable[i2], next2.done = !1, next2;
          return next2.value = void 0, next2.done = !0, next2;
        }, "next");
        return next.next = next;
      }
    }
    return { next: doneResult };
  }
  __name(values, "values");
  function doneResult() {
    return { value: void 0, done: !0 };
  }
  return __name(doneResult, "doneResult"), GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun == "function" && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction");
  }, exports.mark = function(genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function(arg) {
    return { __await: arg };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
    PromiseImpl === void 0 && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result2) {
      return result2.done ? result2.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
    return this;
  }), define(Gp, "toString", function() {
    return "[object Generator]";
  }), exports.keys = function(val) {
    var object = Object(val), keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), /* @__PURE__ */ __name(function next() {
      for (; keys.length; ) {
        var key2 = keys.pop();
        if (key2 in object) return next.value = key2, next.done = !1, next;
      }
      return next.done = !0, next;
    }, "next");
  }, exports.values = values, Context.prototype = { constructor: Context, reset: /* @__PURE__ */ __name(function(skipTempReset) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
  }, "reset"), stop: /* @__PURE__ */ __name(function() {
    this.done = !0;
    var rootRecord = this.tryEntries[0].completion;
    if (rootRecord.type === "throw") throw rootRecord.arg;
    return this.rval;
  }, "stop"), dispatchException: /* @__PURE__ */ __name(function(exception) {
    if (this.done) throw exception;
    var context = this;
    function handle(loc, caught) {
      return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
    }
    __name(handle, "handle");
    for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
      var entry = this.tryEntries[i2], record = entry.completion;
      if (entry.tryLoc === "root") return handle("end");
      if (entry.tryLoc <= this.prev) {
        var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
        if (hasCatch && hasFinally) {
          if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
        } else if (hasCatch) {
          if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
        } else {
          if (!hasFinally) throw new Error("try statement without catch or finally");
          if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
        }
      }
    }
  }, "dispatchException"), abrupt: /* @__PURE__ */ __name(function(type, arg) {
    for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
      var entry = this.tryEntries[i2];
      if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
        var finallyEntry = entry;
        break;
      }
    }
    finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
    var record = finallyEntry ? finallyEntry.completion : {};
    return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
  }, "abrupt"), complete: /* @__PURE__ */ __name(function(record, afterLoc) {
    if (record.type === "throw") throw record.arg;
    return record.type === "break" || record.type === "continue" ? this.next = record.arg : record.type === "return" ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : record.type === "normal" && afterLoc && (this.next = afterLoc), ContinueSentinel;
  }, "complete"), finish: /* @__PURE__ */ __name(function(finallyLoc) {
    for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
      var entry = this.tryEntries[i2];
      if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
    }
  }, "finish"), catch: /* @__PURE__ */ __name(function(tryLoc) {
    for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
      var entry = this.tryEntries[i2];
      if (entry.tryLoc === tryLoc) {
        var record = entry.completion;
        if (record.type === "throw") {
          var thrown = record.arg;
          resetTryEntry(entry);
        }
        return thrown;
      }
    }
    throw new Error("illegal catch attempt");
  }, "_catch"), delegateYield: /* @__PURE__ */ __name(function(iterable, resultName, nextLoc) {
    return this.delegate = { iterator: values(iterable), resultName, nextLoc }, this.method === "next" && (this.arg = void 0), ContinueSentinel;
  }, "delegateYield") }, exports;
}
__name(_regeneratorRuntime, "_regeneratorRuntime");
function asyncGeneratorStep(gen, resolve3, reject, _next3, _throw, key, arg) {
  try {
    var info = gen[key](arg), value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  info.done ? resolve3(value) : Promise.resolve(value).then(_next3, _throw);
}
__name(asyncGeneratorStep, "asyncGeneratorStep");
function _asyncToGenerator(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve3, reject) {
      var gen = fn.apply(self2, args);
      function _next3(value) {
        asyncGeneratorStep(gen, resolve3, reject, _next3, _throw, "next", value);
      }
      __name(_next3, "_next");
      function _throw(err) {
        asyncGeneratorStep(gen, resolve3, reject, _next3, _throw, "throw", err);
      }
      __name(_throw, "_throw"), _next3(void 0);
    });
  };
}
__name(_asyncToGenerator, "_asyncToGenerator");
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$1, "_classCallCheck$1");
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
__name(_defineProperties$1, "_defineProperties$1");
function _createClass$1(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$1(Constructor.prototype, protoProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$1, "_createClass$1");
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$1, "_toPropertyKey$1");
function _toPrimitive$1(input, hint) {
  if (_typeof$1(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$1(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(input);
}
__name(_toPrimitive$1, "_toPrimitive$1");
var FileReader$1 = /* @__PURE__ */ function() {
  function FileReader2() {
    _classCallCheck$1(this, FileReader2);
  }
  return __name(FileReader2, "FileReader"), _createClass$1(FileReader2, [{
    key: "openFile",
    value: function() {
      var _openFile = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(/* @__PURE__ */ __name(function _callee(input, chunkSize) {
        var blob;
        return _regeneratorRuntime().wrap(/* @__PURE__ */ __name(function(_context) {
          for (; ; ) switch (_context.prev = _context.next) {
            case 0:
              if (!(isReactNative$1() && input && typeof input.uri < "u")) {
                _context.next = 11;
                break;
              }
              return _context.prev = 1, _context.next = 4, uriToBlob(input.uri);
            case 4:
              return blob = _context.sent, _context.abrupt("return", new FileSource(blob));
            case 8:
              throw _context.prev = 8, _context.t0 = _context.catch(1), new Error("tus: cannot fetch `file.uri` as Blob, make sure the uri is correct and accessible. ".concat(_context.t0));
            case 11:
              if (!(typeof input.slice == "function" && typeof input.size < "u")) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", Promise.resolve(new FileSource(input)));
            case 13:
              if (typeof input.read != "function") {
                _context.next = 18;
                break;
              }
              if (chunkSize = Number(chunkSize), Number.isFinite(chunkSize)) {
                _context.next = 17;
                break;
              }
              return _context.abrupt("return", Promise.reject(new Error("cannot create source for stream without a finite value for the `chunkSize` option")));
            case 17:
              return _context.abrupt("return", Promise.resolve(new StreamSource(input, chunkSize)));
            case 18:
              return _context.abrupt("return", Promise.reject(new Error("source object may only be an instance of File, Blob, or Reader in this environment")));
            case 19:
            case "end":
              return _context.stop();
          }
        }, "_callee$"), _callee, null, [[1, 8]]);
      }, "_callee")));
      function openFile(_x, _x2) {
        return _openFile.apply(this, arguments);
      }
      return __name(openFile, "openFile"), openFile;
    }()
  }]), FileReader2;
}();
function fingerprint(file, options) {
  return isReactNative$1() ? Promise.resolve(reactNativeFingerprint(file, options)) : Promise.resolve(["tus-br", file.name, file.type, file.size, file.lastModified, options.endpoint].join("-"));
}
__name(fingerprint, "fingerprint");
function reactNativeFingerprint(file, options) {
  var exifHash = file.exif ? hashCode(JSON.stringify(file.exif)) : "noexif";
  return ["tus-rn", file.name || "noname", file.size || "nosize", exifHash, options.endpoint].join("/");
}
__name(reactNativeFingerprint, "reactNativeFingerprint");
function hashCode(str) {
  var hash2 = 0;
  if (str.length === 0)
    return hash2;
  for (var i2 = 0; i2 < str.length; i2++) {
    var _char = str.charCodeAt(i2);
    hash2 = (hash2 << 5) - hash2 + _char, hash2 &= hash2;
  }
  return hash2;
}
__name(hashCode, "hashCode");
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
__name(_typeof, "_typeof");
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(Constructor, protoProps, staticProps) {
  return staticProps && _defineProperties(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass, "_createClass");
function _inherits(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf(subClass, superClass);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(o2, p2) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o3, p3) {
    return o3.__proto__ = p3, o3;
  }, "_setPrototypeOf"), _setPrototypeOf(o2, p2);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return /* @__PURE__ */ __name(function() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else
      result2 = Super.apply(this, arguments);
    return _possibleConstructorReturn(this, result2);
  }, "_createSuperInternal");
}
__name(_createSuper, "_createSuper");
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(self2);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(o2) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  }, "_getPrototypeOf"), _getPrototypeOf(o2);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
__name(ownKeys, "ownKeys");
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(obj, key, value) {
  return key = _toPropertyKey(key), key in obj ? Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj[key] = value, obj;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
__name(_toPrimitive, "_toPrimitive");
var defaultOptions$1 = _objectSpread(_objectSpread({}, BaseUpload.defaultOptions), {}, {
  httpStack: new XHRHttpStack(),
  fileReader: new FileReader$1(),
  urlStorage: canStoreURLs ? new WebStorageUrlStorage() : new NoopUrlStorage(),
  fingerprint
}), Upload = /* @__PURE__ */ function(_BaseUpload) {
  _inherits(Upload2, _BaseUpload);
  var _super = _createSuper(Upload2);
  function Upload2() {
    var file = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return _classCallCheck(this, Upload2), options = _objectSpread(_objectSpread({}, defaultOptions$1), options), _super.call(this, file, options);
  }
  return __name(Upload2, "Upload"), _createClass(Upload2, null, [{
    key: "terminate",
    value: /* @__PURE__ */ __name(function(url) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return options = _objectSpread(_objectSpread({}, defaultOptions$1), options), BaseUpload.terminate(url, options);
    }, "terminate")
  }]), Upload2;
}(BaseUpload);
function isCordova2() {
  return typeof window < "u" && (typeof window.PhoneGap < "u" || typeof window.Cordova < "u" || typeof window.cordova < "u");
}
__name(isCordova2, "isCordova");
function isReactNative2() {
  return typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
}
__name(isReactNative2, "isReactNative");
function getFingerprint(uppyFileObj) {
  return (file, options) => {
    if (isCordova2() || isReactNative2())
      return defaultOptions$1.fingerprint(file, options);
    const uppyFingerprint = ["tus", uppyFileObj.id, options.endpoint].join("-");
    return Promise.resolve(uppyFingerprint);
  };
}
__name(getFingerprint, "getFingerprint");
function _classPrivateFieldLooseBase$7(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$7, "_classPrivateFieldLooseBase$7");
var id$7 = 0;
function _classPrivateFieldLooseKey$7(name) {
  return "__private_" + id$7++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$7, "_classPrivateFieldLooseKey$7");
const packageJson$5 = {
  version: "3.3.0"
}, tusDefaultOptions = {
  endpoint: "",
  uploadUrl: null,
  metadata: {},
  uploadSize: null,
  onProgress: null,
  onChunkComplete: null,
  onSuccess: null,
  onError: null,
  overridePatchMethod: !1,
  headers: {},
  addRequestId: !1,
  chunkSize: 1 / 0,
  retryDelays: [100, 1e3, 3e3, 5e3],
  parallelUploads: 1,
  removeFingerprintOnSuccess: !1,
  uploadLengthDeferred: !1,
  uploadDataDuringCreation: !1
};
var _retryDelayIterator = /* @__PURE__ */ _classPrivateFieldLooseKey$7("retryDelayIterator"), _uploadLocalFile$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$7("uploadLocalFile"), _getCompanionClientArgs$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$7("getCompanionClientArgs"), _uploadFiles$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$7("uploadFiles"), _handleUpload$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$7("handleUpload");
const _Tus = class _Tus extends BasePlugin {
  /**
   * @param {Uppy} uppy
   * @param {TusOptions} opts
   */
  constructor(uppy, _opts) {
    var _this$opts$rateLimite, _this$opts$retryDelay;
    super(uppy, _opts), Object.defineProperty(this, _uploadFiles$1, {
      value: _uploadFiles2$1
    }), Object.defineProperty(this, _getCompanionClientArgs$1, {
      value: _getCompanionClientArgs2$1
    }), Object.defineProperty(this, _uploadLocalFile$1, {
      value: _uploadLocalFile2$1
    }), Object.defineProperty(this, _retryDelayIterator, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _handleUpload$1, {
      writable: !0,
      value: /* @__PURE__ */ __name(async (fileIDs) => {
        if (fileIDs.length === 0) {
          this.uppy.log("[Tus] No files to upload");
          return;
        }
        this.opts.limit === 0 && this.uppy.log("[Tus] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/tus/#limit-0", "warning"), this.uppy.log("[Tus] Uploading...");
        const filesToUpload = this.uppy.getFilesByIds(fileIDs);
        await _classPrivateFieldLooseBase$7(this, _uploadFiles$1)[_uploadFiles$1](filesToUpload);
      }, "value")
    }), this.type = "uploader", this.id = this.opts.id || "Tus", this.title = "Tus";
    const defaultOptions2 = {
      useFastRemoteRetry: !0,
      limit: 20,
      retryDelays: tusDefaultOptions.retryDelays,
      withCredentials: !1
    };
    if (this.opts = {
      ...defaultOptions2,
      ..._opts
    }, (_opts == null ? void 0 : _opts.allowedMetaFields) === void 0 && "metaFields" in this.opts)
      throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
    if ("autoRetry" in _opts)
      throw new Error("The `autoRetry` option was deprecated and has been removed.");
    this.requests = (_this$opts$rateLimite = this.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new RateLimitedQueue(this.opts.limit), _classPrivateFieldLooseBase$7(this, _retryDelayIterator)[_retryDelayIterator] = (_this$opts$retryDelay = this.opts.retryDelays) == null ? void 0 : _this$opts$retryDelay.values(), this.uploaders = /* @__PURE__ */ Object.create(null), this.uploaderEvents = /* @__PURE__ */ Object.create(null), this.handleResetProgress = this.handleResetProgress.bind(this);
  }
  handleResetProgress() {
    const files = {
      ...this.uppy.getState().files
    };
    Object.keys(files).forEach((fileID) => {
      if (files[fileID].tus && files[fileID].tus.uploadUrl) {
        const tusState = {
          ...files[fileID].tus
        };
        delete tusState.uploadUrl, files[fileID] = {
          ...files[fileID],
          tus: tusState
        };
      }
    }), this.uppy.setState({
      files
    });
  }
  /**
   * Clean up all references for a file's upload: the tus.Upload instance,
   * any events related to the file, and the Companion WebSocket connection.
   *
   * @param {string} fileID
   */
  resetUploaderReferences(fileID, opts) {
    if (opts === void 0 && (opts = {}), this.uploaders[fileID]) {
      const uploader = this.uploaders[fileID];
      uploader.abort(), opts.abort && uploader.abort(!0), this.uploaders[fileID] = null;
    }
    this.uploaderEvents[fileID] && (this.uploaderEvents[fileID].remove(), this.uploaderEvents[fileID] = null);
  }
  /**
   * Store the uploadUrl on the file options, so that when Golden Retriever
   * restores state, we will continue uploading to the correct URL.
   *
   * @param {UppyFile} file
   * @param {string} uploadURL
   */
  onReceiveUploadUrl(file, uploadURL) {
    const currentFile = this.uppy.getFile(file.id);
    currentFile && (!currentFile.tus || currentFile.tus.uploadUrl !== uploadURL) && (this.uppy.log("[Tus] Storing upload url"), this.uppy.setFileState(currentFile.id, {
      tus: {
        ...currentFile.tus,
        uploadUrl: uploadURL
      }
    }));
  }
  install() {
    this.uppy.setState({
      capabilities: {
        ...this.uppy.getState().capabilities,
        resumableUploads: !0
      }
    }), this.uppy.addUploader(_classPrivateFieldLooseBase$7(this, _handleUpload$1)[_handleUpload$1]), this.uppy.on("reset-progress", this.handleResetProgress);
  }
  uninstall() {
    this.uppy.setState({
      capabilities: {
        ...this.uppy.getState().capabilities,
        resumableUploads: !1
      }
    }), this.uppy.removeUploader(_classPrivateFieldLooseBase$7(this, _handleUpload$1)[_handleUpload$1]);
  }
};
__name(_Tus, "Tus");
let Tus = _Tus;
function _uploadLocalFile2$1(file) {
  var _this = this;
  return this.resetUploaderReferences(file.id), new Promise((resolve3, reject) => {
    let queuedRequest, qRequest, upload;
    const opts = {
      ...this.opts,
      ...file.tus || {}
    };
    typeof opts.headers == "function" && (opts.headers = opts.headers(file));
    const uploadOptions = {
      ...tusDefaultOptions,
      ...opts
    };
    uploadOptions.fingerprint = getFingerprint(file), uploadOptions.onBeforeRequest = (req) => {
      const xhr = req.getUnderlyingObject();
      xhr.withCredentials = !!opts.withCredentials;
      let userProvidedPromise;
      if (typeof opts.onBeforeRequest == "function" && (userProvidedPromise = opts.onBeforeRequest(req, file)), has$1(queuedRequest, "shouldBeRequeued")) {
        if (!queuedRequest.shouldBeRequeued) return Promise.reject();
        let done;
        const p2 = new Promise((res) => {
          done = res;
        });
        return queuedRequest = this.requests.run(() => (file.isPaused && queuedRequest.abort(), done(), () => {
        })), Promise.all([p2, userProvidedPromise]);
      }
      return userProvidedPromise;
    }, uploadOptions.onError = (err) => {
      var _queuedRequest;
      this.uppy.log(err);
      const xhr = err.originalRequest ? err.originalRequest.getUnderlyingObject() : null;
      isNetworkError(xhr) && (err = new NetworkError(err, xhr)), this.resetUploaderReferences(file.id), (_queuedRequest = queuedRequest) == null || _queuedRequest.abort(), this.uppy.emit("upload-error", file, err), typeof opts.onError == "function" && opts.onError(err), reject(err);
    }, uploadOptions.onProgress = (bytesUploaded, bytesTotal) => {
      this.onReceiveUploadUrl(file, upload.url), typeof opts.onProgress == "function" && opts.onProgress(bytesUploaded, bytesTotal), this.uppy.emit("upload-progress", file, {
        uploader: this,
        bytesUploaded,
        bytesTotal
      });
    }, uploadOptions.onSuccess = () => {
      const uploadResp = {
        uploadURL: upload.url
      };
      this.resetUploaderReferences(file.id), queuedRequest.done(), this.uppy.emit("upload-success", file, uploadResp), upload.url && this.uppy.log(`Download ${upload.file.name} from ${upload.url}`), typeof opts.onSuccess == "function" && opts.onSuccess(), resolve3(upload);
    };
    const defaultOnShouldRetry = /* @__PURE__ */ __name((err) => {
      var _err$originalResponse;
      const status = err == null || (_err$originalResponse = err.originalResponse) == null ? void 0 : _err$originalResponse.getStatus();
      if (status === 429) {
        if (!this.requests.isPaused) {
          var _classPrivateFieldLoo;
          const next = (_classPrivateFieldLoo = _classPrivateFieldLooseBase$7(this, _retryDelayIterator)[_retryDelayIterator]) == null ? void 0 : _classPrivateFieldLoo.next();
          if (next == null || next.done)
            return !1;
          this.requests.rateLimit(next.value);
        }
      } else {
        if (status > 400 && status < 500 && status !== 409 && status !== 423)
          return !1;
        typeof navigator < "u" && navigator.onLine === !1 && (this.requests.isPaused || (this.requests.pause(), window.addEventListener("online", () => {
          this.requests.resume();
        }, {
          once: !0
        })));
      }
      return queuedRequest.abort(), queuedRequest = {
        shouldBeRequeued: !0,
        abort() {
          this.shouldBeRequeued = !1;
        },
        done() {
          throw new Error("Cannot mark a queued request as done: this indicates a bug");
        },
        fn() {
          throw new Error("Cannot run a queued request: this indicates a bug");
        }
      }, !0;
    }, "defaultOnShouldRetry");
    opts.onShouldRetry != null ? uploadOptions.onShouldRetry = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
        args[_key] = arguments[_key];
      return opts.onShouldRetry(...args, defaultOnShouldRetry);
    } : uploadOptions.onShouldRetry = defaultOnShouldRetry;
    const copyProp = /* @__PURE__ */ __name((obj, srcProp, destProp) => {
      has$1(obj, srcProp) && !has$1(obj, destProp) && (obj[destProp] = obj[srcProp]);
    }, "copyProp"), meta = {};
    (Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(file.meta)).forEach((item) => {
      meta[item] = file.meta[item];
    }), copyProp(meta, "type", "filetype"), copyProp(meta, "name", "filename"), uploadOptions.metadata = meta, upload = new Upload(file.data, uploadOptions), this.uploaders[file.id] = upload;
    const eventManager = new EventManager(this.uppy);
    this.uploaderEvents[file.id] = eventManager, qRequest = /* @__PURE__ */ __name(() => (file.isPaused || upload.start(), () => {
    }), "qRequest"), upload.findPreviousUploads().then((previousUploads) => {
      const previousUpload = previousUploads[0];
      previousUpload && (this.uppy.log(`[Tus] Resuming upload of ${file.id} started at ${previousUpload.creationTime}`), upload.resumeFromPreviousUpload(previousUpload));
    }), queuedRequest = this.requests.run(qRequest), eventManager.onFileRemove(file.id, (targetFileID) => {
      queuedRequest.abort(), this.resetUploaderReferences(file.id, {
        abort: !!upload.url
      }), resolve3(`upload ${targetFileID} was removed`);
    }), eventManager.onPause(file.id, (isPaused) => {
      queuedRequest.abort(), isPaused ? upload.abort() : queuedRequest = this.requests.run(qRequest);
    }), eventManager.onPauseAll(file.id, () => {
      queuedRequest.abort(), upload.abort();
    }), eventManager.onCancelAll(file.id, function(_temp) {
      let {
        reason
      } = _temp === void 0 ? {} : _temp;
      reason === "user" && (queuedRequest.abort(), _this.resetUploaderReferences(file.id, {
        abort: !!upload.url
      })), resolve3(`upload ${file.id} was canceled`);
    }), eventManager.onResumeAll(file.id, () => {
      queuedRequest.abort(), file.error && upload.abort(), queuedRequest = this.requests.run(qRequest);
    });
  }).catch((err) => {
    throw this.uppy.emit("upload-error", file, err), err;
  });
}
__name(_uploadLocalFile2$1, "_uploadLocalFile2$1");
function _getCompanionClientArgs2$1(file) {
  const opts = {
    ...this.opts
  };
  return file.tus && Object.assign(opts, file.tus), {
    ...file.remote.body,
    endpoint: opts.endpoint,
    uploadUrl: opts.uploadUrl,
    protocol: "tus",
    size: file.data.size,
    headers: opts.headers,
    metadata: file.meta
  };
}
__name(_getCompanionClientArgs2$1, "_getCompanionClientArgs2$1");
async function _uploadFiles2$1(files) {
  const filesFiltered = filterNonFailedFiles(files), filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
  this.uppy.emit("upload-start", filesToEmit), await Promise.allSettled(filesFiltered.map((file, i2) => {
    const current = i2 + 1, total = files.length;
    if (file.isRemote) {
      const Client2 = file.remote.providerOptions.provider ? Provider : RequestClient, getQueue = /* @__PURE__ */ __name(() => this.requests, "getQueue"), client = new Client2(this.uppy, file.remote.providerOptions, getQueue), controller = new AbortController(), removedHandler = /* @__PURE__ */ __name((removedFile) => {
        removedFile.id === file.id && controller.abort();
      }, "removedHandler");
      this.uppy.on("file-removed", removedHandler);
      const uploadPromise = client.uploadRemoteFile(file, _classPrivateFieldLooseBase$7(this, _getCompanionClientArgs$1)[_getCompanionClientArgs$1](file), {
        signal: controller.signal
      });
      return this.requests.wrapSyncFunction(() => {
        this.uppy.off("file-removed", removedHandler);
      }, {
        priority: -1
      })(), uploadPromise;
    }
    return _classPrivateFieldLooseBase$7(this, _uploadLocalFile$1)[_uploadLocalFile$1](file, current, total);
  }));
}
__name(_uploadFiles2$1, "_uploadFiles2$1");
Tus.VERSION = packageJson$5.version;
var componentEmitter = { exports: {} };
(function(module) {
  module.exports = Emitter2;
  function Emitter2(obj) {
    if (obj) return mixin(obj);
  }
  __name(Emitter2, "Emitter");
  function mixin(obj) {
    for (var key in Emitter2.prototype)
      obj[key] = Emitter2.prototype[key];
    return obj;
  }
  __name(mixin, "mixin"), Emitter2.prototype.on = Emitter2.prototype.addEventListener = function(event, fn) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn), this;
  }, Emitter2.prototype.once = function(event, fn) {
    function on() {
      this.off(event, on), fn.apply(this, arguments);
    }
    return __name(on, "on"), on.fn = fn, this.on(event, on), this;
  }, Emitter2.prototype.off = Emitter2.prototype.removeListener = Emitter2.prototype.removeAllListeners = Emitter2.prototype.removeEventListener = function(event, fn) {
    if (this._callbacks = this._callbacks || {}, arguments.length == 0)
      return this._callbacks = {}, this;
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    if (arguments.length == 1)
      return delete this._callbacks["$" + event], this;
    for (var cb, i2 = 0; i2 < callbacks.length; i2++)
      if (cb = callbacks[i2], cb === fn || cb.fn === fn) {
        callbacks.splice(i2, 1);
        break;
      }
    return callbacks.length === 0 && delete this._callbacks["$" + event], this;
  }, Emitter2.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    for (var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event], i2 = 1; i2 < arguments.length; i2++)
      args[i2 - 1] = arguments[i2];
    if (callbacks) {
      callbacks = callbacks.slice(0);
      for (var i2 = 0, len2 = callbacks.length; i2 < len2; ++i2)
        callbacks[i2].apply(this, args);
    }
    return this;
  }, Emitter2.prototype.listeners = function(event) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + event] || [];
  }, Emitter2.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
  };
})(componentEmitter);
var componentEmitterExports = componentEmitter.exports;
const Emitter$1 = /* @__PURE__ */ getDefaultExportFromCjs(componentEmitterExports);
function _classPrivateFieldLooseBase$6(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$6, "_classPrivateFieldLooseBase$6");
var id$6 = 0;
function _classPrivateFieldLooseKey$6(name) {
  return "__private_" + id$6++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$6, "_classPrivateFieldLooseKey$6");
const ASSEMBLY_UPLOADING = "ASSEMBLY_UPLOADING", ASSEMBLY_EXECUTING = "ASSEMBLY_EXECUTING", ASSEMBLY_COMPLETED = "ASSEMBLY_COMPLETED", statusOrder = [ASSEMBLY_UPLOADING, ASSEMBLY_EXECUTING, ASSEMBLY_COMPLETED];
function isStatus(status, test) {
  return statusOrder.indexOf(status) >= statusOrder.indexOf(test);
}
__name(isStatus, "isStatus");
var _rateLimitedQueue$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$6("rateLimitedQueue"), _fetchWithNetworkError$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$6("fetchWithNetworkError"), _previousFetchStatusStillPending = /* @__PURE__ */ _classPrivateFieldLooseKey$6("previousFetchStatusStillPending"), _sse = /* @__PURE__ */ _classPrivateFieldLooseKey$6("sse"), _onFinished = /* @__PURE__ */ _classPrivateFieldLooseKey$6("onFinished"), _connectServerSentEvents = /* @__PURE__ */ _classPrivateFieldLooseKey$6("connectServerSentEvents"), _onError$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$6("onError"), _beginPolling = /* @__PURE__ */ _classPrivateFieldLooseKey$6("beginPolling"), _fetchStatus = /* @__PURE__ */ _classPrivateFieldLooseKey$6("fetchStatus"), _diffStatus = /* @__PURE__ */ _classPrivateFieldLooseKey$6("diffStatus");
const _TransloaditAssembly = class _TransloaditAssembly extends Emitter$1 {
  constructor(assembly, rateLimitedQueue) {
    super(), Object.defineProperty(this, _diffStatus, {
      value: _diffStatus2
    }), Object.defineProperty(this, _fetchStatus, {
      value: _fetchStatus2
    }), Object.defineProperty(this, _beginPolling, {
      value: _beginPolling2
    }), Object.defineProperty(this, _onError$1, {
      value: _onError2
    }), Object.defineProperty(this, _connectServerSentEvents, {
      value: _connectServerSentEvents2
    }), Object.defineProperty(this, _onFinished, {
      value: _onFinished2
    }), Object.defineProperty(this, _rateLimitedQueue$1, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _fetchWithNetworkError$1, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _previousFetchStatusStillPending, {
      writable: !0,
      value: !1
    }), Object.defineProperty(this, _sse, {
      writable: !0,
      value: void 0
    }), this.status = assembly, this.pollInterval = null, this.closed = !1, _classPrivateFieldLooseBase$6(this, _rateLimitedQueue$1)[_rateLimitedQueue$1] = rateLimitedQueue, _classPrivateFieldLooseBase$6(this, _fetchWithNetworkError$1)[_fetchWithNetworkError$1] = rateLimitedQueue.wrapPromiseFunction(fetchWithNetworkError);
  }
  connect() {
    _classPrivateFieldLooseBase$6(this, _connectServerSentEvents)[_connectServerSentEvents](), _classPrivateFieldLooseBase$6(this, _beginPolling)[_beginPolling]();
  }
  update() {
    return _classPrivateFieldLooseBase$6(this, _fetchStatus)[_fetchStatus]({
      diff: !0
    });
  }
  /**
   * Update this assembly's status with a full new object. Events will be
   * emitted for status changes, new files, and new results.
   *
   * @param {object} next The new assembly status object.
   */
  updateStatus(next) {
    _classPrivateFieldLooseBase$6(this, _diffStatus)[_diffStatus](this.status, next), this.status = next;
  }
  /**
   * Stop updating this assembly.
   */
  close() {
    this.closed = !0, _classPrivateFieldLooseBase$6(this, _sse)[_sse] && (_classPrivateFieldLooseBase$6(this, _sse)[_sse].close(), _classPrivateFieldLooseBase$6(this, _sse)[_sse] = null), clearInterval(this.pollInterval), this.pollInterval = null;
  }
};
__name(_TransloaditAssembly, "TransloaditAssembly");
let TransloaditAssembly = _TransloaditAssembly;
function _onFinished2() {
  this.emit("finished"), this.close();
}
__name(_onFinished2, "_onFinished2");
function _connectServerSentEvents2() {
  _classPrivateFieldLooseBase$6(this, _sse)[_sse] = new EventSource(`${this.status.websocket_url}?assembly=${this.status.assembly_id}`), _classPrivateFieldLooseBase$6(this, _sse)[_sse].addEventListener("open", () => {
    this.socket && (this.socket.disconnect(), this.socket = null), clearInterval(this.pollInterval), this.pollInterval = null;
  }), _classPrivateFieldLooseBase$6(this, _sse)[_sse].addEventListener("message", (e2) => {
    e2.data === "assembly_finished" && _classPrivateFieldLooseBase$6(this, _onFinished)[_onFinished](), e2.data === "assembly_uploading_finished" && this.emit("executing"), e2.data === "assembly_upload_meta_data_extracted" && (this.emit("metadata"), _classPrivateFieldLooseBase$6(this, _fetchStatus)[_fetchStatus]({
      diff: !1
    }));
  }), _classPrivateFieldLooseBase$6(this, _sse)[_sse].addEventListener("assembly_upload_finished", (e2) => {
    const file = JSON.parse(e2.data);
    this.emit("upload", file), this.status.uploads.push(file);
  }), _classPrivateFieldLooseBase$6(this, _sse)[_sse].addEventListener("assembly_result_finished", (e2) => {
    var _this$status$results, _this$status$results$;
    const [stepName, result2] = JSON.parse(e2.data);
    this.emit("result", stepName, result2), ((_this$status$results$ = (_this$status$results = this.status.results)[stepName]) != null ? _this$status$results$ : _this$status$results[stepName] = []).push(result2);
  }), _classPrivateFieldLooseBase$6(this, _sse)[_sse].addEventListener("assembly_execution_progress", (e2) => {
    const details = JSON.parse(e2.data);
    this.emit("execution-progress", details);
  }), _classPrivateFieldLooseBase$6(this, _sse)[_sse].addEventListener("assembly_error", (e2) => {
    try {
      _classPrivateFieldLooseBase$6(this, _onError$1)[_onError$1](JSON.parse(e2.data));
    } catch {
      _classPrivateFieldLooseBase$6(this, _onError$1)[_onError$1]({
        msg: e2.data
      });
    }
    _classPrivateFieldLooseBase$6(this, _fetchStatus)[_fetchStatus]({
      diff: !1
    });
  });
}
__name(_connectServerSentEvents2, "_connectServerSentEvents2");
function _onError2(status) {
  this.emit("error", Object.assign(new Error(status.msg), status)), this.close();
}
__name(_onError2, "_onError2");
function _beginPolling2() {
  this.pollInterval = setInterval(() => {
    _classPrivateFieldLooseBase$6(this, _fetchStatus)[_fetchStatus]();
  }, 2e3);
}
__name(_beginPolling2, "_beginPolling2");
async function _fetchStatus2(_temp) {
  let {
    diff = !0
  } = _temp === void 0 ? {} : _temp;
  if (!(this.closed || _classPrivateFieldLooseBase$6(this, _rateLimitedQueue$1)[_rateLimitedQueue$1].isPaused || _classPrivateFieldLooseBase$6(this, _previousFetchStatusStillPending)[_previousFetchStatusStillPending]))
    try {
      _classPrivateFieldLooseBase$6(this, _previousFetchStatusStillPending)[_previousFetchStatusStillPending] = !0;
      const response = await _classPrivateFieldLooseBase$6(this, _fetchWithNetworkError$1)[_fetchWithNetworkError$1](this.status.assembly_ssl_url);
      if (_classPrivateFieldLooseBase$6(this, _previousFetchStatusStillPending)[_previousFetchStatusStillPending] = !1, this.closed) return;
      if (response.status === 429) {
        _classPrivateFieldLooseBase$6(this, _rateLimitedQueue$1)[_rateLimitedQueue$1].rateLimit(2e3);
        return;
      }
      if (!response.ok) {
        _classPrivateFieldLooseBase$6(this, _onError$1)[_onError$1](new NetworkError(response.statusText));
        return;
      }
      const status = await response.json();
      if (this.closed) return;
      this.emit("status", status), diff ? this.updateStatus(status) : this.status = status;
    } catch (err) {
      _classPrivateFieldLooseBase$6(this, _onError$1)[_onError$1](err);
    }
}
__name(_fetchStatus2, "_fetchStatus2");
function _diffStatus2(prev, next) {
  const prevStatus = prev.ok, nextStatus = next.ok;
  if (next.error && !prev.error)
    return _classPrivateFieldLooseBase$6(this, _onError$1)[_onError$1](next);
  const nowExecuting = isStatus(nextStatus, ASSEMBLY_EXECUTING) && !isStatus(prevStatus, ASSEMBLY_EXECUTING);
  nowExecuting && this.emit("executing"), Object.keys(next.uploads).filter((upload) => !has$1(prev.uploads, upload)).forEach((upload) => {
    this.emit("upload", next.uploads[upload]);
  }), nowExecuting && this.emit("metadata"), Object.keys(next.results).forEach((stepName) => {
    const nextResults = next.results[stepName], prevResults = prev.results[stepName];
    nextResults.filter((n2) => !prevResults || !prevResults.some((p2) => p2.id === n2.id)).forEach((result2) => {
      this.emit("result", stepName, result2);
    });
  }), isStatus(nextStatus, ASSEMBLY_COMPLETED) && !isStatus(prevStatus, ASSEMBLY_COMPLETED) && this.emit("finished");
}
__name(_diffStatus2, "_diffStatus2");
function _classPrivateFieldLooseBase$5(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$5, "_classPrivateFieldLooseBase$5");
var id$5 = 0;
function _classPrivateFieldLooseKey$5(name) {
  return "__private_" + id$5++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$5, "_classPrivateFieldLooseKey$5");
const ASSEMBLIES_ENDPOINT = "/assemblies";
var _headers = /* @__PURE__ */ _classPrivateFieldLooseKey$5("headers"), _fetchWithNetworkError = /* @__PURE__ */ _classPrivateFieldLooseKey$5("fetchWithNetworkError"), _fetchJSON = /* @__PURE__ */ _classPrivateFieldLooseKey$5("fetchJSON"), _reportError = /* @__PURE__ */ _classPrivateFieldLooseKey$5("reportError");
const _Client = class _Client {
  constructor(_opts) {
    _opts === void 0 && (_opts = {}), Object.defineProperty(this, _fetchJSON, {
      value: _fetchJSON2
    }), Object.defineProperty(this, _headers, {
      writable: !0,
      value: {}
    }), Object.defineProperty(this, _fetchWithNetworkError, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _reportError, {
      writable: !0,
      value: /* @__PURE__ */ __name((err, params) => {
        if (this.opts.errorReporting === !1)
          throw err;
        const opts = {
          type: params.type
        };
        throw params.assembly && (opts.assembly = params.assembly.assembly_id, opts.instance = params.assembly.instance), params.url && (opts.endpoint = params.url), this.submitError(err, opts).catch(() => {
        }), err;
      }, "value")
    }), this.opts = _opts, this.opts.client != null && (_classPrivateFieldLooseBase$5(this, _headers)[_headers]["Transloadit-Client"] = this.opts.client), _classPrivateFieldLooseBase$5(this, _fetchWithNetworkError)[_fetchWithNetworkError] = this.opts.rateLimitedQueue.wrapPromiseFunction(fetchWithNetworkError);
  }
  /**
   * Create a new assembly.
   *
   * @param {object} options
   * @param {string|object} options.params
   * @param {object} options.fields
   * @param {string} options.signature
   * @param {number} options.expectedFiles
   */
  createAssembly(_ref) {
    let {
      params,
      fields,
      signature,
      expectedFiles
    } = _ref;
    const data = new FormData();
    data.append("params", typeof params == "string" ? params : JSON.stringify(params)), signature && data.append("signature", signature), Object.keys(fields).forEach((key) => {
      data.append(key, fields[key]);
    }), data.append("num_expected_upload_files", expectedFiles);
    const url = new URL(ASSEMBLIES_ENDPOINT, `${this.opts.service}`).href;
    return _classPrivateFieldLooseBase$5(this, _fetchJSON)[_fetchJSON](url, {
      method: "POST",
      headers: _classPrivateFieldLooseBase$5(this, _headers)[_headers],
      body: data
    }).catch((err) => _classPrivateFieldLooseBase$5(this, _reportError)[_reportError](err, {
      url,
      type: "API_ERROR"
    }));
  }
  /**
   * Reserve resources for a file in an Assembly. Then addFile can be used later.
   *
   * @param {object} assembly
   * @param {UppyFile} file
   */
  reserveFile(assembly, file) {
    const size = encodeURIComponent(file.size), url = `${assembly.assembly_ssl_url}/reserve_file?size=${size}`;
    return _classPrivateFieldLooseBase$5(this, _fetchJSON)[_fetchJSON](url, {
      method: "POST",
      headers: _classPrivateFieldLooseBase$5(this, _headers)[_headers]
    }).catch((err) => _classPrivateFieldLooseBase$5(this, _reportError)[_reportError](err, {
      assembly,
      file,
      url,
      type: "API_ERROR"
    }));
  }
  /**
   * Import a remote file to an Assembly.
   *
   * @param {object} assembly
   * @param {UppyFile} file
   */
  addFile(assembly, file) {
    if (!file.uploadURL)
      return Promise.reject(new Error("File does not have an `uploadURL`."));
    const size = encodeURIComponent(file.size), uploadUrl = encodeURIComponent(file.uploadURL), filename = encodeURIComponent(file.name), qs2 = `size=${size}&filename=${filename}&fieldname=file&s3Url=${uploadUrl}`, url = `${assembly.assembly_ssl_url}/add_file?${qs2}`;
    return _classPrivateFieldLooseBase$5(this, _fetchJSON)[_fetchJSON](url, {
      method: "POST",
      headers: _classPrivateFieldLooseBase$5(this, _headers)[_headers]
    }).catch((err) => _classPrivateFieldLooseBase$5(this, _reportError)[_reportError](err, {
      assembly,
      file,
      url,
      type: "API_ERROR"
    }));
  }
  /**
   * Update the number of expected files in an already created assembly.
   *
   * @param {object} assembly
   * @param {number} num_expected_upload_files
   */
  updateNumberOfFilesInAssembly(assembly, num_expected_upload_files) {
    const url = new URL(assembly.assembly_ssl_url);
    url.pathname = "/update_assemblies";
    const body = JSON.stringify({
      assembly_updates: [{
        assembly_id: assembly.assembly_id,
        num_expected_upload_files
      }]
    });
    return _classPrivateFieldLooseBase$5(this, _fetchJSON)[_fetchJSON](url, {
      method: "POST",
      headers: _classPrivateFieldLooseBase$5(this, _headers)[_headers],
      body
    }).catch((err) => _classPrivateFieldLooseBase$5(this, _reportError)[_reportError](err, {
      url,
      type: "API_ERROR"
    }));
  }
  /**
   * Cancel a running Assembly.
   *
   * @param {object} assembly
   */
  cancelAssembly(assembly) {
    const url = assembly.assembly_ssl_url;
    return _classPrivateFieldLooseBase$5(this, _fetchJSON)[_fetchJSON](url, {
      method: "DELETE",
      headers: _classPrivateFieldLooseBase$5(this, _headers)[_headers]
    }).catch((err) => _classPrivateFieldLooseBase$5(this, _reportError)[_reportError](err, {
      url,
      type: "API_ERROR"
    }));
  }
  /**
   * Get the current status for an assembly.
   *
   * @param {string} url The status endpoint of the assembly.
   */
  getAssemblyStatus(url) {
    return _classPrivateFieldLooseBase$5(this, _fetchJSON)[_fetchJSON](url, {
      headers: _classPrivateFieldLooseBase$5(this, _headers)[_headers]
    }).catch((err) => _classPrivateFieldLooseBase$5(this, _reportError)[_reportError](err, {
      url,
      type: "STATUS_ERROR"
    }));
  }
  submitError(err, _temp) {
    let {
      endpoint,
      instance,
      assembly
    } = _temp === void 0 ? {} : _temp;
    const message = err.details ? `${err.message} (${err.details})` : err.message;
    return _classPrivateFieldLooseBase$5(this, _fetchJSON)[_fetchJSON]("https://transloaditstatus.com/client_error", {
      method: "POST",
      body: JSON.stringify({
        endpoint,
        instance,
        assembly_id: assembly,
        agent: typeof navigator < "u" ? navigator.userAgent : "",
        client: this.opts.client,
        error: message
      })
    });
  }
};
__name(_Client, "Client");
let Client = _Client;
function _fetchJSON2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
    args[_key] = arguments[_key];
  return _classPrivateFieldLooseBase$5(this, _fetchWithNetworkError)[_fetchWithNetworkError](...args).then((response) => {
    if (response.status === 429)
      return this.opts.rateLimitedQueue.rateLimit(2e3), _classPrivateFieldLooseBase$5(this, _fetchJSON)[_fetchJSON](...args);
    if (!response.ok) {
      const serverError = new Error(response.statusText);
      return serverError.statusCode = response.status, `${args[0]}`.endsWith(ASSEMBLIES_ENDPOINT) ? response.json().then((assembly) => {
        if (!assembly.error) throw serverError;
        const error = new Error(assembly.error);
        throw error.details = assembly.message, error.assembly = assembly, assembly.assembly_id && (error.details += ` Assembly ID: ${assembly.assembly_id}`), error;
      }, (err) => {
        throw err.cause = serverError, err;
      }) : Promise.reject(serverError);
    }
    return response.json();
  });
}
__name(_fetchJSON2, "_fetchJSON2");
function validateParams(params) {
  if (params == null)
    throw new Error("Transloadit: The `params` option is required.");
  if (typeof params == "string")
    try {
      params = JSON.parse(params);
    } catch (err) {
      throw new ErrorWithCause("Transloadit: The `params` option is a malformed JSON string.", {
        cause: err
      });
    }
  if (!params.auth || !params.auth.key)
    throw new Error("Transloadit: The `params.auth.key` option is required. You can find your Transloadit API key at https://transloadit.com/c/template-credentials");
}
__name(validateParams, "validateParams");
function dedupe(list) {
  const dedupeMap = /* @__PURE__ */ Object.create(null);
  for (const {
    fileIDs,
    options
  } of list.filter(Boolean)) {
    const id2 = JSON.stringify(options);
    id2 in dedupeMap ? dedupeMap[id2].fileIDArrays.push(fileIDs) : dedupeMap[id2] = {
      options,
      fileIDArrays: [fileIDs]
    };
  }
  return Object.values(dedupeMap).map((_ref) => {
    let {
      options,
      fileIDArrays
    } = _ref;
    return {
      options,
      fileIDs: fileIDArrays.flat(1)
    };
  });
}
__name(dedupe, "dedupe");
async function getAssemblyOptions(file, options) {
  const assemblyOptions = typeof options.assemblyOptions == "function" ? await options.assemblyOptions(file, options) : options.assemblyOptions;
  validateParams(assemblyOptions.params);
  const {
    fields
  } = assemblyOptions;
  return Array.isArray(fields) ? assemblyOptions.fields = file == null ? {} : Object.fromEntries(fields.map((fieldName) => [fieldName, file.meta[fieldName]])) : fields == null && (assemblyOptions.fields = {}), assemblyOptions;
}
__name(getAssemblyOptions, "getAssemblyOptions");
const _AssemblyOptions = class _AssemblyOptions {
  constructor(files, opts) {
    this.files = files, this.opts = opts;
  }
  /**
   * Generate a set of Assemblies that will handle the upload.
   * Returns a Promise for an object with keys:
   *  - fileIDs - an array of file IDs to add to this Assembly
   *  - options - Assembly options
   */
  async build() {
    const options = this.opts;
    if (this.files.length > 0)
      return Promise.all(this.files.map(async (file) => {
        if (file == null) return;
        const assemblyOptions = await getAssemblyOptions(file, options);
        if (file != null)
          return {
            fileIDs: [file.id],
            options: assemblyOptions
          };
      })).then(dedupe);
    if (options.alwaysRunAssembly) {
      const assemblyOptions = await getAssemblyOptions(null, options);
      return [{
        fileIDs: [],
        options: assemblyOptions
      }];
    }
    return [];
  }
};
__name(_AssemblyOptions, "AssemblyOptions");
let AssemblyOptions = _AssemblyOptions;
function _classPrivateFieldLooseBase$4(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$4, "_classPrivateFieldLooseBase$4");
var id$4 = 0;
function _classPrivateFieldLooseKey$4(name) {
  return "__private_" + id$4++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$4, "_classPrivateFieldLooseKey$4");
var _assemblyIDs = /* @__PURE__ */ _classPrivateFieldLooseKey$4("assemblyIDs"), _reject = /* @__PURE__ */ _classPrivateFieldLooseKey$4("reject"), _remaining = /* @__PURE__ */ _classPrivateFieldLooseKey$4("remaining"), _resolve = /* @__PURE__ */ _classPrivateFieldLooseKey$4("resolve"), _uppy = /* @__PURE__ */ _classPrivateFieldLooseKey$4("uppy"), _watching = /* @__PURE__ */ _classPrivateFieldLooseKey$4("watching"), _onAssemblyComplete = /* @__PURE__ */ _classPrivateFieldLooseKey$4("onAssemblyComplete"), _onAssemblyCancel = /* @__PURE__ */ _classPrivateFieldLooseKey$4("onAssemblyCancel"), _onAssemblyError = /* @__PURE__ */ _classPrivateFieldLooseKey$4("onAssemblyError"), _onImportError = /* @__PURE__ */ _classPrivateFieldLooseKey$4("onImportError"), _checkAllComplete = /* @__PURE__ */ _classPrivateFieldLooseKey$4("checkAllComplete"), _removeListeners = /* @__PURE__ */ _classPrivateFieldLooseKey$4("removeListeners"), _addListeners = /* @__PURE__ */ _classPrivateFieldLooseKey$4("addListeners");
const _TransloaditAssemblyWatcher = class _TransloaditAssemblyWatcher extends Emitter$1 {
  constructor(uppy, assemblyIDs) {
    super(), Object.defineProperty(this, _addListeners, {
      value: _addListeners2
    }), Object.defineProperty(this, _removeListeners, {
      value: _removeListeners2
    }), Object.defineProperty(this, _checkAllComplete, {
      value: _checkAllComplete2
    }), Object.defineProperty(this, _watching, {
      value: _watching2
    }), Object.defineProperty(this, _assemblyIDs, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _reject, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _remaining, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _resolve, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _uppy, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _onAssemblyComplete, {
      writable: !0,
      value: /* @__PURE__ */ __name((assembly) => {
        _classPrivateFieldLooseBase$4(this, _watching)[_watching](assembly.assembly_id) && (_classPrivateFieldLooseBase$4(this, _uppy)[_uppy].log(`[Transloadit] AssemblyWatcher: Got Assembly finish ${assembly.assembly_id}`), this.emit("assembly-complete", assembly.assembly_id), _classPrivateFieldLooseBase$4(this, _checkAllComplete)[_checkAllComplete]());
      }, "value")
    }), Object.defineProperty(this, _onAssemblyCancel, {
      writable: !0,
      value: /* @__PURE__ */ __name((assembly) => {
        _classPrivateFieldLooseBase$4(this, _watching)[_watching](assembly.assembly_id) && _classPrivateFieldLooseBase$4(this, _checkAllComplete)[_checkAllComplete]();
      }, "value")
    }), Object.defineProperty(this, _onAssemblyError, {
      writable: !0,
      value: /* @__PURE__ */ __name((assembly, error) => {
        _classPrivateFieldLooseBase$4(this, _watching)[_watching](assembly.assembly_id) && (_classPrivateFieldLooseBase$4(this, _uppy)[_uppy].log(`[Transloadit] AssemblyWatcher: Got Assembly error ${assembly.assembly_id}`), _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].log(error), this.emit("assembly-error", assembly.assembly_id, error), _classPrivateFieldLooseBase$4(this, _checkAllComplete)[_checkAllComplete]());
      }, "value")
    }), Object.defineProperty(this, _onImportError, {
      writable: !0,
      value: /* @__PURE__ */ __name((assembly, fileID, error) => {
        _classPrivateFieldLooseBase$4(this, _watching)[_watching](assembly.assembly_id) && _classPrivateFieldLooseBase$4(this, _onAssemblyError)[_onAssemblyError](assembly, error);
      }, "value")
    }), _classPrivateFieldLooseBase$4(this, _uppy)[_uppy] = uppy, _classPrivateFieldLooseBase$4(this, _assemblyIDs)[_assemblyIDs] = assemblyIDs, _classPrivateFieldLooseBase$4(this, _remaining)[_remaining] = assemblyIDs.length, this.promise = new Promise((resolve3, reject) => {
      _classPrivateFieldLooseBase$4(this, _resolve)[_resolve] = resolve3, _classPrivateFieldLooseBase$4(this, _reject)[_reject] = reject;
    }), _classPrivateFieldLooseBase$4(this, _addListeners)[_addListeners]();
  }
};
__name(_TransloaditAssemblyWatcher, "TransloaditAssemblyWatcher");
let TransloaditAssemblyWatcher = _TransloaditAssemblyWatcher;
function _watching2(id2) {
  return _classPrivateFieldLooseBase$4(this, _assemblyIDs)[_assemblyIDs].indexOf(id2) !== -1;
}
__name(_watching2, "_watching2");
function _checkAllComplete2() {
  _classPrivateFieldLooseBase$4(this, _remaining)[_remaining] -= 1, _classPrivateFieldLooseBase$4(this, _remaining)[_remaining] === 0 && (_classPrivateFieldLooseBase$4(this, _removeListeners)[_removeListeners](), _classPrivateFieldLooseBase$4(this, _resolve)[_resolve]());
}
__name(_checkAllComplete2, "_checkAllComplete2");
function _removeListeners2() {
  _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].off("transloadit:complete", _classPrivateFieldLooseBase$4(this, _onAssemblyComplete)[_onAssemblyComplete]), _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].off("transloadit:assembly-cancel", _classPrivateFieldLooseBase$4(this, _onAssemblyCancel)[_onAssemblyCancel]), _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].off("transloadit:assembly-error", _classPrivateFieldLooseBase$4(this, _onAssemblyError)[_onAssemblyError]), _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].off("transloadit:import-error", _classPrivateFieldLooseBase$4(this, _onImportError)[_onImportError]);
}
__name(_removeListeners2, "_removeListeners2");
function _addListeners2() {
  _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].on("transloadit:complete", _classPrivateFieldLooseBase$4(this, _onAssemblyComplete)[_onAssemblyComplete]), _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].on("transloadit:assembly-cancel", _classPrivateFieldLooseBase$4(this, _onAssemblyCancel)[_onAssemblyCancel]), _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].on("transloadit:assembly-error", _classPrivateFieldLooseBase$4(this, _onAssemblyError)[_onAssemblyError]), _classPrivateFieldLooseBase$4(this, _uppy)[_uppy].on("transloadit:import-error", _classPrivateFieldLooseBase$4(this, _onImportError)[_onImportError]);
}
__name(_addListeners2, "_addListeners2");
const locale$1 = {
  strings: {
    // Shown while Assemblies are being created for an upload.
    creatingAssembly: "Preparing upload...",
    // Shown if an Assembly could not be created.
    creatingAssemblyFailed: "Transloadit: Could not create Assembly",
    // Shown after uploads have succeeded, but when the Assembly is still executing.
    // This only shows if `waitForMetadata` or `waitForEncoding` was enabled.
    encoding: "Encoding..."
  }
};
function _classPrivateFieldLooseBase$3(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$3, "_classPrivateFieldLooseBase$3");
var id$3 = 0;
function _classPrivateFieldLooseKey$3(name) {
  return "__private_" + id$3++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$3, "_classPrivateFieldLooseKey$3");
const packageJson$4 = {
  version: "3.3.0"
}, sendErrorToConsole = /* @__PURE__ */ __name((originalErr) => (err) => {
  const error = new ErrorWithCause("Failed to send error to the client", {
    cause: err
  });
  console.error(error, originalErr);
}, "sendErrorToConsole"), COMPANION_URL = "https://api2.transloadit.com/companion", COMPANION_ALLOWED_HOSTS = /\.transloadit\.com$/, TL_COMPANION = /https?:\/\/api2(?:-\w+)?\.transloadit\.com\/companion/;
var _rateLimitedQueue = /* @__PURE__ */ _classPrivateFieldLooseKey$3("rateLimitedQueue"), _getClientVersion = /* @__PURE__ */ _classPrivateFieldLooseKey$3("getClientVersion"), _attachAssemblyMetadata = /* @__PURE__ */ _classPrivateFieldLooseKey$3("attachAssemblyMetadata"), _createAssembly = /* @__PURE__ */ _classPrivateFieldLooseKey$3("createAssembly"), _createAssemblyWatcher = /* @__PURE__ */ _classPrivateFieldLooseKey$3("createAssemblyWatcher"), _shouldWaitAfterUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$3("shouldWaitAfterUpload"), _reserveFiles = /* @__PURE__ */ _classPrivateFieldLooseKey$3("reserveFiles"), _onFileUploadURLAvailable = /* @__PURE__ */ _classPrivateFieldLooseKey$3("onFileUploadURLAvailable"), _findFile = /* @__PURE__ */ _classPrivateFieldLooseKey$3("findFile"), _onFileUploadComplete = /* @__PURE__ */ _classPrivateFieldLooseKey$3("onFileUploadComplete"), _onResult = /* @__PURE__ */ _classPrivateFieldLooseKey$3("onResult"), _onAssemblyFinished = /* @__PURE__ */ _classPrivateFieldLooseKey$3("onAssemblyFinished"), _cancelAssembly = /* @__PURE__ */ _classPrivateFieldLooseKey$3("cancelAssembly"), _onCancelAll = /* @__PURE__ */ _classPrivateFieldLooseKey$3("onCancelAll"), _getPersistentData = /* @__PURE__ */ _classPrivateFieldLooseKey$3("getPersistentData"), _onRestored = /* @__PURE__ */ _classPrivateFieldLooseKey$3("onRestored"), _connectAssembly = /* @__PURE__ */ _classPrivateFieldLooseKey$3("connectAssembly"), _prepareUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$3("prepareUpload"), _afterUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$3("afterUpload"), _closeAssemblyIfExists = /* @__PURE__ */ _classPrivateFieldLooseKey$3("closeAssemblyIfExists"), _onError = /* @__PURE__ */ _classPrivateFieldLooseKey$3("onError"), _onTusError = /* @__PURE__ */ _classPrivateFieldLooseKey$3("onTusError");
const _Transloadit = class _Transloadit extends BasePlugin {
  constructor(uppy, opts) {
    var _this, _this$opts, _this$opts$assemblyOp, _this$opts$getAssembl;
    super(uppy, opts), _this = this, Object.defineProperty(this, _connectAssembly, {
      value: _connectAssembly2
    }), Object.defineProperty(this, _cancelAssembly, {
      value: _cancelAssembly2
    }), Object.defineProperty(this, _onAssemblyFinished, {
      value: _onAssemblyFinished2
    }), Object.defineProperty(this, _onResult, {
      value: _onResult2
    }), Object.defineProperty(this, _onFileUploadComplete, {
      value: _onFileUploadComplete2
    }), Object.defineProperty(this, _findFile, {
      value: _findFile2
    }), Object.defineProperty(this, _reserveFiles, {
      value: _reserveFiles2
    }), Object.defineProperty(this, _shouldWaitAfterUpload, {
      value: _shouldWaitAfterUpload2
    }), Object.defineProperty(this, _createAssemblyWatcher, {
      value: _createAssemblyWatcher2
    }), Object.defineProperty(this, _createAssembly, {
      value: _createAssembly2
    }), Object.defineProperty(this, _attachAssemblyMetadata, {
      value: _attachAssemblyMetadata2
    }), Object.defineProperty(this, _getClientVersion, {
      value: _getClientVersion2
    }), Object.defineProperty(this, _rateLimitedQueue, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, _onFileUploadURLAvailable, {
      writable: !0,
      value: /* @__PURE__ */ __name((rawFile) => {
        var _file$transloadit;
        const file = this.uppy.getFile(rawFile.id);
        if (!(file != null && (_file$transloadit = file.transloadit) != null && _file$transloadit.assembly))
          return;
        const {
          assemblies
        } = this.getPluginState(), assembly = assemblies[file.transloadit.assembly];
        this.client.addFile(assembly, file).catch((err) => {
          this.uppy.log(err), this.uppy.emit("transloadit:import-error", assembly, file.id, err);
        });
      }, "value")
    }), Object.defineProperty(this, _onCancelAll, {
      writable: !0,
      value: /* @__PURE__ */ __name(async function(_temp) {
        let {
          reason
        } = _temp === void 0 ? {} : _temp;
        try {
          if (reason !== "user") return;
          const {
            uploadsAssemblies
          } = _this.getPluginState(), assemblies = Object.values(uploadsAssemblies).flat(1).map((assemblyID) => _this.getAssembly(assemblyID));
          await Promise.all(assemblies.map((assembly) => _classPrivateFieldLooseBase$3(_this, _cancelAssembly)[_cancelAssembly](assembly)));
        } catch (err) {
          _this.uppy.log(err);
        }
      }, "value")
    }), Object.defineProperty(this, _getPersistentData, {
      writable: !0,
      value: /* @__PURE__ */ __name((setData3) => {
        const {
          assemblies,
          uploadsAssemblies
        } = this.getPluginState();
        setData3({
          [this.id]: {
            assemblies,
            uploadsAssemblies
          }
        });
      }, "value")
    }), Object.defineProperty(this, _onRestored, {
      writable: !0,
      value: /* @__PURE__ */ __name((pluginData) => {
        const savedState = pluginData && pluginData[this.id] ? pluginData[this.id] : {}, previousAssemblies = savedState.assemblies || {}, uploadsAssemblies = savedState.uploadsAssemblies || {};
        if (Object.keys(uploadsAssemblies).length === 0)
          return;
        const restoreState = /* @__PURE__ */ __name((assemblies) => {
          const files = {}, results = [];
          for (const [id2, status] of Object.entries(assemblies)) {
            status.uploads.forEach((uploadedFile) => {
              const file = _classPrivateFieldLooseBase$3(this, _findFile)[_findFile](uploadedFile);
              files[uploadedFile.id] = {
                id: file.id,
                assembly: id2,
                uploadedFile
              };
            });
            const state = this.getPluginState();
            Object.keys(status.results).forEach((stepName) => {
              for (const result2 of status.results[stepName]) {
                const file = state.files[result2.original_id];
                result2.localId = file ? file.id : null, results.push({
                  id: result2.id,
                  result: result2,
                  stepName,
                  assembly: id2
                });
              }
            });
          }
          this.setPluginState({
            assemblies,
            files,
            results,
            uploadsAssemblies
          });
        }, "restoreState"), restoreAssemblies = /* @__PURE__ */ __name(() => {
          const {
            assemblies,
            uploadsAssemblies: uploadsAssemblies2
          } = this.getPluginState();
          Object.keys(uploadsAssemblies2).forEach((uploadID) => {
            const assemblyIDs = uploadsAssemblies2[uploadID];
            _classPrivateFieldLooseBase$3(this, _createAssemblyWatcher)[_createAssemblyWatcher](assemblyIDs, uploadID);
          }), Object.keys(assemblies).forEach((id2) => {
            const assembly = new TransloaditAssembly(assemblies[id2], _classPrivateFieldLooseBase$3(this, _rateLimitedQueue)[_rateLimitedQueue]);
            _classPrivateFieldLooseBase$3(this, _connectAssembly)[_connectAssembly](assembly);
          });
        }, "restoreAssemblies"), updateAssemblies = /* @__PURE__ */ __name(() => {
          const {
            assemblies
          } = this.getPluginState();
          return Promise.all(Object.keys(assemblies).map((id2) => this.activeAssemblies[id2].update()));
        }, "updateAssemblies");
        this.restored = Promise.resolve().then(() => (restoreState(previousAssemblies), restoreAssemblies(), updateAssemblies())), this.restored.then(() => {
          this.restored = null;
        });
      }, "value")
    }), Object.defineProperty(this, _prepareUpload, {
      writable: !0,
      value: /* @__PURE__ */ __name((fileIDs, uploadID) => {
        const filesWithoutErrors = fileIDs.map((id2) => this.uppy.getFile(id2)).filter((file) => file.error ? !1 : (this.uppy.emit("preprocess-progress", file, {
          mode: "indeterminate",
          message: this.i18n("creatingAssembly")
        }), !0)), createAssembly = /* @__PURE__ */ __name(async (_ref) => {
          let {
            fileIDs: fileIDs2,
            options
          } = _ref;
          try {
            const assembly = await _classPrivateFieldLooseBase$3(this, _createAssembly)[_createAssembly](fileIDs2, uploadID, options);
            return this.opts.importFromUploadURLs && await _classPrivateFieldLooseBase$3(this, _reserveFiles)[_reserveFiles](assembly, fileIDs2), fileIDs2.forEach((fileID) => {
              const file = this.uppy.getFile(fileID);
              this.uppy.emit("preprocess-complete", file);
            }), assembly;
          } catch (err) {
            throw fileIDs2.forEach((fileID) => {
              const file = this.uppy.getFile(fileID);
              this.uppy.emit("preprocess-complete", file), this.uppy.emit("upload-error", file, err);
            }), err;
          }
        }, "createAssembly"), {
          uploadsAssemblies
        } = this.getPluginState();
        return this.setPluginState({
          uploadsAssemblies: {
            ...uploadsAssemblies,
            [uploadID]: []
          }
        }), new AssemblyOptions(filesWithoutErrors, this.opts).build().then((assemblies) => Promise.all(assemblies.map(createAssembly))).then((maybeCreatedAssemblies) => {
          const createdAssemblies = maybeCreatedAssemblies.filter(Boolean), assemblyIDs = createdAssemblies.map((assembly) => assembly.status.assembly_id);
          return _classPrivateFieldLooseBase$3(this, _createAssemblyWatcher)[_createAssemblyWatcher](assemblyIDs, uploadID), Promise.all(createdAssemblies.map((assembly) => _classPrivateFieldLooseBase$3(this, _connectAssembly)[_connectAssembly](assembly)));
        }).catch((err) => {
          throw filesWithoutErrors.forEach((file) => {
            this.uppy.emit("preprocess-complete", file), this.uppy.emit("upload-error", file, err);
          }), err;
        });
      }, "value")
    }), Object.defineProperty(this, _afterUpload, {
      writable: !0,
      value: /* @__PURE__ */ __name((fileIDs, uploadID) => {
        const files = fileIDs.map((fileID) => this.uppy.getFile(fileID)), filteredFileIDs = files.filter((file) => !file.error).map((file) => file.id), state = this.getPluginState();
        if (this.restored)
          return this.restored.then(() => _classPrivateFieldLooseBase$3(this, _afterUpload)[_afterUpload](filteredFileIDs, uploadID));
        const assemblyIDs = state.uploadsAssemblies[uploadID], closeSocketConnections = /* @__PURE__ */ __name(() => {
          assemblyIDs.forEach((assemblyID) => {
            this.activeAssemblies[assemblyID].close(), delete this.activeAssemblies[assemblyID];
          });
        }, "closeSocketConnections");
        if (!_classPrivateFieldLooseBase$3(this, _shouldWaitAfterUpload)[_shouldWaitAfterUpload]()) {
          closeSocketConnections();
          const assemblies = assemblyIDs.map((id2) => this.getAssembly(id2));
          return this.uppy.addResultData(uploadID, {
            transloadit: assemblies
          }), Promise.resolve();
        }
        return assemblyIDs.length === 0 ? (this.uppy.addResultData(uploadID, {
          transloadit: []
        }), Promise.resolve()) : (files.filter((file) => !has$1(this.completedFiles, file.id)).forEach((file) => {
          this.uppy.emit("postprocess-progress", file, {
            mode: "indeterminate",
            message: this.i18n("encoding")
          });
        }), this.assemblyWatchers[uploadID].promise.then(() => {
          closeSocketConnections();
          const assemblies = assemblyIDs.map((id2) => this.getAssembly(id2)), uploadsAssemblies = {
            ...this.getPluginState().uploadsAssemblies
          };
          delete uploadsAssemblies[uploadID], this.setPluginState({
            uploadsAssemblies
          }), this.uppy.addResultData(uploadID, {
            transloadit: assemblies
          });
        }));
      }, "value")
    }), Object.defineProperty(this, _closeAssemblyIfExists, {
      writable: !0,
      value: /* @__PURE__ */ __name((assemblyID) => {
        var _this$activeAssemblie;
        (_this$activeAssemblie = this.activeAssemblies[assemblyID]) == null || _this$activeAssemblie.close();
      }, "value")
    }), Object.defineProperty(this, _onError, {
      writable: !0,
      value: /* @__PURE__ */ __name(function(err, uploadID) {
        err === void 0 && (err = null);
        const assemblyIDs = _this.getPluginState().uploadsAssemblies[uploadID];
        assemblyIDs == null || assemblyIDs.forEach(_classPrivateFieldLooseBase$3(_this, _closeAssemblyIfExists)[_closeAssemblyIfExists]), _this.client.submitError(err).catch(sendErrorToConsole(err));
      }, "value")
    }), Object.defineProperty(this, _onTusError, {
      writable: !0,
      value: /* @__PURE__ */ __name((file, err) => {
        var _file$transloadit2, _err$message;
        if (_classPrivateFieldLooseBase$3(this, _closeAssemblyIfExists)[_closeAssemblyIfExists](file == null || (_file$transloadit2 = file.transloadit) == null ? void 0 : _file$transloadit2.assembly), err != null && (_err$message = err.message) != null && _err$message.startsWith("tus: ")) {
          var _err$originalRequest;
          const endpoint = (_err$originalRequest = err.originalRequest) == null || (_err$originalRequest = _err$originalRequest.getUnderlyingObject()) == null ? void 0 : _err$originalRequest.responseURL;
          this.client.submitError(err, {
            endpoint,
            type: "TUS_ERROR"
          }).catch(sendErrorToConsole(err));
        }
      }, "value")
    }), this.type = "uploader", this.id = this.opts.id || "Transloadit", this.title = "Transloadit", this.defaultLocale = locale$1;
    const defaultOptions2 = {
      service: "https://api2.transloadit.com",
      errorReporting: !0,
      waitForEncoding: !1,
      waitForMetadata: !1,
      alwaysRunAssembly: !1,
      importFromUploadURLs: !1,
      /** @deprecated use `assemblyOptions` instead */
      signature: null,
      /** @deprecated use `assemblyOptions` instead */
      params: null,
      /** @deprecated use `assemblyOptions` instead */
      fields: null,
      /** @deprecated use `assemblyOptions` instead */
      getAssemblyOptions: null,
      limit: 20,
      retryDelays: [7e3, 1e4, 15e3, 2e4]
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, (_this$opts$assemblyOp = (_this$opts = this.opts).assemblyOptions) != null || (_this$opts.assemblyOptions = (_this$opts$getAssembl = this.opts.getAssemblyOptions) != null ? _this$opts$getAssembl : {
      params: this.opts.params,
      signature: this.opts.signature,
      fields: this.opts.fields
    }), (opts == null ? void 0 : opts.params) != null && opts.getAssemblyOptions == null && opts.assemblyOptions == null && validateParams(this.opts.assemblyOptions.params), _classPrivateFieldLooseBase$3(this, _rateLimitedQueue)[_rateLimitedQueue] = new RateLimitedQueue(this.opts.limit), this.i18nInit(), this.client = new Client({
      service: this.opts.service,
      client: _classPrivateFieldLooseBase$3(this, _getClientVersion)[_getClientVersion](),
      errorReporting: this.opts.errorReporting,
      rateLimitedQueue: _classPrivateFieldLooseBase$3(this, _rateLimitedQueue)[_rateLimitedQueue]
    }), this.activeAssemblies = {}, this.assemblyWatchers = {}, this.completedFiles = /* @__PURE__ */ Object.create(null);
  }
  install() {
    this.uppy.addPreProcessor(_classPrivateFieldLooseBase$3(this, _prepareUpload)[_prepareUpload]), this.uppy.addPostProcessor(_classPrivateFieldLooseBase$3(this, _afterUpload)[_afterUpload]), this.uppy.on("error", _classPrivateFieldLooseBase$3(this, _onError)[_onError]), this.uppy.on("cancel-all", _classPrivateFieldLooseBase$3(this, _onCancelAll)[_onCancelAll]), this.uppy.on("upload-error", _classPrivateFieldLooseBase$3(this, _onTusError)[_onTusError]), this.opts.importFromUploadURLs ? this.uppy.on("upload-success", _classPrivateFieldLooseBase$3(this, _onFileUploadURLAvailable)[_onFileUploadURLAvailable]) : this.uppy.use(Tus, {
      // Disable tus-js-client fingerprinting, otherwise uploading the same file at different times
      // will upload to an outdated Assembly, and we won't get socket events for it.
      //
      // To resume a Transloadit upload, we need to reconnect to the websocket, and the state that's
      // required to do that is not saved by tus-js-client's fingerprinting. We need the tus URL,
      // the Assembly URL, and the WebSocket URL, at least. We also need to know _all_ the files that
      // were added to the Assembly, so we can properly complete it. All that state is handled by
      // Golden Retriever. So, Golden Retriever is required to do resumability with the Transloadit plugin,
      // and we disable Tus's default resume implementation to prevent bad behaviours.
      storeFingerprintForResuming: !1,
      // Disable Companion's retry optimisation; we need to change the endpoint on retry
      // so it can't just reuse the same tus.Upload instance server-side.
      useFastRemoteRetry: !1,
      // Only send Assembly metadata to the tus endpoint.
      allowedMetaFields: ["assembly_url", "filename", "fieldname"],
      // Pass the limit option to @uppy/tus
      limit: this.opts.limit,
      rateLimitedQueue: _classPrivateFieldLooseBase$3(this, _rateLimitedQueue)[_rateLimitedQueue],
      retryDelays: this.opts.retryDelays
    }), this.uppy.on("restore:get-data", _classPrivateFieldLooseBase$3(this, _getPersistentData)[_getPersistentData]), this.uppy.on("restored", _classPrivateFieldLooseBase$3(this, _onRestored)[_onRestored]), this.setPluginState({
      // Contains Assembly status objects, indexed by their ID.
      assemblies: {},
      // Contains arrays of Assembly IDs, indexed by the upload ID that they belong to.
      uploadsAssemblies: {},
      // Contains file data from Transloadit, indexed by their Transloadit-assigned ID.
      files: {},
      // Contains result data from Transloadit.
      results: []
    });
    const {
      capabilities
    } = this.uppy.getState();
    this.uppy.setState({
      capabilities: {
        ...capabilities,
        individualCancellation: !1
      }
    });
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase$3(this, _prepareUpload)[_prepareUpload]), this.uppy.removePostProcessor(_classPrivateFieldLooseBase$3(this, _afterUpload)[_afterUpload]), this.uppy.off("error", _classPrivateFieldLooseBase$3(this, _onError)[_onError]), this.opts.importFromUploadURLs && this.uppy.off("upload-success", _classPrivateFieldLooseBase$3(this, _onFileUploadURLAvailable)[_onFileUploadURLAvailable]);
    const {
      capabilities
    } = this.uppy.getState();
    this.uppy.setState({
      capabilities: {
        ...capabilities,
        individualCancellation: !0
      }
    });
  }
  getAssembly(id2) {
    const {
      assemblies
    } = this.getPluginState();
    return assemblies[id2];
  }
  getAssemblyFiles(assemblyID) {
    return this.uppy.getFiles().filter((file) => {
      var _file$transloadit3;
      return (file == null || (_file$transloadit3 = file.transloadit) == null ? void 0 : _file$transloadit3.assembly) === assemblyID;
    });
  }
};
__name(_Transloadit, "Transloadit");
let Transloadit = _Transloadit;
function _getClientVersion2() {
  const list = [`uppy-core:${this.uppy.constructor.VERSION}`, `uppy-transloadit:${this.constructor.VERSION}`, `uppy-tus:${Tus.VERSION}`], addPluginVersion = /* @__PURE__ */ __name((pluginName, versionName) => {
    const plugin = this.uppy.getPlugin(pluginName);
    plugin && list.push(`${versionName}:${plugin.constructor.VERSION}`);
  }, "addPluginVersion");
  return this.opts.importFromUploadURLs && (addPluginVersion("XHRUpload", "uppy-xhr-upload"), addPluginVersion("AwsS3", "uppy-aws-s3"), addPluginVersion("AwsS3Multipart", "uppy-aws-s3-multipart")), addPluginVersion("Dropbox", "uppy-dropbox"), addPluginVersion("Box", "uppy-box"), addPluginVersion("Facebook", "uppy-facebook"), addPluginVersion("GoogleDrive", "uppy-google-drive"), addPluginVersion("Instagram", "uppy-instagram"), addPluginVersion("OneDrive", "uppy-onedrive"), addPluginVersion("Zoom", "uppy-zoom"), addPluginVersion("Url", "uppy-url"), list.join(",");
}
__name(_getClientVersion2, "_getClientVersion2");
function _attachAssemblyMetadata2(file, status) {
  const meta = {
    ...file.meta,
    assembly_url: status.assembly_url,
    filename: file.name,
    fieldname: "file"
  }, tus = {
    ...file.tus,
    endpoint: status.tus_url,
    // Include X-Request-ID headers for better debugging.
    addRequestId: !0
  };
  let {
    remote
  } = file;
  if (file.remote && TL_COMPANION.test(file.remote.companionUrl)) {
    const newHost = status.companion_url.replace(/\/$/, ""), path = file.remote.url.replace(file.remote.companionUrl, "").replace(/^\//, "");
    remote = {
      ...file.remote,
      companionUrl: newHost,
      url: `${newHost}/${path}`
    };
  }
  const newFile = {
    ...file,
    transloadit: {
      assembly: status.assembly_id
    }
  };
  return this.opts.importFromUploadURLs || Object.assign(newFile, {
    meta,
    tus,
    remote
  }), newFile;
}
__name(_attachAssemblyMetadata2, "_attachAssemblyMetadata2");
function _createAssembly2(fileIDs, uploadID, assemblyOptions) {
  return this.uppy.log("[Transloadit] Create Assembly"), this.client.createAssembly({
    ...assemblyOptions,
    expectedFiles: fileIDs.length
  }).then(async (newAssembly) => {
    const files = this.uppy.getFiles().filter((_ref2) => {
      let {
        id: id2
      } = _ref2;
      return fileIDs.includes(id2);
    });
    if (files.length !== fileIDs.length) {
      if (files.length === 0)
        return await this.client.cancelAssembly(newAssembly), null;
      await this.client.updateNumberOfFilesInAssembly(newAssembly, files.length);
    }
    const assembly = new TransloaditAssembly(newAssembly, _classPrivateFieldLooseBase$3(this, _rateLimitedQueue)[_rateLimitedQueue]), {
      status
    } = assembly, assemblyID = status.assembly_id, {
      assemblies,
      uploadsAssemblies
    } = this.getPluginState();
    this.setPluginState({
      // Store the Assembly status.
      assemblies: {
        ...assemblies,
        [assemblyID]: status
      },
      // Store the list of Assemblies related to this upload.
      uploadsAssemblies: {
        ...uploadsAssemblies,
        [uploadID]: [...uploadsAssemblies[uploadID], assemblyID]
      }
    });
    const updatedFiles = {};
    files.forEach((file) => {
      updatedFiles[file.id] = _classPrivateFieldLooseBase$3(this, _attachAssemblyMetadata)[_attachAssemblyMetadata](file, status);
    }), this.uppy.setState({
      files: {
        ...this.uppy.getState().files,
        ...updatedFiles
      }
    });
    const fileRemovedHandler = /* @__PURE__ */ __name((fileRemoved, reason) => {
      var _assembly$status;
      if (((_assembly$status = assembly.status) == null ? void 0 : _assembly$status.ok) === "ASSEMBLY_COMPLETED") {
        this.uppy.off("file-removed", fileRemovedHandler);
        return;
      }
      if (reason === "cancel-all")
        assembly.close(), this.uppy.off("file-removed", fileRemovedHandler);
      else if (fileRemoved.id in updatedFiles) {
        delete updatedFiles[fileRemoved.id];
        const nbOfRemainingFiles = Object.keys(updatedFiles).length;
        nbOfRemainingFiles === 0 ? (assembly.close(), _classPrivateFieldLooseBase$3(this, _cancelAssembly)[_cancelAssembly](newAssembly).catch(() => {
        }), this.uppy.off("file-removed", fileRemovedHandler)) : this.client.updateNumberOfFilesInAssembly(newAssembly, nbOfRemainingFiles).catch(() => {
        });
      }
    }, "fileRemovedHandler");
    return this.uppy.on("file-removed", fileRemovedHandler), this.uppy.emit("transloadit:assembly-created", status, fileIDs), this.uppy.log(`[Transloadit] Created Assembly ${assemblyID}`), assembly;
  }).catch((err) => {
    const wrapped = new ErrorWithCause(`${this.i18n("creatingAssemblyFailed")}: ${err.message}`, {
      cause: err
    });
    throw "details" in err && (wrapped.details = err.details), "assembly" in err && (wrapped.assembly = err.assembly), wrapped;
  });
}
__name(_createAssembly2, "_createAssembly2");
function _createAssemblyWatcher2(assemblyID, uploadID) {
  const watcher = new TransloaditAssemblyWatcher(this.uppy, assemblyID);
  watcher.on("assembly-complete", (id2) => {
    this.getAssemblyFiles(id2).forEach((file) => {
      this.completedFiles[file.id] = !0, this.uppy.emit("postprocess-complete", file);
    });
  }), watcher.on("assembly-error", (id2, error) => {
    const filesFromAssembly = this.getAssemblyFiles(id2);
    filesFromAssembly.forEach((file) => {
      this.uppy.emit("upload-error", file, error), this.uppy.emit("postprocess-complete", file);
    });
    const files = {
      ...this.uppy.getState().files
    };
    filesFromAssembly.forEach((file) => delete files[file.id].tus), this.uppy.setState({
      files
    }), this.uppy.emit("error", error);
  }), this.assemblyWatchers[uploadID] = watcher;
}
__name(_createAssemblyWatcher2, "_createAssemblyWatcher2");
function _shouldWaitAfterUpload2() {
  return this.opts.waitForEncoding || this.opts.waitForMetadata;
}
__name(_shouldWaitAfterUpload2, "_shouldWaitAfterUpload2");
function _reserveFiles2(assembly, fileIDs) {
  return Promise.all(fileIDs.map((fileID) => {
    const file = this.uppy.getFile(fileID);
    return this.client.reserveFile(assembly.status, file);
  }));
}
__name(_reserveFiles2, "_reserveFiles2");
function _findFile2(uploadedFile) {
  const files = this.uppy.getFiles();
  for (let i2 = 0; i2 < files.length; i2++) {
    const file = files[i2];
    if (file.uploadURL === uploadedFile.tus_upload_url || file.tus && file.tus.uploadUrl === uploadedFile.tus_upload_url || !uploadedFile.is_tus_file && file.name === uploadedFile.name && file.size === uploadedFile.size)
      return file;
  }
}
__name(_findFile2, "_findFile2");
function _onFileUploadComplete2(assemblyId, uploadedFile) {
  const state = this.getPluginState(), file = _classPrivateFieldLooseBase$3(this, _findFile)[_findFile](uploadedFile);
  if (!file) {
    this.uppy.log("[Transloadit] Couldn’t find the file, it was likely removed in the process");
    return;
  }
  this.setPluginState({
    files: {
      ...state.files,
      [uploadedFile.id]: {
        assembly: assemblyId,
        id: file.id,
        uploadedFile
      }
    }
  }), this.uppy.emit("transloadit:upload", uploadedFile, this.getAssembly(assemblyId));
}
__name(_onFileUploadComplete2, "_onFileUploadComplete2");
function _onResult2(assemblyId, stepName, result2) {
  const state = this.getPluginState(), file = state.files[result2.original_id];
  result2.localId = file ? file.id : null;
  const entry = {
    result: result2,
    stepName,
    id: result2.id,
    assembly: assemblyId
  };
  this.setPluginState({
    results: [...state.results, entry]
  }), this.uppy.emit("transloadit:result", stepName, result2, this.getAssembly(assemblyId));
}
__name(_onResult2, "_onResult2");
function _onAssemblyFinished2(status) {
  const url = status.assembly_ssl_url;
  this.client.getAssemblyStatus(url).then((finalStatus) => {
    const assemblyId = finalStatus.assembly_id, state = this.getPluginState();
    this.setPluginState({
      assemblies: {
        ...state.assemblies,
        [assemblyId]: finalStatus
      }
    }), this.uppy.emit("transloadit:complete", finalStatus);
  });
}
__name(_onAssemblyFinished2, "_onAssemblyFinished2");
async function _cancelAssembly2(assembly) {
  await this.client.cancelAssembly(assembly), this.uppy.emit("transloadit:assembly-cancelled", assembly);
}
__name(_cancelAssembly2, "_cancelAssembly2");
function _connectAssembly2(assembly) {
  const {
    status
  } = assembly, id2 = status.assembly_id;
  return this.activeAssemblies[id2] = assembly, assembly.on("status", (newStatus) => {
    const {
      assemblies
    } = this.getPluginState();
    this.setPluginState({
      assemblies: {
        ...assemblies,
        [id2]: newStatus
      }
    });
  }), assembly.on("upload", (file) => {
    _classPrivateFieldLooseBase$3(this, _onFileUploadComplete)[_onFileUploadComplete](id2, file);
  }), assembly.on("error", (error) => {
    error.assembly = assembly.status, this.uppy.emit("transloadit:assembly-error", assembly.status, error);
  }), assembly.on("executing", () => {
    this.uppy.emit("transloadit:assembly-executing", assembly.status);
  }), assembly.on("execution-progress", (details) => {
    if (this.uppy.emit("transloadit:execution-progress", details), details.progress_combined != null)
      for (const file of this.uppy.getFiles())
        this.uppy.emit("postprocess-progress", file, {
          mode: "determinate",
          value: details.progress_combined / 100,
          message: this.i18n("encoding")
        });
  }), this.opts.waitForEncoding && assembly.on("result", (stepName, result2) => {
    _classPrivateFieldLooseBase$3(this, _onResult)[_onResult](id2, stepName, result2);
  }), this.opts.waitForEncoding ? assembly.on("finished", () => {
    _classPrivateFieldLooseBase$3(this, _onAssemblyFinished)[_onAssemblyFinished](assembly.status);
  }) : this.opts.waitForMetadata && assembly.on("metadata", () => {
    _classPrivateFieldLooseBase$3(this, _onAssemblyFinished)[_onAssemblyFinished](assembly.status);
  }), assembly.ok === "ASSEMBLY_COMPLETE" || assembly.connect(), assembly;
}
__name(_connectAssembly2, "_connectAssembly2");
Transloadit.VERSION = packageJson$4.version;
Transloadit.COMPANION = COMPANION_URL;
Transloadit.COMPANION_PATTERN = COMPANION_ALLOWED_HOSTS;
const locale = {
  strings: {
    // Shown in the Informer if an upload is being canceled because it stalled for too long.
    uploadStalled: "Upload has not made any progress for %{seconds} seconds. You may want to retry it."
  }
};
function _classPrivateFieldLooseBase$2(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$2, "_classPrivateFieldLooseBase$2");
var id$2 = 0;
function _classPrivateFieldLooseKey$2(name) {
  return "__private_" + id$2++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$2, "_classPrivateFieldLooseKey$2");
const packageJson$3 = {
  version: "3.4.0"
};
function buildResponseError(xhr, err) {
  let error = err;
  return error || (error = new Error("Upload error")), typeof error == "string" && (error = new Error(error)), error instanceof Error || (error = Object.assign(new Error("Upload error"), {
    data: error
  })), isNetworkError(xhr) ? (error = new NetworkError(error, xhr), error) : (error.request = xhr, error);
}
__name(buildResponseError, "buildResponseError");
function setTypeInBlob(file) {
  return file.data.slice(0, file.data.size, file.meta.type);
}
__name(setTypeInBlob, "setTypeInBlob");
var _uploadLocalFile = /* @__PURE__ */ _classPrivateFieldLooseKey$2("uploadLocalFile"), _uploadBundle = /* @__PURE__ */ _classPrivateFieldLooseKey$2("uploadBundle"), _getCompanionClientArgs = /* @__PURE__ */ _classPrivateFieldLooseKey$2("getCompanionClientArgs"), _uploadFiles = /* @__PURE__ */ _classPrivateFieldLooseKey$2("uploadFiles"), _handleUpload = /* @__PURE__ */ _classPrivateFieldLooseKey$2("handleUpload");
const _XHRUpload = class _XHRUpload extends BasePlugin {
  constructor(uppy, _opts) {
    super(uppy, _opts), Object.defineProperty(this, _uploadFiles, {
      value: _uploadFiles2
    }), Object.defineProperty(this, _getCompanionClientArgs, {
      value: _getCompanionClientArgs2
    }), Object.defineProperty(this, _uploadBundle, {
      value: _uploadBundle2
    }), Object.defineProperty(this, _uploadLocalFile, {
      value: _uploadLocalFile2
    }), Object.defineProperty(this, _handleUpload, {
      writable: !0,
      value: /* @__PURE__ */ __name(async (fileIDs) => {
        if (fileIDs.length === 0) {
          this.uppy.log("[XHRUpload] No files to upload!");
          return;
        }
        this.opts.limit === 0 && !this.opts[internalRateLimitedQueue] && this.uppy.log("[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0", "warning"), this.uppy.log("[XHRUpload] Uploading...");
        const files = this.uppy.getFilesByIds(fileIDs), filesFiltered = filterNonFailedFiles(files), filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
        if (this.uppy.emit("upload-start", filesToEmit), this.opts.bundle) {
          if (filesFiltered.some((file) => file.isRemote))
            throw new Error("Can’t upload remote files when the `bundle: true` option is set");
          if (typeof this.opts.headers == "function")
            throw new TypeError("`headers` may not be a function when the `bundle: true` option is set");
          await _classPrivateFieldLooseBase$2(this, _uploadBundle)[_uploadBundle](filesFiltered);
        } else
          await _classPrivateFieldLooseBase$2(this, _uploadFiles)[_uploadFiles](filesFiltered);
      }, "value")
    }), this.type = "uploader", this.id = this.opts.id || "XHRUpload", this.title = "XHRUpload", this.defaultLocale = locale;
    const defaultOptions2 = {
      formData: !0,
      fieldName: _opts.bundle ? "files[]" : "file",
      method: "post",
      allowedMetaFields: null,
      responseUrlFieldName: "url",
      bundle: !1,
      headers: {},
      timeout: 30 * 1e3,
      limit: 5,
      withCredentials: !1,
      responseType: "",
      /**
       * @param {string} responseText the response body string
       */
      getResponseData(responseText) {
        let parsedResponse = {};
        try {
          parsedResponse = JSON.parse(responseText);
        } catch (err) {
          uppy.log(err);
        }
        return parsedResponse;
      },
      /**
       *
       * @param {string} _ the response body string
       * @param {XMLHttpRequest | respObj} response the response object (XHR or similar)
       */
      getResponseError(_2, response) {
        let error = new Error("Upload error");
        return isNetworkError(response) && (error = new NetworkError(error, response)), error;
      },
      /**
       * Check if the response from the upload endpoint indicates that the upload was successful.
       *
       * @param {number} status the response status code
       */
      validateStatus(status) {
        return status >= 200 && status < 300;
      }
    };
    if (this.opts = {
      ...defaultOptions2,
      ..._opts
    }, this.i18nInit(), internalRateLimitedQueue in this.opts ? this.requests = this.opts[internalRateLimitedQueue] : this.requests = new RateLimitedQueue(this.opts.limit), this.opts.bundle && !this.opts.formData)
      throw new Error("`opts.formData` must be true when `opts.bundle` is enabled.");
    if ((_opts == null ? void 0 : _opts.allowedMetaFields) === void 0 && "metaFields" in this.opts)
      throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
    this.uploaderEvents = /* @__PURE__ */ Object.create(null);
  }
  getOptions(file) {
    const overrides = this.uppy.getState().xhrUpload, {
      headers
    } = this.opts, opts = {
      ...this.opts,
      ...overrides || {},
      ...file.xhrUpload || {},
      headers: {}
    };
    return typeof headers == "function" ? opts.headers = headers(file) : Object.assign(opts.headers, this.opts.headers), overrides && Object.assign(opts.headers, overrides.headers), file.xhrUpload && Object.assign(opts.headers, file.xhrUpload.headers), opts;
  }
  // eslint-disable-next-line class-methods-use-this
  addMetadata(formData, meta, opts) {
    (Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta)).forEach((item) => {
      Array.isArray(meta[item]) ? meta[item].forEach((subItem) => formData.append(item, subItem)) : formData.append(item, meta[item]);
    });
  }
  createFormDataUpload(file, opts) {
    const formPost = new FormData();
    this.addMetadata(formPost, file.meta, opts);
    const dataWithUpdatedType = setTypeInBlob(file);
    return file.name ? formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name) : formPost.append(opts.fieldName, dataWithUpdatedType), formPost;
  }
  createBundledUpload(files, opts) {
    const formPost = new FormData(), {
      meta
    } = this.uppy.getState();
    return this.addMetadata(formPost, meta, opts), files.forEach((file) => {
      const options = this.getOptions(file), dataWithUpdatedType = setTypeInBlob(file);
      file.name ? formPost.append(options.fieldName, dataWithUpdatedType, file.name) : formPost.append(options.fieldName, dataWithUpdatedType);
    }), formPost;
  }
  install() {
    if (this.opts.bundle) {
      const {
        capabilities
      } = this.uppy.getState();
      this.uppy.setState({
        capabilities: {
          ...capabilities,
          individualCancellation: !1
        }
      });
    }
    this.uppy.addUploader(_classPrivateFieldLooseBase$2(this, _handleUpload)[_handleUpload]);
  }
  uninstall() {
    if (this.opts.bundle) {
      const {
        capabilities
      } = this.uppy.getState();
      this.uppy.setState({
        capabilities: {
          ...capabilities,
          individualCancellation: !0
        }
      });
    }
    this.uppy.removeUploader(_classPrivateFieldLooseBase$2(this, _handleUpload)[_handleUpload]);
  }
};
__name(_XHRUpload, "XHRUpload");
let XHRUpload = _XHRUpload;
async function _uploadLocalFile2(file, current, total) {
  const opts = this.getOptions(file);
  return this.uppy.log(`uploading ${current} of ${total}`), new Promise((resolve3, reject) => {
    const data = opts.formData ? this.createFormDataUpload(file, opts) : file.data, xhr = new XMLHttpRequest(), eventManager = new EventManager(this.uppy);
    this.uploaderEvents[file.id] = eventManager;
    let queuedRequest;
    const timer = new ProgressTimeout(opts.timeout, () => {
      const error = new Error(this.i18n("uploadStalled", {
        seconds: Math.ceil(opts.timeout / 1e3)
      }));
      this.uppy.emit("upload-stalled", error, [file]);
    }), id2 = nanoid();
    xhr.upload.addEventListener("loadstart", () => {
      this.uppy.log(`[XHRUpload] ${id2} started`);
    }), xhr.upload.addEventListener("progress", (ev) => {
      this.uppy.log(`[XHRUpload] ${id2} progress: ${ev.loaded} / ${ev.total}`), timer.progress(), ev.lengthComputable && this.uppy.emit("upload-progress", file, {
        uploader: this,
        bytesUploaded: ev.loaded,
        bytesTotal: ev.total
      });
    }), xhr.addEventListener("load", () => {
      if (this.uppy.log(`[XHRUpload] ${id2} finished`), timer.done(), queuedRequest.done(), this.uploaderEvents[file.id] && (this.uploaderEvents[file.id].remove(), this.uploaderEvents[file.id] = null), opts.validateStatus(xhr.status, xhr.responseText, xhr)) {
        const body2 = opts.getResponseData(xhr.responseText, xhr), uploadURL = body2[opts.responseUrlFieldName], uploadResp = {
          status: xhr.status,
          body: body2,
          uploadURL
        };
        return this.uppy.emit("upload-success", file, uploadResp), uploadURL && this.uppy.log(`Download ${file.name} from ${uploadURL}`), resolve3(file);
      }
      const body = opts.getResponseData(xhr.responseText, xhr), error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr)), response = {
        status: xhr.status,
        body
      };
      return this.uppy.emit("upload-error", file, error, response), reject(error);
    }), xhr.addEventListener("error", () => {
      this.uppy.log(`[XHRUpload] ${id2} errored`), timer.done(), queuedRequest.done(), this.uploaderEvents[file.id] && (this.uploaderEvents[file.id].remove(), this.uploaderEvents[file.id] = null);
      const error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
      return this.uppy.emit("upload-error", file, error), reject(error);
    }), xhr.open(opts.method.toUpperCase(), opts.endpoint, !0), xhr.withCredentials = opts.withCredentials, opts.responseType !== "" && (xhr.responseType = opts.responseType), queuedRequest = this.requests.run(() => {
      const currentOpts = this.getOptions(file);
      return Object.keys(currentOpts.headers).forEach((header) => {
        xhr.setRequestHeader(header, currentOpts.headers[header]);
      }), xhr.send(data), () => {
        timer.done(), xhr.abort();
      };
    }), eventManager.onFileRemove(file.id, () => {
      queuedRequest.abort(), reject(new Error("File removed"));
    }), eventManager.onCancelAll(file.id, (_ref) => {
      let {
        reason
      } = _ref;
      reason === "user" && queuedRequest.abort(), reject(new Error("Upload cancelled"));
    });
  });
}
__name(_uploadLocalFile2, "_uploadLocalFile2");
function _uploadBundle2(files) {
  return new Promise((resolve3, reject) => {
    const {
      endpoint
    } = this.opts, {
      method
    } = this.opts, optsFromState = this.uppy.getState().xhrUpload, formData = this.createBundledUpload(files, {
      ...this.opts,
      ...optsFromState || {}
    }), xhr = new XMLHttpRequest(), emitError = /* @__PURE__ */ __name((error) => {
      files.forEach((file) => {
        this.uppy.emit("upload-error", file, error);
      });
    }, "emitError"), timer = new ProgressTimeout(this.opts.timeout, () => {
      const error = new Error(this.i18n("uploadStalled", {
        seconds: Math.ceil(this.opts.timeout / 1e3)
      }));
      this.uppy.emit("upload-stalled", error, files);
    });
    xhr.upload.addEventListener("loadstart", () => {
      this.uppy.log("[XHRUpload] started uploading bundle"), timer.progress();
    }), xhr.upload.addEventListener("progress", (ev) => {
      timer.progress(), ev.lengthComputable && files.forEach((file) => {
        this.uppy.emit("upload-progress", file, {
          uploader: this,
          bytesUploaded: ev.loaded / ev.total * file.size,
          bytesTotal: file.size
        });
      });
    }), xhr.addEventListener("load", (ev) => {
      if (timer.done(), this.opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
        const body = this.opts.getResponseData(xhr.responseText, xhr), uploadResp = {
          status: ev.target.status,
          body
        };
        return files.forEach((file) => {
          this.uppy.emit("upload-success", file, uploadResp);
        }), resolve3();
      }
      const error = this.opts.getResponseError(xhr.responseText, xhr) || new Error("Upload error");
      return error.request = xhr, emitError(error), reject(error);
    }), xhr.addEventListener("error", () => {
      timer.done();
      const error = this.opts.getResponseError(xhr.responseText, xhr) || new Error("Upload error");
      return emitError(error), reject(error);
    }), this.uppy.on("cancel-all", function(_temp) {
      let {
        reason
      } = _temp === void 0 ? {} : _temp;
      reason === "user" && (timer.done(), xhr.abort());
    }), xhr.open(method.toUpperCase(), endpoint, !0), xhr.withCredentials = this.opts.withCredentials, this.opts.responseType !== "" && (xhr.responseType = this.opts.responseType), Object.keys(this.opts.headers).forEach((header) => {
      xhr.setRequestHeader(header, this.opts.headers[header]);
    }), xhr.send(formData);
  });
}
__name(_uploadBundle2, "_uploadBundle2");
function _getCompanionClientArgs2(file) {
  const opts = this.getOptions(file), allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(file.meta);
  return {
    ...file.remote.body,
    protocol: "multipart",
    endpoint: opts.endpoint,
    size: file.data.size,
    fieldname: opts.fieldName,
    metadata: Object.fromEntries(allowedMetaFields.map((name) => [name, file.meta[name]])),
    httpMethod: opts.method,
    useFormData: opts.formData,
    headers: opts.headers
  };
}
__name(_getCompanionClientArgs2, "_getCompanionClientArgs2");
async function _uploadFiles2(files) {
  await Promise.allSettled(files.map((file, i2) => {
    const current = parseInt(i2, 10) + 1, total = files.length;
    if (file.isRemote) {
      const Client2 = file.remote.providerOptions.provider ? Provider : RequestClient, getQueue = /* @__PURE__ */ __name(() => this.requests, "getQueue"), client = new Client2(this.uppy, file.remote.providerOptions, getQueue), controller = new AbortController(), removedHandler = /* @__PURE__ */ __name((removedFile) => {
        removedFile.id === file.id && controller.abort();
      }, "removedHandler");
      this.uppy.on("file-removed", removedHandler);
      const uploadPromise = client.uploadRemoteFile(file, _classPrivateFieldLooseBase$2(this, _getCompanionClientArgs)[_getCompanionClientArgs](file), {
        signal: controller.signal
      });
      return this.requests.wrapSyncFunction(() => {
        this.uppy.off("file-removed", removedHandler);
      }, {
        priority: -1
      })(), uploadPromise;
    }
    return _classPrivateFieldLooseBase$2(this, _uploadLocalFile)[_uploadLocalFile](file, current, total);
  }));
}
__name(_uploadFiles2, "_uploadFiles2");
XHRUpload.VERSION = packageJson$3.version;
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */
var canvasToBlob = { exports: {} };
(function(module) {
  typeof window > "u" || function(window2) {
    var CanvasPrototype = window2.HTMLCanvasElement && window2.HTMLCanvasElement.prototype, hasBlobConstructor = window2.Blob && function() {
      try {
        return !!new Blob();
      } catch {
        return !1;
      }
    }(), hasArrayBufferViewSupport = hasBlobConstructor && window2.Uint8Array && function() {
      try {
        return new Blob([new Uint8Array(100)]).size === 100;
      } catch {
        return !1;
      }
    }(), BlobBuilder = window2.BlobBuilder || window2.WebKitBlobBuilder || window2.MozBlobBuilder || window2.MSBlobBuilder, dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/, dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window2.atob && window2.ArrayBuffer && window2.Uint8Array && function(dataURI) {
      var matches2, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i2, bb;
      if (matches2 = dataURI.match(dataURIPattern), !matches2)
        throw new Error("invalid data URI");
      for (mediaType = matches2[2] ? matches2[1] : "text/plain" + (matches2[3] || ";charset=US-ASCII"), isBase64 = !!matches2[4], dataString = dataURI.slice(matches2[0].length), isBase64 ? byteString = atob(dataString) : byteString = decodeURIComponent(dataString), arrayBuffer = new ArrayBuffer(byteString.length), intArray = new Uint8Array(arrayBuffer), i2 = 0; i2 < byteString.length; i2 += 1)
        intArray[i2] = byteString.charCodeAt(i2);
      return hasBlobConstructor ? new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
        type: mediaType
      }) : (bb = new BlobBuilder(), bb.append(arrayBuffer), bb.getBlob(mediaType));
    };
    window2.HTMLCanvasElement && !CanvasPrototype.toBlob && (CanvasPrototype.mozGetAsFile ? CanvasPrototype.toBlob = function(callback, type, quality) {
      var self2 = this;
      setTimeout(function() {
        quality && CanvasPrototype.toDataURL && dataURLtoBlob ? callback(dataURLtoBlob(self2.toDataURL(type, quality))) : callback(self2.mozGetAsFile("blob", type));
      });
    } : CanvasPrototype.toDataURL && dataURLtoBlob && (CanvasPrototype.msToBlob ? CanvasPrototype.toBlob = function(callback, type, quality) {
      var self2 = this;
      setTimeout(function() {
        (type && type !== "image/png" || quality) && CanvasPrototype.toDataURL && dataURLtoBlob ? callback(dataURLtoBlob(self2.toDataURL(type, quality))) : callback(self2.msToBlob(type));
      });
    } : CanvasPrototype.toBlob = function(callback, type, quality) {
      var self2 = this;
      setTimeout(function() {
        callback(dataURLtoBlob(self2.toDataURL(type, quality)));
      });
    })), module.exports ? module.exports = dataURLtoBlob : window2.dataURLtoBlob = dataURLtoBlob;
  }(window);
})(canvasToBlob);
function _extends() {
  return _extends = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
__name(_extends, "_extends");
var NODE_LIST_CLASSES = {
  "[object HTMLCollection]": !0,
  "[object NodeList]": !0,
  "[object RadioNodeList]": !0
}, IGNORED_ELEMENT_TYPES = {
  button: !0,
  fieldset: !0,
  reset: !0,
  submit: !0
}, CHECKED_INPUT_TYPES = {
  checkbox: !0,
  radio: !0
}, TRIM_RE = /^\s+|\s+$/g, slice = Array.prototype.slice, toString$1 = Object.prototype.toString;
function getFormData(form, options) {
  if (!form)
    throw new Error("A form is required by getFormData, was given form=" + form);
  options = _extends({
    includeDisabled: !1,
    trim: !1
  }, options);
  for (var data = {}, elementName, elementNames = [], elementNameLookup = {}, i2 = 0, l2 = form.elements.length; i2 < l2; i2++) {
    var element = form.elements[i2];
    IGNORED_ELEMENT_TYPES[element.type] || element.disabled && !options.includeDisabled || (elementName = element.name || element.id, elementName && !elementNameLookup[elementName] && (elementNames.push(elementName), elementNameLookup[elementName] = !0));
  }
  for (var _i = 0, _l = elementNames.length; _i < _l; _i++) {
    elementName = elementNames[_i];
    var value = getFieldData(form, elementName, options);
    value != null && (data[elementName] = value);
  }
  return data;
}
__name(getFormData, "getFormData");
function getFieldData(form, fieldName, options) {
  if (!form)
    throw new Error("A form is required by getFieldData, was given form=" + form);
  if (!fieldName && toString$1.call(fieldName) !== "[object String]")
    throw new Error("A field name is required by getFieldData, was given fieldName=" + fieldName);
  options = _extends({
    includeDisabled: !1,
    trim: !1
  }, options);
  var element = form.elements[fieldName];
  if (!element || element.disabled && !options.includeDisabled)
    return null;
  if (!NODE_LIST_CLASSES[toString$1.call(element)])
    return getFormElementValue(element, options.trim);
  for (var data = [], allRadios = !0, i2 = 0, l2 = element.length; i2 < l2; i2++)
    if (!(element[i2].disabled && !options.includeDisabled)) {
      allRadios && element[i2].type !== "radio" && (allRadios = !1);
      var value = getFormElementValue(element[i2], options.trim);
      value != null && (data = data.concat(value));
    }
  return allRadios && data.length === 1 ? data[0] : data.length > 0 ? data : null;
}
__name(getFieldData, "getFieldData");
function getFormElementValue(element, trim2) {
  var value = null, type = element.type;
  if (type === "select-one")
    return element.options.length && (value = element.options[element.selectedIndex].value), value;
  if (type === "select-multiple") {
    value = [];
    for (var i2 = 0, l2 = element.options.length; i2 < l2; i2++)
      element.options[i2].selected && value.push(element.options[i2].value);
    return value.length === 0 && (value = null), value;
  }
  return type === "file" && "files" in element ? (element.multiple ? (value = slice.call(element.files), value.length === 0 && (value = null)) : value = element.files[0], value) : (CHECKED_INPUT_TYPES[type] ? element.checked && (type === "checkbox" && !element.hasAttribute("value") ? value = !0 : value = element.value) : value = trim2 ? element.value.replace(TRIM_RE, "") : element.value, value);
}
__name(getFormElementValue, "getFormElementValue");
getFormData.getFieldData = getFieldData;
const packageJson$2 = {
  version: "3.0.2"
}, _Form = class _Form extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.type = "acquirer", this.id = this.opts.id || "Form", this.title = "Form";
    const defaultOptions2 = {
      target: null,
      resultName: "uppyResult",
      getMetaFromForm: !0,
      addResultToForm: !0,
      submitOnSuccess: !1,
      triggerUploadOnSubmit: !1
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.handleFormSubmit = this.handleFormSubmit.bind(this), this.handleUploadStart = this.handleUploadStart.bind(this), this.handleSuccess = this.handleSuccess.bind(this), this.addResultToForm = this.addResultToForm.bind(this), this.getMetaFromForm = this.getMetaFromForm.bind(this);
  }
  handleUploadStart() {
    this.opts.getMetaFromForm && this.getMetaFromForm();
  }
  handleSuccess(result2) {
    this.opts.addResultToForm && this.addResultToForm(result2), this.opts.submitOnSuccess && this.form.submit();
  }
  handleFormSubmit(ev) {
    if (this.opts.triggerUploadOnSubmit) {
      ev.preventDefault();
      const elements = toArray$3(ev.target.elements), disabledByUppy = [];
      elements.forEach((el) => {
        (el.tagName === "BUTTON" || el.tagName === "INPUT" && el.type === "submit") && !el.disabled && (el.disabled = !0, disabledByUppy.push(el));
      }), this.uppy.upload().then(() => {
        disabledByUppy.forEach((button) => {
          button.disabled = !1;
        });
      }, (err) => (disabledByUppy.forEach((button) => {
        button.disabled = !1;
      }), Promise.reject(err))).catch((err) => {
        this.uppy.log(err.stack || err.message || err);
      });
    }
  }
  addResultToForm(result2) {
    this.uppy.log("[Form] Adding result to the original form:"), this.uppy.log(result2);
    let resultInput = this.form.querySelector(`[name="${this.opts.resultName}"]`);
    if (resultInput) {
      let updatedResult;
      try {
        updatedResult = JSON.parse(resultInput.value);
      } catch {
      }
      Array.isArray(updatedResult) || (updatedResult = []), updatedResult.push(result2), resultInput.value = JSON.stringify(updatedResult);
      return;
    }
    resultInput = document.createElement("input"), resultInput.name = this.opts.resultName, resultInput.type = "hidden", resultInput.value = JSON.stringify([result2]), this.form.appendChild(resultInput);
  }
  getMetaFromForm() {
    const formMeta = getFormData(this.form);
    delete formMeta[this.opts.resultName], this.uppy.setMeta(formMeta);
  }
  install() {
    if (this.form = findDOMElement(this.opts.target), !this.form || this.form.nodeName !== "FORM") {
      this.uppy.log("Form plugin requires a <form> target element passed in options to operate, none was found", "error");
      return;
    }
    this.form.addEventListener("submit", this.handleFormSubmit), this.uppy.on("upload", this.handleUploadStart), this.uppy.on("complete", this.handleSuccess);
  }
  uninstall() {
    this.form.removeEventListener("submit", this.handleFormSubmit), this.uppy.off("upload", this.handleUploadStart), this.uppy.off("complete", this.handleSuccess);
  }
};
__name(_Form, "Form");
let Form = _Form;
Form.VERSION = packageJson$2.version;
function _classPrivateFieldLooseBase$1(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase$1, "_classPrivateFieldLooseBase$1");
var id$1 = 0;
function _classPrivateFieldLooseKey$1(name) {
  return "__private_" + id$1++ + "_" + name;
}
__name(_classPrivateFieldLooseKey$1, "_classPrivateFieldLooseKey$1");
const isSupported$1 = typeof navigator < "u" && "serviceWorker" in navigator;
function waitForServiceWorker() {
  return new Promise((resolve3, reject) => {
    isSupported$1 ? navigator.serviceWorker.controller ? resolve3() : navigator.serviceWorker.addEventListener("controllerchange", () => {
      resolve3();
    }) : reject(new Error("Unsupported"));
  });
}
__name(waitForServiceWorker, "waitForServiceWorker");
var _ready$1 = /* @__PURE__ */ _classPrivateFieldLooseKey$1("ready");
const _ServiceWorkerStore = class _ServiceWorkerStore {
  constructor(opts) {
    Object.defineProperty(this, _ready$1, {
      writable: !0,
      value: void 0
    }), _classPrivateFieldLooseBase$1(this, _ready$1)[_ready$1] = waitForServiceWorker().then((val) => {
      _classPrivateFieldLooseBase$1(this, _ready$1)[_ready$1] = val;
    }), this.name = opts.storeName;
  }
  get ready() {
    return Promise.resolve(_classPrivateFieldLooseBase$1(this, _ready$1)[_ready$1]);
  }
  // TODO: remove this setter in the next major
  set ready(val) {
    _classPrivateFieldLooseBase$1(this, _ready$1)[_ready$1] = val;
  }
  async list() {
    return await _classPrivateFieldLooseBase$1(this, _ready$1)[_ready$1], new Promise((resolve3, reject) => {
      const onMessage = /* @__PURE__ */ __name((event) => {
        if (event.data.store === this.name)
          switch (event.data.type) {
            case "uppy/ALL_FILES":
              resolve3(event.data.files), navigator.serviceWorker.removeEventListener("message", onMessage);
              break;
            default:
              reject();
          }
      }, "onMessage");
      navigator.serviceWorker.addEventListener("message", onMessage), navigator.serviceWorker.controller.postMessage({
        type: "uppy/GET_FILES",
        store: this.name
      });
    });
  }
  async put(file) {
    await _classPrivateFieldLooseBase$1(this, _ready$1)[_ready$1], navigator.serviceWorker.controller.postMessage({
      type: "uppy/ADD_FILE",
      store: this.name,
      file
    });
  }
  async delete(fileID) {
    await _classPrivateFieldLooseBase$1(this, _ready$1)[_ready$1], navigator.serviceWorker.controller.postMessage({
      type: "uppy/REMOVE_FILE",
      store: this.name,
      fileID
    });
  }
};
__name(_ServiceWorkerStore, "ServiceWorkerStore");
let ServiceWorkerStore = _ServiceWorkerStore;
ServiceWorkerStore.isSupported = isSupported$1;
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey))
    throw new TypeError("attempted to use private field on non-instance");
  return receiver;
}
__name(_classPrivateFieldLooseBase, "_classPrivateFieldLooseBase");
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
__name(_classPrivateFieldLooseKey, "_classPrivateFieldLooseKey");
const indexedDB = typeof window < "u" && (window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.OIndexedDB || window.msIndexedDB), isSupported = !!indexedDB, DB_NAME = "uppy-blobs", STORE_NAME = "files", DEFAULT_EXPIRY = 24 * 60 * 60 * 1e3, DB_VERSION = 3, MiB = 1048576;
function migrateExpiration(store) {
  const request = store.openCursor();
  request.onsuccess = (event) => {
    const cursor = event.target.result;
    if (!cursor)
      return;
    const entry = cursor.value;
    entry.expires = Date.now() + DEFAULT_EXPIRY, cursor.update(entry);
  };
}
__name(migrateExpiration, "migrateExpiration");
function connect(dbName) {
  const request = indexedDB.open(dbName, DB_VERSION);
  return new Promise((resolve3, reject) => {
    request.onupgradeneeded = (event) => {
      const db = event.target.result, {
        transaction
      } = event.currentTarget;
      if (event.oldVersion < 2 && db.createObjectStore(STORE_NAME, {
        keyPath: "id"
      }).createIndex("store", "store", {
        unique: !1
      }), event.oldVersion < 3) {
        const store = transaction.objectStore(STORE_NAME);
        store.createIndex("expires", "expires", {
          unique: !1
        }), migrateExpiration(store);
      }
      transaction.oncomplete = () => {
        resolve3(db);
      };
    }, request.onsuccess = (event) => {
      resolve3(event.target.result);
    }, request.onerror = reject;
  });
}
__name(connect, "connect");
function waitForRequest(request) {
  return new Promise((resolve3, reject) => {
    request.onsuccess = (event) => {
      resolve3(event.target.result);
    }, request.onerror = reject;
  });
}
__name(waitForRequest, "waitForRequest");
let cleanedUp$1 = !1;
var _ready = /* @__PURE__ */ _classPrivateFieldLooseKey("ready");
const _IndexedDBStore = class _IndexedDBStore {
  constructor(opts) {
    Object.defineProperty(this, _ready, {
      writable: !0,
      value: void 0
    }), this.opts = {
      dbName: DB_NAME,
      storeName: "default",
      expires: DEFAULT_EXPIRY,
      // 24 hours
      maxFileSize: 10 * MiB,
      maxTotalSize: 300 * MiB,
      ...opts
    }, this.name = this.opts.storeName;
    const createConnection = /* @__PURE__ */ __name(async () => {
      const db = await connect(this.opts.dbName);
      return _classPrivateFieldLooseBase(this, _ready)[_ready] = db, db;
    }, "createConnection");
    cleanedUp$1 ? _classPrivateFieldLooseBase(this, _ready)[_ready] = createConnection() : (cleanedUp$1 = !0, _classPrivateFieldLooseBase(this, _ready)[_ready] = _IndexedDBStore.cleanup().then(createConnection, createConnection));
  }
  get ready() {
    return Promise.resolve(_classPrivateFieldLooseBase(this, _ready)[_ready]);
  }
  // TODO: remove this setter in the next major
  set ready(val) {
    _classPrivateFieldLooseBase(this, _ready)[_ready] = val;
  }
  key(fileID) {
    return `${this.name}!${fileID}`;
  }
  /**
   * List all file blobs currently in the store.
   */
  async list() {
    const request = (await _classPrivateFieldLooseBase(this, _ready)[_ready]).transaction([STORE_NAME], "readonly").objectStore(STORE_NAME).index("store").getAll(IDBKeyRange.only(this.name)), files = await waitForRequest(request);
    return Object.fromEntries(files.map((file) => [file.fileID, file.data]));
  }
  /**
   * Get one file blob from the store.
   */
  async get(fileID) {
    const request = (await _classPrivateFieldLooseBase(this, _ready)[_ready]).transaction([STORE_NAME], "readonly").objectStore(STORE_NAME).get(this.key(fileID)), {
      data
    } = await waitForRequest(request);
    return {
      id: data.fileID,
      data: data.data
    };
  }
  /**
   * Get the total size of all stored files.
   *
   * @private
   * @returns {Promise<number>}
   */
  async getSize() {
    const request = (await _classPrivateFieldLooseBase(this, _ready)[_ready]).transaction([STORE_NAME], "readonly").objectStore(STORE_NAME).index("store").openCursor(IDBKeyRange.only(this.name));
    return new Promise((resolve3, reject) => {
      let size = 0;
      request.onsuccess = (event) => {
        const cursor = event.target.result;
        cursor ? (size += cursor.value.data.size, cursor.continue()) : resolve3(size);
      }, request.onerror = () => {
        reject(new Error("Could not retrieve stored blobs size"));
      };
    });
  }
  /**
   * Save a file in the store.
   */
  async put(file) {
    if (file.data.size > this.opts.maxFileSize)
      throw new Error("File is too big to store.");
    if (await this.getSize() > this.opts.maxTotalSize)
      throw new Error("No space left");
    const request = _classPrivateFieldLooseBase(this, _ready)[_ready].transaction([STORE_NAME], "readwrite").objectStore(STORE_NAME).add({
      id: this.key(file.id),
      fileID: file.id,
      store: this.name,
      expires: Date.now() + this.opts.expires,
      data: file.data
    });
    return waitForRequest(request);
  }
  /**
   * Delete a file blob from the store.
   */
  async delete(fileID) {
    const request = (await _classPrivateFieldLooseBase(this, _ready)[_ready]).transaction([STORE_NAME], "readwrite").objectStore(STORE_NAME).delete(this.key(fileID));
    return waitForRequest(request);
  }
  /**
   * Delete all stored blobs that have an expiry date that is before Date.now().
   * This is a static method because it deletes expired blobs from _all_ Uppy instances.
   */
  static async cleanup() {
    const db = await connect(DB_NAME), request = db.transaction([STORE_NAME], "readwrite").objectStore(STORE_NAME).index("expires").openCursor(IDBKeyRange.upperBound(Date.now()));
    await new Promise((resolve3, reject) => {
      request.onsuccess = (event) => {
        const cursor = event.target.result;
        cursor ? (cursor.delete(), cursor.continue()) : resolve3();
      }, request.onerror = reject;
    }), db.close();
  }
};
__name(_IndexedDBStore, "IndexedDBStore");
let IndexedDBStore = _IndexedDBStore;
IndexedDBStore.isSupported = isSupported;
function findUppyInstances() {
  const instances = [];
  for (let i2 = 0; i2 < localStorage.length; i2++) {
    const key = localStorage.key(i2);
    key.startsWith("uppyState:") && instances.push(key.slice(10));
  }
  return instances;
}
__name(findUppyInstances, "findUppyInstances");
function maybeParse(str) {
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
}
__name(maybeParse, "maybeParse");
let cleanedUp = !1;
const _MetaDataStore = class _MetaDataStore {
  constructor(opts) {
    this.opts = {
      expires: 24 * 60 * 60 * 1e3,
      // 24 hours
      ...opts
    }, this.name = `uppyState:${opts.storeName}`, cleanedUp || (cleanedUp = !0, _MetaDataStore.cleanup());
  }
  /**
   *
   */
  load() {
    const savedState = localStorage.getItem(this.name);
    if (!savedState) return null;
    const data = maybeParse(savedState);
    return data ? data.metadata ? data.metadata : (this.save(data), data) : null;
  }
  save(metadata) {
    const expires = Date.now() + this.opts.expires, state = JSON.stringify({
      metadata,
      expires
    });
    localStorage.setItem(this.name, state);
  }
  /**
   * Remove all expired state.
   */
  static cleanup(instanceID) {
    if (instanceID) {
      localStorage.removeItem(`uppyState:${instanceID}`);
      return;
    }
    const instanceIDs = findUppyInstances(), now2 = Date.now();
    instanceIDs.forEach((id2) => {
      const data = localStorage.getItem(`uppyState:${id2}`);
      if (!data) return;
      const obj = maybeParse(data);
      obj && obj.expires && obj.expires < now2 && localStorage.removeItem(`uppyState:${id2}`);
    });
  }
};
__name(_MetaDataStore, "MetaDataStore");
let MetaDataStore = _MetaDataStore;
const packageJson$1 = {
  version: "3.1.0"
}, _GoldenRetriever = class _GoldenRetriever extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.addBlobToStores = (file) => {
      file.isRemote || (this.ServiceWorkerStore && this.ServiceWorkerStore.put(file).catch((err) => {
        this.uppy.log("[GoldenRetriever] Could not store file", "warning"), this.uppy.log(err);
      }), this.IndexedDBStore.put(file).catch((err) => {
        this.uppy.log("[GoldenRetriever] Could not store file", "warning"), this.uppy.log(err);
      }));
    }, this.removeBlobFromStores = (file) => {
      this.ServiceWorkerStore && this.ServiceWorkerStore.delete(file.id).catch((err) => {
        this.uppy.log("[GoldenRetriever] Failed to remove file", "warning"), this.uppy.log(err);
      }), this.IndexedDBStore.delete(file.id).catch((err) => {
        this.uppy.log("[GoldenRetriever] Failed to remove file", "warning"), this.uppy.log(err);
      });
    }, this.replaceBlobInStores = (file) => {
      this.removeBlobFromStores(file), this.addBlobToStores(file);
    }, this.handleRestoreConfirmed = () => {
      this.uppy.log("[GoldenRetriever] Restore confirmed, proceeding...");
      const {
        currentUploads
      } = this.uppy.getState();
      currentUploads && (this.uppy.resumeAll(), Object.keys(currentUploads).forEach((uploadId) => {
        this.uppy.restore(uploadId, currentUploads[uploadId]);
      })), this.uppy.setState({
        recoveredState: null
      });
    }, this.abortRestore = () => {
      this.uppy.log("[GoldenRetriever] Aborting restore...");
      const fileIDs = Object.keys(this.uppy.getState().files);
      this.deleteBlobs(fileIDs).then(() => {
        this.uppy.log(`[GoldenRetriever] Removed ${fileIDs.length} files`);
      }).catch((err) => {
        this.uppy.log(`[GoldenRetriever] Could not remove ${fileIDs.length} files`, "warning"), this.uppy.log(err);
      }), this.uppy.cancelAll(), this.uppy.setState({
        recoveredState: null
      }), MetaDataStore.cleanup(this.uppy.opts.id);
    }, this.handleComplete = (_ref) => {
      let {
        successful
      } = _ref;
      const fileIDs = successful.map((file) => file.id);
      this.deleteBlobs(fileIDs).then(() => {
        this.uppy.log(`[GoldenRetriever] Removed ${successful.length} files that finished uploading`);
      }).catch((err) => {
        this.uppy.log(`[GoldenRetriever] Could not remove ${successful.length} files that finished uploading`, "warning"), this.uppy.log(err);
      }), this.uppy.setState({
        recoveredState: null
      }), MetaDataStore.cleanup(this.uppy.opts.id);
    }, this.restoreBlobs = () => {
      this.uppy.getFiles().length > 0 ? Promise.all([this.loadFileBlobsFromServiceWorker(), this.loadFileBlobsFromIndexedDB()]).then((resultingArrayOfObjects) => {
        const blobs = {
          ...resultingArrayOfObjects[0],
          ...resultingArrayOfObjects[1]
        };
        this.onBlobsLoaded(blobs);
      }) : this.uppy.log("[GoldenRetriever] No files need to be loaded, only restoring processing state...");
    }, this.type = "debugger", this.id = this.opts.id || "GoldenRetriever", this.title = "Golden Retriever";
    const defaultOptions2 = {
      expires: 24 * 60 * 60 * 1e3,
      // 24 hours
      serviceWorker: !1
    };
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.MetaDataStore = new MetaDataStore({
      expires: this.opts.expires,
      storeName: uppy.getID()
    }), this.ServiceWorkerStore = null, this.opts.serviceWorker && (this.ServiceWorkerStore = new ServiceWorkerStore({
      storeName: uppy.getID()
    })), this.IndexedDBStore = new IndexedDBStore({
      expires: this.opts.expires,
      ...this.opts.indexedDB || {},
      storeName: uppy.getID()
    }), this.saveFilesStateToLocalStorage = throttle$2(this.saveFilesStateToLocalStorage.bind(this), 500, {
      leading: !0,
      trailing: !0
    }), this.restoreState = this.restoreState.bind(this), this.loadFileBlobsFromServiceWorker = this.loadFileBlobsFromServiceWorker.bind(this), this.loadFileBlobsFromIndexedDB = this.loadFileBlobsFromIndexedDB.bind(this), this.onBlobsLoaded = this.onBlobsLoaded.bind(this);
  }
  restoreState() {
    const savedState = this.MetaDataStore.load();
    savedState && (this.uppy.log("[GoldenRetriever] Recovered some state from Local Storage"), this.uppy.setState({
      currentUploads: savedState.currentUploads || {},
      files: savedState.files || {},
      recoveredState: savedState
    }), this.savedPluginData = savedState.pluginData);
  }
  /**
   * Get file objects that are currently waiting: they've been selected,
   * but aren't yet being uploaded.
   */
  getWaitingFiles() {
    const waitingFiles = {};
    return this.uppy.getFiles().forEach((file) => {
      (!file.progress || !file.progress.uploadStarted) && (waitingFiles[file.id] = file);
    }), waitingFiles;
  }
  /**
   * Get file objects that are currently being uploaded. If a file has finished
   * uploading, but the other files in the same batch have not, the finished
   * file is also returned.
   */
  getUploadingFiles() {
    const uploadingFiles = {}, {
      currentUploads
    } = this.uppy.getState();
    return currentUploads && Object.keys(currentUploads).forEach((uploadID) => {
      currentUploads[uploadID].fileIDs.forEach((fileID) => {
        uploadingFiles[fileID] = this.uppy.getFile(fileID);
      });
    }), uploadingFiles;
  }
  saveFilesStateToLocalStorage() {
    const filesToSave = {
      ...this.getWaitingFiles(),
      ...this.getUploadingFiles()
    }, fileToSaveEntries = Object.entries(filesToSave);
    if (fileToSaveEntries.length === 0) {
      this.uppy.getState().recoveredState !== null && this.uppy.setState({
        recoveredState: null
      }), MetaDataStore.cleanup(this.uppy.opts.id);
      return;
    }
    const filesToSaveWithoutData = Object.fromEntries(fileToSaveEntries.map((_ref2) => {
      let [id2, fileInfo] = _ref2;
      return [id2, fileInfo.isRemote ? {
        ...fileInfo,
        isRestored: !0
      } : {
        ...fileInfo,
        isRestored: !0,
        data: null,
        preview: null
      }];
    })), pluginData = {};
    this.uppy.emit("restore:get-data", (data) => {
      Object.assign(pluginData, data);
    });
    const {
      currentUploads
    } = this.uppy.getState();
    this.MetaDataStore.save({
      currentUploads,
      files: filesToSaveWithoutData,
      pluginData
    });
  }
  loadFileBlobsFromServiceWorker() {
    return this.ServiceWorkerStore ? this.ServiceWorkerStore.list().then((blobs) => {
      const numberOfFilesRecovered = Object.keys(blobs).length;
      return numberOfFilesRecovered > 0 ? (this.uppy.log(`[GoldenRetriever] Successfully recovered ${numberOfFilesRecovered} blobs from Service Worker!`), blobs) : (this.uppy.log("[GoldenRetriever] No blobs found in Service Worker, trying IndexedDB now..."), {});
    }).catch((err) => (this.uppy.log("[GoldenRetriever] Failed to recover blobs from Service Worker", "warning"), this.uppy.log(err), {})) : Promise.resolve({});
  }
  loadFileBlobsFromIndexedDB() {
    return this.IndexedDBStore.list().then((blobs) => {
      const numberOfFilesRecovered = Object.keys(blobs).length;
      return numberOfFilesRecovered > 0 ? (this.uppy.log(`[GoldenRetriever] Successfully recovered ${numberOfFilesRecovered} blobs from IndexedDB!`), blobs) : (this.uppy.log("[GoldenRetriever] No blobs found in IndexedDB"), {});
    }).catch((err) => (this.uppy.log("[GoldenRetriever] Failed to recover blobs from IndexedDB", "warning"), this.uppy.log(err), {}));
  }
  onBlobsLoaded(blobs) {
    const obsoleteBlobs = [], updatedFiles = {
      ...this.uppy.getState().files
    };
    Object.keys(blobs).forEach((fileID) => {
      const originalFile = this.uppy.getFile(fileID);
      if (!originalFile) {
        obsoleteBlobs.push(fileID);
        return;
      }
      const updatedFileData = {
        data: blobs[fileID],
        isRestored: !0,
        isGhost: !1
      };
      updatedFiles[fileID] = {
        ...originalFile,
        ...updatedFileData
      };
    }), Object.keys(updatedFiles).forEach((fileID) => {
      updatedFiles[fileID].data === null && (updatedFiles[fileID] = {
        ...updatedFiles[fileID],
        isGhost: !0
      });
    }), this.uppy.setState({
      files: updatedFiles
    }), this.uppy.emit("restored", this.savedPluginData), obsoleteBlobs.length && this.deleteBlobs(obsoleteBlobs).then(() => {
      this.uppy.log(`[GoldenRetriever] Cleaned up ${obsoleteBlobs.length} old files`);
    }).catch((err) => {
      this.uppy.log(`[GoldenRetriever] Could not clean up ${obsoleteBlobs.length} old files`, "warning"), this.uppy.log(err);
    });
  }
  deleteBlobs(fileIDs) {
    return Promise.all(fileIDs.map((id2) => {
      var _this$ServiceWorkerSt, _this$ServiceWorkerSt2, _this$IndexedDBStore;
      return (_this$ServiceWorkerSt = (_this$ServiceWorkerSt2 = this.ServiceWorkerStore) == null ? void 0 : _this$ServiceWorkerSt2.delete(id2)) != null ? _this$ServiceWorkerSt : (_this$IndexedDBStore = this.IndexedDBStore) == null ? void 0 : _this$IndexedDBStore.delete(id2);
    }));
  }
  install() {
    this.restoreState(), this.restoreBlobs(), this.uppy.on("file-added", this.addBlobToStores), this.uppy.on("file-editor:complete", this.replaceBlobInStores), this.uppy.on("file-removed", this.removeBlobFromStores), this.uppy.on("state-update", this.saveFilesStateToLocalStorage), this.uppy.on("restore-confirmed", this.handleRestoreConfirmed), this.uppy.on("restore-canceled", this.abortRestore), this.uppy.on("complete", this.handleComplete);
  }
  uninstall() {
    this.uppy.off("file-added", this.addBlobToStores), this.uppy.off("file-editor:complete", this.replaceBlobInStores), this.uppy.off("file-removed", this.removeBlobFromStores), this.uppy.off("state-update", this.saveFilesStateToLocalStorage), this.uppy.off("restore-confirmed", this.handleRestoreConfirmed), this.uppy.off("restore-canceled", this.abortRestore), this.uppy.off("complete", this.handleComplete);
  }
};
__name(_GoldenRetriever, "GoldenRetriever");
let GoldenRetriever = _GoldenRetriever;
GoldenRetriever.VERSION = packageJson$1.version;
const packageJson = {
  version: "3.0.3"
}, _ReduxDevTools = class _ReduxDevTools extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts), this.type = "debugger", this.id = this.opts.id || "ReduxDevTools", this.title = "Redux DevTools";
    const defaultOptions2 = {};
    this.opts = {
      ...defaultOptions2,
      ...opts
    }, this.handleStateChange = this.handleStateChange.bind(this), this.initDevTools = this.initDevTools.bind(this);
  }
  handleStateChange(prevState, nextState) {
    this.devTools.send("UPPY_STATE_UPDATE", nextState);
  }
  initDevTools() {
    this.devTools = window.devToolsExtension.connect(), this.devToolsUnsubscribe = this.devTools.subscribe((message) => {
      if (message.type === "DISPATCH")
        switch (message.payload.type) {
          case "RESET":
            this.uppy.cancelAll();
            return;
          case "IMPORT_STATE": {
            const {
              computedStates
            } = message.payload.nextLiftedState;
            this.uppy.store.state = {
              ...this.uppy.getState(),
              ...computedStates[computedStates.length - 1].state
            }, this.uppy.updateAll(this.uppy.getState());
            return;
          }
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            this.uppy.store.state = {
              ...this.uppy.getState(),
              ...JSON.parse(message.state)
            }, this.uppy.updateAll(this.uppy.getState());
            break;
        }
    });
  }
  install() {
    this.withDevTools = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__, this.withDevTools && (this.initDevTools(), this.uppy.on("state-update", this.handleStateChange));
  }
  uninstall() {
    this.withDevTools && (this.devToolsUnsubscribe(), this.uppy.off("state-update", this.handleStateUpdate));
  }
};
__name(_ReduxDevTools, "ReduxDevTools");
let ReduxDevTools = _ReduxDevTools;
ReduxDevTools.VERSION = packageJson.version;
Transloadit.COMPANION_URL = COMPANION_URL;
Transloadit.COMPANION_ALLOWED_HOSTS = COMPANION_ALLOWED_HOSTS;
gql(`
  query BucketAndRegion {
    bucketAndRegion {
      region
      bucket
    }
  }
`);
gql(`
  query MultipartUploadId($key: String!, $bucket: String!) {
    multipartUploadId(key: $key, bucket: $bucket)
  }
`);
gql(`
  query AbortMultipartUpload($key: String!, $bucket: String!, $uploadId: String!) {
    abortMultipartUpload(key: $key, bucket: $bucket, uploadId: $uploadId)
  }
`);
gql(`
  query PresignedMultipartUrl($key: String!, $partNumber: Float!, $uploadId: String!) {
    presignedMultipartUrl(key: $key, partNumber: $partNumber, uploadId: $uploadId)
  }
`);
gql(`
  query ListUploadParts($key: String!, $bucket: String!, $uploadId: String!) {
    listUploadParts(key: $key, bucket: $bucket, uploadId: $uploadId) {
      PartNumber
      ETag
      Size
    }
  }
`);
gql(`
  query CompleteMultipartUploadQuery(
    $key: String!
    $bucket: String!
    $uploadId: String!
    $parts: [PartInput!]!
  ) {
    completeMultipartUpload(bucket: $bucket, key: $key, uploadId: $uploadId, parts: $parts)
  }
`);
const FIND_DATA_IMPORT_REQUEST_BY_DATA_IMPORT_REQUEST_ID = gql(`
  query FindDataImportRequestByDataImportRequestId($dataImportRequestId: ID!) {
    findDataImportRequestByDataImportRequestId(id: $dataImportRequestId) {
      rootFolderImportRequestId
    } 
  }
`), ACCOUNT_BY_CONTEXT = gql(`
  query AccountByContext {
    accountByContext {
      id
    }
  }
`), LIST_MULTIPART_UPLOAD_PARTS = gql(`
  query listPartsForMultipartUpload(
    $bucket: String!
    $key: String!
    $uploadId: String!
  ) {
    listPartsForMultipartUpload(
      bucket: $bucket
      key: $key
      uploadId: $uploadId
    ) {
      ETag
      PartNumber
      Size
    }
  }
`), COUNT_FILE_IMPORT_REQUESTS_BY_DATA_IMPORT_REQUEST_ID = gql(`
query CountFileImportRequestsByDataImportRequestId($dataImportRequestId: String!, $fileKind: String) {
  countFileImportRequestsByDataImportRequestId(
      dataImportRequestId: $dataImportRequestId
      fileKind: $fileKind
  )
}
`), FIND_FILE_IMPORT_REQUESTS_BY_DATA_IMPORT_REQUEST_ID = gql(`
query FindFileImportRequestsByDataImportRequestId($dataImportRequestId: String!, $fileKind: String, $start: Int, $size: Int) {
  findFileImportRequestsByDataImportRequestId(
      dataImportRequestId: $dataImportRequestId
      fileKind: $fileKind
      start: $start
      size: $size
  ) {
      id
      kind
      fileId
  }
}
`), LIST_MULTIPART_UPLOAD_PARTS_FOR_FILE_IMPORT_REQUEST = gql(`
  query listPartsForMultipartUploadForFileImportRequest(
    $bucket: String!
    $key: String!
    $uploadId: String!
  ) {
    listPartsForMultipartUploadForFileImportRequest(
      bucket: $bucket
      key: $key
      uploadId: $uploadId
    ) {
      ETag
      PartNumber
      Size
    }
  }
`), useMultipart = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext), createUpload = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_MULTIPART_UPLOAD, variables), "mutationFn")
  }), abortUpload = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(ABORT_MULTIPART_UPLOAD, variables), "mutationFn")
  }), listParts = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(LIST_MULTIPART_UPLOAD_PARTS, variables), "mutationFn")
  }), completeUpload = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(COMPLETE_MULTIPART_UPLOAD, variables), "mutationFn")
  }), createPresignedUrl = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_PRESIGNED_UPLOAD_PART_URL, variables), "mutationFn")
  }), createUploadForFileImportRequest = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_MULTIPART_UPLOAD_FOR_FILE_IMPORT_REQUEST, variables), "mutationFn")
  }), abortUploadForFileImportRequest = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(ABORT_MULTIPART_UPLOAD_FOR_FILE_IMPORT_REQUEST, variables), "mutationFn")
  }), listPartsForFileImportRequest = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(LIST_MULTIPART_UPLOAD_PARTS_FOR_FILE_IMPORT_REQUEST, variables), "mutationFn")
  }), completeUploadForFileImportRequest = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(COMPLETE_MULTIPART_UPLOAD_FOR_FILE_IMPORT_REQUEST, variables), "mutationFn")
  }), createPresignedUrlForFileImportRequest = useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_PRESIGNED_UPLOAD_PART_URL_FOR_FILE_IMPORT_REQUEST, variables), "mutationFn")
  });
  return {
    abortUpload,
    abortUploadForFileImportRequest,
    completeUpload,
    completeUploadForFileImportRequest,
    createPresignedUrl,
    createPresignedUrlForFileImportRequest,
    createUpload,
    createUploadForFileImportRequest,
    listParts,
    listPartsForFileImportRequest
  };
}, "useMultipart"), _512MB$1 = 512 * 1024 * 1024, useUppyForSimpleUploader = /* @__PURE__ */ __name((options) => {
  const { createUpload, listParts, createPresignedUrl, completeUpload, abortUpload } = useMultipart(), uppy = useState(/* @__PURE__ */ __name(() => new Uppy(), "initialize"))[0];
  return useEffect(() => (uppy.use(AwsS3Multipart, {
    shouldUseMultipart: !0,
    getChunkSize: options.chunkSize ? () => options.chunkSize ?? _512MB$1 : void 0,
    createMultipartUpload: /* @__PURE__ */ __name(async (file) => {
      const response = await createUpload.mutateAsync({ fileName: file.name }), { bucket, fileId, key, uploadId } = response.createMultipartUpload ?? {};
      assertIsString(bucket, "bucket is not a string"), assertIsString(fileId, "fileId is not a string"), assertIsString(key, "key is not a string"), assertIsString(uploadId, "uploadId is not a string");
      const fileMap = options.fileMap;
      assertIsMap(fileMap);
      const { meta, name } = file, { relativePath } = meta, filePath = relativePath || `/${name}`;
      return fileMap.set(file.id, { bucket, fileId, key, filePath }), { key, uploadId };
    }, "createMultipartUpload"),
    listParts: /* @__PURE__ */ __name(async (file, { uploadId, key }) => {
      var _a6;
      const fileMap = options.fileMap;
      assertIsMap(fileMap);
      const bucket = (_a6 = fileMap.get(file.id)) == null ? void 0 : _a6.bucket;
      return assertIsString(bucket, "bucket is not a string"), (await listParts.mutateAsync({ bucket, key, uploadId })).listPartsForMultipartUpload ?? [];
    }, "listParts"),
    signPart: /* @__PURE__ */ __name(async (file, { uploadId, key, partNumber, signal }) => {
      var _a6;
      const fileMap = options.fileMap;
      assertIsMap(fileMap);
      const bucket = (_a6 = fileMap.get(file.id)) == null ? void 0 : _a6.bucket;
      assertIsString(bucket, "bucket is not a string"), assertNotAborted(signal, "The operation was aborted");
      const url = (await createPresignedUrl.mutateAsync({
        bucket,
        key,
        partNumber,
        uploadId
      })).createPresignedUploadPartUrl;
      return assertIsString(url, "url is not a string"), { url };
    }, "signPart"),
    completeMultipartUpload: /* @__PURE__ */ __name(async (file, { key, uploadId, parts, signal }) => {
      var _a6;
      const fileMap = options.fileMap;
      assertIsMap(fileMap);
      const bucket = (_a6 = fileMap.get(file.id)) == null ? void 0 : _a6.bucket;
      assertIsString(bucket, "bucket is not a string"), assertNotAborted(signal, "The operation was aborted");
      const response = await completeUpload.mutateAsync({
        bucket,
        key,
        parts: parts.map((part) => ({ etag: part.ETag, partNumber: part.PartNumber })),
        uploadId
      }), location2 = response.completeMultipartUpload;
      return assertIsString(location2, "location is not a string"), { location: response.completeMultipartUpload ?? "" };
    }, "completeMultipartUpload"),
    abortMultipartUpload: /* @__PURE__ */ __name(async (file, { uploadId, key, signal }) => {
      var _a6;
      const fileMap = options.fileMap;
      assertIsMap(fileMap);
      const bucket = (_a6 = fileMap.get(file.id)) == null ? void 0 : _a6.bucket;
      assertIsString(bucket, "bucket is not a string"), assertNotAborted(signal, "The operation was aborted"), await abortUpload.mutateAsync({ bucket, key, uploadId });
    }, "abortMultipartUpload")
  }), () => {
    const plugin = uppy.getPlugin("AwsS3Multipart");
    plugin && uppy.removePlugin(plugin);
  }), [options.chunkSize]), uppy;
}, "useUppyForSimpleUploader"), getRelativePath = /* @__PURE__ */ __name((file) => file.webkitRelativePath ? file.webkitRelativePath : "path" in file && file.path !== file.name ? file.path : null, "getRelativePath"), useUppyMethods = /* @__PURE__ */ __name((uppy) => {
  const addFile = useCallback(
    (file) => {
      uppy.addFile({
        data: file,
        meta: { relativePath: getRelativePath(file) },
        name: file.name,
        type: file.type
      });
    },
    [uppy]
  ), addFiles = useCallback(
    (files) => {
      const uppyFiles = files.map((file) => ({
        data: file,
        meta: { relativePath: getRelativePath(file) },
        name: file.name,
        type: file.type
      }));
      uppy.addFiles(uppyFiles);
    },
    [uppy]
  ), removeFile = useCallback(
    (fileId) => {
      uppy.removeFile(fileId);
    },
    [uppy]
  ), reset2 = useCallback(() => uppy.cancelAll({ reason: "user" }), [uppy]), retry = useCallback(() => uppy.retryAll(), [uppy]), upload = useCallback(async () => uppy.upload(), [uppy]);
  return {
    addFile,
    addFiles,
    removeFile,
    reset: reset2,
    retry,
    upload
  };
}, "useUppyMethods"), queryKey = ["ACCOUNT_BY_CONTEXT"], useAccount = /* @__PURE__ */ __name((isDisabled) => {
  var _a6;
  const request = useContext(RequestContext), response = useQuery({
    enabled: !isDisabled,
    queryFn: /* @__PURE__ */ __name(() => request(ACCOUNT_BY_CONTEXT), "queryFn"),
    queryKey
  }), account = useMemo(() => {
    var _a7;
    return (_a7 = response == null ? void 0 : response.data) == null ? void 0 : _a7.accountByContext;
  }, [(_a6 = response == null ? void 0 : response.data) == null ? void 0 : _a6.accountByContext]);
  return { response, account };
}, "useAccount");
useAccount.queryKey = queryKey;
const _Logger = class _Logger {
  /**
   * @param loggerName - name of logger. If undefined, its name will be null.
   */
  constructor(loggerName) {
    /**
     * Name of logger,
     * every message logged by this logger should be prefixed with this name,
     * unless it is null.
     */
    __publicField(this, "_loggerName");
    this._loggerName = loggerName ?? null;
  }
};
__name(_Logger, "Logger");
let Logger = _Logger;
const _ConsoleLogger = class _ConsoleLogger extends Logger {
  withPrefix(data) {
    return this._loggerName === null ? data : [`[${this._loggerName}]`, ...data];
  }
  debug(...data) {
    console.debug(...this.withPrefix(data));
  }
  info(...data) {
    console.info(...this.withPrefix(data));
  }
  warn(...data) {
    console.warn(...this.withPrefix(data));
  }
  error(...data) {
    console.error(...this.withPrefix(data));
  }
};
__name(_ConsoleLogger, "ConsoleLogger");
let ConsoleLogger = _ConsoleLogger;
const _ConsoleLoggerFactory = class _ConsoleLoggerFactory {
  create(loggerName) {
    return new ConsoleLogger(loggerName);
  }
};
__name(_ConsoleLoggerFactory, "ConsoleLoggerFactory");
let ConsoleLoggerFactory = _ConsoleLoggerFactory;
const useLifeCycleLogger = /* @__PURE__ */ __name((name, options) => {
  useEffect(() => {
    const logger = ((options == null ? void 0 : options.loggerFactory) ?? new ConsoleLoggerFactory()).create(name);
    return logger.debug(`${name} hook mounted`), () => {
      logger.debug(`${name} hook unmounted`);
    };
  }, []);
}, "useLifeCycleLogger"), useSimpleUploader = /* @__PURE__ */ __name(({ isDisabled, parentNodeId } = {}) => {
  var _a6;
  useLifeCycleLogger("legacy useSimpleUploader");
  const accountId = (_a6 = useAccount(isDisabled).account) == null ? void 0 : _a6.id, fileMap = useState(() => /* @__PURE__ */ new Map())[0], uppy = useUppyForSimpleUploader({ fileMap }), { emit: emit2, on, off } = useUppyEvents(uppy), { addFile, addFiles, upload } = useUppyMethods(uppy), { mutateAsync: createFile } = useCreateFile(), [isUploading, setIsUploading] = useState(!1);
  return useEffect(() => {
    const onUpload = /* @__PURE__ */ __name(async () => setIsUploading(!0), "onUpload"), onUploadSuccess = /* @__PURE__ */ __name(async (file) => {
      const { bucket, fileId, key } = fileMap.get(file.id) ?? {};
      assertIsString(bucket, "bucket is not a string"), assertIsString(fileId, "fileId is not a string"), assertIsString(key, "key is not a string"), assertIsString(accountId, "accountId is not a string"), (await createFile({
        accountId,
        bucket,
        fileId,
        fileKind: getFileKindInput(file.type),
        key,
        name: file.name,
        size: file.size,
        type: file.type
      })).createFile && emit2("createSuccess", {
        bucket,
        file: file.data,
        fileId,
        key
      });
    }, "onUploadSuccess");
    return uppy.on("upload", onUpload), uppy.on("upload-success", onUploadSuccess), () => {
      uppy.off("upload", onUpload), uppy.off("upload-success", onUploadSuccess);
    };
  }, [accountId, createFile, emit2, fileMap, parentNodeId, uppy]), {
    addFile,
    addFiles,
    isUploading,
    off,
    on,
    upload,
    uppy
  };
}, "useSimpleUploader"), useDirFind = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((id2) => request(FIND_DATA_IMPORT_REQUEST_BY_DATA_IMPORT_REQUEST_ID, { dataImportRequestId: id2 }), "mutationFn")
  });
}, "useDirFind"), _512MB = 512 * 1024 * 1024, useUppy = /* @__PURE__ */ __name((options) => {
  const {
    createUploadForFileImportRequest,
    listPartsForFileImportRequest,
    createPresignedUrlForFileImportRequest,
    completeUploadForFileImportRequest,
    abortUploadForFileImportRequest
  } = useMultipart(), uppy = useState(/* @__PURE__ */ __name(() => new Uppy(), "initialize"))[0];
  return useEffect(() => (uppy.use(AwsS3Multipart, {
    shouldUseMultipart: !0,
    getChunkSize: options.chunkSize ? () => options.chunkSize ?? _512MB : void 0,
    createMultipartUpload: /* @__PURE__ */ __name(async (file) => {
      var _a6, _b, _c2;
      const dataImportRequestId = (_a6 = options.uploadState.current.dir) == null ? void 0 : _a6.id;
      assertIsString(dataImportRequestId, "dataImportRequestId is not a string");
      const { meta, name } = file, { relativePath } = meta, filePath = relativePath || `/${name}`, fileNode = (_b = options.uploadState.current.graph) == null ? void 0 : _b.get(filePath);
      if ((fileNode == null ? void 0 : fileNode.type) !== "file") throw new Error("fileNode is not a file");
      const fileImportRequestId = fileNode.fileImportRequestId;
      assertIsString(fileImportRequestId, "fileImportRequestId is not a string");
      const response = await createUploadForFileImportRequest.mutateAsync({
        dataImportRequestId,
        fileImportRequestId
      }), { bucket, key, uploadId } = response.createMultipartUploadForFileImportRequest ?? {};
      assertIsString(bucket, "bucket is not a string"), assertIsString(key, "key is not a string"), assertIsString(uploadId, "uploadId is not a string");
      const fileMap = (_c2 = options.uploadState) == null ? void 0 : _c2.current.fileCreation;
      return assertIsMap(fileMap), fileMap.set(file.id, { bucket, key, filePath }), { key, uploadId };
    }, "createMultipartUpload"),
    listParts: /* @__PURE__ */ __name(async (file, { uploadId, key }) => {
      var _a6, _b;
      const fileMap = (_a6 = options.uploadState) == null ? void 0 : _a6.current.fileCreation;
      assertIsMap(fileMap);
      const bucket = (_b = fileMap.get(file.id)) == null ? void 0 : _b.bucket;
      return assertIsString(bucket, "bucket is not a string"), (await listPartsForFileImportRequest.mutateAsync({ bucket, key, uploadId })).listPartsForMultipartUploadForFileImportRequest ?? [];
    }, "listParts"),
    signPart: /* @__PURE__ */ __name(async (file, { uploadId, key, partNumber, signal }) => {
      var _a6, _b;
      const fileMap = (_a6 = options.uploadState) == null ? void 0 : _a6.current.fileCreation;
      assertIsMap(fileMap);
      const bucket = (_b = fileMap.get(file.id)) == null ? void 0 : _b.bucket;
      assertIsString(bucket, "bucket is not a string"), assertNotAborted(signal, "The operation was aborted");
      const url = (await createPresignedUrlForFileImportRequest.mutateAsync({
        bucket,
        key,
        partNumber,
        uploadId
      })).createPresignedPartUrlForFileImportRequest;
      return assertIsString(url, "url is not a string"), { url };
    }, "signPart"),
    completeMultipartUpload: /* @__PURE__ */ __name(async (file, { key, uploadId, parts, signal }) => {
      var _a6, _b;
      const fileMap = (_a6 = options.uploadState) == null ? void 0 : _a6.current.fileCreation;
      assertIsMap(fileMap);
      const bucket = (_b = fileMap.get(file.id)) == null ? void 0 : _b.bucket;
      assertIsString(bucket, "bucket is not a string"), assertNotAborted(signal, "The operation was aborted");
      const response = await completeUploadForFileImportRequest.mutateAsync({
        bucket,
        key,
        parts: parts.map((part) => ({ etag: part.ETag, partNumber: part.PartNumber })),
        uploadId
      }), location2 = response.completeMultipartUploadForFileImportRequest;
      return assertIsString(location2, "location is not a string"), { location: response.completeMultipartUploadForFileImportRequest ?? "" };
    }, "completeMultipartUpload"),
    abortMultipartUpload: /* @__PURE__ */ __name(async (file, { uploadId, key, signal }) => {
      var _a6, _b;
      const fileMap = (_a6 = options.uploadState) == null ? void 0 : _a6.current.fileCreation;
      assertIsMap(fileMap);
      const bucket = (_b = fileMap.get(file.id)) == null ? void 0 : _b.bucket;
      assertIsString(bucket, "bucket is not a string"), assertNotAborted(signal, "The operation was aborted"), await abortUploadForFileImportRequest.mutateAsync({ bucket, key, uploadId });
    }, "abortMultipartUpload")
  }), () => {
    const plugin = uppy.getPlugin("AwsS3Multipart");
    plugin && uppy.removePlugin(plugin);
  }), [options.chunkSize]), uppy;
}, "useUppy"), useCountFileImportRequestByDataImportRequestId = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name(({
      dataImportRequestId,
      fileKind
    }) => request(COUNT_FILE_IMPORT_REQUESTS_BY_DATA_IMPORT_REQUEST_ID, {
      dataImportRequestId,
      fileKind
    }), "mutationFn")
  });
}, "useCountFileImportRequestByDataImportRequestId"), useCreateThumbnailsForPersistedImageFiles = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((fileIds) => request(CREATE_IMAGE_THUMBNAILS_FOR_PERSISTED_IMAGES_BY_IDS, {
      fileIds
    }), "mutationFn")
  });
}, "useCreateThumbnailsForPersistedImageFiles"), useFindFileImportRequestByDataImportRequestId = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name(({
      dataImportRequestId,
      fileKind,
      start,
      size
    }) => request(FIND_FILE_IMPORT_REQUESTS_BY_DATA_IMPORT_REQUEST_ID, {
      dataImportRequestId,
      fileKind,
      start,
      size
    }), "mutationFn")
  });
}, "useFindFileImportRequestByDataImportRequestId"), useCreateThumbnailsForImages = /* @__PURE__ */ __name((uploadState) => {
  const { mutateAsync: countFileImportRequestsByDataImportRequestId } = useCountFileImportRequestByDataImportRequestId(), { mutateAsync: findFileImportRequestsByDataImportRequestId } = useFindFileImportRequestByDataImportRequestId(), { mutateAsync: createImageThumbnailsForPersistedImagesByIds } = useCreateThumbnailsForPersistedImageFiles();
  return useCallback(async () => {
    var _a6, _b;
    if (!((_b = (_a6 = uploadState.current) == null ? void 0 : _a6.dir) != null && _b.id)) throw new Error("The data import request ID doesn't exist");
    const { countFileImportRequestsByDataImportRequestId: numberOfImageFileImportRequest } = await countFileImportRequestsByDataImportRequestId({
      dataImportRequestId: uploadState.current.dir.id,
      fileKind: FILE_KIND.IMAGE
    });
    for (let i2 = 0; i2 < (numberOfImageFileImportRequest ?? 0); i2 += 1e3) {
      const { findFileImportRequestsByDataImportRequestId: fileImportRequests = [] } = await findFileImportRequestsByDataImportRequestId({
        dataImportRequestId: uploadState.current.dir.id,
        fileKind: FILE_KIND.IMAGE,
        start: i2,
        size: 1e3
      }), imageFileIds = (fileImportRequests == null ? void 0 : fileImportRequests.map((fileImportRequest) => (assertIsDefined(fileImportRequest), assertIsString(fileImportRequest.fileId), fileImportRequest.fileId))) ?? [];
      await createImageThumbnailsForPersistedImagesByIds(imageFileIds);
    }
  }, [
    countFileImportRequestsByDataImportRequestId,
    createImageThumbnailsForPersistedImagesByIds,
    findFileImportRequestsByDataImportRequestId,
    uploadState
  ]);
}, "useCreateThumbnailsForImages");
function baseSlice(array, start, end) {
  var index = -1, length = array.length;
  start < 0 && (start = -start > length ? 0 : length + start), end = end > length ? length : end, end < 0 && (end += length), length = start > end ? 0 : end - start >>> 0, start >>>= 0;
  for (var result2 = Array(length); ++index < length; )
    result2[index] = array[index + start];
  return result2;
}
__name(baseSlice, "baseSlice");
var freeGlobal = typeof global == "object" && global && global.Object === Object && global, freeSelf = typeof self == "object" && self && self.Object === Object && self, root = freeGlobal || freeSelf || Function("return this")(), Symbol$1 = root.Symbol, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty, nativeObjectToString$1 = objectProto$1.toString, symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = !0;
  } catch {
  }
  var result2 = nativeObjectToString$1.call(value);
  return unmasked && (isOwn ? value[symToStringTag$1] = tag : delete value[symToStringTag$1]), result2;
}
__name(getRawTag, "getRawTag");
var objectProto = Object.prototype, nativeObjectToString = objectProto.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
__name(objectToString, "objectToString");
var nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(value) {
  return value == null ? value === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
__name(baseGetTag, "baseGetTag");
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
__name(isObject$1, "isObject$1");
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  for (var index = string.length; index-- && reWhitespace.test(string.charAt(index)); )
    ;
  return index;
}
__name(trimmedEndIndex, "trimmedEndIndex");
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string && string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "");
}
__name(baseTrim, "baseTrim");
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
__name(isObjectLike, "isObjectLike");
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
__name(isSymbol, "isSymbol");
var NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number")
    return value;
  if (isSymbol(value))
    return NAN;
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string")
    return value === 0 ? value : +value;
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
__name(toNumber, "toNumber");
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite(value) {
  if (!value)
    return value === 0 ? value : 0;
  if (value = toNumber(value), value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
__name(toFinite, "toFinite");
function toInteger(value) {
  var result2 = toFinite(value), remainder = result2 % 1;
  return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
}
__name(toInteger, "toInteger");
var nativeCeil = Math.ceil, nativeMax = Math.max;
function chunk(array, size, guard) {
  size === void 0 ? size = 1 : size = nativeMax(toInteger(size), 0);
  var length = array == null ? 0 : array.length;
  if (!length || size < 1)
    return [];
  for (var index = 0, resIndex = 0, result2 = Array(nativeCeil(length / size)); index < length; )
    result2[resIndex++] = baseSlice(array, index, index += size);
  return result2;
}
__name(chunk, "chunk");
const useDirUpdateStatus = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(UPDATE_STATUS_FOR_DATA_IMPORT_REQUEST, variables), "mutationFn")
  });
}, "useDirUpdateStatus"), useFirImportFileNodes = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_FILE_NODE_FOR_FOLDER_IMPORT_REQUEST, variables), "mutationFn")
  });
}, "useFirImportFileNodes"), useFirUpdateStatus = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(UPDATE_STATUS_FOR_FOLDER_IMPORT_REQUEST, { input: variables }), "mutationFn")
  });
}, "useFirUpdateStatus"), useImportFiles = /* @__PURE__ */ __name((uploadState, chunkThreshold) => {
  const { mutateAsync: dirUpdateStatus } = useDirUpdateStatus(), { mutateAsync: firImportFileNodes } = useFirImportFileNodes(), { mutateAsync: firUpdateStatus } = useFirUpdateStatus();
  return useCallback(async () => {
    var _a6, _b, _c2, _d, _e, _f, _g2, _h, _i;
    if (!((_b = (_a6 = uploadState.current) == null ? void 0 : _a6.dir) != null && _b.id)) throw new Error();
    if (uploadState.current.result === null) throw new Error();
    const firIdMap = /* @__PURE__ */ new Map();
    for (const [, fileCreation] of uploadState.current.fileCreation) {
      const filePath = fileCreation.filePath, fileNode = (_c2 = uploadState.current.graph) == null ? void 0 : _c2.get(filePath);
      if ((fileNode == null ? void 0 : fileNode.type) !== "file") throw new Error();
      const file = fileNode.file, { meta, name, size, type } = file, { relativePath } = meta, folderPath = relativePath ? relativePath.split("/").slice(0, -1).join("/") : "/", parentNode = (_e = (_d = uploadState.current) == null ? void 0 : _d.graph) == null ? void 0 : _e.get(folderPath), childNode = (_g2 = (_f = uploadState.current) == null ? void 0 : _f.graph) == null ? void 0 : _g2.get(filePath);
      if (!parentNode || !childNode) throw new Error();
      if (!("firId" in parentNode)) throw new Error();
      if (folderPath === "/" && (parentNode.firId = uploadState.current.dir.rootFolderImportRequestId), parentNode.firId === null) throw new Error();
      const { bucket, key } = fileCreation;
      assertIsString(bucket, "bucket is not a string"), assertIsString(key, "key is not a string");
      const storages = firIdMap.get(parentNode.firId), idempotencyKeyAndStorage = {
        idempotencyKey: filePath,
        storage: {
          bucket,
          key,
          name,
          size,
          type
        }
      };
      storages ? storages.push(idempotencyKeyAndStorage) : firIdMap.set(parentNode.firId, [idempotencyKeyAndStorage]);
    }
    await dirUpdateStatus({
      dataImportRequestId: uploadState.current.dir.id,
      status: DATA_IMPORT_REQUEST_STATUS.IMPORTING_FILE_NODES
    });
    for (const [firId, fileIdempotencyKeyStorageAndMetadata] of firIdMap.entries()) {
      await firUpdateStatus({
        folderImportRequestId: firId,
        status: NODE_IMPORT_REQUEST_STATUS.IMPORTING_FILE_NODES
      });
      const chunks2 = chunk(fileIdempotencyKeyStorageAndMetadata, chunkThreshold);
      for (const chunk2 of chunks2) {
        const { createFileNodeForFolderImportRequest: fileIds } = await firImportFileNodes({
          dataImportRequestId: uploadState.current.dir.id,
          fileIdempotencyKeyStorageAndMetadata: chunk2,
          folderImportRequestId: firId
        });
        for (let i2 = 0; i2 < chunk2.length; i2++) {
          const fileId = fileIds == null ? void 0 : fileIds.at(i2);
          assertIsString(fileId, "fileId is not a string");
          const filePath = (_h = chunk2.at(i2)) == null ? void 0 : _h.idempotencyKey;
          assertIsString(filePath, "filePath is not a string");
          const fileNode = (_i = uploadState.current.graph) == null ? void 0 : _i.get(filePath);
          if (fileNode && "fileId" in fileNode) fileNode.fileId = fileId;
          else throw new Error("fileNode is not a file node");
        }
      }
      await firUpdateStatus({
        folderImportRequestId: firId,
        status: NODE_IMPORT_REQUEST_STATUS.FILE_NODES_IMPORTED
      });
    }
    await dirUpdateStatus({
      dataImportRequestId: uploadState.current.dir.id,
      status: DATA_IMPORT_REQUEST_STATUS.FILE_NODES_IMPORTED
    });
  }, [chunkThreshold, dirUpdateStatus, firImportFileNodes, firUpdateStatus, uploadState]);
}, "useImportFiles"), useFirImportFolderNodes = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_FOLDER_NODE_FOR_FOLDER_IMPORT_REQUEST, variables), "mutationFn")
  });
}, "useFirImportFolderNodes"), useImportFolders = /* @__PURE__ */ __name((uploadState) => {
  const { mutateAsync: dirUpdateStatus } = useDirUpdateStatus(), { mutateAsync: firImportFolderNodes } = useFirImportFolderNodes(), { mutateAsync: firUpdateStatus } = useFirUpdateStatus();
  return useCallback(async () => {
    var _a6, _b, _c2;
    if (!((_b = (_a6 = uploadState.current) == null ? void 0 : _a6.dir) != null && _b.id)) return;
    const graph = (_c2 = uploadState.current) == null ? void 0 : _c2.graph;
    if (graph) {
      if (await dirUpdateStatus({
        dataImportRequestId: uploadState.current.dir.id,
        status: DATA_IMPORT_REQUEST_STATUS.IMPORTING_FOLDER_NODES
      }), !uploadState.current.dir.rootFolderImportRequestId) throw new Error();
      await firUpdateStatus({
        folderImportRequestId: uploadState.current.dir.rootFolderImportRequestId,
        status: NODE_IMPORT_REQUEST_STATUS.FOLDER_NODE_IMPORTED
      });
      for (const [path, node] of graph.entries()) {
        if (node.type === "file") continue;
        const childFolderImportRequestIds = [...node.folders.values()].map((folderPath) => {
          const childNode = graph.get(folderPath);
          if (childNode && "firId" in childNode && childNode.firId !== null) return childNode.firId;
          throw new Error();
        });
        if (!uploadState.current.dir.rootFolderImportRequestId) throw new Error();
        const parentFolderImportRequestId = path === "/" ? uploadState.current.dir.rootFolderImportRequestId : node.firId;
        if (parentFolderImportRequestId === null) throw new Error();
        await firImportFolderNodes({
          dataImportRequestId: uploadState.current.dir.id,
          parentFolderImportRequestId,
          childFolderImportRequestIds
        });
      }
      await dirUpdateStatus({
        dataImportRequestId: uploadState.current.dir.id,
        status: DATA_IMPORT_REQUEST_STATUS.FOLDER_NODES_IMPORTED
      });
    }
  }, [dirUpdateStatus, firImportFolderNodes, firUpdateStatus, uploadState]);
}, "useImportFolders");
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
__name(rng, "rng");
const byteToHex = [];
for (let i2 = 0; i2 < 256; ++i2)
  byteToHex.push((i2 + 256).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
__name(unsafeStringify, "unsafeStringify");
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = {
  randomUUID
};
function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options)
    return native.randomUUID();
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  return rnds[6] = rnds[6] & 15 | 64, rnds[8] = rnds[8] & 63 | 128, unsafeStringify(rnds);
}
__name(v4, "v4");
const useDirCreate = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_DATA_IMPORT_REQUEST_V2, variables), "mutationFn")
  });
}, "useDirCreate"), useInitDir = /* @__PURE__ */ __name(() => {
  const { mutateAsync } = useDirCreate();
  return useCallback(
    async (dependants, featureType, persistType, rootFolderKey, rootFolderName, systemFolderNodeId) => {
      const name = encodeURIComponent(`${v4()}_${Date.now()}`);
      return {
        id: (await mutateAsync({
          dependants,
          featureType,
          name,
          persistType,
          priority: persistType === "IMMEDIATE" ? DATA_IMPORT_REQUEST_PRIORITY.IMMEDIATE : DATA_IMPORT_REQUEST_PRIORITY.HIGH,
          rootFolderIdempotencyKeyAndName: {
            idempotencyKey: rootFolderKey,
            name: rootFolderName
          },
          systemFolderNodeId
        })).createDataImportRequestV2 ?? "",
        name,
        rootFolderImportRequestId: null,
        rootFolderKey,
        rootFolderName,
        status: "CREATED"
      };
    },
    [mutateAsync]
  );
}, "useInitDir"), useFirTrackFiles = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(TRACK_FILES_FOR_FOLDER_IMPORT_REQUEST, variables), "mutationFn")
  });
}, "useFirTrackFiles"), useTrackFiles = /* @__PURE__ */ __name((uploadState) => {
  const { mutateAsync: dirUpdateStatus } = useDirUpdateStatus(), { mutateAsync: firTrackFiles } = useFirTrackFiles(), { mutateAsync: firUpdateStatus } = useFirUpdateStatus();
  return useCallback(async () => {
    var _a6, _b, _c2;
    if (!((_b = (_a6 = uploadState.current) == null ? void 0 : _a6.dir) != null && _b.id)) return;
    const graph = (_c2 = uploadState.current) == null ? void 0 : _c2.graph;
    if (graph) {
      await dirUpdateStatus({
        dataImportRequestId: uploadState.current.dir.id,
        status: DATA_IMPORT_REQUEST_STATUS.TRACKING_FILE_PATHS
      });
      for (const [path, node] of graph.entries()) {
        if (node.type === "file") continue;
        const filePaths = [...node.files.values()], fileItems = filePaths.map((filePath) => {
          const fileNode = graph.get(filePath);
          if ((fileNode == null ? void 0 : fileNode.type) !== "file") throw new Error("fileNode is not a file");
          const metadata = {
            name: fileNode.file.name,
            size: fileNode.file.size
          };
          return {
            fileIdempotencyKey: filePath,
            fileName: fileNode.file.name,
            fileKind: getFileKind(fileNode.file.type),
            metadata
          };
        });
        if (!uploadState.current.dir.rootFolderImportRequestId)
          throw new Error("rootFolderImportRequestId does not exist");
        const folderImportRequestId = path === "/" ? uploadState.current.dir.rootFolderImportRequestId : node.firId;
        if (folderImportRequestId === null)
          throw new Error("rootFolderImportRequestId does not exist");
        await firUpdateStatus({
          folderImportRequestId,
          status: NODE_IMPORT_REQUEST_STATUS.TRACKING_FILE_PATHS
        });
        const fileImportRequestIds = (await firTrackFiles({
          dataImportRequestId: uploadState.current.dir.id,
          files: fileItems,
          folderImportRequestId
        })).trackFilesForFolderImportRequest ?? [];
        if (fileImportRequestIds.length !== filePaths.length)
          throw new Error("not all files have fileImportRequestId");
        for (let i2 = 0; i2 < fileImportRequestIds.length; i2++) {
          const fileImportRequestId = fileImportRequestIds[i2], filePath = filePaths[i2], fileNode = graph.get(filePath);
          if ((fileNode == null ? void 0 : fileNode.type) !== "file") throw new Error("fileNode is not a file");
          fileNode.fileImportRequestId = fileImportRequestId;
        }
        await firUpdateStatus({
          folderImportRequestId,
          status: NODE_IMPORT_REQUEST_STATUS.FILE_PATHS_TRACKED
        });
      }
      await dirUpdateStatus({
        dataImportRequestId: uploadState.current.dir.id,
        status: DATA_IMPORT_REQUEST_STATUS.FILE_PATHS_TRACKED
      });
    }
  }, [dirUpdateStatus, firTrackFiles, firUpdateStatus, uploadState]);
}, "useTrackFiles");
function assertPath(path) {
  if (typeof path != "string")
    throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
__name(assertPath, "assertPath");
function normalizeStringPosix(path, allowAboveRoot) {
  for (var res = "", lastSegmentLength = 0, lastSlash = -1, dots = 0, code, i2 = 0; i2 <= path.length; ++i2) {
    if (i2 < path.length)
      code = path.charCodeAt(i2);
    else {
      if (code === 47)
        break;
      code = 47;
    }
    if (code === 47) {
      if (!(lastSlash === i2 - 1 || dots === 1)) if (lastSlash !== i2 - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf("/");
            if (lastSlashIndex !== res.length - 1) {
              lastSlashIndex === -1 ? (res = "", lastSegmentLength = 0) : (res = res.slice(0, lastSlashIndex), lastSegmentLength = res.length - 1 - res.lastIndexOf("/")), lastSlash = i2, dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = "", lastSegmentLength = 0, lastSlash = i2, dots = 0;
            continue;
          }
        }
        allowAboveRoot && (res.length > 0 ? res += "/.." : res = "..", lastSegmentLength = 2);
      } else
        res.length > 0 ? res += "/" + path.slice(lastSlash + 1, i2) : res = path.slice(lastSlash + 1, i2), lastSegmentLength = i2 - lastSlash - 1;
      lastSlash = i2, dots = 0;
    } else code === 46 && dots !== -1 ? ++dots : dots = -1;
  }
  return res;
}
__name(normalizeStringPosix, "normalizeStringPosix");
function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root, base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
  return dir ? dir === pathObject.root ? dir + base : dir + sep + base : base;
}
__name(_format, "_format");
var posix = {
  // path.resolve([from ...], to)
  resolve: /* @__PURE__ */ __name(function() {
    for (var resolvedPath = "", resolvedAbsolute = !1, cwd, i2 = arguments.length - 1; i2 >= -1 && !resolvedAbsolute; i2--) {
      var path;
      i2 >= 0 ? path = arguments[i2] : (cwd === void 0 && (cwd = process.cwd()), path = cwd), assertPath(path), path.length !== 0 && (resolvedPath = path + "/" + resolvedPath, resolvedAbsolute = path.charCodeAt(0) === 47);
    }
    return resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute), resolvedAbsolute ? resolvedPath.length > 0 ? "/" + resolvedPath : "/" : resolvedPath.length > 0 ? resolvedPath : ".";
  }, "resolve"),
  normalize: /* @__PURE__ */ __name(function(path) {
    if (assertPath(path), path.length === 0) return ".";
    var isAbsolute2 = path.charCodeAt(0) === 47, trailingSeparator = path.charCodeAt(path.length - 1) === 47;
    return path = normalizeStringPosix(path, !isAbsolute2), path.length === 0 && !isAbsolute2 && (path = "."), path.length > 0 && trailingSeparator && (path += "/"), isAbsolute2 ? "/" + path : path;
  }, "normalize"),
  isAbsolute: /* @__PURE__ */ __name(function(path) {
    return assertPath(path), path.length > 0 && path.charCodeAt(0) === 47;
  }, "isAbsolute"),
  join: /* @__PURE__ */ __name(function() {
    if (arguments.length === 0)
      return ".";
    for (var joined, i2 = 0; i2 < arguments.length; ++i2) {
      var arg = arguments[i2];
      assertPath(arg), arg.length > 0 && (joined === void 0 ? joined = arg : joined += "/" + arg);
    }
    return joined === void 0 ? "." : posix.normalize(joined);
  }, "join"),
  relative: /* @__PURE__ */ __name(function(from, to) {
    if (assertPath(from), assertPath(to), from === to || (from = posix.resolve(from), to = posix.resolve(to), from === to)) return "";
    for (var fromStart = 1; fromStart < from.length && from.charCodeAt(fromStart) === 47; ++fromStart)
      ;
    for (var fromEnd = from.length, fromLen = fromEnd - fromStart, toStart = 1; toStart < to.length && to.charCodeAt(toStart) === 47; ++toStart)
      ;
    for (var toEnd = to.length, toLen = toEnd - toStart, length = fromLen < toLen ? fromLen : toLen, lastCommonSep = -1, i2 = 0; i2 <= length; ++i2) {
      if (i2 === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i2) === 47)
            return to.slice(toStart + i2 + 1);
          if (i2 === 0)
            return to.slice(toStart + i2);
        } else fromLen > length && (from.charCodeAt(fromStart + i2) === 47 ? lastCommonSep = i2 : i2 === 0 && (lastCommonSep = 0));
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i2), toCode = to.charCodeAt(toStart + i2);
      if (fromCode !== toCode)
        break;
      fromCode === 47 && (lastCommonSep = i2);
    }
    var out = "";
    for (i2 = fromStart + lastCommonSep + 1; i2 <= fromEnd; ++i2)
      (i2 === fromEnd || from.charCodeAt(i2) === 47) && (out.length === 0 ? out += ".." : out += "/..");
    return out.length > 0 ? out + to.slice(toStart + lastCommonSep) : (toStart += lastCommonSep, to.charCodeAt(toStart) === 47 && ++toStart, to.slice(toStart));
  }, "relative"),
  _makeLong: /* @__PURE__ */ __name(function(path) {
    return path;
  }, "_makeLong"),
  dirname: /* @__PURE__ */ __name(function(path) {
    if (assertPath(path), path.length === 0) return ".";
    for (var code = path.charCodeAt(0), hasRoot = code === 47, end = -1, matchedSlash = !0, i2 = path.length - 1; i2 >= 1; --i2)
      if (code = path.charCodeAt(i2), code === 47) {
        if (!matchedSlash) {
          end = i2;
          break;
        }
      } else
        matchedSlash = !1;
    return end === -1 ? hasRoot ? "/" : "." : hasRoot && end === 1 ? "//" : path.slice(0, end);
  }, "dirname"),
  basename: /* @__PURE__ */ __name(function(path, ext) {
    if (ext !== void 0 && typeof ext != "string") throw new TypeError('"ext" argument must be a string');
    assertPath(path);
    var start = 0, end = -1, matchedSlash = !0, i2;
    if (ext !== void 0 && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return "";
      var extIdx = ext.length - 1, firstNonSlashEnd = -1;
      for (i2 = path.length - 1; i2 >= 0; --i2) {
        var code = path.charCodeAt(i2);
        if (code === 47) {
          if (!matchedSlash) {
            start = i2 + 1;
            break;
          }
        } else
          firstNonSlashEnd === -1 && (matchedSlash = !1, firstNonSlashEnd = i2 + 1), extIdx >= 0 && (code === ext.charCodeAt(extIdx) ? --extIdx === -1 && (end = i2) : (extIdx = -1, end = firstNonSlashEnd));
      }
      return start === end ? end = firstNonSlashEnd : end === -1 && (end = path.length), path.slice(start, end);
    } else {
      for (i2 = path.length - 1; i2 >= 0; --i2)
        if (path.charCodeAt(i2) === 47) {
          if (!matchedSlash) {
            start = i2 + 1;
            break;
          }
        } else end === -1 && (matchedSlash = !1, end = i2 + 1);
      return end === -1 ? "" : path.slice(start, end);
    }
  }, "basename"),
  extname: /* @__PURE__ */ __name(function(path) {
    assertPath(path);
    for (var startDot = -1, startPart = 0, end = -1, matchedSlash = !0, preDotState = 0, i2 = path.length - 1; i2 >= 0; --i2) {
      var code = path.charCodeAt(i2);
      if (code === 47) {
        if (!matchedSlash) {
          startPart = i2 + 1;
          break;
        }
        continue;
      }
      end === -1 && (matchedSlash = !1, end = i2 + 1), code === 46 ? startDot === -1 ? startDot = i2 : preDotState !== 1 && (preDotState = 1) : startDot !== -1 && (preDotState = -1);
    }
    return startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
    preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? "" : path.slice(startDot, end);
  }, "extname"),
  format: /* @__PURE__ */ __name(function(pathObject) {
    if (pathObject === null || typeof pathObject != "object")
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    return _format("/", pathObject);
  }, "format"),
  parse: /* @__PURE__ */ __name(function(path) {
    assertPath(path);
    var ret = { root: "", dir: "", base: "", ext: "", name: "" };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0), isAbsolute2 = code === 47, start;
    isAbsolute2 ? (ret.root = "/", start = 1) : start = 0;
    for (var startDot = -1, startPart = 0, end = -1, matchedSlash = !0, i2 = path.length - 1, preDotState = 0; i2 >= start; --i2) {
      if (code = path.charCodeAt(i2), code === 47) {
        if (!matchedSlash) {
          startPart = i2 + 1;
          break;
        }
        continue;
      }
      end === -1 && (matchedSlash = !1, end = i2 + 1), code === 46 ? startDot === -1 ? startDot = i2 : preDotState !== 1 && (preDotState = 1) : startDot !== -1 && (preDotState = -1);
    }
    return startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
    preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? end !== -1 && (startPart === 0 && isAbsolute2 ? ret.base = ret.name = path.slice(1, end) : ret.base = ret.name = path.slice(startPart, end)) : (startPart === 0 && isAbsolute2 ? (ret.name = path.slice(1, startDot), ret.base = path.slice(1, end)) : (ret.name = path.slice(startPart, startDot), ret.base = path.slice(startPart, end)), ret.ext = path.slice(startDot, end)), startPart > 0 ? ret.dir = path.slice(0, startPart - 1) : isAbsolute2 && (ret.dir = "/"), ret;
  }, "parse"),
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
posix.posix = posix;
var pathBrowserify = posix;
const useFirCreateForDir = /* @__PURE__ */ __name(() => {
  const request = useContext(RequestContext);
  return useMutation({
    mutationFn: /* @__PURE__ */ __name((variables) => request(CREATE_FOLDER_IMPORT_REQUEST_FOR_DATA_IMPORT_REQUEST, variables), "mutationFn")
  });
}, "useFirCreateForDir"), buildGraph = /* @__PURE__ */ __name((files) => {
  var _a6;
  const graph = /* @__PURE__ */ new Map();
  for (const file of files) {
    const paths = (file.data.relativePath || ((_a6 = file.meta) == null ? void 0 : _a6.relativePath) || file.data.name).split("/").filter((path) => path !== "");
    for (let i2 = 0; i2 < paths.length; i2++) {
      const parentPath = i2 === 0 ? "/" : "/" + paths.slice(0, i2).join("/"), childPath = "/" + paths.slice(0, i2 + 1).join("/"), parentChildren = graph.get(parentPath);
      if (i2 === paths.length - 1) {
        if (graph.set(childPath, { type: "file", file, fileId: null, fileImportRequestId: null }), parentChildren === void 0)
          graph.set(parentPath, {
            type: "folder",
            files: /* @__PURE__ */ new Set([childPath]),
            folders: /* @__PURE__ */ new Set(),
            firId: null
          });
        else if (parentChildren.type === "folder") parentChildren.files.add(childPath);
        else throw new Error();
        continue;
      }
      if (parentChildren === void 0)
        graph.set(parentPath, {
          type: "folder",
          files: /* @__PURE__ */ new Set(),
          folders: /* @__PURE__ */ new Set([childPath]),
          firId: null
        });
      else if (parentChildren.type === "folder") parentChildren.folders.add(childPath);
      else throw new Error();
      graph.get(childPath) === void 0 && graph.set(childPath, {
        type: "folder",
        files: /* @__PURE__ */ new Set(),
        folders: /* @__PURE__ */ new Set(),
        firId: null
      });
    }
  }
  return graph;
}, "buildGraph"), traverseGraph = /* @__PURE__ */ __name((graph, origin2, action) => {
  if (origin2 === void 0) {
    const root2 = graph.get("/");
    if (!root2) return;
    action("/", root2), traverseGraph(graph, root2, action);
    return;
  }
  if (origin2.type === "folder") {
    for (const childPath of origin2.folders.values()) {
      const childNode = graph.get(childPath);
      childNode && (action(childPath, childNode), traverseGraph(graph, childNode, action));
    }
    for (const childPath of origin2.files.values()) {
      const childNode = graph.get(childPath);
      childNode && action(childPath, childNode);
    }
  }
}, "traverseGraph"), traverseGraphAsync = /* @__PURE__ */ __name(async (graph, origin2, action) => {
  if (origin2 === void 0) {
    const root2 = graph.get("/");
    if (!root2) return;
    await action("/", root2), await traverseGraphAsync(graph, root2, action);
    return;
  }
  if (origin2.type === "folder") {
    for (const childPath of origin2.folders.values()) {
      const childNode = graph.get(childPath);
      childNode && (await action(childPath, childNode), await traverseGraphAsync(graph, childNode, action));
    }
    for (const childPath of origin2.files.values()) {
      const childNode = graph.get(childPath);
      childNode && await action(childPath, childNode);
    }
  }
}, "traverseGraphAsync"), getTotalNumberOfFiles = /* @__PURE__ */ __name((graph) => {
  let count = 0;
  for (const node of graph.values())
    node.type === "file" && count++;
  return count;
}, "getTotalNumberOfFiles"), useTrackFolders = /* @__PURE__ */ __name((uploadState) => {
  const { mutateAsync: dirUpdateStatus } = useDirUpdateStatus(), { mutateAsync: firCreateForDir } = useFirCreateForDir();
  return useCallback(async () => {
    var _a6, _b, _c2;
    if (!((_b = (_a6 = uploadState.current) == null ? void 0 : _a6.dir) != null && _b.id)) return;
    const graph = (_c2 = uploadState.current) == null ? void 0 : _c2.graph;
    graph && (await dirUpdateStatus({
      dataImportRequestId: uploadState.current.dir.id,
      status: DATA_IMPORT_REQUEST_STATUS.TRACKING_FOLDER_PATHS
    }), uploadState.current.dir.status = DATA_IMPORT_REQUEST_STATUS.TRACKING_FOLDER_PATHS, await traverseGraphAsync(graph, void 0, async (path, node) => {
      var _a7;
      if (node.type === "file") return;
      const childFolderNodeIdempotencyKeyAndNames = [];
      for (const childPath of node.folders)
        childFolderNodeIdempotencyKeyAndNames.push({
          idempotencyKey: childPath,
          name: pathBrowserify.basename(childPath)
        });
      assertIsString((_a7 = uploadState.current.dir) == null ? void 0 : _a7.id, "dir does not exist");
      const firIds = (await firCreateForDir({
        dataImportRequestId: uploadState.current.dir.id,
        parentFolderNodeIdempotencyKey: path,
        childFolderNodeIdempotencyKeyAndNames
      })).createFolderImportRequestForDataImportRequest;
      if (firIds)
        for (let i2 = 0; i2 < childFolderNodeIdempotencyKeyAndNames.length; i2++) {
          const childNode = graph.get(childFolderNodeIdempotencyKeyAndNames[i2].idempotencyKey);
          childNode && "firId" in childNode && childNode.firId === null && (childNode.firId = firIds[i2]);
        }
    }), await dirUpdateStatus({
      dataImportRequestId: uploadState.current.dir.id,
      status: DATA_IMPORT_REQUEST_STATUS.FOLDER_PATHS_TRACKED
    }));
  }, [dirUpdateStatus, firCreateForDir, uploadState]);
}, "useTrackFolders"), initialState = {
  dir: null,
  fileCreation: /* @__PURE__ */ new Map(),
  graph: null,
  stage: "initial",
  result: null,
  totalNumberOfFiles: 0
}, useUploadState = /* @__PURE__ */ __name(() => useRef(initialState), "useUploadState"), resetUploadState = /* @__PURE__ */ __name((uploadStateRef) => {
  uploadStateRef.current.dir = null, uploadStateRef.current.fileCreation = /* @__PURE__ */ new Map(), uploadStateRef.current.graph = null, uploadStateRef.current.stage = "initial", uploadStateRef.current.result = null, uploadStateRef.current.totalNumberOfFiles = 0;
}, "resetUploadState"), useUploader$1 = /* @__PURE__ */ __name(({
  dependants,
  featureType,
  persistType,
  systemFolderNodeId,
  chunkSize,
  emitDirCreatingManually,
  importFilesChunkThreshold = 500
}) => {
  useLifeCycleLogger("legacy useUploader");
  const uploadState = useUploadState(), { mutateAsync: dirFind } = useDirFind(), importFiles = useImportFiles(uploadState, importFilesChunkThreshold), importFolders = useImportFolders(uploadState), createThumbnailsForImages = useCreateThumbnailsForImages(uploadState), initDir = useInitDir(), trackFiles = useTrackFiles(uploadState), trackFolders = useTrackFolders(uploadState), uppy = useUppy({ uploadState, chunkSize }), { emit: emit2, on, off } = useUppyEvents(uppy), { addFiles, removeFile, reset: resetUppy, upload: uploadUppy } = useUppyMethods(uppy), setStage = useCallback(
    (stage) => {
      console.log("setStage", stage), uploadState.current.stage = stage, emit2("updateStage", uploadState.current.stage);
    },
    [emit2, uploadState]
  ), reset2 = useCallback(() => {
    resetUppy(), resetUploadState(uploadState), emit2("reset", null);
  }, [emit2, resetUppy, uploadState]), uploadRetry = useCallback(() => {
    uppy.retryAll();
  }, [uppy]), handleError = useCallback(
    (error) => {
      emit2("error", { error, stage: uploadState.current.stage });
    },
    [emit2, uploadState]
  ), emitDirCreating = useCallback(() => {
    setStage("dirCreating"), emitDirCreatingManually || emit2("dirCreating", null);
  }, [emit2, emitDirCreatingManually, setStage]), onDirCreating = useCallback(async () => {
    try {
      uploadState.current.dir = await initDir(
        dependants ?? null,
        featureType,
        persistType,
        "/",
        "/",
        systemFolderNodeId
      ), setStage("dirCreated"), emit2("dirCreated", null);
    } catch (e2) {
      handleError(e2);
    }
  }, [
    dependants,
    emit2,
    featureType,
    handleError,
    initDir,
    persistType,
    setStage,
    systemFolderNodeId,
    uploadState
  ]), onDirCreated = useCallback(() => {
    setStage("dirFinding"), emit2("dirFinding", null);
  }, [emit2, setStage]), onDirFinding = useCallback(async () => {
    var _a6, _b;
    try {
      assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id);
      const dir = await dirFind(uploadState.current.dir.id);
      uploadState.current.dir.rootFolderImportRequestId = ((_b = dir == null ? void 0 : dir.findDataImportRequestByDataImportRequestId) == null ? void 0 : _b.rootFolderImportRequestId) ?? null, setStage("dirFound"), emit2("dirFound", null);
    } catch (e2) {
      handleError(e2);
    }
  }, [dirFind, emit2, handleError, setStage, uploadState]), onDirFound = useCallback(() => {
    var _a6;
    assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id), setStage("folderTracking"), emit2("folderTracking", { dataImportRequestId: uploadState.current.dir.id });
  }, [emit2, setStage, uploadState]), onFolderTracking = useCallback(async () => {
    var _a6;
    try {
      assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id), await trackFolders(), setStage("folderTracked"), emit2("folderTracked", { dataImportRequestId: uploadState.current.dir.id });
    } catch (e2) {
      handleError(e2);
    }
  }, [emit2, handleError, setStage, trackFolders, uploadState]), onFolderTracked = useCallback(() => {
    var _a6;
    assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id), setStage("fileTracking"), emit2("fileTracking", { dataImportRequestId: uploadState.current.dir.id });
  }, [emit2, setStage, uploadState]), onFileTracking = useCallback(async () => {
    var _a6;
    try {
      assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id), await trackFiles(), setStage("fileTracked"), emit2("fileTracked", { dataImportRequestId: uploadState.current.dir.id });
    } catch (e2) {
      handleError(e2);
    }
  }, [emit2, handleError, setStage, trackFiles, uploadState]), emitFolderImporting = useCallback(() => {
    var _a6;
    assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id), setStage("folderImporting"), emit2("folderImporting", { dataImportRequestId: uploadState.current.dir.id });
  }, [emit2, setStage, uploadState]), onFolderImporting = useCallback(async () => {
    var _a6;
    try {
      assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id), await importFolders(), setStage("folderImported"), emit2("folderImported", { dataImportRequestId: uploadState.current.dir.id }), uploadUppy();
    } catch (e2) {
      handleError(e2);
    }
  }, [emit2, handleError, importFolders, setStage, uploadState, uploadUppy]), emitFileImporting = useCallback(() => {
    var _a6;
    assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id), setStage("fileImporting"), emit2("fileImporting", { dataImportRequestId: uploadState.current.dir.id });
  }, [emit2, setStage, uploadState]), onFileImporting = useCallback(async () => {
    var _a6;
    try {
      assertIsString((_a6 = uploadState.current.dir) == null ? void 0 : _a6.id), await importFiles(), await createThumbnailsForImages(), emit2("updateGraph", uploadState.current.graph), setStage("fileImported"), emit2("fileImported", { dataImportRequestId: uploadState.current.dir.id });
    } catch (e2) {
      handleError(e2);
    }
  }, [createThumbnailsForImages, emit2, handleError, importFiles, setStage, uploadState]), retry = useCallback(() => {
    uploadState.current.stage === "dirCreating" && onDirCreating(), uploadState.current.stage === "dirCreated" && onDirCreated(), uploadState.current.stage === "dirFinding" && onDirFinding(), uploadState.current.stage === "dirFound" && onDirFound(), uploadState.current.stage === "folderTracking" && onFolderTracking(), uploadState.current.stage === "folderTracked" && onFolderTracked(), uploadState.current.stage === "fileTracking" && onFileTracking(), uploadState.current.stage === "fileTracked" && emitFolderImporting(), uploadState.current.stage === "folderImporting" && onFolderImporting(), uploadState.current.stage === "folderImported" && uploadRetry(), uploadState.current.stage === "fileImporting" && onFileImporting();
  }, [
    emitFolderImporting,
    onDirCreated,
    onDirCreating,
    onDirFinding,
    onDirFound,
    onFileImporting,
    onFileTracking,
    onFolderImporting,
    onFolderTracked,
    onFolderTracking,
    uploadRetry,
    uploadState
  ]), upload = useCallback(async () => {
    emitFolderImporting();
  }, [emitFolderImporting]);
  return useEffect(() => {
    const onFilesAdded = /* @__PURE__ */ __name(async (files) => {
      uploadState.current.graph = buildGraph(files), uploadState.current.totalNumberOfFiles = getTotalNumberOfFiles(uploadState.current.graph), emit2("updateGraph", uploadState.current.graph), emitDirCreating();
    }, "onFilesAdded"), onComplete = /* @__PURE__ */ __name(async (result2) => {
      console.log(
        `upload complete, ${result2.successful.length} successful, ${result2.failed.length} failed`
      );
    }, "onComplete"), onUploadSuccess = /* @__PURE__ */ __name(async (file) => {
      console.log(`upload success, filename: ${file.name}`), uploadState.current.result === null ? uploadState.current.result = { successful: [file], failed: [] } : uploadState.current.result.successful.push(file), uploadState.current.result.successful.length === uploadState.current.totalNumberOfFiles && (console.log("all files were uploaded successfully"), emitFileImporting());
    }, "onUploadSuccess");
    return uppy.on("files-added", onFilesAdded).on("complete", onComplete).on("upload-success", onUploadSuccess), () => {
      uppy.off("files-added", onFilesAdded).off("complete", onComplete).off("upload-success", onUploadSuccess);
    };
  }, [
    dirFind,
    emit2,
    emitDirCreating,
    emitFileImporting,
    featureType,
    handleError,
    importFiles,
    initDir,
    persistType,
    setStage,
    systemFolderNodeId,
    trackFiles,
    trackFolders,
    uploadState,
    uppy
  ]), useEffect(() => (on("dirCreating", onDirCreating), on("dirCreated", onDirCreated), on("dirFinding", onDirFinding), on("dirFound", onDirFound), on("folderTracking", onFolderTracking), on("folderTracked", onFolderTracked), on("fileTracking", onFileTracking), on("folderImporting", onFolderImporting), on("fileImporting", onFileImporting), () => {
    off("dirCreating", onDirCreating), off("dirCreated", onDirCreated), off("dirFinding", onDirFinding), off("dirFound", onDirFound), off("folderTracking", onFolderTracking), off("folderTracked", onFolderTracked), off("fileTracking", onFileTracking), off("folderImporting", onFolderImporting), off("fileImporting", onFileImporting);
  }), [
    dirFind,
    emit2,
    off,
    on,
    onDirCreated,
    onDirCreating,
    onDirFinding,
    onDirFound,
    onFileImporting,
    onFileTracking,
    onFolderImporting,
    onFolderTracked,
    onFolderTracking,
    setStage,
    trackFiles,
    trackFolders,
    uploadState
  ]), {
    addFiles,
    off,
    on,
    removeFile,
    reset: reset2,
    retry,
    upload,
    uploadRetry,
    uploadState,
    uppy,
    emit: emit2
  };
}, "useUploader$1"), Byte = 1, KB = 1024 * Byte, MB = 1024 * KB, GB = 1024 * MB, TB = 1024 * GB, UNIT = {
  Byte,
  KB,
  MB,
  GB
}, UNITS = {
  BYTE: {
    BYTE: 1,
    KB: 1024,
    MB: 1024 * 1024,
    GB: 1024 * 1024 * 1024,
    TB: 1024 * 1024 * 1024 * 1024
  },
  SECOND: {
    SECOND: 1,
    MINUTE: 60,
    HOUR: 60 * 60
  },
  MILLISECOND: {
    MILLISECOND: 1,
    SECOND: 1e3,
    MINUTE: 1e3 * 60,
    HOUR: 1e3 * 60 * 60
  }
};
function getGlobal() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
__name(getGlobal, "getGlobal");
function getDevTools() {
  const w2 = getGlobal();
  if (w2.__xstate__)
    return w2.__xstate__;
}
__name(getDevTools, "getDevTools");
const devToolsAdapter = /* @__PURE__ */ __name((service) => {
  if (typeof window > "u")
    return;
  const devTools = getDevTools();
  devTools && devTools.register(service);
}, "devToolsAdapter"), _Mailbox = class _Mailbox {
  constructor(_process) {
    this._process = _process, this._active = !1, this._current = null, this._last = null;
  }
  start() {
    this._active = !0, this.flush();
  }
  clear() {
    this._current && (this._current.next = null, this._last = this._current);
  }
  enqueue(event) {
    const enqueued = {
      value: event,
      next: null
    };
    if (this._current) {
      this._last.next = enqueued, this._last = enqueued;
      return;
    }
    this._current = enqueued, this._last = enqueued, this._active && this.flush();
  }
  flush() {
    for (; this._current; ) {
      const consumed = this._current;
      this._process(consumed.value), this._current = consumed.next;
    }
    this._last = null;
  }
};
__name(_Mailbox, "Mailbox");
let Mailbox = _Mailbox;
const STATE_DELIMITER = ".", TARGETLESS_KEY = "", NULL_EVENT = "", STATE_IDENTIFIER$1 = "#", WILDCARD = "*", XSTATE_INIT = "xstate.init", XSTATE_ERROR = "xstate.error", XSTATE_STOP = "xstate.stop";
function createAfterEvent(delayRef, id2) {
  return {
    type: `xstate.after.${delayRef}.${id2}`
  };
}
__name(createAfterEvent, "createAfterEvent");
function createDoneStateEvent(id2, output2) {
  return {
    type: `xstate.done.state.${id2}`,
    output: output2
  };
}
__name(createDoneStateEvent, "createDoneStateEvent");
function createDoneActorEvent(invokeId, output2) {
  return {
    type: `xstate.done.actor.${invokeId}`,
    output: output2,
    actorId: invokeId
  };
}
__name(createDoneActorEvent, "createDoneActorEvent");
function createErrorActorEvent(id2, error) {
  return {
    type: `xstate.error.actor.${id2}`,
    error,
    actorId: id2
  };
}
__name(createErrorActorEvent, "createErrorActorEvent");
function createInitEvent(input) {
  return {
    type: XSTATE_INIT,
    input
  };
}
__name(createInitEvent, "createInitEvent");
function reportUnhandledError(err) {
  setTimeout(() => {
    throw err;
  });
}
__name(reportUnhandledError, "reportUnhandledError");
const symbolObservable = typeof Symbol == "function" && Symbol.observable || "@@observable";
function matchesState(parentStateId, childStateId) {
  const parentStateValue = toStateValue(parentStateId), childStateValue = toStateValue(childStateId);
  return typeof childStateValue == "string" ? typeof parentStateValue == "string" ? childStateValue === parentStateValue : !1 : typeof parentStateValue == "string" ? parentStateValue in childStateValue : Object.keys(parentStateValue).every((key) => key in childStateValue ? matchesState(parentStateValue[key], childStateValue[key]) : !1);
}
__name(matchesState, "matchesState");
function toStatePath(stateId) {
  if (isArray$1(stateId))
    return stateId;
  let result2 = [], segment = "";
  for (let i2 = 0; i2 < stateId.length; i2++) {
    switch (stateId.charCodeAt(i2)) {
      case 92:
        segment += stateId[i2 + 1], i2++;
        continue;
      case 46:
        result2.push(segment), segment = "";
        continue;
    }
    segment += stateId[i2];
  }
  return result2.push(segment), result2;
}
__name(toStatePath, "toStatePath");
function toStateValue(stateValue) {
  if (isMachineSnapshot(stateValue))
    return stateValue.value;
  if (typeof stateValue != "string")
    return stateValue;
  const statePath = toStatePath(stateValue);
  return pathToStateValue(statePath);
}
__name(toStateValue, "toStateValue");
function pathToStateValue(statePath) {
  if (statePath.length === 1)
    return statePath[0];
  const value = {};
  let marker = value;
  for (let i2 = 0; i2 < statePath.length - 1; i2++)
    if (i2 === statePath.length - 2)
      marker[statePath[i2]] = statePath[i2 + 1];
    else {
      const previous = marker;
      marker = {}, previous[statePath[i2]] = marker;
    }
  return value;
}
__name(pathToStateValue, "pathToStateValue");
function mapValues(collection, iteratee) {
  const result2 = {}, collectionKeys = Object.keys(collection);
  for (let i2 = 0; i2 < collectionKeys.length; i2++) {
    const key = collectionKeys[i2];
    result2[key] = iteratee(collection[key], key, collection, i2);
  }
  return result2;
}
__name(mapValues, "mapValues");
function toArrayStrict(value) {
  return isArray$1(value) ? value : [value];
}
__name(toArrayStrict, "toArrayStrict");
function toArray$1(value) {
  return value === void 0 ? [] : toArrayStrict(value);
}
__name(toArray$1, "toArray$1");
function resolveOutput(mapper, context, event, self2) {
  return typeof mapper == "function" ? mapper({
    context,
    event,
    self: self2
  }) : mapper;
}
__name(resolveOutput, "resolveOutput");
function isArray$1(value) {
  return Array.isArray(value);
}
__name(isArray$1, "isArray$1");
function isErrorActorEvent(event) {
  return event.type.startsWith("xstate.error.actor");
}
__name(isErrorActorEvent, "isErrorActorEvent");
function toTransitionConfigArray(configLike) {
  return toArrayStrict(configLike).map((transitionLike) => typeof transitionLike > "u" || typeof transitionLike == "string" ? {
    target: transitionLike
  } : transitionLike);
}
__name(toTransitionConfigArray, "toTransitionConfigArray");
function normalizeTarget(target) {
  if (!(target === void 0 || target === TARGETLESS_KEY))
    return toArray$1(target);
}
__name(normalizeTarget, "normalizeTarget");
function toObserver(nextHandler, errorHandler, completionHandler) {
  var _a6, _b, _c2;
  const isObserver = typeof nextHandler == "object", self2 = isObserver ? nextHandler : void 0;
  return {
    next: (_a6 = isObserver ? nextHandler.next : nextHandler) == null ? void 0 : _a6.bind(self2),
    error: (_b = isObserver ? nextHandler.error : errorHandler) == null ? void 0 : _b.bind(self2),
    complete: (_c2 = isObserver ? nextHandler.complete : completionHandler) == null ? void 0 : _c2.bind(self2)
  };
}
__name(toObserver, "toObserver");
function createInvokeId(stateNodeId, index) {
  return `${index}.${stateNodeId}`;
}
__name(createInvokeId, "createInvokeId");
function resolveReferencedActor(machine, src) {
  const match2 = src.match(/^xstate\.invoke\.(\d+)\.(.*)/);
  if (!match2)
    return machine.implementations.actors[src];
  const [, indexStr, nodeId] = match2, invokeConfig = machine.getStateNodeById(nodeId).config.invoke;
  return (Array.isArray(invokeConfig) ? invokeConfig[indexStr] : invokeConfig).src;
}
__name(resolveReferencedActor, "resolveReferencedActor");
function createScheduledEventId(actorRef, id2) {
  return `${actorRef.sessionId}.${id2}`;
}
__name(createScheduledEventId, "createScheduledEventId");
let idCounter = 0;
function createSystem(rootActor, options) {
  const children = /* @__PURE__ */ new Map(), keyedActors = /* @__PURE__ */ new Map(), reverseKeyedActors = /* @__PURE__ */ new WeakMap(), inspectionObservers = /* @__PURE__ */ new Set(), timerMap = {}, {
    clock,
    logger
  } = options, scheduler = {
    schedule: /* @__PURE__ */ __name((source, target, event, delay, id2 = Math.random().toString(36).slice(2)) => {
      const scheduledEvent = {
        source,
        target,
        event,
        delay,
        id: id2,
        startedAt: Date.now()
      }, scheduledEventId = createScheduledEventId(source, id2);
      system._snapshot._scheduledEvents[scheduledEventId] = scheduledEvent;
      const timeout = clock.setTimeout(() => {
        delete timerMap[scheduledEventId], delete system._snapshot._scheduledEvents[scheduledEventId], system._relay(source, target, event);
      }, delay);
      timerMap[scheduledEventId] = timeout;
    }, "schedule"),
    cancel: /* @__PURE__ */ __name((source, id2) => {
      const scheduledEventId = createScheduledEventId(source, id2), timeout = timerMap[scheduledEventId];
      delete timerMap[scheduledEventId], delete system._snapshot._scheduledEvents[scheduledEventId], clock.clearTimeout(timeout);
    }, "cancel"),
    cancelAll: /* @__PURE__ */ __name((actorRef) => {
      for (const scheduledEventId in system._snapshot._scheduledEvents) {
        const scheduledEvent = system._snapshot._scheduledEvents[scheduledEventId];
        scheduledEvent.source === actorRef && scheduler.cancel(actorRef, scheduledEvent.id);
      }
    }, "cancelAll")
  }, sendInspectionEvent = /* @__PURE__ */ __name((event) => {
    if (!inspectionObservers.size)
      return;
    const resolvedInspectionEvent = {
      ...event,
      rootId: rootActor.sessionId
    };
    inspectionObservers.forEach((observer) => {
      var _a6;
      return (_a6 = observer.next) == null ? void 0 : _a6.call(observer, resolvedInspectionEvent);
    });
  }, "sendInspectionEvent"), system = {
    _snapshot: {
      _scheduledEvents: ((options == null ? void 0 : options.snapshot) && options.snapshot.scheduler) ?? {}
    },
    _bookId: /* @__PURE__ */ __name(() => `x:${idCounter++}`, "_bookId"),
    _register: /* @__PURE__ */ __name((sessionId, actorRef) => (children.set(sessionId, actorRef), sessionId), "_register"),
    _unregister: /* @__PURE__ */ __name((actorRef) => {
      children.delete(actorRef.sessionId);
      const systemId = reverseKeyedActors.get(actorRef);
      systemId !== void 0 && (keyedActors.delete(systemId), reverseKeyedActors.delete(actorRef));
    }, "_unregister"),
    get: /* @__PURE__ */ __name((systemId) => keyedActors.get(systemId), "get"),
    _set: /* @__PURE__ */ __name((systemId, actorRef) => {
      const existing = keyedActors.get(systemId);
      if (existing && existing !== actorRef)
        throw new Error(`Actor with system ID '${systemId}' already exists.`);
      keyedActors.set(systemId, actorRef), reverseKeyedActors.set(actorRef, systemId);
    }, "_set"),
    inspect: /* @__PURE__ */ __name((observerOrFn) => {
      const observer = toObserver(observerOrFn);
      return inspectionObservers.add(observer), {
        unsubscribe() {
          inspectionObservers.delete(observer);
        }
      };
    }, "inspect"),
    _sendInspectionEvent: sendInspectionEvent,
    _relay: /* @__PURE__ */ __name((source, target, event) => {
      system._sendInspectionEvent({
        type: "@xstate.event",
        sourceRef: source,
        actorRef: target,
        event
      }), target._send(event);
    }, "_relay"),
    scheduler,
    getSnapshot: /* @__PURE__ */ __name(() => ({
      _scheduledEvents: {
        ...system._snapshot._scheduledEvents
      }
    }), "getSnapshot"),
    start: /* @__PURE__ */ __name(() => {
      const scheduledEvents = system._snapshot._scheduledEvents;
      system._snapshot._scheduledEvents = {};
      for (const scheduledId in scheduledEvents) {
        const {
          source,
          target,
          event,
          delay,
          id: id2
        } = scheduledEvents[scheduledId];
        scheduler.schedule(source, target, event, delay, id2);
      }
    }, "start"),
    _clock: clock,
    _logger: logger
  };
  return system;
}
__name(createSystem, "createSystem");
const $$ACTOR_TYPE = 1;
let ProcessingStatus = /* @__PURE__ */ function(ProcessingStatus2) {
  return ProcessingStatus2[ProcessingStatus2.NotStarted = 0] = "NotStarted", ProcessingStatus2[ProcessingStatus2.Running = 1] = "Running", ProcessingStatus2[ProcessingStatus2.Stopped = 2] = "Stopped", ProcessingStatus2;
}({});
const defaultOptions = {
  clock: {
    setTimeout: /* @__PURE__ */ __name((fn, ms) => setTimeout(fn, ms), "setTimeout"),
    clearTimeout: /* @__PURE__ */ __name((id2) => clearTimeout(id2), "clearTimeout")
  },
  logger: console.log.bind(console),
  devTools: !1
}, _Actor = class _Actor {
  /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */
  constructor(logic, options) {
    this.logic = logic, this._snapshot = void 0, this.clock = void 0, this.options = void 0, this.id = void 0, this.mailbox = new Mailbox(this._process.bind(this)), this.observers = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Map(), this.logger = void 0, this._processingStatus = ProcessingStatus.NotStarted, this._parent = void 0, this._syncSnapshot = void 0, this.ref = void 0, this._actorScope = void 0, this._systemId = void 0, this.sessionId = void 0, this.system = void 0, this._doneEvent = void 0, this.src = void 0, this._deferred = [];
    const resolvedOptions = {
      ...defaultOptions,
      ...options
    }, {
      clock,
      logger,
      parent,
      syncSnapshot,
      id: id2,
      systemId,
      inspect
    } = resolvedOptions;
    this.system = parent ? parent.system : createSystem(this, {
      clock,
      logger
    }), inspect && !parent && this.system.inspect(toObserver(inspect)), this.sessionId = this.system._bookId(), this.id = id2 ?? this.sessionId, this.logger = (options == null ? void 0 : options.logger) ?? this.system._logger, this.clock = (options == null ? void 0 : options.clock) ?? this.system._clock, this._parent = parent, this._syncSnapshot = syncSnapshot, this.options = resolvedOptions, this.src = resolvedOptions.src ?? logic, this.ref = this, this._actorScope = {
      self: this,
      id: this.id,
      sessionId: this.sessionId,
      logger: this.logger,
      defer: /* @__PURE__ */ __name((fn) => {
        this._deferred.push(fn);
      }, "defer"),
      system: this.system,
      stopChild: /* @__PURE__ */ __name((child) => {
        if (child._parent !== this)
          throw new Error(`Cannot stop child actor ${child.id} of ${this.id} because it is not a child`);
        child._stop();
      }, "stopChild"),
      emit: /* @__PURE__ */ __name((emittedEvent) => {
        const listeners = this.eventListeners.get(emittedEvent.type), wildcardListener = this.eventListeners.get("*");
        if (!listeners && !wildcardListener)
          return;
        const allListeners = /* @__PURE__ */ new Set([...listeners ? listeners.values() : [], ...wildcardListener ? wildcardListener.values() : []]);
        for (const handler of Array.from(allListeners))
          handler(emittedEvent);
      }, "emit")
    }, this.send = this.send.bind(this), this.system._sendInspectionEvent({
      type: "@xstate.actor",
      actorRef: this
    }), systemId && (this._systemId = systemId, this.system._set(systemId, this)), this._initState((options == null ? void 0 : options.snapshot) ?? (options == null ? void 0 : options.state)), systemId && this._snapshot.status !== "active" && this.system._unregister(this);
  }
  _initState(persistedState) {
    var _a6;
    try {
      this._snapshot = persistedState ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(persistedState, this._actorScope) : persistedState : this.logic.getInitialSnapshot(this._actorScope, (_a6 = this.options) == null ? void 0 : _a6.input);
    } catch (err) {
      this._snapshot = {
        status: "error",
        output: void 0,
        error: err
      };
    }
  }
  update(snapshot, event) {
    var _a6, _b;
    this._snapshot = snapshot;
    let deferredFn;
    for (; deferredFn = this._deferred.shift(); )
      try {
        deferredFn();
      } catch (err) {
        this._deferred.length = 0, this._snapshot = {
          ...snapshot,
          status: "error",
          error: err
        };
      }
    switch (this._snapshot.status) {
      case "active":
        for (const observer of this.observers)
          try {
            (_a6 = observer.next) == null || _a6.call(observer, snapshot);
          } catch (err) {
            reportUnhandledError(err);
          }
        break;
      case "done":
        for (const observer of this.observers)
          try {
            (_b = observer.next) == null || _b.call(observer, snapshot);
          } catch (err) {
            reportUnhandledError(err);
          }
        this._stopProcedure(), this._complete(), this._doneEvent = createDoneActorEvent(this.id, this._snapshot.output), this._parent && this.system._relay(this, this._parent, this._doneEvent);
        break;
      case "error":
        this._error(this._snapshot.error);
        break;
    }
    this.system._sendInspectionEvent({
      type: "@xstate.snapshot",
      actorRef: this,
      event,
      snapshot
    });
  }
  /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */
  subscribe(nextListenerOrObserver, errorListener, completeListener) {
    var _a6;
    const observer = toObserver(nextListenerOrObserver, errorListener, completeListener);
    if (this._processingStatus !== ProcessingStatus.Stopped)
      this.observers.add(observer);
    else
      switch (this._snapshot.status) {
        case "done":
          try {
            (_a6 = observer.complete) == null || _a6.call(observer);
          } catch (err) {
            reportUnhandledError(err);
          }
          break;
        case "error": {
          const err = this._snapshot.error;
          if (!observer.error)
            reportUnhandledError(err);
          else
            try {
              observer.error(err);
            } catch (err2) {
              reportUnhandledError(err2);
            }
          break;
        }
      }
    return {
      unsubscribe: /* @__PURE__ */ __name(() => {
        this.observers.delete(observer);
      }, "unsubscribe")
    };
  }
  on(type, handler) {
    let listeners = this.eventListeners.get(type);
    listeners || (listeners = /* @__PURE__ */ new Set(), this.eventListeners.set(type, listeners));
    const wrappedHandler = handler.bind(void 0);
    return listeners.add(wrappedHandler), {
      unsubscribe: /* @__PURE__ */ __name(() => {
        listeners.delete(wrappedHandler);
      }, "unsubscribe")
    };
  }
  /** Starts the Actor from the initial state */
  start() {
    if (this._processingStatus === ProcessingStatus.Running)
      return this;
    this._syncSnapshot && this.subscribe({
      next: /* @__PURE__ */ __name((snapshot) => {
        snapshot.status === "active" && this.system._relay(this, this._parent, {
          type: `xstate.snapshot.${this.id}`,
          snapshot
        });
      }, "next"),
      error: /* @__PURE__ */ __name(() => {
      }, "error")
    }), this.system._register(this.sessionId, this), this._systemId && this.system._set(this._systemId, this), this._processingStatus = ProcessingStatus.Running;
    const initEvent = createInitEvent(this.options.input);
    switch (this.system._sendInspectionEvent({
      type: "@xstate.event",
      sourceRef: this._parent,
      actorRef: this,
      event: initEvent
    }), this._snapshot.status) {
      case "done":
        return this.update(this._snapshot, initEvent), this;
      case "error":
        return this._error(this._snapshot.error), this;
    }
    if (this._parent || this.system.start(), this.logic.start)
      try {
        this.logic.start(this._snapshot, this._actorScope);
      } catch (err) {
        return this._snapshot = {
          ...this._snapshot,
          status: "error",
          error: err
        }, this._error(err), this;
      }
    return this.update(this._snapshot, initEvent), this.options.devTools && this.attachDevTools(), this.mailbox.start(), this;
  }
  _process(event) {
    let nextState, caughtError;
    try {
      nextState = this.logic.transition(this._snapshot, event, this._actorScope);
    } catch (err) {
      caughtError = {
        err
      };
    }
    if (caughtError) {
      const {
        err
      } = caughtError;
      this._snapshot = {
        ...this._snapshot,
        status: "error",
        error: err
      }, this._error(err);
      return;
    }
    this.update(nextState, event), event.type === XSTATE_STOP && (this._stopProcedure(), this._complete());
  }
  _stop() {
    return this._processingStatus === ProcessingStatus.Stopped ? this : (this.mailbox.clear(), this._processingStatus === ProcessingStatus.NotStarted ? (this._processingStatus = ProcessingStatus.Stopped, this) : (this.mailbox.enqueue({
      type: XSTATE_STOP
    }), this));
  }
  /** Stops the Actor and unsubscribe all listeners. */
  stop() {
    if (this._parent)
      throw new Error("A non-root actor cannot be stopped directly.");
    return this._stop();
  }
  _complete() {
    var _a6;
    for (const observer of this.observers)
      try {
        (_a6 = observer.complete) == null || _a6.call(observer);
      } catch (err) {
        reportUnhandledError(err);
      }
    this.observers.clear();
  }
  _reportError(err) {
    if (!this.observers.size) {
      this._parent || reportUnhandledError(err);
      return;
    }
    let reportError = !1;
    for (const observer of this.observers) {
      const errorListener = observer.error;
      reportError || (reportError = !errorListener);
      try {
        errorListener == null || errorListener(err);
      } catch (err2) {
        reportUnhandledError(err2);
      }
    }
    this.observers.clear(), reportError && reportUnhandledError(err);
  }
  _error(err) {
    this._stopProcedure(), this._reportError(err), this._parent && this.system._relay(this, this._parent, createErrorActorEvent(this.id, err));
  }
  // TODO: atm children don't belong entirely to the actor so
  // in a way - it's not even super aware of them
  // so we can't stop them from here but we really should!
  // right now, they are being stopped within the machine's transition
  // but that could throw and leave us with "orphaned" active actors
  _stopProcedure() {
    return this._processingStatus !== ProcessingStatus.Running ? this : (this.system.scheduler.cancelAll(this), this.mailbox.clear(), this.mailbox = new Mailbox(this._process.bind(this)), this._processingStatus = ProcessingStatus.Stopped, this.system._unregister(this), this);
  }
  /** @internal */
  _send(event) {
    this._processingStatus !== ProcessingStatus.Stopped && this.mailbox.enqueue(event);
  }
  /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */
  send(event) {
    this.system._relay(void 0, this, event);
  }
  attachDevTools() {
    const {
      devTools
    } = this.options;
    devTools && (typeof devTools == "function" ? devTools : devToolsAdapter)(this);
  }
  toJSON() {
    return {
      xstate$$type: $$ACTOR_TYPE,
      id: this.id
    };
  }
  /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */
  getPersistedSnapshot(options) {
    return this.logic.getPersistedSnapshot(this._snapshot, options);
  }
  [symbolObservable]() {
    return this;
  }
  /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */
  getSnapshot() {
    return this._snapshot;
  }
};
__name(_Actor, "Actor");
let Actor = _Actor;
function createActor(logic, ...[options]) {
  return new Actor(logic, options);
}
__name(createActor, "createActor");
function resolveCancel(_2, snapshot, actionArgs, actionParams, {
  sendId
}) {
  const resolvedSendId = typeof sendId == "function" ? sendId(actionArgs, actionParams) : sendId;
  return [snapshot, resolvedSendId];
}
__name(resolveCancel, "resolveCancel");
function executeCancel(actorScope, resolvedSendId) {
  actorScope.defer(() => {
    actorScope.system.scheduler.cancel(actorScope.self, resolvedSendId);
  });
}
__name(executeCancel, "executeCancel");
function cancel(sendId) {
  function cancel2(args, params) {
  }
  return __name(cancel2, "cancel"), cancel2.type = "xstate.cancel", cancel2.sendId = sendId, cancel2.resolve = resolveCancel, cancel2.execute = executeCancel, cancel2;
}
__name(cancel, "cancel");
function resolveSpawn(actorScope, snapshot, actionArgs, _actionParams, {
  id: id2,
  systemId,
  src,
  input,
  syncSnapshot
}) {
  const logic = typeof src == "string" ? resolveReferencedActor(snapshot.machine, src) : src, resolvedId = typeof id2 == "function" ? id2(actionArgs) : id2;
  let actorRef;
  return logic && (actorRef = createActor(logic, {
    id: resolvedId,
    src,
    parent: actorScope.self,
    syncSnapshot,
    systemId,
    input: typeof input == "function" ? input({
      context: snapshot.context,
      event: actionArgs.event,
      self: actorScope.self
    }) : input
  })), [cloneMachineSnapshot(snapshot, {
    children: {
      ...snapshot.children,
      [resolvedId]: actorRef
    }
  }), {
    id: id2,
    actorRef
  }];
}
__name(resolveSpawn, "resolveSpawn");
function executeSpawn(actorScope, {
  id: id2,
  actorRef
}) {
  actorRef && actorScope.defer(() => {
    actorRef._processingStatus !== ProcessingStatus.Stopped && actorRef.start();
  });
}
__name(executeSpawn, "executeSpawn");
function spawnChild(...[src, {
  id: id2,
  systemId,
  input,
  syncSnapshot = !1
} = {}]) {
  function spawnChild2(args, params) {
  }
  return __name(spawnChild2, "spawnChild"), spawnChild2.type = "snapshot.spawnChild", spawnChild2.id = id2, spawnChild2.systemId = systemId, spawnChild2.src = src, spawnChild2.input = input, spawnChild2.syncSnapshot = syncSnapshot, spawnChild2.resolve = resolveSpawn, spawnChild2.execute = executeSpawn, spawnChild2;
}
__name(spawnChild, "spawnChild");
function resolveStop(_2, snapshot, args, actionParams, {
  actorRef
}) {
  const actorRefOrString = typeof actorRef == "function" ? actorRef(args, actionParams) : actorRef, resolvedActorRef = typeof actorRefOrString == "string" ? snapshot.children[actorRefOrString] : actorRefOrString;
  let children = snapshot.children;
  return resolvedActorRef && (children = {
    ...children
  }, delete children[resolvedActorRef.id]), [cloneMachineSnapshot(snapshot, {
    children
  }), resolvedActorRef];
}
__name(resolveStop, "resolveStop");
function executeStop(actorScope, actorRef) {
  if (actorRef) {
    if (actorScope.system._unregister(actorRef), actorRef._processingStatus !== ProcessingStatus.Running) {
      actorScope.stopChild(actorRef);
      return;
    }
    actorScope.defer(() => {
      actorScope.stopChild(actorRef);
    });
  }
}
__name(executeStop, "executeStop");
function stopChild(actorRef) {
  function stop(args, params) {
  }
  return __name(stop, "stop"), stop.type = "xstate.stopChild", stop.actorRef = actorRef, stop.resolve = resolveStop, stop.execute = executeStop, stop;
}
__name(stopChild, "stopChild");
function evaluateGuard(guard, context, event, snapshot) {
  const {
    machine
  } = snapshot, isInline = typeof guard == "function", resolved = isInline ? guard : machine.implementations.guards[typeof guard == "string" ? guard : guard.type];
  if (!isInline && !resolved)
    throw new Error(`Guard '${typeof guard == "string" ? guard : guard.type}' is not implemented.'.`);
  if (typeof resolved != "function")
    return evaluateGuard(resolved, context, event, snapshot);
  const guardArgs = {
    context,
    event
  }, guardParams = isInline || typeof guard == "string" ? void 0 : "params" in guard ? typeof guard.params == "function" ? guard.params({
    context,
    event
  }) : guard.params : void 0;
  return "check" in resolved ? resolved.check(
    snapshot,
    guardArgs,
    resolved
    // this holds all params
  ) : resolved(guardArgs, guardParams);
}
__name(evaluateGuard, "evaluateGuard");
const isAtomicStateNode = /* @__PURE__ */ __name((stateNode) => stateNode.type === "atomic" || stateNode.type === "final", "isAtomicStateNode");
function getChildren(stateNode) {
  return Object.values(stateNode.states).filter((sn) => sn.type !== "history");
}
__name(getChildren, "getChildren");
function getProperAncestors(stateNode, toStateNode) {
  const ancestors = [];
  if (toStateNode === stateNode)
    return ancestors;
  let m2 = stateNode.parent;
  for (; m2 && m2 !== toStateNode; )
    ancestors.push(m2), m2 = m2.parent;
  return ancestors;
}
__name(getProperAncestors, "getProperAncestors");
function getAllStateNodes(stateNodes) {
  const nodeSet = new Set(stateNodes), adjList = getAdjList(nodeSet);
  for (const s2 of nodeSet)
    if (s2.type === "compound" && (!adjList.get(s2) || !adjList.get(s2).length))
      getInitialStateNodesWithTheirAncestors(s2).forEach((sn) => nodeSet.add(sn));
    else if (s2.type === "parallel") {
      for (const child of getChildren(s2))
        if (child.type !== "history" && !nodeSet.has(child)) {
          const initialStates = getInitialStateNodesWithTheirAncestors(child);
          for (const initialStateNode of initialStates)
            nodeSet.add(initialStateNode);
        }
    }
  for (const s2 of nodeSet) {
    let m2 = s2.parent;
    for (; m2; )
      nodeSet.add(m2), m2 = m2.parent;
  }
  return nodeSet;
}
__name(getAllStateNodes, "getAllStateNodes");
function getValueFromAdj(baseNode, adjList) {
  const childStateNodes = adjList.get(baseNode);
  if (!childStateNodes)
    return {};
  if (baseNode.type === "compound") {
    const childStateNode = childStateNodes[0];
    if (childStateNode) {
      if (isAtomicStateNode(childStateNode))
        return childStateNode.key;
    } else
      return {};
  }
  const stateValue = {};
  for (const childStateNode of childStateNodes)
    stateValue[childStateNode.key] = getValueFromAdj(childStateNode, adjList);
  return stateValue;
}
__name(getValueFromAdj, "getValueFromAdj");
function getAdjList(stateNodes) {
  const adjList = /* @__PURE__ */ new Map();
  for (const s2 of stateNodes)
    adjList.has(s2) || adjList.set(s2, []), s2.parent && (adjList.has(s2.parent) || adjList.set(s2.parent, []), adjList.get(s2.parent).push(s2));
  return adjList;
}
__name(getAdjList, "getAdjList");
function getStateValue(rootNode, stateNodes) {
  const config = getAllStateNodes(stateNodes);
  return getValueFromAdj(rootNode, getAdjList(config));
}
__name(getStateValue, "getStateValue");
function isInFinalState(stateNodeSet, stateNode) {
  return stateNode.type === "compound" ? getChildren(stateNode).some((s2) => s2.type === "final" && stateNodeSet.has(s2)) : stateNode.type === "parallel" ? getChildren(stateNode).every((sn) => isInFinalState(stateNodeSet, sn)) : stateNode.type === "final";
}
__name(isInFinalState, "isInFinalState");
const isStateId = /* @__PURE__ */ __name((str) => str[0] === STATE_IDENTIFIER$1, "isStateId");
function getCandidates(stateNode, receivedEventType) {
  return stateNode.transitions.get(receivedEventType) || [...stateNode.transitions.keys()].filter((eventDescriptor) => {
    if (eventDescriptor === WILDCARD)
      return !0;
    if (!eventDescriptor.endsWith(".*"))
      return !1;
    const partialEventTokens = eventDescriptor.split("."), eventTokens = receivedEventType.split(".");
    for (let tokenIndex = 0; tokenIndex < partialEventTokens.length; tokenIndex++) {
      const partialEventToken = partialEventTokens[tokenIndex], eventToken = eventTokens[tokenIndex];
      if (partialEventToken === "*")
        return tokenIndex === partialEventTokens.length - 1;
      if (partialEventToken !== eventToken)
        return !1;
    }
    return !0;
  }).sort((a2, b2) => b2.length - a2.length).flatMap((key) => stateNode.transitions.get(key));
}
__name(getCandidates, "getCandidates");
function getDelayedTransitions(stateNode) {
  const afterConfig = stateNode.config.after;
  if (!afterConfig)
    return [];
  const mutateEntryExit = /* @__PURE__ */ __name((delay, i2) => {
    const afterEvent = createAfterEvent(delay, stateNode.id), eventType = afterEvent.type;
    return stateNode.entry.push(raise(afterEvent, {
      id: eventType,
      delay
    })), stateNode.exit.push(cancel(eventType)), eventType;
  }, "mutateEntryExit");
  return Object.keys(afterConfig).flatMap((delay, i2) => {
    const configTransition = afterConfig[delay], resolvedTransition = typeof configTransition == "string" ? {
      target: configTransition
    } : configTransition, resolvedDelay = Number.isNaN(+delay) ? delay : +delay, eventType = mutateEntryExit(resolvedDelay);
    return toArray$1(resolvedTransition).map((transition) => ({
      ...transition,
      event: eventType,
      delay: resolvedDelay
    }));
  }).map((delayedTransition) => {
    const {
      delay
    } = delayedTransition;
    return {
      ...formatTransition(stateNode, delayedTransition.event, delayedTransition),
      delay
    };
  });
}
__name(getDelayedTransitions, "getDelayedTransitions");
function formatTransition(stateNode, descriptor, transitionConfig) {
  const normalizedTarget = normalizeTarget(transitionConfig.target), reenter = transitionConfig.reenter ?? !1, target = resolveTarget(stateNode, normalizedTarget), transition = {
    ...transitionConfig,
    actions: toArray$1(transitionConfig.actions),
    guard: transitionConfig.guard,
    target,
    source: stateNode,
    reenter,
    eventType: descriptor,
    toJSON: /* @__PURE__ */ __name(() => ({
      ...transition,
      source: `#${stateNode.id}`,
      target: target ? target.map((t2) => `#${t2.id}`) : void 0
    }), "toJSON")
  };
  return transition;
}
__name(formatTransition, "formatTransition");
function formatTransitions(stateNode) {
  const transitions = /* @__PURE__ */ new Map();
  if (stateNode.config.on)
    for (const descriptor of Object.keys(stateNode.config.on)) {
      if (descriptor === NULL_EVENT)
        throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
      const transitionsConfig = stateNode.config.on[descriptor];
      transitions.set(descriptor, toTransitionConfigArray(transitionsConfig).map((t2) => formatTransition(stateNode, descriptor, t2)));
    }
  if (stateNode.config.onDone) {
    const descriptor = `xstate.done.state.${stateNode.id}`;
    transitions.set(descriptor, toTransitionConfigArray(stateNode.config.onDone).map((t2) => formatTransition(stateNode, descriptor, t2)));
  }
  for (const invokeDef of stateNode.invoke) {
    if (invokeDef.onDone) {
      const descriptor = `xstate.done.actor.${invokeDef.id}`;
      transitions.set(descriptor, toTransitionConfigArray(invokeDef.onDone).map((t2) => formatTransition(stateNode, descriptor, t2)));
    }
    if (invokeDef.onError) {
      const descriptor = `xstate.error.actor.${invokeDef.id}`;
      transitions.set(descriptor, toTransitionConfigArray(invokeDef.onError).map((t2) => formatTransition(stateNode, descriptor, t2)));
    }
    if (invokeDef.onSnapshot) {
      const descriptor = `xstate.snapshot.${invokeDef.id}`;
      transitions.set(descriptor, toTransitionConfigArray(invokeDef.onSnapshot).map((t2) => formatTransition(stateNode, descriptor, t2)));
    }
  }
  for (const delayedTransition of stateNode.after) {
    let existing = transitions.get(delayedTransition.eventType);
    existing || (existing = [], transitions.set(delayedTransition.eventType, existing)), existing.push(delayedTransition);
  }
  return transitions;
}
__name(formatTransitions, "formatTransitions");
function formatInitialTransition(stateNode, _target) {
  const resolvedTarget = typeof _target == "string" ? stateNode.states[_target] : _target ? stateNode.states[_target.target] : void 0;
  if (!resolvedTarget && _target)
    throw new Error(`Initial state node "${_target}" not found on parent state node #${stateNode.id}`);
  const transition = {
    source: stateNode,
    actions: !_target || typeof _target == "string" ? [] : toArray$1(_target.actions),
    eventType: null,
    reenter: !1,
    target: resolvedTarget ? [resolvedTarget] : [],
    toJSON: /* @__PURE__ */ __name(() => ({
      ...transition,
      source: `#${stateNode.id}`,
      target: resolvedTarget ? [`#${resolvedTarget.id}`] : []
    }), "toJSON")
  };
  return transition;
}
__name(formatInitialTransition, "formatInitialTransition");
function resolveTarget(stateNode, targets) {
  if (targets !== void 0)
    return targets.map((target) => {
      if (typeof target != "string")
        return target;
      if (isStateId(target))
        return stateNode.machine.getStateNodeById(target);
      const isInternalTarget = target[0] === STATE_DELIMITER;
      if (isInternalTarget && !stateNode.parent)
        return getStateNodeByPath(stateNode, target.slice(1));
      const resolvedTarget = isInternalTarget ? stateNode.key + target : target;
      if (stateNode.parent)
        try {
          return getStateNodeByPath(stateNode.parent, resolvedTarget);
        } catch (err) {
          throw new Error(`Invalid transition definition for state node '${stateNode.id}':
${err.message}`);
        }
      else
        throw new Error(`Invalid target: "${target}" is not a valid target from the root node. Did you mean ".${target}"?`);
    });
}
__name(resolveTarget, "resolveTarget");
function resolveHistoryDefaultTransition(stateNode) {
  const normalizedTarget = normalizeTarget(stateNode.config.target);
  return normalizedTarget ? {
    target: normalizedTarget.map((t2) => typeof t2 == "string" ? getStateNodeByPath(stateNode.parent, t2) : t2)
  } : stateNode.parent.initial;
}
__name(resolveHistoryDefaultTransition, "resolveHistoryDefaultTransition");
function isHistoryNode(stateNode) {
  return stateNode.type === "history";
}
__name(isHistoryNode, "isHistoryNode");
function getInitialStateNodesWithTheirAncestors(stateNode) {
  const states = getInitialStateNodes(stateNode);
  for (const initialState2 of states)
    for (const ancestor of getProperAncestors(initialState2, stateNode))
      states.add(ancestor);
  return states;
}
__name(getInitialStateNodesWithTheirAncestors, "getInitialStateNodesWithTheirAncestors");
function getInitialStateNodes(stateNode) {
  const set2 = /* @__PURE__ */ new Set();
  function iter(descStateNode) {
    if (!set2.has(descStateNode)) {
      if (set2.add(descStateNode), descStateNode.type === "compound")
        iter(descStateNode.initial.target[0]);
      else if (descStateNode.type === "parallel")
        for (const child of getChildren(descStateNode))
          iter(child);
    }
  }
  return __name(iter, "iter"), iter(stateNode), set2;
}
__name(getInitialStateNodes, "getInitialStateNodes");
function getStateNode(stateNode, stateKey) {
  if (isStateId(stateKey))
    return stateNode.machine.getStateNodeById(stateKey);
  if (!stateNode.states)
    throw new Error(`Unable to retrieve child state '${stateKey}' from '${stateNode.id}'; no child states exist.`);
  const result2 = stateNode.states[stateKey];
  if (!result2)
    throw new Error(`Child state '${stateKey}' does not exist on '${stateNode.id}'`);
  return result2;
}
__name(getStateNode, "getStateNode");
function getStateNodeByPath(stateNode, statePath) {
  if (typeof statePath == "string" && isStateId(statePath))
    try {
      return stateNode.machine.getStateNodeById(statePath);
    } catch {
    }
  const arrayStatePath = toStatePath(statePath).slice();
  let currentStateNode = stateNode;
  for (; arrayStatePath.length; ) {
    const key = arrayStatePath.shift();
    if (!key.length)
      break;
    currentStateNode = getStateNode(currentStateNode, key);
  }
  return currentStateNode;
}
__name(getStateNodeByPath, "getStateNodeByPath");
function getStateNodes(stateNode, stateValue) {
  if (typeof stateValue == "string") {
    const childStateNode = stateNode.states[stateValue];
    if (!childStateNode)
      throw new Error(`State '${stateValue}' does not exist on '${stateNode.id}'`);
    return [stateNode, childStateNode];
  }
  const childStateKeys = Object.keys(stateValue), childStateNodes = childStateKeys.map((subStateKey) => getStateNode(stateNode, subStateKey)).filter(Boolean);
  return [stateNode.machine.root, stateNode].concat(childStateNodes, childStateKeys.reduce((allSubStateNodes, subStateKey) => {
    const subStateNode = getStateNode(stateNode, subStateKey);
    if (!subStateNode)
      return allSubStateNodes;
    const subStateNodes = getStateNodes(subStateNode, stateValue[subStateKey]);
    return allSubStateNodes.concat(subStateNodes);
  }, []));
}
__name(getStateNodes, "getStateNodes");
function transitionAtomicNode(stateNode, stateValue, snapshot, event) {
  const next = getStateNode(stateNode, stateValue).next(snapshot, event);
  return !next || !next.length ? stateNode.next(snapshot, event) : next;
}
__name(transitionAtomicNode, "transitionAtomicNode");
function transitionCompoundNode(stateNode, stateValue, snapshot, event) {
  const subStateKeys = Object.keys(stateValue), childStateNode = getStateNode(stateNode, subStateKeys[0]), next = transitionNode(childStateNode, stateValue[subStateKeys[0]], snapshot, event);
  return !next || !next.length ? stateNode.next(snapshot, event) : next;
}
__name(transitionCompoundNode, "transitionCompoundNode");
function transitionParallelNode(stateNode, stateValue, snapshot, event) {
  const allInnerTransitions = [];
  for (const subStateKey of Object.keys(stateValue)) {
    const subStateValue = stateValue[subStateKey];
    if (!subStateValue)
      continue;
    const subStateNode = getStateNode(stateNode, subStateKey), innerTransitions = transitionNode(subStateNode, subStateValue, snapshot, event);
    innerTransitions && allInnerTransitions.push(...innerTransitions);
  }
  return allInnerTransitions.length ? allInnerTransitions : stateNode.next(snapshot, event);
}
__name(transitionParallelNode, "transitionParallelNode");
function transitionNode(stateNode, stateValue, snapshot, event) {
  return typeof stateValue == "string" ? transitionAtomicNode(stateNode, stateValue, snapshot, event) : Object.keys(stateValue).length === 1 ? transitionCompoundNode(stateNode, stateValue, snapshot, event) : transitionParallelNode(stateNode, stateValue, snapshot, event);
}
__name(transitionNode, "transitionNode");
function getHistoryNodes(stateNode) {
  return Object.keys(stateNode.states).map((key) => stateNode.states[key]).filter((sn) => sn.type === "history");
}
__name(getHistoryNodes, "getHistoryNodes");
function isDescendant(childStateNode, parentStateNode) {
  let marker = childStateNode;
  for (; marker.parent && marker.parent !== parentStateNode; )
    marker = marker.parent;
  return marker.parent === parentStateNode;
}
__name(isDescendant, "isDescendant");
function hasIntersection(s1, s2) {
  const set1 = new Set(s1), set2 = new Set(s2);
  for (const item of set1)
    if (set2.has(item))
      return !0;
  for (const item of set2)
    if (set1.has(item))
      return !0;
  return !1;
}
__name(hasIntersection, "hasIntersection");
function removeConflictingTransitions(enabledTransitions, stateNodeSet, historyValue) {
  const filteredTransitions = /* @__PURE__ */ new Set();
  for (const t1 of enabledTransitions) {
    let t1Preempted = !1;
    const transitionsToRemove = /* @__PURE__ */ new Set();
    for (const t2 of filteredTransitions)
      if (hasIntersection(computeExitSet([t1], stateNodeSet, historyValue), computeExitSet([t2], stateNodeSet, historyValue)))
        if (isDescendant(t1.source, t2.source))
          transitionsToRemove.add(t2);
        else {
          t1Preempted = !0;
          break;
        }
    if (!t1Preempted) {
      for (const t3 of transitionsToRemove)
        filteredTransitions.delete(t3);
      filteredTransitions.add(t1);
    }
  }
  return Array.from(filteredTransitions);
}
__name(removeConflictingTransitions, "removeConflictingTransitions");
function findLeastCommonAncestor(stateNodes) {
  const [head, ...tail] = stateNodes;
  for (const ancestor of getProperAncestors(head, void 0))
    if (tail.every((sn) => isDescendant(sn, ancestor)))
      return ancestor;
}
__name(findLeastCommonAncestor, "findLeastCommonAncestor");
function getEffectiveTargetStates(transition, historyValue) {
  if (!transition.target)
    return [];
  const targets = /* @__PURE__ */ new Set();
  for (const targetNode of transition.target)
    if (isHistoryNode(targetNode))
      if (historyValue[targetNode.id])
        for (const node of historyValue[targetNode.id])
          targets.add(node);
      else
        for (const node of getEffectiveTargetStates(resolveHistoryDefaultTransition(targetNode), historyValue))
          targets.add(node);
    else
      targets.add(targetNode);
  return [...targets];
}
__name(getEffectiveTargetStates, "getEffectiveTargetStates");
function getTransitionDomain(transition, historyValue) {
  const targetStates = getEffectiveTargetStates(transition, historyValue);
  if (!targetStates)
    return;
  if (!transition.reenter && targetStates.every((target) => target === transition.source || isDescendant(target, transition.source)))
    return transition.source;
  const lca = findLeastCommonAncestor(targetStates.concat(transition.source));
  if (lca)
    return lca;
  if (!transition.reenter)
    return transition.source.machine.root;
}
__name(getTransitionDomain, "getTransitionDomain");
function computeExitSet(transitions, stateNodeSet, historyValue) {
  var _a6;
  const statesToExit = /* @__PURE__ */ new Set();
  for (const t2 of transitions)
    if ((_a6 = t2.target) != null && _a6.length) {
      const domain = getTransitionDomain(t2, historyValue);
      t2.reenter && t2.source === domain && statesToExit.add(domain);
      for (const stateNode of stateNodeSet)
        isDescendant(stateNode, domain) && statesToExit.add(stateNode);
    }
  return [...statesToExit];
}
__name(computeExitSet, "computeExitSet");
function areStateNodeCollectionsEqual(prevStateNodes, nextStateNodeSet) {
  if (prevStateNodes.length !== nextStateNodeSet.size)
    return !1;
  for (const node of prevStateNodes)
    if (!nextStateNodeSet.has(node))
      return !1;
  return !0;
}
__name(areStateNodeCollectionsEqual, "areStateNodeCollectionsEqual");
function microstep(transitions, currentSnapshot, actorScope, event, isInitial, internalQueue) {
  if (!transitions.length)
    return currentSnapshot;
  const mutStateNodeSet = new Set(currentSnapshot._nodes);
  let historyValue = currentSnapshot.historyValue;
  const filteredTransitions = removeConflictingTransitions(transitions, mutStateNodeSet, historyValue);
  let nextState = currentSnapshot;
  isInitial || ([nextState, historyValue] = exitStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, historyValue, internalQueue)), nextState = resolveActionsAndContext(nextState, event, actorScope, filteredTransitions.flatMap((t2) => t2.actions), internalQueue), nextState = enterStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial);
  const nextStateNodes = [...mutStateNodeSet];
  nextState.status === "done" && (nextState = resolveActionsAndContext(nextState, event, actorScope, nextStateNodes.sort((a2, b2) => b2.order - a2.order).flatMap((state) => state.exit), internalQueue));
  try {
    return historyValue === currentSnapshot.historyValue && areStateNodeCollectionsEqual(currentSnapshot._nodes, mutStateNodeSet) ? nextState : cloneMachineSnapshot(nextState, {
      _nodes: nextStateNodes,
      historyValue
    });
  } catch (e2) {
    throw e2;
  }
}
__name(microstep, "microstep");
function getMachineOutput(snapshot, event, actorScope, rootNode, rootCompletionNode) {
  if (rootNode.output === void 0)
    return;
  const doneStateEvent = createDoneStateEvent(rootCompletionNode.id, rootCompletionNode.output !== void 0 && rootCompletionNode.parent ? resolveOutput(rootCompletionNode.output, snapshot.context, event, actorScope.self) : void 0);
  return resolveOutput(rootNode.output, snapshot.context, doneStateEvent, actorScope.self);
}
__name(getMachineOutput, "getMachineOutput");
function enterStates(currentSnapshot, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial) {
  let nextSnapshot = currentSnapshot;
  const statesToEnter = /* @__PURE__ */ new Set(), statesForDefaultEntry = /* @__PURE__ */ new Set();
  computeEntrySet(filteredTransitions, historyValue, statesForDefaultEntry, statesToEnter), isInitial && statesForDefaultEntry.add(currentSnapshot.machine.root);
  const completedNodes = /* @__PURE__ */ new Set();
  for (const stateNodeToEnter of [...statesToEnter].sort((a2, b2) => a2.order - b2.order)) {
    mutStateNodeSet.add(stateNodeToEnter);
    const actions = [];
    actions.push(...stateNodeToEnter.entry);
    for (const invokeDef of stateNodeToEnter.invoke)
      actions.push(spawnChild(invokeDef.src, {
        ...invokeDef,
        syncSnapshot: !!invokeDef.onSnapshot
      }));
    if (statesForDefaultEntry.has(stateNodeToEnter)) {
      const initialActions = stateNodeToEnter.initial.actions;
      actions.push(...initialActions);
    }
    if (nextSnapshot = resolveActionsAndContext(nextSnapshot, event, actorScope, actions, internalQueue, stateNodeToEnter.invoke.map((invokeDef) => invokeDef.id)), stateNodeToEnter.type === "final") {
      const parent = stateNodeToEnter.parent;
      let ancestorMarker = (parent == null ? void 0 : parent.type) === "parallel" ? parent : parent == null ? void 0 : parent.parent, rootCompletionNode = ancestorMarker || stateNodeToEnter;
      for ((parent == null ? void 0 : parent.type) === "compound" && internalQueue.push(createDoneStateEvent(parent.id, stateNodeToEnter.output !== void 0 ? resolveOutput(stateNodeToEnter.output, nextSnapshot.context, event, actorScope.self) : void 0)); (ancestorMarker == null ? void 0 : ancestorMarker.type) === "parallel" && !completedNodes.has(ancestorMarker) && isInFinalState(mutStateNodeSet, ancestorMarker); )
        completedNodes.add(ancestorMarker), internalQueue.push(createDoneStateEvent(ancestorMarker.id)), rootCompletionNode = ancestorMarker, ancestorMarker = ancestorMarker.parent;
      if (ancestorMarker)
        continue;
      nextSnapshot = cloneMachineSnapshot(nextSnapshot, {
        status: "done",
        output: getMachineOutput(nextSnapshot, event, actorScope, nextSnapshot.machine.root, rootCompletionNode)
      });
    }
  }
  return nextSnapshot;
}
__name(enterStates, "enterStates");
function computeEntrySet(transitions, historyValue, statesForDefaultEntry, statesToEnter) {
  for (const t2 of transitions) {
    const domain = getTransitionDomain(t2, historyValue);
    for (const s2 of t2.target || [])
      !isHistoryNode(s2) && // if the target is different than the source then it will *definitely* be entered
      (t2.source !== s2 || // we know that the domain can't lie within the source
      // if it's different than the source then it's outside of it and it means that the target has to be entered as well
      t2.source !== domain || // reentering transitions always enter the target, even if it's the source itself
      t2.reenter) && (statesToEnter.add(s2), statesForDefaultEntry.add(s2)), addDescendantStatesToEnter(s2, historyValue, statesForDefaultEntry, statesToEnter);
    const targetStates = getEffectiveTargetStates(t2, historyValue);
    for (const s2 of targetStates) {
      const ancestors = getProperAncestors(s2, domain);
      (domain == null ? void 0 : domain.type) === "parallel" && ancestors.push(domain), addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, !t2.source.parent && t2.reenter ? void 0 : domain);
    }
  }
}
__name(computeEntrySet, "computeEntrySet");
function addDescendantStatesToEnter(stateNode, historyValue, statesForDefaultEntry, statesToEnter) {
  var _a6;
  if (isHistoryNode(stateNode))
    if (historyValue[stateNode.id]) {
      const historyStateNodes = historyValue[stateNode.id];
      for (const s2 of historyStateNodes)
        statesToEnter.add(s2), addDescendantStatesToEnter(s2, historyValue, statesForDefaultEntry, statesToEnter);
      for (const s2 of historyStateNodes)
        addProperAncestorStatesToEnter(s2, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
    } else {
      const historyDefaultTransition = resolveHistoryDefaultTransition(stateNode);
      for (const s2 of historyDefaultTransition.target)
        statesToEnter.add(s2), historyDefaultTransition === ((_a6 = stateNode.parent) == null ? void 0 : _a6.initial) && statesForDefaultEntry.add(stateNode.parent), addDescendantStatesToEnter(s2, historyValue, statesForDefaultEntry, statesToEnter);
      for (const s2 of historyDefaultTransition.target)
        addProperAncestorStatesToEnter(s2, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
    }
  else if (stateNode.type === "compound") {
    const [initialState2] = stateNode.initial.target;
    isHistoryNode(initialState2) || (statesToEnter.add(initialState2), statesForDefaultEntry.add(initialState2)), addDescendantStatesToEnter(initialState2, historyValue, statesForDefaultEntry, statesToEnter), addProperAncestorStatesToEnter(initialState2, stateNode, statesToEnter, historyValue, statesForDefaultEntry);
  } else if (stateNode.type === "parallel")
    for (const child of getChildren(stateNode).filter((sn) => !isHistoryNode(sn)))
      [...statesToEnter].some((s2) => isDescendant(s2, child)) || (isHistoryNode(child) || (statesToEnter.add(child), statesForDefaultEntry.add(child)), addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter));
}
__name(addDescendantStatesToEnter, "addDescendantStatesToEnter");
function addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, reentrancyDomain) {
  for (const anc of ancestors)
    if ((!reentrancyDomain || isDescendant(anc, reentrancyDomain)) && statesToEnter.add(anc), anc.type === "parallel")
      for (const child of getChildren(anc).filter((sn) => !isHistoryNode(sn)))
        [...statesToEnter].some((s2) => isDescendant(s2, child)) || (statesToEnter.add(child), addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter));
}
__name(addAncestorStatesToEnter, "addAncestorStatesToEnter");
function addProperAncestorStatesToEnter(stateNode, toStateNode, statesToEnter, historyValue, statesForDefaultEntry) {
  addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, getProperAncestors(stateNode, toStateNode));
}
__name(addProperAncestorStatesToEnter, "addProperAncestorStatesToEnter");
function exitStates(currentSnapshot, event, actorScope, transitions, mutStateNodeSet, historyValue, internalQueue) {
  let nextSnapshot = currentSnapshot;
  const statesToExit = computeExitSet(transitions, mutStateNodeSet, historyValue);
  statesToExit.sort((a2, b2) => b2.order - a2.order);
  let changedHistory;
  for (const exitStateNode of statesToExit)
    for (const historyNode of getHistoryNodes(exitStateNode)) {
      let predicate;
      historyNode.history === "deep" ? predicate = /* @__PURE__ */ __name((sn) => isAtomicStateNode(sn) && isDescendant(sn, exitStateNode), "predicate") : predicate = /* @__PURE__ */ __name((sn) => sn.parent === exitStateNode, "predicate"), changedHistory ?? (changedHistory = {
        ...historyValue
      }), changedHistory[historyNode.id] = Array.from(mutStateNodeSet).filter(predicate);
    }
  for (const s2 of statesToExit)
    nextSnapshot = resolveActionsAndContext(nextSnapshot, event, actorScope, [...s2.exit, ...s2.invoke.map((def) => stopChild(def.id))], internalQueue), mutStateNodeSet.delete(s2);
  return [nextSnapshot, changedHistory || historyValue];
}
__name(exitStates, "exitStates");
let executingCustomAction = !1;
function resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, extra, retries) {
  const {
    machine
  } = currentSnapshot;
  let intermediateSnapshot = currentSnapshot;
  for (const action of actions) {
    let executeAction = function() {
      actorScope.system._sendInspectionEvent({
        type: "@xstate.action",
        actorRef: actorScope.self,
        action: {
          type: typeof action == "string" ? action : typeof action == "object" ? action.type : action.name || "(anonymous)",
          params: actionParams
        }
      });
      try {
        executingCustomAction = resolvedAction, resolvedAction(actionArgs, actionParams);
      } finally {
        executingCustomAction = !1;
      }
    };
    __name(executeAction, "executeAction");
    const isInline = typeof action == "function", resolvedAction = isInline ? action : (
      // the existing type of `.actions` assumes non-nullable `TExpressionAction`
      // it's fine to cast this here to get a common type and lack of errors in the rest of the code
      // our logic below makes sure that we call those 2 "variants" correctly
      machine.implementations.actions[typeof action == "string" ? action : action.type]
    );
    if (!resolvedAction)
      continue;
    const actionArgs = {
      context: intermediateSnapshot.context,
      event,
      self: actorScope.self,
      system: actorScope.system
    }, actionParams = isInline || typeof action == "string" ? void 0 : "params" in action ? typeof action.params == "function" ? action.params({
      context: intermediateSnapshot.context,
      event
    }) : action.params : void 0;
    if (!("resolve" in resolvedAction)) {
      actorScope.self._processingStatus === ProcessingStatus.Running ? executeAction() : actorScope.defer(() => {
        executeAction();
      });
      continue;
    }
    const builtinAction = resolvedAction, [nextState, params, actions2] = builtinAction.resolve(
      actorScope,
      intermediateSnapshot,
      actionArgs,
      actionParams,
      resolvedAction,
      // this holds all params
      extra
    );
    intermediateSnapshot = nextState, "retryResolve" in builtinAction && (retries == null || retries.push([builtinAction, params])), "execute" in builtinAction && (actorScope.self._processingStatus === ProcessingStatus.Running ? builtinAction.execute(actorScope, params) : actorScope.defer(builtinAction.execute.bind(null, actorScope, params))), actions2 && (intermediateSnapshot = resolveAndExecuteActionsWithContext(intermediateSnapshot, event, actorScope, actions2, extra, retries));
  }
  return intermediateSnapshot;
}
__name(resolveAndExecuteActionsWithContext, "resolveAndExecuteActionsWithContext");
function resolveActionsAndContext(currentSnapshot, event, actorScope, actions, internalQueue, deferredActorIds) {
  const retries = deferredActorIds ? [] : void 0, nextState = resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, {
    internalQueue,
    deferredActorIds
  }, retries);
  return retries == null || retries.forEach(([builtinAction, params]) => {
    builtinAction.retryResolve(actorScope, nextState, params);
  }), nextState;
}
__name(resolveActionsAndContext, "resolveActionsAndContext");
function macrostep(snapshot, event, actorScope, internalQueue = []) {
  let nextSnapshot = snapshot;
  const microstates = [];
  function addMicrostate(microstate, event2, transitions) {
    actorScope.system._sendInspectionEvent({
      type: "@xstate.microstep",
      actorRef: actorScope.self,
      event: event2,
      snapshot: microstate,
      _transitions: transitions
    }), microstates.push(microstate);
  }
  if (__name(addMicrostate, "addMicrostate"), event.type === XSTATE_STOP)
    return nextSnapshot = cloneMachineSnapshot(stopChildren(nextSnapshot, event, actorScope), {
      status: "stopped"
    }), addMicrostate(nextSnapshot, event, []), {
      snapshot: nextSnapshot,
      microstates
    };
  let nextEvent = event;
  if (nextEvent.type !== XSTATE_INIT) {
    const currentEvent = nextEvent, isErr = isErrorActorEvent(currentEvent), transitions = selectTransitions(currentEvent, nextSnapshot);
    if (isErr && !transitions.length)
      return nextSnapshot = cloneMachineSnapshot(snapshot, {
        status: "error",
        error: currentEvent.error
      }), addMicrostate(nextSnapshot, currentEvent, []), {
        snapshot: nextSnapshot,
        microstates
      };
    nextSnapshot = microstep(
      transitions,
      snapshot,
      actorScope,
      nextEvent,
      !1,
      // isInitial
      internalQueue
    ), addMicrostate(nextSnapshot, currentEvent, transitions);
  }
  let shouldSelectEventlessTransitions = !0;
  for (; nextSnapshot.status === "active"; ) {
    let enabledTransitions = shouldSelectEventlessTransitions ? selectEventlessTransitions(nextSnapshot, nextEvent) : [];
    const previousState = enabledTransitions.length ? nextSnapshot : void 0;
    if (!enabledTransitions.length) {
      if (!internalQueue.length)
        break;
      nextEvent = internalQueue.shift(), enabledTransitions = selectTransitions(nextEvent, nextSnapshot);
    }
    nextSnapshot = microstep(enabledTransitions, nextSnapshot, actorScope, nextEvent, !1, internalQueue), shouldSelectEventlessTransitions = nextSnapshot !== previousState, addMicrostate(nextSnapshot, nextEvent, enabledTransitions);
  }
  return nextSnapshot.status !== "active" && stopChildren(nextSnapshot, nextEvent, actorScope), {
    snapshot: nextSnapshot,
    microstates
  };
}
__name(macrostep, "macrostep");
function stopChildren(nextState, event, actorScope) {
  return resolveActionsAndContext(nextState, event, actorScope, Object.values(nextState.children).map((child) => stopChild(child)), []);
}
__name(stopChildren, "stopChildren");
function selectTransitions(event, nextState) {
  return nextState.machine.getTransitionData(nextState, event);
}
__name(selectTransitions, "selectTransitions");
function selectEventlessTransitions(nextState, event) {
  const enabledTransitionSet = /* @__PURE__ */ new Set(), atomicStates = nextState._nodes.filter(isAtomicStateNode);
  for (const stateNode of atomicStates)
    loop: for (const s2 of [stateNode].concat(getProperAncestors(stateNode, void 0)))
      if (s2.always) {
        for (const transition of s2.always)
          if (transition.guard === void 0 || evaluateGuard(transition.guard, nextState.context, event, nextState)) {
            enabledTransitionSet.add(transition);
            break loop;
          }
      }
  return removeConflictingTransitions(Array.from(enabledTransitionSet), new Set(nextState._nodes), nextState.historyValue);
}
__name(selectEventlessTransitions, "selectEventlessTransitions");
function resolveStateValue(rootNode, stateValue) {
  const allStateNodes = getAllStateNodes(getStateNodes(rootNode, stateValue));
  return getStateValue(rootNode, [...allStateNodes]);
}
__name(resolveStateValue, "resolveStateValue");
function isMachineSnapshot(value) {
  return !!value && typeof value == "object" && "machine" in value && "value" in value;
}
__name(isMachineSnapshot, "isMachineSnapshot");
const machineSnapshotMatches = /* @__PURE__ */ __name(function(testValue) {
  return matchesState(testValue, this.value);
}, "matches"), machineSnapshotHasTag = /* @__PURE__ */ __name(function(tag) {
  return this.tags.has(tag);
}, "hasTag"), machineSnapshotCan = /* @__PURE__ */ __name(function(event) {
  const transitionData = this.machine.getTransitionData(this, event);
  return !!(transitionData != null && transitionData.length) && // Check that at least one transition is not forbidden
  transitionData.some((t2) => t2.target !== void 0 || t2.actions.length);
}, "can"), machineSnapshotToJSON = /* @__PURE__ */ __name(function() {
  const {
    _nodes: nodes,
    tags,
    machine,
    getMeta: getMeta2,
    toJSON: toJSON3,
    can: can2,
    hasTag: hasTag2,
    matches: matches2,
    ...jsonValues
  } = this;
  return {
    ...jsonValues,
    tags: Array.from(tags)
  };
}, "toJSON"), machineSnapshotGetMeta = /* @__PURE__ */ __name(function() {
  return this._nodes.reduce((acc, stateNode) => (stateNode.meta !== void 0 && (acc[stateNode.id] = stateNode.meta), acc), {});
}, "getMeta");
function createMachineSnapshot(config, machine) {
  return {
    status: config.status,
    output: config.output,
    error: config.error,
    machine,
    context: config.context,
    _nodes: config._nodes,
    value: getStateValue(machine.root, config._nodes),
    tags: new Set(config._nodes.flatMap((sn) => sn.tags)),
    children: config.children,
    historyValue: config.historyValue || {},
    matches: machineSnapshotMatches,
    hasTag: machineSnapshotHasTag,
    can: machineSnapshotCan,
    getMeta: machineSnapshotGetMeta,
    toJSON: machineSnapshotToJSON
  };
}
__name(createMachineSnapshot, "createMachineSnapshot");
function cloneMachineSnapshot(snapshot, config = {}) {
  return createMachineSnapshot({
    ...snapshot,
    ...config
  }, snapshot.machine);
}
__name(cloneMachineSnapshot, "cloneMachineSnapshot");
function getPersistedSnapshot(snapshot, options) {
  const {
    _nodes: nodes,
    tags,
    machine,
    children,
    context,
    can: can2,
    hasTag: hasTag2,
    matches: matches2,
    getMeta: getMeta2,
    toJSON: toJSON3,
    ...jsonValues
  } = snapshot, childrenJson = {};
  for (const id2 in children) {
    const child = children[id2];
    childrenJson[id2] = {
      snapshot: child.getPersistedSnapshot(options),
      src: child.src,
      systemId: child._systemId,
      syncSnapshot: child._syncSnapshot
    };
  }
  return {
    ...jsonValues,
    context: persistContext(context),
    children: childrenJson
  };
}
__name(getPersistedSnapshot, "getPersistedSnapshot");
function persistContext(contextPart) {
  let copy;
  for (const key in contextPart) {
    const value = contextPart[key];
    if (value && typeof value == "object")
      if ("sessionId" in value && "send" in value && "ref" in value)
        copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
          ...contextPart
        }), copy[key] = {
          xstate$$type: $$ACTOR_TYPE,
          id: value.id
        };
      else {
        const result2 = persistContext(value);
        result2 !== value && (copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
          ...contextPart
        }), copy[key] = result2);
      }
  }
  return copy ?? contextPart;
}
__name(persistContext, "persistContext");
function resolveRaise(_2, snapshot, args, actionParams, {
  event: eventOrExpr,
  id: id2,
  delay
}, {
  internalQueue
}) {
  const delaysMap = snapshot.machine.implementations.delays;
  if (typeof eventOrExpr == "string")
    throw new Error(`Only event objects may be used with raise; use raise({ type: "${eventOrExpr}" }) instead`);
  const resolvedEvent = typeof eventOrExpr == "function" ? eventOrExpr(args, actionParams) : eventOrExpr;
  let resolvedDelay;
  if (typeof delay == "string") {
    const configDelay = delaysMap && delaysMap[delay];
    resolvedDelay = typeof configDelay == "function" ? configDelay(args, actionParams) : configDelay;
  } else
    resolvedDelay = typeof delay == "function" ? delay(args, actionParams) : delay;
  return typeof resolvedDelay != "number" && internalQueue.push(resolvedEvent), [snapshot, {
    event: resolvedEvent,
    id: id2,
    delay: resolvedDelay
  }];
}
__name(resolveRaise, "resolveRaise");
function executeRaise(actorScope, params) {
  const {
    event,
    delay,
    id: id2
  } = params;
  if (typeof delay == "number") {
    actorScope.defer(() => {
      const self2 = actorScope.self;
      actorScope.system.scheduler.schedule(self2, self2, event, delay, id2);
    });
    return;
  }
}
__name(executeRaise, "executeRaise");
function raise(eventOrExpr, options) {
  function raise2(args, params) {
  }
  return __name(raise2, "raise"), raise2.type = "xstate.raise", raise2.event = eventOrExpr, raise2.id = options == null ? void 0 : options.id, raise2.delay = options == null ? void 0 : options.delay, raise2.resolve = resolveRaise, raise2.execute = executeRaise, raise2;
}
__name(raise, "raise");
const XSTATE_PROMISE_RESOLVE = "xstate.promise.resolve", XSTATE_PROMISE_REJECT = "xstate.promise.reject", controllerMap = /* @__PURE__ */ new WeakMap();
function fromPromise(promiseCreator) {
  return {
    config: promiseCreator,
    transition: /* @__PURE__ */ __name((state, event, scope) => {
      var _a6;
      if (state.status !== "active")
        return state;
      switch (event.type) {
        case XSTATE_PROMISE_RESOLVE: {
          const resolvedValue = event.data;
          return {
            ...state,
            status: "done",
            output: resolvedValue,
            input: void 0
          };
        }
        case XSTATE_PROMISE_REJECT:
          return {
            ...state,
            status: "error",
            error: event.data,
            input: void 0
          };
        case XSTATE_STOP:
          return (_a6 = controllerMap.get(scope.self)) == null || _a6.abort(), {
            ...state,
            status: "stopped",
            input: void 0
          };
        default:
          return state;
      }
    }, "transition"),
    start: /* @__PURE__ */ __name((state, {
      self: self2,
      system,
      emit: emit2
    }) => {
      if (state.status !== "active")
        return;
      const controller = new AbortController();
      controllerMap.set(self2, controller), Promise.resolve(promiseCreator({
        input: state.input,
        system,
        self: self2,
        signal: controller.signal,
        emit: emit2
      })).then((response) => {
        self2.getSnapshot().status === "active" && (controllerMap.delete(self2), system._relay(self2, self2, {
          type: XSTATE_PROMISE_RESOLVE,
          data: response
        }));
      }, (errorData) => {
        self2.getSnapshot().status === "active" && (controllerMap.delete(self2), system._relay(self2, self2, {
          type: XSTATE_PROMISE_REJECT,
          data: errorData
        }));
      });
    }, "start"),
    getInitialSnapshot: /* @__PURE__ */ __name((_2, input) => ({
      status: "active",
      output: void 0,
      error: void 0,
      input
    }), "getInitialSnapshot"),
    getPersistedSnapshot: /* @__PURE__ */ __name((snapshot) => snapshot, "getPersistedSnapshot"),
    restoreSnapshot: /* @__PURE__ */ __name((snapshot) => snapshot, "restoreSnapshot")
  };
}
__name(fromPromise, "fromPromise");
function createSpawner(actorScope, {
  machine,
  context
}, event, spawnedChildren) {
  const spawn = /* @__PURE__ */ __name((src, options = {}) => {
    const {
      systemId,
      input
    } = options;
    if (typeof src == "string") {
      const logic = resolveReferencedActor(machine, src);
      if (!logic)
        throw new Error(`Actor logic '${src}' not implemented in machine '${machine.id}'`);
      const actorRef = createActor(logic, {
        id: options.id,
        parent: actorScope.self,
        syncSnapshot: options.syncSnapshot,
        input: typeof input == "function" ? input({
          context,
          event,
          self: actorScope.self
        }) : input,
        src,
        systemId
      });
      return spawnedChildren[actorRef.id] = actorRef, actorRef;
    } else
      return createActor(src, {
        id: options.id,
        parent: actorScope.self,
        syncSnapshot: options.syncSnapshot,
        input: options.input,
        src,
        systemId
      });
  }, "spawn");
  return (src, options) => {
    const actorRef = spawn(src, options);
    return spawnedChildren[actorRef.id] = actorRef, actorScope.defer(() => {
      actorRef._processingStatus !== ProcessingStatus.Stopped && actorRef.start();
    }), actorRef;
  };
}
__name(createSpawner, "createSpawner");
function resolveAssign(actorScope, snapshot, actionArgs, actionParams, {
  assignment
}) {
  if (!snapshot.context)
    throw new Error("Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.");
  const spawnedChildren = {}, assignArgs = {
    context: snapshot.context,
    event: actionArgs.event,
    spawn: createSpawner(actorScope, snapshot, actionArgs.event, spawnedChildren),
    self: actorScope.self,
    system: actorScope.system
  };
  let partialUpdate = {};
  if (typeof assignment == "function")
    partialUpdate = assignment(assignArgs, actionParams);
  else
    for (const key of Object.keys(assignment)) {
      const propAssignment = assignment[key];
      partialUpdate[key] = typeof propAssignment == "function" ? propAssignment(assignArgs, actionParams) : propAssignment;
    }
  const updatedContext = Object.assign({}, snapshot.context, partialUpdate);
  return [cloneMachineSnapshot(snapshot, {
    context: updatedContext,
    children: Object.keys(spawnedChildren).length ? {
      ...snapshot.children,
      ...spawnedChildren
    } : snapshot.children
  })];
}
__name(resolveAssign, "resolveAssign");
function assign2(assignment) {
  function assign3(args, params) {
  }
  return __name(assign3, "assign"), assign3.type = "xstate.assign", assign3.assignment = assignment, assign3.resolve = resolveAssign, assign3;
}
__name(assign2, "assign");
function resolveEmit(_2, snapshot, args, actionParams, {
  event: eventOrExpr
}) {
  const resolvedEvent = typeof eventOrExpr == "function" ? eventOrExpr(args, actionParams) : eventOrExpr;
  return [snapshot, {
    event: resolvedEvent
  }];
}
__name(resolveEmit, "resolveEmit");
function executeEmit(actorScope, {
  event
}) {
  actorScope.defer(() => actorScope.emit(event));
}
__name(executeEmit, "executeEmit");
function emit(eventOrExpr) {
  function emit2(args, params) {
  }
  return __name(emit2, "emit"), emit2.type = "xstate.emit", emit2.event = eventOrExpr, emit2.resolve = resolveEmit, emit2.execute = executeEmit, emit2;
}
__name(emit, "emit");
let SpecialTargets = /* @__PURE__ */ function(SpecialTargets2) {
  return SpecialTargets2.Parent = "#_parent", SpecialTargets2.Internal = "#_internal", SpecialTargets2;
}({});
function resolveSendTo(actorScope, snapshot, args, actionParams, {
  to,
  event: eventOrExpr,
  id: id2,
  delay
}, extra) {
  var _a6;
  const delaysMap = snapshot.machine.implementations.delays;
  if (typeof eventOrExpr == "string")
    throw new Error(`Only event objects may be used with sendTo; use sendTo({ type: "${eventOrExpr}" }) instead`);
  const resolvedEvent = typeof eventOrExpr == "function" ? eventOrExpr(args, actionParams) : eventOrExpr;
  let resolvedDelay;
  if (typeof delay == "string") {
    const configDelay = delaysMap && delaysMap[delay];
    resolvedDelay = typeof configDelay == "function" ? configDelay(args, actionParams) : configDelay;
  } else
    resolvedDelay = typeof delay == "function" ? delay(args, actionParams) : delay;
  const resolvedTarget = typeof to == "function" ? to(args, actionParams) : to;
  let targetActorRef;
  if (typeof resolvedTarget == "string") {
    if (resolvedTarget === SpecialTargets.Parent ? targetActorRef = actorScope.self._parent : resolvedTarget === SpecialTargets.Internal ? targetActorRef = actorScope.self : resolvedTarget.startsWith("#_") ? targetActorRef = snapshot.children[resolvedTarget.slice(2)] : targetActorRef = (_a6 = extra.deferredActorIds) != null && _a6.includes(resolvedTarget) ? resolvedTarget : snapshot.children[resolvedTarget], !targetActorRef)
      throw new Error(`Unable to send event to actor '${resolvedTarget}' from machine '${snapshot.machine.id}'.`);
  } else
    targetActorRef = resolvedTarget || actorScope.self;
  return [snapshot, {
    to: targetActorRef,
    event: resolvedEvent,
    id: id2,
    delay: resolvedDelay
  }];
}
__name(resolveSendTo, "resolveSendTo");
function retryResolveSendTo(_2, snapshot, params) {
  typeof params.to == "string" && (params.to = snapshot.children[params.to]);
}
__name(retryResolveSendTo, "retryResolveSendTo");
function executeSendTo(actorScope, params) {
  actorScope.defer(() => {
    const {
      to,
      event,
      delay,
      id: id2
    } = params;
    if (typeof delay == "number") {
      actorScope.system.scheduler.schedule(actorScope.self, to, event, delay, id2);
      return;
    }
    actorScope.system._relay(
      actorScope.self,
      // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
      // if it initially started as a string
      to,
      event.type === XSTATE_ERROR ? createErrorActorEvent(actorScope.self.id, event.data) : event
    );
  });
}
__name(executeSendTo, "executeSendTo");
function sendTo(to, eventOrExpr, options) {
  function sendTo2(args, params) {
  }
  return __name(sendTo2, "sendTo"), sendTo2.type = "xsnapshot.sendTo", sendTo2.to = to, sendTo2.event = eventOrExpr, sendTo2.id = options == null ? void 0 : options.id, sendTo2.delay = options == null ? void 0 : options.delay, sendTo2.resolve = resolveSendTo, sendTo2.retryResolve = retryResolveSendTo, sendTo2.execute = executeSendTo, sendTo2;
}
__name(sendTo, "sendTo");
function resolveEnqueueActions(actorScope, snapshot, args, actionParams, {
  collect
}) {
  const actions = [], enqueue = /* @__PURE__ */ __name(function(action) {
    actions.push(action);
  }, "enqueue");
  return enqueue.assign = (...args2) => {
    actions.push(assign2(...args2));
  }, enqueue.cancel = (...args2) => {
    actions.push(cancel(...args2));
  }, enqueue.raise = (...args2) => {
    actions.push(raise(...args2));
  }, enqueue.sendTo = (...args2) => {
    actions.push(sendTo(...args2));
  }, enqueue.spawnChild = (...args2) => {
    actions.push(spawnChild(...args2));
  }, enqueue.stopChild = (...args2) => {
    actions.push(stopChild(...args2));
  }, enqueue.emit = (...args2) => {
    actions.push(emit(...args2));
  }, collect({
    context: args.context,
    event: args.event,
    enqueue,
    check: /* @__PURE__ */ __name((guard) => evaluateGuard(guard, snapshot.context, args.event, snapshot), "check"),
    self: actorScope.self,
    system: actorScope.system
  }, actionParams), [snapshot, void 0, actions];
}
__name(resolveEnqueueActions, "resolveEnqueueActions");
function enqueueActions(collect) {
  function enqueueActions2(args, params) {
  }
  return __name(enqueueActions2, "enqueueActions"), enqueueActions2.type = "xstate.enqueueActions", enqueueActions2.collect = collect, enqueueActions2.resolve = resolveEnqueueActions, enqueueActions2;
}
__name(enqueueActions, "enqueueActions");
const cache = /* @__PURE__ */ new WeakMap();
function memo(object, key, fn) {
  let memoizedData = cache.get(object);
  return memoizedData ? key in memoizedData || (memoizedData[key] = fn()) : (memoizedData = {
    [key]: fn()
  }, cache.set(object, memoizedData)), memoizedData[key];
}
__name(memo, "memo");
const EMPTY_OBJECT = {}, toSerializableAction = /* @__PURE__ */ __name((action) => typeof action == "string" ? {
  type: action
} : typeof action == "function" ? "resolve" in action ? {
  type: action.type
} : {
  type: action.name
} : action, "toSerializableAction"), _StateNode = class _StateNode {
  constructor(config, options) {
    if (this.config = config, this.key = void 0, this.id = void 0, this.type = void 0, this.path = void 0, this.states = void 0, this.history = void 0, this.entry = void 0, this.exit = void 0, this.parent = void 0, this.machine = void 0, this.meta = void 0, this.output = void 0, this.order = -1, this.description = void 0, this.tags = [], this.transitions = void 0, this.always = void 0, this.parent = options._parent, this.key = options._key, this.machine = options._machine, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.id = this.config.id || [this.machine.id, ...this.path].join(STATE_DELIMITER), this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.description = this.config.description, this.order = this.machine.idMap.size, this.machine.idMap.set(this.id, this), this.states = this.config.states ? mapValues(this.config.states, (stateConfig, key) => new _StateNode(stateConfig, {
      _parent: this,
      _key: key,
      _machine: this.machine
    })) : EMPTY_OBJECT, this.type === "compound" && !this.config.initial)
      throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
    this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this.entry = toArray$1(this.config.entry).slice(), this.exit = toArray$1(this.config.exit).slice(), this.meta = this.config.meta, this.output = this.type === "final" || !this.parent ? this.config.output : void 0, this.tags = toArray$1(config.tags).slice();
  }
  /** @internal */
  _initialize() {
    this.transitions = formatTransitions(this), this.config.always && (this.always = toTransitionConfigArray(this.config.always).map((t2) => formatTransition(this, NULL_EVENT, t2))), Object.keys(this.states).forEach((key) => {
      this.states[key]._initialize();
    });
  }
  /** The well-structured state node definition. */
  get definition() {
    return {
      id: this.id,
      key: this.key,
      version: this.machine.version,
      type: this.type,
      initial: this.initial ? {
        target: this.initial.target,
        source: this,
        actions: this.initial.actions.map(toSerializableAction),
        eventType: null,
        reenter: !1,
        toJSON: /* @__PURE__ */ __name(() => ({
          target: this.initial.target.map((t2) => `#${t2.id}`),
          source: `#${this.id}`,
          actions: this.initial.actions.map(toSerializableAction),
          eventType: null
        }), "toJSON")
      } : void 0,
      history: this.history,
      states: mapValues(this.states, (state) => state.definition),
      on: this.on,
      transitions: [...this.transitions.values()].flat().map((t2) => ({
        ...t2,
        actions: t2.actions.map(toSerializableAction)
      })),
      entry: this.entry.map(toSerializableAction),
      exit: this.exit.map(toSerializableAction),
      meta: this.meta,
      order: this.order || -1,
      output: this.output,
      invoke: this.invoke,
      description: this.description,
      tags: this.tags
    };
  }
  /** @internal */
  toJSON() {
    return this.definition;
  }
  /** The logic invoked as actors by this state node. */
  get invoke() {
    return memo(this, "invoke", () => toArray$1(this.config.invoke).map((invokeConfig, i2) => {
      const {
        src,
        systemId
      } = invokeConfig, resolvedId = invokeConfig.id ?? createInvokeId(this.id, i2), resolvedSrc = typeof src == "string" ? src : `xstate.invoke.${createInvokeId(this.id, i2)}`;
      return {
        ...invokeConfig,
        src: resolvedSrc,
        id: resolvedId,
        systemId,
        toJSON() {
          const {
            onDone,
            onError,
            ...invokeDefValues
          } = invokeConfig;
          return {
            ...invokeDefValues,
            type: "xstate.invoke",
            src: resolvedSrc,
            id: resolvedId
          };
        }
      };
    }));
  }
  /** The mapping of events to transitions. */
  get on() {
    return memo(this, "on", () => [...this.transitions].flatMap(([descriptor, t2]) => t2.map((t3) => [descriptor, t3])).reduce((map, [descriptor, transition]) => (map[descriptor] = map[descriptor] || [], map[descriptor].push(transition), map), {}));
  }
  get after() {
    return memo(this, "delayedTransitions", () => getDelayedTransitions(this));
  }
  get initial() {
    return memo(this, "initial", () => formatInitialTransition(this, this.config.initial));
  }
  /** @internal */
  next(snapshot, event) {
    const eventType = event.type, actions = [];
    let selectedTransition;
    const candidates = memo(this, `candidates-${eventType}`, () => getCandidates(this, eventType));
    for (const candidate of candidates) {
      const {
        guard
      } = candidate, resolvedContext = snapshot.context;
      let guardPassed = !1;
      try {
        guardPassed = !guard || evaluateGuard(guard, resolvedContext, event, snapshot);
      } catch (err) {
        const guardType = typeof guard == "string" ? guard : typeof guard == "object" ? guard.type : void 0;
        throw new Error(`Unable to evaluate guard ${guardType ? `'${guardType}' ` : ""}in transition for event '${eventType}' in state node '${this.id}':
${err.message}`);
      }
      if (guardPassed) {
        actions.push(...candidate.actions), selectedTransition = candidate;
        break;
      }
    }
    return selectedTransition ? [selectedTransition] : void 0;
  }
  /** All the event types accepted by this state node and its descendants. */
  get events() {
    return memo(this, "events", () => {
      const {
        states
      } = this, events2 = new Set(this.ownEvents);
      if (states)
        for (const stateId of Object.keys(states)) {
          const state = states[stateId];
          if (state.states)
            for (const event of state.events)
              events2.add(`${event}`);
        }
      return Array.from(events2);
    });
  }
  /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */
  get ownEvents() {
    const events2 = new Set([...this.transitions.keys()].filter((descriptor) => this.transitions.get(descriptor).some((transition) => !(!transition.target && !transition.actions.length && !transition.reenter))));
    return Array.from(events2);
  }
};
__name(_StateNode, "StateNode");
let StateNode = _StateNode;
const STATE_IDENTIFIER = "#", _StateMachine = class _StateMachine {
  constructor(config, implementations) {
    this.config = config, this.version = void 0, this.schemas = void 0, this.implementations = void 0, this.__xstatenode = !0, this.idMap = /* @__PURE__ */ new Map(), this.root = void 0, this.id = void 0, this.states = void 0, this.events = void 0, this.id = config.id || "(machine)", this.implementations = {
      actors: (implementations == null ? void 0 : implementations.actors) ?? {},
      actions: (implementations == null ? void 0 : implementations.actions) ?? {},
      delays: (implementations == null ? void 0 : implementations.delays) ?? {},
      guards: (implementations == null ? void 0 : implementations.guards) ?? {}
    }, this.version = this.config.version, this.schemas = this.config.schemas, this.transition = this.transition.bind(this), this.getInitialSnapshot = this.getInitialSnapshot.bind(this), this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this), this.restoreSnapshot = this.restoreSnapshot.bind(this), this.start = this.start.bind(this), this.root = new StateNode(config, {
      _key: this.id,
      _machine: this
    }), this.root._initialize(), this.states = this.root.states, this.events = this.root.events;
  }
  /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */
  provide(implementations) {
    const {
      actions,
      guards,
      actors: actors2,
      delays
    } = this.implementations;
    return new _StateMachine(this.config, {
      actions: {
        ...actions,
        ...implementations.actions
      },
      guards: {
        ...guards,
        ...implementations.guards
      },
      actors: {
        ...actors2,
        ...implementations.actors
      },
      delays: {
        ...delays,
        ...implementations.delays
      }
    });
  }
  resolveState(config) {
    const resolvedStateValue = resolveStateValue(this.root, config.value), nodeSet = getAllStateNodes(getStateNodes(this.root, resolvedStateValue));
    return createMachineSnapshot({
      _nodes: [...nodeSet],
      context: config.context || {},
      children: {},
      status: isInFinalState(nodeSet, this.root) ? "done" : config.status || "active",
      output: config.output,
      error: config.error,
      historyValue: config.historyValue
    }, this);
  }
  /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */
  transition(snapshot, event, actorScope) {
    return macrostep(snapshot, event, actorScope).snapshot;
  }
  /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */
  microstep(snapshot, event, actorScope) {
    return macrostep(snapshot, event, actorScope).microstates;
  }
  getTransitionData(snapshot, event) {
    return transitionNode(this.root, snapshot.value, snapshot, event) || [];
  }
  /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */
  getPreInitialState(actorScope, initEvent, internalQueue) {
    const {
      context
    } = this.config, preInitial = createMachineSnapshot({
      context: typeof context != "function" && context ? context : {},
      _nodes: [this.root],
      children: {},
      status: "active"
    }, this);
    return typeof context == "function" ? resolveActionsAndContext(preInitial, initEvent, actorScope, [assign2(/* @__PURE__ */ __name(({
      spawn,
      event,
      self: self2
    }) => context({
      spawn,
      input: event.input,
      self: self2
    }), "assignment"))], internalQueue) : preInitial;
  }
  /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */
  getInitialSnapshot(actorScope, input) {
    const initEvent = createInitEvent(input), internalQueue = [], preInitialState = this.getPreInitialState(actorScope, initEvent, internalQueue), nextState = microstep([{
      target: [...getInitialStateNodes(this.root)],
      source: this.root,
      reenter: !0,
      actions: [],
      eventType: null,
      toJSON: null
      // TODO: fix
    }], preInitialState, actorScope, initEvent, !0, internalQueue), {
      snapshot: macroState
    } = macrostep(nextState, initEvent, actorScope, internalQueue);
    return macroState;
  }
  start(snapshot) {
    Object.values(snapshot.children).forEach((child) => {
      child.getSnapshot().status === "active" && child.start();
    });
  }
  getStateNodeById(stateId) {
    const fullPath = toStatePath(stateId), relativePath = fullPath.slice(1), resolvedStateId = isStateId(fullPath[0]) ? fullPath[0].slice(STATE_IDENTIFIER.length) : fullPath[0], stateNode = this.idMap.get(resolvedStateId);
    if (!stateNode)
      throw new Error(`Child state node '#${resolvedStateId}' does not exist on machine '${this.id}'`);
    return getStateNodeByPath(stateNode, relativePath);
  }
  get definition() {
    return this.root.definition;
  }
  toJSON() {
    return this.definition;
  }
  getPersistedSnapshot(snapshot, options) {
    return getPersistedSnapshot(snapshot, options);
  }
  restoreSnapshot(snapshot, _actorScope) {
    const children = {}, snapshotChildren = snapshot.children;
    Object.keys(snapshotChildren).forEach((actorId) => {
      const actorData = snapshotChildren[actorId], childState = actorData.snapshot, src = actorData.src, logic = typeof src == "string" ? resolveReferencedActor(this, src) : src;
      if (!logic)
        return;
      const actorRef = createActor(logic, {
        id: actorId,
        parent: _actorScope.self,
        syncSnapshot: actorData.syncSnapshot,
        snapshot: childState,
        src,
        systemId: actorData.systemId
      });
      children[actorId] = actorRef;
    });
    const restoredSnapshot = createMachineSnapshot({
      ...snapshot,
      children,
      _nodes: Array.from(getAllStateNodes(getStateNodes(this.root, snapshot.value)))
    }, this);
    let seen = /* @__PURE__ */ new Set();
    function reviveContext(contextPart, children2) {
      if (!seen.has(contextPart)) {
        seen.add(contextPart);
        for (let key in contextPart) {
          const value = contextPart[key];
          if (value && typeof value == "object") {
            if ("xstate$$type" in value && value.xstate$$type === $$ACTOR_TYPE) {
              contextPart[key] = children2[value.id];
              continue;
            }
            reviveContext(value, children2);
          }
        }
      }
    }
    return __name(reviveContext, "reviveContext"), reviveContext(restoredSnapshot.context, children), restoredSnapshot;
  }
};
__name(_StateMachine, "StateMachine");
let StateMachine = _StateMachine;
function createMachine(config, implementations) {
  return new StateMachine(config, implementations);
}
__name(createMachine, "createMachine");
function setup({
  schemas,
  actors: actors2,
  actions,
  guards,
  delays
}) {
  return {
    createMachine: /* @__PURE__ */ __name((config) => createMachine({
      ...config,
      schemas
    }, {
      actors: actors2,
      actions,
      guards,
      delays
    }), "createMachine")
  };
}
__name(setup, "setup");
const _Emitter = class _Emitter {
  constructor(logger = new ConsoleLogger()) {
    __publicField(this, "_listeners", /* @__PURE__ */ new Map());
    __publicField(this, "_logger");
    this._logger = logger;
  }
  on(eventName, callback) {
    const callbacks = this._listeners.get(eventName);
    if (callbacks)
      callbacks.add(callback);
    else {
      const newCallbacks = /* @__PURE__ */ new Set();
      newCallbacks.add(callback), this._listeners.set(eventName, newCallbacks);
    }
    return this;
  }
  once(eventName, callback) {
    const onceCallback = /* @__PURE__ */ __name((...args) => {
      callback(...args), this.off(eventName, onceCallback);
    }, "onceCallback");
    return this.on(eventName, onceCallback), this;
  }
  off(eventName, callback) {
    const callbacks = this._listeners.get(eventName);
    return callbacks && callbacks.delete(callback), this;
  }
  emit(eventName, ...args) {
    const callbacks = this._listeners.get(eventName);
    if (callbacks) {
      for (const callback of callbacks)
        callback(...args);
      return this;
    }
  }
  clearListeners() {
    return this._listeners.clear(), this;
  }
};
__name(_Emitter, "Emitter");
let Emitter = _Emitter;
const _Job = class _Job {
  constructor(start, retry) {
    __publicField(this, "_stage");
    __publicField(this, "_start");
    __publicField(this, "_retry");
    this._stage = "initial", this._start = start, this._retry = retry ?? start;
  }
  async start() {
    this._stage = "started";
    try {
      const value = await this._start();
      return this._stage = "success", value;
    } catch (e2) {
      throw this._stage = "failure", e2;
    }
  }
  async retry() {
    this._stage = "retried";
    try {
      const value = await this._retry();
      return this._stage = "success", value;
    } catch (e2) {
      throw this._stage = "failure", e2;
    }
  }
  get stage() {
    return this._stage;
  }
};
__name(_Job, "Job");
let Job = _Job;
const _RateLimiter = class _RateLimiter {
  constructor(options) {
    __publicField(this, "_isAborted", !1);
    __publicField(this, "_maxConcurrency");
    __publicField(this, "_failureJobs");
    __publicField(this, "_runningJobs");
    __publicField(this, "_waitingJobs");
    __publicField(this, "_emitter", new Emitter());
    this._maxConcurrency = (options == null ? void 0 : options.maxConcurrency) ?? 1 / 0, this._failureJobs = /* @__PURE__ */ new Set(), this._runningJobs = /* @__PURE__ */ new Set(), this._waitingJobs = [];
  }
  enqueue(...jobs) {
    this._waitingJobs.push(...jobs);
  }
  async enqueueJob(job) {
    return new Promise((resolve3, reject) => {
      const onJobFailure = /* @__PURE__ */ __name((jobFailure, error) => {
        job === jobFailure && (this._emitter.off("jobFailure", onJobFailure), reject(error));
      }, "onJobFailure"), onJobSuccess = /* @__PURE__ */ __name((jobSuccess, value) => {
        job === jobSuccess && (this._emitter.off("jobSuccess", onJobSuccess), resolve3(value));
      }, "onJobSuccess");
      this._emitter.on("jobFailure", onJobFailure), this._emitter.on("jobSuccess", onJobSuccess), this.enqueue(job), this.next();
    });
  }
  wrap(execute) {
    return (...args) => {
      const start = /* @__PURE__ */ __name(() => execute(...args), "start"), job = new Job(start);
      return this.enqueueJob(job);
    };
  }
  start() {
    return new Promise((resolve3, reject) => {
      this._emitter.on("allSuccess", resolve3), this._emitter.on("jobFailure", (_2, error) => {
        reject(error);
      }), this.next();
    });
  }
  retry() {
    return new Promise((resolve3, reject) => {
      this._emitter.on("allSuccess", resolve3), this._emitter.on("jobFailure", (_2, error) => {
        reject(error);
      }), this._waitingJobs.push(...this._failureJobs), this._failureJobs.clear(), this.next();
    });
  }
  next() {
    if (this._isAborted || this._runningJobs.size >= this._maxConcurrency) return;
    if (this._runningJobs.size === 0 && this._waitingJobs.length === 0 && this._failureJobs.size === 0) {
      this._emitter.emit("allSuccess");
      return;
    }
    const diff = this._maxConcurrency - this._runningJobs.size;
    for (let i2 = 0; i2 < diff; i2++) {
      const job = this._waitingJobs.shift();
      if (!job) return;
      this._runningJobs.add(job), (job.stage === "initial" ? job.start() : job.retry()).then((value) => {
        this._runningJobs.delete(job), this._emitter.emit("jobSuccess", job, value), this.next();
      }).catch((error) => {
        this._runningJobs.delete(job), this._failureJobs.add(job), this._emitter.emit("jobFailure", job, error), this.next();
      });
    }
  }
  abort() {
    this._isAborted = !0;
  }
};
__name(_RateLimiter, "RateLimiter");
let RateLimiter = _RateLimiter;
function bind2(fn, thisArg) {
  return /* @__PURE__ */ __name(function() {
    return fn.apply(thisArg, arguments);
  }, "wrap");
}
__name(bind2, "bind");
const { toString } = Object.prototype, { getPrototypeOf } = Object, kindOf = /* @__PURE__ */ ((cache2) => (thing) => {
  const str = toString.call(thing);
  return cache2[str] || (cache2[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = /* @__PURE__ */ __name((type) => (type = type.toLowerCase(), (thing) => kindOf(thing) === type), "kindOfTest"), typeOfTest = /* @__PURE__ */ __name((type) => (thing) => typeof thing === type, "typeOfTest"), { isArray } = Array, isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
__name(isBuffer, "isBuffer");
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result2;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? result2 = ArrayBuffer.isView(val) : result2 = val && val.buffer && isArrayBuffer(val.buffer), result2;
}
__name(isArrayBufferView, "isArrayBufferView");
const isString = typeOfTest("string"), isFunction = typeOfTest("function"), isNumber = typeOfTest("number"), isObject = /* @__PURE__ */ __name((thing) => thing !== null && typeof thing == "object", "isObject"), isBoolean = /* @__PURE__ */ __name((thing) => thing === !0 || thing === !1, "isBoolean"), isPlainObject = /* @__PURE__ */ __name((val) => {
  if (kindOf(val) !== "object")
    return !1;
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}, "isPlainObject"), isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = /* @__PURE__ */ __name((val) => isObject(val) && isFunction(val.pipe), "isStream"), isFormData = /* @__PURE__ */ __name((thing) => {
  let kind;
  return thing && (typeof FormData == "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
}, "isFormData"), isURLSearchParams = kindOfTest("URLSearchParams"), [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest), trim = /* @__PURE__ */ __name((str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), "trim");
function forEach(obj, fn, { allOwnKeys = !1 } = {}) {
  if (obj === null || typeof obj > "u")
    return;
  let i2, l2;
  if (typeof obj != "object" && (obj = [obj]), isArray(obj))
    for (i2 = 0, l2 = obj.length; i2 < l2; i2++)
      fn.call(null, obj[i2], i2, obj);
  else {
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj), len2 = keys.length;
    let key;
    for (i2 = 0; i2 < len2; i2++)
      key = keys[i2], fn.call(null, obj[key], key, obj);
  }
}
__name(forEach, "forEach");
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i2 = keys.length, _key;
  for (; i2-- > 0; )
    if (_key = keys[i2], key === _key.toLowerCase())
      return _key;
  return null;
}
__name(findKey, "findKey");
const _global = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, isContextDefined = /* @__PURE__ */ __name((context) => !isUndefined(context) && context !== _global, "isContextDefined");
function merge() {
  const { caseless } = isContextDefined(this) && this || {}, result2 = {}, assignValue = /* @__PURE__ */ __name((val, key) => {
    const targetKey = caseless && findKey(result2, key) || key;
    isPlainObject(result2[targetKey]) && isPlainObject(val) ? result2[targetKey] = merge(result2[targetKey], val) : isPlainObject(val) ? result2[targetKey] = merge({}, val) : isArray(val) ? result2[targetKey] = val.slice() : result2[targetKey] = val;
  }, "assignValue");
  for (let i2 = 0, l2 = arguments.length; i2 < l2; i2++)
    arguments[i2] && forEach(arguments[i2], assignValue);
  return result2;
}
__name(merge, "merge");
const extend = /* @__PURE__ */ __name((a2, b2, thisArg, { allOwnKeys } = {}) => (forEach(b2, (val, key) => {
  thisArg && isFunction(val) ? a2[key] = bind2(val, thisArg) : a2[key] = val;
}, { allOwnKeys }), a2), "extend"), stripBOM = /* @__PURE__ */ __name((content) => (content.charCodeAt(0) === 65279 && (content = content.slice(1)), content), "stripBOM"), inherits = /* @__PURE__ */ __name((constructor, superConstructor, props, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2), constructor.prototype.constructor = constructor, Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  }), props && Object.assign(constructor.prototype, props);
}, "inherits"), toFlatObject = /* @__PURE__ */ __name((sourceObj, destObj, filter2, propFilter) => {
  let props, i2, prop;
  const merged = {};
  if (destObj = destObj || {}, sourceObj == null) return destObj;
  do {
    for (props = Object.getOwnPropertyNames(sourceObj), i2 = props.length; i2-- > 0; )
      prop = props[i2], (!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop] && (destObj[prop] = sourceObj[prop], merged[prop] = !0);
    sourceObj = filter2 !== !1 && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
}, "toFlatObject"), endsWith = /* @__PURE__ */ __name((str, searchString, position) => {
  str = String(str), (position === void 0 || position > str.length) && (position = str.length), position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}, "endsWith"), toArray = /* @__PURE__ */ __name((thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i2 = thing.length;
  if (!isNumber(i2)) return null;
  const arr = new Array(i2);
  for (; i2-- > 0; )
    arr[i2] = thing[i2];
  return arr;
}, "toArray"), isTypedArray = /* @__PURE__ */ ((TypedArray) => (thing) => TypedArray && thing instanceof TypedArray)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = /* @__PURE__ */ __name((obj, fn) => {
  const iterator = (obj && obj[Symbol.iterator]).call(obj);
  let result2;
  for (; (result2 = iterator.next()) && !result2.done; ) {
    const pair = result2.value;
    fn.call(obj, pair[0], pair[1]);
  }
}, "forEachEntry"), matchAll = /* @__PURE__ */ __name((regExp, str) => {
  let matches2;
  const arr = [];
  for (; (matches2 = regExp.exec(str)) !== null; )
    arr.push(matches2);
  return arr;
}, "matchAll"), isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = /* @__PURE__ */ __name((str) => str.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  /* @__PURE__ */ __name(function(m2, p1, p2) {
    return p1.toUpperCase() + p2;
  }, "replacer")
), "toCamelCase"), hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = /* @__PURE__ */ __name((obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj), reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name) => {
    let ret;
    (ret = reducer(descriptor, name, obj)) !== !1 && (reducedDescriptors[name] = ret || descriptor);
  }), Object.defineProperties(obj, reducedDescriptors);
}, "reduceDescriptors"), freezeMethods = /* @__PURE__ */ __name((obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1)
      return !1;
    const value = obj[name];
    if (isFunction(value)) {
      if (descriptor.enumerable = !1, "writable" in descriptor) {
        descriptor.writable = !1;
        return;
      }
      descriptor.set || (descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      });
    }
  });
}, "freezeMethods"), toObjectSet = /* @__PURE__ */ __name((arrayOrString, delimiter) => {
  const obj = {}, define = /* @__PURE__ */ __name((arr) => {
    arr.forEach((value) => {
      obj[value] = !0;
    });
  }, "define");
  return isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter)), obj;
}, "toObjectSet"), noop = /* @__PURE__ */ __name(() => {
}, "noop"), toFiniteNumber = /* @__PURE__ */ __name((value, defaultValue) => value != null && Number.isFinite(value = +value) ? value : defaultValue, "toFiniteNumber"), ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = /* @__PURE__ */ __name((size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = "";
  const { length } = alphabet;
  for (; size--; )
    str += alphabet[Math.random() * length | 0];
  return str;
}, "generateString");
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
__name(isSpecCompliantForm, "isSpecCompliantForm");
const toJSONObject = /* @__PURE__ */ __name((obj) => {
  const stack = new Array(10), visit = /* @__PURE__ */ __name((source, i2) => {
    if (isObject(source)) {
      if (stack.indexOf(source) >= 0)
        return;
      if (!("toJSON" in source)) {
        stack[i2] = source;
        const target = isArray(source) ? [] : {};
        return forEach(source, (value, key) => {
          const reducedValue = visit(value, i2 + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        }), stack[i2] = void 0, target;
      }
    }
    return source;
  }, "visit");
  return visit(obj, 0);
}, "toJSONObject"), isAsyncFn = kindOfTest("AsyncFunction"), isThenable = /* @__PURE__ */ __name((thing) => thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch), "isThenable"), utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError$1(message, code, config, request, response) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = message, this.name = "AxiosError", code && (this.code = code), config && (this.config = config), request && (this.request = request), response && (this.response = response);
}
__name(AxiosError$1, "AxiosError$1");
utils$1.inherits(AxiosError$1, Error, {
  toJSON: /* @__PURE__ */ __name(function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, "toJSON")
});
const prototype$1 = AxiosError$1.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError$1.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  return utils$1.toFlatObject(error, axiosError, /* @__PURE__ */ __name(function(obj) {
    return obj !== Error.prototype;
  }, "filter"), (prop) => prop !== "isAxiosError"), AxiosError$1.call(axiosError, error.message, code, config, request, response), axiosError.cause = error, axiosError.name = error.name, customProps && Object.assign(axiosError, customProps), axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
__name(isVisitable, "isVisitable");
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
__name(removeBrackets, "removeBrackets");
function renderKey(path, key, dots) {
  return path ? path.concat(key).map(/* @__PURE__ */ __name(function(token, i2) {
    return token = removeBrackets(token), !dots && i2 ? "[" + token + "]" : token;
  }, "each")).join(dots ? "." : "") : key;
}
__name(renderKey, "renderKey");
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
__name(isFlatArray, "isFlatArray");
const predicates = utils$1.toFlatObject(utils$1, {}, null, /* @__PURE__ */ __name(function(prop) {
  return /^is[A-Z]/.test(prop);
}, "filter"));
function toFormData$1(obj, formData, options) {
  if (!utils$1.isObject(obj))
    throw new TypeError("target must be an object");
  formData = formData || new FormData(), options = utils$1.toFlatObject(options, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, /* @__PURE__ */ __name(function(option, source) {
    return !utils$1.isUndefined(source[option]);
  }, "defined"));
  const metaTokens = options.metaTokens, visitor = options.visitor || defaultVisitor, dots = options.dots, indexes = options.indexes, useBlob = (options.Blob || typeof Blob < "u" && Blob) && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor))
    throw new TypeError("visitor must be a function");
  function convertValue(value) {
    if (value === null) return "";
    if (utils$1.isDate(value))
      return value.toISOString();
    if (!useBlob && utils$1.isBlob(value))
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    return utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value) ? useBlob && typeof Blob == "function" ? new Blob([value]) : Buffer.from(value) : value;
  }
  __name(convertValue, "convertValue");
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value == "object") {
      if (utils$1.endsWith(key, "{}"))
        key = metaTokens ? key : key.slice(0, -2), value = JSON.stringify(value);
      else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value)))
        return key = removeBrackets(key), arr.forEach(/* @__PURE__ */ __name(function(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === !0 ? renderKey([key], index, dots) : indexes === null ? key : key + "[]",
            convertValue(el)
          );
        }, "each")), !1;
    }
    return isVisitable(value) ? !0 : (formData.append(renderKey(path, key, dots), convertValue(value)), !1);
  }
  __name(defaultVisitor, "defaultVisitor");
  const stack = [], exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (!utils$1.isUndefined(value)) {
      if (stack.indexOf(value) !== -1)
        throw Error("Circular reference detected in " + path.join("."));
      stack.push(value), utils$1.forEach(value, /* @__PURE__ */ __name(function(el, key) {
        (!(utils$1.isUndefined(el) || el === null) && visitor.call(
          formData,
          el,
          utils$1.isString(key) ? key.trim() : key,
          path,
          exposedHelpers
        )) === !0 && build(el, path ? path.concat(key) : [key]);
      }, "each")), stack.pop();
    }
  }
  if (__name(build, "build"), !utils$1.isObject(obj))
    throw new TypeError("data must be an object");
  return build(obj), formData;
}
__name(toFormData$1, "toFormData$1");
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, /* @__PURE__ */ __name(function(match2) {
    return charMap[match2];
  }, "replacer"));
}
__name(encode$1, "encode$1");
function AxiosURLSearchParams(params, options) {
  this._pairs = [], params && toFormData$1(params, this, options);
}
__name(AxiosURLSearchParams, "AxiosURLSearchParams");
const prototype = AxiosURLSearchParams.prototype;
prototype.append = /* @__PURE__ */ __name(function(name, value) {
  this._pairs.push([name, value]);
}, "append");
prototype.toString = /* @__PURE__ */ __name(function(encoder) {
  const _encode2 = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(/* @__PURE__ */ __name(function(pair) {
    return _encode2(pair[0]) + "=" + _encode2(pair[1]);
  }, "each"), "").join("&");
}, "toString");
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
__name(encode, "encode");
function buildURL(url, params, options) {
  if (!params)
    return url;
  const _encode2 = options && options.encode || encode, serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn ? serializedParams = serializeFn(params, options) : serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode2), serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    hashmarkIndex !== -1 && (url = url.slice(0, hashmarkIndex)), url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
__name(buildURL, "buildURL");
const _InterceptorManager = class _InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    return this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : !1,
      runWhen: options ? options.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id2) {
    this.handlers[id2] && (this.handlers[id2] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, /* @__PURE__ */ __name(function(h2) {
      h2 !== null && fn(h2);
    }, "forEachHandler"));
  }
};
__name(_InterceptorManager, "InterceptorManager");
let InterceptorManager = _InterceptorManager;
const transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window < "u" && typeof document < "u", hasStandardBrowserEnv = ((product) => hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(product) < 0)(typeof navigator < "u" && navigator.product), hasStandardBrowserWebWorkerEnv = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", origin = hasBrowserEnv && window.location.href || "http://localhost", utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  origin
}, Symbol.toStringTag, { value: "Module" })), platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(data, options) {
  return toFormData$1(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: /* @__PURE__ */ __name(function(value, key, path, helpers) {
      return platform.isNode && utils$1.isBuffer(value) ? (this.append(key, value.toString("base64")), !1) : helpers.defaultVisitor.apply(this, arguments);
    }, "visitor")
  }, options));
}
__name(toURLEncodedForm, "toURLEncodedForm");
function parsePropPath(name) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map((match2) => match2[0] === "[]" ? "" : match2[1] || match2[0]);
}
__name(parsePropPath, "parsePropPath");
function arrayToObject(arr) {
  const obj = {}, keys = Object.keys(arr);
  let i2;
  const len2 = keys.length;
  let key;
  for (i2 = 0; i2 < len2; i2++)
    key = keys[i2], obj[key] = arr[key];
  return obj;
}
__name(arrayToObject, "arrayToObject");
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    if (name === "__proto__") return !0;
    const isNumericKey = Number.isFinite(+name), isLast = index >= path.length;
    return name = !name && utils$1.isArray(target) ? target.length : name, isLast ? (utils$1.hasOwnProp(target, name) ? target[name] = [target[name], value] : target[name] = value, !isNumericKey) : ((!target[name] || !utils$1.isObject(target[name])) && (target[name] = []), buildPath(path, value, target[name], index) && utils$1.isArray(target[name]) && (target[name] = arrayToObject(target[name])), !isNumericKey);
  }
  if (__name(buildPath, "buildPath"), utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    return utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    }), obj;
  }
  return null;
}
__name(formDataToJSON, "formDataToJSON");
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue))
    try {
      return (parser || JSON.parse)(rawValue), utils$1.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError")
        throw e2;
    }
  return (encoder || JSON.stringify)(rawValue);
}
__name(stringifySafely, "stringifySafely");
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [/* @__PURE__ */ __name(function(data, headers) {
    const contentType = headers.getContentType() || "", hasJSONContentType = contentType.indexOf("application/json") > -1, isObjectPayload = utils$1.isObject(data);
    if (isObjectPayload && utils$1.isHTMLForm(data) && (data = new FormData(data)), utils$1.isFormData(data))
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data) || utils$1.isReadableStream(data))
      return data;
    if (utils$1.isArrayBufferView(data))
      return data.buffer;
    if (utils$1.isURLSearchParams(data))
      return headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), data.toString();
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(data, this.formSerializer).toString();
      if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData$1(
          isFileList2 ? { "files[]": data } : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    return isObjectPayload || hasJSONContentType ? (headers.setContentType("application/json", !1), stringifySafely(data)) : data;
  }, "transformRequest")],
  transformResponse: [/* @__PURE__ */ __name(function(data) {
    const transitional2 = this.transitional || defaults.transitional, forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing, JSONRequested = this.responseType === "json";
    if (utils$1.isResponse(data) || utils$1.isReadableStream(data))
      return data;
    if (data && utils$1.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const strictJSONParsing = !(transitional2 && transitional2.silentJSONParsing) && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e2) {
        if (strictJSONParsing)
          throw e2.name === "SyntaxError" ? AxiosError$1.from(e2, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response) : e2;
      }
    }
    return data;
  }, "transformResponse")],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: /* @__PURE__ */ __name(function(status) {
    return status >= 200 && status < 300;
  }, "validateStatus"),
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults.headers[method] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = /* @__PURE__ */ __name((rawHeaders) => {
  const parsed = {};
  let key, val, i2;
  return rawHeaders && rawHeaders.split(`
`).forEach(/* @__PURE__ */ __name(function(line) {
    i2 = line.indexOf(":"), key = line.substring(0, i2).trim().toLowerCase(), val = line.substring(i2 + 1).trim(), !(!key || parsed[key] && ignoreDuplicateOf[key]) && (key === "set-cookie" ? parsed[key] ? parsed[key].push(val) : parsed[key] = [val] : parsed[key] = parsed[key] ? parsed[key] + ", " + val : val);
  }, "parser")), parsed;
}, "parseHeaders"), $internals = Symbol("internals");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
__name(normalizeHeader, "normalizeHeader");
function normalizeValue(value) {
  return value === !1 || value == null ? value : utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
__name(normalizeValue, "normalizeValue");
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null), tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match2;
  for (; match2 = tokensRE.exec(str); )
    tokens[match2[1]] = match2[2];
  return tokens;
}
__name(parseTokens, "parseTokens");
const isValidHeaderName = /* @__PURE__ */ __name((str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim()), "isValidHeaderName");
function matchHeaderValue(context, value, header, filter2, isHeaderNameFilter) {
  if (utils$1.isFunction(filter2))
    return filter2.call(this, value, header);
  if (isHeaderNameFilter && (value = header), !!utils$1.isString(value)) {
    if (utils$1.isString(filter2))
      return value.indexOf(filter2) !== -1;
    if (utils$1.isRegExp(filter2))
      return filter2.test(value);
  }
}
__name(matchHeaderValue, "matchHeaderValue");
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w2, char, str) => char.toUpperCase() + str);
}
__name(formatHeader, "formatHeader");
function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: /* @__PURE__ */ __name(function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      }, "value"),
      configurable: !0
    });
  });
}
__name(buildAccessors, "buildAccessors");
var _a3;
let AxiosHeaders$1 = (_a3 = class {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader)
        throw new Error("header name must be a non-empty string");
      const key = utils$1.findKey(self2, lHeader);
      (!key || self2[key] === void 0 || _rewrite === !0 || _rewrite === void 0 && self2[key] !== !1) && (self2[key || _header] = normalizeValue(_value));
    }
    __name(setHeader, "setHeader");
    const setHeaders = /* @__PURE__ */ __name((headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite)), "setHeaders");
    if (utils$1.isPlainObject(header) || header instanceof this.constructor)
      setHeaders(header, valueOrRewrite);
    else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header))
      setHeaders(parseHeaders(header), valueOrRewrite);
    else if (utils$1.isHeaders(header))
      for (const [key, value] of header.entries())
        setHeader(value, key, rewrite);
    else
      header != null && setHeader(valueOrRewrite, header, rewrite);
    return this;
  }
  get(header, parser) {
    if (header = normalizeHeader(header), header) {
      const key = utils$1.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser)
          return value;
        if (parser === !0)
          return parseTokens(value);
        if (utils$1.isFunction(parser))
          return parser.call(this, value, key);
        if (utils$1.isRegExp(parser))
          return parser.exec(value);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header, matcher) {
    if (header = normalizeHeader(header), header) {
      const key = utils$1.findKey(this, header);
      return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return !1;
  }
  delete(header, matcher) {
    const self2 = this;
    let deleted = !1;
    function deleteHeader(_header) {
      if (_header = normalizeHeader(_header), _header) {
        const key = utils$1.findKey(self2, _header);
        key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher)) && (delete self2[key], deleted = !0);
      }
    }
    return __name(deleteHeader, "deleteHeader"), utils$1.isArray(header) ? header.forEach(deleteHeader) : deleteHeader(header), deleted;
  }
  clear(matcher) {
    const keys = Object.keys(this);
    let i2 = keys.length, deleted = !1;
    for (; i2--; ) {
      const key = keys[i2];
      (!matcher || matchHeaderValue(this, this[key], key, matcher, !0)) && (delete this[key], deleted = !0);
    }
    return deleted;
  }
  normalize(format2) {
    const self2 = this, headers = {};
    return utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);
      if (key) {
        self2[key] = normalizeValue(value), delete self2[header];
        return;
      }
      const normalized = format2 ? formatHeader(header) : String(header).trim();
      normalized !== header && delete self2[header], self2[normalized] = normalizeValue(value), headers[normalized] = !0;
    }), this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    return utils$1.forEach(this, (value, header) => {
      value != null && value !== !1 && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    }), obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed = new this(first);
    return targets.forEach((target) => computed.set(target)), computed;
  }
  static accessor(header) {
    const accessors = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      accessors[lHeader] || (buildAccessors(prototype2, _header), accessors[lHeader] = !0);
    }
    return __name(defineAccessor, "defineAccessor"), utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header), this;
  }
}, __name(_a3, "AxiosHeaders"), _a3);
AxiosHeaders$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: /* @__PURE__ */ __name(() => value, "get"),
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders$1);
function transformData(fns, response) {
  const config = this || defaults, context = response || config, headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;
  return utils$1.forEach(fns, /* @__PURE__ */ __name(function(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
  }, "transform")), headers.normalize(), data;
}
__name(transformData, "transformData");
function isCancel$1(value) {
  return !!(value && value.__CANCEL__);
}
__name(isCancel$1, "isCancel$1");
function CanceledError$1(message, config, request) {
  AxiosError$1.call(this, message ?? "canceled", AxiosError$1.ERR_CANCELED, config, request), this.name = "CanceledError";
}
__name(CanceledError$1, "CanceledError$1");
utils$1.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: !0
});
function settle(resolve3, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  !response.status || !validateStatus2 || validateStatus2(response.status) ? resolve3(response) : reject(new AxiosError$1(
    "Request failed with status code " + response.status,
    [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
    response.config,
    response.request,
    response
  ));
}
__name(settle, "settle");
function parseProtocol(url) {
  const match2 = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match2 && match2[1] || "";
}
__name(parseProtocol, "parseProtocol");
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount), timestamps = new Array(samplesCount);
  let head = 0, tail = 0, firstSampleTS;
  return min = min !== void 0 ? min : 1e3, /* @__PURE__ */ __name(function(chunkLength) {
    const now2 = Date.now(), startedAt = timestamps[tail];
    firstSampleTS || (firstSampleTS = now2), bytes[head] = chunkLength, timestamps[head] = now2;
    let i2 = tail, bytesCount = 0;
    for (; i2 !== head; )
      bytesCount += bytes[i2++], i2 = i2 % samplesCount;
    if (head = (head + 1) % samplesCount, head === tail && (tail = (tail + 1) % samplesCount), now2 - firstSampleTS < min)
      return;
    const passed = startedAt && now2 - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  }, "push");
}
__name(speedometer, "speedometer");
function throttle(fn, freq) {
  let timestamp = 0;
  const threshold = 1e3 / freq;
  let timer = null;
  return /* @__PURE__ */ __name(function() {
    const force = this === !0, now2 = Date.now();
    if (force || now2 - timestamp > threshold)
      return timer && (clearTimeout(timer), timer = null), timestamp = now2, fn.apply(null, arguments);
    timer || (timer = setTimeout(() => (timer = null, timestamp = Date.now(), fn.apply(null, arguments)), threshold - (now2 - timestamp)));
  }, "throttled");
}
__name(throttle, "throttle");
const progressEventReducer = /* @__PURE__ */ __name((listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return throttle((e2) => {
    const loaded = e2.loaded, total = e2.lengthComputable ? e2.total : void 0, progressBytes = loaded - bytesNotified, rate = _speedometer(progressBytes), inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate || void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e2,
      lengthComputable: total != null
    };
    data[isDownloadStream ? "download" : "upload"] = !0, listener(data);
  }, freq);
}, "progressEventReducer"), isURLSameOrigin = platform.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (/* @__PURE__ */ __name(function() {
    const msie = /(msie|trident)/i.test(navigator.userAgent), urlParsingNode = document.createElement("a");
    let originURL;
    function resolveURL(url) {
      let href = url;
      return msie && (urlParsingNode.setAttribute("href", href), href = urlParsingNode.href), urlParsingNode.setAttribute("href", href), {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
      };
    }
    return __name(resolveURL, "resolveURL"), originURL = resolveURL(window.location.href), /* @__PURE__ */ __name(function(requestURL) {
      const parsed = utils$1.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    }, "isURLSameOrigin");
  }, "standardBrowserEnv"))()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  (/* @__PURE__ */ __name(function() {
    return /* @__PURE__ */ __name(function() {
      return !0;
    }, "isURLSameOrigin");
  }, "nonStandardBrowserEnv"))()
), cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + "=" + encodeURIComponent(value)];
      utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString()), utils$1.isString(path) && cookie.push("path=" + path), utils$1.isString(domain) && cookie.push("domain=" + domain), secure === !0 && cookie.push("secure"), document.cookie = cookie.join("; ");
    },
    read(name) {
      const match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
__name(isAbsoluteURL, "isAbsoluteURL");
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
__name(combineURLs, "combineURLs");
function buildFullPath(baseURL, requestedURL) {
  return baseURL && !isAbsoluteURL(requestedURL) ? combineURLs(baseURL, requestedURL) : requestedURL;
}
__name(buildFullPath, "buildFullPath");
const headersToObject = /* @__PURE__ */ __name((thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing, "headersToObject");
function mergeConfig$1(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, caseless) {
    return utils$1.isPlainObject(target) && utils$1.isPlainObject(source) ? utils$1.merge.call({ caseless }, target, source) : utils$1.isPlainObject(source) ? utils$1.merge({}, source) : utils$1.isArray(source) ? source.slice() : source;
  }
  __name(getMergedValue, "getMergedValue");
  function mergeDeepProperties(a2, b2, caseless) {
    if (utils$1.isUndefined(b2)) {
      if (!utils$1.isUndefined(a2))
        return getMergedValue(void 0, a2, caseless);
    } else return getMergedValue(a2, b2, caseless);
  }
  __name(mergeDeepProperties, "mergeDeepProperties");
  function valueFromConfig2(a2, b2) {
    if (!utils$1.isUndefined(b2))
      return getMergedValue(void 0, b2);
  }
  __name(valueFromConfig2, "valueFromConfig2");
  function defaultToConfig2(a2, b2) {
    if (utils$1.isUndefined(b2)) {
      if (!utils$1.isUndefined(a2))
        return getMergedValue(void 0, a2);
    } else return getMergedValue(void 0, b2);
  }
  __name(defaultToConfig2, "defaultToConfig2");
  function mergeDirectKeys(a2, b2, prop) {
    if (prop in config2)
      return getMergedValue(a2, b2);
    if (prop in config1)
      return getMergedValue(void 0, a2);
  }
  __name(mergeDirectKeys, "mergeDirectKeys");
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: /* @__PURE__ */ __name((a2, b2) => mergeDeepProperties(headersToObject(a2), headersToObject(b2), !0), "headers")
  };
  return utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), /* @__PURE__ */ __name(function(prop) {
    const merge2 = mergeMap[prop] || mergeDeepProperties, configValue = merge2(config1[prop], config2[prop], prop);
    utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  }, "computeConfigValue")), config;
}
__name(mergeConfig$1, "mergeConfig$1");
const resolveConfig = /* @__PURE__ */ __name((config) => {
  const newConfig = mergeConfig$1({}, config);
  let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
  newConfig.headers = headers = AxiosHeaders$1.from(headers), newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer), auth && headers.set(
    "Authorization",
    "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : ""))
  );
  let contentType;
  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
      headers.setContentType(void 0);
    else if ((contentType = headers.getContentType()) !== !1) {
      const [type, ...tokens] = contentType ? contentType.split(";").map((token) => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || "multipart/form-data", ...tokens].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv && (withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig)), withXSRFToken || withXSRFToken !== !1 && isURLSameOrigin(newConfig.url))) {
    const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
    xsrfValue && headers.set(xsrfHeaderName, xsrfValue);
  }
  return newConfig;
}, "resolveConfig"), isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(config) {
  return new Promise(/* @__PURE__ */ __name(function(resolve3, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
    let { responseType } = _config, onCanceled;
    function done() {
      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled), _config.signal && _config.signal.removeEventListener("abort", onCanceled);
    }
    __name(done, "done");
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, !0), request.timeout = _config.timeout;
    function onloadend() {
      if (!request)
        return;
      const responseHeaders = AxiosHeaders$1.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      ), response = {
        data: !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(/* @__PURE__ */ __name(function(value) {
        resolve3(value), done();
      }, "_resolve"), /* @__PURE__ */ __name(function(err) {
        reject(err), done();
      }, "_reject"), response), request = null;
    }
    __name(onloadend, "onloadend"), "onloadend" in request ? request.onloadend = onloadend : request.onreadystatechange = /* @__PURE__ */ __name(function() {
      !request || request.readyState !== 4 || request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0) || setTimeout(onloadend);
    }, "handleLoad"), request.onabort = /* @__PURE__ */ __name(function() {
      request && (reject(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, _config, request)), request = null);
    }, "handleAbort"), request.onerror = /* @__PURE__ */ __name(function() {
      reject(new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, _config, request)), request = null;
    }, "handleError"), request.ontimeout = /* @__PURE__ */ __name(function() {
      let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = _config.transitional || transitionalDefaults;
      _config.timeoutErrorMessage && (timeoutErrorMessage = _config.timeoutErrorMessage), reject(new AxiosError$1(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        _config,
        request
      )), request = null;
    }, "handleTimeout"), requestData === void 0 && requestHeaders.setContentType(null), "setRequestHeader" in request && utils$1.forEach(requestHeaders.toJSON(), /* @__PURE__ */ __name(function(val, key) {
      request.setRequestHeader(key, val);
    }, "setRequestHeader")), utils$1.isUndefined(_config.withCredentials) || (request.withCredentials = !!_config.withCredentials), responseType && responseType !== "json" && (request.responseType = _config.responseType), typeof _config.onDownloadProgress == "function" && request.addEventListener("progress", progressEventReducer(_config.onDownloadProgress, !0)), typeof _config.onUploadProgress == "function" && request.upload && request.upload.addEventListener("progress", progressEventReducer(_config.onUploadProgress)), (_config.cancelToken || _config.signal) && (onCanceled = /* @__PURE__ */ __name((cancel2) => {
      request && (reject(!cancel2 || cancel2.type ? new CanceledError$1(null, config, request) : cancel2), request.abort(), request = null);
    }, "onCanceled"), _config.cancelToken && _config.cancelToken.subscribe(onCanceled), _config.signal && (_config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled)));
    const protocol = parseProtocol(_config.url);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError$1("Unsupported protocol " + protocol + ":", AxiosError$1.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  }, "dispatchXhrRequest"));
}, composeSignals = /* @__PURE__ */ __name((signals, timeout) => {
  let controller = new AbortController(), aborted;
  const onabort = /* @__PURE__ */ __name(function(cancel2) {
    if (!aborted) {
      aborted = !0, unsubscribe();
      const err = cancel2 instanceof Error ? cancel2 : this.reason;
      controller.abort(err instanceof AxiosError$1 ? err : new CanceledError$1(err instanceof Error ? err.message : err));
    }
  }, "onabort");
  let timer = timeout && setTimeout(() => {
    onabort(new AxiosError$1(`timeout ${timeout} of ms exceeded`, AxiosError$1.ETIMEDOUT));
  }, timeout);
  const unsubscribe = /* @__PURE__ */ __name(() => {
    signals && (timer && clearTimeout(timer), timer = null, signals.forEach((signal2) => {
      signal2 && (signal2.removeEventListener ? signal2.removeEventListener("abort", onabort) : signal2.unsubscribe(onabort));
    }), signals = null);
  }, "unsubscribe");
  signals.forEach((signal2) => signal2 && signal2.addEventListener && signal2.addEventListener("abort", onabort));
  const { signal } = controller;
  return signal.unsubscribe = unsubscribe, [signal, () => {
    timer && clearTimeout(timer), timer = null;
  }];
}, "composeSignals"), streamChunk = /* @__PURE__ */ __name(function* (chunk2, chunkSize) {
  let len2 = chunk2.byteLength;
  if (!chunkSize || len2 < chunkSize) {
    yield chunk2;
    return;
  }
  let pos = 0, end;
  for (; pos < len2; )
    end = pos + chunkSize, yield chunk2.slice(pos, end), pos = end;
}, "streamChunk"), readBytes = /* @__PURE__ */ __name(async function* (iterable, chunkSize, encode2) {
  for await (const chunk2 of iterable)
    yield* streamChunk(ArrayBuffer.isView(chunk2) ? chunk2 : await encode2(String(chunk2)), chunkSize);
}, "readBytes"), trackStream = /* @__PURE__ */ __name((stream, chunkSize, onProgress, onFinish, encode2) => {
  const iterator = readBytes(stream, chunkSize, encode2);
  let bytes = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(controller) {
      const { done, value } = await iterator.next();
      if (done) {
        controller.close(), onFinish();
        return;
      }
      let len2 = value.byteLength;
      onProgress && onProgress(bytes += len2), controller.enqueue(new Uint8Array(value));
    },
    cancel(reason) {
      return onFinish(reason), iterator.return();
    }
  }, {
    highWaterMark: 2
  });
}, "trackStream"), fetchProgressDecorator = /* @__PURE__ */ __name((total, fn) => {
  const lengthComputable = total != null;
  return (loaded) => setTimeout(() => fn({
    lengthComputable,
    total,
    loaded
  }));
}, "fetchProgressDecorator"), isFetchSupported = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", isReadableStreamSupported = isFetchSupported && typeof ReadableStream == "function", encodeText = isFetchSupported && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Response(str).arrayBuffer())), supportsRequestStream = isReadableStreamSupported && (() => {
  let duplexAccessed = !1;
  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return duplexAccessed = !0, "half";
    }
  }).headers.has("Content-Type");
  return duplexAccessed && !hasContentType;
})(), DEFAULT_CHUNK_SIZE = 64 * 1024, supportsResponseStream = isReadableStreamSupported && !!(() => {
  try {
    return utils$1.isReadableStream(new Response("").body);
  } catch {
  }
})(), resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};
isFetchSupported && ((res) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type) => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res2) => res2[type]() : (_2, config) => {
      throw new AxiosError$1(`Response type '${type}' is not supported`, AxiosError$1.ERR_NOT_SUPPORT, config);
    });
  });
})(new Response());
const getBodyLength = /* @__PURE__ */ __name(async (body) => {
  if (body == null)
    return 0;
  if (utils$1.isBlob(body))
    return body.size;
  if (utils$1.isSpecCompliantForm(body))
    return (await new Request(body).arrayBuffer()).byteLength;
  if (utils$1.isArrayBufferView(body))
    return body.byteLength;
  if (utils$1.isURLSearchParams(body) && (body = body + ""), utils$1.isString(body))
    return (await encodeText(body)).byteLength;
}, "getBodyLength"), resolveBodyLength = /* @__PURE__ */ __name(async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());
  return length ?? getBodyLength(body);
}, "resolveBodyLength"), fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = "same-origin",
    fetchOptions
  } = resolveConfig(config);
  responseType = responseType ? (responseType + "").toLowerCase() : "text";
  let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? composeSignals([signal, cancelToken], timeout) : [], finished, request;
  const onFinish = /* @__PURE__ */ __name(() => {
    !finished && setTimeout(() => {
      composedSignal && composedSignal.unsubscribe();
    }), finished = !0;
  }, "onFinish");
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
      let _request = new Request(url, {
        method: "POST",
        body: data,
        duplex: "half"
      }), contentTypeHeader;
      utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get("content-type")) && headers.setContentType(contentTypeHeader), _request.body && (data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, fetchProgressDecorator(
        requestContentLength,
        progressEventReducer(onUploadProgress)
      ), null, encodeText));
    }
    utils$1.isString(withCredentials) || (withCredentials = withCredentials ? "cors" : "omit"), request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      withCredentials
    });
    let response = await fetch(request);
    const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
      const options = {};
      ["status", "statusText", "headers"].forEach((prop) => {
        options[prop] = response[prop];
      });
      const responseContentLength = utils$1.toFiniteNumber(response.headers.get("content-length"));
      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onDownloadProgress && fetchProgressDecorator(
          responseContentLength,
          progressEventReducer(onDownloadProgress, !0)
        ), isStreamResponse && onFinish, encodeText),
        options
      );
    }
    responseType = responseType || "text";
    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](response, config);
    return !isStreamResponse && onFinish(), stopTimeout && stopTimeout(), await new Promise((resolve3, reject) => {
      settle(resolve3, reject, {
        data: responseData,
        headers: AxiosHeaders$1.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    });
  } catch (err) {
    throw onFinish(), err && err.name === "TypeError" && /fetch/i.test(err.message) ? Object.assign(
      new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, config, request),
      {
        cause: err.cause || err
      }
    ) : AxiosError$1.from(err, err && err.code, config, request);
  }
}), knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, "name", { value });
    } catch {
    }
    Object.defineProperty(fn, "adapterName", { value });
  }
});
const renderReason = /* @__PURE__ */ __name((reason) => `- ${reason}`, "renderReason"), isResolvedHandle = /* @__PURE__ */ __name((adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === !1, "isResolvedHandle"), adapters = {
  getAdapter: /* @__PURE__ */ __name((adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter, adapter;
    const rejectedReasons = {};
    for (let i2 = 0; i2 < length; i2++) {
      nameOrAdapter = adapters2[i2];
      let id2;
      if (adapter = nameOrAdapter, !isResolvedHandle(nameOrAdapter) && (adapter = knownAdapters[(id2 = String(nameOrAdapter)).toLowerCase()], adapter === void 0))
        throw new AxiosError$1(`Unknown adapter '${id2}'`);
      if (adapter)
        break;
      rejectedReasons[id2 || "#" + i2] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id2, state]) => `adapter ${id2} ` + (state === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s2 = length ? reasons.length > 1 ? `since :
` + reasons.map(renderReason).join(`
`) : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError$1(
        "There is no suitable adapter to dispatch the request " + s2,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  }, "getAdapter"),
  adapters: knownAdapters
};
function throwIfCancellationRequested(config) {
  if (config.cancelToken && config.cancelToken.throwIfRequested(), config.signal && config.signal.aborted)
    throw new CanceledError$1(null, config);
}
__name(throwIfCancellationRequested, "throwIfCancellationRequested");
function dispatchRequest(config) {
  return throwIfCancellationRequested(config), config.headers = AxiosHeaders$1.from(config.headers), config.data = transformData.call(
    config,
    config.transformRequest
  ), ["post", "put", "patch"].indexOf(config.method) !== -1 && config.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(config.adapter || defaults.adapter)(config).then(/* @__PURE__ */ __name(function(response) {
    return throwIfCancellationRequested(config), response.data = transformData.call(
      config,
      config.transformResponse,
      response
    ), response.headers = AxiosHeaders$1.from(response.headers), response;
  }, "onAdapterResolution"), /* @__PURE__ */ __name(function(reason) {
    return isCancel$1(reason) || (throwIfCancellationRequested(config), reason && reason.response && (reason.response.data = transformData.call(
      config,
      config.transformResponse,
      reason.response
    ), reason.response.headers = AxiosHeaders$1.from(reason.response.headers))), Promise.reject(reason);
  }, "onAdapterRejection"));
}
__name(dispatchRequest, "dispatchRequest");
const VERSION$1 = "1.7.2", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i2) => {
  validators$1[type] = /* @__PURE__ */ __name(function(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  }, "validator");
});
const deprecatedWarnings = {};
validators$1.transitional = /* @__PURE__ */ __name(function(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return __name(formatMessage, "formatMessage"), (value, opt, opts) => {
    if (validator2 === !1)
      throw new AxiosError$1(
        formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    return version2 && !deprecatedWarnings[opt] && (deprecatedWarnings[opt] = !0, console.warn(
      formatMessage(
        opt,
        " has been deprecated since v" + version2 + " and will be removed in the near future"
      )
    )), validator2 ? validator2(value, opt, opts) : !0;
  };
}, "transitional");
function assertOptions(options, schema, allowUnknown) {
  if (typeof options != "object")
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  const keys = Object.keys(options);
  let i2 = keys.length;
  for (; i2-- > 0; ) {
    const opt = keys[i2], validator2 = schema[opt];
    if (validator2) {
      const value = options[opt], result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== !0)
        throw new AxiosError$1("option " + opt + " must be " + result2, AxiosError$1.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (allowUnknown !== !0)
      throw new AxiosError$1("Unknown option " + opt, AxiosError$1.ERR_BAD_OPTION);
  }
}
__name(assertOptions, "assertOptions");
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
var _a4;
let Axios$1 = (_a4 = class {
  constructor(instanceConfig) {
    this.defaults = instanceConfig, this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;
        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
        try {
          err.stack ? stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, "")) && (err.stack += `
` + stack) : err.stack = stack;
        } catch {
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config) {
    typeof configOrUrl == "string" ? (config = config || {}, config.url = configOrUrl) : config = configOrUrl || {}, config = mergeConfig$1(this.defaults, config);
    const { transitional: transitional2, paramsSerializer, headers } = config;
    transitional2 !== void 0 && validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), paramsSerializer != null && (utils$1.isFunction(paramsSerializer) ? config.paramsSerializer = {
      serialize: paramsSerializer
    } : validator.assertOptions(paramsSerializer, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), config.method = (config.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );
    headers && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers[method];
      }
    ), config.headers = AxiosHeaders$1.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = !0;
    this.interceptors.request.forEach(/* @__PURE__ */ __name(function(interceptor) {
      typeof interceptor.runWhen == "function" && interceptor.runWhen(config) === !1 || (synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous, requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected));
    }, "unshiftRequestInterceptors"));
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(/* @__PURE__ */ __name(function(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    }, "pushResponseInterceptors"));
    let promise, i2 = 0, len2;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      for (chain.unshift.apply(chain, requestInterceptorChain), chain.push.apply(chain, responseInterceptorChain), len2 = chain.length, promise = Promise.resolve(config); i2 < len2; )
        promise = promise.then(chain[i2++], chain[i2++]);
      return promise;
    }
    len2 = requestInterceptorChain.length;
    let newConfig = config;
    for (i2 = 0; i2 < len2; ) {
      const onFulfilled = requestInterceptorChain[i2++], onRejected = requestInterceptorChain[i2++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    for (i2 = 0, len2 = responseInterceptorChain.length; i2 < len2; )
      promise = promise.then(responseInterceptorChain[i2++], responseInterceptorChain[i2++]);
    return promise;
  }
  getUri(config) {
    config = mergeConfig$1(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}, __name(_a4, "Axios"), _a4);
utils$1.forEach(["delete", "get", "head", "options"], /* @__PURE__ */ __name(function(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
}, "forEachMethodNoData"));
utils$1.forEach(["post", "put", "patch"], /* @__PURE__ */ __name(function(method) {
  function generateHTTPMethod(isForm) {
    return /* @__PURE__ */ __name(function(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data
      }));
    }, "httpMethod");
  }
  __name(generateHTTPMethod, "generateHTTPMethod"), Axios$1.prototype[method] = generateHTTPMethod(), Axios$1.prototype[method + "Form"] = generateHTTPMethod(!0);
}, "forEachMethodWithData"));
var _a5;
let CancelToken$1 = (_a5 = class {
  constructor(executor) {
    if (typeof executor != "function")
      throw new TypeError("executor must be a function.");
    let resolvePromise;
    this.promise = new Promise(/* @__PURE__ */ __name(function(resolve3) {
      resolvePromise = resolve3;
    }, "promiseExecutor"));
    const token = this;
    this.promise.then((cancel2) => {
      if (!token._listeners) return;
      let i2 = token._listeners.length;
      for (; i2-- > 0; )
        token._listeners[i2](cancel2);
      token._listeners = null;
    }), this.promise.then = (onfulfilled) => {
      let _resolve2;
      const promise = new Promise((resolve3) => {
        token.subscribe(resolve3), _resolve2 = resolve3;
      }).then(onfulfilled);
      return promise.cancel = /* @__PURE__ */ __name(function() {
        token.unsubscribe(_resolve2);
      }, "reject"), promise;
    }, executor(/* @__PURE__ */ __name(function(message, config, request) {
      token.reason || (token.reason = new CanceledError$1(message, config, request), resolvePromise(token.reason));
    }, "cancel"));
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(listener) : this._listeners = [listener];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners)
      return;
    const index = this._listeners.indexOf(listener);
    index !== -1 && this._listeners.splice(index, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel2;
    return {
      token: new _a5(/* @__PURE__ */ __name(function(c2) {
        cancel2 = c2;
      }, "executor")),
      cancel: cancel2
    };
  }
}, __name(_a5, "CancelToken"), _a5);
function spread$1(callback) {
  return /* @__PURE__ */ __name(function(arr) {
    return callback.apply(null, arr);
  }, "wrap");
}
__name(spread$1, "spread$1");
function isAxiosError$1(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === !0;
}
__name(isAxiosError$1, "isAxiosError$1");
const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode$1).forEach(([key, value]) => {
  HttpStatusCode$1[value] = key;
});
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig), instance = bind2(Axios$1.prototype.request, context);
  return utils$1.extend(instance, Axios$1.prototype, context, { allOwnKeys: !0 }), utils$1.extend(instance, context, null, { allOwnKeys: !0 }), instance.create = /* @__PURE__ */ __name(function(instanceConfig) {
    return createInstance(mergeConfig$1(defaultConfig, instanceConfig));
  }, "create"), instance;
}
__name(createInstance, "createInstance");
const axios = createInstance(defaults);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError$1;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel$1;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData$1;
axios.AxiosError = AxiosError$1;
axios.Cancel = axios.CanceledError;
axios.all = /* @__PURE__ */ __name(function(promises) {
  return Promise.all(promises);
}, "all");
axios.spread = spread$1;
axios.isAxiosError = isAxiosError$1;
axios.mergeConfig = mergeConfig$1;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all: all2,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios, calcAverageSpeed = /* @__PURE__ */ __name((bytesUploaded, uploadStartedAt, uploadFinishedAt) => {
  if (uploadStartedAt === null) return 0;
  const start = uploadStartedAt.getTime(), diff = (((uploadFinishedAt == null ? void 0 : uploadFinishedAt.getTime()) ?? Date.now()) - start) / 1e3;
  return diff === 0 ? 0 : bytesUploaded / diff;
}, "calcAverageSpeed"), isAbortOrCancelError = /* @__PURE__ */ __name((error) => error instanceof AbortionError || error instanceof CanceledError || error instanceof DOMException && error.name === "AbortError", "isAbortOrCancelError"), isRetryableError = /* @__PURE__ */ __name((error) => !(isAbortOrCancelError(error) || (error == null ? void 0 : error.isRetryable) === !1), "isRetryableError"), stateMachineContext = /* @__PURE__ */ __name(({ context }) => context, "stateMachineContext"), stateMachineContextWithParentRef = /* @__PURE__ */ __name(({
  context,
  self: self2
}) => ({ ...context, parentRef: self2 }), "stateMachineContextWithParentRef"), startUploadFiles$1 = fromPromise(async ({ input }) => {
  const parentRef = input.parentRef, jobs = input.fileTree.mapFileNodes((fileNode) => {
    const uploader = fileNode.createUploader(input.uploaderFactory);
    return uploader.onUploadProgress(() => {
      parentRef.send({
        type: "fileUploadProgress"
      });
    }), uploader.onUploadSuccess(() => {
      parentRef.send({
        type: "fileUploadSucess"
      });
    }), uploader;
  }).map((uploader) => new Job(uploader.start.bind(uploader), uploader.retry.bind(uploader))), rateLimiter = input.options.uploadRateLimiter;
  rateLimiter.enqueue(...jobs), await rateLimiter.start();
}), retryUploadFiles$1 = fromPromise(async ({ input }) => {
  await input.options.uploadRateLimiter.retry();
}), createFiles = fromPromise(
  async ({ input }) => {
    const promises = input.fileTree.mapFileNodes(async (fileNode) => {
      var _a6, _b;
      return assertIsString(input.accountId), assertIsString(fileNode.fileId), assertIsString((_a6 = fileNode.storage) == null ? void 0 : _a6.bucket), assertIsString((_b = fileNode.storage) == null ? void 0 : _b.key), await input.requestService.createFile(
        {
          accountId: input.accountId,
          bucket: fileNode.storage.bucket,
          fileId: fileNode.fileId,
          fileKind: getFileKindInput(fileNode.file.type),
          key: fileNode.storage.key,
          name: fileNode.file.name,
          size: fileNode.file.size,
          type: fileNode.file.type
        },
        input.abortController.signal
      );
    });
    await Promise.all(promises);
  }
), actors$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFiles,
  retryUploadFiles: retryUploadFiles$1,
  startUploadFiles: startUploadFiles$1
}, Symbol.toStringTag, { value: "Module" })), simpleUploadSessionStateMachine = setup({
  actions: {
    abortAbortController: /* @__PURE__ */ __name(({ context }) => {
      context.abortController.abort();
    }, "abortAbortController"),
    abortUploaders: /* @__PURE__ */ __name(({ context }) => {
      context.fileTree.traverseFileNodes((fileNode) => {
        var _a6;
        (_a6 = fileNode.uploader) == null || _a6.abort();
      });
    }, "abortUploaders"),
    addFiles: enqueueActions(({ enqueue, context, event }) => {
      assertIsEvent(event, "addFiles"), context.fileTree.addFiles(event.files), enqueue.emit({ type: "fileTreeChange" });
    }),
    updateUploaderFactory: assign2({
      uploaderFactory: /* @__PURE__ */ __name(({ event }) => (assertIsEvent(event, "setUploaderFactory"), event.uploaderFactory), "uploaderFactory")
    }),
    setAccountId: assign2({
      accountId: /* @__PURE__ */ __name(({ event }) => (assertIsEvent(event, "start"), event.accountId), "accountId")
    }),
    clearError: assign2({
      error: null
    }),
    startUploadProgress: assign2({
      uploadStartedAt: /* @__PURE__ */ __name(() => /* @__PURE__ */ new Date(), "uploadStartedAt"),
      bytesUploaded: 0
    }),
    updateUploadProgress: enqueueActions(({ enqueue, context }) => {
      let bytesUploaded = 0;
      context.fileTree.traverseFileNodes((node) => {
        var _a6;
        bytesUploaded += ((_a6 = node.uploader) == null ? void 0 : _a6.uploadProgress.bytesUploaded) ?? 0;
      }), enqueue.assign({ bytesUploaded }), enqueue.emit({ type: "uploadProgress" });
    }),
    finishUploadProgress: enqueueActions(({ enqueue, context }) => {
      const numberOfFilesUploaded = context.numberOfFilesUploaded + 1;
      if (enqueue.assign({ numberOfFilesUploaded }), numberOfFilesUploaded === context.fileTree.numberOfFiles) {
        let bytesUploaded = 0;
        context.fileTree.traverseFileNodes((node) => {
          var _a6;
          bytesUploaded += ((_a6 = node.uploader) == null ? void 0 : _a6.uploadProgress.bytesUploaded) ?? 0;
        }), enqueue.assign({ uploadFinishedAt: /* @__PURE__ */ new Date(), bytesUploaded }), enqueue.emit({ type: "uploadSuccess" });
      }
    })
  },
  actors: actors$2,
  types: {
    context: {},
    // emitted: {} as UploadSessionStateMachineEmitted,
    events: {},
    input: {}
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5SwJYFsAOAbMBVbA9gIYQDKcqBAdgHQpUoAuKRWAxEQEYEBOjA2gAYAuolAYCqZtTEgAHogBMAdkU0AnMoBsAVgDMAFlXr9ADk0AaEAE9Ep0zpqKAjKa1bB6xeufOtBgF8Aq1RMHHwsYjIKFGo6BmZWDggIADEUHFghUSQQCSlYqlkFBBMaPUVBPSrXLT09XS0rWwRTQUEaU0V9ZR0DHUUDH1MgkPRsPEISclhKWnomFnYAVwwIIkZJyJIwHlSiAGNGXmts2XzFmVySg0VmxGVBA3LVQYNDQy6tUZBQiYiojM5vFFklYIwiHwzrkLtIitclKoNNp9EZvGZLDYlKZnJ1FCoTJ5BDovHofn9wlNorNCjQAGYZOAAfVW2wg9CgbAg1DA8QAbgQANa8ilbQExOIMzIsqkchD0AUHDaFbLQ8SSS7w0AlLT2Gh9LTqQSmVTVLTOHT3BAqNSKHHOarqfpDCrfYK-caUtlA2lS5msqIcti7Hi8GjYDZ03hoGiigHTCW0P2wGVsuUKghKuGqkTnDVw4qIXWmfUGQ3G02Cc2WrEIPTOdQ0ZT2s3vB2KcmesUJmmSxkpgMkINcXgCXMw-OFQsIYul8smxRmi1WnE0IbqDeVHTKQx9EbuuNUn196WD9lUTl++MQAAKoagPAoaryk6u2sQBneNGcO5NWm83hGMoVoNo4tzqLolQ4uoejKBanZhN21LAsmqaBhebBXkeywHE+47qgUb7yB+RhNpUO5GP03S6la6glpokGeMYBLOAh-xHom9L9mhQ4Xkyj6MDw1hBtyVC8hmwqxl217Hkm3Fnhy-FgIJwkXvKVCKsq1A5jkBGatOs4GkaC5LjWLQGA6TiGASvQeBZHYHtJHG9nJp6ynxAlCUGIZhhGjBRjwMaHt6nGoQpHnKV5akZlmKoiM+sJTgiM56kZFaLlWy61v+uLGjophlkYxrtA5YyITJoXye5UBKSpw7cFC+EvoRWrESlJZpSZmVmQ8zjPBiJj5bBng6GxXrii5XFuWmEV1RhWFsneBAPnhunNfpyWfnoNB5U62gGKYsHqFaJKNvYRo6I0e2GmNSGyVN-rVbVUWXoyMk4ateYtdOn7KDQdR2joOigQYFYnVUa56CS3Rlk8WjNrdFWTWFT2wDhuGzGwCWvq1JS+KD+qPC4PjOIIxhWqDjh0bcXRtI8BW9IjzkoVVM01XSRAZMsj4cA1Y5rYlRF431HTboIxO+GT3gnb436Xb4dRweaMFumV7EhcjrPoeznNYNzYBsJ5pxNYLuMPOaGgFYo-jmpBJonYM-0VHB+jmsoPhMxrLPSgcj7KhhoniRpQoik5Xu+txvtgP7UDqZp2bxSbOPTha3TlE8+U6FUwNuAYFN2v9nh2iYeiaM2n6exN3vMlHMfBjwoY8OGWCRtGUnlczEc+37zDRcHsXaYnAvJ8lqeONU-QONntR57W9SOBa-56G4fj1k8lc9tXKa173OtczzI6NcP32jyYf2gYudnOJU-RWhUJZS-YsPVsoG-IV3Nc94pHP7wbRvYyfd8CBF7PFUDbHcXhiqzxaIuEsjw169DJtUXwZIfhUAIBAOAshgpVySnpAsyUAC0TRazEJ2u0ChlCKHvDfvdQ+mwIBfQ2kA8ijYXBuFUBaH8QwTplk6NDcwy8HB0VoZxBYiQsBMIIUAyWGhYIugaIMZePDaxGltM2LOjQLSCFYo5Du4cTyPTZlIvBbV3gdDooMPoUMiSl2gUoCCnQvhTx0VnAYojNbTW1s9VSUATFCw-NUJsrhlC3GJF4Zs8MrSPFxNZY0TpzAZ10Wrcam8P4DlRujCg-izalE8OUd4cEV7tmOrWUGzxqbeFcLYyiHit48XPHvPWj4cnThJk2T8xoqmHWEbwkspMYKlz8BZMs+4Ul3Uqt3aOu9Wmj3rLiIYLh2iXWJKXPQd9VwHVuIaBsxI-CjT0erXBhjt5fz4mjA4GN4ATkAW1H84sdoOC6PWTQ7wnT5y0OUaGmg3BEnFnU9JTId7f11vrWZMi4J-TtHUIGYtF49TrMDUshICp5WvvuIIQA */
  context: /* @__PURE__ */ __name(({ input }) => ({
    options: input.options,
    requestService: input.requestService,
    uploaderFactory: input.uploaderFactory,
    abortController: new AbortController(),
    accountId: null,
    bytesUploaded: 0,
    dataImportRequestId: null,
    dataImportRequestOptions: null,
    error: null,
    fileTree: new FileTree(),
    numberOfFilesUploaded: 0,
    uploadFinishedAt: null,
    uploadStartedAt: null
  }), "context"),
  id: "simpleUploadSession",
  initial: "initial",
  states: {
    aborted: {
      type: "final"
    },
    initial: {
      on: {
        abort: {
          target: "aborted"
        },
        addFiles: {
          actions: "addFiles"
        },
        updateUploaderFactory: {
          actions: "updateUploaderFactory"
        },
        start: {
          target: "files_uploading",
          actions: "setAccountId"
        }
      }
    },
    files_uploading: {
      invoke: {
        src: "startUploadFiles",
        input: stateMachineContextWithParentRef,
        onDone: {
          target: "files_uploading_success"
        },
        onError: {
          target: "files_uploading_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: ["abortUploaders"]
        },
        fileUploadProgress: {
          actions: ["updateUploadProgress"]
        },
        fileUploadSucess: {
          actions: ["finishUploadProgress"]
        }
      }
    },
    files_uploading_retrying: {
      invoke: {
        src: "retryUploadFiles",
        input: stateMachineContextWithParentRef,
        onDone: {
          target: "files_uploading_success"
        },
        onError: {
          target: "files_uploading_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: ["abortUploaders"]
        },
        fileUploadProgress: {
          actions: ["updateUploadProgress"]
        },
        fileUploadSucess: {
          actions: ["finishUploadProgress"]
        }
      }
    },
    files_uploading_success: {
      always: "files_creating"
    },
    files_uploading_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: ["abortUploaders"]
        },
        retry: {
          target: "files_uploading_retrying",
          actions: "clearError"
        }
      }
    },
    files_creating: {
      invoke: {
        src: "createFiles",
        input: stateMachineContext,
        onDone: {
          target: "files_creating_success"
        },
        onError: {
          target: "files_creating_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: ["abortAbortController"]
        }
      }
    },
    files_creating_success: {
      type: "final"
    },
    files_creating_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: ["abortAbortController"]
        },
        retry: {
          target: "files_creating",
          actions: "clearError"
        }
      }
    }
  }
}), _SimpleUploadSession = class _SimpleUploadSession {
  constructor(uploaderFactory, requestService, options) {
    __publicField(this, "_requestService");
    __publicField(this, "_uploaderFactory");
    __publicField(this, "_options");
    __publicField(this, "_stateMachineActor");
    __publicField(this, "addFiles", /* @__PURE__ */ __name((files) => {
      this._stateMachineActor.send({ type: "addFiles", files });
    }, "addFiles"));
    __publicField(this, "subscribeFileTreeChange", /* @__PURE__ */ __name((listener) => {
      const subscription = this._stateMachineActor.on("fileTreeChange", listener);
      return () => subscription.unsubscribe();
    }, "subscribeFileTreeChange"));
    this._uploaderFactory = uploaderFactory, this._requestService = requestService, this._options = {
      logger: (options == null ? void 0 : options.logger) ?? new ConsoleLogger("SimpleUploadSession"),
      uploadRateLimiter: (options == null ? void 0 : options.uploadRateLimiter) ?? new RateLimiter()
    }, this._stateMachineActor = createActor(simpleUploadSessionStateMachine, {
      input: {
        options: this._options,
        requestService: this._requestService,
        uploaderFactory: this._uploaderFactory
      }
    }), this._stateMachineActor.start();
  }
  setUploaderFactory(uploaderFactory) {
    this._stateMachineActor.send({ type: "setUploaderFactory", uploaderFactory });
  }
  async start(accountId) {
    return new Promise((resolve3, reject) => {
      this._stateMachineActor.subscribe((snapshot) => {
        snapshot.value === "files_creating_success" && resolve3(), snapshot.value === "aborted" && reject(new AbortionError()), snapshot.context.error && reject(snapshot.context.error);
      }), this._stateMachineActor.send({ type: "start", accountId });
    });
  }
  async retry() {
    return new Promise((resolve3, reject) => {
      this._stateMachineActor.subscribe((snapshot) => {
        snapshot.value === "files_creating_success" && resolve3(), snapshot.value === "aborted" && reject(new AbortionError()), snapshot.context.error && reject(snapshot.context.error);
      }), this._stateMachineActor.send({ type: "retry" });
    });
  }
  abort() {
    const snapshot = this._stateMachineActor.getSnapshot();
    if (!snapshot.can({ type: "abort" })) {
      this._options.logger.warn(`current stage (${snapshot.value}) is not abortable`);
      return;
    }
    this._stateMachineActor.send({ type: "abort" });
  }
  get error() {
    return this._stateMachineActor.getSnapshot().context.error;
  }
  get stage() {
    return this._stateMachineActor.getSnapshot().value;
  }
  get fileTree() {
    return this._stateMachineActor.getSnapshot().context.fileTree;
  }
  get uploadProgress() {
    const context = this._stateMachineActor.getSnapshot().context, { bytesUploaded, uploadFinishedAt, uploadStartedAt, numberOfFilesUploaded, fileTree } = context, bytesTotal = fileTree.sizeOfFiles;
    return {
      averageSpeed: calcAverageSpeed(bytesUploaded, uploadStartedAt, uploadFinishedAt),
      bytesTotal,
      bytesUploaded,
      hasFinished: uploadFinishedAt !== null,
      hasStarted: uploadStartedAt !== null,
      numberOfFilesTotal: fileTree.numberOfFiles,
      numberOfFilesUploaded,
      proportion: bytesTotal === 0 ? 0 : bytesUploaded / bytesTotal,
      uploadFinishedAt,
      uploadStartedAt
    };
  }
  get stateMachineActor() {
    return this._stateMachineActor;
  }
};
__name(_SimpleUploadSession, "SimpleUploadSession");
let SimpleUploadSession = _SimpleUploadSession;
const useCreateNewSimpleUploadSession = /* @__PURE__ */ __name((uploaderFactory, simpleUploadSessionRequestService, options) => {
  useLifeCycleLogger("useCreateNewSimpleUploadSession");
  const createSimpleUploadSession = useCallback(
    () => new SimpleUploadSession(uploaderFactory, simpleUploadSessionRequestService, options),
    [options, simpleUploadSessionRequestService, uploaderFactory]
  ), [simpleUploadSession, setSimpleUploadSession] = useState(createSimpleUploadSession), createNewSimpleUploadSession = useCallback(() => {
    setSimpleUploadSession(createSimpleUploadSession());
  }, [createSimpleUploadSession]);
  return useEffect(() => {
    simpleUploadSession.setUploaderFactory(uploaderFactory);
  }, [simpleUploadSession, uploaderFactory]), {
    simpleUploadSession,
    createNewSimpleUploadSession
  };
}, "useCreateNewSimpleUploadSession"), _CreateDataImportRequestsUseCase = class _CreateDataImportRequestsUseCase {
  constructor(requestService) {
    __publicField(this, "_requestService");
    this._requestService = requestService;
  }
  async execute(dataImportRequestOptions) {
    return await this._requestService.createDataImportRequestV2({
      dependants: dataImportRequestOptions.dependants,
      featureType: dataImportRequestOptions.featureType,
      name: "DataImportRequest",
      // TODO: unique name?
      persistType: dataImportRequestOptions.persistType,
      priority: dataImportRequestOptions.priority,
      rootFolderIdempotencyKeyAndName: {
        idempotencyKey: "/",
        name: "/"
      },
      systemFolderNodeId: dataImportRequestOptions.parentSystemFolderNodeId
    });
  }
};
__name(_CreateDataImportRequestsUseCase, "CreateDataImportRequestsUseCase");
let CreateDataImportRequestsUseCase = _CreateDataImportRequestsUseCase;
const _CreateFileImportRequestsUseCase = class _CreateFileImportRequestsUseCase {
  constructor(requestService) {
    __publicField(this, "_requestService");
    this._requestService = requestService;
  }
  async execute(dataImportRequestId, fileTree) {
    await this._requestService.updateDataImportRequestStatus({
      dataImportRequestId,
      status: DATA_IMPORT_REQUEST_STATUS.TRACKING_FILE_PATHS
    });
    const promises = [];
    fileTree.traverse((node) => {
      if (node.type === "file") return;
      const childFileAbsolutePaths = [...node.childFileAbsolutePaths.values()], fileItems = childFileAbsolutePaths.map((filePath) => {
        const fileNode = fileTree.getNode(filePath);
        assertIsFileNode(fileNode);
        const metadata = {
          name: fileNode.file.name,
          size: fileNode.file.size
        };
        return {
          fileIdempotencyKey: filePath,
          fileName: fileNode.file.name,
          fileKind: getFileKind(fileNode.file.type),
          metadata
        };
      }), folderImportRequestId = node.folderImportRequestId;
      assertIsString(folderImportRequestId);
      const promise = /* @__PURE__ */ __name(async () => {
        await this._requestService.updateFolderImportRequestStatus({
          folderImportRequestId,
          status: NODE_IMPORT_REQUEST_STATUS.TRACKING_FILE_PATHS
        });
        const fileImportRequestIds = await this._requestService.createFileImportRequests({
          dataImportRequestId,
          folderImportRequestId,
          files: fileItems
        });
        if (fileImportRequestIds.length !== fileItems.length)
          throw new ServerError("not all files have fileImportRequestId");
        for (let i2 = 0; i2 < fileImportRequestIds.length; i2++) {
          const fileImportRequestId = fileImportRequestIds[i2], filePath = childFileAbsolutePaths[i2], fileNode = fileTree.getNode(filePath);
          if (assertIsFileNode(fileNode), !fileImportRequestId)
            throw new ServerError("fileImportRequestId is not returned from server");
          fileNode.fileImportRequestId === null && fileNode.setFileImportRequestId(fileImportRequestId);
        }
        await this._requestService.updateFolderImportRequestStatus({
          folderImportRequestId,
          status: NODE_IMPORT_REQUEST_STATUS.FILE_PATHS_TRACKED
        });
      }, "promise");
      promises.push(promise());
    }), await Promise.all(promises), await this._requestService.updateDataImportRequestStatus({
      dataImportRequestId,
      status: DATA_IMPORT_REQUEST_STATUS.FILE_PATHS_TRACKED
    });
  }
};
__name(_CreateFileImportRequestsUseCase, "CreateFileImportRequestsUseCase");
let CreateFileImportRequestsUseCase = _CreateFileImportRequestsUseCase;
const _CreateFileNodesUseCase = class _CreateFileNodesUseCase {
  constructor(chunkThreshold, requestService) {
    __publicField(this, "_chunkThreshold");
    __publicField(this, "_requestService");
    this._chunkThreshold = chunkThreshold, this._requestService = requestService;
  }
  async execute(dataImportRequestId, fileTree) {
    await this._requestService.updateDataImportRequestStatus({
      dataImportRequestId,
      status: DATA_IMPORT_REQUEST_STATUS.IMPORTING_FILE_NODES
    });
    const promises = [];
    fileTree.traverseFolderNodes((node) => {
      const idempotencyKeysAndStorages = [];
      for (const childFilePath of node.childFileAbsolutePaths) {
        const childFileNode = fileTree.getNode(childFilePath);
        if (!childFileNode || childFileNode.type === "folder") return;
        if (childFileNode.storage === null)
          throw new BadStateError(`file node (${childFileNode}) has no storage`);
        const idempotencyKeyAndStorage = {
          idempotencyKey: childFileNode.absolutePath,
          storage: {
            bucket: childFileNode.storage.bucket,
            key: childFileNode.storage.key,
            name: childFileNode.file.name,
            size: childFileNode.file.size,
            type: childFileNode.file.type
          }
        };
        idempotencyKeysAndStorages.push(idempotencyKeyAndStorage);
      }
      const idempotencyKeysAndStoragesChunked = chunk(
        idempotencyKeysAndStorages,
        this._chunkThreshold
      ), promise = /* @__PURE__ */ __name(async () => {
        var _a6;
        assertIsString(node.folderImportRequestId), await this._requestService.updateFolderImportRequestStatus({
          folderImportRequestId: node.folderImportRequestId,
          status: NODE_IMPORT_REQUEST_STATUS.IMPORTING_FILE_NODES
        });
        for (const idempotencyKeysAndStoragesChunk of idempotencyKeysAndStoragesChunked) {
          const fileSystemNodeIds = await this._requestService.createFileNodes({
            dataImportRequestId,
            fileIdempotencyKeyStorageAndMetadata: idempotencyKeysAndStoragesChunk,
            folderImportRequestId: node.folderImportRequestId
          });
          for (let i2 = 0; i2 < idempotencyKeysAndStoragesChunk.length; i2++) {
            const fileSystemNodeId = fileSystemNodeIds == null ? void 0 : fileSystemNodeIds.at(i2);
            assertIsString(fileSystemNodeId, "fileSystemNodeId is not a string");
            const filePath = (_a6 = idempotencyKeysAndStoragesChunk.at(i2)) == null ? void 0 : _a6.idempotencyKey;
            assertIsString(filePath, "filePath is not a string");
            const fileNode = fileTree.getNode(filePath);
            assertIsFileNode(fileNode), fileNode.setFileSystemNodeId(fileSystemNodeId);
          }
        }
        await this._requestService.updateFolderImportRequestStatus({
          folderImportRequestId: node.folderImportRequestId,
          status: NODE_IMPORT_REQUEST_STATUS.FILE_NODES_IMPORTED
        });
      }, "promise");
      promises.push(promise());
    }), await Promise.all(promises), await this._requestService.updateDataImportRequestStatus({
      dataImportRequestId,
      status: DATA_IMPORT_REQUEST_STATUS.FILE_NODES_IMPORTED
    });
  }
};
__name(_CreateFileNodesUseCase, "CreateFileNodesUseCase");
let CreateFileNodesUseCase = _CreateFileNodesUseCase;
const _CreateFolderImportRequestsUseCase = class _CreateFolderImportRequestsUseCase {
  constructor(requestService) {
    __publicField(this, "_requestService");
    this._requestService = requestService;
  }
  async execute(dataImportRequestId, fileTree) {
    await this._requestService.updateDataImportRequestStatus({
      dataImportRequestId,
      status: DATA_IMPORT_REQUEST_STATUS.TRACKING_FOLDER_PATHS
    });
    const promises = fileTree.mapFolderNodes((node) => {
      const childFolderNodeIdempotencyKeyAndNames = [];
      for (const childPath of node.childFolderAbsolutePaths)
        childFolderNodeIdempotencyKeyAndNames.push({
          idempotencyKey: childPath,
          name: pathBrowserify.basename(childPath)
        });
      return /* @__PURE__ */ __name(async () => {
        const folderImportRequestIds = await this._requestService.createFolderImportRequests({
          dataImportRequestId,
          parentFolderNodeIdempotencyKey: node.absolutePath,
          childFolderNodeIdempotencyKeyAndNames
        });
        for (let i2 = 0; i2 < childFolderNodeIdempotencyKeyAndNames.length; i2++) {
          const folderImportRequestId = folderImportRequestIds[i2];
          if (!folderImportRequestId)
            throw new ServerError("folderImportRequestId is not returned from server");
          const childPath = childFolderNodeIdempotencyKeyAndNames[i2].idempotencyKey, childNode = fileTree.getNode(childPath);
          assertIsFolderNode(childNode), childNode.folderImportRequestId === null && childNode.setFolderImportRequestId(folderImportRequestId);
        }
      }, "promise");
    });
    for (const promise of promises)
      await promise();
    await this._requestService.updateDataImportRequestStatus({
      dataImportRequestId,
      status: DATA_IMPORT_REQUEST_STATUS.FOLDER_PATHS_TRACKED
    });
  }
};
__name(_CreateFolderImportRequestsUseCase, "CreateFolderImportRequestsUseCase");
let CreateFolderImportRequestsUseCase = _CreateFolderImportRequestsUseCase;
const _CreateFolderNodesUseCase = class _CreateFolderNodesUseCase {
  constructor(requestService) {
    __publicField(this, "_requestService");
    this._requestService = requestService;
  }
  async execute(dataImportRequestId, fileTree) {
    await this._requestService.updateDataImportRequestStatus({
      dataImportRequestId,
      status: DATA_IMPORT_REQUEST_STATUS.IMPORTING_FOLDER_NODES
    });
    const rootFolderNode = fileTree.getRootNode();
    assertIsFolderNode(rootFolderNode);
    const rootFolderImportRequestId = rootFolderNode.folderImportRequestId;
    assertIsString(rootFolderImportRequestId), await this._requestService.updateFolderImportRequestStatus({
      folderImportRequestId: rootFolderImportRequestId,
      status: NODE_IMPORT_REQUEST_STATUS.FOLDER_NODE_IMPORTED
    });
    const promises = fileTree.mapFolderNodes((node) => {
      const parentFolderImportRequestId = node.folderImportRequestId;
      assertIsString(parentFolderImportRequestId);
      const childFolderImportRequestIds = [...node.childFolderAbsolutePaths.values()].map((folderPath) => {
        const childFolderNode = fileTree.getNode(folderPath);
        return assertIsFolderNode(childFolderNode), childFolderNode.folderImportRequestId;
      });
      return /* @__PURE__ */ __name(async () => {
        await this._requestService.createFolderNodes({
          dataImportRequestId,
          parentFolderImportRequestId,
          childFolderImportRequestIds
        }), await this._requestService.updateFolderImportRequestStatus({
          folderImportRequestId: parentFolderImportRequestId,
          status: NODE_IMPORT_REQUEST_STATUS.FOLDER_NODE_IMPORTED
        });
      }, "promise");
    });
    for (const promise of promises)
      await promise();
    await this._requestService.updateDataImportRequestStatus({
      dataImportRequestId,
      status: DATA_IMPORT_REQUEST_STATUS.FOLDER_NODES_IMPORTED
    });
  }
};
__name(_CreateFolderNodesUseCase, "CreateFolderNodesUseCase");
let CreateFolderNodesUseCase = _CreateFolderNodesUseCase;
const _CreateThumbnailsUseCase = class _CreateThumbnailsUseCase {
  constructor(chunkThreshold, requestService) {
    __publicField(this, "_chunkThreshold");
    __publicField(this, "_requestService");
    this._chunkThreshold = chunkThreshold, this._requestService = requestService;
  }
  async execute(dataImportRequestId) {
    const numberOfFileImportRequests = await this._requestService.countFileImportRequests({
      dataImportRequestId,
      fileKind: FILE_KIND.IMAGE
    });
    for (let i2 = 0; i2 < numberOfFileImportRequests; i2 += this._chunkThreshold) {
      const fileIds = await this._requestService.findFileIds({
        dataImportRequestId,
        fileKind: FILE_KIND.IMAGE,
        start: i2,
        size: this._chunkThreshold
      });
      await this._requestService.createThumbnails({ fileIds });
    }
  }
};
__name(_CreateThumbnailsUseCase, "CreateThumbnailsUseCase");
let CreateThumbnailsUseCase = _CreateThumbnailsUseCase;
const _FindDataImportRequestUseCase = class _FindDataImportRequestUseCase {
  constructor(requestService) {
    __publicField(this, "_requestService");
    this._requestService = requestService;
  }
  async execute(dataImportRequestId, fileTree) {
    const { rootFolderImportRequestId } = await this._requestService.findDataImportRequest({
      dataImportRequestId
    }), rootNode = fileTree.getRootNode();
    assertIsFolderNode(rootNode), rootNode.setFolderImportRequestId(rootFolderImportRequestId), fileTree.traverse((node) => node.setDataImportRequestId(dataImportRequestId));
  }
};
__name(_FindDataImportRequestUseCase, "FindDataImportRequestUseCase");
let FindDataImportRequestUseCase = _FindDataImportRequestUseCase;
const createDataImportRequest = fromPromise(
  async ({ input }) => {
    if (input.dataImportRequestOptions === null)
      throw new BadStateError("dataImportRequestOptions has not been set");
    return await new CreateDataImportRequestsUseCase(input.requestService).execute(input.dataImportRequestOptions);
  }
), findDataImportRequest = fromPromise(
  async ({ input }) => {
    assertIsString(input.dataImportRequestId), await new FindDataImportRequestUseCase(input.requestService).execute(input.dataImportRequestId, input.fileTree);
  }
), createFolderImportRequests = fromPromise(
  async ({ input }) => {
    assertIsString(input.dataImportRequestId), await new CreateFolderImportRequestsUseCase(input.requestService).execute(input.dataImportRequestId, input.fileTree);
  }
), createFileImportRequests = fromPromise(
  async ({ input }) => {
    assertIsString(input.dataImportRequestId), await new CreateFileImportRequestsUseCase(input.requestService).execute(input.dataImportRequestId, input.fileTree);
  }
), createFolderNodes = fromPromise(
  async ({ input }) => {
    assertIsString(input.dataImportRequestId), await new CreateFolderNodesUseCase(input.requestService).execute(input.dataImportRequestId, input.fileTree);
  }
), createFileNodes = fromPromise(
  async ({ input }) => {
    assertIsString(input.dataImportRequestId), await new CreateFileNodesUseCase(
      input.options.chunkThreshold ?? 500,
      input.requestService
    ).execute(input.dataImportRequestId, input.fileTree);
  }
), startUploadFiles = fromPromise(
  async ({ input }) => {
    const parentRef = input.parentRef, jobs = input.fileTree.mapFileNodes((fileNode) => {
      const uploader = fileNode.createUploader(input.uploaderFactory);
      return uploader.onUploadProgress(() => {
        parentRef.send({
          type: "fileUploadProgress"
        });
      }), uploader.onUploadSuccess(() => {
        parentRef.send({
          type: "fileUploadSucess"
        });
      }), uploader;
    }).map((uploader) => new Job(uploader.start.bind(uploader), uploader.retry.bind(uploader))), rateLimiter = input.rateLimiter;
    rateLimiter.enqueue(...jobs), await rateLimiter.start();
  }
), retryUploadFiles = fromPromise(
  async ({ input }) => {
    await input.rateLimiter.retry();
  }
), createThumbnails = fromPromise(
  async ({ input }) => {
    assertIsString(input.dataImportRequestId), await new CreateThumbnailsUseCase(
      input.options.chunkThreshold ?? 500,
      input.requestService
    ).execute(input.dataImportRequestId);
  }
), actors$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createDataImportRequest,
  createFileImportRequests,
  createFileNodes,
  createFolderImportRequests,
  createFolderNodes,
  createThumbnails,
  findDataImportRequest,
  retryUploadFiles,
  startUploadFiles
}, Symbol.toStringTag, { value: "Module" })), uploadSessionStateMachine = setup({
  actions: {
    abort: /* @__PURE__ */ __name(() => {
    }, "abort"),
    abortUploaders: /* @__PURE__ */ __name(({ context }) => {
      context.fileTree.traverseFileNodes((fileNode) => {
        var _a6;
        (_a6 = fileNode.uploader) == null || _a6.abort();
      });
    }, "abortUploaders"),
    addFiles: enqueueActions(({ enqueue, context, event }) => {
      assertIsEvent(event, "addFiles"), context.fileTree.addFiles(event.files), enqueue.emit({ type: "fileTreeChange" });
    }),
    setUploaderFactory: assign2({
      uploaderFactory: /* @__PURE__ */ __name(({ event }) => (assertIsEvent(event, "setUploaderFactory"), event.uploaderFactory), "uploaderFactory")
    }),
    clearError: assign2({
      error: null
    }),
    start: assign2({
      dataImportRequestOptions: /* @__PURE__ */ __name(({ event }) => (assertIsEvent(event, "start"), event.dataImportRequestOptions), "dataImportRequestOptions")
    }),
    startUploadProgress: assign2({
      uploadStartedAt: /* @__PURE__ */ __name(() => /* @__PURE__ */ new Date(), "uploadStartedAt"),
      bytesUploaded: 0
    }),
    // this action is triggered on every file's uploader's fileUploadProgress event,
    // and will sum up the bytesUploaded of all files.
    // we need to *throttle* this action to prevent too frequent state updates.
    updateUploadProgress: enqueueActions(({ enqueue, context }) => {
      const now2 = /* @__PURE__ */ new Date();
      if (context.uploadProgressUpdatedAt !== null && now2.getTime() - context.uploadProgressUpdatedAt.getTime() < UNITS.MILLISECOND.SECOND)
        return;
      let bytesUploaded = 0;
      context.fileTree.traverseFileNodes((node) => {
        var _a6;
        bytesUploaded += ((_a6 = node.uploader) == null ? void 0 : _a6.uploadProgress.bytesUploaded) ?? 0;
      }), enqueue.assign({ bytesUploaded, uploadProgressUpdatedAt: now2 }), enqueue.emit({ type: "uploadProgress" });
    }),
    // this action is triggered on every file's uploader's fileUploadSuccess event
    finishUploadProgress: enqueueActions(({ enqueue, context }) => {
      const numberOfFilesUploaded = context.numberOfFilesUploaded + 1;
      enqueue.assign({ numberOfFilesUploaded }), numberOfFilesUploaded === context.fileTree.numberOfFiles && (enqueue.assign({
        uploadFinishedAt: /* @__PURE__ */ new Date(),
        bytesUploaded: context.fileTree.sizeOfFiles
      }), enqueue.emit({ type: "uploadSuccess" }));
    })
  },
  actors: actors$1,
  types: {
    context: {},
    emitted: {},
    events: {},
    input: {}
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QFcAOAbA9gQwgZTlgEtMA7AOiNKIBcjt0BibAI0wCcaBtABgF1EoVJmJ0ygkAA9EAJgAsc8gHYZANgCsagJxKAHDKUAaEAE9EugIzk5WrbqUBmHnN1z1PSwF9PxtFlwEsMRklNR0DMwQEABiROhwvAJIIMKiJKQS0giW5BZamvYu9g5aCsZmCA4yVqq6WlWqNg5KqhYy3r4YOPiE6aG09EywYDQAql24YOzR2ADGNBwmiRKpA+LJWXIy5bIy6uQyDqoObU48Wqoyex0gft2BwRRUAxGwNNicy8mrYhkbsgplGpNKodPojKZEHIeKpyB55IdbFoYTpVDc7gFeiEINh3gBJAC2wk4ACUwABHZBwGgAfVm7DAuKoUEYEDIYFCADdMABrDkYnpBPo4-FEjg0MmU6l0hlM0hQBBUbmzJlkRJfIQiNZ-UBZUEOchaGT5Aw2dQaS47BCOJS5E51CxuByuJToiaCx7kEXYQnEiUUqlvGWMujyxhTdgccgYXEAMw4BPIAoewtxPrFpID0vpIeZitIytVpHV-BWWt+mUQ+sNxs0SjNFu2kIQcgsujtV106mhFwsFm7bv8HtTor9ksDtJzcpZrHFGpS5fSlYQ1aNJvr+UbVqu+yuGh4DXNulB7R8t3dKexad94vH2dloagNNgyFms0IjHnPyX-wQFicVhVLoPAyF2ehKOachWi0PC5B4Sg8HkXaHLog73FiFDejemZSkGU6PjSsbYHEyAMswbCfKW3yLusuqIP+iHkEBIFgfYkFWq2VjOFofYnB4RrOuoaGYkKV6jreWZ4Q+zKEcR6CkWAjAMjQ7BLFRmppLRUjmPI5DHgh6g6HYSj1hYVpVDUSj5BY9bqK4XbHsJw5iemY6SbSsZUBAzKsuyXK8vyF4YV614Zv6uEeV5eZKpgKq-CWSQadqy5ttUhowtUhkHuoRwOFaFg8IxexuK0x48WaTmXphoVuRFhFRWGEZRjGNDxuwibJsFWFhXeQaeaQ3nyvmhbxfwX40Tq2l-voVjIpc-bIg4OXHNBci2rU1Stjw9ZqKhZ6daJ1XiThE71QNPmzpRiULppk1ZKls0ZQt2W5Va6jdsoEGXCBPA5YcDiVV1NUSXV-WDU+L5vh+423cuiKKAoILqDtzQQhUBVFd25ptqCjr5IDh0hcd4WnWDMlESRZGXdw6k3clv7w9YbjAijJmrbBhn2DuJxzXtnRDlVROuSDpMNU+FPyWRymqTD9N0X+9S2saqjgRtzTI1aGhWJ2xxyCUlg7gTnrxugEBTNhJPUrAwbTr5pAcjFfJJkFhMm2b7AW71NDW-h0UFrFRYJWWsMM-UBr9qVdg2dCqj5dtiiHAVNhyKooJp0bfRu+bPXuT70mNewkbsNG6BxgmzsC8FWceznEV57mQ0xXF6RB9RIfy8aDjh9jdSWPWMJWnYsEmfoeszQVmgZyE1ee7nNsEZD75BJ+tPflpWRLRBTHOLU6h5AYfbqHH9YHHxyepxcFxTxQM+1xO9fTrJlOKdTssVr+m-7E4KddvvSiH4PRw5BQQ2G2kteoiE0T7RdsbTApts61XvvPcmckFJKRGDLVeE1lxOGAtYHKB4SjyDKkfZsuhXBMT2FcC4oEnDHGvuQTy8RZ512QWGNk9t-JOwOsbOIYAWFIN9o3f2zc1RjSwe3Kan9t4-z3kaf+-Ztx2UUN2Y8ewShWTyAwph-C75WzYSyJqxcWptQ6jAzOfCBH6KEQqJugdxHXTXndRAm9YSNAPIVFiiNtxtFmkaY49Q+xuB0Noyxei3gPwXq+JesBGCzDIKGKkAAVTA4whyxHiLAN+P55arlrKaTc5omzo2NAjOytYVBULqKE5h4TvYGOfNE6GEi5ZTTyeuBsRT8rEPwfob+KcrgwhqboxB1j87i1QVTCiNNHHYI-sjL+O9f7yIAc2GQIF9g5R4g0JaJwtjDKsREhpEs0HSzUrMyRG8FkyN3n-VZFQrj9iZoZZoCgYQISgfzdCrs+HWwFD5DhDt-bcPMdPX5NJ-nCJGi3BxwdWn3QApQ4CoFkZsUaN0-IhpyktDYgtPm55K4-MyRC90PkjElzLu1Cu3zeHEshbYkR9i+DZPXvRRFzEUXgXYs2f8etenrMQroBop4vkiVpXAElQ4LrTJZc4v87LQIsVRV9KCPL+ybNAnsc05TDKumgYS8VfzSVhh0Wk7oAAFSMUAGRBFlSlECWgmLyMaM6Zw1Q8pqoQnCX6Hg9bVCFY0YZRqpUmr4WagIr5CB2t-AVLuhoSitFqCZGElhj4GneqlZ0xRA36ppRYulxqnxnIBX5R2gUDX5olfSmkxaoUB1Gsylp795YMUAoqzlaLVXoz1rCHieMhVtDWgDXNYrK3Bu6DJWthjC7NVLq1cuPCx2SonfKGtGCTB+2hWIxtFz4VssYhy1iKrtzNFgsaRwOhzjfxFQSvNYKC0hqLeu6Vc4m05Kmq2pFSquXop5cedsXdDKtnIVQlwQbl24Enc+0N8Rw0QEtZga1Ua32sr-DCfY+kgmOD3K4HxjQmI2S7O9E4S1U7gerVOxgpqLyRttShuVBUvWth7AeGwEFDjbneXpRorh-yCWRnq0Vzkb7gurYvZpu7m0fpmuleaWVdkrR5VsR1qd+w2WaLjQ45HC1P0li-GV9GUoybmplRay0PUPIcG4YB+RyHQkQnvQTt7R33qrTpk5Ut13Rpba85QFoVYwVSsU3YQDXBj2NIVBEnznPCcYXA92AA5TAZtIkls4WW6lLmb7xamEllLBjhr1phTuuFUmsiM0RizLYqN8p6EUOVFFGhNBOGHUJwW1c8sSpseGGdxi52mMy7FjryWuvjMK6I4ssK257oQBV5mGhWZo3oj2XI9ljQXGOOU7ROX2CddS6u8Ty9vNTU7t3SOfcY61YoeVCwlwcp60Vtt+Bu2Rv7Ymc-cir7JPvvK2HXIPco791jkpkCcF+wQTsnvQdT3EuveOZMxSZzjvlZcIoAqOhnQISss0fKJwZDKBI4cCL1QDDDL2wYu2QLuQgora58nNjxtMuRy46539bkrMUTykyto9A8V1W2ZNcgydw+6+SkxC7QUifiPTsbdiG3M8qIVR1AubDFSqHufKhl9iFRgho7aE9hf5e66-Qz8yt5s+WQfTn6NaiASOI6d6ewdD9kN6Nhu729OfauqVn7sg-sRzbIDy7Sm7DkHem4Oo3O+1C5HUNvhMv3e6dOV503Hd-cA4uwPHltR2wp3OD9JEm1vBnlIK9iQi6tJOOXAAWmBxUWv3rPFN6b6BBh1NIA+9QyUI0ekh7Adu62c0J7WjANcHz44B4uwMOeOEdAne5UXD0oOxwMIC9qA4ocXI1WY7HnNA5hh3VRlSXd-PnB+hT59nWQojwHgOIwjhHZBriEV9kdj4LQ-It7yJ8O-AabZXEA0IHBqAJrIx2BFDQSGRwRCp7xrRK71gH7AwnRf6PweZgCn6-gXD7BbB6y3bELkLvQcRWZh57ABb6yNC3YIHExexnTgzoEtp-S5B7CFRuCth7BLbWhLTAIeDNaXBrT-jRYV5HTCxIF9RiyNJQxBB0EnbxzALYzyApxWbuBdr0SeIHDdhuAQSbijyUHCGWyiHnSrqoFSHlbbS2hdgaDkKXA6AmTKHWj4bbQFAbS4Epww4IKf5HI2LGGyDzTWA57GjyCOAlAWYAEtDKCqKaE8TO4CGS5xbPaHL1I2LiExJeGVBXBmGnBY6-SlC2GMYGiHDnBuB5BLQgStYxbtY7bxFvZJ4MgpFVAnBwhtBIiELOgqyDw6C5D-ydF1AojyAHJ1Jva1G2D469zOBtgD4RxKJVBOrIgmSNHuA3qCGMJhJH4JHjJJGEC1F7zKA2D1AuAmRdwtA5Hnr8r5CVIFBaB9ErFVFGF-6+6pHIxAgqwkb9g7y2GbQGiXyKHmj1BCraaPopEFQ2QHCIQDJ7CuDrKkIlL-y9JWZrTmi4LRG05S5uaPproqQbrygAm-TpqFR9g8SHHMHbjAifQeCggqCD7vR-EroQxNKSG3Gob9gpzAJ+oeAlANjsGOigTAKtDLRXBbB9xUmQaGEI4AndhuLuIqx9gXyaAnrn6NDIgeD6AqzkKuEvZG7jIpEk4fHmiODQH9hXDBF-jQj7C3aOjzTNB8n4qLHDbqnf60m-5JT-6zabZL7yDvKOhbDBZ-h6AfGOhjHOg2T0Jv5Vw7YJ4oEin0lyrAEYZ2CGQMSFStD5RbCbIjz1DHAnA6mu4DGRk4IGD46IRVKBJ2Bdi1YlBwglDnB2Y+mv5tZVzx4i5rE-6DE94jH97kFD5rLYFOp1B7zplrRZnw7Pyam7xwgISwlWSr66D5SJqGiuB8Q6xWbF6eBAA */
  context: /* @__PURE__ */ __name(({ input }) => ({
    options: input.options,
    rateLimiter: input.rateLimiter,
    requestService: input.requestService,
    uploaderFactory: input.uploaderFactory,
    bytesUploaded: 0,
    dataImportRequestId: null,
    dataImportRequestOptions: null,
    error: null,
    fileTree: new FileTree(),
    numberOfFilesUploaded: 0,
    uploadFinishedAt: null,
    uploadStartedAt: null,
    uploadProgressUpdatedAt: null
  }), "context"),
  id: "uploadSession",
  initial: "initial",
  states: {
    aborted: {
      type: "final"
    },
    initial: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        addFiles: {
          actions: "addFiles"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        },
        start: {
          target: "dataImportRequest_creating",
          actions: "start"
        }
      }
    },
    dataImportRequest_creating: {
      invoke: {
        src: "createDataImportRequest",
        input: /* @__PURE__ */ __name(({ context }) => context, "input"),
        onDone: {
          target: "dataImportRequest_creating_success",
          actions: assign2({
            dataImportRequestId: /* @__PURE__ */ __name(({ event }) => event.output, "dataImportRequestId")
          })
        },
        onError: {
          target: "dataImportRequest_creating_failure",
          actions: assign2({
            error: /* @__PURE__ */ __name(({ event }) => event.error, "error")
          })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    dataImportRequest_creating_success: {
      always: {
        target: "dataImportRequest_finding"
      }
    },
    dataImportRequest_creating_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "dataImportRequest_creating",
          actions: "clearError"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    dataImportRequest_finding: {
      invoke: {
        src: "findDataImportRequest",
        input: /* @__PURE__ */ __name(({ context }) => context, "input"),
        onDone: {
          target: "dataImportRequest_finding_success"
        },
        onError: {
          target: "dataImportRequest_finding_failure",
          actions: assign2({
            error: /* @__PURE__ */ __name(({ event }) => event.error, "error")
          })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    dataImportRequest_finding_success: {
      always: {
        target: "folderImportRequests_creating"
      }
    },
    dataImportRequest_finding_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "dataImportRequest_finding",
          actions: "clearError"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    folderImportRequests_creating: {
      invoke: {
        src: "createFolderImportRequests",
        input: stateMachineContext,
        onDone: {
          target: "folderImportRequests_creating_success"
        },
        onError: {
          target: "folderImportRequests_creating_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    folderImportRequests_creating_success: {
      always: "fileImportRequests_creating"
    },
    folderImportRequests_creating_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "folderImportRequests_creating",
          actions: "clearError"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    fileImportRequests_creating: {
      invoke: {
        src: "createFileImportRequests",
        input: stateMachineContext,
        onDone: {
          target: "fileImportRequests_creating_success"
        },
        onError: {
          target: "fileImportRequests_creating_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    fileImportRequests_creating_success: {
      always: {
        guard: /* @__PURE__ */ __name(({ context }) => !(context.options.pauseBeforeUploadFiles ?? !1), "guard"),
        target: "files_uploading"
      },
      on: {
        continueToUploadFiles: "files_uploading",
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    fileImportRequests_creating_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "fileImportRequests_creating",
          actions: "clearError"
        },
        setUploaderFactory: {
          actions: "setUploaderFactory"
        }
      }
    },
    files_uploading: {
      entry: "startUploadProgress",
      invoke: {
        src: "startUploadFiles",
        input: stateMachineContextWithParentRef,
        onDone: {
          target: "files_uploading_success"
        },
        onError: {
          target: "files_uploading_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: ["abort", "abortUploaders"]
        },
        fileUploadProgress: {
          actions: ["updateUploadProgress"]
        },
        fileUploadSucess: {
          actions: ["finishUploadProgress"]
        }
      }
    },
    files_uploading_retrying: {
      invoke: {
        src: "retryUploadFiles",
        input: stateMachineContextWithParentRef,
        onDone: {
          target: "files_uploading_success"
        },
        onError: {
          target: "files_uploading_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: ["abort", "abortUploaders"]
        },
        fileUploadProgress: {
          actions: ["updateUploadProgress"]
        },
        fileUploadSucess: {
          actions: ["finishUploadProgress"]
        }
      }
    },
    files_uploading_success: {
      always: "folderNodes_creating"
    },
    files_uploading_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: ["abort", "abortUploaders"]
        },
        retry: {
          target: "files_uploading_retrying",
          actions: "clearError"
        }
      }
    },
    folderNodes_creating: {
      invoke: {
        src: "createFolderNodes",
        input: stateMachineContext,
        onDone: {
          target: "folderNodes_creating_success"
        },
        onError: {
          target: "folderNodes_creating_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        }
      }
    },
    folderNodes_creating_success: {
      always: "fileNodes_creating"
    },
    folderNodes_creating_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "folderNodes_creating",
          actions: "clearError"
        }
      }
    },
    fileNodes_creating: {
      invoke: {
        src: "createFileNodes",
        input: stateMachineContext,
        onDone: {
          target: "fileNodes_creating_success"
        },
        onError: {
          target: "fileNodes_creating_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        }
      }
    },
    fileNodes_creating_success: {
      always: "thumbnails_creating"
    },
    fileNodes_creating_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "fileNodes_creating",
          actions: "clearError"
        }
      }
    },
    thumbnails_creating: {
      invoke: {
        src: "createThumbnails",
        input: stateMachineContext,
        onDone: {
          target: "thumbnails_creating_success"
        },
        onError: {
          target: "thumbnails_creating_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        }
      }
    },
    thumbnails_creating_success: {
      type: "final",
      entry: emit({ type: "success" })
    },
    thumbnails_creating_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "thumbnails_creating",
          actions: "clearError"
        }
      }
    }
  }
}), _UploadSession = class _UploadSession {
  constructor(uploaderFactory, uploadSessionRequestService, options) {
    /**
     * {@link UploadSessionRequestService} of uploadSession.
     */
    __publicField(this, "_requestService");
    /**
     * {@link UploaderFactory} of uploadSession.
     * This factory is used to create uploader for each file seleceted to upload.
     */
    __publicField(this, "_uploaderFactory");
    /**
     * Options of uploadSession.
     */
    __publicField(this, "_options");
    __publicField(this, "_rateLimiter");
    __publicField(this, "_stateMachineActor");
    __publicField(this, "addFiles", /* @__PURE__ */ __name((files) => {
      this._stateMachineActor.send({ type: "addFiles", files });
    }, "addFiles"));
    __publicField(this, "subscribeSnapshot", /* @__PURE__ */ __name((listener) => {
      const subscription = this._stateMachineActor.subscribe(listener);
      return () => subscription.unsubscribe();
    }, "subscribeSnapshot"));
    __publicField(this, "subscribeFileTreeChange", /* @__PURE__ */ __name((listener) => {
      const subscription = this._stateMachineActor.on("fileTreeChange", listener);
      return () => subscription.unsubscribe();
    }, "subscribeFileTreeChange"));
    __publicField(this, "subscribeSuccess", /* @__PURE__ */ __name((listener) => {
      const subscription = this._stateMachineActor.on("success", listener);
      return () => subscription.unsubscribe();
    }, "subscribeSuccess"));
    this._uploaderFactory = uploaderFactory, this._requestService = uploadSessionRequestService, this._options = {
      chunkThreshold: (options == null ? void 0 : options.chunkThreshold) ?? 500,
      logger: (options == null ? void 0 : options.logger) ?? new ConsoleLogger("UploadSession"),
      pauseBeforeUploadFiles: (options == null ? void 0 : options.pauseBeforeUploadFiles) ?? !1,
      rateLimiterOptions: options == null ? void 0 : options.rateLimiterOptions
    }, this._rateLimiter = new RateLimiter(this._options.rateLimiterOptions), this._stateMachineActor = createActor(uploadSessionStateMachine, {
      input: {
        options: this._options,
        rateLimiter: this._rateLimiter,
        requestService: this._requestService,
        uploaderFactory: this._uploaderFactory
      }
    }), this._stateMachineActor.start();
  }
  setUploaderFactory(uploaderFactory) {
    this._stateMachineActor.send({ type: "setUploaderFactory", uploaderFactory }), this._uploaderFactory = this._stateMachineActor.getSnapshot().context.uploaderFactory;
  }
  async start(dataImportRequestOptions) {
    return new Promise((resolve3, reject) => {
      this._stateMachineActor.subscribe((snapshot) => {
        snapshot.value === "thumbnails_creating_success" && resolve3(), snapshot.value === "aborted" && reject(new AbortionError());
        const error = this.getErrorFromSnapshot(snapshot);
        error && reject(error);
      }), this._stateMachineActor.send({ type: "start", dataImportRequestOptions });
    });
  }
  async retry() {
    return new Promise((resolve3, reject) => {
      this._stateMachineActor.subscribe((snapshot) => {
        snapshot.value === "thumbnails_creating_success" && resolve3(), snapshot.value === "aborted" && reject(new AbortionError());
        const error = this.getErrorFromSnapshot(snapshot);
        error && reject(error);
      }), this._stateMachineActor.send({ type: "retry" });
    });
  }
  abort() {
    const snapshot = this._stateMachineActor.getSnapshot();
    if (!snapshot.can({ type: "abort" })) {
      this._options.logger.warn(`current stage (${snapshot.value}) is not abortable`);
      return;
    }
    this._stateMachineActor.send({ type: "abort" });
  }
  continueToUploadFiles() {
    this._stateMachineActor.send({ type: "continueToUploadFiles" });
  }
  getErrorFromSnapshot(snapshot) {
    return snapshot.context.error ?? snapshot.error;
  }
  get error() {
    const snapshot = this._stateMachineActor.getSnapshot();
    return this.getErrorFromSnapshot(snapshot);
  }
  get stage() {
    return this._stateMachineActor.getSnapshot().value;
  }
  get fileTree() {
    return this._stateMachineActor.getSnapshot().context.fileTree;
  }
  get uploadProgress() {
    const context = this._stateMachineActor.getSnapshot().context, { bytesUploaded, uploadFinishedAt, uploadStartedAt, numberOfFilesUploaded, fileTree } = context, bytesTotal = fileTree.sizeOfFiles;
    return {
      averageSpeed: calcAverageSpeed(bytesUploaded, uploadStartedAt, uploadFinishedAt),
      bytesTotal,
      bytesUploaded,
      hasFinished: uploadFinishedAt !== null,
      hasStarted: uploadStartedAt !== null,
      numberOfFilesTotal: fileTree.numberOfFiles,
      numberOfFilesUploaded,
      uploadFinishedAt,
      uploadStartedAt,
      proportion: bytesTotal === 0 ? 0 : bytesUploaded / bytesTotal
    };
  }
  get stateMachineActor() {
    return this._stateMachineActor;
  }
  get uploaderFactory() {
    return this._uploaderFactory;
  }
};
__name(_UploadSession, "UploadSession");
let UploadSession = _UploadSession;
const useCreateNewUploadSession = /* @__PURE__ */ __name((uploaderFactory, uploadSessionRequestService, options) => {
  useLifeCycleLogger("useCreateNewUploadSession");
  const createUploadSession = useCallback(
    () => new UploadSession(uploaderFactory, uploadSessionRequestService, options),
    [options, uploadSessionRequestService, uploaderFactory]
  ), [uploadSession, setUploadSession] = useState(createUploadSession), createNewUploadSession = useCallback(() => {
    setUploadSession(createUploadSession());
  }, [createUploadSession]);
  return useEffect(() => {
    uploadSession.setUploaderFactory(uploaderFactory);
  }, [uploadSession, uploaderFactory]), {
    uploadSession,
    createNewUploadSession
  };
}, "useCreateNewUploadSession");
var withSelector = { exports: {} }, withSelector_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min) return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var h2 = React__default, n2 = shimExports;
  function p2(a2, b2) {
    return a2 === b2 && (a2 !== 0 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
  }
  __name(p2, "p");
  var q2 = typeof Object.is == "function" ? Object.is : p2, r2 = n2.useSyncExternalStore, t2 = h2.useRef, u2 = h2.useEffect, v2 = h2.useMemo, w2 = h2.useDebugValue;
  return withSelector_production_min.useSyncExternalStoreWithSelector = function(a2, b2, e2, l2, g2) {
    var c2 = t2(null);
    if (c2.current === null) {
      var f2 = { hasValue: !1, value: null };
      c2.current = f2;
    } else f2 = c2.current;
    c2 = v2(function() {
      function a3(a4) {
        if (!c3) {
          if (c3 = !0, d3 = a4, a4 = l2(a4), g2 !== void 0 && f2.hasValue) {
            var b3 = f2.value;
            if (g2(b3, a4)) return k2 = b3;
          }
          return k2 = a4;
        }
        if (b3 = k2, q2(d3, a4)) return b3;
        var e3 = l2(a4);
        return g2 !== void 0 && g2(b3, e3) ? b3 : (d3 = a4, k2 = e3);
      }
      __name(a3, "a");
      var c3 = !1, d3, k2, m2 = e2 === void 0 ? null : e2;
      return [function() {
        return a3(b2());
      }, m2 === null ? void 0 : function() {
        return a3(m2());
      }];
    }, [b2, e2, l2, g2]);
    var d2 = r2(a2, c2[0], c2[1]);
    return u2(function() {
      f2.hasValue = !0, f2.value = d2;
    }, [d2]), w2(d2), d2;
  }, withSelector_production_min;
}
__name(requireWithSelector_production_min, "requireWithSelector_production_min");
var withSelector_development = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  return hasRequiredWithSelector_development || (hasRequiredWithSelector_development = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React2 = React__default, shim2 = shimExports;
    function is2(x2, y2) {
      return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
    }
    __name(is2, "is");
    var objectIs = typeof Object.is == "function" ? Object.is : is2, useSyncExternalStore2 = shim2.useSyncExternalStore, useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue = React2.useDebugValue;
    function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual2) {
      var instRef = useRef2(null), inst;
      instRef.current === null ? (inst = {
        hasValue: !1,
        value: null
      }, instRef.current = inst) : inst = instRef.current;
      var _useMemo = useMemo2(function() {
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, memoizedSelector = /* @__PURE__ */ __name(function(nextSnapshot) {
          if (!hasMemo) {
            hasMemo = !0, memoizedSnapshot = nextSnapshot;
            var _nextSelection = selector(nextSnapshot);
            if (isEqual2 !== void 0 && inst.hasValue) {
              var currentSelection = inst.value;
              if (isEqual2(currentSelection, _nextSelection))
                return memoizedSelection = currentSelection, currentSelection;
            }
            return memoizedSelection = _nextSelection, _nextSelection;
          }
          var prevSnapshot = memoizedSnapshot, prevSelection = memoizedSelection;
          if (objectIs(prevSnapshot, nextSnapshot))
            return prevSelection;
          var nextSelection = selector(nextSnapshot);
          return isEqual2 !== void 0 && isEqual2(prevSelection, nextSelection) ? prevSelection : (memoizedSnapshot = nextSnapshot, memoizedSelection = nextSelection, nextSelection);
        }, "memoizedSelector"), maybeGetServerSnapshot = getServerSnapshot === void 0 ? null : getServerSnapshot, getSnapshotWithSelector = /* @__PURE__ */ __name(function() {
          return memoizedSelector(getSnapshot());
        }, "getSnapshotWithSelector"), getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? void 0 : function() {
          return memoizedSelector(maybeGetServerSnapshot());
        };
        return [getSnapshotWithSelector, getServerSnapshotWithSelector];
      }, [getSnapshot, getServerSnapshot, selector, isEqual2]), getSelection = _useMemo[0], getServerSelection = _useMemo[1], value = useSyncExternalStore2(subscribe, getSelection, getServerSelection);
      return useEffect2(function() {
        inst.hasValue = !0, inst.value = value;
      }, [value]), useDebugValue(value), value;
    }
    __name(useSyncExternalStoreWithSelector, "useSyncExternalStoreWithSelector"), withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), withSelector_development;
}
__name(requireWithSelector_development, "requireWithSelector_development");
process.env.NODE_ENV === "production" ? withSelector.exports = requireWithSelector_production_min() : withSelector.exports = requireWithSelector_development();
var withSelectorExports = withSelector.exports;
function defaultCompare(a2, b2) {
  return a2 === b2;
}
__name(defaultCompare, "defaultCompare");
function useSelector(actor, selector, compare = defaultCompare) {
  const subscribe = useCallback((handleStoreChange) => {
    if (!actor)
      return () => {
      };
    const {
      unsubscribe
    } = actor.subscribe(handleStoreChange);
    return unsubscribe;
  }, [actor]), boundGetSnapshot = useCallback(() => actor == null ? void 0 : actor.getSnapshot(), [actor]);
  return withSelectorExports.useSyncExternalStoreWithSelector(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
}
__name(useSelector, "useSelector");
function is(x2, y2) {
  return x2 === y2 ? x2 !== 0 || y2 !== 0 || 1 / x2 === 1 / y2 : x2 !== x2 && y2 !== y2;
}
__name(is, "is");
function shallowEqual(objA, objB) {
  if (is(objA, objB)) return !0;
  if (typeof objA != "object" || objA === null || typeof objB != "object" || objB === null)
    return !1;
  const keysA = Object.keys(objA), keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return !1;
  for (let i2 = 0; i2 < keysA.length; i2++)
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i2]) || !is(objA[keysA[i2]], objB[keysA[i2]]))
      return !1;
  return !0;
}
__name(shallowEqual, "shallowEqual");
const useSimpleUploadSession = /* @__PURE__ */ __name((simpleUploadSession) => {
  useLifeCycleLogger("useSimpleUploadSession");
  const error = useSelector(simpleUploadSession.stateMachineActor, (state) => state.error), stage = useSelector(simpleUploadSession.stateMachineActor, (state) => state.value), uploadProgress = useSelector(
    simpleUploadSession.stateMachineActor,
    () => simpleUploadSession.uploadProgress,
    shallowEqual
  ), [fileTreeRef, setFileTreeRef] = useState({ current: simpleUploadSession.fileTree });
  return useEffect(() => {
    const onFileTreeChange = /* @__PURE__ */ __name(() => setFileTreeRef({ current: simpleUploadSession.fileTree }), "onFileTreeChange");
    return simpleUploadSession.subscribeFileTreeChange(onFileTreeChange);
  }, [simpleUploadSession]), {
    error,
    fileTreeRef,
    stage,
    uploadProgress
  };
}, "useSimpleUploadSession"), useUploader = /* @__PURE__ */ __name((uploader) => (useLifeCycleLogger("useUploader"), uploader.useUploader()), "useUploader"), useUploadSession = /* @__PURE__ */ __name((uploadSession) => {
  useLifeCycleLogger("useUploadSession");
  const error = useSelector(uploadSession.stateMachineActor, () => uploadSession.error), stage = useSelector(uploadSession.stateMachineActor, () => uploadSession.stage), uploadProgress = useSelector(
    uploadSession.stateMachineActor,
    () => uploadSession.uploadProgress,
    shallowEqual
  ), [fileTreeRef, setFileTreeRef] = useState({ current: uploadSession.fileTree });
  return useEffect(() => {
    const onFileTreeChange = /* @__PURE__ */ __name(() => setFileTreeRef({ current: uploadSession.fileTree }), "onFileTreeChange");
    return uploadSession.subscribeFileTreeChange(onFileTreeChange);
  }, [uploadSession]), {
    error,
    fileTreeRef,
    stage,
    uploadProgress
  };
}, "useUploadSession"), _RequestService = class _RequestService {
  /**
   * @param options - options of this requestService.
   */
  constructor(options) {
    /**
     * A {@link Logger} instance indicates how to log messages. If omitted, a new {@link ConsoleLogger} will be used.
     */
    __publicField(this, "_logger");
    /**
     * A {@link RateLimiter} instance indicates how to put a rimit limiter over requests. If null, no rate limiter will be applied.
     */
    __publicField(this, "_rateLimiter");
    this._logger = (options == null ? void 0 : options.logger) ?? new ConsoleLogger("RequestService"), this._rateLimiter = (options == null ? void 0 : options.rateLimiter) ?? null;
  }
};
__name(_RequestService, "RequestService");
let RequestService = _RequestService;
const _AwsMultipartRequestService = class _AwsMultipartRequestService extends RequestService {
  constructor(requests, options) {
    const logger = (options == null ? void 0 : options.logger) ?? new ConsoleLogger("AwsMultipartRequestService");
    super({ ...options, logger });
    __publicField(this, "_requests");
    __publicField(this, "defaultUploadData", /* @__PURE__ */ __name(async (presignedUrl, blob, signal, onUploadProgress) => {
      const eTag = (await axios.put(presignedUrl, blob, {
        onUploadProgress: /* @__PURE__ */ __name((progressEvent) => {
          this._logger.debug(
            "uploadDataProgress",
            progressEvent.loaded,
            progressEvent.total,
            presignedUrl
          ), onUploadProgress(progressEvent.loaded);
        }, "onUploadProgress"),
        signal
      })).headers.etag;
      if (!eTag) throw new ServerError("ETag is missing from responded headers");
      return eTag;
    }, "defaultUploadData"));
    __publicField(this, "abortMultipartUpload", /* @__PURE__ */ __name(async (variables) => {
      this._logger.debug("abortMultipartUpload", variables);
      const response = await this._requests.abortMultipartUpload(variables);
      return this._logger.debug("succeeded to abortMultipartUpload", variables, response), response;
    }, "abortMultipartUpload"));
    __publicField(this, "completeMultipartUpload", /* @__PURE__ */ __name(async (variables, signal) => {
      this._logger.debug("completeMultipartUpload", variables);
      const response = await this._requests.completeMultipartUpload(variables, signal);
      return this._logger.debug("succeeded to completeMultipartUpload", variables, response), response;
    }, "completeMultipartUpload"));
    __publicField(this, "createMultipartUpload", /* @__PURE__ */ __name(async (fileNode, signal) => {
      this._logger.debug("createMultipartUpload", fileNode);
      const response = await this._requests.createMultipartUpload(fileNode, signal);
      return this._logger.debug("succeeded to createMultipartUpload", fileNode, response), response;
    }, "createMultipartUpload"));
    __publicField(this, "signMultipartUploadPart", /* @__PURE__ */ __name(async (variables, signal) => {
      this._logger.debug("signMultipartUploadPart", variables);
      const response = await this._requests.signMultipartUploadPart(variables, signal);
      return this._logger.debug("succeeded to signMultipartUploadPart", variables, response), response;
    }, "signMultipartUploadPart"));
    __publicField(this, "uploadData", /* @__PURE__ */ __name(async (presignedUrl, blob, signal, onUploadProgress) => {
      this._logger.debug("uploadData", { presignedUrl });
      const response = await this._requests.uploadData(presignedUrl, blob, signal, onUploadProgress);
      return this._logger.debug("succeeded to uploadData", { presignedUrl }, response), response;
    }, "uploadData"));
    this._requests = this.createRequests(requests);
  }
  createRequests(requests) {
    const uploadData2 = requests.uploadData ?? this.defaultUploadData;
    return this._rateLimiter === null ? {
      ...requests,
      uploadData: uploadData2
    } : {
      abortMultipartUpload: this._rateLimiter.wrap(requests.abortMultipartUpload),
      completeMultipartUpload: this._rateLimiter.wrap(requests.completeMultipartUpload),
      createMultipartUpload: this._rateLimiter.wrap(requests.createMultipartUpload),
      signMultipartUploadPart: this._rateLimiter.wrap(requests.signMultipartUploadPart),
      uploadData: this._rateLimiter.wrap(uploadData2)
    };
  }
};
__name(_AwsMultipartRequestService, "AwsMultipartRequestService");
let AwsMultipartRequestService = _AwsMultipartRequestService;
const _Chunk = class _Chunk {
  constructor(fileNode, start, end) {
    __publicField(this, "_fileNode");
    __publicField(this, "_start");
    __publicField(this, "_end");
    this._fileNode = fileNode, this._start = start, this._end = end;
  }
  getBlob() {
    return this._fileNode.file.slice(this._start, this._end);
  }
  get fileNode() {
    return this._fileNode;
  }
  get size() {
    return this._end - this._start;
  }
  static sliceFileNodeIntoNChunks(fileNode, chunkSize, chunkNumber) {
    const chunks2 = [];
    for (let i2 = 0; i2 < chunkNumber; i2++) {
      const start = i2 * chunkSize, end = Math.min((i2 + 1) * chunkSize, fileNode.file.size), chunk2 = new _Chunk(fileNode, start, end);
      chunks2.push(chunk2);
    }
    return chunks2;
  }
  static sliceFileNodeIntoChunks(fileNode, chunkSize, chunkOptions = {}) {
    const { minChunkSize, maxChunkSize, maxChunkNumber } = chunkOptions;
    if (minChunkSize !== void 0 && fileNode.file.size <= minChunkSize)
      return [new _Chunk(fileNode, 0, fileNode.file.size)];
    if (fileNode.file.size <= chunkSize)
      return [new _Chunk(fileNode, 0, fileNode.file.size)];
    const chunkNumber = Math.ceil(fileNode.file.size / chunkSize);
    if (maxChunkNumber !== void 0 && chunkNumber > maxChunkNumber) {
      const newChunkNumber = maxChunkNumber, newChunkSize = Math.ceil(fileNode.file.size / newChunkNumber);
      if (maxChunkSize !== void 0 && newChunkSize > maxChunkSize)
        throw new LimitationError(
          `file (${fileNode.file.name}) is too large to be sliced into ${maxChunkNumber} chunks, ${maxChunkSize} bytes per chunk`
        );
      return _Chunk.sliceFileNodeIntoNChunks(fileNode, newChunkSize, newChunkNumber);
    }
    return _Chunk.sliceFileNodeIntoNChunks(fileNode, chunkSize, chunkNumber);
  }
};
__name(_Chunk, "Chunk");
let Chunk = _Chunk;
const signPart = fromPromise(
  async ({ input }) => {
    if (input.uploadParams === null) throw new BadStateError("uploadParams has not been set");
    return await input.requestService.signMultipartUploadPart(
      {
        partNumber: input.partNumber,
        ...input.uploadParams
      },
      input.abortController.signal
    );
  }
), uploadData = fromPromise(async ({ input }) => {
  if (input.presignedUrl === null) throw new BadStateError("presignedUrl has not been set");
  const parentRef = input.parentRef, onUploadProgress = /* @__PURE__ */ __name((bytesUploaded) => parentRef.send({ type: "updateUploadProgress", bytesUploaded }), "onUploadProgress");
  return input.requestService.uploadData(
    input.presignedUrl,
    input.chunk.getBlob(),
    input.abortController.signal,
    onUploadProgress
  );
}), awsMultipartChunkUploaderStateMachine = setup({
  actions: {
    abort: /* @__PURE__ */ __name(({ context }) => {
      context.abortController.abort();
    }, "abort"),
    start: assign2({
      uploadParams: /* @__PURE__ */ __name(({ event }) => (assertIsEvent(event, "start"), event.uploadParams), "uploadParams")
    }),
    clearError: assign2({
      error: null
    }),
    startUploadProgress: assign2({
      uploadStartedAt: /* @__PURE__ */ __name(() => /* @__PURE__ */ new Date(), "uploadStartedAt"),
      bytesUploaded: 0
    }),
    finishUploadProgress: enqueueActions(({ enqueue, context }) => {
      enqueue.assign({
        bytesUploaded: context.chunk.size,
        uploadFinishedAt: /* @__PURE__ */ __name(() => /* @__PURE__ */ new Date(), "uploadFinishedAt")
      }), enqueue.emit({ type: "chunkUploadSuccess" });
    }),
    updateUploadProgress: enqueueActions(({ enqueue, event }) => {
      assertIsEvent(event, "updateUploadProgress"), enqueue.assign({
        bytesUploaded: event.bytesUploaded
      }), enqueue.emit({
        type: "chunkUploadProgress"
      });
    })
  },
  actors: {
    signPart,
    uploadData
  },
  types: {
    context: {},
    emitted: {},
    events: {},
    input: {}
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QEMDusCyBXANgFwEsAHZAJzwGEALLAOwGsBVInAe2QjFIDoDaDCyHAGJkAI1bkA2gAYAuolBFWsAQVa1FIAB6IAjAGYArNz0y9RgGwAmIwBoQAT0QAOPdyMBfTw7SZchCTk1HRMLOycPHxqQsKweGR4sgpIIMqqhBpaugiGJmYWNvZOrgDsMtzWlla23r7o2PjEiSEMzGwcXNwAxjQMAPqqUPy0UMIQGmC8tABurPRTfo2BLX1hHZE9a4MEw3xQCHxz3ciZtMnJWulqWak5ACyW99ylbrYOzggAnObcXwbWaxfPSWUFgyx1EBLALNYJrdoRLq9UI7PajYRcUiSbgsU4AM0kAFtuNCmkFKPDwp0eMiBkMRgcjqwTmcLvIriobpo7ohHs9Xnp3iUEPc9C5TAC3l4fFCGjDya11oiadt6ftRBJpOzUtcztleU8XlKPohASZAdUipDSSs4aEEdStii1aNBlhut04LBhJcdZy9TyEC4jO5SpahZ8vtZnj8XMHReDQda5WTVvaqZtafRUQz+njkAQcFhSGANZIktqlP71NzQDlg6Hw8VPqL3DJ7l97qVgYnSsn-Km7W0M0jVbtc-nC8XSyW8KRHL6qxka-qECHLNwXF8XPcDKVm4gAe5LN3LC59-3lrCKemNqOUVgM+qJrQpkyFiSU7ab8O76R+o+GwACKnMgi5pNWtx1voBiWF8Ro-EUJrfLu3CgvcMhWjKNrXoqDqZtsgEROqmLYrieAEqQxI4QqlJ-gBGYgQk4G6iugaGHBCGYRGiBwaU3AdqUBhfEYLgGOJEmXvKaa-sqToDERHDquI5YsZBtY6DBnGvIhPFBgYzx6BhWH1AO354SOKoPk+6KKRATHIAAyu6nqwLAanLlBmm5JhFQGIKB4IN28EyMJ3HSqZV60beclZgxGzqnZDkAApYlAJZuR5XKrmYRj8aU9zWGK+7IeU1geMG-wXthX64XRsWETZUB5gWRYlmWWopEu2WBtY5jlUYRiPOegVwRUorGbUNVmXVMWOnFdn7C1U7tbO85ZQG0G5DY5X7gKemDeKlV7tKMq0KwnDwKkNEyUq1Icp5Gk5AAtJYyGvVJg4-ndmwqeQkAPT1W1FQZHj7YFu4GJUYbtiCvafeZ9WOtEgg4IDm3eYVyFxvxAKDX1YkSeJCOzbJ81jmiUDo2xwNdqYennhU0ZFSNJPRWTBHOuOS2wC5XrU15ORFAJ4XIVGUOxvGcPgmzt34fedLc66k5tWAAtPbx1jipYmGlOUhMSfcyG7s8RhVLDiYnrLQ4-Qr2aLaM6url8lhQzpovCj841RsVEWyjN7O21ZClNW6Hr836j05UJ7hVDUgVfHrm4nr71vffLwf26HKvTk77EFRujzGAmvalYYm66adnhAA */
  context: /* @__PURE__ */ __name(({ input }) => ({
    chunk: input.chunk,
    logger: input.logger,
    partNumber: input.partNumber,
    requestService: input.requestService,
    abortController: new AbortController(),
    bytesUploaded: 0,
    eTag: null,
    error: null,
    presignedUrl: null,
    uploadFinishedAt: null,
    uploadStartedAt: null,
    uploadParams: null
  }), "context"),
  id: "awsMultipartChunkUploader",
  initial: "initial",
  states: {
    aborted: {
      type: "final"
    },
    initial: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        start: {
          target: "chunk_signing",
          actions: "start"
        }
      }
    },
    chunk_signing: {
      invoke: {
        src: "signPart",
        input: /* @__PURE__ */ __name(({ context }) => context, "input"),
        onDone: {
          target: "chunk_signing_success",
          actions: assign2({ presignedUrl: /* @__PURE__ */ __name(({ event }) => event.output, "presignedUrl") })
        },
        onError: {
          target: "chunk_signing_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        }
      }
    },
    chunk_signing_success: {
      always: "chunk_uploading"
    },
    chunk_signing_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "chunk_signing",
          actions: "clearError"
        }
      }
    },
    chunk_uploading: {
      entry: "startUploadProgress",
      invoke: {
        id: "awsMultipartChunkUploader_uploadData",
        src: "uploadData",
        input: stateMachineContextWithParentRef,
        onDone: {
          target: "chunk_uploading_success",
          actions: [assign2({ eTag: /* @__PURE__ */ __name(({ event }) => event.output, "eTag") }), "finishUploadProgress"]
        },
        onError: {
          target: "chunk_uploading_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        updateUploadProgress: {
          actions: ["updateUploadProgress"]
        }
      }
    },
    chunk_uploading_success: {
      type: "final"
    },
    chunk_uploading_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abort"
        },
        retry: {
          target: "chunk_signing",
          actions: "clearError"
        }
      }
    }
  }
}), _AwsMultipartChunkUploader = class _AwsMultipartChunkUploader {
  constructor(chunk2, partNumber, requestService, options) {
    __publicField(this, "_chunk");
    __publicField(this, "_partNumber");
    __publicField(this, "_requestService");
    __publicField(this, "_stateMachineActor");
    __publicField(this, "_logger");
    __publicField(this, "_uploadProgressListeners", /* @__PURE__ */ new Set());
    __publicField(this, "_uploadSuccessListeners", /* @__PURE__ */ new Set());
    __publicField(this, "emitUploadProgress", /* @__PURE__ */ __name(() => {
      for (const listener of this._uploadProgressListeners)
        listener();
    }, "emitUploadProgress"));
    __publicField(this, "emitUploadSuccess", /* @__PURE__ */ __name(() => {
      for (const listener of this._uploadSuccessListeners)
        listener();
    }, "emitUploadSuccess"));
    this._chunk = chunk2, this._logger = (options == null ? void 0 : options.logger) ?? new ConsoleLogger("AwsMultipartChunkUploader"), this._partNumber = partNumber, this._requestService = requestService, this._stateMachineActor = createActor(awsMultipartChunkUploaderStateMachine, {
      input: {
        chunk: this._chunk,
        logger: this._logger,
        partNumber: this._partNumber,
        requestService: this._requestService
      }
    }), this._stateMachineActor.on("chunkUploadProgress", this.emitUploadProgress), this._stateMachineActor.on("chunkUploadSuccess", this.emitUploadSuccess), this._stateMachineActor.start();
  }
  async start(uploadParams) {
    const snapshot = this._stateMachineActor.getSnapshot();
    return snapshot.can({ type: "start", uploadParams }) ? new Promise((resolve3, reject) => {
      this._stateMachineActor.subscribe((snapshot2) => {
        snapshot2.value === "chunk_uploading_success" && resolve3(), snapshot2.value === "aborted" && reject(new AbortionError());
        const error = this.getErrorFromSnapshot(snapshot2);
        error && reject(error);
      }), this._stateMachineActor.send({ type: "start", uploadParams });
    }) : (this._logger.warn(`current stage (${snapshot.value}) is not startable`), Promise.resolve());
  }
  async retry() {
    const snapshot = this._stateMachineActor.getSnapshot();
    return snapshot.can({ type: "retry" }) ? new Promise((resolve3, reject) => {
      this._stateMachineActor.subscribe((snapshot2) => {
        snapshot2.value === "chunk_uploading_success" && resolve3(), snapshot2.value === "aborted" && reject(new AbortionError());
        const error = this.getErrorFromSnapshot(snapshot2);
        error && reject(error);
      }), this._stateMachineActor.send({ type: "retry" });
    }) : (this._logger.warn(`current stage (${snapshot.value}) is not retryable`), Promise.resolve());
  }
  abort() {
    const snapshot = this._stateMachineActor.getSnapshot();
    if (!snapshot.can({ type: "abort" })) {
      this._logger.warn(`current stage (${snapshot.value}) is not abortable`);
      return;
    }
    this._stateMachineActor.send({ type: "abort" });
  }
  getErrorFromSnapshot(snapshot) {
    return snapshot.context.error ?? snapshot.error;
  }
  onUploadProgress(cb) {
    this._uploadProgressListeners.add(cb);
  }
  offUploadProgress(cb) {
    this._uploadProgressListeners.delete(cb);
  }
  onUploadSuccess(cb) {
    this._uploadSuccessListeners.add(cb);
  }
  offUploadSuccess(cb) {
    this._uploadSuccessListeners.delete(cb);
  }
  get error() {
    const snapshot = this._stateMachineActor.getSnapshot();
    return this.getErrorFromSnapshot(snapshot);
  }
  get eTag() {
    return this._stateMachineActor.getSnapshot().context.eTag;
  }
  get partNumber() {
    return this._partNumber;
  }
  get stage() {
    return this._stateMachineActor.getSnapshot().value;
  }
  get isAborted() {
    return this._stateMachineActor.getSnapshot().value === "aborted";
  }
  get uploadProgress() {
    const context = this._stateMachineActor.getSnapshot().context, { bytesUploaded, uploadFinishedAt, uploadStartedAt } = context;
    return {
      bytesUploaded,
      bytesTotal: this._chunk.size,
      hasFinished: uploadFinishedAt !== null,
      hasStarted: uploadStartedAt !== null,
      uploadFinishedAt,
      uploadStartedAt
    };
  }
  get stateMachineActor() {
    return this._stateMachineActor;
  }
};
__name(_AwsMultipartChunkUploader, "AwsMultipartChunkUploader");
let AwsMultipartChunkUploader = _AwsMultipartChunkUploader;
const createMultipartUpload = fromPromise(async ({ input }) => {
  const { bucket, fileId, key, uploadId } = await input.requestService.createMultipartUpload(
    input.fileNode,
    input.abortController.signal
  );
  return fileId && input.fileNode.setFileId(fileId), {
    bucket,
    key,
    uploadId
  };
}), startUploadChunks = fromPromise(async ({ input }) => {
  const parentRef = input.parentRef, jobs = input.chunkUploaders.map((chunkUploader) => (chunkUploader.onUploadProgress(() => {
    parentRef.send({ type: "chunkUploadProgress" });
  }), chunkUploader.onUploadSuccess(() => {
    parentRef.send({ type: "chunkUploadSuccess" });
  }), chunkUploader)).map((chunkUploader) => {
    if (input.uploadParams === null) throw new BadStateError("uploadParams has not been set");
    return new Job(
      chunkUploader.start.bind(chunkUploader, input.uploadParams),
      chunkUploader.retry.bind(chunkUploader)
    );
  }), rateLimiter = input.rateLimiter;
  rateLimiter.enqueue(...jobs), await rateLimiter.start();
}), retryUploadChunks = fromPromise(async ({ input }) => {
  await input.rateLimiter.retry();
}), completeMultipartUpload = fromPromise(
  async ({ input }) => {
    if (input.uploadParams === null) throw new BadStateError("uploadParams has not been set");
    const { bucket, key, uploadId } = input.uploadParams, parts = input.chunkUploaders.map((chunkUploader) => ({
      partNumber: chunkUploader.partNumber,
      etag: chunkUploader.eTag
    }));
    await input.requestService.completeMultipartUpload(
      {
        bucket,
        key,
        parts,
        uploadId
      },
      input.abortController.signal
    ), input.fileNode.setStorage({
      bucket: input.uploadParams.bucket,
      key: input.uploadParams.key
    });
  }
), actors = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  completeMultipartUpload,
  createMultipartUpload,
  retryUploadChunks,
  startUploadChunks
}, Symbol.toStringTag, { value: "Module" })), awsMultipartUploaderStateMachine = setup({
  actions: {
    abortAbortController: /* @__PURE__ */ __name(({ context }) => {
      context.abortController.abort();
    }, "abortAbortController"),
    abortChunkUploaders: /* @__PURE__ */ __name(({ context }) => {
      context.chunkUploaders.forEach((chunkUploader) => chunkUploader.abort());
    }, "abortChunkUploaders"),
    abortMultipartUpload: /* @__PURE__ */ __name(async ({ context }) => {
      if (context.uploadParams === null) throw new BadStateError("uploadParams has not been set");
      await context.requestService.abortMultipartUpload(context.uploadParams).catch((e2) => {
        context.logger.warn("failed to abort multipart upload", e2);
      });
    }, "abortMultipartUpload"),
    clearError: assign2({
      error: null
    }),
    startUploadProgress: assign2({
      uploadStartedAt: /* @__PURE__ */ __name(() => /* @__PURE__ */ new Date(), "uploadStartedAt"),
      bytesUploaded: 0
    }),
    // this action is triggered on every chunk's uploader's chunkUploadProgress event,
    // and will sum up the bytesUploaded of all chunks.
    // we need to *throttle* this action to prevent too frequent state updates.
    updateUploadProgress: enqueueActions(({ enqueue, context }) => {
      const now2 = /* @__PURE__ */ new Date();
      if (context.uploadProgressUpdatedAt !== null && now2.getTime() - context.uploadProgressUpdatedAt.getTime() < UNITS.MILLISECOND.SECOND)
        return;
      let bytesUploaded = 0;
      for (const chunkUploader of context.chunkUploaders)
        bytesUploaded += chunkUploader.uploadProgress.bytesUploaded;
      enqueue.assign({ bytesUploaded, uploadProgressUpdatedAt: now2 }), enqueue.emit({ type: "fileUploadProgress" });
    }),
    finishUploadProgress: enqueueActions(({ enqueue, context }) => {
      enqueue.assign({
        bytesUploaded: context.fileNode.file.size,
        uploadFinishedAt: /* @__PURE__ */ __name(() => /* @__PURE__ */ new Date(), "uploadFinishedAt")
      }), enqueue.emit({ type: "fileUploadSuccess" });
    })
  },
  actors,
  types: {
    context: {},
    emitted: {},
    events: {},
    input: {}
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QEMDusCyBXANgFwEsAHZAJzwFUicB7ZCMUgOgIDsDDkcBiZAIxrkA2gAYAuolBEasDgRqtJIAB6IAjAGYArEzUi1WgJwaA7FpP6ALACYANCACeiABxqmlw58NbLlszYBfAPs0TFxCEnIqWnpGFnZOHlg8MjxRCSQQaVlCBSVVBE0dPQNjMws1G3snBBtDJhEjDUNnZoA2S2drbyCQ9Gx8YlTougZmAFtwofIAfSxqUZmAY1IwZEJWKG4IBTB4gDcaAGs90IGI4YXYianIvDmriGXV9bYoBDZDpdeFdPSlbJyPKZAptaxubSGSwicH6NoaazOaqIEwmNpMcFaNqtTomZwiETOXogM63S4xMZMSaDO4PCnPNYbLaMUiCJjUdYAM0E4yYpJp5NGcWpF1m83pK0Zbw+rC+P1Yf3EAJkQMUIMQYIhRmhsLU8MRyNqamcugRrgRlmNJk8lmJ-NFlEewrJYseDNem14AmESsygNyatAoPBTEhOpK+qRjkQ1msOljbS0RgJHREhjBdv6LsdFOdAtdEpeTJmsCwSyWcFg3H+fpVAfy6mNIiYzi6zh8pkMJg0GkN1vqakMsYRlT84JMmbC+ZzQpu07pi0lHqgM05yAIOCwqy9gjSvqkdfkgZUjfxLbbHet3d70aNbhEHk66cqWgRE+CJKz05G1yp2YX9DusWa4bluYDcKseCkA4NYHjkR4Ngg3ZuNiJh+G0KZqN2bSGiOTBtNa2JtGo1iWr4759FODo-pSSwABZYKwRywABEBvNsuwHMcpxftRTrMPRjHMax0qfDQ3wBoqGRwaqiF6h4DQWNCSZptY2g3jU1o6PqGg2EY3TOG0bSTuc0wzr+glMSx4qjOxLJshyeDcqQvL2mZNFxJZwk2fQomyuJ8pScq8HAkG6gdPUIhKY0WiqephotNYTCvs4aLOFChJYbaH5uXcHkCQxVkiZ6-C7rBWSHqFJ6FBFikPjFcWvoaSaWEwqIYa+WG6QSGgmdm+VMF51mPOx8wQOsYA0QACqyUCrLAsDlf6CHqoU7TJX4BKuOYPaEoaBH1ImWjpeY7bWCYJF9d+-GDYV3kjZsJZlhWC3VvuFUhceBTgpaoaGCIRnkb4lgJQ+LYkSRP0iD2rRXXxuYFUJw0Um8q7rpu26lT60kfbJq0-RC-2A34wOGmolQoWRg7EeTMK9TlvHuTdQ3FSuIEY+BkHQUtlVfeoaHNrF1rdLF+L4iYZNRTonjGpYGHk2hRIM1RTMI7dSOs2joHbmNE3TbN82Le9y1VQUxpdg06VDlFfgaJUhiS-9+HGuCbTeKU2WUaZeXM3dyO2Y9XMOOxOysHsYknHyjM+2rLM+WxgdgFBwebDKcqSeIPOfXJtVRfVKlDvFt6tpF7a4hdPhplocOq7O6tFfHqNB3ZpCsswjnOa50eChZfua83qdiRJR5BbW2erfJkXRQXalNbeCtJcDrQWNYEVK17-W+xrjeJ8n7FY3uOMm3zNUKXnymxYXc81JoJGhuC1iNO2PhYdYNcx3XccPSuA9bLreCTUeDNGgc1KxZzxmFNa3h8KNETMaYiRhEyS2OkwQwxpybNHSm7aG78e6UhFGZViywaDjGoEnEOnEI48RVh-X8BDaTx2IaQnA5DB7+WHr8TOxteaIVXloJKVosStkygYEGt40E6A0JqcmiY8Tdk9p+GheC8wOiIUsEhZCmTcHsu3HAXIeRRyUVEG69DUhqI0SwpkacAoZzEOA+s+NEwCNSkIsW5MfCGi6G4f6rYNAPgtEdXBxi1amILIuCxrCtgH3sStSBfDnFmGxG40RCULZoI8KRPQphzrGWVt7ZRc5VGMPUcwyJWsOY7mxsFCB1UzQmHcEklMLRLDNE8foUMHgHzdCiiLNQQTzL4P-MUiJwF0ZgQgknbm3Dx5xLxM2SMLVzCIJwreEwcZ3BJlaFCLCFc37ElYDQBg8BMi5QKdUhxkCAC0KyajXIaASB5jyHnmH6QNA+kBzmxNqUmReaIsQXXJoOMmukNDO1hPoUwBJYyvJumwOQXBPmm0QFUW8NhQWVFXpaN25otB9LyZvEJQy3RLiZIik+PZ0SpnhFCbZsY1CGmhOiRoUJOhuzxNtGFhL5zFKLKjUs5ZKxksQoZSKctWxu2IviGEfYWi6CHJkyoFhZGcrrqE+4PKpSPXZmBIVq1UpJVIp0W+zhOnpgZbpZKq8YqIhaavE1Kre7b2-rqyBmgujuFjNDTUiUbkolcLoQk4qpUwkqA62ifcd4rn5S9Y5MkLnVWNKlFsBFH4tIwmsuw4jobg3BHbDF2JwRhs8hG7+5SdVjxqWbdKzY+ERRhPiHwmab6DiSlFEiUV0zwhaevRR+TgmfxLSjXe0E3guoTRod1NhH5SPBD6smepmymFprFB8vgi2FMIcM0ppKK3xu+rpeo2hSi6STMTTxZ47bglcMDQkAN11-m5cSkZfLnqCt3V876aD6meATB0TQw4EqaF0O2xVLS4T0w3tdLlRSn3btRtq1YY7P09jledXF2zvBRhqK0E0fi1Kzq7I0UNQQAhAA */
  context: /* @__PURE__ */ __name(({ input }) => ({
    chunkUploaders: input.chunkUploaders,
    logger: input.logger,
    fileNode: input.fileNode,
    rateLimiter: input.rateLimiter,
    requestService: input.requestService,
    abortController: new AbortController(),
    bytesUploaded: 0,
    error: null,
    uploadFinishedAt: null,
    uploadStartedAt: null,
    uploadParams: null,
    uploadProgressUpdatedAt: null
  }), "context"),
  id: "awsMultipartUploader",
  initial: "initial",
  states: {
    aborted: {
      type: "final"
    },
    initial: {
      on: {
        abort: {
          target: "aborted",
          actions: "abortAbortController"
        },
        start: {
          target: "multipart_upload_creating"
        }
      }
    },
    multipart_upload_creating: {
      invoke: {
        src: "createMultipartUpload",
        input: /* @__PURE__ */ __name(({ context }) => context, "input"),
        onDone: {
          target: "multipart_upload_creating_success",
          actions: assign2({ uploadParams: /* @__PURE__ */ __name(({ event }) => event.output, "uploadParams") })
        },
        onError: {
          target: "multipart_upload_creating_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: "abortAbortController"
        }
      }
    },
    multipart_upload_creating_success: {
      always: "chunks_uploading"
    },
    multipart_upload_creating_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: "abortAbortController"
        },
        retry: {
          target: "multipart_upload_creating",
          actions: "clearError"
        }
      }
    },
    chunks_uploading: {
      entry: "startUploadProgress",
      invoke: {
        src: "startUploadChunks",
        input: stateMachineContextWithParentRef,
        onDone: {
          target: "chunks_uploading_success",
          actions: "finishUploadProgress"
        },
        onError: {
          target: "chunks_uploading_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: ["abortAbortController", "abortChunkUploaders", "abortMultipartUpload"]
        },
        chunkUploadProgress: {
          actions: "updateUploadProgress"
        }
      }
    },
    chunks_uploading_success: {
      always: "multipart_upload_completing"
    },
    chunks_uploading_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: ["abortAbortController", "abortChunkUploaders", "abortMultipartUpload"]
        },
        retry: {
          target: "chunks_uploading_retrying",
          actions: ["clearError"]
        }
      }
    },
    chunks_uploading_retrying: {
      invoke: {
        src: "retryUploadChunks",
        input: stateMachineContextWithParentRef,
        onDone: {
          target: "chunks_uploading_success",
          actions: "finishUploadProgress"
        },
        onError: {
          target: "chunks_uploading_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: ["abortAbortController", "abortChunkUploaders", "abortMultipartUpload"]
        },
        updateUploadProgress: {
          actions: "updateUploadProgress"
        }
      }
    },
    multipart_upload_completing: {
      invoke: {
        src: "completeMultipartUpload",
        input: /* @__PURE__ */ __name(({ context }) => context, "input"),
        onDone: {
          target: "multipart_upload_completing_success"
        },
        onError: {
          target: "multipart_upload_completing_failure",
          actions: assign2({ error: /* @__PURE__ */ __name(({ event }) => event.error, "error") })
        }
      },
      on: {
        abort: {
          target: "aborted",
          actions: ["abortAbortController", "abortMultipartUpload"]
        }
      }
    },
    multipart_upload_completing_success: {
      type: "final"
    },
    multipart_upload_completing_failure: {
      on: {
        abort: {
          target: "aborted",
          actions: ["abortAbortController", "abortMultipartUpload"]
        },
        retry: {
          target: "multipart_upload_completing",
          actions: "clearError"
        }
      }
    }
  }
}), _AwsMultipartUploader = class _AwsMultipartUploader {
  constructor(fileNode, chunkSize, requestService, options) {
    __publicField(this, "_chunkSize");
    __publicField(this, "_chunkUploaders");
    __publicField(this, "_logger");
    __publicField(this, "_fileNode");
    __publicField(this, "_rateLimiter");
    __publicField(this, "_requestService");
    __publicField(this, "_stateMachineActor");
    __publicField(this, "_uploadProgressListeners", /* @__PURE__ */ new Set());
    __publicField(this, "_uploadSuccessListeners", /* @__PURE__ */ new Set());
    __publicField(this, "emitUploadProgress", /* @__PURE__ */ __name(() => {
      for (const listener of this._uploadProgressListeners)
        listener();
    }, "emitUploadProgress"));
    __publicField(this, "emitUploadSuccess", /* @__PURE__ */ __name(() => {
      for (const listener of this._uploadSuccessListeners)
        listener();
    }, "emitUploadSuccess"));
    __publicField(this, "useUploader", /* @__PURE__ */ __name(() => {
      useLifeCycleLogger("AwsMultipartUploader useUploader");
      const error = useSelector(this._stateMachineActor, () => this.error), stage = useSelector(this._stateMachineActor, () => this.stage), uploadProgress = useSelector(
        this._stateMachineActor,
        () => this.uploadProgress,
        shallowEqual
      );
      return {
        error,
        stage,
        uploadProgress
      };
    }, "useUploader"));
    this._chunkSize = chunkSize, this._fileNode = fileNode, this._logger = (options == null ? void 0 : options.logger) ?? new ConsoleLogger("AwsMultipartUploader"), this._rateLimiter = new RateLimiter(options == null ? void 0 : options.rateLimiterOptions), this._requestService = requestService, this.precheck();
    const chunks2 = Chunk.sliceFileNodeIntoChunks(fileNode, this._chunkSize, {
      maxChunkSize: _AwsMultipartUploader.maxChunkSize,
      maxChunkNumber: _AwsMultipartUploader.maxChunkNumber,
      minChunkSize: _AwsMultipartUploader.minChunkSize
    });
    this._chunkUploaders = chunks2.map(
      (chunk2, partNumber) => new AwsMultipartChunkUploader(chunk2, partNumber + 1, requestService)
    ), this._stateMachineActor = createActor(awsMultipartUploaderStateMachine, {
      input: {
        chunkUploaders: this._chunkUploaders,
        logger: this._logger,
        fileNode: this._fileNode,
        rateLimiter: this._rateLimiter,
        requestService: this._requestService
      }
    }), this._stateMachineActor.on("fileUploadProgress", this.emitUploadProgress), this._stateMachineActor.on("fileUploadSuccess", this.emitUploadSuccess), this._stateMachineActor.start();
  }
  precheck() {
    if (this._fileNode.file.size > _AwsMultipartUploader.maxFileSize)
      throw new LimitationError(
        `file (${this._fileNode.file.name}) size exceeds the maximum limit (${_AwsMultipartUploader.maxFileSize}) of Amazon S3`
      );
  }
  async start() {
    const snapshot = this._stateMachineActor.getSnapshot();
    return snapshot.can({ type: "start" }) ? new Promise((resolve3, reject) => {
      this._stateMachineActor.subscribe((snapshot2) => {
        snapshot2.value === "multipart_upload_completing_success" && resolve3(), snapshot2.value === "aborted" && reject(new AbortionError());
        const error = this.getErrorFromSnapshot(snapshot2);
        error && reject(error);
      }), this._stateMachineActor.send({ type: "start" });
    }) : (this._logger.warn(`current stage (${snapshot.value}) is not startable`), Promise.resolve());
  }
  async retry() {
    const snapshot = this._stateMachineActor.getSnapshot();
    return snapshot.can({ type: "retry" }) ? new Promise((resolve3, reject) => {
      this._stateMachineActor.subscribe((snapshot2) => {
        snapshot2.value === "multipart_upload_completing_success" && resolve3(), snapshot2.value === "aborted" && reject(new AbortionError());
        const error = this.getErrorFromSnapshot(snapshot2);
        error && reject(error);
      }), this._stateMachineActor.send({ type: "retry" });
    }) : (this._logger.warn(`current stage (${snapshot.value}) is not retryable`), Promise.resolve());
  }
  abort() {
    const snapshot = this._stateMachineActor.getSnapshot();
    if (!snapshot.can({ type: "abort" })) {
      this._logger.warn(`current stage (${snapshot.value}) is not abortable`);
      return;
    }
    this._stateMachineActor.send({ type: "abort" });
  }
  getErrorFromSnapshot(snapshot) {
    return snapshot.context.error ?? snapshot.error;
  }
  onUploadProgress(cb) {
    this._uploadProgressListeners.add(cb);
  }
  offUploadProgress(cb) {
    this._uploadProgressListeners.delete(cb);
  }
  onUploadSuccess(cb) {
    this._uploadSuccessListeners.add(cb);
  }
  offUploadSuccess(cb) {
    this._uploadSuccessListeners.delete(cb);
  }
  get error() {
    const snapshot = this._stateMachineActor.getSnapshot();
    return this.getErrorFromSnapshot(snapshot);
  }
  get stage() {
    return this._stateMachineActor.getSnapshot().value;
  }
  get isAborted() {
    return this._stateMachineActor.getSnapshot().value === "aborted";
  }
  get fileNode() {
    return this._fileNode;
  }
  get uploadProgress() {
    const context = this._stateMachineActor.getSnapshot().context, { bytesUploaded, uploadFinishedAt, uploadStartedAt } = context, bytesTotal = this._fileNode.file.size;
    return {
      averageSpeed: calcAverageSpeed(bytesUploaded, uploadStartedAt, uploadFinishedAt),
      bytesUploaded,
      bytesTotal,
      hasFinished: uploadFinishedAt !== null,
      hasStarted: uploadStartedAt !== null,
      proportion: bytesTotal === 0 ? 0 : bytesUploaded / bytesTotal,
      uploadFinishedAt,
      uploadStartedAt
    };
  }
  get stateMachineActor() {
    return this._stateMachineActor;
  }
};
__name(_AwsMultipartUploader, "AwsMultipartUploader"), // AWS S3 multipart upload limitations
// see: https://docs.aws.amazon.com/AmazonS3/latest/userguide/qfacts.html
__publicField(_AwsMultipartUploader, "minChunkSize", 5 * MB), __publicField(_AwsMultipartUploader, "maxChunkSize", 5 * GB), __publicField(_AwsMultipartUploader, "maxChunkNumber", 1e4), __publicField(_AwsMultipartUploader, "maxFileSize", 5 * TB);
let AwsMultipartUploader = _AwsMultipartUploader;
const _AwsMultipartUploaderFactory = class _AwsMultipartUploaderFactory {
  constructor(chunkSize, requestService, options) {
    __publicField(this, "_chunkSize");
    __publicField(this, "_requestService");
    __publicField(this, "_options");
    this._chunkSize = chunkSize, this._requestService = requestService, this._options = options;
  }
  create(fileNode) {
    return new AwsMultipartUploader(fileNode, this._chunkSize, this._requestService, this._options);
  }
};
__name(_AwsMultipartUploaderFactory, "AwsMultipartUploaderFactory");
let AwsMultipartUploaderFactory = _AwsMultipartUploaderFactory;
const _SimpleUploadSessionRequestService = class _SimpleUploadSessionRequestService extends RequestService {
  constructor(requests, options) {
    const logger = (options == null ? void 0 : options.logger) ?? new ConsoleLogger("SimpleUploadSessionRequestService");
    super({ ...options, logger });
    __publicField(this, "_requests");
    __publicField(this, "createFile", /* @__PURE__ */ __name(async (variables, signal) => {
      this._logger.debug("createFile", variables);
      const response = await this._requests.createFile(variables, signal);
      return this._logger.debug("succeeded to createFile", variables), response;
    }, "createFile"));
    this._requests = this.createRequests(requests);
  }
  createRequests(requests) {
    return this._rateLimiter === null ? requests : {
      createFile: this._rateLimiter.wrap(requests.createFile)
    };
  }
};
__name(_SimpleUploadSessionRequestService, "SimpleUploadSessionRequestService");
let SimpleUploadSessionRequestService = _SimpleUploadSessionRequestService;
const UPLOAD_SESSION_STAGE = {
  aborted: "aborted",
  initial: "initial",
  dataImportRequest_creating: "dataImportRequest_creating",
  dataImportRequest_creating_success: "dataImportRequest_creating_success",
  dataImportRequest_creating_failure: "dataImportRequest_creating_failure",
  dataImportRequest_finding: "dataImportRequest_finding",
  dataImportRequest_finding_success: "dataImportRequest_finding_success",
  dataImportRequest_finding_failure: "dataImportRequest_finding_failure",
  folderImportRequests_creating: "folderImportRequests_creating",
  folderImportRequests_creating_success: "folderImportRequests_creating_success",
  folderImportRequests_creating_failure: "folderImportRequests_creating_failure",
  fileImportRequests_creating: "fileImportRequests_creating",
  fileImportRequests_creating_success: "fileImportRequests_creating_success",
  fileImportRequests_creating_failure: "fileImportRequests_creating_failure",
  files_uploading: "files_uploading",
  files_uploading_retrying: "files_uploading_retrying",
  files_uploading_success: "files_uploading_success",
  files_uploading_failure: "files_uploading_failure",
  folderNodes_creating: "folderNodes_creating",
  folderNodes_creating_success: "folderNodes_creating_success",
  folderNodes_creating_failure: "folderNodes_creating_failure",
  fileNodes_creating: "fileNodes_creating",
  fileNodes_creating_success: "fileNodes_creating_success",
  fileNodes_creating_failure: "fileNodes_creating_failure",
  thumbnails_creating: "thumbnails_creating",
  thumbnails_creating_success: "thumbnails_creating_success",
  thumbnails_creating_failure: "thumbnails_creating_failure"
}, _Store = class _Store {
  constructor() {
    __publicField(this, "_listeners", /* @__PURE__ */ new Set());
    __publicField(this, "unsubscribe", /* @__PURE__ */ __name((listener) => {
      this._listeners.delete(listener);
    }, "unsubscribe"));
    __publicField(this, "subscribe", /* @__PURE__ */ __name((listener) => (this._listeners.add(listener), () => this.unsubscribe(listener)), "subscribe"));
  }
  notify() {
    this._listeners.forEach((listener) => listener());
  }
  createUseSelector(caller) {
    return /* @__PURE__ */ __name((selector) => {
      const [value, setValue] = useState(() => selector(caller));
      return useEffect(() => {
        const forceUpdate = /* @__PURE__ */ __name(() => setValue(selector(caller)), "forceUpdate");
        return this.subscribe(forceUpdate);
      }, [selector]), value;
    }, "useSelector");
  }
};
__name(_Store, "Store");
let Store = _Store;
const _UploadSessionManager = class _UploadSessionManager {
  constructor(uploaderFactory, uploadSessionRequestService, uploadSessionOptions) {
    __publicField(this, "_uploadSession");
    __publicField(this, "_store", new Store());
    __publicField(this, "_useSelector", this._store.createUseSelector(this));
    __publicField(this, "_selector", /* @__PURE__ */ __name(() => this._uploadSession, "_selector"));
    this._uploadSession = this.createUploadSession(
      uploaderFactory,
      uploadSessionRequestService,
      uploadSessionOptions
    );
  }
  get uploadSession() {
    return this._uploadSession;
  }
  createUploadSession(uploaderFactory, uploadSessionRequestService, options) {
    return this._uploadSession = new UploadSession(uploaderFactory, uploadSessionRequestService, options), this._store.notify(), this._uploadSession;
  }
  useUploadSession(uploaderFactory) {
    useLifeCycleLogger("UploadSessionManager.useUploadSession");
    const uploadSession = this._useSelector(this._selector);
    return useEffect(() => {
      uploadSession.setUploaderFactory(uploaderFactory);
    }, [uploadSession, uploaderFactory]), uploadSession;
  }
};
__name(_UploadSessionManager, "UploadSessionManager");
let UploadSessionManager = _UploadSessionManager;
const _UploadSessionRequestService = class _UploadSessionRequestService extends RequestService {
  constructor(requests, options) {
    const logger = (options == null ? void 0 : options.logger) ?? new ConsoleLogger("UploadSessionRequestService");
    super({ ...options, logger });
    __publicField(this, "_requests");
    __publicField(this, "createDataImportRequestV2", /* @__PURE__ */ __name(async (variables) => {
      this._logger.debug("createDataImportRequestV2", variables);
      const response = await this._requests.createDataImportRequestV2(variables);
      return this._logger.debug("succeeded to createDataImportRequestV2", variables, response), response;
    }, "createDataImportRequestV2"));
    __publicField(this, "findDataImportRequest", /* @__PURE__ */ __name(async (variables) => {
      this._logger.debug("findDataImportRequest", variables);
      const response = await this._requests.findDataImportRequest(variables);
      return this._logger.debug("succeeded to findDataImportRequest with", variables, response), response;
    }, "findDataImportRequest"));
    __publicField(this, "createFolderImportRequests", /* @__PURE__ */ __name(async (variables) => {
      this._logger.debug("createFolderImportRequests");
      const response = await this._requests.createFolderImportRequests(variables);
      return this._logger.debug("succeeded to createFolderImportRequests", variables, response), response;
    }, "createFolderImportRequests"));
    __publicField(this, "createFileImportRequests", /* @__PURE__ */ __name(async (variables) => {
      this._logger.debug("createFileImportRequests", variables);
      const response = await this._requests.createFileImportRequests(variables);
      return this._logger.debug("succeeded to createFileImportRequests", variables, response), response;
    }, "createFileImportRequests"));
    __publicField(this, "createFolderNodes", /* @__PURE__ */ __name(async (variables) => {
      this._logger.debug("createFolderNodes", variables);
      const response = await this._requests.createFolderNodes(variables);
      return this._logger.debug("succeeded to createFolderNodes", variables, response), response;
    }, "createFolderNodes"));
    __publicField(this, "createFileNodes", /* @__PURE__ */ __name(async (variables) => {
      this._logger.debug("createFileNodes", variables);
      const response = await this._requests.createFileNodes(variables);
      return this._logger.debug("succeeded to createFileNodes", variables, response), response;
    }, "createFileNodes"));
    this._requests = this.createRequests(requests);
  }
  createRequests(requests) {
    return this._rateLimiter === null ? requests : {
      createDataImportRequestV2: this._rateLimiter.wrap(requests.createDataImportRequestV2),
      findDataImportRequest: this._rateLimiter.wrap(requests.findDataImportRequest),
      createFolderImportRequests: this._rateLimiter.wrap(requests.createFolderImportRequests),
      createFileImportRequests: this._rateLimiter.wrap(requests.createFileImportRequests),
      createFolderNodes: this._rateLimiter.wrap(requests.createFolderNodes),
      createFileNodes: this._rateLimiter.wrap(requests.createFileNodes),
      updateDataImportRequestStatus: this._rateLimiter.wrap(requests.updateDataImportRequestStatus),
      updateFolderImportRequestStatus: this._rateLimiter.wrap(
        requests.updateFolderImportRequestStatus
      ),
      createThumbnails: this._rateLimiter.wrap(requests.createThumbnails),
      countFileImportRequests: this._rateLimiter.wrap(requests.countFileImportRequests),
      findFileIds: this._rateLimiter.wrap(requests.findFileIds)
    };
  }
  async updateDataImportRequestStatus(variables) {
    this._logger.debug("updateDataImportRequestStatus", variables), await this._requests.updateDataImportRequestStatus(variables), this._logger.debug("succeeded to updateDataImportRequestStatus", variables);
  }
  async updateFolderImportRequestStatus(variables) {
    this._logger.debug("updateFolderImportRequestStatus", variables), await this._requests.updateFolderImportRequestStatus({ input: variables }), this._logger.debug("succeeded to updateFolderImportRequestStatus", variables);
  }
  async createThumbnails(variables) {
    this._logger.debug("createThumbnails", variables), await this._requests.createThumbnails(variables), this._logger.debug("succeeded to createThumbnails", variables);
  }
  async countFileImportRequests(variables) {
    this._logger.debug("countFileImportRequests", variables);
    const response = await this._requests.countFileImportRequests(variables);
    return this._logger.debug("succeeded to countFileImportRequests", variables, response), response;
  }
  async findFileIds(variables) {
    this._logger.debug("findFileImportRequests", variables);
    const response = await this._requests.findFileIds(variables);
    return this._logger.debug("succeeded to findFileImportRequests", variables, response), response;
  }
};
__name(_UploadSessionRequestService, "UploadSessionRequestService");
let UploadSessionRequestService = _UploadSessionRequestService;
export {
  AbortionError,
  AwsMultipartRequestService,
  AwsMultipartUploader,
  AwsMultipartUploaderFactory,
  BadStateError,
  Chunk,
  ConsoleLogger,
  ConsoleLoggerFactory,
  FileNode,
  FileTree,
  FolderNode,
  Job,
  LimitationError,
  QueryClientProvider,
  RateLimiter,
  RequestContext,
  RequestContextProvider,
  ServerError,
  SimpleUploadSessionRequestService,
  UNIT,
  UNITS,
  UPLOAD_SESSION_STAGE,
  UploadSession,
  UploadSessionManager,
  UploadSessionRequestService,
  isAbortOrCancelError,
  isRetryableError,
  traverseGraph,
  traverseGraphAsync,
  useCreateNewSimpleUploadSession,
  useCreateNewUploadSession,
  useLifeCycleLogger,
  useSimpleUploadSession,
  useSimpleUploader,
  useUploadSession,
  useUploader as useUploadSessionUploader,
  useUploader$1 as useUploader
};
//# sourceMappingURL=index.js.map
